function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire85ca"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire85ca"] = parcelRequire;
}
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});


parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});

parcelRequire.register("6EoaL", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("iC1WG")).then(()=>parcelRequire("3Q10N"));

});

parcelRequire.register("c86jh", function(module, exports) {
"use strict";
var $8d4b206bfc03b6cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8d4b206bfc03b6cb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8d4b206bfc03b6cb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8d4b206bfc03b6cb$var$__createBinding(result, mod, k);
    }
    $8d4b206bfc03b6cb$var$__setModuleDefault(result, mod);
    return result;
};
var $8d4b206bfc03b6cb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8d4b206bfc03b6cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPriorityConnector = module.exports.getSelectedConnector = module.exports.initializeConnector = void 0;

var $8H9a7 = parcelRequire("8H9a7");

var $acw62 = parcelRequire("acw62");

const $8d4b206bfc03b6cb$var$zustand_1 = $8d4b206bfc03b6cb$var$__importDefault((parcelRequire("f4OIt")));
let $8d4b206bfc03b6cb$var$DynamicProvider;

function $8d4b206bfc03b6cb$var$importProvider() {
    return $8d4b206bfc03b6cb$var$__awaiter(this, void 0, void 0, function*() {
        if ($8d4b206bfc03b6cb$var$DynamicProvider === undefined) try {
            const { Web3Provider: Web3Provider } = yield Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("bsYBY")));
            }).then((res)=>$8d4b206bfc03b6cb$var$__importStar(res));
            $8d4b206bfc03b6cb$var$DynamicProvider = Web3Provider;
        } catch (_a) {
            console.debug("@ethersproject/providers not available");
            $8d4b206bfc03b6cb$var$DynamicProvider = null;
        }
    });
}
/**
 * Wraps the initialization of a `connector`. Creates a zustand `store` with `actions` bound to it, and then passes
 * these to the connector as specified in `f`. Also creates a variety of `hooks` bound to this `store`.
 *
 * @typeParam T - The type of the `connector` returned from `f`.
 * @param f - A function which is called with `actions` bound to the returned `store`.
 * @param allowedChainIds - An optional array of chainIds which the `connector` may connect to. If the `connector` is
 * connected to a chainId which is not allowed, a ChainIdNotAllowedError error will be reported.
 * If this argument is unspecified, the `connector` may connect to any chainId.
 * @returns [connector, hooks, store] - The initialized connector, a variety of hooks, and a zustand store.
 */ function $8d4b206bfc03b6cb$var$initializeConnector(f, allowedChainIds) {
    const [store, actions] = (0, $8H9a7.createWeb3ReactStoreAndActions)(allowedChainIds);
    const connector = f(actions);
    const useConnector = (0, $8d4b206bfc03b6cb$var$zustand_1.default)(store);
    const stateHooks = $8d4b206bfc03b6cb$var$getStateHooks(useConnector);
    const derivedHooks = $8d4b206bfc03b6cb$var$getDerivedHooks(stateHooks);
    const augmentedHooks = $8d4b206bfc03b6cb$var$getAugmentedHooks(connector, stateHooks, derivedHooks);
    return [
        connector,
        Object.assign(Object.assign(Object.assign({}, stateHooks), derivedHooks), augmentedHooks),
        store
    ];
}
module.exports.initializeConnector = $8d4b206bfc03b6cb$var$initializeConnector;
function $8d4b206bfc03b6cb$var$computeIsActive({ chainId: chainId, accounts: accounts, activating: activating, error: error }) {
    return Boolean(chainId && accounts && !activating && !error);
}
/**
 * Creates a variety of convenience `hooks` that return data associated with a particular passed connector.
 *
 * @param initializedConnectors - Two or more [connector, hooks(, store)] arrays, as returned from initializeConnector.
 * @returns hooks - A variety of convenience hooks that wrap the hooks returned from initializeConnector.
 */ function $8d4b206bfc03b6cb$var$getSelectedConnector(...initializedConnectors) {
    function getIndex(connector) {
        const index = initializedConnectors.findIndex(([initializedConnector])=>connector === initializedConnector);
        if (index === -1) throw new Error("Connector not found");
        return index;
    }
    function useSelectedStore(connector) {
        const store = initializedConnectors[getIndex(connector)][2];
        if (!store) throw new Error("Stores not passed");
        return store;
    }
    // the following code calls hooks in a map a lot, which violates the eslint rule.
    // this is ok, though, because initializedConnectors never changes, so the same hooks are called each time
    function useSelectedChainId(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useChainId: useChainId }])=>useChainId());
        return values[getIndex(connector)];
    }
    function useSelectedAccounts(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useAccounts: useAccounts }])=>useAccounts());
        return values[getIndex(connector)];
    }
    function useSelectedIsActivating(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useIsActivating: useIsActivating }])=>useIsActivating());
        return values[getIndex(connector)];
    }
    function useSelectedError(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useError: useError }])=>useError());
        return values[getIndex(connector)];
    }
    function useSelectedAccount(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useAccount: useAccount }])=>useAccount());
        return values[getIndex(connector)];
    }
    function useSelectedIsActive(connector) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useIsActive: useIsActive }])=>useIsActive());
        return values[getIndex(connector)];
    }
    /**
     * @typeParam T - A type argument must only be provided if one or more of the connectors passed to
     * getSelectedConnector is using `connector.customProvider`, in which case it must match every possible type of this
     * property, over all connectors.
     */ function useSelectedProvider(connector, network) {
        const index = getIndex(connector);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useProvider: useProvider }], i)=>useProvider(network, i === index));
        return values[index];
    }
    function useSelectedENSNames(connector, provider) {
        const index = getIndex(connector);
        const values = initializedConnectors.map(([, { useENSNames: useENSNames }], i)=>// eslint-disable-next-line react-hooks/rules-of-hooks
            useENSNames(i === index ? provider : undefined));
        return values[index];
    }
    function useSelectedENSName(connector, provider) {
        const index = getIndex(connector);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useENSName: useENSName }], i)=>useENSName(i === index ? provider : undefined));
        return values[index];
    }
    return {
        useSelectedStore: useSelectedStore,
        useSelectedChainId: useSelectedChainId,
        useSelectedAccounts: useSelectedAccounts,
        useSelectedIsActivating: useSelectedIsActivating,
        useSelectedError: useSelectedError,
        useSelectedAccount: useSelectedAccount,
        useSelectedIsActive: useSelectedIsActive,
        useSelectedProvider: useSelectedProvider,
        useSelectedENSNames: useSelectedENSNames,
        useSelectedENSName: useSelectedENSName
    };
}
module.exports.getSelectedConnector = $8d4b206bfc03b6cb$var$getSelectedConnector;
/**
 * Creates a variety of convenience `hooks` that return data associated with the first of the `initializedConnectors`
 * that is active.
 *
 * @param initializedConnectors - Two or more [connector, hooks(, store)] arrays, as returned from initializeConnector.
 * @returns hooks - A variety of convenience hooks that wrap the hooks returned from initializeConnector.
 */ function $8d4b206bfc03b6cb$var$getPriorityConnector(...initializedConnectors) {
    const { useSelectedStore: useSelectedStore, useSelectedChainId: useSelectedChainId, useSelectedAccounts: useSelectedAccounts, useSelectedIsActivating: useSelectedIsActivating, useSelectedError: useSelectedError, useSelectedAccount: useSelectedAccount, useSelectedIsActive: useSelectedIsActive, useSelectedProvider: useSelectedProvider, useSelectedENSNames: useSelectedENSNames, useSelectedENSName: useSelectedENSName } = $8d4b206bfc03b6cb$var$getSelectedConnector(...initializedConnectors);
    function usePriorityConnector() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const values = initializedConnectors.map(([, { useIsActive: useIsActive }])=>useIsActive());
        const index = values.findIndex((isActive)=>isActive);
        return initializedConnectors[index === -1 ? 0 : index][0];
    }
    function usePriorityStore() {
        return useSelectedStore(usePriorityConnector());
    }
    function usePriorityChainId() {
        return useSelectedChainId(usePriorityConnector());
    }
    function usePriorityAccounts() {
        return useSelectedAccounts(usePriorityConnector());
    }
    function usePriorityIsActivating() {
        return useSelectedIsActivating(usePriorityConnector());
    }
    function usePriorityError() {
        return useSelectedError(usePriorityConnector());
    }
    function usePriorityAccount() {
        return useSelectedAccount(usePriorityConnector());
    }
    function usePriorityIsActive() {
        return useSelectedIsActive(usePriorityConnector());
    }
    /**
     * @typeParam T - A type argument must only be provided if one or more of the connectors passed to
     * getPriorityConnector is using `connector.customProvider`, in which case it must match every possible type of this
     * property, over all connectors.
     */ function usePriorityProvider(network) {
        return useSelectedProvider(usePriorityConnector(), network);
    }
    function usePriorityENSNames(provider) {
        return useSelectedENSNames(usePriorityConnector(), provider);
    }
    function usePriorityENSName(provider) {
        return useSelectedENSName(usePriorityConnector(), provider);
    }
    return {
        useSelectedStore: useSelectedStore,
        useSelectedChainId: useSelectedChainId,
        useSelectedAccounts: useSelectedAccounts,
        useSelectedIsActivating: useSelectedIsActivating,
        useSelectedError: useSelectedError,
        useSelectedAccount: useSelectedAccount,
        useSelectedIsActive: useSelectedIsActive,
        useSelectedProvider: useSelectedProvider,
        useSelectedENSNames: useSelectedENSNames,
        useSelectedENSName: useSelectedENSName,
        usePriorityConnector: usePriorityConnector,
        usePriorityStore: usePriorityStore,
        usePriorityChainId: usePriorityChainId,
        usePriorityAccounts: usePriorityAccounts,
        usePriorityIsActivating: usePriorityIsActivating,
        usePriorityError: usePriorityError,
        usePriorityAccount: usePriorityAccount,
        usePriorityIsActive: usePriorityIsActive,
        usePriorityProvider: usePriorityProvider,
        usePriorityENSNames: usePriorityENSNames,
        usePriorityENSName: usePriorityENSName
    };
}
module.exports.getPriorityConnector = $8d4b206bfc03b6cb$var$getPriorityConnector;
const $8d4b206bfc03b6cb$var$CHAIN_ID = ({ chainId: chainId })=>chainId;
const $8d4b206bfc03b6cb$var$ACCOUNTS = ({ accounts: accounts })=>accounts;
const $8d4b206bfc03b6cb$var$ACCOUNTS_EQUALITY_CHECKER = (oldAccounts, newAccounts)=>oldAccounts === undefined && newAccounts === undefined || oldAccounts !== undefined && oldAccounts.length === (newAccounts === null || newAccounts === void 0 ? void 0 : newAccounts.length) && oldAccounts.every((oldAccount, i)=>oldAccount === newAccounts[i]);
const $8d4b206bfc03b6cb$var$ACTIVATING = ({ activating: activating })=>activating;
const $8d4b206bfc03b6cb$var$ERROR = ({ error: error })=>error;
function $8d4b206bfc03b6cb$var$getStateHooks(useConnector) {
    function useChainId() {
        return useConnector($8d4b206bfc03b6cb$var$CHAIN_ID);
    }
    function useAccounts() {
        return useConnector($8d4b206bfc03b6cb$var$ACCOUNTS, $8d4b206bfc03b6cb$var$ACCOUNTS_EQUALITY_CHECKER);
    }
    function useIsActivating() {
        return useConnector($8d4b206bfc03b6cb$var$ACTIVATING);
    }
    function useError() {
        return useConnector($8d4b206bfc03b6cb$var$ERROR);
    }
    return {
        useChainId: useChainId,
        useAccounts: useAccounts,
        useIsActivating: useIsActivating,
        useError: useError
    };
}
function $8d4b206bfc03b6cb$var$getDerivedHooks({ useChainId: useChainId, useAccounts: useAccounts, useIsActivating: useIsActivating, useError: useError }) {
    function useAccount() {
        var _a;
        return (_a = useAccounts()) === null || _a === void 0 ? void 0 : _a[0];
    }
    function useIsActive() {
        const chainId = useChainId();
        const accounts = useAccounts();
        const activating = useIsActivating();
        const error = useError();
        return $8d4b206bfc03b6cb$var$computeIsActive({
            chainId: chainId,
            accounts: accounts,
            activating: activating,
            error: error
        });
    }
    return {
        useAccount: useAccount,
        useIsActive: useIsActive
    };
}
/**
 * @returns ENSNames - An array of length `accounts.length` which contains entries which are either all `undefined`,
 * indicated that names cannot be fetched because there's no provider, or they're in the process of being fetched,
 * or `string | null`, depending on whether an ENS name has been set for the account in question or not.
 */ function $8d4b206bfc03b6cb$var$useENS(provider, accounts = []) {
    const [ENSNames, setENSNames] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (provider && accounts.length) {
            let stale = false;
            Promise.all(accounts.map((account)=>provider.lookupAddress(account))).then((ENSNames)=>{
                if (stale) return;
                setENSNames(ENSNames);
            }).catch((error)=>{
                if (stale) return;
                console.debug("Could not fetch ENS names", error);
                setENSNames(new Array(accounts.length).fill(null));
            });
            return ()=>{
                stale = true;
                setENSNames(undefined);
            };
        }
    }, [
        provider,
        accounts
    ]);
    return ENSNames !== null && ENSNames !== void 0 ? ENSNames : new Array(accounts.length).fill(undefined);
}
function $8d4b206bfc03b6cb$var$getAugmentedHooks(connector, { useAccounts: useAccounts, useChainId: useChainId }, { useAccount: useAccount, useIsActive: useIsActive }) {
    /**
     * Avoid type erasure by returning the most qualified type if not otherwise set.
     * Note that this function's return type is `T | undefined`, but there is a code path
     * that returns a Web3Provider, which could conflict with a user-provided T. So,
     * it's important that users only provide an override for T if they know that
     * `connector.customProvider` is going to be defined and of type T.
     *
     * @typeParam T - A type argument must only be provided if using `connector.customProvider`, in which case it
     * must match the type of this property.
     */ function useProvider(network, enabled = true) {
        const isActive = useIsActive();
        const chainId = useChainId();
        // ensure that Provider is going to be available when loaded if @ethersproject/providers is installed
        const [loaded, setLoaded] = (0, $acw62.useState)($8d4b206bfc03b6cb$var$DynamicProvider !== undefined);
        (0, $acw62.useEffect)(()=>{
            if (loaded) return;
            let stale = false;
            $8d4b206bfc03b6cb$var$importProvider().then(()=>{
                if (stale) return;
                setLoaded(true);
            });
            return ()=>{
                stale = true;
            };
        }, [
            loaded
        ]);
        return (0, $acw62.useMemo)(()=>{
            if (enabled) {
                if (connector.customProvider) return connector.customProvider;
                else if ($8d4b206bfc03b6cb$var$DynamicProvider && connector.provider) return new $8d4b206bfc03b6cb$var$DynamicProvider(connector.provider, network);
            }
        }, [
            loaded,
            enabled,
            isActive,
            chainId,
            network
        ]);
    }
    function useENSNames(provider) {
        const accounts = useAccounts();
        return $8d4b206bfc03b6cb$var$useENS(provider, accounts);
    }
    function useENSName(provider) {
        var _a;
        const account = useAccount();
        const accounts = (0, $acw62.useMemo)(()=>account === undefined ? undefined : [
                account
            ], [
            account
        ]);
        return (_a = $8d4b206bfc03b6cb$var$useENS(provider, accounts)) === null || _a === void 0 ? void 0 : _a[0];
    }
    return {
        useProvider: useProvider,
        useENSNames: useENSNames,
        useENSName: useENSName
    };
}

});
parcelRequire.register("8H9a7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createWeb3ReactStoreAndActions = module.exports.ChainIdNotAllowedError = module.exports.MAX_SAFE_CHAIN_ID = void 0;

var $ara3F = parcelRequire("ara3F");

var $f4OIt = parcelRequire("f4OIt");
/**
 * MAX_SAFE_CHAIN_ID is the upper bound limit on what will be accepted for `chainId`
 * `MAX_SAFE_CHAIN_ID = floor( ( 2**53 - 39 ) / 2 ) = 4503599627370476`
 *
 * @see {@link https://github.com/MetaMask/metamask-extension/blob/b6673731e2367e119a5fee9a454dd40bd4968948/shared/constants/network.js#L31}
 */ module.exports.MAX_SAFE_CHAIN_ID = 4503599627370476;
function $65497248dde6993f$var$validateChainId(chainId) {
    if (!Number.isInteger(chainId) || chainId <= 0 || chainId > module.exports.MAX_SAFE_CHAIN_ID) throw new Error(`Invalid chainId ${chainId}`);
}
class $65497248dde6993f$var$ChainIdNotAllowedError extends Error {
    constructor(chainId, allowedChainIds){
        super(`chainId ${chainId} not included in ${allowedChainIds.toString()}`);
        this.chainId = chainId;
        this.name = $65497248dde6993f$var$ChainIdNotAllowedError.name;
        Object.setPrototypeOf(this, $65497248dde6993f$var$ChainIdNotAllowedError.prototype);
    }
}
module.exports.ChainIdNotAllowedError = $65497248dde6993f$var$ChainIdNotAllowedError;
function $65497248dde6993f$var$ensureChainIdIsAllowed(chainId, allowedChainIds) {
    return allowedChainIds.some((allowedChainId)=>chainId === allowedChainId) ? undefined : new $65497248dde6993f$var$ChainIdNotAllowedError(chainId, allowedChainIds);
}
function $65497248dde6993f$var$validateAccount(account) {
    return (0, $ara3F.getAddress)(account);
}
const $65497248dde6993f$var$DEFAULT_STATE = {
    chainId: undefined,
    accounts: undefined,
    activating: false,
    error: undefined
};
function $65497248dde6993f$var$createWeb3ReactStoreAndActions(allowedChainIds) {
    if ((allowedChainIds === null || allowedChainIds === void 0 ? void 0 : allowedChainIds.length) === 0) throw new Error(`allowedChainIds is length 0`);
    const store = (0, $f4OIt.createStore)()(()=>$65497248dde6993f$var$DEFAULT_STATE);
    // flag for tracking updates so we don't clobber data when cancelling activation
    let nullifier = 0;
    /**
     * Sets activating to true, indicating that an update is in progress.
     *
     * @returns cancelActivation - A function that cancels the activation by setting activating to false,
     * as long as there haven't been any intervening updates.
     */ function startActivation() {
        const nullifierCached = ++nullifier;
        store.setState(Object.assign(Object.assign({}, $65497248dde6993f$var$DEFAULT_STATE), {
            activating: true
        }));
        // return a function that cancels the activation iff nothing else has happened
        return ()=>{
            if (nullifier === nullifierCached) store.setState({
                activating: false
            });
        };
    }
    /**
     * Used to report a `stateUpdate` which is merged with existing state. The first `stateUpdate` that results in chainId
     * and accounts being set will also set activating to false, indicating a successful connection. Similarly, if an
     * error is set, the first `stateUpdate` that results in chainId and accounts being set will clear this error.
     *
     * @param stateUpdate - The state update to report.
     */ function update(stateUpdate) {
        // validate chainId statically, independent of existing state
        if (stateUpdate.chainId !== undefined) $65497248dde6993f$var$validateChainId(stateUpdate.chainId);
        // validate accounts statically, independent of existing state
        if (stateUpdate.accounts !== undefined) for(let i = 0; i < stateUpdate.accounts.length; i++)stateUpdate.accounts[i] = $65497248dde6993f$var$validateAccount(stateUpdate.accounts[i]);
        nullifier++;
        store.setState((existingState)=>{
            var _a, _b;
            // determine the next chainId and accounts
            const chainId = (_a = stateUpdate.chainId) !== null && _a !== void 0 ? _a : existingState.chainId;
            const accounts = (_b = stateUpdate.accounts) !== null && _b !== void 0 ? _b : existingState.accounts;
            // determine the next error
            let error = existingState.error;
            if (chainId && allowedChainIds) {
                // if we have a chainId allowlist and a chainId, we need to ensure it's allowed
                const chainIdError = $65497248dde6993f$var$ensureChainIdIsAllowed(chainId, allowedChainIds);
                // warn if we're going to clobber existing error
                if (chainIdError && error) {
                    if (!(error instanceof $65497248dde6993f$var$ChainIdNotAllowedError) || error.chainId !== chainIdError.chainId) console.debug(`${error.name} is being clobbered by ${chainIdError.name}`);
                }
                error = chainIdError;
            }
            // ensure that the error is cleared when appropriate
            if (error && !(error instanceof $65497248dde6993f$var$ChainIdNotAllowedError) && chainId && accounts) error = undefined;
            // ensure that the activating flag is cleared when appropriate
            let activating = existingState.activating;
            if (activating && (error || chainId && accounts)) activating = false;
            return {
                chainId: chainId,
                accounts: accounts,
                activating: activating,
                error: error
            };
        });
    }
    /**
     * Used to report an `error`, which clears all existing state.
     *
     * @param error - The error to report. If undefined, the state will be reset to its default value.
     */ function reportError(error) {
        nullifier++;
        store.setState(()=>Object.assign(Object.assign({}, $65497248dde6993f$var$DEFAULT_STATE), {
                error: error
            }));
    }
    return [
        store,
        {
            startActivation: startActivation,
            update: update,
            reportError: reportError
        }
    ];
}
module.exports.createWeb3ReactStoreAndActions = $65497248dde6993f$var$createWeb3ReactStoreAndActions;

});
parcelRequire.register("ara3F", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $79943a5540e7c4b2$export$88411125f012957a);

var $bKKIK = parcelRequire("bKKIK");

var $4HuzN = parcelRequire("4HuzN");

var $ep0Ku = parcelRequire("ep0Ku");

var $4IkKc = parcelRequire("4IkKc");

var $gk7bp = parcelRequire("gk7bp");

var $eDe5s = parcelRequire("eDe5s");
"use strict";
const $79943a5540e7c4b2$var$logger = new (0, $gk7bp.Logger)((0, $eDe5s.version));
function $79943a5540e7c4b2$var$getChecksumAddress(address) {
    if (!(0, $bKKIK.isHexString)(address, 20)) $79943a5540e7c4b2$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $bKKIK.arrayify)((0, $ep0Ku.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $79943a5540e7c4b2$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $79943a5540e7c4b2$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $79943a5540e7c4b2$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$79943a5540e7c4b2$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$79943a5540e7c4b2$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $79943a5540e7c4b2$var$safeDigits = Math.floor($79943a5540e7c4b2$var$log10($79943a5540e7c4b2$var$MAX_SAFE_INTEGER));
function $79943a5540e7c4b2$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $79943a5540e7c4b2$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $79943a5540e7c4b2$var$safeDigits){
        let block = expanded.substring(0, $79943a5540e7c4b2$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $79943a5540e7c4b2$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $79943a5540e7c4b2$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $79943a5540e7c4b2$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $79943a5540e7c4b2$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $79943a5540e7c4b2$var$ibanChecksum(address)) $79943a5540e7c4b2$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $4HuzN._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $79943a5540e7c4b2$var$getChecksumAddress("0x" + result);
    } else $79943a5540e7c4b2$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $79943a5540e7c4b2$export$977e255126d763d6(address) {
    try {
        $79943a5540e7c4b2$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $79943a5540e7c4b2$export$962c4ddada9f668f(address) {
    let base36 = (0, $4HuzN._base16To36)($79943a5540e7c4b2$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $79943a5540e7c4b2$var$ibanChecksum("XE00" + base36) + base36;
}
function $79943a5540e7c4b2$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $79943a5540e7c4b2$export$88411125f012957a(transaction.from);
    } catch (error) {
        $79943a5540e7c4b2$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $bKKIK.stripZeros)((0, $bKKIK.arrayify)((0, $4HuzN.BigNumber).from(transaction.nonce).toHexString()));
    return $79943a5540e7c4b2$export$88411125f012957a((0, $bKKIK.hexDataSlice)((0, $ep0Ku.keccak256)((0, $4IkKc.encode)([
        from,
        nonce
    ])), 12));
}
function $79943a5540e7c4b2$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $bKKIK.hexDataLength)(salt) !== 32) $79943a5540e7c4b2$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $bKKIK.hexDataLength)(initCodeHash) !== 32) $79943a5540e7c4b2$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $79943a5540e7c4b2$export$88411125f012957a((0, $bKKIK.hexDataSlice)((0, $ep0Ku.keccak256)((0, $bKKIK.concat)([
        "0xff",
        $79943a5540e7c4b2$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRequire.register("bKKIK", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $88e83b55df95e8ab$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $88e83b55df95e8ab$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $88e83b55df95e8ab$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $88e83b55df95e8ab$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $88e83b55df95e8ab$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $88e83b55df95e8ab$export$a8f4574d0e56446c);
$parcel$export(module.exports, "hexlify", () => $88e83b55df95e8ab$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $88e83b55df95e8ab$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $88e83b55df95e8ab$export$15da666eba198c18);

var $gk7bp = parcelRequire("gk7bp");

var $9cQEi = parcelRequire("9cQEi");
"use strict";
const $88e83b55df95e8ab$var$logger = new (0, $gk7bp.Logger)((0, $9cQEi.version));
///////////////////////////////
function $88e83b55df95e8ab$var$isHexable(value) {
    return !!value.toHexString;
}
function $88e83b55df95e8ab$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $88e83b55df95e8ab$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $88e83b55df95e8ab$export$9a14abb1a440cd5e(value) {
    return $88e83b55df95e8ab$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $88e83b55df95e8ab$export$c6fabfbfd097fc30(value);
}
function $88e83b55df95e8ab$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $88e83b55df95e8ab$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$88e83b55df95e8ab$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$88e83b55df95e8ab$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $88e83b55df95e8ab$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $88e83b55df95e8ab$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $88e83b55df95e8ab$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($88e83b55df95e8ab$var$isHexable(value)) value = value.toHexString();
    if ($88e83b55df95e8ab$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $88e83b55df95e8ab$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $88e83b55df95e8ab$var$addSlice(new Uint8Array(result));
    }
    if ($88e83b55df95e8ab$export$c6fabfbfd097fc30(value)) return $88e83b55df95e8ab$var$addSlice(new Uint8Array(value));
    return $88e83b55df95e8ab$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $88e83b55df95e8ab$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$88e83b55df95e8ab$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $88e83b55df95e8ab$var$addSlice(result);
}
function $88e83b55df95e8ab$export$a8f4574d0e56446c(value) {
    let result = $88e83b55df95e8ab$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $88e83b55df95e8ab$export$3cdc770bf8b2ed3d(value, length) {
    value = $88e83b55df95e8ab$export$3131421a7d01b4fb(value);
    if (value.length > length) $88e83b55df95e8ab$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $88e83b55df95e8ab$var$addSlice(result);
}
function $88e83b55df95e8ab$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $88e83b55df95e8ab$var$HexCharacters = "0123456789abcdef";
function $88e83b55df95e8ab$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $88e83b55df95e8ab$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $88e83b55df95e8ab$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($88e83b55df95e8ab$var$isHexable(value)) return value.toHexString();
    if ($88e83b55df95e8ab$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $88e83b55df95e8ab$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($88e83b55df95e8ab$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $88e83b55df95e8ab$var$HexCharacters[(v & 0xf0) >> 4] + $88e83b55df95e8ab$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $88e83b55df95e8ab$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $88e83b55df95e8ab$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(data);
    else if (!$88e83b55df95e8ab$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $88e83b55df95e8ab$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(data);
    else if (!$88e83b55df95e8ab$export$b02a40aff8e4ad18(data) || data.length % 2) $88e83b55df95e8ab$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $88e83b55df95e8ab$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $88e83b55df95e8ab$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $88e83b55df95e8ab$export$6916af760a341dd3(value) {
    const trimmed = $88e83b55df95e8ab$export$967bc0082a978949($88e83b55df95e8ab$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $88e83b55df95e8ab$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(value);
    if (!$88e83b55df95e8ab$export$b02a40aff8e4ad18(value)) $88e83b55df95e8ab$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $88e83b55df95e8ab$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(value);
    else if (!$88e83b55df95e8ab$export$b02a40aff8e4ad18(value)) $88e83b55df95e8ab$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $88e83b55df95e8ab$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $88e83b55df95e8ab$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($88e83b55df95e8ab$export$9a14abb1a440cd5e(signature)) {
        let bytes = $88e83b55df95e8ab$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $88e83b55df95e8ab$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $88e83b55df95e8ab$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $88e83b55df95e8ab$export$3cdc770bf8b2ed3d($88e83b55df95e8ab$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $88e83b55df95e8ab$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $88e83b55df95e8ab$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $88e83b55df95e8ab$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $88e83b55df95e8ab$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$88e83b55df95e8ab$export$b02a40aff8e4ad18(result.r)) $88e83b55df95e8ab$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $88e83b55df95e8ab$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$88e83b55df95e8ab$export$b02a40aff8e4ad18(result.s)) $88e83b55df95e8ab$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $88e83b55df95e8ab$export$e9c46a54370b47e8(result.s, 32);
        const vs = $88e83b55df95e8ab$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $88e83b55df95e8ab$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $88e83b55df95e8ab$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$88e83b55df95e8ab$export$b02a40aff8e4ad18(result._vs)) $88e83b55df95e8ab$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $88e83b55df95e8ab$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $88e83b55df95e8ab$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $88e83b55df95e8ab$export$71bb9d78a59bbe25(signature) {
    signature = $88e83b55df95e8ab$export$7fb170f1e457988f(signature);
    return $88e83b55df95e8ab$export$2b0d6b5fbe698c70($88e83b55df95e8ab$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRequire.register("gk7bp", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $be2415fc9aba2ff6$export$efa9a398d6368992);

var $kmaHV = parcelRequire("kmaHV");
"use strict";
let $be2415fc9aba2ff6$var$_permanentCensorErrors = false;
let $be2415fc9aba2ff6$var$_censorErrors = false;
const $be2415fc9aba2ff6$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $be2415fc9aba2ff6$var$_logLevel = $be2415fc9aba2ff6$var$LogLevels["default"];
let $be2415fc9aba2ff6$var$_globalLogger = null;
function $be2415fc9aba2ff6$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $be2415fc9aba2ff6$var$_normalizeError = $be2415fc9aba2ff6$var$_checkNormalize();
var $be2415fc9aba2ff6$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($be2415fc9aba2ff6$export$243e62d78d3b544d || ($be2415fc9aba2ff6$export$243e62d78d3b544d = {}));
var $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($be2415fc9aba2ff6$export$d4e71bc0b80dc0fb || ($be2415fc9aba2ff6$export$d4e71bc0b80dc0fb = {}));
const $be2415fc9aba2ff6$var$HEX = "0123456789abcdef";
class $be2415fc9aba2ff6$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($be2415fc9aba2ff6$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($be2415fc9aba2ff6$var$_logLevel > $be2415fc9aba2ff6$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($be2415fc9aba2ff6$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($be2415fc9aba2ff6$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($be2415fc9aba2ff6$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($be2415fc9aba2ff6$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $be2415fc9aba2ff6$var$HEX[value[i] >> 4];
                        hex += $be2415fc9aba2ff6$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $be2415fc9aba2ff6$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($be2415fc9aba2ff6$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $be2415fc9aba2ff6$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $be2415fc9aba2ff6$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $be2415fc9aba2ff6$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $be2415fc9aba2ff6$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$be2415fc9aba2ff6$var$_globalLogger) $be2415fc9aba2ff6$var$_globalLogger = new $be2415fc9aba2ff6$export$efa9a398d6368992((0, $kmaHV.version));
        return $be2415fc9aba2ff6$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($be2415fc9aba2ff6$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $be2415fc9aba2ff6$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $be2415fc9aba2ff6$var$_censorErrors = !!censorship;
        $be2415fc9aba2ff6$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $be2415fc9aba2ff6$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $be2415fc9aba2ff6$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $be2415fc9aba2ff6$var$_logLevel = level;
    }
    static from(version) {
        return new $be2415fc9aba2ff6$export$efa9a398d6368992(version);
    }
}
$be2415fc9aba2ff6$export$efa9a398d6368992.errors = $be2415fc9aba2ff6$export$d4e71bc0b80dc0fb;
$be2415fc9aba2ff6$export$efa9a398d6368992.levels = $be2415fc9aba2ff6$export$243e62d78d3b544d;

});
parcelRequire.register("kmaHV", function(module, exports) {

$parcel$export(module.exports, "version", () => $ed1e2afd2b752c2a$export$83d89fbfd8236492);
const $ed1e2afd2b752c2a$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("9cQEi", function(module, exports) {

$parcel$export(module.exports, "version", () => $6b3e1305272ed018$export$83d89fbfd8236492);
const $6b3e1305272ed018$export$83d89fbfd8236492 = "bytes/5.6.1";

});


parcelRequire.register("4HuzN", function(module, exports) {

$parcel$export(module.exports, "BigNumber", () => $36c2e564b0385d9a$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $36c2e564b0385d9a$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $36c2e564b0385d9a$export$1293db5d29c264ff);

var $dEXSZ = parcelRequire("dEXSZ");

var $bKKIK = parcelRequire("bKKIK");

var $gk7bp = parcelRequire("gk7bp");

var $jsoLf = parcelRequire("jsoLf");
"use strict";
var $36c2e564b0385d9a$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $36c2e564b0385d9a$var$logger = new (0, $gk7bp.Logger)((0, $jsoLf.version));
const $36c2e564b0385d9a$var$_constructorGuard = {};
const $36c2e564b0385d9a$var$MAX_SAFE = 0x1fffffffffffff;
function $36c2e564b0385d9a$export$a3d0a7fa9b65683b(value) {
    return value != null && ($36c2e564b0385d9a$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $bKKIK.isHexString)(value) || typeof value === "bigint" || (0, $bKKIK.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $36c2e564b0385d9a$var$_warnedToStringRadix = false;
class $36c2e564b0385d9a$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $36c2e564b0385d9a$var$_constructorGuard) $36c2e564b0385d9a$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $gk7bp.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $36c2e564b0385d9a$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).add($36c2e564b0385d9a$var$toBN(other)));
    }
    sub(other) {
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).sub($36c2e564b0385d9a$var$toBN(other)));
    }
    div(other) {
        const o = $36c2e564b0385d9a$export$d97aa349ed20696.from(other);
        if (o.isZero()) $36c2e564b0385d9a$var$throwFault("division-by-zero", "div");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).div($36c2e564b0385d9a$var$toBN(other)));
    }
    mul(other) {
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).mul($36c2e564b0385d9a$var$toBN(other)));
    }
    mod(other) {
        const value = $36c2e564b0385d9a$var$toBN(other);
        if (value.isNeg()) $36c2e564b0385d9a$var$throwFault("division-by-zero", "mod");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $36c2e564b0385d9a$var$toBN(other);
        if (value.isNeg()) $36c2e564b0385d9a$var$throwFault("negative-power", "pow");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $36c2e564b0385d9a$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $36c2e564b0385d9a$var$throwFault("unbound-bitwise-result", "and");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).and(value));
    }
    or(other) {
        const value = $36c2e564b0385d9a$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $36c2e564b0385d9a$var$throwFault("unbound-bitwise-result", "or");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $36c2e564b0385d9a$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $36c2e564b0385d9a$var$throwFault("unbound-bitwise-result", "xor");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $36c2e564b0385d9a$var$throwFault("negative-width", "mask");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $36c2e564b0385d9a$var$throwFault("negative-width", "shl");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $36c2e564b0385d9a$var$throwFault("negative-width", "shr");
        return $36c2e564b0385d9a$var$toBigNumber($36c2e564b0385d9a$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $36c2e564b0385d9a$var$toBN(this).eq($36c2e564b0385d9a$var$toBN(other));
    }
    lt(other) {
        return $36c2e564b0385d9a$var$toBN(this).lt($36c2e564b0385d9a$var$toBN(other));
    }
    lte(other) {
        return $36c2e564b0385d9a$var$toBN(this).lte($36c2e564b0385d9a$var$toBN(other));
    }
    gt(other) {
        return $36c2e564b0385d9a$var$toBN(this).gt($36c2e564b0385d9a$var$toBN(other));
    }
    gte(other) {
        return $36c2e564b0385d9a$var$toBN(this).gte($36c2e564b0385d9a$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $36c2e564b0385d9a$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $36c2e564b0385d9a$var$toBN(this).toNumber();
        } catch (error) {
            $36c2e564b0385d9a$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $36c2e564b0385d9a$var$logger.throwError("this platform does not support BigInt", (0, $gk7bp.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$36c2e564b0385d9a$var$_warnedToStringRadix) {
                    $36c2e564b0385d9a$var$_warnedToStringRadix = true;
                    $36c2e564b0385d9a$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $36c2e564b0385d9a$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $gk7bp.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $36c2e564b0385d9a$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $gk7bp.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $36c2e564b0385d9a$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $36c2e564b0385d9a$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $36c2e564b0385d9a$export$d97aa349ed20696($36c2e564b0385d9a$var$_constructorGuard, $36c2e564b0385d9a$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $36c2e564b0385d9a$export$d97aa349ed20696($36c2e564b0385d9a$var$_constructorGuard, $36c2e564b0385d9a$var$toHex(new $36c2e564b0385d9a$var$BN(value)));
            return $36c2e564b0385d9a$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $36c2e564b0385d9a$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $36c2e564b0385d9a$var$MAX_SAFE || value <= -$36c2e564b0385d9a$var$MAX_SAFE) $36c2e564b0385d9a$var$throwFault("overflow", "BigNumber.from", value);
            return $36c2e564b0385d9a$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $36c2e564b0385d9a$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $bKKIK.isBytes)(anyValue)) return $36c2e564b0385d9a$export$d97aa349ed20696.from((0, $bKKIK.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $36c2e564b0385d9a$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $bKKIK.isHexString)(hex) || hex[0] === "-" && (0, $bKKIK.isHexString)(hex.substring(1))) return $36c2e564b0385d9a$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $36c2e564b0385d9a$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $36c2e564b0385d9a$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $36c2e564b0385d9a$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $36c2e564b0385d9a$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $36c2e564b0385d9a$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $36c2e564b0385d9a$var$toBigNumber(value) {
    return $36c2e564b0385d9a$export$d97aa349ed20696.from($36c2e564b0385d9a$var$toHex(value));
}
function $36c2e564b0385d9a$var$toBN(value) {
    const hex = $36c2e564b0385d9a$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $36c2e564b0385d9a$var$BN("-" + hex.substring(3), 16);
    return new $36c2e564b0385d9a$var$BN(hex.substring(2), 16);
}
function $36c2e564b0385d9a$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $36c2e564b0385d9a$var$logger.throwError(fault, (0, $gk7bp.Logger).errors.NUMERIC_FAULT, params);
}
function $36c2e564b0385d9a$export$51e4a08295f7770f(value) {
    return new $36c2e564b0385d9a$var$BN(value, 36).toString(16);
}
function $36c2e564b0385d9a$export$1293db5d29c264ff(value) {
    return new $36c2e564b0385d9a$var$BN(value, 16).toString(36);
}

});
parcelRequire.register("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});


parcelRequire.register("jsoLf", function(module, exports) {

$parcel$export(module.exports, "version", () => $e2a3d6e4d5571bd7$export$83d89fbfd8236492);
const $e2a3d6e4d5571bd7$export$83d89fbfd8236492 = "bignumber/5.6.2";

});


parcelRequire.register("ep0Ku", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $a7c3fb319b12cc55$export$f8151fce47ad1c35);

var $1IGmO = parcelRequire("1IGmO");

var $bKKIK = parcelRequire("bKKIK");
"use strict";
function $a7c3fb319b12cc55$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $bKKIK.arrayify)(data));
}

});
parcelRequire.register("1IGmO", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRequire.register("4IkKc", function(module, exports) {

$parcel$export(module.exports, "encode", () => $36eb5cdd82498bfa$export$c564cdbbe6da493);

var $bKKIK = parcelRequire("bKKIK");

var $gk7bp = parcelRequire("gk7bp");

var $gD2nE = parcelRequire("gD2nE");
"use strict";
const $36eb5cdd82498bfa$var$logger = new (0, $gk7bp.Logger)((0, $gD2nE.version));
function $36eb5cdd82498bfa$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $36eb5cdd82498bfa$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $36eb5cdd82498bfa$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($36eb5cdd82498bfa$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $36eb5cdd82498bfa$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $bKKIK.isBytesLike)(object)) $36eb5cdd82498bfa$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $bKKIK.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $36eb5cdd82498bfa$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $36eb5cdd82498bfa$export$c564cdbbe6da493(object) {
    return (0, $bKKIK.hexlify)($36eb5cdd82498bfa$var$_encode(object));
}
function $36eb5cdd82498bfa$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $36eb5cdd82498bfa$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $36eb5cdd82498bfa$var$logger.throwError("child data too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $36eb5cdd82498bfa$var$_decode(data, offset) {
    if (data.length === 0) $36eb5cdd82498bfa$var$logger.throwError("data too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $36eb5cdd82498bfa$var$logger.throwError("data short segment too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        const length = $36eb5cdd82498bfa$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $36eb5cdd82498bfa$var$logger.throwError("data long segment too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        return $36eb5cdd82498bfa$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $36eb5cdd82498bfa$var$logger.throwError("data array too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        return $36eb5cdd82498bfa$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $36eb5cdd82498bfa$var$logger.throwError("data array too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        const length = $36eb5cdd82498bfa$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $36eb5cdd82498bfa$var$logger.throwError("data array too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $bKKIK.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $36eb5cdd82498bfa$var$logger.throwError("data too short", (0, $gk7bp.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $bKKIK.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $bKKIK.hexlify)(data[offset])
    };
}
function $36eb5cdd82498bfa$export$2f872c0f2117be69(data) {
    const bytes = (0, $bKKIK.arrayify)(data);
    const decoded = $36eb5cdd82498bfa$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $36eb5cdd82498bfa$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRequire.register("gD2nE", function(module, exports) {

$parcel$export(module.exports, "version", () => $c1b222902352336f$export$83d89fbfd8236492);
const $c1b222902352336f$export$83d89fbfd8236492 = "rlp/5.6.1";

});


parcelRequire.register("eDe5s", function(module, exports) {

$parcel$export(module.exports, "version", () => $aa6fa29653366778$export$83d89fbfd8236492);
const $aa6fa29653366778$export$83d89fbfd8236492 = "address/5.6.1";

});


parcelRequire.register("f4OIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iNkrR = parcelRequire("iNkrR");

var $acw62 = parcelRequire("acw62");

var $9b0Yv = parcelRequire("9b0Yv");
function $af9e91ea6e32034a$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $af9e91ea6e32034a$var$createStore__default = /*#__PURE__*/ $af9e91ea6e32034a$var$_interopDefaultLegacy($iNkrR);
var $af9e91ea6e32034a$var$useSyncExternalStoreExports__default = /*#__PURE__*/ $af9e91ea6e32034a$var$_interopDefaultLegacy($9b0Yv);
var $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector = $af9e91ea6e32034a$var$useSyncExternalStoreExports__default["default"].useSyncExternalStoreWithSelector;
function $af9e91ea6e32034a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $acw62.useDebugValue(slice);
    return slice;
}
var $af9e91ea6e32034a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $af9e91ea6e32034a$var$createStore__default["default"](createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $af9e91ea6e32034a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $af9e91ea6e32034a$var$create = function create(createState) {
    return createState ? $af9e91ea6e32034a$var$createImpl(createState) : $af9e91ea6e32034a$var$createImpl;
};
var $af9e91ea6e32034a$var$create$1 = $af9e91ea6e32034a$var$create;
Object.defineProperty(module.exports, "createStore", {
    enumerable: true,
    get: function() {
        return $af9e91ea6e32034a$var$createStore__default["default"];
    }
});
module.exports["default"] = $af9e91ea6e32034a$var$create$1;
module.exports.useStore = $af9e91ea6e32034a$var$useStore;
Object.keys($iNkrR).forEach(function(k) {
    if (k !== "default" && !module.exports.hasOwnProperty(k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $iNkrR[k];
        }
    });
});

});
parcelRequire.register("iNkrR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
module.exports["default"] = $daecaa38e3584fd1$var$createStore;

});

parcelRequire.register("9b0Yv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6VZtt"));

});
parcelRequire.register("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRequire.register("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});
parcelRequire.register("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});






parcelRequire.register("bsYBY", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", () => $859153647bbc688f$export$4f77a1d3c1ac6642);
$parcel$export(module.exports, "Provider", () => (parcelRequire("d6X7y")).Provider);
$parcel$export(module.exports, "BaseProvider", () => (parcelRequire("5PrHs")).BaseProvider);
$parcel$export(module.exports, "Resolver", () => (parcelRequire("5PrHs")).Resolver);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => (parcelRequire("b0LZy")).UrlJsonRpcProvider);
$parcel$export(module.exports, "FallbackProvider", () => (parcelRequire("1Nl15")).FallbackProvider);
$parcel$export(module.exports, "AlchemyProvider", () => (parcelRequire("k1QbV")).AlchemyProvider);
$parcel$export(module.exports, "AlchemyWebSocketProvider", () => (parcelRequire("k1QbV")).AlchemyWebSocketProvider);
$parcel$export(module.exports, "AnkrProvider", () => (parcelRequire("kAG8Y")).AnkrProvider);
$parcel$export(module.exports, "CloudflareProvider", () => (parcelRequire("hFzRk")).CloudflareProvider);
$parcel$export(module.exports, "EtherscanProvider", () => (parcelRequire("iuBVm")).EtherscanProvider);
$parcel$export(module.exports, "InfuraProvider", () => (parcelRequire("2opDo")).InfuraProvider);
$parcel$export(module.exports, "InfuraWebSocketProvider", () => (parcelRequire("2opDo")).InfuraWebSocketProvider);
$parcel$export(module.exports, "JsonRpcProvider", () => (parcelRequire("jviUl")).JsonRpcProvider);
$parcel$export(module.exports, "JsonRpcBatchProvider", () => (parcelRequire("ewooy")).JsonRpcBatchProvider);
$parcel$export(module.exports, "NodesmithProvider", () => (parcelRequire("iWIjv")).NodesmithProvider);
$parcel$export(module.exports, "PocketProvider", () => (parcelRequire("lCKhA")).PocketProvider);
$parcel$export(module.exports, "StaticJsonRpcProvider", () => (parcelRequire("b0LZy")).StaticJsonRpcProvider);
$parcel$export(module.exports, "Web3Provider", () => (parcelRequire("hat2t")).Web3Provider);
$parcel$export(module.exports, "WebSocketProvider", () => (parcelRequire("kQ2qk")).WebSocketProvider);
$parcel$export(module.exports, "IpcProvider", () => (parcelRequire("dkCSn")).IpcProvider);
$parcel$export(module.exports, "JsonRpcSigner", () => (parcelRequire("jviUl")).JsonRpcSigner);
$parcel$export(module.exports, "getNetwork", () => (parcelRequire("kiQYw")).getNetwork);
$parcel$export(module.exports, "isCommunityResource", () => (parcelRequire("iVjdI")).isCommunityResource);
$parcel$export(module.exports, "isCommunityResourcable", () => (parcelRequire("iVjdI")).isCommunityResourcable);
$parcel$export(module.exports, "showThrottleMessage", () => (parcelRequire("iVjdI")).showThrottleMessage);
$parcel$export(module.exports, "Formatter", () => (parcelRequire("iVjdI")).Formatter);

var $d6X7y = parcelRequire("d6X7y");

var $kiQYw = parcelRequire("kiQYw");

var $5PrHs = parcelRequire("5PrHs");

var $k1QbV = parcelRequire("k1QbV");

var $kAG8Y = parcelRequire("kAG8Y");

var $hFzRk = parcelRequire("hFzRk");

var $iuBVm = parcelRequire("iuBVm");

var $1Nl15 = parcelRequire("1Nl15");

var $dkCSn = parcelRequire("dkCSn");

var $2opDo = parcelRequire("2opDo");

var $jviUl = parcelRequire("jviUl");

var $ewooy = parcelRequire("ewooy");

var $iWIjv = parcelRequire("iWIjv");

var $lCKhA = parcelRequire("lCKhA");

var $b0LZy = parcelRequire("b0LZy");

var $hat2t = parcelRequire("hat2t");

var $kQ2qk = parcelRequire("kQ2qk");

var $iVjdI = parcelRequire("iVjdI");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
const $859153647bbc688f$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
////////////////////////
// Helper Functions
function $859153647bbc688f$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $jviUl.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $kQ2qk.WebSocketProvider)(network);
            default:
                $859153647bbc688f$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $kiQYw.getNetwork)(network);
    if (!n || !n._defaultProvider) $859153647bbc688f$var$logger.throwError("unsupported getDefaultProvider network", (0, $62TjC.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $1Nl15.FallbackProvider,
        AlchemyProvider: $k1QbV.AlchemyProvider,
        AnkrProvider: $kAG8Y.AnkrProvider,
        CloudflareProvider: $hFzRk.CloudflareProvider,
        EtherscanProvider: $iuBVm.EtherscanProvider,
        InfuraProvider: $2opDo.InfuraProvider,
        JsonRpcProvider: $jviUl.JsonRpcProvider,
        NodesmithProvider: $iWIjv.NodesmithProvider,
        PocketProvider: $lCKhA.PocketProvider,
        Web3Provider: $hat2t.Web3Provider,
        IpcProvider: $dkCSn.IpcProvider
    }, options);
}

});
parcelRequire.register("d6X7y", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", () => $98b9b214f0eb8c9a$export$406ece1549ccd00e);
$parcel$export(module.exports, "Provider", () => $98b9b214f0eb8c9a$export$2881499e37b75b9a);

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $cOBsC = parcelRequire("cOBsC");
"use strict";
var $98b9b214f0eb8c9a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $98b9b214f0eb8c9a$var$logger = new (0, $62TjC.Logger)((0, $cOBsC.version));
class $98b9b214f0eb8c9a$export$406ece1549ccd00e extends (0, $e72ut.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $98b9b214f0eb8c9a$export$5b2cada8494f9d99 extends $98b9b214f0eb8c9a$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $7hAPV.isHexString)(blockHash, 32)) $98b9b214f0eb8c9a$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $98b9b214f0eb8c9a$export$26bcd61a55716c98 extends $98b9b214f0eb8c9a$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $7hAPV.isHexString)(hash, 32)) $98b9b214f0eb8c9a$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $98b9b214f0eb8c9a$export$8f8609bfee47c93 extends $98b9b214f0eb8c9a$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $7hAPV.isHexString)(beforeHash, 32)) $98b9b214f0eb8c9a$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $7hAPV.isHexString)(afterHash, 32)) $98b9b214f0eb8c9a$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $98b9b214f0eb8c9a$export$2881499e37b75b9a {
    constructor(){
        $98b9b214f0eb8c9a$var$logger.checkAbstract(new.target, $98b9b214f0eb8c9a$export$2881499e37b75b9a);
        (0, $e72ut.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $98b9b214f0eb8c9a$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $e72ut.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                maxPriorityFeePerGas = (0, $gfkzi.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRequire.register("gfkzi", function(module, exports) {

$parcel$export(module.exports, "BigNumber", () => $bd3e008092ab3736$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $bd3e008092ab3736$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $bd3e008092ab3736$export$1293db5d29c264ff);

var $dEXSZ = parcelRequire("dEXSZ");

var $7hAPV = parcelRequire("7hAPV");

var $62TjC = parcelRequire("62TjC");

var $iOYk2 = parcelRequire("iOYk2");
"use strict";
var $bd3e008092ab3736$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $bd3e008092ab3736$var$logger = new (0, $62TjC.Logger)((0, $iOYk2.version));
const $bd3e008092ab3736$var$_constructorGuard = {};
const $bd3e008092ab3736$var$MAX_SAFE = 0x1fffffffffffff;
function $bd3e008092ab3736$export$a3d0a7fa9b65683b(value) {
    return value != null && ($bd3e008092ab3736$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $7hAPV.isHexString)(value) || typeof value === "bigint" || (0, $7hAPV.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $bd3e008092ab3736$var$_warnedToStringRadix = false;
class $bd3e008092ab3736$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $bd3e008092ab3736$var$_constructorGuard) $bd3e008092ab3736$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $bd3e008092ab3736$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).add($bd3e008092ab3736$var$toBN(other)));
    }
    sub(other) {
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).sub($bd3e008092ab3736$var$toBN(other)));
    }
    div(other) {
        const o = $bd3e008092ab3736$export$d97aa349ed20696.from(other);
        if (o.isZero()) $bd3e008092ab3736$var$throwFault("division-by-zero", "div");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).div($bd3e008092ab3736$var$toBN(other)));
    }
    mul(other) {
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).mul($bd3e008092ab3736$var$toBN(other)));
    }
    mod(other) {
        const value = $bd3e008092ab3736$var$toBN(other);
        if (value.isNeg()) $bd3e008092ab3736$var$throwFault("division-by-zero", "mod");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $bd3e008092ab3736$var$toBN(other);
        if (value.isNeg()) $bd3e008092ab3736$var$throwFault("negative-power", "pow");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $bd3e008092ab3736$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $bd3e008092ab3736$var$throwFault("unbound-bitwise-result", "and");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).and(value));
    }
    or(other) {
        const value = $bd3e008092ab3736$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $bd3e008092ab3736$var$throwFault("unbound-bitwise-result", "or");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $bd3e008092ab3736$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $bd3e008092ab3736$var$throwFault("unbound-bitwise-result", "xor");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $bd3e008092ab3736$var$throwFault("negative-width", "mask");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $bd3e008092ab3736$var$throwFault("negative-width", "shl");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $bd3e008092ab3736$var$throwFault("negative-width", "shr");
        return $bd3e008092ab3736$var$toBigNumber($bd3e008092ab3736$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $bd3e008092ab3736$var$toBN(this).eq($bd3e008092ab3736$var$toBN(other));
    }
    lt(other) {
        return $bd3e008092ab3736$var$toBN(this).lt($bd3e008092ab3736$var$toBN(other));
    }
    lte(other) {
        return $bd3e008092ab3736$var$toBN(this).lte($bd3e008092ab3736$var$toBN(other));
    }
    gt(other) {
        return $bd3e008092ab3736$var$toBN(this).gt($bd3e008092ab3736$var$toBN(other));
    }
    gte(other) {
        return $bd3e008092ab3736$var$toBN(this).gte($bd3e008092ab3736$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $bd3e008092ab3736$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $bd3e008092ab3736$var$toBN(this).toNumber();
        } catch (error) {
            $bd3e008092ab3736$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $bd3e008092ab3736$var$logger.throwError("this platform does not support BigInt", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$bd3e008092ab3736$var$_warnedToStringRadix) {
                    $bd3e008092ab3736$var$_warnedToStringRadix = true;
                    $bd3e008092ab3736$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $bd3e008092ab3736$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $62TjC.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $bd3e008092ab3736$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $62TjC.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $bd3e008092ab3736$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $bd3e008092ab3736$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $bd3e008092ab3736$export$d97aa349ed20696($bd3e008092ab3736$var$_constructorGuard, $bd3e008092ab3736$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $bd3e008092ab3736$export$d97aa349ed20696($bd3e008092ab3736$var$_constructorGuard, $bd3e008092ab3736$var$toHex(new $bd3e008092ab3736$var$BN(value)));
            return $bd3e008092ab3736$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $bd3e008092ab3736$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $bd3e008092ab3736$var$MAX_SAFE || value <= -$bd3e008092ab3736$var$MAX_SAFE) $bd3e008092ab3736$var$throwFault("overflow", "BigNumber.from", value);
            return $bd3e008092ab3736$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $bd3e008092ab3736$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $7hAPV.isBytes)(anyValue)) return $bd3e008092ab3736$export$d97aa349ed20696.from((0, $7hAPV.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $bd3e008092ab3736$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $7hAPV.isHexString)(hex) || hex[0] === "-" && (0, $7hAPV.isHexString)(hex.substring(1))) return $bd3e008092ab3736$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $bd3e008092ab3736$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $bd3e008092ab3736$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $bd3e008092ab3736$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $bd3e008092ab3736$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $bd3e008092ab3736$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $bd3e008092ab3736$var$toBigNumber(value) {
    return $bd3e008092ab3736$export$d97aa349ed20696.from($bd3e008092ab3736$var$toHex(value));
}
function $bd3e008092ab3736$var$toBN(value) {
    const hex = $bd3e008092ab3736$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $bd3e008092ab3736$var$BN("-" + hex.substring(3), 16);
    return new $bd3e008092ab3736$var$BN(hex.substring(2), 16);
}
function $bd3e008092ab3736$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $bd3e008092ab3736$var$logger.throwError(fault, (0, $62TjC.Logger).errors.NUMERIC_FAULT, params);
}
function $bd3e008092ab3736$export$51e4a08295f7770f(value) {
    return new $bd3e008092ab3736$var$BN(value, 36).toString(16);
}
function $bd3e008092ab3736$export$1293db5d29c264ff(value) {
    return new $bd3e008092ab3736$var$BN(value, 16).toString(36);
}

});
parcelRequire.register("7hAPV", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $54d6b1e5664b4a1c$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $54d6b1e5664b4a1c$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $54d6b1e5664b4a1c$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $54d6b1e5664b4a1c$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $54d6b1e5664b4a1c$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $54d6b1e5664b4a1c$export$a8f4574d0e56446c);
$parcel$export(module.exports, "hexlify", () => $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $54d6b1e5664b4a1c$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $54d6b1e5664b4a1c$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $54d6b1e5664b4a1c$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexValue", () => $54d6b1e5664b4a1c$export$6916af760a341dd3);
$parcel$export(module.exports, "hexZeroPad", () => $54d6b1e5664b4a1c$export$e9c46a54370b47e8);
$parcel$export(module.exports, "splitSignature", () => $54d6b1e5664b4a1c$export$7fb170f1e457988f);

var $62TjC = parcelRequire("62TjC");

var $7Y5QA = parcelRequire("7Y5QA");
"use strict";
const $54d6b1e5664b4a1c$var$logger = new (0, $62TjC.Logger)((0, $7Y5QA.version));
///////////////////////////////
function $54d6b1e5664b4a1c$var$isHexable(value) {
    return !!value.toHexString;
}
function $54d6b1e5664b4a1c$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $54d6b1e5664b4a1c$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $54d6b1e5664b4a1c$export$9a14abb1a440cd5e(value) {
    return $54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $54d6b1e5664b4a1c$export$c6fabfbfd097fc30(value);
}
function $54d6b1e5664b4a1c$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $54d6b1e5664b4a1c$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$54d6b1e5664b4a1c$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$54d6b1e5664b4a1c$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $54d6b1e5664b4a1c$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $54d6b1e5664b4a1c$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $54d6b1e5664b4a1c$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($54d6b1e5664b4a1c$var$isHexable(value)) value = value.toHexString();
    if ($54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $54d6b1e5664b4a1c$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $54d6b1e5664b4a1c$var$addSlice(new Uint8Array(result));
    }
    if ($54d6b1e5664b4a1c$export$c6fabfbfd097fc30(value)) return $54d6b1e5664b4a1c$var$addSlice(new Uint8Array(value));
    return $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $54d6b1e5664b4a1c$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$54d6b1e5664b4a1c$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $54d6b1e5664b4a1c$var$addSlice(result);
}
function $54d6b1e5664b4a1c$export$a8f4574d0e56446c(value) {
    let result = $54d6b1e5664b4a1c$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $54d6b1e5664b4a1c$export$3cdc770bf8b2ed3d(value, length) {
    value = $54d6b1e5664b4a1c$export$3131421a7d01b4fb(value);
    if (value.length > length) $54d6b1e5664b4a1c$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $54d6b1e5664b4a1c$var$addSlice(result);
}
function $54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $54d6b1e5664b4a1c$var$HexCharacters = "0123456789abcdef";
function $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $54d6b1e5664b4a1c$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $54d6b1e5664b4a1c$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($54d6b1e5664b4a1c$var$isHexable(value)) return value.toHexString();
    if ($54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $54d6b1e5664b4a1c$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($54d6b1e5664b4a1c$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $54d6b1e5664b4a1c$var$HexCharacters[(v & 0xf0) >> 4] + $54d6b1e5664b4a1c$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $54d6b1e5664b4a1c$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(data);
    else if (!$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $54d6b1e5664b4a1c$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(data);
    else if (!$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(data) || data.length % 2) $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $54d6b1e5664b4a1c$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $54d6b1e5664b4a1c$export$6916af760a341dd3(value) {
    const trimmed = $54d6b1e5664b4a1c$export$967bc0082a978949($54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $54d6b1e5664b4a1c$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(value);
    if (!$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value)) $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $54d6b1e5664b4a1c$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(value);
    else if (!$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(value)) $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $54d6b1e5664b4a1c$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $54d6b1e5664b4a1c$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($54d6b1e5664b4a1c$export$9a14abb1a440cd5e(signature)) {
        let bytes = $54d6b1e5664b4a1c$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $54d6b1e5664b4a1c$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $54d6b1e5664b4a1c$export$3cdc770bf8b2ed3d($54d6b1e5664b4a1c$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(result.r)) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $54d6b1e5664b4a1c$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(result.s)) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $54d6b1e5664b4a1c$export$e9c46a54370b47e8(result.s, 32);
        const vs = $54d6b1e5664b4a1c$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$54d6b1e5664b4a1c$export$b02a40aff8e4ad18(result._vs)) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $54d6b1e5664b4a1c$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $54d6b1e5664b4a1c$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $54d6b1e5664b4a1c$export$71bb9d78a59bbe25(signature) {
    signature = $54d6b1e5664b4a1c$export$7fb170f1e457988f(signature);
    return $54d6b1e5664b4a1c$export$2b0d6b5fbe698c70($54d6b1e5664b4a1c$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRequire.register("62TjC", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $466dd67d56ca78e8$export$efa9a398d6368992);

var $cbDHr = parcelRequire("cbDHr");
"use strict";
let $466dd67d56ca78e8$var$_permanentCensorErrors = false;
let $466dd67d56ca78e8$var$_censorErrors = false;
const $466dd67d56ca78e8$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $466dd67d56ca78e8$var$_logLevel = $466dd67d56ca78e8$var$LogLevels["default"];
let $466dd67d56ca78e8$var$_globalLogger = null;
function $466dd67d56ca78e8$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $466dd67d56ca78e8$var$_normalizeError = $466dd67d56ca78e8$var$_checkNormalize();
var $466dd67d56ca78e8$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($466dd67d56ca78e8$export$243e62d78d3b544d || ($466dd67d56ca78e8$export$243e62d78d3b544d = {}));
var $466dd67d56ca78e8$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($466dd67d56ca78e8$export$d4e71bc0b80dc0fb || ($466dd67d56ca78e8$export$d4e71bc0b80dc0fb = {}));
const $466dd67d56ca78e8$var$HEX = "0123456789abcdef";
class $466dd67d56ca78e8$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($466dd67d56ca78e8$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($466dd67d56ca78e8$var$_logLevel > $466dd67d56ca78e8$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($466dd67d56ca78e8$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($466dd67d56ca78e8$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($466dd67d56ca78e8$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($466dd67d56ca78e8$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $466dd67d56ca78e8$var$HEX[value[i] >> 4];
                        hex += $466dd67d56ca78e8$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $466dd67d56ca78e8$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $466dd67d56ca78e8$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($466dd67d56ca78e8$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $466dd67d56ca78e8$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $466dd67d56ca78e8$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $466dd67d56ca78e8$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $466dd67d56ca78e8$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $466dd67d56ca78e8$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $466dd67d56ca78e8$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$466dd67d56ca78e8$var$_globalLogger) $466dd67d56ca78e8$var$_globalLogger = new $466dd67d56ca78e8$export$efa9a398d6368992((0, $cbDHr.version));
        return $466dd67d56ca78e8$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($466dd67d56ca78e8$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $466dd67d56ca78e8$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $466dd67d56ca78e8$var$_censorErrors = !!censorship;
        $466dd67d56ca78e8$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $466dd67d56ca78e8$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $466dd67d56ca78e8$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $466dd67d56ca78e8$var$_logLevel = level;
    }
    static from(version) {
        return new $466dd67d56ca78e8$export$efa9a398d6368992(version);
    }
}
$466dd67d56ca78e8$export$efa9a398d6368992.errors = $466dd67d56ca78e8$export$d4e71bc0b80dc0fb;
$466dd67d56ca78e8$export$efa9a398d6368992.levels = $466dd67d56ca78e8$export$243e62d78d3b544d;

});
parcelRequire.register("cbDHr", function(module, exports) {

$parcel$export(module.exports, "version", () => $8df54ea3b0fc1b74$export$83d89fbfd8236492);
const $8df54ea3b0fc1b74$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("7Y5QA", function(module, exports) {

$parcel$export(module.exports, "version", () => $5cd2ac205fb05726$export$83d89fbfd8236492);
const $5cd2ac205fb05726$export$83d89fbfd8236492 = "bytes/5.6.1";

});


parcelRequire.register("iOYk2", function(module, exports) {

$parcel$export(module.exports, "version", () => $db3bb03ee8fd2985$export$83d89fbfd8236492);
const $db3bb03ee8fd2985$export$83d89fbfd8236492 = "bignumber/5.6.2";

});


parcelRequire.register("e72ut", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", () => $a463a6b5f08d6875$export$104236534534f9be);
$parcel$export(module.exports, "getStatic", () => $a463a6b5f08d6875$export$f695fbbf3cdaaf47);
$parcel$export(module.exports, "resolveProperties", () => $a463a6b5f08d6875$export$d503dd157d963b60);
$parcel$export(module.exports, "checkProperties", () => $a463a6b5f08d6875$export$ae5a316ba623b73a);
$parcel$export(module.exports, "shallowCopy", () => $a463a6b5f08d6875$export$9c13236873b118a5);
$parcel$export(module.exports, "deepCopy", () => $a463a6b5f08d6875$export$6c40052bed430212);
$parcel$export(module.exports, "Description", () => $a463a6b5f08d6875$export$393edc798c47379d);

var $luVGn = parcelRequire("luVGn");

var $kgXnl = parcelRequire("kgXnl");
"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $luVGn.Logger)((0, $kgXnl.version));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}

});
parcelRequire.register("luVGn", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $fa6924e1982b5e5e$export$efa9a398d6368992);

var $hSZj0 = parcelRequire("hSZj0");
"use strict";
let $fa6924e1982b5e5e$var$_permanentCensorErrors = false;
let $fa6924e1982b5e5e$var$_censorErrors = false;
const $fa6924e1982b5e5e$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $fa6924e1982b5e5e$var$_logLevel = $fa6924e1982b5e5e$var$LogLevels["default"];
let $fa6924e1982b5e5e$var$_globalLogger = null;
function $fa6924e1982b5e5e$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $fa6924e1982b5e5e$var$_normalizeError = $fa6924e1982b5e5e$var$_checkNormalize();
var $fa6924e1982b5e5e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($fa6924e1982b5e5e$export$243e62d78d3b544d || ($fa6924e1982b5e5e$export$243e62d78d3b544d = {}));
var $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($fa6924e1982b5e5e$export$d4e71bc0b80dc0fb || ($fa6924e1982b5e5e$export$d4e71bc0b80dc0fb = {}));
const $fa6924e1982b5e5e$var$HEX = "0123456789abcdef";
class $fa6924e1982b5e5e$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($fa6924e1982b5e5e$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($fa6924e1982b5e5e$var$_logLevel > $fa6924e1982b5e5e$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($fa6924e1982b5e5e$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($fa6924e1982b5e5e$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($fa6924e1982b5e5e$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($fa6924e1982b5e5e$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $fa6924e1982b5e5e$var$HEX[value[i] >> 4];
                        hex += $fa6924e1982b5e5e$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $fa6924e1982b5e5e$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($fa6924e1982b5e5e$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $fa6924e1982b5e5e$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $fa6924e1982b5e5e$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $fa6924e1982b5e5e$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $fa6924e1982b5e5e$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$fa6924e1982b5e5e$var$_globalLogger) $fa6924e1982b5e5e$var$_globalLogger = new $fa6924e1982b5e5e$export$efa9a398d6368992((0, $hSZj0.version));
        return $fa6924e1982b5e5e$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($fa6924e1982b5e5e$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $fa6924e1982b5e5e$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $fa6924e1982b5e5e$var$_censorErrors = !!censorship;
        $fa6924e1982b5e5e$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $fa6924e1982b5e5e$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $fa6924e1982b5e5e$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $fa6924e1982b5e5e$var$_logLevel = level;
    }
    static from(version) {
        return new $fa6924e1982b5e5e$export$efa9a398d6368992(version);
    }
}
$fa6924e1982b5e5e$export$efa9a398d6368992.errors = $fa6924e1982b5e5e$export$d4e71bc0b80dc0fb;
$fa6924e1982b5e5e$export$efa9a398d6368992.levels = $fa6924e1982b5e5e$export$243e62d78d3b544d;

});
parcelRequire.register("hSZj0", function(module, exports) {

$parcel$export(module.exports, "version", () => $d05708d21ee1322f$export$83d89fbfd8236492);
const $d05708d21ee1322f$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("kgXnl", function(module, exports) {

$parcel$export(module.exports, "version", () => $ec235c03b0398629$export$83d89fbfd8236492);
const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.6.0";

});


parcelRequire.register("cOBsC", function(module, exports) {

$parcel$export(module.exports, "version", () => $9547367430e21c2c$export$83d89fbfd8236492);
const $9547367430e21c2c$export$83d89fbfd8236492 = "abstract-provider/5.6.1";

});


parcelRequire.register("kiQYw", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $ec7e94d99db6367e$export$7de4970ebfd8206d);

var $62TjC = parcelRequire("62TjC");

var $5OtTJ = parcelRequire("5OtTJ");
"use strict";
const $ec7e94d99db6367e$var$logger = new (0, $62TjC.Logger)((0, $5OtTJ.version));
function $ec7e94d99db6367e$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $ec7e94d99db6367e$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $ec7e94d99db6367e$var$ethDefaultProvider(network);
    };
    return func;
}
function $ec7e94d99db6367e$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $ec7e94d99db6367e$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $ec7e94d99db6367e$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("homestead")
};
const $ec7e94d99db6367e$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("ropsten")
};
const $ec7e94d99db6367e$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $ec7e94d99db6367e$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $ec7e94d99db6367e$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $ec7e94d99db6367e$var$homestead,
    mainnet: $ec7e94d99db6367e$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $ec7e94d99db6367e$var$ropsten,
    testnet: $ec7e94d99db6367e$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $ec7e94d99db6367e$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $ec7e94d99db6367e$var$classicMordor,
    classicTestnet: $ec7e94d99db6367e$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $ec7e94d99db6367e$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $ec7e94d99db6367e$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $ec7e94d99db6367e$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $ec7e94d99db6367e$var$networks){
            const standard = $ec7e94d99db6367e$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $ec7e94d99db6367e$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $ec7e94d99db6367e$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $ec7e94d99db6367e$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $ec7e94d99db6367e$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($ec7e94d99db6367e$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRequire.register("5OtTJ", function(module, exports) {

$parcel$export(module.exports, "version", () => $43b8d0574ec3b4a8$export$83d89fbfd8236492);
const $43b8d0574ec3b4a8$export$83d89fbfd8236492 = "networks/5.6.4";

});


parcelRequire.register("5PrHs", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $43e733c7f2a529c1$export$8b4c839865b08288);
$parcel$export(module.exports, "BaseProvider", () => $43e733c7f2a529c1$export$ff3f6dd83125ac45);

var $d6X7y = parcelRequire("d6X7y");

var $2vfMQ = parcelRequire("2vfMQ");

var $8AXVn = parcelRequire("8AXVn");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $dRlln = parcelRequire("dRlln");

var $TKBau = parcelRequire("TKBau");

var $kiQYw = parcelRequire("kiQYw");

var $e72ut = parcelRequire("e72ut");

var $kVcAl = parcelRequire("kVcAl");

var $ky3VX = parcelRequire("ky3VX");

var $je7da = parcelRequire("je7da");

var $7CtKW = parcelRequire("7CtKW");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $iVjdI = parcelRequire("iVjdI");
"use strict";
var $43e733c7f2a529c1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $43e733c7f2a529c1$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
const $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $43e733c7f2a529c1$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $7hAPV.hexDataLength)(topic) !== 32) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $43e733c7f2a529c1$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$43e733c7f2a529c1$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $43e733c7f2a529c1$var$checkTopic(topic);
    }).join("&");
}
function $43e733c7f2a529c1$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $43e733c7f2a529c1$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $7hAPV.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $43e733c7f2a529c1$var$serializeTopics(eventName);
    else if ((0, $d6X7y.ForkEvent).isForkEvent(eventName)) {
        $43e733c7f2a529c1$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $43e733c7f2a529c1$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $43e733c7f2a529c1$var$getTime() {
    return new Date().getTime();
}
function $43e733c7f2a529c1$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $43e733c7f2a529c1$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $43e733c7f2a529c1$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $e72ut.defineReadOnly)(this, "tag", tag);
        (0, $e72ut.defineReadOnly)(this, "listener", listener);
        (0, $e72ut.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $43e733c7f2a529c1$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $43e733c7f2a529c1$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $43e733c7f2a529c1$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $43e733c7f2a529c1$var$bytes32ify(value) {
    return (0, $7hAPV.hexZeroPad)((0, $gfkzi.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $43e733c7f2a529c1$var$base58Encode(data) {
    return (0, $8AXVn.Base58).encode((0, $7hAPV.concat)([
        data,
        (0, $7hAPV.hexDataSlice)((0, $kVcAl.sha256)((0, $kVcAl.sha256)(data)), 0, 4)
    ]));
}
const $43e733c7f2a529c1$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $43e733c7f2a529c1$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $43e733c7f2a529c1$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $43e733c7f2a529c1$var$_parseString(result, start) {
    try {
        return (0, $ky3VX.toUtf8String)($43e733c7f2a529c1$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $43e733c7f2a529c1$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $gfkzi.BigNumber).from((0, $7hAPV.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $gfkzi.BigNumber).from((0, $7hAPV.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $7hAPV.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $43e733c7f2a529c1$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $43e733c7f2a529c1$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $43e733c7f2a529c1$var$numPad(value) {
    const result = (0, $7hAPV.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $43e733c7f2a529c1$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $43e733c7f2a529c1$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $7hAPV.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $43e733c7f2a529c1$var$numPad(byteCount);
        // The length and padded value of data
        result.push($43e733c7f2a529c1$var$numPad(data.length));
        result.push($43e733c7f2a529c1$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $7hAPV.hexConcat)(result);
}
class $43e733c7f2a529c1$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $e72ut.defineReadOnly)(this, "provider", provider);
        (0, $e72ut.defineReadOnly)(this, "name", name);
        (0, $e72ut.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $e72ut.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $gfkzi.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $62TjC.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $7hAPV.hexConcat)([
                    selector,
                    (0, $TKBau.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $7hAPV.hexConcat)([
                    "0x9061b923",
                    $43e733c7f2a529c1$var$encodeBytes([
                        (0, $TKBau.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $7hAPV.arrayify)(result).length % 32 === 4) $43e733c7f2a529c1$var$logger.throwError("resolver threw error", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $43e733c7f2a529c1$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $62TjC.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $43e733c7f2a529c1$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $43e733c7f2a529c1$var$coinInfos[String(coinType)];
        if (coinInfo == null) $43e733c7f2a529c1$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $7hAPV.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7hAPV.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7hAPV.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $dRlln.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $62TjC.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $43e733c7f2a529c1$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported coin data`, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $43e733c7f2a529c1$var$matchers.length; i++){
                    const match = avatar.match($43e733c7f2a529c1$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $43e733c7f2a529c1$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $7hAPV.hexZeroPad)((0, $gfkzi.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7hAPV.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $gfkzi.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7hAPV.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $7hAPV.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $7hAPV.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $43e733c7f2a529c1$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $43e733c7f2a529c1$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $je7da.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($43e733c7f2a529c1$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $43e733c7f2a529c1$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $8AXVn.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $8AXVn.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $2vfMQ.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported content hash data`, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $ky3VX.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $7hAPV.concat)([
                $43e733c7f2a529c1$var$bytes32ify(64),
                $43e733c7f2a529c1$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $7hAPV.concat)([
                keyBytes,
                (0, $7hAPV.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $7hAPV.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $ky3VX.toUtf8String)(hexBytes);
        });
    }
}
let $43e733c7f2a529c1$var$defaultFormatter = null;
let $43e733c7f2a529c1$var$nextPollId = 1;
class $43e733c7f2a529c1$export$ff3f6dd83125ac45 extends (0, $d6X7y.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $e72ut.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $e72ut.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $e72ut.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $43e733c7f2a529c1$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $43e733c7f2a529c1$var$logger.throwError("no network detected", (0, $62TjC.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $e72ut.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $je7da.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $62TjC.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($43e733c7f2a529c1$var$defaultFormatter == null) $43e733c7f2a529c1$var$defaultFormatter = new (0, $iVjdI.Formatter)();
        return $43e733c7f2a529c1$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $kiQYw.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $je7da.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $43e733c7f2a529c1$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $43e733c7f2a529c1$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $62TjC.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($43e733c7f2a529c1$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $43e733c7f2a529c1$var$getTime();
            const checkInternalBlockNumber = (0, $e72ut.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $43e733c7f2a529c1$var$getTime();
                blockNumber = (0, $gfkzi.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $43e733c7f2a529c1$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $43e733c7f2a529c1$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $43e733c7f2a529c1$var$logger.makeError("network block skew detected", (0, $62TjC.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // Filter from the last known event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild
                            if (filter.toBlock - this._maxFilterBlockRange > filter.fromBlock) filter.fromBlock = filter.toBlock - this._maxFilterBlockRange;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return $43e733c7f2a529c1$var$logger.throwError("provider does not support network detection", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $43e733c7f2a529c1$var$stall(0);
                    return this._network;
                }
                const error = $43e733c7f2a529c1$var$logger.makeError("underlying network changed", (0, $62TjC.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $43e733c7f2a529c1$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $43e733c7f2a529c1$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $43e733c7f2a529c1$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($43e733c7f2a529c1$var$logger.makeError("transaction was replaced", (0, $62TjC.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($43e733c7f2a529c1$var$logger.makeError("timeout exceeded", (0, $62TjC.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $gfkzi.BigNumber).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $gfkzi.BigNumber).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $gfkzi.BigNumber).from(result).toNumber();
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $7hAPV.hexlify)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $7hAPV.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $7hAPV.hexlify)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $7hAPV.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $43e733c7f2a529c1$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $62TjC.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $43e733c7f2a529c1$var$logger.throwError("transaction failed", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $7hAPV.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $gfkzi.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $7hAPV.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $e72ut.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $e72ut.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS) $43e733c7f2a529c1$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $7hAPV.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $7hAPV.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $7hAPV.hexDataSlice)(data, 0, 32);
                if (!(0, $gfkzi.BigNumber).from(sender).eq(txSender)) $43e733c7f2a529c1$var$logger.throwError("CCIP Read sender did not match", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $gfkzi.BigNumber).from((0, $7hAPV.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $gfkzi.BigNumber).from((0, $7hAPV.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $7hAPV.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $43e733c7f2a529c1$var$_parseString(urlsData, u * 32);
                    if (url == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $43e733c7f2a529c1$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $gfkzi.BigNumber).from((0, $7hAPV.hexDataSlice)(data, 100, 128)).isZero()) $43e733c7f2a529c1$var$logger.throwError("CCIP Read callback selector included junk", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $7hAPV.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $43e733c7f2a529c1$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $7hAPV.hexConcat)([
                        callbackSelector,
                        $43e733c7f2a529c1$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $62TjC.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $7hAPV.hexlify)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $e72ut.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $gfkzi.BigNumber).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError("ENS name not configured", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $7hAPV.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $7hAPV.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $43e733c7f2a529c1$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $je7da.poll)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $je7da.poll)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $je7da.poll)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $e72ut.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $iVjdI.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $43e733c7f2a529c1$var$logger.throwError("network does not support ENS", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $TKBau.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $7hAPV.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $TKBau.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $7hAPV.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $62TjC.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $TKBau.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $62TjC.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $43e733c7f2a529c1$var$logger.throwError(method + " not implemented", (0, $62TjC.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $43e733c7f2a529c1$export$d61e24a684f9e51($43e733c7f2a529c1$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRequire.register("2vfMQ", function(module, exports) {

$parcel$export(module.exports, "decode", () => $1d2ab8f2156e640e$export$2f872c0f2117be69);
$parcel$export(module.exports, "encode", () => $1d2ab8f2156e640e$export$c564cdbbe6da493);

var $3S0P3 = parcelRequire("3S0P3");
"use strict";
function $1d2ab8f2156e640e$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $3S0P3.arrayify)(data);
}
function $1d2ab8f2156e640e$export$c564cdbbe6da493(data) {
    data = (0, $3S0P3.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});
parcelRequire.register("3S0P3", function(module, exports) {

$parcel$export(module.exports, "arrayify", () => $2d170d966dc4cfe3$export$3131421a7d01b4fb);

var $1US8q = parcelRequire("1US8q");

var $fl3iQ = parcelRequire("fl3iQ");
"use strict";
const $2d170d966dc4cfe3$var$logger = new (0, $1US8q.Logger)((0, $fl3iQ.version));
///////////////////////////////
function $2d170d966dc4cfe3$var$isHexable(value) {
    return !!value.toHexString;
}
function $2d170d966dc4cfe3$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $2d170d966dc4cfe3$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $2d170d966dc4cfe3$export$9a14abb1a440cd5e(value) {
    return $2d170d966dc4cfe3$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $2d170d966dc4cfe3$export$c6fabfbfd097fc30(value);
}
function $2d170d966dc4cfe3$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $2d170d966dc4cfe3$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$2d170d966dc4cfe3$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$2d170d966dc4cfe3$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $2d170d966dc4cfe3$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $2d170d966dc4cfe3$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $2d170d966dc4cfe3$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($2d170d966dc4cfe3$var$isHexable(value)) value = value.toHexString();
    if ($2d170d966dc4cfe3$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $2d170d966dc4cfe3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $2d170d966dc4cfe3$var$addSlice(new Uint8Array(result));
    }
    if ($2d170d966dc4cfe3$export$c6fabfbfd097fc30(value)) return $2d170d966dc4cfe3$var$addSlice(new Uint8Array(value));
    return $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $2d170d966dc4cfe3$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$2d170d966dc4cfe3$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $2d170d966dc4cfe3$var$addSlice(result);
}
function $2d170d966dc4cfe3$export$a8f4574d0e56446c(value) {
    let result = $2d170d966dc4cfe3$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $2d170d966dc4cfe3$export$3cdc770bf8b2ed3d(value, length) {
    value = $2d170d966dc4cfe3$export$3131421a7d01b4fb(value);
    if (value.length > length) $2d170d966dc4cfe3$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $2d170d966dc4cfe3$var$addSlice(result);
}
function $2d170d966dc4cfe3$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $2d170d966dc4cfe3$var$HexCharacters = "0123456789abcdef";
function $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $2d170d966dc4cfe3$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $2d170d966dc4cfe3$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($2d170d966dc4cfe3$var$isHexable(value)) return value.toHexString();
    if ($2d170d966dc4cfe3$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $2d170d966dc4cfe3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($2d170d966dc4cfe3$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $2d170d966dc4cfe3$var$HexCharacters[(v & 0xf0) >> 4] + $2d170d966dc4cfe3$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $2d170d966dc4cfe3$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(data);
    else if (!$2d170d966dc4cfe3$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $2d170d966dc4cfe3$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(data);
    else if (!$2d170d966dc4cfe3$export$b02a40aff8e4ad18(data) || data.length % 2) $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $2d170d966dc4cfe3$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $2d170d966dc4cfe3$export$6916af760a341dd3(value) {
    const trimmed = $2d170d966dc4cfe3$export$967bc0082a978949($2d170d966dc4cfe3$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $2d170d966dc4cfe3$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(value);
    if (!$2d170d966dc4cfe3$export$b02a40aff8e4ad18(value)) $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $2d170d966dc4cfe3$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(value);
    else if (!$2d170d966dc4cfe3$export$b02a40aff8e4ad18(value)) $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $2d170d966dc4cfe3$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $2d170d966dc4cfe3$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($2d170d966dc4cfe3$export$9a14abb1a440cd5e(signature)) {
        let bytes = $2d170d966dc4cfe3$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $2d170d966dc4cfe3$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $2d170d966dc4cfe3$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $2d170d966dc4cfe3$export$3cdc770bf8b2ed3d($2d170d966dc4cfe3$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$2d170d966dc4cfe3$export$b02a40aff8e4ad18(result.r)) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $2d170d966dc4cfe3$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$2d170d966dc4cfe3$export$b02a40aff8e4ad18(result.s)) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $2d170d966dc4cfe3$export$e9c46a54370b47e8(result.s, 32);
        const vs = $2d170d966dc4cfe3$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $2d170d966dc4cfe3$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$2d170d966dc4cfe3$export$b02a40aff8e4ad18(result._vs)) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $2d170d966dc4cfe3$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $2d170d966dc4cfe3$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $2d170d966dc4cfe3$export$71bb9d78a59bbe25(signature) {
    signature = $2d170d966dc4cfe3$export$7fb170f1e457988f(signature);
    return $2d170d966dc4cfe3$export$2b0d6b5fbe698c70($2d170d966dc4cfe3$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRequire.register("1US8q", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $165503760134d940$export$efa9a398d6368992);

var $bZLta = parcelRequire("bZLta");
"use strict";
let $165503760134d940$var$_permanentCensorErrors = false;
let $165503760134d940$var$_censorErrors = false;
const $165503760134d940$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $165503760134d940$var$_logLevel = $165503760134d940$var$LogLevels["default"];
let $165503760134d940$var$_globalLogger = null;
function $165503760134d940$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $165503760134d940$var$_normalizeError = $165503760134d940$var$_checkNormalize();
var $165503760134d940$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($165503760134d940$export$243e62d78d3b544d || ($165503760134d940$export$243e62d78d3b544d = {}));
var $165503760134d940$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($165503760134d940$export$d4e71bc0b80dc0fb || ($165503760134d940$export$d4e71bc0b80dc0fb = {}));
const $165503760134d940$var$HEX = "0123456789abcdef";
class $165503760134d940$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($165503760134d940$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($165503760134d940$var$_logLevel > $165503760134d940$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($165503760134d940$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($165503760134d940$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($165503760134d940$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($165503760134d940$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $165503760134d940$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $165503760134d940$var$HEX[value[i] >> 4];
                        hex += $165503760134d940$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $165503760134d940$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $165503760134d940$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $165503760134d940$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $165503760134d940$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $165503760134d940$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $165503760134d940$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $165503760134d940$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $165503760134d940$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $165503760134d940$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($165503760134d940$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $165503760134d940$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $165503760134d940$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $165503760134d940$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $165503760134d940$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $165503760134d940$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $165503760134d940$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $165503760134d940$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $165503760134d940$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $165503760134d940$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$165503760134d940$var$_globalLogger) $165503760134d940$var$_globalLogger = new $165503760134d940$export$efa9a398d6368992((0, $bZLta.version));
        return $165503760134d940$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $165503760134d940$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($165503760134d940$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $165503760134d940$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $165503760134d940$var$_censorErrors = !!censorship;
        $165503760134d940$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $165503760134d940$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $165503760134d940$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $165503760134d940$var$_logLevel = level;
    }
    static from(version) {
        return new $165503760134d940$export$efa9a398d6368992(version);
    }
}
$165503760134d940$export$efa9a398d6368992.errors = $165503760134d940$export$d4e71bc0b80dc0fb;
$165503760134d940$export$efa9a398d6368992.levels = $165503760134d940$export$243e62d78d3b544d;

});
parcelRequire.register("bZLta", function(module, exports) {

$parcel$export(module.exports, "version", () => $8bba36a6c12127a0$export$83d89fbfd8236492);
const $8bba36a6c12127a0$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("fl3iQ", function(module, exports) {

$parcel$export(module.exports, "version", () => $b2ab611062da48e0$export$83d89fbfd8236492);
const $b2ab611062da48e0$export$83d89fbfd8236492 = "bytes/5.6.1";

});



parcelRequire.register("8AXVn", function(module, exports) {

$parcel$export(module.exports, "Base58", () => $64202b4751e038ea$export$45a587635c9954b2);
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");
class $64202b4751e038ea$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $e72ut.defineReadOnly)(this, "alphabet", alphabet);
        (0, $e72ut.defineReadOnly)(this, "base", alphabet.length);
        (0, $e72ut.defineReadOnly)(this, "_alphabetMap", {});
        (0, $e72ut.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $7hAPV.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $7hAPV.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $64202b4751e038ea$export$cfabb2852920f5ec = new $64202b4751e038ea$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $64202b4751e038ea$export$45a587635c9954b2 = new $64202b4751e038ea$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRequire.register("dRlln", function(module, exports) {

$parcel$export(module.exports, "HashZero", () => $a170c806ba5c868f$export$71c2e4e213dcb7f2);
const $a170c806ba5c868f$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRequire.register("TKBau", function(module, exports) {

$parcel$export(module.exports, "namehash", () => $0a7948a874d66185$export$91d651ee363e1209);
$parcel$export(module.exports, "dnsEncode", () => $0a7948a874d66185$export$6c0a8cdae51cb512);

var $7hAPV = parcelRequire("7hAPV");

var $hH6Jg = parcelRequire("hH6Jg");
var $ky3VX = parcelRequire("ky3VX");

var $greay = parcelRequire("greay");

var $62TjC = parcelRequire("62TjC");

var $5Ok1g = parcelRequire("5Ok1g");
const $0a7948a874d66185$var$logger = new (0, $62TjC.Logger)((0, $5Ok1g.version));
const $0a7948a874d66185$var$Zeros = new Uint8Array(32);
$0a7948a874d66185$var$Zeros.fill(0);
const $0a7948a874d66185$var$Partition = new RegExp("^((.*)\\.)?([^.]+)$");
function $0a7948a874d66185$export$cce2300886e7ace6(name) {
    try {
        const comps = name.split(".");
        for(let i = 0; i < comps.length; i++){
            if ((0, $hH6Jg.nameprep)(comps[i]).length === 0) throw new Error("empty");
        }
        return true;
    } catch (error) {}
    return false;
}
function $0a7948a874d66185$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $0a7948a874d66185$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let current = name;
    let result = $0a7948a874d66185$var$Zeros;
    while(current.length){
        const partition = current.match($0a7948a874d66185$var$Partition);
        if (partition == null || partition[2] === "") $0a7948a874d66185$var$logger.throwArgumentError("invalid ENS address; missing component", "name", name);
        const label = (0, $ky3VX.toUtf8Bytes)((0, $hH6Jg.nameprep)(partition[3]));
        result = (0, $greay.keccak256)((0, $7hAPV.concat)([
            result,
            (0, $greay.keccak256)(label)
        ]));
        current = partition[2] || "";
    }
    return (0, $7hAPV.hexlify)(result);
}
function $0a7948a874d66185$export$6c0a8cdae51cb512(name) {
    return (0, $7hAPV.hexlify)((0, $7hAPV.concat)(name.split(".").map((comp)=>{
        // We jam in an _ prefix to fill in with the length later
        // Note: Nameprep throws if the component is over 63 bytes
        const bytes = (0, $ky3VX.toUtf8Bytes)("_" + (0, $hH6Jg.nameprep)(comp));
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRequire.register("hH6Jg", function(module, exports) {

$parcel$export(module.exports, "nameprep", () => $ce1bac0e31f00046$export$94f0b6f93c619bc);

var $ky3VX = parcelRequire("ky3VX");
"use strict";
function $ce1bac0e31f00046$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $ce1bac0e31f00046$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $ce1bac0e31f00046$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $ce1bac0e31f00046$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $ce1bac0e31f00046$var$Table_A_1_ranges = $ce1bac0e31f00046$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $ce1bac0e31f00046$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $ce1bac0e31f00046$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $ce1bac0e31f00046$var$Table_B_2_lut_abs = $ce1bac0e31f00046$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $ce1bac0e31f00046$var$Table_B_2_lut_rel = $ce1bac0e31f00046$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $ce1bac0e31f00046$var$Table_B_2_complex = $ce1bac0e31f00046$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $ce1bac0e31f00046$var$bytes2);
const $ce1bac0e31f00046$var$Table_C_ranges = $ce1bac0e31f00046$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $ce1bac0e31f00046$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $ce1bac0e31f00046$export$d1ae0d802533bef0(codepoint) {
    return !!$ce1bac0e31f00046$var$matchMap(codepoint, $ce1bac0e31f00046$var$Table_A_1_ranges);
}
function $ce1bac0e31f00046$export$9630a1f26a43b76c(codepoint) {
    let range = $ce1bac0e31f00046$var$matchMap(codepoint, $ce1bac0e31f00046$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $ce1bac0e31f00046$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $ce1bac0e31f00046$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $ce1bac0e31f00046$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $ce1bac0e31f00046$export$e07a548cae6d1553(codepoint) {
    return !!$ce1bac0e31f00046$var$matchMap(codepoint, $ce1bac0e31f00046$var$Table_C_ranges);
}
function $ce1bac0e31f00046$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $ky3VX.toUtf8CodePoints)(value);
    codes = $ce1bac0e31f00046$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($ce1bac0e31f00046$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $ce1bac0e31f00046$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $ky3VX.toUtf8CodePoints)((0, $ky3VX._toUtf8String)(codes), (0, $ky3VX.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($ce1bac0e31f00046$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($ce1bac0e31f00046$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $ky3VX._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    // IDNA: 4.2.4
    if (name.length > 63) throw new Error("too long");
    return name;
}

});
parcelRequire.register("ky3VX", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", () => $ef5a08cd6d979fb7$export$c6986442964129f5);
$parcel$export(module.exports, "toUtf8Bytes", () => $ef5a08cd6d979fb7$export$8feeb310b4b4752f);
$parcel$export(module.exports, "_toUtf8String", () => $ef5a08cd6d979fb7$export$232e1dab03132235);
$parcel$export(module.exports, "toUtf8String", () => $ef5a08cd6d979fb7$export$7643a1dc2c38d5eb);
$parcel$export(module.exports, "toUtf8CodePoints", () => $ef5a08cd6d979fb7$export$ae470a36a31b28c2);

var $7hAPV = parcelRequire("7hAPV");

var $62TjC = parcelRequire("62TjC");

var $hTYH2 = parcelRequire("hTYH2");
"use strict";
const $ef5a08cd6d979fb7$var$logger = new (0, $62TjC.Logger)((0, $hTYH2.version));
var $ef5a08cd6d979fb7$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($ef5a08cd6d979fb7$export$c6986442964129f5 || ($ef5a08cd6d979fb7$export$c6986442964129f5 = {}));
var $ef5a08cd6d979fb7$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6 || ($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6 = {}));
function $ef5a08cd6d979fb7$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $ef5a08cd6d979fb7$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $ef5a08cd6d979fb7$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $ef5a08cd6d979fb7$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $ef5a08cd6d979fb7$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $ef5a08cd6d979fb7$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $ef5a08cd6d979fb7$var$errorFunc,
    ignore: $ef5a08cd6d979fb7$var$ignoreFunc,
    replace: $ef5a08cd6d979fb7$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $ef5a08cd6d979fb7$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $ef5a08cd6d979fb7$export$c6e2180c5bb5bc05.error;
    bytes = (0, $7hAPV.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($ef5a08cd6d979fb7$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $ef5a08cd6d979fb7$export$8feeb310b4b4752f(str, form = $ef5a08cd6d979fb7$export$c6986442964129f5.current) {
    if (form != $ef5a08cd6d979fb7$export$c6986442964129f5.current) {
        $ef5a08cd6d979fb7$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $7hAPV.arrayify)(result);
}
function $ef5a08cd6d979fb7$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $ef5a08cd6d979fb7$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $ef5a08cd6d979fb7$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $ef5a08cd6d979fb7$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $ef5a08cd6d979fb7$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $ef5a08cd6d979fb7$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $ef5a08cd6d979fb7$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $ef5a08cd6d979fb7$export$7643a1dc2c38d5eb(bytes, onError) {
    return $ef5a08cd6d979fb7$export$232e1dab03132235($ef5a08cd6d979fb7$var$getUtf8CodePoints(bytes, onError));
}
function $ef5a08cd6d979fb7$export$ae470a36a31b28c2(str, form = $ef5a08cd6d979fb7$export$c6986442964129f5.current) {
    return $ef5a08cd6d979fb7$var$getUtf8CodePoints($ef5a08cd6d979fb7$export$8feeb310b4b4752f(str, form));
}

});
parcelRequire.register("hTYH2", function(module, exports) {

$parcel$export(module.exports, "version", () => $d086a7184f405dff$export$83d89fbfd8236492);
const $d086a7184f405dff$export$83d89fbfd8236492 = "strings/5.6.1";

});



parcelRequire.register("greay", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $bf7a28b15ba3d110$export$f8151fce47ad1c35);

var $1IGmO = parcelRequire("1IGmO");

var $7hAPV = parcelRequire("7hAPV");
"use strict";
function $bf7a28b15ba3d110$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $7hAPV.arrayify)(data));
}

});

parcelRequire.register("5Ok1g", function(module, exports) {

$parcel$export(module.exports, "version", () => $43b126b4248a9e03$export$83d89fbfd8236492);
const $43b126b4248a9e03$export$83d89fbfd8236492 = "hash/5.6.1";

});


parcelRequire.register("kVcAl", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $f3b2e4ae1b93d2bc$export$bced8d2aada2d1c9);

var $kiSKt = parcelRequire("kiSKt");

var $7hAPV = parcelRequire("7hAPV");

var $gotmY = parcelRequire("gotmY");

var $62TjC = parcelRequire("62TjC");

var $fXukG = parcelRequire("fXukG");
"use strict";
const $f3b2e4ae1b93d2bc$var$logger = new (0, $62TjC.Logger)((0, $fXukG.version));
function $f3b2e4ae1b93d2bc$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $7hAPV.arrayify)(data)).digest("hex");
}
function $f3b2e4ae1b93d2bc$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $7hAPV.arrayify)(data)).digest("hex");
}
function $f3b2e4ae1b93d2bc$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $7hAPV.arrayify)(data)).digest("hex");
}
function $f3b2e4ae1b93d2bc$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $gotmY.SupportedAlgorithm)[algorithm]) $f3b2e4ae1b93d2bc$var$logger.throwError("unsupported algorithm " + algorithm, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $7hAPV.arrayify)(key)).update((0, $7hAPV.arrayify)(data)).digest("hex");
}

});
parcelRequire.register("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRequire.register("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});
parcelRequire.register("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRequire.register("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRequire.register("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRequire.register("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRequire.register("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("gotmY", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", () => $bef5ab6a57ef770e$export$d2a8849cfb277c);
var $bef5ab6a57ef770e$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($bef5ab6a57ef770e$export$d2a8849cfb277c || ($bef5ab6a57ef770e$export$d2a8849cfb277c = {}));

});

parcelRequire.register("fXukG", function(module, exports) {

$parcel$export(module.exports, "version", () => $b9e3e526243fc002$export$83d89fbfd8236492);
const $b9e3e526243fc002$export$83d89fbfd8236492 = "sha2/5.6.1";

});


parcelRequire.register("je7da", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $dff4eb22e4ffe323$export$6d71b655afe1638d);
$parcel$export(module.exports, "poll", () => $dff4eb22e4ffe323$export$e0c10349b2c5e1d4);

var $2vfMQ = parcelRequire("2vfMQ");

var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");

var $ky3VX = parcelRequire("ky3VX");

var $62TjC = parcelRequire("62TjC");

var $5FMgB = parcelRequire("5FMgB");

var $fwgoK = parcelRequire("fwgoK");
"use strict";
var $dff4eb22e4ffe323$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dff4eb22e4ffe323$var$logger = new (0, $62TjC.Logger)((0, $5FMgB.version));
function $dff4eb22e4ffe323$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $dff4eb22e4ffe323$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $7hAPV.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $ky3VX.toUtf8String)(value);
        } catch (error) {}
        return (0, $7hAPV.hexlify)(value);
    }
    return value;
}
function $dff4eb22e4ffe323$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $dff4eb22e4ffe323$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $dff4eb22e4ffe323$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $dff4eb22e4ffe323$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $dff4eb22e4ffe323$var$logger.throwError("basic authentication requires a secure https url", (0, $62TjC.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $2vfMQ.encode)((0, $ky3VX.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
    }
    const reData = new RegExp("^data:([a-z0-9-]+/[a-z0-9-]+);base64,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1]
            },
            body: (0, $2vfMQ.decode)(dataMatch[2])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $dff4eb22e4ffe323$var$logger.throwError("processing response error", (0, $62TjC.Logger).errors.SERVER_ERROR, {
            body: $dff4eb22e4ffe323$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($dff4eb22e4ffe323$var$logger.makeError("timeout", (0, $62TjC.Logger).errors.TIMEOUT, {
                    requestBody: $dff4eb22e4ffe323$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $dff4eb22e4ffe323$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $fwgoK.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $dff4eb22e4ffe323$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $dff4eb22e4ffe323$var$logger.throwError("missing response", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                            requestBody: $dff4eb22e4ffe323$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $dff4eb22e4ffe323$var$logger.throwError("bad response", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $dff4eb22e4ffe323$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $dff4eb22e4ffe323$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $dff4eb22e4ffe323$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $dff4eb22e4ffe323$var$logger.throwError("processing response error", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                        body: $dff4eb22e4ffe323$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $dff4eb22e4ffe323$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $dff4eb22e4ffe323$var$logger.throwError("failed response", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                requestBody: $dff4eb22e4ffe323$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $dff4eb22e4ffe323$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $ky3VX.toUtf8String)(value));
        } catch (error) {
            $dff4eb22e4ffe323$var$logger.throwError("invalid JSON", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $ky3VX.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $e72ut.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $e72ut.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $dff4eb22e4ffe323$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $dff4eb22e4ffe323$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $e72ut.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRequire.register("5FMgB", function(module, exports) {

$parcel$export(module.exports, "version", () => $421638d96d70559e$export$83d89fbfd8236492);
const $421638d96d70559e$export$83d89fbfd8236492 = "web/5.6.1";

});

parcelRequire.register("fwgoK", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $b4c6908576ebd70b$export$94df0e59ebebf4a7);

var $7hAPV = parcelRequire("7hAPV");
"use strict";
var $b4c6908576ebd70b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $b4c6908576ebd70b$export$94df0e59ebebf4a7(href, options) {
    return $b4c6908576ebd70b$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $7hAPV.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRequire.register("7CtKW", function(module, exports) {
"use strict";
var $58c329f65c659a19$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $58c329f65c659a19$var$ALPHABET_MAP = {};
for(var $58c329f65c659a19$var$z = 0; $58c329f65c659a19$var$z < $58c329f65c659a19$var$ALPHABET.length; $58c329f65c659a19$var$z++){
    var $58c329f65c659a19$var$x = $58c329f65c659a19$var$ALPHABET.charAt($58c329f65c659a19$var$z);
    if ($58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] !== undefined) throw new TypeError($58c329f65c659a19$var$x + " is ambiguous");
    $58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] = $58c329f65c659a19$var$z;
}
function $58c329f65c659a19$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $58c329f65c659a19$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $58c329f65c659a19$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $58c329f65c659a19$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ x;
        result += $58c329f65c659a19$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $58c329f65c659a19$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $58c329f65c659a19$var$ALPHABET.charAt(v);
    }
    return result;
}
function $58c329f65c659a19$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $58c329f65c659a19$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $58c329f65c659a19$var$decodeUnsafe() {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $58c329f65c659a19$var$decode(str) {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $58c329f65c659a19$var$toWordsUnsafe(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$toWords(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$fromWordsUnsafe(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$fromWords(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $58c329f65c659a19$var$decodeUnsafe,
    decode: $58c329f65c659a19$var$decode,
    encode: $58c329f65c659a19$var$encode,
    toWordsUnsafe: $58c329f65c659a19$var$toWordsUnsafe,
    toWords: $58c329f65c659a19$var$toWords,
    fromWordsUnsafe: $58c329f65c659a19$var$fromWordsUnsafe,
    fromWords: $58c329f65c659a19$var$fromWords
};

});

parcelRequire.register("lLH54", function(module, exports) {

$parcel$export(module.exports, "version", () => $fd8f67b80e142427$export$83d89fbfd8236492);
const $fd8f67b80e142427$export$83d89fbfd8236492 = "providers/5.6.8";

});

parcelRequire.register("iVjdI", function(module, exports) {

$parcel$export(module.exports, "Formatter", () => $dc6c759982861e14$export$a06636add2a09fd8);
$parcel$export(module.exports, "isCommunityResourcable", () => $dc6c759982861e14$export$3091239f5b20b896);
$parcel$export(module.exports, "isCommunityResource", () => $dc6c759982861e14$export$d93d5f61c2498b6);
$parcel$export(module.exports, "showThrottleMessage", () => $dc6c759982861e14$export$4c41bd49e82e82ab);

var $2V9vq = parcelRequire("2V9vq");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $5f20y = parcelRequire("5f20y");

var $e72ut = parcelRequire("e72ut");

var $aNGBw = parcelRequire("aNGBw");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
const $dc6c759982861e14$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
class $dc6c759982861e14$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            creates: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            raw: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            value: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(strictData),
            type: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $e72ut.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $aNGBw.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $gfkzi.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $gfkzi.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $gfkzi.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $7hAPV.isHexString)(value)) return value.toLowerCase();
        }
        return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $2V9vq.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $7hAPV.isHexString)(value, 32)) return null;
        const address = (0, $2V9vq.getAddress)((0, $7hAPV.hexDataSlice)(value, 12));
        return address === (0, $5f20y.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $2V9vq.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        if (blockTag === "latest" || blockTag === "pending") return blockTag;
        if (typeof blockTag === "number" || (0, $7hAPV.isHexString)(blockTag)) return (0, $7hAPV.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $7hAPV.hexDataLength)(result) !== 32) return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $gfkzi.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $7hAPV.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $7hAPV.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $gfkzi.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $gfkzi.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $7hAPV.isHexString)(chainId)) chainId = (0, $gfkzi.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $7hAPV.isHexString)(chainId)) chainId = (0, $gfkzi.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $aNGBw.parse)(value);
    }
    receiptLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $gfkzi.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $dc6c759982861e14$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $dc6c759982861e14$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $dc6c759982861e14$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $dc6c759982861e14$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $dc6c759982861e14$export$d93d5f61c2498b6(value) {
    return $dc6c759982861e14$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $dc6c759982861e14$var$throttleMessage = false;
function $dc6c759982861e14$export$4c41bd49e82e82ab() {
    if ($dc6c759982861e14$var$throttleMessage) return;
    $dc6c759982861e14$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});
parcelRequire.register("2V9vq", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $2208474f52659fd6$export$88411125f012957a);
$parcel$export(module.exports, "getContractAddress", () => $2208474f52659fd6$export$b7fbffef12272e40);

var $7hAPV = parcelRequire("7hAPV");

var $gfkzi = parcelRequire("gfkzi");

var $greay = parcelRequire("greay");

var $7zZyK = parcelRequire("7zZyK");

var $62TjC = parcelRequire("62TjC");

var $6wt0h = parcelRequire("6wt0h");
"use strict";
const $2208474f52659fd6$var$logger = new (0, $62TjC.Logger)((0, $6wt0h.version));
function $2208474f52659fd6$var$getChecksumAddress(address) {
    if (!(0, $7hAPV.isHexString)(address, 20)) $2208474f52659fd6$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $7hAPV.arrayify)((0, $greay.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $2208474f52659fd6$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $2208474f52659fd6$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $2208474f52659fd6$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$2208474f52659fd6$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$2208474f52659fd6$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $2208474f52659fd6$var$safeDigits = Math.floor($2208474f52659fd6$var$log10($2208474f52659fd6$var$MAX_SAFE_INTEGER));
function $2208474f52659fd6$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $2208474f52659fd6$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $2208474f52659fd6$var$safeDigits){
        let block = expanded.substring(0, $2208474f52659fd6$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $2208474f52659fd6$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $2208474f52659fd6$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $2208474f52659fd6$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $2208474f52659fd6$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $2208474f52659fd6$var$ibanChecksum(address)) $2208474f52659fd6$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $gfkzi._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $2208474f52659fd6$var$getChecksumAddress("0x" + result);
    } else $2208474f52659fd6$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $2208474f52659fd6$export$977e255126d763d6(address) {
    try {
        $2208474f52659fd6$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $2208474f52659fd6$export$962c4ddada9f668f(address) {
    let base36 = (0, $gfkzi._base16To36)($2208474f52659fd6$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $2208474f52659fd6$var$ibanChecksum("XE00" + base36) + base36;
}
function $2208474f52659fd6$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $2208474f52659fd6$export$88411125f012957a(transaction.from);
    } catch (error) {
        $2208474f52659fd6$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $7hAPV.stripZeros)((0, $7hAPV.arrayify)((0, $gfkzi.BigNumber).from(transaction.nonce).toHexString()));
    return $2208474f52659fd6$export$88411125f012957a((0, $7hAPV.hexDataSlice)((0, $greay.keccak256)((0, $7zZyK.encode)([
        from,
        nonce
    ])), 12));
}
function $2208474f52659fd6$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $7hAPV.hexDataLength)(salt) !== 32) $2208474f52659fd6$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $7hAPV.hexDataLength)(initCodeHash) !== 32) $2208474f52659fd6$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $2208474f52659fd6$export$88411125f012957a((0, $7hAPV.hexDataSlice)((0, $greay.keccak256)((0, $7hAPV.concat)([
        "0xff",
        $2208474f52659fd6$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRequire.register("7zZyK", function(module, exports) {

$parcel$export(module.exports, "encode", () => $584b8db52926c91c$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $584b8db52926c91c$export$2f872c0f2117be69);

var $7hAPV = parcelRequire("7hAPV");

var $62TjC = parcelRequire("62TjC");

var $9Lkhf = parcelRequire("9Lkhf");
"use strict";
const $584b8db52926c91c$var$logger = new (0, $62TjC.Logger)((0, $9Lkhf.version));
function $584b8db52926c91c$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $584b8db52926c91c$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $584b8db52926c91c$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($584b8db52926c91c$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $584b8db52926c91c$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $7hAPV.isBytesLike)(object)) $584b8db52926c91c$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $7hAPV.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $584b8db52926c91c$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $584b8db52926c91c$export$c564cdbbe6da493(object) {
    return (0, $7hAPV.hexlify)($584b8db52926c91c$var$_encode(object));
}
function $584b8db52926c91c$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $584b8db52926c91c$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $584b8db52926c91c$var$logger.throwError("child data too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $584b8db52926c91c$var$_decode(data, offset) {
    if (data.length === 0) $584b8db52926c91c$var$logger.throwError("data too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $584b8db52926c91c$var$logger.throwError("data short segment too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        const length = $584b8db52926c91c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $584b8db52926c91c$var$logger.throwError("data long segment too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        return $584b8db52926c91c$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $584b8db52926c91c$var$logger.throwError("data array too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        return $584b8db52926c91c$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $584b8db52926c91c$var$logger.throwError("data array too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        const length = $584b8db52926c91c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $584b8db52926c91c$var$logger.throwError("data array too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $7hAPV.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $584b8db52926c91c$var$logger.throwError("data too short", (0, $62TjC.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $7hAPV.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $7hAPV.hexlify)(data[offset])
    };
}
function $584b8db52926c91c$export$2f872c0f2117be69(data) {
    const bytes = (0, $7hAPV.arrayify)(data);
    const decoded = $584b8db52926c91c$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $584b8db52926c91c$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRequire.register("9Lkhf", function(module, exports) {

$parcel$export(module.exports, "version", () => $71b83b79bf5e1918$export$83d89fbfd8236492);
const $71b83b79bf5e1918$export$83d89fbfd8236492 = "rlp/5.6.1";

});


parcelRequire.register("6wt0h", function(module, exports) {

$parcel$export(module.exports, "version", () => $4bfc3abac2314156$export$83d89fbfd8236492);
const $4bfc3abac2314156$export$83d89fbfd8236492 = "address/5.6.1";

});


parcelRequire.register("5f20y", function(module, exports) {

$parcel$export(module.exports, "AddressZero", () => $3d0fe92d83a02e66$export$badd13187c087617);
const $3d0fe92d83a02e66$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRequire.register("aNGBw", function(module, exports) {

$parcel$export(module.exports, "accessListify", () => $7dcf874ea1eb7aa1$export$6c8662b1600dce2);
$parcel$export(module.exports, "parse", () => $7dcf874ea1eb7aa1$export$98e6a39c04603d36);

var $2V9vq = parcelRequire("2V9vq");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $eMYiV = parcelRequire("eMYiV");

var $greay = parcelRequire("greay");

var $e72ut = parcelRequire("e72ut");

var $7zZyK = parcelRequire("7zZyK");

var $dkfJD = parcelRequire("dkfJD");

var $62TjC = parcelRequire("62TjC");

var $c9RQP = parcelRequire("c9RQP");
"use strict";
const $7dcf874ea1eb7aa1$var$logger = new (0, $62TjC.Logger)((0, $c9RQP.version));
var $7dcf874ea1eb7aa1$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($7dcf874ea1eb7aa1$export$80349e05e0724e11 || ($7dcf874ea1eb7aa1$export$80349e05e0724e11 = {}));
///////////////////////////////
function $7dcf874ea1eb7aa1$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $2V9vq.getAddress)(value);
}
function $7dcf874ea1eb7aa1$var$handleNumber(value) {
    if (value === "0x") return 0, $eMYiV.Zero;
    return (0, $gfkzi.BigNumber).from(value);
}
// Legacy Transaction Fields
const $7dcf874ea1eb7aa1$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $7dcf874ea1eb7aa1$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $7dcf874ea1eb7aa1$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $dkfJD.computePublicKey)(key);
    return (0, $2V9vq.getAddress)((0, $7hAPV.hexDataSlice)((0, $greay.keccak256)((0, $7hAPV.hexDataSlice)(publicKey, 1)), 12));
}
function $7dcf874ea1eb7aa1$export$23cc18f96d8510e2(digest, signature) {
    return $7dcf874ea1eb7aa1$export$e67e2732ba9803f9((0, $dkfJD.recoverPublicKey)((0, $7hAPV.arrayify)(digest), signature));
}
function $7dcf874ea1eb7aa1$var$formatNumber(value, name) {
    const result = (0, $7hAPV.stripZeros)((0, $gfkzi.BigNumber).from(value).toHexString());
    if (result.length > 32) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $7dcf874ea1eb7aa1$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $2V9vq.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $7hAPV.hexDataLength)(storageKey) !== 32) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $7dcf874ea1eb7aa1$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $7dcf874ea1eb7aa1$var$accessSetify(set[0], set[1]);
        }
        return $7dcf874ea1eb7aa1$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $7dcf874ea1eb7aa1$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $7dcf874ea1eb7aa1$var$formatAccessList(value) {
    return $7dcf874ea1eb7aa1$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $7dcf874ea1eb7aa1$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $gfkzi.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $gfkzi.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.chainId || 0, "chainId"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.nonce || 0, "nonce"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $2V9vq.getAddress)(transaction.to) : "0x",
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $7dcf874ea1eb7aa1$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7hAPV.splitSignature)(signature);
        fields.push($7dcf874ea1eb7aa1$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7hAPV.stripZeros)(sig.r));
        fields.push((0, $7hAPV.stripZeros)(sig.s));
    }
    return (0, $7hAPV.hexConcat)([
        "0x02",
        $7zZyK.encode(fields)
    ]);
}
function $7dcf874ea1eb7aa1$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.chainId || 0, "chainId"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.nonce || 0, "nonce"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $2V9vq.getAddress)(transaction.to) : "0x",
        $7dcf874ea1eb7aa1$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $7dcf874ea1eb7aa1$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7hAPV.splitSignature)(signature);
        fields.push($7dcf874ea1eb7aa1$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7hAPV.stripZeros)(sig.r));
        fields.push((0, $7hAPV.stripZeros)(sig.s));
    }
    return (0, $7hAPV.hexConcat)([
        "0x01",
        $7zZyK.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $7dcf874ea1eb7aa1$var$_serialize(transaction, signature) {
    (0, $e72ut.checkProperties)(transaction, $7dcf874ea1eb7aa1$var$allowedTransactionKeys);
    const raw = [];
    $7dcf874ea1eb7aa1$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $7hAPV.arrayify)((0, $7hAPV.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $7hAPV.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $7hAPV.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $7hAPV.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $7hAPV.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $7zZyK.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $7hAPV.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $7hAPV.hexlify)(v));
    raw.push((0, $7hAPV.stripZeros)((0, $7hAPV.arrayify)(sig.r)));
    raw.push((0, $7hAPV.stripZeros)((0, $7hAPV.arrayify)(sig.s)));
    return $7zZyK.encode(raw);
}
function $7dcf874ea1eb7aa1$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $7dcf874ea1eb7aa1$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $7dcf874ea1eb7aa1$var$_serializeEip2930(transaction, signature);
        case 2:
            return $7dcf874ea1eb7aa1$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $7dcf874ea1eb7aa1$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $7dcf874ea1eb7aa1$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $7dcf874ea1eb7aa1$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $7hAPV.hexZeroPad)(fields[1], 32);
    tx.s = (0, $7hAPV.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $greay.keccak256)(serialize(tx));
        tx.from = $7dcf874ea1eb7aa1$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $7dcf874ea1eb7aa1$var$_parseEip1559(payload) {
    const transaction = $7zZyK.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $7hAPV.hexlify)(payload));
    const maxPriorityFeePerGas = $7dcf874ea1eb7aa1$var$handleNumber(transaction[2]);
    const maxFeePerGas = $7dcf874ea1eb7aa1$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $7dcf874ea1eb7aa1$var$handleNumber(transaction[0]).toNumber(),
        nonce: $7dcf874ea1eb7aa1$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $7dcf874ea1eb7aa1$var$handleNumber(transaction[4]),
        to: $7dcf874ea1eb7aa1$var$handleAddress(transaction[5]),
        value: $7dcf874ea1eb7aa1$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $7dcf874ea1eb7aa1$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $greay.keccak256)(payload);
    $7dcf874ea1eb7aa1$var$_parseEipSignature(tx, transaction.slice(9), $7dcf874ea1eb7aa1$var$_serializeEip1559);
    return tx;
}
function $7dcf874ea1eb7aa1$var$_parseEip2930(payload) {
    const transaction = $7zZyK.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $7hAPV.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $7dcf874ea1eb7aa1$var$handleNumber(transaction[0]).toNumber(),
        nonce: $7dcf874ea1eb7aa1$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $7dcf874ea1eb7aa1$var$handleNumber(transaction[2]),
        gasLimit: $7dcf874ea1eb7aa1$var$handleNumber(transaction[3]),
        to: $7dcf874ea1eb7aa1$var$handleAddress(transaction[4]),
        value: $7dcf874ea1eb7aa1$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $7dcf874ea1eb7aa1$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $greay.keccak256)(payload);
    $7dcf874ea1eb7aa1$var$_parseEipSignature(tx, transaction.slice(8), $7dcf874ea1eb7aa1$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $7dcf874ea1eb7aa1$var$_parse(rawTransaction) {
    const transaction = $7zZyK.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $7dcf874ea1eb7aa1$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $7dcf874ea1eb7aa1$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $7dcf874ea1eb7aa1$var$handleNumber(transaction[1]),
        gasLimit: $7dcf874ea1eb7aa1$var$handleNumber(transaction[2]),
        to: $7dcf874ea1eb7aa1$var$handleAddress(transaction[3]),
        value: $7dcf874ea1eb7aa1$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $gfkzi.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $7hAPV.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $7hAPV.hexZeroPad)(transaction[8], 32);
    if ((0, $gfkzi.BigNumber).from(tx.r).isZero() && (0, $gfkzi.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $7hAPV.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $greay.keccak256)($7zZyK.encode(raw));
        try {
            tx.from = $7dcf874ea1eb7aa1$export$23cc18f96d8510e2(digest, {
                r: (0, $7hAPV.hexlify)(tx.r),
                s: (0, $7hAPV.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $greay.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $7dcf874ea1eb7aa1$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $7hAPV.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $7dcf874ea1eb7aa1$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $7dcf874ea1eb7aa1$var$_parseEip2930(payload);
        case 2:
            return $7dcf874ea1eb7aa1$var$_parseEip1559(payload);
        default:
            break;
    }
    return $7dcf874ea1eb7aa1$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRequire.register("eMYiV", function(module, exports) {

$parcel$export(module.exports, "Zero", () => $ac44538801f1a163$export$aaef8a3eae948f03);

var $gfkzi = parcelRequire("gfkzi");
const $ac44538801f1a163$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $gfkzi.BigNumber).from(-1);
const $ac44538801f1a163$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $gfkzi.BigNumber).from(0);
const $ac44538801f1a163$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $gfkzi.BigNumber).from(1);
const $ac44538801f1a163$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $gfkzi.BigNumber).from(2);
const $ac44538801f1a163$export$c8db55bd7405209e = /*#__PURE__*/ (0, $gfkzi.BigNumber).from("1000000000000000000");
const $ac44538801f1a163$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $gfkzi.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $ac44538801f1a163$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $gfkzi.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $ac44538801f1a163$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $gfkzi.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});

parcelRequire.register("dkfJD", function(module, exports) {

$parcel$export(module.exports, "computePublicKey", () => $9b395946b9c5eaac$export$4a89473d39301224);
$parcel$export(module.exports, "recoverPublicKey", () => $9b395946b9c5eaac$export$952dd09fbe0232b7);

var $dkEwa = parcelRequire("dkEwa");

var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $bK1t8 = parcelRequire("bK1t8");
"use strict";
const $9b395946b9c5eaac$var$logger = new (0, $62TjC.Logger)((0, $bK1t8.version));
let $9b395946b9c5eaac$var$_curve = null;
function $9b395946b9c5eaac$var$getCurve() {
    if (!$9b395946b9c5eaac$var$_curve) $9b395946b9c5eaac$var$_curve = new (0, $dkEwa.EC)("secp256k1");
    return $9b395946b9c5eaac$var$_curve;
}
class $9b395946b9c5eaac$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $e72ut.defineReadOnly)(this, "curve", "secp256k1");
        (0, $e72ut.defineReadOnly)(this, "privateKey", (0, $7hAPV.hexlify)(privateKey));
        if ((0, $7hAPV.hexDataLength)(this.privateKey) !== 32) $9b395946b9c5eaac$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $9b395946b9c5eaac$var$getCurve().keyFromPrivate((0, $7hAPV.arrayify)(this.privateKey));
        (0, $e72ut.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $e72ut.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $e72ut.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $9b395946b9c5eaac$var$getCurve().keyFromPublic((0, $7hAPV.arrayify)(this.publicKey));
        const p1 = $9b395946b9c5eaac$var$getCurve().keyFromPublic((0, $7hAPV.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $9b395946b9c5eaac$var$getCurve().keyFromPrivate((0, $7hAPV.arrayify)(this.privateKey));
        const digestBytes = (0, $7hAPV.arrayify)(digest);
        if (digestBytes.length !== 32) $9b395946b9c5eaac$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $7hAPV.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $7hAPV.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $7hAPV.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $9b395946b9c5eaac$var$getCurve().keyFromPrivate((0, $7hAPV.arrayify)(this.privateKey));
        const otherKeyPair = $9b395946b9c5eaac$var$getCurve().keyFromPublic((0, $7hAPV.arrayify)($9b395946b9c5eaac$export$4a89473d39301224(otherKey)));
        return (0, $7hAPV.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $9b395946b9c5eaac$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $7hAPV.splitSignature)(signature);
    const rs = {
        r: (0, $7hAPV.arrayify)(sig.r),
        s: (0, $7hAPV.arrayify)(sig.s)
    };
    return "0x" + $9b395946b9c5eaac$var$getCurve().recoverPubKey((0, $7hAPV.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $9b395946b9c5eaac$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $7hAPV.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $9b395946b9c5eaac$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $9b395946b9c5eaac$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $7hAPV.hexlify)(bytes);
        return "0x" + $9b395946b9c5eaac$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $7hAPV.hexlify)(bytes);
        return "0x" + $9b395946b9c5eaac$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $9b395946b9c5eaac$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRequire.register("dkEwa", function(module, exports) {

$parcel$export(module.exports, "EC", () => $9b4c9298ff0f74fa$export$129fe12d32abc311);

var $dEXSZ = parcelRequire("dEXSZ");

var $kiSKt = parcelRequire("kiSKt");
var $9b4c9298ff0f74fa$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $9b4c9298ff0f74fa$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $9b4c9298ff0f74fa$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $9b4c9298ff0f74fa$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $9b4c9298ff0f74fa$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $9b4c9298ff0f74fa$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $9b4c9298ff0f74fa$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $9b4c9298ff0f74fa$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $9b4c9298ff0f74fa$var$minimalisticAssert = $9b4c9298ff0f74fa$var$assert;
function $9b4c9298ff0f74fa$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$9b4c9298ff0f74fa$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $9b4c9298ff0f74fa$var$utils_1 = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $9b4c9298ff0f74fa$var$utils_1$1 = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $9b4c9298ff0f74fa$var$minimalisticAssert;
    utils.toArray = $9b4c9298ff0f74fa$var$utils_1.toArray;
    utils.zero2 = $9b4c9298ff0f74fa$var$utils_1.zero2;
    utils.toHex = $9b4c9298ff0f74fa$var$utils_1.toHex;
    utils.encode = $9b4c9298ff0f74fa$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $9b4c9298ff0f74fa$var$getNAF = $9b4c9298ff0f74fa$var$utils_1$1.getNAF;
var $9b4c9298ff0f74fa$var$getJSF = $9b4c9298ff0f74fa$var$utils_1$1.getJSF;
var $9b4c9298ff0f74fa$var$assert$1 = $9b4c9298ff0f74fa$var$utils_1$1.assert;
function $9b4c9298ff0f74fa$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $9b4c9298ff0f74fa$var$base = $9b4c9298ff0f74fa$var$BaseCurve;
$9b4c9298ff0f74fa$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$9b4c9298ff0f74fa$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$9b4c9298ff0f74fa$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $9b4c9298ff0f74fa$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $9b4c9298ff0f74fa$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$9b4c9298ff0f74fa$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $9b4c9298ff0f74fa$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $9b4c9298ff0f74fa$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$9b4c9298ff0f74fa$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $9b4c9298ff0f74fa$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $9b4c9298ff0f74fa$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $9b4c9298ff0f74fa$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $9b4c9298ff0f74fa$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$9b4c9298ff0f74fa$var$BaseCurve.BasePoint = $9b4c9298ff0f74fa$var$BasePoint;
$9b4c9298ff0f74fa$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$9b4c9298ff0f74fa$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$9b4c9298ff0f74fa$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $9b4c9298ff0f74fa$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $9b4c9298ff0f74fa$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $9b4c9298ff0f74fa$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$9b4c9298ff0f74fa$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$9b4c9298ff0f74fa$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$9b4c9298ff0f74fa$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $9b4c9298ff0f74fa$var$utils_1$1.encode(this._encode(compact), enc);
};
$9b4c9298ff0f74fa$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$9b4c9298ff0f74fa$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$9b4c9298ff0f74fa$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$9b4c9298ff0f74fa$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$9b4c9298ff0f74fa$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$9b4c9298ff0f74fa$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $9b4c9298ff0f74fa$var$inherits_browser = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $9b4c9298ff0f74fa$var$assert$2 = $9b4c9298ff0f74fa$var$utils_1$1.assert;
function $9b4c9298ff0f74fa$var$ShortCurve(conf) {
    $9b4c9298ff0f74fa$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$9b4c9298ff0f74fa$var$inherits_browser($9b4c9298ff0f74fa$var$ShortCurve, $9b4c9298ff0f74fa$var$base);
var $9b4c9298ff0f74fa$var$short_1 = $9b4c9298ff0f74fa$var$ShortCurve;
$9b4c9298ff0f74fa$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $9b4c9298ff0f74fa$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $9b4c9298ff0f74fa$var$Point(curve, x, y, isRed) {
    $9b4c9298ff0f74fa$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$9b4c9298ff0f74fa$var$inherits_browser($9b4c9298ff0f74fa$var$Point, $9b4c9298ff0f74fa$var$base.BasePoint);
$9b4c9298ff0f74fa$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $9b4c9298ff0f74fa$var$Point(this, x, y, isRed);
};
$9b4c9298ff0f74fa$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $9b4c9298ff0f74fa$var$Point.fromJSON(this, obj, red);
};
$9b4c9298ff0f74fa$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$9b4c9298ff0f74fa$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$9b4c9298ff0f74fa$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$9b4c9298ff0f74fa$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$9b4c9298ff0f74fa$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$9b4c9298ff0f74fa$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$9b4c9298ff0f74fa$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$9b4c9298ff0f74fa$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$9b4c9298ff0f74fa$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$9b4c9298ff0f74fa$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$9b4c9298ff0f74fa$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$9b4c9298ff0f74fa$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$9b4c9298ff0f74fa$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$9b4c9298ff0f74fa$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$9b4c9298ff0f74fa$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $9b4c9298ff0f74fa$var$JPoint(curve, x, y, z) {
    $9b4c9298ff0f74fa$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$9b4c9298ff0f74fa$var$inherits_browser($9b4c9298ff0f74fa$var$JPoint, $9b4c9298ff0f74fa$var$base.BasePoint);
$9b4c9298ff0f74fa$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $9b4c9298ff0f74fa$var$JPoint(this, x, y, z);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$9b4c9298ff0f74fa$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$9b4c9298ff0f74fa$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$9b4c9298ff0f74fa$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$9b4c9298ff0f74fa$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$9b4c9298ff0f74fa$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $9b4c9298ff0f74fa$var$curve_1 = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $9b4c9298ff0f74fa$var$base;
    curve.short = $9b4c9298ff0f74fa$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $9b4c9298ff0f74fa$var$curves_1 = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $9b4c9298ff0f74fa$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $9b4c9298ff0f74fa$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $9b4c9298ff0f74fa$var$curve_1.edwards(options);
        else this.curve = new $9b4c9298ff0f74fa$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $9b4c9298ff0f74fa$var$HmacDRBG(options) {
    if (!(this instanceof $9b4c9298ff0f74fa$var$HmacDRBG)) return new $9b4c9298ff0f74fa$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $9b4c9298ff0f74fa$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $9b4c9298ff0f74fa$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $9b4c9298ff0f74fa$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $9b4c9298ff0f74fa$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $9b4c9298ff0f74fa$var$hmacDrbg = $9b4c9298ff0f74fa$var$HmacDRBG;
$9b4c9298ff0f74fa$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$9b4c9298ff0f74fa$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$9b4c9298ff0f74fa$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$9b4c9298ff0f74fa$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $9b4c9298ff0f74fa$var$utils_1.toArray(entropy, entropyEnc);
    add = $9b4c9298ff0f74fa$var$utils_1.toArray(add, addEnc);
    $9b4c9298ff0f74fa$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$9b4c9298ff0f74fa$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $9b4c9298ff0f74fa$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $9b4c9298ff0f74fa$var$utils_1.encode(res, enc);
};
"use strict";
var $9b4c9298ff0f74fa$var$assert$3 = $9b4c9298ff0f74fa$var$utils_1$1.assert;
function $9b4c9298ff0f74fa$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $9b4c9298ff0f74fa$var$key = $9b4c9298ff0f74fa$var$KeyPair;
$9b4c9298ff0f74fa$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $9b4c9298ff0f74fa$var$KeyPair) return pub;
    return new $9b4c9298ff0f74fa$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$9b4c9298ff0f74fa$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $9b4c9298ff0f74fa$var$KeyPair) return priv;
    return new $9b4c9298ff0f74fa$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$9b4c9298ff0f74fa$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$9b4c9298ff0f74fa$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$9b4c9298ff0f74fa$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$9b4c9298ff0f74fa$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$9b4c9298ff0f74fa$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $9b4c9298ff0f74fa$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $9b4c9298ff0f74fa$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$9b4c9298ff0f74fa$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $9b4c9298ff0f74fa$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$9b4c9298ff0f74fa$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$9b4c9298ff0f74fa$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$9b4c9298ff0f74fa$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $9b4c9298ff0f74fa$var$assert$4 = $9b4c9298ff0f74fa$var$utils_1$1.assert;
function $9b4c9298ff0f74fa$var$Signature(options, enc) {
    if (options instanceof $9b4c9298ff0f74fa$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $9b4c9298ff0f74fa$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $9b4c9298ff0f74fa$var$signature = $9b4c9298ff0f74fa$var$Signature;
function $9b4c9298ff0f74fa$var$Position() {
    this.place = 0;
}
function $9b4c9298ff0f74fa$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $9b4c9298ff0f74fa$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$9b4c9298ff0f74fa$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $9b4c9298ff0f74fa$var$utils_1$1.toArray(data, enc);
    var p = new $9b4c9298ff0f74fa$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $9b4c9298ff0f74fa$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $9b4c9298ff0f74fa$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $9b4c9298ff0f74fa$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $9b4c9298ff0f74fa$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$9b4c9298ff0f74fa$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $9b4c9298ff0f74fa$var$rmPadding(r);
    s = $9b4c9298ff0f74fa$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $9b4c9298ff0f74fa$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $9b4c9298ff0f74fa$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $9b4c9298ff0f74fa$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $9b4c9298ff0f74fa$var$utils_1$1.encode(res, enc);
};
"use strict";
var $9b4c9298ff0f74fa$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $9b4c9298ff0f74fa$var$assert$5 = $9b4c9298ff0f74fa$var$utils_1$1.assert;
function $9b4c9298ff0f74fa$var$EC(options) {
    if (!(this instanceof $9b4c9298ff0f74fa$var$EC)) return new $9b4c9298ff0f74fa$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $9b4c9298ff0f74fa$var$assert$5(Object.prototype.hasOwnProperty.call($9b4c9298ff0f74fa$var$curves_1, options), "Unknown curve " + options);
        options = $9b4c9298ff0f74fa$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $9b4c9298ff0f74fa$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $9b4c9298ff0f74fa$var$ec = $9b4c9298ff0f74fa$var$EC;
$9b4c9298ff0f74fa$var$EC.prototype.keyPair = function keyPair(options) {
    return new $9b4c9298ff0f74fa$var$key(this, options);
};
$9b4c9298ff0f74fa$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $9b4c9298ff0f74fa$var$key.fromPrivate(this, priv, enc);
};
$9b4c9298ff0f74fa$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $9b4c9298ff0f74fa$var$key.fromPublic(this, pub, enc);
};
$9b4c9298ff0f74fa$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $9b4c9298ff0f74fa$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9b4c9298ff0f74fa$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$9b4c9298ff0f74fa$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$9b4c9298ff0f74fa$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $9b4c9298ff0f74fa$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $9b4c9298ff0f74fa$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$9b4c9298ff0f74fa$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $9b4c9298ff0f74fa$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$9b4c9298ff0f74fa$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $9b4c9298ff0f74fa$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $9b4c9298ff0f74fa$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$9b4c9298ff0f74fa$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $9b4c9298ff0f74fa$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $9b4c9298ff0f74fa$var$elliptic_1 = $9b4c9298ff0f74fa$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $9b4c9298ff0f74fa$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $9b4c9298ff0f74fa$var$curve_1;
    elliptic.curves = $9b4c9298ff0f74fa$var$curves_1;
    // Protocols
    elliptic.ec = $9b4c9298ff0f74fa$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $9b4c9298ff0f74fa$export$129fe12d32abc311 = $9b4c9298ff0f74fa$var$elliptic_1.ec;

});

parcelRequire.register("bK1t8", function(module, exports) {

$parcel$export(module.exports, "version", () => $88c5214cea6e62ff$export$83d89fbfd8236492);
const $88c5214cea6e62ff$export$83d89fbfd8236492 = "signing-key/5.6.2";

});


parcelRequire.register("c9RQP", function(module, exports) {

$parcel$export(module.exports, "version", () => $8da018fcfa2636c9$export$83d89fbfd8236492);
const $8da018fcfa2636c9$export$83d89fbfd8236492 = "transactions/5.6.2";

});




parcelRequire.register("k1QbV", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", () => $e94c62bb842b5925$export$f6c13301c7b76371);
$parcel$export(module.exports, "AlchemyProvider", () => $e94c62bb842b5925$export$999cc40da3fbc6f);

var $e72ut = parcelRequire("e72ut");

var $iVjdI = parcelRequire("iVjdI");

var $kQ2qk = parcelRequire("kQ2qk");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $b0LZy = parcelRequire("b0LZy");
"use strict";
const $e94c62bb842b5925$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $e94c62bb842b5925$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $e94c62bb842b5925$export$f6c13301c7b76371 extends (0, $kQ2qk.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $e94c62bb842b5925$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $e72ut.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}
class $e94c62bb842b5925$export$999cc40da3fbc6f extends (0, $b0LZy.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $e94c62bb842b5925$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $e94c62bb842b5925$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $e94c62bb842b5925$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "ropsten":
                host = "eth-ropsten.alchemyapi.io/v2/";
                break;
            case "rinkeby":
                host = "eth-rinkeby.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.alchemyapi.io/v2/";
                break;
            case "kovan":
                host = "eth-kovan.alchemyapi.io/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-rinkeby":
                host = "arb-rinkeby.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-kovan":
                host = "opt-kovan.g.alchemy.com/v2/";
                break;
            default:
                $e94c62bb842b5925$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $e94c62bb842b5925$var$defaultApiKey) (0, $iVjdI.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}

});
parcelRequire.register("kQ2qk", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", () => $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd);

var $gfkzi = parcelRequire("gfkzi");

var $e72ut = parcelRequire("e72ut");

var $jviUl = parcelRequire("jviUl");

var $gELTB = parcelRequire("gELTB");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
var $f2ba8b3ea7dcf3ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f2ba8b3ea7dcf3ca$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $f2ba8b3ea7dcf3ca$var$NextId = 1;
class $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd extends (0, $jviUl.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $f2ba8b3ea7dcf3ca$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $e72ut.defineReadOnly)(this, "_websocket", new (0, $gELTB.WebSocket)(this.connection.url));
        else (0, $e72ut.defineReadOnly)(this, "_websocket", url);
        (0, $e72ut.defineReadOnly)(this, "_requests", {});
        (0, $e72ut.defineReadOnly)(this, "_subs", {});
        (0, $e72ut.defineReadOnly)(this, "_subIds", {});
        (0, $e72ut.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $e72ut.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $e72ut.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $f2ba8b3ea7dcf3ca$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $gfkzi.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $gELTB.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}

});
parcelRequire.register("jviUl", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", () => $e32f9441afb0a406$export$5f7b5fca3508545a);
$parcel$export(module.exports, "JsonRpcProvider", () => $e32f9441afb0a406$export$da28308012bf6748);

var $j7x7T = parcelRequire("j7x7T");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $aMibb = parcelRequire("aMibb");

var $e72ut = parcelRequire("e72ut");

var $ky3VX = parcelRequire("ky3VX");

var $aNGBw = parcelRequire("aNGBw");

var $je7da = parcelRequire("je7da");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $5PrHs = parcelRequire("5PrHs");
"use strict";
var $e32f9441afb0a406$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e32f9441afb0a406$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
const $e32f9441afb0a406$var$errorGas = [
    "call",
    "estimateGas"
];
function $e32f9441afb0a406$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $7hAPV.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $e32f9441afb0a406$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $e32f9441afb0a406$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $e32f9441afb0a406$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $e32f9441afb0a406$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $e32f9441afb0a406$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $e32f9441afb0a406$var$spelunk(error.body, false);
        if (result == null) result = $e32f9441afb0a406$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $62TjC.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $62TjC.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit/i)) $e32f9441afb0a406$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $62TjC.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $e32f9441afb0a406$var$logger.throwError("nonce has already been used", (0, $62TjC.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $e32f9441afb0a406$var$logger.throwError("replacement fee too low", (0, $62TjC.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $e32f9441afb0a406$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($e32f9441afb0a406$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted/)) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $62TjC.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $e32f9441afb0a406$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $e32f9441afb0a406$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $e32f9441afb0a406$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $e32f9441afb0a406$var$_constructorGuard = {};
class $e32f9441afb0a406$export$5f7b5fca3508545a extends (0, $j7x7T.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $e32f9441afb0a406$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $e72ut.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $e72ut.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $e72ut.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $e72ut.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $e72ut.defineReadOnly)(this, "_address", null);
        } else $e32f9441afb0a406$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $e32f9441afb0a406$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $e32f9441afb0a406$var$UncheckedJsonRpcSigner($e32f9441afb0a406$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $e32f9441afb0a406$var$logger.throwError("unknown account #" + this._index, (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $e72ut.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $e72ut.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $e32f9441afb0a406$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $e72ut.resolveProperties)({
            tx: (0, $e72ut.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $e32f9441afb0a406$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                return $e32f9441afb0a406$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $e32f9441afb0a406$var$logger.throwError("signing transactions is unsupported", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $je7da.poll)(()=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $ky3VX.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            return yield this.provider.send("personal_sign", [
                (0, $7hAPV.hexlify)(data),
                address.toLowerCase()
            ]);
        });
    }
    _legacySignMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $ky3VX.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
            return yield this.provider.send("eth_sign", [
                address.toLowerCase(),
                (0, $7hAPV.hexlify)(data)
            ]);
        });
    }
    _signTypedData(domain, types, value) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $aMibb.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            return yield this.provider.send("eth_signTypedData_v4", [
                address.toLowerCase(),
                JSON.stringify((0, $aMibb.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
            ]);
        });
    }
    unlock(password) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $e32f9441afb0a406$var$UncheckedJsonRpcSigner extends $e32f9441afb0a406$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $e32f9441afb0a406$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $e32f9441afb0a406$export$da28308012bf6748 extends (0, $5PrHs.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $e72ut.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $e72ut.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $e72ut.defineReadOnly)(this, "connection", Object.freeze((0, $e72ut.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            yield $e32f9441afb0a406$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $e72ut.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $gfkzi.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $62TjC.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $62TjC.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $e32f9441afb0a406$export$5f7b5fca3508545a($e32f9441afb0a406$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $e72ut.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $je7da.fetchJson)(this.connection, JSON.stringify(request), $e32f9441afb0a406$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        (0, $7hAPV.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $e72ut.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $e72ut.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $e32f9441afb0a406$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $gfkzi.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $e72ut.shallowCopy)(params);
                            params.transaction = (0, $e72ut.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $e32f9441afb0a406$var$logger.throwError(method + " not implemented", (0, $62TjC.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $e32f9441afb0a406$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $e32f9441afb0a406$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $e72ut.shallowCopy)($e32f9441afb0a406$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $e72ut.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $7hAPV.hexValue)((0, $gfkzi.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $7hAPV.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $aNGBw.accessListify)(transaction.accessList);
        return result;
    }
}

});
parcelRequire.register("j7x7T", function(module, exports) {

$parcel$export(module.exports, "Signer", () => $deb85df20e19ba32$export$fdf54fdde81cc9f0);
$parcel$export(module.exports, "VoidSigner", () => $deb85df20e19ba32$export$7dbc56d9b9612bad);

var $e72ut = parcelRequire("e72ut");

var $czury = parcelRequire("czury");

var $2FBHa = parcelRequire("2FBHa");
"use strict";
var $deb85df20e19ba32$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $deb85df20e19ba32$var$logger = new (0, $czury.Logger)((0, $2FBHa.version));
const $deb85df20e19ba32$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $deb85df20e19ba32$var$forwardErrors = [
    (0, $czury.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $czury.Logger).errors.NONCE_EXPIRED,
    (0, $czury.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $deb85df20e19ba32$var$logger.checkAbstract(new.target, $deb85df20e19ba32$export$fdf54fdde81cc9f0);
        (0, $e72ut.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $e72ut.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $e72ut.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($deb85df20e19ba32$var$allowedTransactionKeys.indexOf(key) === -1) $deb85df20e19ba32$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $e72ut.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $deb85df20e19ba32$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $e72ut.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $deb85df20e19ba32$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $deb85df20e19ba32$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $deb85df20e19ba32$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $deb85df20e19ba32$var$logger.throwError("network does not support EIP-1559", (0, $czury.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $deb85df20e19ba32$var$logger.throwError("failed to get consistent fee data", (0, $czury.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($deb85df20e19ba32$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $deb85df20e19ba32$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $czury.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $deb85df20e19ba32$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $e72ut.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $deb85df20e19ba32$var$logger.throwError("missing provider", (0, $czury.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $deb85df20e19ba32$export$7dbc56d9b9612bad extends $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $e72ut.defineReadOnly)(this, "address", address);
        (0, $e72ut.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $deb85df20e19ba32$var$logger.throwError(message, (0, $czury.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $deb85df20e19ba32$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRequire.register("czury", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $92705e5efb192c07$export$efa9a398d6368992);

var $7gzEz = parcelRequire("7gzEz");
"use strict";
let $92705e5efb192c07$var$_permanentCensorErrors = false;
let $92705e5efb192c07$var$_censorErrors = false;
const $92705e5efb192c07$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $92705e5efb192c07$var$_logLevel = $92705e5efb192c07$var$LogLevels["default"];
let $92705e5efb192c07$var$_globalLogger = null;
function $92705e5efb192c07$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $92705e5efb192c07$var$_normalizeError = $92705e5efb192c07$var$_checkNormalize();
var $92705e5efb192c07$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($92705e5efb192c07$export$243e62d78d3b544d || ($92705e5efb192c07$export$243e62d78d3b544d = {}));
var $92705e5efb192c07$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($92705e5efb192c07$export$d4e71bc0b80dc0fb || ($92705e5efb192c07$export$d4e71bc0b80dc0fb = {}));
const $92705e5efb192c07$var$HEX = "0123456789abcdef";
class $92705e5efb192c07$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($92705e5efb192c07$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($92705e5efb192c07$var$_logLevel > $92705e5efb192c07$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($92705e5efb192c07$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($92705e5efb192c07$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($92705e5efb192c07$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($92705e5efb192c07$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $92705e5efb192c07$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $92705e5efb192c07$var$HEX[value[i] >> 4];
                        hex += $92705e5efb192c07$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $92705e5efb192c07$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $92705e5efb192c07$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($92705e5efb192c07$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $92705e5efb192c07$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $92705e5efb192c07$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $92705e5efb192c07$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $92705e5efb192c07$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $92705e5efb192c07$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $92705e5efb192c07$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $92705e5efb192c07$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $92705e5efb192c07$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $92705e5efb192c07$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$92705e5efb192c07$var$_globalLogger) $92705e5efb192c07$var$_globalLogger = new $92705e5efb192c07$export$efa9a398d6368992((0, $7gzEz.version));
        return $92705e5efb192c07$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $92705e5efb192c07$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($92705e5efb192c07$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $92705e5efb192c07$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $92705e5efb192c07$var$_censorErrors = !!censorship;
        $92705e5efb192c07$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $92705e5efb192c07$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $92705e5efb192c07$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $92705e5efb192c07$var$_logLevel = level;
    }
    static from(version) {
        return new $92705e5efb192c07$export$efa9a398d6368992(version);
    }
}
$92705e5efb192c07$export$efa9a398d6368992.errors = $92705e5efb192c07$export$d4e71bc0b80dc0fb;
$92705e5efb192c07$export$efa9a398d6368992.levels = $92705e5efb192c07$export$243e62d78d3b544d;

});
parcelRequire.register("7gzEz", function(module, exports) {

$parcel$export(module.exports, "version", () => $54a5af0f934fd114$export$83d89fbfd8236492);
const $54a5af0f934fd114$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("2FBHa", function(module, exports) {

$parcel$export(module.exports, "version", () => $1f1ca693564f9708$export$83d89fbfd8236492);
const $1f1ca693564f9708$export$83d89fbfd8236492 = "abstract-signer/5.6.2";

});


parcelRequire.register("aMibb", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", () => $7d8c7d18f8a6761c$export$458ab927ae635c3);

var $2V9vq = parcelRequire("2V9vq");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $greay = parcelRequire("greay");

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $5Ok1g = parcelRequire("5Ok1g");

var $aQiTy = parcelRequire("aQiTy");
var $7d8c7d18f8a6761c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7d8c7d18f8a6761c$var$logger = new (0, $62TjC.Logger)((0, $5Ok1g.version));
const $7d8c7d18f8a6761c$var$padding = new Uint8Array(32);
$7d8c7d18f8a6761c$var$padding.fill(0);
const $7d8c7d18f8a6761c$var$NegativeOne = (0, $gfkzi.BigNumber).from(-1);
const $7d8c7d18f8a6761c$var$Zero = (0, $gfkzi.BigNumber).from(0);
const $7d8c7d18f8a6761c$var$One = (0, $gfkzi.BigNumber).from(1);
const $7d8c7d18f8a6761c$var$MaxUint256 = (0, $gfkzi.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $7d8c7d18f8a6761c$var$hexPadRight(value) {
    const bytes = (0, $7hAPV.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $7hAPV.hexConcat)([
        bytes,
        $7d8c7d18f8a6761c$var$padding.slice(padOffset)
    ]);
    return (0, $7hAPV.hexlify)(bytes);
}
const $7d8c7d18f8a6761c$var$hexTrue = (0, $7hAPV.hexZeroPad)($7d8c7d18f8a6761c$var$One.toHexString(), 32);
const $7d8c7d18f8a6761c$var$hexFalse = (0, $7hAPV.hexZeroPad)($7d8c7d18f8a6761c$var$Zero.toHexString(), 32);
const $7d8c7d18f8a6761c$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $7d8c7d18f8a6761c$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $7d8c7d18f8a6761c$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $7d8c7d18f8a6761c$var$domainChecks = {
    name: $7d8c7d18f8a6761c$var$checkString("name"),
    version: $7d8c7d18f8a6761c$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $gfkzi.BigNumber).from(value).toString();
        } catch (error) {}
        return $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $2V9vq.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $7hAPV.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $7hAPV.hexlify)(bytes);
        } catch (error) {}
        return $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $7d8c7d18f8a6761c$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $7d8c7d18f8a6761c$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $7d8c7d18f8a6761c$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($7d8c7d18f8a6761c$var$One).mul($7d8c7d18f8a6761c$var$NegativeOne) : $7d8c7d18f8a6761c$var$Zero;
            return function(value) {
                const v = (0, $gfkzi.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $7hAPV.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $7d8c7d18f8a6761c$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $7hAPV.arrayify)(value);
                if (bytes.length !== width) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $7d8c7d18f8a6761c$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $7hAPV.hexZeroPad)((0, $2V9vq.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $7d8c7d18f8a6761c$var$hexFalse : $7d8c7d18f8a6761c$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $greay.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $aQiTy.id)(value);
            };
    }
    return null;
}
function $7d8c7d18f8a6761c$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $7d8c7d18f8a6761c$export$458ab927ae635c3 {
    constructor(types){
        (0, $e72ut.defineReadOnly)(this, "types", Object.freeze((0, $e72ut.deepCopy)(types)));
        (0, $e72ut.defineReadOnly)(this, "_encoderCache", {});
        (0, $e72ut.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $7d8c7d18f8a6761c$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $7d8c7d18f8a6761c$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $e72ut.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $7d8c7d18f8a6761c$var$encodeType(name, types[name]) + st.map((t)=>$7d8c7d18f8a6761c$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $7d8c7d18f8a6761c$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $7d8c7d18f8a6761c$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $greay.keccak256));
                return (0, $greay.keccak256)((0, $7hAPV.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $aQiTy.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $greay.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $7hAPV.hexConcat)(values);
            };
        }
        return $7d8c7d18f8a6761c$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $greay.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $7d8c7d18f8a6761c$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $7d8c7d18f8a6761c$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $7d8c7d18f8a6761c$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $7d8c7d18f8a6761c$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $7d8c7d18f8a6761c$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $7d8c7d18f8a6761c$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $7d8c7d18f8a6761c$var$domainFieldTypes[name];
            if (!type) $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $7d8c7d18f8a6761c$var$domainFieldNames.indexOf(a.name) - $7d8c7d18f8a6761c$var$domainFieldNames.indexOf(b.name);
        });
        return $7d8c7d18f8a6761c$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $7hAPV.hexConcat)([
            "0x1901",
            $7d8c7d18f8a6761c$export$458ab927ae635c3.hashDomain(domain),
            $7d8c7d18f8a6761c$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $greay.keccak256)($7d8c7d18f8a6761c$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $7d8c7d18f8a6761c$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $e72ut.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $7hAPV.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $7d8c7d18f8a6761c$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $7hAPV.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $7d8c7d18f8a6761c$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $7d8c7d18f8a6761c$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $7d8c7d18f8a6761c$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $7d8c7d18f8a6761c$var$domainFieldTypes[name]
            });
        });
        const encoder = $7d8c7d18f8a6761c$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $e72ut.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $7d8c7d18f8a6761c$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $7hAPV.hexlify)((0, $7hAPV.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $gfkzi.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $7d8c7d18f8a6761c$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $7d8c7d18f8a6761c$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRequire.register("aQiTy", function(module, exports) {

$parcel$export(module.exports, "id", () => $7e4d6ae11be37372$export$d560c7e4a29451c2);

var $greay = parcelRequire("greay");

var $ky3VX = parcelRequire("ky3VX");
function $7e4d6ae11be37372$export$d560c7e4a29451c2(text) {
    return (0, $greay.keccak256)((0, $ky3VX.toUtf8Bytes)(text));
}

});



parcelRequire.register("gELTB", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $c20588e763a5ccc3$export$3909fb301d3dc8c9);

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
let $c20588e763a5ccc3$export$3909fb301d3dc8c9 = null;
try {
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = WebSocket;
    if ($c20588e763a5ccc3$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $62TjC.Logger)((0, $lLH54.version));
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRequire.register("b0LZy", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", () => $8044ebfe209f61e4$export$b3d647c1c29df44d);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => $8044ebfe209f61e4$export$664128d6239ccf96);

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $jviUl = parcelRequire("jviUl");
"use strict";
var $8044ebfe209f61e4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8044ebfe209f61e4$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
class $8044ebfe209f61e4$export$b3d647c1c29df44d extends (0, $jviUl.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $8044ebfe209f61e4$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $8044ebfe209f61e4$var$logger.throwError("no network detected", (0, $62TjC.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $e72ut.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $8044ebfe209f61e4$export$664128d6239ccf96 extends $8044ebfe209f61e4$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $8044ebfe209f61e4$var$logger.checkAbstract(new.target, $8044ebfe209f61e4$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $e72ut.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $e72ut.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $e72ut.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $e72ut.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $e72ut.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $8044ebfe209f61e4$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $8044ebfe209f61e4$var$logger.throwError("API provider does not support signing", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $8044ebfe209f61e4$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $62TjC.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRequire.register("kAG8Y", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", () => $efd7dc521b26566c$export$72783b2aefa72a45);

var $iVjdI = parcelRequire("iVjdI");

var $b0LZy = parcelRequire("b0LZy");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
const $efd7dc521b26566c$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
const $efd7dc521b26566c$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $efd7dc521b26566c$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $efd7dc521b26566c$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $efd7dc521b26566c$export$72783b2aefa72a45 extends (0, $b0LZy.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $efd7dc521b26566c$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $efd7dc521b26566c$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $efd7dc521b26566c$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $efd7dc521b26566c$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $efd7dc521b26566c$var$defaultApiKey) (0, $iVjdI.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRequire.register("hFzRk", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", () => $cdd214e3d1599302$export$7113381f8f264fc0);

var $b0LZy = parcelRequire("b0LZy");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
var $cdd214e3d1599302$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cdd214e3d1599302$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
class $cdd214e3d1599302$export$7113381f8f264fc0 extends (0, $b0LZy.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $cdd214e3d1599302$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $cdd214e3d1599302$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $cdd214e3d1599302$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRequire.register("iuBVm", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", () => $d7687248e25a81ef$export$dd1d942a536c7912);

var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");

var $aNGBw = parcelRequire("aNGBw");

var $je7da = parcelRequire("je7da");

var $iVjdI = parcelRequire("iVjdI");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $5PrHs = parcelRequire("5PrHs");
"use strict";
var $d7687248e25a81ef$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d7687248e25a81ef$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
// The transaction has already been sanitized by the calls in Provider
function $d7687248e25a81ef$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $7hAPV.hexValue)((0, $7hAPV.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $aNGBw.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $7hAPV.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $d7687248e25a81ef$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || result.message != "OK") {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $d7687248e25a81ef$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $d7687248e25a81ef$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
const $d7687248e25a81ef$var$defaultApiKey = "9D13ZE7XSBTJ94N9BNJ2MA33VMAY2YPIRB";
function $d7687248e25a81ef$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $62TjC.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $7hAPV.isHexString)(data)) return data;
            $d7687248e25a81ef$var$logger.throwError("missing revert data in call exception", (0, $62TjC.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $62TjC.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $d7687248e25a81ef$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $62TjC.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $d7687248e25a81ef$var$logger.throwError("nonce has already been used", (0, $62TjC.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $d7687248e25a81ef$var$logger.throwError("replacement fee too low", (0, $62TjC.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $d7687248e25a81ef$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $62TjC.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $d7687248e25a81ef$export$dd1d942a536c7912 extends (0, $5PrHs.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $e72ut.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $e72ut.defineReadOnly)(this, "apiKey", apiKey || $d7687248e25a81ef$var$defaultApiKey);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "ropsten":
                return "https://api-ropsten.etherscan.io";
            case "rinkeby":
                return "https://api-rinkeby.etherscan.io";
            case "kovan":
                return "https://api-kovan.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            default:
        }
        return $d7687248e25a81ef$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $d7687248e25a81ef$var$getJsonResult : $d7687248e25a81ef$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $iVjdI.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $je7da.fetchJson)(connection, payloadStr, procFunc || $d7687248e25a81ef$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $e72ut.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $d7687248e25a81ef$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $d7687248e25a81ef$var$logger.throwError("unsupported topic count", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $d7687248e25a81ef$var$logger.throwError("unsupported topic format", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey === $d7687248e25a81ef$var$defaultApiKey;
    }
}

});

parcelRequire.register("1Nl15", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", () => $14eaab77c6d2e466$export$cb1d0beacb55feb7);

var $d6X7y = parcelRequire("d6X7y");

var $gfkzi = parcelRequire("gfkzi");

var $7hAPV = parcelRequire("7hAPV");

var $e72ut = parcelRequire("e72ut");

var $68S5W = parcelRequire("68S5W");

var $je7da = parcelRequire("je7da");

var $5PrHs = parcelRequire("5PrHs");

var $iVjdI = parcelRequire("iVjdI");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
var $14eaab77c6d2e466$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $14eaab77c6d2e466$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
function $14eaab77c6d2e466$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $14eaab77c6d2e466$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $14eaab77c6d2e466$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $14eaab77c6d2e466$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $14eaab77c6d2e466$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $gfkzi.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$14eaab77c6d2e466$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $14eaab77c6d2e466$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $14eaab77c6d2e466$var$nextRid = 1;
function $14eaab77c6d2e466$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $14eaab77c6d2e466$var$ForwardErrors = [
    (0, $62TjC.Logger).errors.CALL_EXCEPTION,
    (0, $62TjC.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $62TjC.Logger).errors.NONCE_EXPIRED,
    (0, $62TjC.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $62TjC.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $14eaab77c6d2e466$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $14eaab77c6d2e466$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $14eaab77c6d2e466$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $14eaab77c6d2e466$var$getProcessFunc(provider, method, params) {
    let normalize = $14eaab77c6d2e466$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $14eaab77c6d2e466$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $14eaab77c6d2e466$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $e72ut.shallowCopy)(tx);
                tx.confirmations = -1;
                return $14eaab77c6d2e466$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $e72ut.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $e72ut.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $14eaab77c6d2e466$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $14eaab77c6d2e466$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $14eaab77c6d2e466$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $14eaab77c6d2e466$var$waitForSync(config, blockNumber) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $je7da.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $7hAPV.isHexString)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $7hAPV.isHexString)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $7hAPV.isHexString)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $7hAPV.isHexString)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $7hAPV.isHexString)(filter.fromBlock) || filter.toBlock && (0, $7hAPV.isHexString)(filter.toBlock)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $14eaab77c6d2e466$var$logger.throwError("unknown method error", (0, $62TjC.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $14eaab77c6d2e466$export$cb1d0beacb55feb7 extends (0, $5PrHs.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $14eaab77c6d2e466$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $d6X7y.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $iVjdI.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $e72ut.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $iVjdI.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $14eaab77c6d2e466$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $14eaab77c6d2e466$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $14eaab77c6d2e466$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $e72ut.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $e72ut.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $14eaab77c6d2e466$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $14eaab77c6d2e466$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $68S5W.shuffled)(this.providerConfigs.map((0, $e72ut.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $14eaab77c6d2e466$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $14eaab77c6d2e466$var$nextRid++;
                    config.start = $14eaab77c6d2e466$var$now();
                    config.staller = $14eaab77c6d2e466$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $e72ut.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $e72ut.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $e72ut.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $14eaab77c6d2e466$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($14eaab77c6d2e466$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $14eaab77c6d2e466$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $14eaab77c6d2e466$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $14eaab77c6d2e466$var$logger.throwError("failed to meet quorum", (0, $62TjC.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$14eaab77c6d2e466$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRequire.register("68S5W", function(module, exports) {

$parcel$export(module.exports, "shuffled", () => $478d738b49591787$export$e6c7296801b9b341);
"use strict";
function $478d738b49591787$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRequire.register("dkCSn", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", () => $9b4b4c9da3406148$export$fbe151f90a1ece01);
"use strict";
const $9b4b4c9da3406148$export$fbe151f90a1ece01 = null;

});

parcelRequire.register("2opDo", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", () => $1be1b51d2ba5e5c5$export$dd168a807d60da4f);
$parcel$export(module.exports, "InfuraProvider", () => $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd);

var $e72ut = parcelRequire("e72ut");

var $kQ2qk = parcelRequire("kQ2qk");

var $iVjdI = parcelRequire("iVjdI");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $b0LZy = parcelRequire("b0LZy");
"use strict";
const $1be1b51d2ba5e5c5$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
const $1be1b51d2ba5e5c5$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $1be1b51d2ba5e5c5$export$dd168a807d60da4f extends (0, $kQ2qk.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $1be1b51d2ba5e5c5$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $62TjC.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $e72ut.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $e72ut.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $e72ut.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}
class $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd extends (0, $b0LZy.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $1be1b51d2ba5e5c5$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectId: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "ropsten":
                host = "ropsten.infura.io";
                break;
            case "rinkeby":
                host = "rinkeby.infura.io";
                break;
            case "kovan":
                host = "kovan.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-kovan":
                host = "optimism-kovan.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-rinkeby":
                host = "arbitrum-rinkeby.infura.io";
                break;
            default:
                $1be1b51d2ba5e5c5$var$logger.throwError("unsupported network", (0, $62TjC.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId) (0, $iVjdI.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}

});

parcelRequire.register("ewooy", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", () => $a926fa2c67f65d9a$export$5a16092bf20edf97);

var $e72ut = parcelRequire("e72ut");

var $je7da = parcelRequire("je7da");

var $jviUl = parcelRequire("jviUl");
class $a926fa2c67f65d9a$export$5a16092bf20edf97 extends (0, $jviUl.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $e72ut.deepCopy)(request),
                provider: this
            });
            return (0, $je7da.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRequire.register("iWIjv", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", () => $dcb00489ffa41a84$export$8235cbce3ce273bd);
/* istanbul ignore file */ 
var $b0LZy = parcelRequire("b0LZy");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");
"use strict";
const $dcb00489ffa41a84$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
// Special API key provided by Nodesmith for ethers.js
const $dcb00489ffa41a84$var$defaultApiKey = "ETHERS_JS_SHARED";
class $dcb00489ffa41a84$export$8235cbce3ce273bd extends (0, $b0LZy.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $dcb00489ffa41a84$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $dcb00489ffa41a84$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $dcb00489ffa41a84$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $dcb00489ffa41a84$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRequire.register("lCKhA", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", () => $fbe10c5df3b2b203$export$58bb47e42f6b092e);

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $b0LZy = parcelRequire("b0LZy");
"use strict";
const $fbe10c5df3b2b203$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
// These are load-balancer-based application IDs
const $fbe10c5df3b2b203$var$defaultApplicationIds = {
    homestead: "6004bcd10040261633ade990",
    ropsten: "6004bd4d0040261633ade991",
    rinkeby: "6004bda20040261633ade994",
    goerli: "6004bd860040261633ade992"
};
class $fbe10c5df3b2b203$export$58bb47e42f6b092e extends (0, $b0LZy.UrlJsonRpcProvider) {
    constructor(network, apiKey){
        // We need a bit of creativity in the constructor because
        // Pocket uses different default API keys based on the network
        if (apiKey == null) {
            const n = (0, $e72ut.getStatic)(new.target, "getNetwork")(network);
            if (n) {
                const applicationId = $fbe10c5df3b2b203$var$defaultApplicationIds[n.name];
                if (applicationId) apiKey = {
                    applicationId: applicationId,
                    loadBalancer: true
                };
            }
            // If there was any issue above, we don't know this network
            if (apiKey == null) $fbe10c5df3b2b203$var$logger.throwError("unsupported network", (0, $62TjC.Logger).errors.INVALID_ARGUMENT, {
                argument: "network",
                value: network
            });
        }
        super(network, apiKey);
    }
    static getApiKey(apiKey) {
        // Most API Providers allow null to get the default configuration, but
        // Pocket requires the network to decide the default provider, so we
        // rely on hijacking the constructor to add a sensible default for us
        if (apiKey == null) $fbe10c5df3b2b203$var$logger.throwArgumentError("PocketProvider.getApiKey does not support null apiKey", "apiKey", apiKey);
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: false,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            $fbe10c5df3b2b203$var$logger.assertArgument(typeof apiKey.applicationId === "string", "applicationSecretKey requires an applicationId", "applicationId", apiKey.applicationId);
            $fbe10c5df3b2b203$var$logger.assertArgument(typeof apiKey.applicationSecretKey === "string", "invalid applicationSecretKey", "applicationSecretKey", "[REDACTED]");
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
            apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
        } else if (apiKey.applicationId) {
            $fbe10c5df3b2b203$var$logger.assertArgument(typeof apiKey.applicationId === "string", "apiKey.applicationId must be a string", "apiKey.applicationId", apiKey.applicationId);
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
        } else $fbe10c5df3b2b203$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            default:
                $fbe10c5df3b2b203$var$logger.throwError("unsupported network", (0, $62TjC.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        let url = null;
        if (apiKey.loadBalancer) url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        else url = `https:/\/${host}/v1/${apiKey.applicationId}`;
        const connection = {
            url: url
        };
        // Initialize empty headers
        connection.headers = {};
        // Apply application secret key
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $fbe10c5df3b2b203$var$defaultApplicationIds[this.network.name];
    }
}

});

parcelRequire.register("hat2t", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", () => $c7f9e560d629e6df$export$d05096c9fd9d936d);

var $e72ut = parcelRequire("e72ut");

var $62TjC = parcelRequire("62TjC");

var $lLH54 = parcelRequire("lLH54");

var $jviUl = parcelRequire("jviUl");
"use strict";
const $c7f9e560d629e6df$var$logger = new (0, $62TjC.Logger)((0, $lLH54.version));
let $c7f9e560d629e6df$var$_nextId = 1;
function $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $c7f9e560d629e6df$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $e72ut.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $c7f9e560d629e6df$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $e72ut.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $c7f9e560d629e6df$export$d05096c9fd9d936d extends (0, $jviUl.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $c7f9e560d629e6df$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $c7f9e560d629e6df$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $e72ut.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $e72ut.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});



parcelRequire.register("9LSgA", function(module, exports) {
"use strict";
var $71d29907afa9d2b2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $71d29907afa9d2b2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $71d29907afa9d2b2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $71d29907afa9d2b2$var$__createBinding(result, mod, k);
    }
    $71d29907afa9d2b2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useWeb3React = module.exports.Web3ReactProvider = void 0;

const $71d29907afa9d2b2$var$react_1 = $71d29907afa9d2b2$var$__importStar((parcelRequire("acw62")));

var $c86jh = parcelRequire("c86jh");
const $71d29907afa9d2b2$var$Web3Context = (0, $71d29907afa9d2b2$var$react_1.createContext)(undefined);
function $71d29907afa9d2b2$var$Web3ReactProvider({ children: children, connectors: connectors, connectorOverride: connectorOverride, network: network, lookupENS: lookupENS = true }) {
    const hooks = (0, $c86jh.getPriorityConnector)(...connectors);
    const { usePriorityConnector: usePriorityConnector, useSelectedChainId: useSelectedChainId, useSelectedAccounts: useSelectedAccounts, useSelectedIsActivating: useSelectedIsActivating, useSelectedError: useSelectedError, useSelectedAccount: useSelectedAccount, useSelectedIsActive: useSelectedIsActive, useSelectedProvider: useSelectedProvider, useSelectedENSNames: useSelectedENSNames, useSelectedENSName: useSelectedENSName } = hooks;
    const priorityConnector = usePriorityConnector();
    const connector = connectorOverride !== null && connectorOverride !== void 0 ? connectorOverride : priorityConnector;
    const chainId = useSelectedChainId(connector);
    const accounts = useSelectedAccounts(connector);
    const isActivating = useSelectedIsActivating(connector);
    const error = useSelectedError(connector);
    const account = useSelectedAccount(connector);
    const isActive = useSelectedIsActive(connector);
    // note that we've omitted a <T extends BaseProvider = Web3Provider> generic type
    // in Web3ReactProvider, and thus can't pass T through to useSelectedProvider below.
    // this is because if we did so, the type of provider would include T, but that would
    // conflict because Web3Context can't take a generic. however, this isn't particularly
    // important, because useWeb3React (below) is manually typed
    const provider = useSelectedProvider(connector, network);
    const ENSNames = useSelectedENSNames(connector, lookupENS ? provider : undefined);
    const ENSName = useSelectedENSName(connector, lookupENS ? provider : undefined);
    return $71d29907afa9d2b2$var$react_1.default.createElement($71d29907afa9d2b2$var$Web3Context.Provider, {
        value: {
            connector: connector,
            chainId: chainId,
            accounts: accounts,
            isActivating: isActivating,
            error: error,
            account: account,
            isActive: isActive,
            provider: provider,
            ENSNames: ENSNames,
            ENSName: ENSName,
            hooks: hooks
        }
    }, children);
}
module.exports.Web3ReactProvider = $71d29907afa9d2b2$var$Web3ReactProvider;
function $71d29907afa9d2b2$var$useWeb3React() {
    const context = (0, $71d29907afa9d2b2$var$react_1.useContext)($71d29907afa9d2b2$var$Web3Context);
    if (!context) throw Error("useWeb3React can only be used within the Web3ReactProvider component");
    return context;
}
module.exports.useWeb3React = $71d29907afa9d2b2$var$useWeb3React;

});

parcelRequire.register("kiSL0", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("71UAj")).then(()=>parcelRequire("dfTyR"));

});

parcelRequire.register("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRequire.register("ks9nR", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("27Lyk")).resolve("2F1ZC")),
    import("./" + (parcelRequire("27Lyk")).resolve("2BBnd"))
]).then(()=>parcelRequire("dHHSL"));

});

parcelRequire.register("fBgkM", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("27Lyk")).resolve("2F1ZC")),
    import("./" + (parcelRequire("27Lyk")).resolve("ioF3F"))
]).then(()=>parcelRequire("7q0i6"));

});

parcelRequire.register("aXHhw", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("hTq8P")).then(()=>parcelRequire("b7DB8"));

});

parcelRequire.register("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRequire.register("hiDPq", function(module, exports) {

$parcel$export(module.exports, "encode", () => $c983033072e737eb$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $c983033072e737eb$export$2f872c0f2117be69);

var $9uSEH = parcelRequire("9uSEH");

var $f8A5C = parcelRequire("f8A5C");

var $3p3gh = parcelRequire("3p3gh");
"use strict";
const $c983033072e737eb$var$logger = new (0, $f8A5C.Logger)((0, $3p3gh.version));
function $c983033072e737eb$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $c983033072e737eb$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $c983033072e737eb$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($c983033072e737eb$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $c983033072e737eb$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $9uSEH.isBytesLike)(object)) $c983033072e737eb$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $9uSEH.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $c983033072e737eb$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $c983033072e737eb$export$c564cdbbe6da493(object) {
    return (0, $9uSEH.hexlify)($c983033072e737eb$var$_encode(object));
}
function $c983033072e737eb$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $c983033072e737eb$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $c983033072e737eb$var$logger.throwError("child data too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $c983033072e737eb$var$_decode(data, offset) {
    if (data.length === 0) $c983033072e737eb$var$logger.throwError("data too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $c983033072e737eb$var$logger.throwError("data short segment too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        const length = $c983033072e737eb$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $c983033072e737eb$var$logger.throwError("data long segment too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        return $c983033072e737eb$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $c983033072e737eb$var$logger.throwError("data array too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        return $c983033072e737eb$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $c983033072e737eb$var$logger.throwError("data array too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        const length = $c983033072e737eb$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $c983033072e737eb$var$logger.throwError("data array too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $9uSEH.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $c983033072e737eb$var$logger.throwError("data too short", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $9uSEH.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $9uSEH.hexlify)(data[offset])
    };
}
function $c983033072e737eb$export$2f872c0f2117be69(data) {
    const bytes = (0, $9uSEH.arrayify)(data);
    const decoded = $c983033072e737eb$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $c983033072e737eb$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRequire.register("9uSEH", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $6ea14fce962ee0df$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $6ea14fce962ee0df$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $6ea14fce962ee0df$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $6ea14fce962ee0df$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $6ea14fce962ee0df$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $6ea14fce962ee0df$export$a8f4574d0e56446c);
$parcel$export(module.exports, "zeroPad", () => $6ea14fce962ee0df$export$3cdc770bf8b2ed3d);
$parcel$export(module.exports, "hexlify", () => $6ea14fce962ee0df$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $6ea14fce962ee0df$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $6ea14fce962ee0df$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $6ea14fce962ee0df$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexValue", () => $6ea14fce962ee0df$export$6916af760a341dd3);
$parcel$export(module.exports, "hexStripZeros", () => $6ea14fce962ee0df$export$967bc0082a978949);
$parcel$export(module.exports, "hexZeroPad", () => $6ea14fce962ee0df$export$e9c46a54370b47e8);
$parcel$export(module.exports, "splitSignature", () => $6ea14fce962ee0df$export$7fb170f1e457988f);
$parcel$export(module.exports, "joinSignature", () => $6ea14fce962ee0df$export$71bb9d78a59bbe25);

var $f8A5C = parcelRequire("f8A5C");

var $8dkr0 = parcelRequire("8dkr0");
"use strict";
const $6ea14fce962ee0df$var$logger = new (0, $f8A5C.Logger)((0, $8dkr0.version));
///////////////////////////////
function $6ea14fce962ee0df$var$isHexable(value) {
    return !!value.toHexString;
}
function $6ea14fce962ee0df$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $6ea14fce962ee0df$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $6ea14fce962ee0df$export$9a14abb1a440cd5e(value) {
    return $6ea14fce962ee0df$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $6ea14fce962ee0df$export$c6fabfbfd097fc30(value);
}
function $6ea14fce962ee0df$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $6ea14fce962ee0df$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$6ea14fce962ee0df$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$6ea14fce962ee0df$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $6ea14fce962ee0df$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $6ea14fce962ee0df$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $6ea14fce962ee0df$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($6ea14fce962ee0df$var$isHexable(value)) value = value.toHexString();
    if ($6ea14fce962ee0df$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $6ea14fce962ee0df$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $6ea14fce962ee0df$var$addSlice(new Uint8Array(result));
    }
    if ($6ea14fce962ee0df$export$c6fabfbfd097fc30(value)) return $6ea14fce962ee0df$var$addSlice(new Uint8Array(value));
    return $6ea14fce962ee0df$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $6ea14fce962ee0df$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$6ea14fce962ee0df$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $6ea14fce962ee0df$var$addSlice(result);
}
function $6ea14fce962ee0df$export$a8f4574d0e56446c(value) {
    let result = $6ea14fce962ee0df$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $6ea14fce962ee0df$export$3cdc770bf8b2ed3d(value, length) {
    value = $6ea14fce962ee0df$export$3131421a7d01b4fb(value);
    if (value.length > length) $6ea14fce962ee0df$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $6ea14fce962ee0df$var$addSlice(result);
}
function $6ea14fce962ee0df$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $6ea14fce962ee0df$var$HexCharacters = "0123456789abcdef";
function $6ea14fce962ee0df$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $6ea14fce962ee0df$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $6ea14fce962ee0df$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($6ea14fce962ee0df$var$isHexable(value)) return value.toHexString();
    if ($6ea14fce962ee0df$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $6ea14fce962ee0df$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($6ea14fce962ee0df$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $6ea14fce962ee0df$var$HexCharacters[(v & 0xf0) >> 4] + $6ea14fce962ee0df$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $6ea14fce962ee0df$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $6ea14fce962ee0df$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(data);
    else if (!$6ea14fce962ee0df$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $6ea14fce962ee0df$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(data);
    else if (!$6ea14fce962ee0df$export$b02a40aff8e4ad18(data) || data.length % 2) $6ea14fce962ee0df$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $6ea14fce962ee0df$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $6ea14fce962ee0df$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $6ea14fce962ee0df$export$6916af760a341dd3(value) {
    const trimmed = $6ea14fce962ee0df$export$967bc0082a978949($6ea14fce962ee0df$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $6ea14fce962ee0df$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(value);
    if (!$6ea14fce962ee0df$export$b02a40aff8e4ad18(value)) $6ea14fce962ee0df$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $6ea14fce962ee0df$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(value);
    else if (!$6ea14fce962ee0df$export$b02a40aff8e4ad18(value)) $6ea14fce962ee0df$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $6ea14fce962ee0df$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $6ea14fce962ee0df$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($6ea14fce962ee0df$export$9a14abb1a440cd5e(signature)) {
        let bytes = $6ea14fce962ee0df$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $6ea14fce962ee0df$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $6ea14fce962ee0df$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $6ea14fce962ee0df$export$3cdc770bf8b2ed3d($6ea14fce962ee0df$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $6ea14fce962ee0df$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $6ea14fce962ee0df$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $6ea14fce962ee0df$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $6ea14fce962ee0df$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$6ea14fce962ee0df$export$b02a40aff8e4ad18(result.r)) $6ea14fce962ee0df$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $6ea14fce962ee0df$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$6ea14fce962ee0df$export$b02a40aff8e4ad18(result.s)) $6ea14fce962ee0df$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $6ea14fce962ee0df$export$e9c46a54370b47e8(result.s, 32);
        const vs = $6ea14fce962ee0df$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $6ea14fce962ee0df$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $6ea14fce962ee0df$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$6ea14fce962ee0df$export$b02a40aff8e4ad18(result._vs)) $6ea14fce962ee0df$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $6ea14fce962ee0df$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $6ea14fce962ee0df$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $6ea14fce962ee0df$export$71bb9d78a59bbe25(signature) {
    signature = $6ea14fce962ee0df$export$7fb170f1e457988f(signature);
    return $6ea14fce962ee0df$export$2b0d6b5fbe698c70($6ea14fce962ee0df$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRequire.register("f8A5C", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "Logger", () => $b0539904eaf4a0f9$export$efa9a398d6368992);

var $5jxLl = parcelRequire("5jxLl");
"use strict";
let $b0539904eaf4a0f9$var$_permanentCensorErrors = false;
let $b0539904eaf4a0f9$var$_censorErrors = false;
const $b0539904eaf4a0f9$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $b0539904eaf4a0f9$var$_logLevel = $b0539904eaf4a0f9$var$LogLevels["default"];
let $b0539904eaf4a0f9$var$_globalLogger = null;
function $b0539904eaf4a0f9$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $b0539904eaf4a0f9$var$_normalizeError = $b0539904eaf4a0f9$var$_checkNormalize();
var $b0539904eaf4a0f9$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($b0539904eaf4a0f9$export$243e62d78d3b544d || ($b0539904eaf4a0f9$export$243e62d78d3b544d = {}));
var $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($b0539904eaf4a0f9$export$d4e71bc0b80dc0fb || ($b0539904eaf4a0f9$export$d4e71bc0b80dc0fb = {}));
const $b0539904eaf4a0f9$var$HEX = "0123456789abcdef";
class $b0539904eaf4a0f9$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($b0539904eaf4a0f9$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($b0539904eaf4a0f9$var$_logLevel > $b0539904eaf4a0f9$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($b0539904eaf4a0f9$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($b0539904eaf4a0f9$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($b0539904eaf4a0f9$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($b0539904eaf4a0f9$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $b0539904eaf4a0f9$var$HEX[value[i] >> 4];
                        hex += $b0539904eaf4a0f9$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $b0539904eaf4a0f9$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($b0539904eaf4a0f9$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $b0539904eaf4a0f9$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $b0539904eaf4a0f9$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $b0539904eaf4a0f9$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $b0539904eaf4a0f9$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$b0539904eaf4a0f9$var$_globalLogger) $b0539904eaf4a0f9$var$_globalLogger = new $b0539904eaf4a0f9$export$efa9a398d6368992((0, $5jxLl.version));
        return $b0539904eaf4a0f9$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($b0539904eaf4a0f9$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $b0539904eaf4a0f9$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $b0539904eaf4a0f9$var$_censorErrors = !!censorship;
        $b0539904eaf4a0f9$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $b0539904eaf4a0f9$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $b0539904eaf4a0f9$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $b0539904eaf4a0f9$var$_logLevel = level;
    }
    static from(version) {
        return new $b0539904eaf4a0f9$export$efa9a398d6368992(version);
    }
}
$b0539904eaf4a0f9$export$efa9a398d6368992.errors = $b0539904eaf4a0f9$export$d4e71bc0b80dc0fb;
$b0539904eaf4a0f9$export$efa9a398d6368992.levels = $b0539904eaf4a0f9$export$243e62d78d3b544d;

});
parcelRequire.register("5jxLl", function(module, exports) {

$parcel$export(module.exports, "version", () => $3de8eaa9ff7b99af$export$83d89fbfd8236492);
const $3de8eaa9ff7b99af$export$83d89fbfd8236492 = "logger/5.6.0";

});


parcelRequire.register("8dkr0", function(module, exports) {

$parcel$export(module.exports, "version", () => $5faf637ed083024d$export$83d89fbfd8236492);
const $5faf637ed083024d$export$83d89fbfd8236492 = "bytes/5.6.1";

});


parcelRequire.register("3p3gh", function(module, exports) {

$parcel$export(module.exports, "version", () => $27a63c9892b47c19$export$83d89fbfd8236492);
const $27a63c9892b47c19$export$83d89fbfd8236492 = "rlp/5.6.1";

});


parcelRequire.register("eGcmO", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("2vfMQ")).decode);
$parcel$export(module.exports, "encode", () => (parcelRequire("2vfMQ")).encode);

var $2vfMQ = parcelRequire("2vfMQ");
"use strict";

});

parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $1WnaA = parcelRequire("1WnaA");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $1WnaA.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRequire.register("1WnaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $169d2e441f4c4370$export$2e2bcd8739ae039);
function $169d2e441f4c4370$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $169d2e441f4c4370$export$2e2bcd8739ae039 = $169d2e441f4c4370$var$memoize;

});


parcelRequire.register("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});


var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $acw62 = parcelRequire("acw62");
function $776fcec02d76c008$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}


function $1b787b96cfd7de9e$export$7a171f172be0782e(entity) {
    if (entity === "state") return window.LiveChatWidget.get("state");
    if (entity === "chat") return window.LiveChatWidget.get("chat_data");
    if (entity === "customer") return window.LiveChatWidget.get("customer_data");
    return null;
}
function $1b787b96cfd7de9e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b787b96cfd7de9e$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1b787b96cfd7de9e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1b787b96cfd7de9e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1b787b96cfd7de9e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b787b96cfd7de9e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b787b96cfd7de9e$var$_slicedToArray(arr, i) {
    return $1b787b96cfd7de9e$var$_arrayWithHoles(arr) || $1b787b96cfd7de9e$var$_iterableToArrayLimit(arr, i) || $1b787b96cfd7de9e$var$_unsupportedIterableToArray(arr, i) || $1b787b96cfd7de9e$var$_nonIterableRest();
}
function $1b787b96cfd7de9e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1b787b96cfd7de9e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1b787b96cfd7de9e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1b787b96cfd7de9e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1b787b96cfd7de9e$var$_arrayLikeToArray(o, minLen);
}
function $1b787b96cfd7de9e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1b787b96cfd7de9e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable prefer-rest-params, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment, @typescript-eslint/unbound-method */ var $1b787b96cfd7de9e$var$scriptRef = {
    current: null
};
function $1b787b96cfd7de9e$var$createJSApi() {
    var _scriptRef$current;
    var slice = Array.prototype.slice;
    /* istanbul ignore next */ function handle(args) {
        // @ts-ignore
        return api._h ? api._h.apply(null, args) : api._q.push(args);
    }
    /* istanbul ignore next */ var api = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function on() {
            handle([
                "on",
                slice.call(arguments)
            ]);
        },
        once: function once() {
            handle([
                "once",
                slice.call(arguments)
            ]);
        },
        off: function off() {
            handle([
                "off",
                slice.call(arguments)
            ]);
        },
        get: function get() {
            if (!api._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
            return handle([
                "get",
                slice.call(arguments)
            ]);
        },
        call: function call() {
            handle([
                "call",
                slice.call(arguments)
            ]);
        },
        init: function init() {
            var script = document.createElement("script");
            script.async = true;
            script.type = "text/javascript";
            script.src = "https://cdn.livechatinc.com/tracking.js";
            document.head.appendChild(script);
            $1b787b96cfd7de9e$var$scriptRef.current = script;
        }
    };
    (_scriptRef$current = $1b787b96cfd7de9e$var$scriptRef.current) === null || _scriptRef$current === void 0 || _scriptRef$current.remove();
    window.LiveChatWidget = window.LiveChatWidget || api;
    return $1b787b96cfd7de9e$var$scriptRef;
}
function $1b787b96cfd7de9e$export$6a5f2b0854617648(_ref) {
    var license = _ref.license, group = _ref.group, chatBetweenGroups = _ref.chatBetweenGroups, sessionVariables = _ref.sessionVariables;
    window.__lc = window.__lc || {};
    if (typeof license === "string") window.__lc.license = Number(license);
    else throw new Error("[LiveChatWidget] The license property is required for initialization");
    if (typeof group !== "undefined") window.__lc.group = Number(group);
    if (typeof chatBetweenGroups !== "undefined") window.__lc.chat_between_groups = Boolean(chatBetweenGroups);
    if (sessionVariables instanceof Object) window.__lc.params = Object.entries(sessionVariables).map(function(_ref2) {
        var _ref3 = $1b787b96cfd7de9e$var$_slicedToArray(_ref2, 2), name = _ref3[0], value = _ref3[1];
        return {
            name: name,
            value: value
        };
    });
}
function $1b787b96cfd7de9e$export$e60776cadabc921e(method, eventHandlers) {
    if (method === "off" && typeof window.LiveChatWidget === "undefined") return;
    if (typeof eventHandlers.onReady === "function") window.LiveChatWidget[method]("ready", eventHandlers.onReady);
    if (typeof eventHandlers.onAvailabilityChanged === "function") window.LiveChatWidget[method]("availability_changed", eventHandlers.onAvailabilityChanged);
    if (typeof eventHandlers.onVisibilityChanged === "function") window.LiveChatWidget[method]("visibility_changed", eventHandlers.onVisibilityChanged);
    if (typeof eventHandlers.onCustomerStatusChanged === "function") window.LiveChatWidget[method]("customer_status_changed", eventHandlers.onCustomerStatusChanged);
    if (typeof eventHandlers.onNewEvent === "function") window.LiveChatWidget[method]("new_event", eventHandlers.onNewEvent);
    if (typeof eventHandlers.onFormSubmitted === "function") window.LiveChatWidget[method]("form_submitted", eventHandlers.onFormSubmitted);
    if (typeof eventHandlers.onRatingSubmitted === "function") window.LiveChatWidget[method]("rating_submitted", eventHandlers.onRatingSubmitted);
    if (typeof eventHandlers.onGreetingDisplayed === "function") window.LiveChatWidget[method]("greeting_displayed", eventHandlers.onGreetingDisplayed);
    if (typeof eventHandlers.onGreetingHidden === "function") window.LiveChatWidget[method]("greeting_hidden", eventHandlers.onGreetingHidden);
    if (typeof eventHandlers.onRichMessageButtonClicked === "function") window.LiveChatWidget[method]("rich_message_button_clicked", eventHandlers.onRichMessageButtonClicked);
}
function $1b787b96cfd7de9e$export$798d7334ae3df603(customerData) {
    if (typeof customerData.name === "string") window.LiveChatWidget.call("set_customer_name", customerData.name);
    if (typeof customerData.email === "string") window.LiveChatWidget.call("set_customer_email", customerData.email);
}
function $1b787b96cfd7de9e$export$43c8f391a4a93bd8(visibility) {
    if (visibility === "hidden") window.LiveChatWidget.call("hide");
    if (visibility === "maximized") window.LiveChatWidget.call("maximize");
    if (visibility === "minimized") window.LiveChatWidget.call("minimize");
}
var $1b787b96cfd7de9e$var$emitter = (0, $776fcec02d76c008$export$2e2bcd8739ae039)();
var $1b787b96cfd7de9e$var$lifecycleEmit = $1b787b96cfd7de9e$var$emitter.emit.bind(null);
function $1b787b96cfd7de9e$export$2a580700536c2a87(callback) {
    $1b787b96cfd7de9e$var$emitter.on("init", callback);
    if ("LiveChatWidget" in window) callback();
    return function() {
        $1b787b96cfd7de9e$var$emitter.off("init", callback);
    };
}
function $1b787b96cfd7de9e$export$92773d15693dd7d1(callback) {
    $1b787b96cfd7de9e$var$emitter.on("destroy", callback);
    return function() {
        $1b787b96cfd7de9e$var$emitter.off("destroy", callback);
    };
}
function $1b787b96cfd7de9e$export$d856f5947026c431(config) {
    var state = {
        isLoading: false,
        desiredState: "unknown",
        currentEventHandlers: {
            onReady: config.onReady,
            onNewEvent: config.onNewEvent,
            onFormSubmitted: config.onFormSubmitted,
            onGreetingHidden: config.onGreetingHidden,
            onRatingSubmitted: config.onRatingSubmitted,
            onGreetingDisplayed: config.onGreetingDisplayed,
            onVisibilityChanged: config.onVisibilityChanged,
            onAvailabilityChanged: config.onAvailabilityChanged,
            onCustomerStatusChanged: config.onCustomerStatusChanged,
            onRichMessageButtonClicked: config.onRichMessageButtonClicked
        }
    };
    var scriptRef = $1b787b96cfd7de9e$var$createJSApi();
    $1b787b96cfd7de9e$export$6a5f2b0854617648(config);
    $1b787b96cfd7de9e$export$43c8f391a4a93bd8(config.visibility);
    $1b787b96cfd7de9e$export$e60776cadabc921e("on", state.currentEventHandlers);
    $1b787b96cfd7de9e$export$798d7334ae3df603({
        name: config.customerName,
        email: config.customerEmail
    });
    window.__lc.integration_name = "@livechat/widget-core";
    return {
        init: function init() {
            var _this = this;
            state.desiredState = "loaded";
            if (state.isLoading) return;
            window.LC_API = window.LC_API || {};
            window.LC_API.on_after_load = function() {
                state.isLoading = false;
                if (state.desiredState === "destroyed") _this.destroy();
                state.desiredState = "unknown";
            };
            $1b787b96cfd7de9e$var$lifecycleEmit("init");
            state.isLoading = true;
            window.LiveChatWidget.init();
        },
        destroy: function destroy() {
            var _scriptRef$current;
            state.desiredState = "destroyed";
            if (state.isLoading) return;
            $1b787b96cfd7de9e$var$lifecycleEmit("destroy");
            (_scriptRef$current = scriptRef.current) === null || _scriptRef$current === void 0 || _scriptRef$current.remove();
            window.LiveChatWidget.call("destroy");
        },
        updateVisibility: function updateVisibility(visibility) {
            $1b787b96cfd7de9e$export$43c8f391a4a93bd8(visibility);
        },
        updateEventHandlers: function updateEventHandlers(eventHabndlers) {
            $1b787b96cfd7de9e$export$e60776cadabc921e("off", state.currentEventHandlers);
            $1b787b96cfd7de9e$export$e60776cadabc921e("on", eventHabndlers);
            state.currentEventHandlers = $1b787b96cfd7de9e$var$_objectSpread2({}, eventHabndlers);
        },
        updateSessionVariables: function updateSessionVariables(sessionVariables) {
            if (sessionVariables) window.LiveChatWidget.call("update_session_variables", sessionVariables);
        },
        hideGreeting: function hideGreeting() {
            window.LiveChatWidget.call("hide_greeting");
        },
        updateCustomerData: function updateCustomerData(customerData) {
            $1b787b96cfd7de9e$export$798d7334ae3df603(customerData);
        }
    };
}


function $0138d73dc39d8a3c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0138d73dc39d8a3c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0138d73dc39d8a3c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0138d73dc39d8a3c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0138d73dc39d8a3c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0138d73dc39d8a3c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0138d73dc39d8a3c$var$_slicedToArray(arr, i) {
    return $0138d73dc39d8a3c$var$_arrayWithHoles(arr) || $0138d73dc39d8a3c$var$_iterableToArrayLimit(arr, i) || $0138d73dc39d8a3c$var$_unsupportedIterableToArray(arr, i) || $0138d73dc39d8a3c$var$_nonIterableRest();
}
function $0138d73dc39d8a3c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0138d73dc39d8a3c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0138d73dc39d8a3c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0138d73dc39d8a3c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0138d73dc39d8a3c$var$_arrayLikeToArray(o, minLen);
}
function $0138d73dc39d8a3c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0138d73dc39d8a3c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0138d73dc39d8a3c$export$b3e754008c897cb8() {
    var _React$useState = $acw62.useState(false), _React$useState2 = $0138d73dc39d8a3c$var$_slicedToArray(_React$useState, 2), isReady = _React$useState2[0], setIsReady = _React$useState2[1];
    $acw62.useEffect(function() {
        var onReady = function onReady() {
            return setIsReady(true);
        };
        var unsubscribeInit = (0, $1b787b96cfd7de9e$export$2a580700536c2a87)(function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("once", {
                onReady: onReady
            });
        });
        var unsubscribeDestroy = (0, $1b787b96cfd7de9e$export$92773d15693dd7d1)(function() {
            setIsReady(false);
        });
        return function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("off", {
                onReady: onReady
            });
            unsubscribeInit();
            unsubscribeDestroy();
        };
    }, []);
    return isReady;
}
function $0138d73dc39d8a3c$export$b323c00015b1e5c6() {
    var _React$useState = $acw62.useState(null), _React$useState2 = $0138d73dc39d8a3c$var$_slicedToArray(_React$useState, 2), widgetState = _React$useState2[0], setWidgetState = _React$useState2[1];
    $acw62.useEffect(function() {
        var onReady = function onReady(_ref) {
            var state = _ref.state;
            return setWidgetState(state);
        };
        var onVisibilityChanged = function onVisibilityChanged(_ref2) {
            var visibility = _ref2.visibility;
            setWidgetState(function(prevState) {
                return prevState ? $0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2({}, prevState), {}, {
                    visibility: visibility
                }) : prevState;
            });
        };
        var onAvailabilityChanged = function onAvailabilityChanged(_ref3) {
            var availability = _ref3.availability;
            setWidgetState(function(prevState) {
                return prevState ? $0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2({}, prevState), {}, {
                    availability: availability
                }) : prevState;
            });
        };
        var unsubscribeInit = (0, $1b787b96cfd7de9e$export$2a580700536c2a87)(function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("once", {
                onReady: onReady
            });
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("on", {
                onVisibilityChanged: onVisibilityChanged,
                onAvailabilityChanged: onAvailabilityChanged
            });
        });
        var unsubscribeDestroy = (0, $1b787b96cfd7de9e$export$92773d15693dd7d1)(function() {
            setWidgetState(null);
        });
        return function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("off", {
                onReady: onReady,
                onVisibilityChanged: onVisibilityChanged,
                onAvailabilityChanged: onAvailabilityChanged
            });
            unsubscribeInit();
            unsubscribeDestroy();
        };
    }, []);
    return widgetState;
}
function $0138d73dc39d8a3c$export$3263fa2eb313db21() {
    var _React$useState = $acw62.useState(null), _React$useState2 = $0138d73dc39d8a3c$var$_slicedToArray(_React$useState, 2), customerData = _React$useState2[0], setCustomerData = _React$useState2[1];
    $acw62.useEffect(function() {
        var onReady = function onReady(_ref) {
            var customerData = _ref.customerData;
            return setCustomerData(customerData);
        };
        var onCustomerStatusChanged = function onCustomerStatusChanged() {
            return setCustomerData((0, $1b787b96cfd7de9e$export$7a171f172be0782e)("customer"));
        };
        var unsubscribeInit = (0, $1b787b96cfd7de9e$export$2a580700536c2a87)(function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("once", {
                onReady: onReady
            });
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("on", {
                onCustomerStatusChanged: onCustomerStatusChanged
            });
        });
        var unsubscribeDestroy = (0, $1b787b96cfd7de9e$export$92773d15693dd7d1)(function() {
            setCustomerData(null);
        });
        return function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("off", {
                onReady: onReady,
                onCustomerStatusChanged: onCustomerStatusChanged
            });
            unsubscribeInit();
            unsubscribeDestroy();
        };
    }, []);
    return customerData;
}
function $0138d73dc39d8a3c$export$7b45ef2ca8fd836d() {
    var customerData = $0138d73dc39d8a3c$export$3263fa2eb313db21();
    var status = customerData === null || customerData === void 0 ? void 0 : customerData.status;
    var _React$useState = $acw62.useState(null), _React$useState2 = $0138d73dc39d8a3c$var$_slicedToArray(_React$useState, 2), chatData = _React$useState2[0], setChatData = _React$useState2[1];
    $acw62.useEffect(function() {
        if (status === "chatting") setChatData((0, $1b787b96cfd7de9e$export$7a171f172be0782e)("chat"));
        else setChatData(null);
    }, [
        status
    ]);
    return chatData;
}
function $0138d73dc39d8a3c$export$89ad64e368097e9f() {
    var _React$useState = $acw62.useState(null), _React$useState2 = $0138d73dc39d8a3c$var$_slicedToArray(_React$useState, 2), greeting = _React$useState2[0], setGreeting = _React$useState2[1];
    $acw62.useEffect(function() {
        var onGreetingDisplayed = function onGreetingDisplayed(greeting) {
            return setGreeting(greeting);
        };
        var onGreetingHidden = function onGreetingHidden() {
            return setGreeting(null);
        };
        var unsubscribeInit = (0, $1b787b96cfd7de9e$export$2a580700536c2a87)(function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("on", {
                onGreetingDisplayed: onGreetingDisplayed,
                onGreetingHidden: onGreetingHidden
            });
        });
        var unsubscribeDestroy = (0, $1b787b96cfd7de9e$export$92773d15693dd7d1)(function() {
            setGreeting(null);
        });
        return function() {
            (0, $1b787b96cfd7de9e$export$e60776cadabc921e)("off", {
                onGreetingDisplayed: onGreetingDisplayed,
                onGreetingHidden: onGreetingHidden
            });
            unsubscribeInit();
            unsubscribeDestroy();
        };
    }, []);
    return greeting;
}
function $0138d73dc39d8a3c$export$431600d623a8d3a4(props) {
    var widgetRef = $acw62.useRef(null);
    $acw62.useEffect(function() {
        widgetRef.current = (0, $1b787b96cfd7de9e$export$d856f5947026c431)(props);
        window.__lc.integration_name = "@livechat/widget-react";
        widgetRef.current.init();
        return function() {
            var _widgetRef$current;
            (_widgetRef$current = widgetRef.current) === null || _widgetRef$current === void 0 || _widgetRef$current.destroy();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.license,
        props.group,
        props.chatBetweenGroups
    ]);
    $acw62.useEffect(function() {
        var _widgetRef$current2;
        (_widgetRef$current2 = widgetRef.current) === null || _widgetRef$current2 === void 0 || _widgetRef$current2.updateVisibility(props.visibility);
    }, [
        props.visibility
    ]);
    $acw62.useEffect(function() {
        var _widgetRef$current3;
        (_widgetRef$current3 = widgetRef.current) === null || _widgetRef$current3 === void 0 || _widgetRef$current3.updateSessionVariables(props.sessionVariables);
    }, [
        props.sessionVariables
    ]);
    $acw62.useEffect(function() {
        var _widgetRef$current4;
        (_widgetRef$current4 = widgetRef.current) === null || _widgetRef$current4 === void 0 || _widgetRef$current4.updateCustomerData({
            name: props.customerName,
            email: props.customerEmail
        });
    }, [
        props.customerName,
        props.customerEmail
    ]);
    $acw62.useEffect(function() {
        var _widgetRef$current5;
        (_widgetRef$current5 = widgetRef.current) === null || _widgetRef$current5 === void 0 || _widgetRef$current5.updateEventHandlers($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2($0138d73dc39d8a3c$var$_objectSpread2({}, props.onReady && {
            onReady: props.onReady
        }), props.onNewEvent && {
            onNewEvent: props.onNewEvent
        }), props.onFormSubmitted && {
            onFormSubmitted: props.onFormSubmitted
        }), props.onGreetingHidden && {
            onGreetingHidden: props.onGreetingHidden
        }), props.onRatingSubmitted && {
            onRatingSubmitted: props.onRatingSubmitted
        }), props.onGreetingDisplayed && {
            onGreetingDisplayed: props.onGreetingDisplayed
        }), props.onVisibilityChanged && {
            onVisibilityChanged: props.onVisibilityChanged
        }), props.onAvailabilityChanged && {
            onAvailabilityChanged: props.onAvailabilityChanged
        }), props.onCustomerStatusChanged && {
            onCustomerStatusChanged: props.onCustomerStatusChanged
        }), props.onRichMessageButtonClicked && {
            onRichMessageButtonClicked: props.onRichMessageButtonClicked
        }));
    }, [
        props.onReady,
        props.onNewEvent,
        props.onFormSubmitted,
        props.onGreetingHidden,
        props.onRatingSubmitted,
        props.onGreetingDisplayed,
        props.onVisibilityChanged,
        props.onAvailabilityChanged,
        props.onCustomerStatusChanged,
        props.onRichMessageButtonClicked
    ]);
    return null;
}


const $0862eb9053e475c0$export$4dc9137e70244002 = "15030696";


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


const $0a8cbb743e3b2749$export$431600d623a8d3a4 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0138d73dc39d8a3c$export$431600d623a8d3a4), {
        license: (0, $0862eb9053e475c0$export$4dc9137e70244002)
    });



var $acw62 = parcelRequire("acw62");

const $7ba40f9fe3eefc5f$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)({
    pushModal: ()=>undefined,
    popModal: ()=>undefined,
    replaceModal: ()=>undefined,
    hideModal: ()=>undefined,
    modalType: undefined,
    modalState: undefined,
    modalComponents: {}
});
const $7ba40f9fe3eefc5f$export$178405afcd8c5eb = ({ modalComponents: modalComponents, children: children })=>{
    const [modalHistory, setModalHistory] = (0, $acw62.useState)([]);
    const pushModal = (0, $acw62.useCallback)((modalType, modalState)=>{
        setModalHistory([
            ...modalHistory,
            {
                modalType: modalType,
                modalState: modalState
            }
        ]);
    }, [
        modalHistory
    ]);
    const popModal = (0, $acw62.useCallback)(()=>{
        setModalHistory(modalHistory.slice(0, -1));
    }, [
        modalHistory
    ]);
    const replaceModal = (0, $acw62.useCallback)((modalType, modalState)=>{
        setModalHistory([
            {
                modalType: modalType,
                modalState: modalState
            }
        ]);
    }, []);
    const hideModal = (0, $acw62.useCallback)(()=>{
        setModalHistory([]);
    }, []);
    const lastModalHistoryItem = modalHistory.length > 0 ? modalHistory[modalHistory.length - 1] : null;
    const modalType = lastModalHistoryItem?.modalType;
    const modalState = lastModalHistoryItem?.modalState;
    const value = (0, $acw62.useMemo)(()=>({
            pushModal: pushModal,
            popModal: popModal,
            replaceModal: replaceModal,
            hideModal: hideModal,
            modalType: modalType,
            modalState: modalState,
            modalComponents: modalComponents
        }), [
        pushModal,
        popModal,
        replaceModal,
        hideModal,
        modalType,
        modalState,
        modalComponents
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7ba40f9fe3eefc5f$export$ab57792b9b6974a6.Provider, {
        value: value,
        children: children
    });
};


var $0d8f9ce9c9511b31$exports = {};
"use strict";
var $0d8f9ce9c9511b31$var$__createBinding = $0d8f9ce9c9511b31$exports && $0d8f9ce9c9511b31$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0d8f9ce9c9511b31$var$__setModuleDefault = $0d8f9ce9c9511b31$exports && $0d8f9ce9c9511b31$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0d8f9ce9c9511b31$var$__importStar = $0d8f9ce9c9511b31$exports && $0d8f9ce9c9511b31$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0d8f9ce9c9511b31$var$__createBinding(result, mod, k);
    }
    $0d8f9ce9c9511b31$var$__setModuleDefault(result, mod);
    return result;
};
var $0d8f9ce9c9511b31$var$__awaiter = $0d8f9ce9c9511b31$exports && $0d8f9ce9c9511b31$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0d8f9ce9c9511b31$var$__rest = $0d8f9ce9c9511b31$exports && $0d8f9ce9c9511b31$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($0d8f9ce9c9511b31$exports, "__esModule", {
    value: true
});
$0d8f9ce9c9511b31$exports.CoinbaseWallet = void 0;
var $14c6de76a1303f53$exports = {};
"use strict";
Object.defineProperty($14c6de76a1303f53$exports, "__esModule", {
    value: true
});
$14c6de76a1303f53$exports.Connector = void 0;
class $14c6de76a1303f53$var$Connector {
    /**
     * @param actions - Methods bound to a zustand store that tracks the state of the connector.
     * Actions are used by the connector to report changes in connection status.
     */ constructor(actions){
        this.actions = actions;
    }
    get serverSide() {
        return typeof window === "undefined";
    }
    /**
     * Initiate a disconnect.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    deactivate(...args) {
        this.actions.reportError(undefined);
    }
}
$14c6de76a1303f53$exports.Connector = $14c6de76a1303f53$var$Connector;


function $0d8f9ce9c9511b31$var$parseChainId(chainId) {
    return typeof chainId === "number" ? chainId : Number.parseInt(chainId, chainId.startsWith("0x") ? 16 : 10);
}

class $0d8f9ce9c9511b31$var$CoinbaseWallet extends $14c6de76a1303f53$exports.Connector {
    /**
     * @param options - Options to pass to `@coinbase/wallet-sdk`
     * @param connectEagerly - A flag indicating whether connection should be initiated when the class is constructed.
     */ constructor(actions, options, connectEagerly = false){
        super(actions);
        if (connectEagerly && this.serverSide) throw new Error("connectEagerly = true is invalid for SSR, instead use the connectEagerly method in a useEffect");
        this.options = options;
        if (connectEagerly) this.connectEagerly();
    }
    // the `connected` property, is bugged, but this works as a hack to check connection status
    get connected() {
        var _a;
        return !!((_a = this.provider) === null || _a === void 0 ? void 0 : _a.selectedAddress);
    }
    isomorphicInitialize() {
        return $0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
            if (this.eagerConnection) return this.eagerConnection;
            yield this.eagerConnection = Promise.resolve().then(function() {
                return (parcelRequire("6EoaL"));
            }).then((res)=>$0d8f9ce9c9511b31$var$__importStar(res)).then((m)=>{
                const _a = this.options, { url: url } = _a, options = $0d8f9ce9c9511b31$var$__rest(_a, [
                    "url"
                ]);
                this.coinbaseWallet = new m.default(options);
                this.provider = this.coinbaseWallet.makeWeb3Provider(url);
                this.provider.on("connect", ({ chainId: chainId })=>{
                    this.actions.update({
                        chainId: $0d8f9ce9c9511b31$var$parseChainId(chainId)
                    });
                });
                this.provider.on("disconnect", (error)=>{
                    this.actions.reportError(error);
                });
                this.provider.on("chainChanged", (chainId)=>{
                    this.actions.update({
                        chainId: $0d8f9ce9c9511b31$var$parseChainId(chainId)
                    });
                });
                this.provider.on("accountsChanged", (accounts)=>{
                    this.actions.update({
                        accounts: accounts
                    });
                });
            });
        });
    }
    /** {@inheritdoc Connector.connectEagerly} */ connectEagerly() {
        return $0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
            const cancelActivation = this.actions.startActivation();
            yield this.isomorphicInitialize();
            if (this.connected) return Promise.all([
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({
                    method: "eth_chainId"
                }),
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({
                    method: "eth_accounts"
                })
            ]).then(([chainId, accounts])=>{
                if (accounts.length) this.actions.update({
                    chainId: $0d8f9ce9c9511b31$var$parseChainId(chainId),
                    accounts: accounts
                });
                else throw new Error("No accounts returned");
            }).catch((error)=>{
                console.debug("Could not connect eagerly", error);
                cancelActivation();
            });
            else cancelActivation();
        });
    }
    /**
     * Initiates a connection.
     *
     * @param desiredChainIdOrChainParameters - If defined, indicates the desired chain to connect to. If the user is
     * already connected to this chain, no additional steps will be taken. Otherwise, the user will be prompted to switch
     * to the chain, if one of two conditions is met: either they already have it added, or the argument is of type
     * AddEthereumChainParameter, in which case the user will be prompted to add the chain with the specified parameters
     * first, before being prompted to switch.
     */ activate(desiredChainIdOrChainParameters) {
        return $0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
            const desiredChainId = typeof desiredChainIdOrChainParameters === "number" ? desiredChainIdOrChainParameters : desiredChainIdOrChainParameters === null || desiredChainIdOrChainParameters === void 0 ? void 0 : desiredChainIdOrChainParameters.chainId;
            if (this.connected) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (!desiredChainId || desiredChainId === $0d8f9ce9c9511b31$var$parseChainId(this.provider.chainId)) return;
                const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return this.provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: desiredChainIdHex
                        }
                    ]
                }).catch((error)=>$0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
                        if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== "number") // if we're here, we can try to add a new network
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        return this.provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                Object.assign(Object.assign({}, desiredChainIdOrChainParameters), {
                                    chainId: desiredChainIdHex
                                })
                            ]
                        });
                        else throw error;
                    })).catch((error)=>{
                    this.actions.reportError(error);
                });
            }
            this.actions.startActivation();
            yield this.isomorphicInitialize();
            return Promise.all([
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({
                    method: "eth_chainId"
                }),
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.provider.request({
                    method: "eth_requestAccounts"
                })
            ]).then(([chainId, accounts])=>{
                var _a;
                const receivedChainId = $0d8f9ce9c9511b31$var$parseChainId(chainId);
                if (!desiredChainId || desiredChainId === receivedChainId) return this.actions.update({
                    chainId: receivedChainId,
                    accounts: accounts
                });
                // if we're here, we can try to switch networks
                const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
                return (_a = this.provider) === null || _a === void 0 ? void 0 : _a.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: desiredChainIdHex
                        }
                    ]
                }).catch((error)=>$0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
                        if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== "number") // if we're here, we can try to add a new network
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        return this.provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                Object.assign(Object.assign({}, desiredChainIdOrChainParameters), {
                                    chainId: desiredChainIdHex
                                })
                            ]
                        });
                        else throw error;
                    }));
            }).catch((error)=>{
                this.actions.reportError(error);
            });
        });
    }
    /** {@inheritdoc Connector.deactivate} */ deactivate() {
        var _a;
        (_a = this.coinbaseWallet) === null || _a === void 0 || _a.disconnect();
    }
    watchAsset({ address: address, symbol: symbol, decimals: decimals, image: image }) {
        return $0d8f9ce9c9511b31$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.provider) throw new Error("No provider");
            return this.provider.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: address,
                        symbol: symbol,
                        decimals: decimals,
                        image: image
                    }
                }
            }).then((success)=>{
                if (!success) throw new Error("Rejected");
                return true;
            });
        });
    }
}
$0d8f9ce9c9511b31$exports.CoinbaseWallet = $0d8f9ce9c9511b31$var$CoinbaseWallet;


var $21dacc32874bba56$exports = {};
"use strict";
var $21dacc32874bba56$var$__createBinding = $21dacc32874bba56$exports && $21dacc32874bba56$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21dacc32874bba56$var$__exportStar = $21dacc32874bba56$exports && $21dacc32874bba56$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21dacc32874bba56$var$__createBinding(exports1, m, p);
};
Object.defineProperty($21dacc32874bba56$exports, "__esModule", {
    value: true
});

$21dacc32874bba56$var$__exportStar((parcelRequire("c86jh")), $21dacc32874bba56$exports);

$21dacc32874bba56$var$__exportStar((parcelRequire("9LSgA")), $21dacc32874bba56$exports);


var $989e9203f47e6879$exports = {};
"use strict";
var $989e9203f47e6879$var$__createBinding = $989e9203f47e6879$exports && $989e9203f47e6879$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $989e9203f47e6879$var$__setModuleDefault = $989e9203f47e6879$exports && $989e9203f47e6879$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $989e9203f47e6879$var$__importStar = $989e9203f47e6879$exports && $989e9203f47e6879$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $989e9203f47e6879$var$__createBinding(result, mod, k);
    }
    $989e9203f47e6879$var$__setModuleDefault(result, mod);
    return result;
};
var $989e9203f47e6879$var$__awaiter = $989e9203f47e6879$exports && $989e9203f47e6879$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($989e9203f47e6879$exports, "__esModule", {
    value: true
});
$989e9203f47e6879$exports.MetaMask = $989e9203f47e6879$exports.NoMetaMaskError = void 0;

class $989e9203f47e6879$var$NoMetaMaskError extends Error {
    constructor(){
        super("MetaMask not installed");
        this.name = $989e9203f47e6879$var$NoMetaMaskError.name;
        Object.setPrototypeOf(this, $989e9203f47e6879$var$NoMetaMaskError.prototype);
    }
}
$989e9203f47e6879$exports.NoMetaMaskError = $989e9203f47e6879$var$NoMetaMaskError;
function $989e9203f47e6879$var$parseChainId(chainId) {
    return Number.parseInt(chainId, 16);
}

class $989e9203f47e6879$var$MetaMask extends $14c6de76a1303f53$exports.Connector {
    /**
     * @param connectEagerly - A flag indicating whether connection should be initiated when the class is constructed.
     * @param options - Options to pass to `@metamask/detect-provider`
     */ constructor(actions, connectEagerly = false, options){
        super(actions);
        if (connectEagerly && this.serverSide) throw new Error("connectEagerly = true is invalid for SSR, instead use the connectEagerly method in a useEffect");
        this.options = options;
        if (connectEagerly) this.connectEagerly();
    }
    isomorphicInitialize() {
        return $989e9203f47e6879$var$__awaiter(this, void 0, void 0, function*() {
            if (this.eagerConnection) return this.eagerConnection;
            yield this.eagerConnection = Promise.resolve().then(function() {
                return (parcelRequire("kiSL0"));
            }).then((res)=>$989e9203f47e6879$var$__importStar(res)).then((m)=>m.default(this.options)).then((provider)=>{
                var _a, _b;
                if (provider) {
                    this.provider = provider;
                    // edge case if e.g. metamask and coinbase wallet are both installed
                    if ((_a = this.provider.providers) === null || _a === void 0 ? void 0 : _a.length) this.provider = (_b = this.provider.providers.find((p)=>p.isMetaMask)) !== null && _b !== void 0 ? _b : this.provider.providers[0];
                    this.provider.on("connect", ({ chainId: chainId })=>{
                        this.actions.update({
                            chainId: $989e9203f47e6879$var$parseChainId(chainId)
                        });
                    });
                    this.provider.on("disconnect", (error)=>{
                        this.actions.reportError(error);
                    });
                    this.provider.on("chainChanged", (chainId)=>{
                        this.actions.update({
                            chainId: $989e9203f47e6879$var$parseChainId(chainId)
                        });
                    });
                    this.provider.on("accountsChanged", (accounts)=>{
                        if (accounts.length === 0) // handle this edge case by disconnecting
                        this.actions.reportError(undefined);
                        else this.actions.update({
                            accounts: accounts
                        });
                    });
                }
            });
        });
    }
    /** {@inheritdoc Connector.connectEagerly} */ connectEagerly() {
        return $989e9203f47e6879$var$__awaiter(this, void 0, void 0, function*() {
            const cancelActivation = this.actions.startActivation();
            yield this.isomorphicInitialize();
            if (!this.provider) return cancelActivation();
            return Promise.all([
                this.provider.request({
                    method: "eth_chainId"
                }),
                this.provider.request({
                    method: "eth_accounts"
                })
            ]).then(([chainId, accounts])=>{
                if (accounts.length) this.actions.update({
                    chainId: $989e9203f47e6879$var$parseChainId(chainId),
                    accounts: accounts
                });
                else throw new Error("No accounts returned");
            }).catch((error)=>{
                console.debug("Could not connect eagerly", error);
                cancelActivation();
            });
        });
    }
    /**
     * Initiates a connection.
     *
     * @param desiredChainIdOrChainParameters - If defined, indicates the desired chain to connect to. If the user is
     * already connected to this chain, no additional steps will be taken. Otherwise, the user will be prompted to switch
     * to the chain, if one of two conditions is met: either they already have it added in their extension, or the
     * argument is of type AddEthereumChainParameter, in which case the user will be prompted to add the chain with the
     * specified parameters first, before being prompted to switch.
     */ activate(desiredChainIdOrChainParameters) {
        var _a, _b;
        return $989e9203f47e6879$var$__awaiter(this, void 0, void 0, function*() {
            if (!((_b = (_a = this.provider) === null || _a === void 0 ? void 0 : _a.isConnected) === null || _b === void 0 ? void 0 : _b.call(_a))) this.actions.startActivation();
            yield this.isomorphicInitialize();
            if (!this.provider) return this.actions.reportError(new $989e9203f47e6879$var$NoMetaMaskError());
            return Promise.all([
                this.provider.request({
                    method: "eth_chainId"
                }),
                this.provider.request({
                    method: "eth_requestAccounts"
                })
            ]).then(([chainId, accounts])=>{
                const receivedChainId = $989e9203f47e6879$var$parseChainId(chainId);
                const desiredChainId = typeof desiredChainIdOrChainParameters === "number" ? desiredChainIdOrChainParameters : desiredChainIdOrChainParameters === null || desiredChainIdOrChainParameters === void 0 ? void 0 : desiredChainIdOrChainParameters.chainId;
                // if there's no desired chain, or it's equal to the received, update
                if (!desiredChainId || receivedChainId === desiredChainId) return this.actions.update({
                    chainId: receivedChainId,
                    accounts: accounts
                });
                const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
                // if we're here, we can try to switch networks
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return this.provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: desiredChainIdHex
                        }
                    ]
                }).catch((error)=>{
                    if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== "number") // if we're here, we can try to add a new network
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return this.provider.request({
                        method: "wallet_addEthereumChain",
                        params: [
                            Object.assign(Object.assign({}, desiredChainIdOrChainParameters), {
                                chainId: desiredChainIdHex
                            })
                        ]
                    });
                    else throw error;
                }).then(()=>this.activate(desiredChainId));
            }).catch((error)=>{
                this.actions.reportError(error);
            });
        });
    }
    watchAsset({ address: address, symbol: symbol, decimals: decimals, image: image }) {
        return $989e9203f47e6879$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.provider) throw new Error("No provider");
            return this.provider.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: address,
                        symbol: symbol,
                        decimals: decimals,
                        image: image
                    }
                }
            }).then((success)=>{
                if (!success) throw new Error("Rejected");
                return true;
            });
        });
    }
}
$989e9203f47e6879$exports.MetaMask = $989e9203f47e6879$var$MetaMask;


var $0bff700fbccebab8$exports = {};
"use strict";
var $0bff700fbccebab8$var$__createBinding = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0bff700fbccebab8$var$__setModuleDefault = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0bff700fbccebab8$var$__importStar = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0bff700fbccebab8$var$__createBinding(result, mod, k);
    }
    $0bff700fbccebab8$var$__setModuleDefault(result, mod);
    return result;
};
var $0bff700fbccebab8$var$__awaiter = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0bff700fbccebab8$var$__rest = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0bff700fbccebab8$var$__importDefault = $0bff700fbccebab8$exports && $0bff700fbccebab8$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0bff700fbccebab8$exports, "__esModule", {
    value: true
});
$0bff700fbccebab8$exports.WalletConnect = $0bff700fbccebab8$exports.URI_AVAILABLE = void 0;


const $0bff700fbccebab8$var$eventemitter3_1 = $0bff700fbccebab8$var$__importDefault((parcelRequire("3vRz3")));
var $aa652029c043817d$exports = {};
"use strict";
var $aa652029c043817d$var$__createBinding = $aa652029c043817d$exports && $aa652029c043817d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aa652029c043817d$var$__setModuleDefault = $aa652029c043817d$exports && $aa652029c043817d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aa652029c043817d$var$__importStar = $aa652029c043817d$exports && $aa652029c043817d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $aa652029c043817d$var$__createBinding(result, mod, k);
    }
    $aa652029c043817d$var$__setModuleDefault(result, mod);
    return result;
};
var $aa652029c043817d$var$__awaiter = $aa652029c043817d$exports && $aa652029c043817d$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($aa652029c043817d$exports, "__esModule", {
    value: true
});
$aa652029c043817d$exports.getBestUrl = void 0;


function $aa652029c043817d$var$getBestUrl(urls) {
    return $aa652029c043817d$var$__awaiter(this, void 0, void 0, function*() {
        // if we only have 1 url, it's the best!
        if (urls.length === 1) return urls[0];
        const [HttpConnection, JsonRpcProvider] = yield Promise.all([
            Promise.resolve().then(function() {
                return (parcelRequire("ks9nR"));
            }).then((res)=>$aa652029c043817d$var$__importStar(res)).then(({ HttpConnection: HttpConnection })=>HttpConnection),
            Promise.resolve().then(function() {
                return (parcelRequire("fBgkM"));
            }).then((res)=>$aa652029c043817d$var$__importStar(res)).then(({ JsonRpcProvider: JsonRpcProvider })=>JsonRpcProvider)
        ]);
        // the below returns the first url for which there's been a successful call, prioritized by index
        return new Promise((resolve)=>{
            let resolved = false;
            const successes = {};
            urls.forEach((url, i)=>{
                const http = new JsonRpcProvider(new HttpConnection(url));
                http.request({
                    method: "eth_chainId"
                }).then(()=>true).catch(()=>false).then((success)=>{
                    // if we already resolved, return
                    if (resolved) return;
                    // store the result of the call
                    successes[i] = success;
                    // if this is the last call and we haven't resolved yet - do so
                    if (Object.keys(successes).length === urls.length) {
                        const index = Object.keys(successes).findIndex((j)=>successes[Number(j)]);
                        // no need to set resolved to true, as this is the last promise
                        return resolve(urls[index === -1 ? 0 : index]);
                    }
                    // otherwise, for each prospective index, check if we can resolve
                    new Array(urls.length).fill(0).forEach((_, prospectiveIndex)=>{
                        // to resolve, we need to:
                        // a) have successfully made a call
                        // b) not be waiting on any other higher-index calls
                        if (successes[prospectiveIndex] && new Array(prospectiveIndex).fill(0).every((_, j)=>successes[j] === false)) {
                            resolved = true;
                            resolve(urls[prospectiveIndex]);
                        }
                    });
                });
            });
        });
    });
}
$aa652029c043817d$exports.getBestUrl = $aa652029c043817d$var$getBestUrl;


$0bff700fbccebab8$exports.URI_AVAILABLE = "URI_AVAILABLE";
function $0bff700fbccebab8$var$parseChainId(chainId) {
    return typeof chainId === "string" ? Number.parseInt(chainId) : chainId;
}

class $0bff700fbccebab8$var$WalletConnect extends $14c6de76a1303f53$exports.Connector {
    /**
     * @param options - Options to pass to `@walletconnect/ethereum-provider`
     * @param connectEagerly - A flag indicating whether connection should be initiated when the class is constructed.
     */ constructor(actions, options, connectEagerly = false, treatModalCloseAsError = true){
        super(actions);
        this.events = new $0bff700fbccebab8$var$eventemitter3_1.default();
        this.disconnectListener = (error)=>{
            this.actions.reportError(error);
        };
        this.chainChangedListener = (chainId)=>{
            this.actions.update({
                chainId: $0bff700fbccebab8$var$parseChainId(chainId)
            });
        };
        this.accountsChangedListener = (accounts)=>{
            this.actions.update({
                accounts: accounts
            });
        };
        this.URIListener = (_, payload)=>{
            this.events.emit($0bff700fbccebab8$exports.URI_AVAILABLE, payload.params[0]);
        };
        if (connectEagerly && this.serverSide) throw new Error("connectEagerly = true is invalid for SSR, instead use the connectEagerly method in a useEffect");
        const { rpc: rpc } = options, rest = $0bff700fbccebab8$var$__rest(options, [
            "rpc"
        ]);
        this.rpc = Object.keys(rpc).reduce((accumulator, chainId)=>{
            const value = rpc[Number(chainId)];
            accumulator[Number(chainId)] = Array.isArray(value) ? value : [
                value
            ];
            return accumulator;
        }, {});
        this.options = rest;
        this.treatModalCloseAsError = treatModalCloseAsError;
        if (connectEagerly) this.connectEagerly();
    }
    isomorphicInitialize(chainId = Number(Object.keys(this.rpc)[0])) {
        return $0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
            if (this.eagerConnection) return this.eagerConnection;
            // because we can only use 1 url per chainId, we need to decide between multiple, where necessary
            const rpc = Promise.all(Object.keys(this.rpc).map((chainId)=>$0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
                    return [
                        Number(chainId),
                        (yield (0, $aa652029c043817d$exports.getBestUrl)(this.rpc[Number(chainId)]))
                    ];
                }))).then((results)=>results.reduce((accumulator, [chainId, url])=>{
                    accumulator[chainId] = url;
                    return accumulator;
                }, {}));
            yield this.eagerConnection = Promise.resolve().then(function() {
                return (parcelRequire("aXHhw"));
            }).then((res)=>$0bff700fbccebab8$var$__importStar(res)).then((m)=>$0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
                    this.provider = new m.default(Object.assign(Object.assign({}, this.options), {
                        chainId: chainId,
                        rpc: yield rpc
                    }));
                    this.provider.on("disconnect", this.disconnectListener);
                    this.provider.on("chainChanged", this.chainChangedListener);
                    this.provider.on("accountsChanged", this.accountsChangedListener);
                    this.provider.connector.on("display_uri", this.URIListener);
                }));
        });
    }
    /** {@inheritdoc Connector.connectEagerly} */ connectEagerly() {
        return $0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
            const cancelActivation = this.actions.startActivation();
            yield this.isomorphicInitialize();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (this.provider.connected) try {
                // for walletconnect, we always use sequential instead of parallel fetches because otherwise
                // chainId defaults to 1 even if the connecting wallet isn't on mainnet
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const accounts = yield this.provider.request({
                    method: "eth_accounts"
                });
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const chainId = $0bff700fbccebab8$var$parseChainId((yield this.provider.request({
                    method: "eth_chainId"
                })));
                if (accounts.length) this.actions.update({
                    chainId: chainId,
                    accounts: accounts
                });
                else throw new Error("No accounts returned");
            } catch (error) {
                console.debug("Could not connect eagerly", error);
                cancelActivation();
            }
            else cancelActivation();
        });
    }
    /**
     * Initiates a connection.
     *
     * @param desiredChainId - If defined, indicates the desired chain to connect to. If the user is
     * already connected to this chain, no additional steps will be taken. Otherwise, the user will be prompted to switch
     * to the chain, if their wallet supports it.
     */ activate(desiredChainId) {
        var _a, _b, _c;
        return $0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
            if (desiredChainId && this.rpc[desiredChainId] === undefined) throw new Error(`no url(s) provided for desiredChainId ${desiredChainId}`);
            // this early return clause catches some common cases if we're already connected
            if ((_a = this.provider) === null || _a === void 0 ? void 0 : _a.connected) {
                if (!desiredChainId || desiredChainId === this.provider.chainId) return;
                const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
                return this.provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: desiredChainIdHex
                        }
                    ]
                }).catch(()=>void 0);
            }
            this.actions.startActivation();
            // if we're trying to connect to a specific chain that we're not already initialized for, we have to re-initialize
            if (desiredChainId && desiredChainId !== ((_b = this.provider) === null || _b === void 0 ? void 0 : _b.chainId)) yield this.deactivate();
            yield this.isomorphicInitialize(desiredChainId);
            try {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const accounts = yield this.provider.request({
                    method: "eth_requestAccounts"
                });
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const chainId = $0bff700fbccebab8$var$parseChainId((yield this.provider.request({
                    method: "eth_chainId"
                })));
                if (!desiredChainId || desiredChainId === chainId) return this.actions.update({
                    chainId: chainId,
                    accounts: accounts
                });
                // because e.g. metamask doesn't support wallet_switchEthereumChain, we have to report connections,
                // even if the chainId isn't necessarily the desired one. this is ok because in e.g. rainbow,
                // we won't report a connection to the wrong chain while the switch is pending because of the re-initialization
                // logic above, which ensures first-time connections are to the correct chain in the first place
                this.actions.update({
                    chainId: chainId,
                    accounts: accounts
                });
                // if we're here, we can try to switch networks, ignoring errors
                const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
                return (_c = this.provider) === null || _c === void 0 ? void 0 : _c.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: desiredChainIdHex
                        }
                    ]
                }).catch(()=>void 0);
            } catch (error) {
                // this condition is a bit of a hack :/
                // if a user triggers the walletconnect modal, closes it, and then tries to connect again,
                // the modal will not trigger. the logic below prevents this from happening
                if (error.message === "User closed modal") yield this.deactivate(this.treatModalCloseAsError ? error : undefined);
                else this.actions.reportError(error);
            }
        });
    }
    /** {@inheritdoc Connector.deactivate} */ deactivate(error) {
        var _a, _b, _c, _d, _e, _f;
        return $0bff700fbccebab8$var$__awaiter(this, void 0, void 0, function*() {
            (_a = this.provider) === null || _a === void 0 || _a.off("disconnect", this.disconnectListener);
            (_b = this.provider) === null || _b === void 0 || _b.off("chainChanged", this.chainChangedListener);
            (_c = this.provider) === null || _c === void 0 || _c.off("accountsChanged", this.accountsChangedListener);
            (_e = (_d = this.provider) === null || _d === void 0 ? void 0 : _d.connector) === null || _e === void 0 || _e.off("display_uri", this.URIListener);
            yield (_f = this.provider) === null || _f === void 0 ? void 0 : _f.disconnect();
            this.provider = undefined;
            this.eagerConnection = undefined;
            this.actions.reportError(error);
        });
    }
}
$0bff700fbccebab8$exports.WalletConnect = $0bff700fbccebab8$var$WalletConnect;


var $ba7eaeeb642ff516$export$c06e1e7429de6283;
(function(ChainId) {
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
    ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
    ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
})($ba7eaeeb642ff516$export$c06e1e7429de6283 || ($ba7eaeeb642ff516$export$c06e1e7429de6283 = {}));


const $256cfab3646322b9$export$80ade7c548160012 = [
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET,
        title: "Ethereum",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH"
        },
        providers: {
            rpc: "https://rpc.ankr.com/eth"
        },
        urls: {
            explorer: "https://etherscan.io",
            explorerApi: "https://api.etherscan.io/"
        },
        addresses: {
            wrappedNativeCoinAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            mainAssetOracleAddress: "0x5f4ec3df9cbd43714fe2740f5e3616155c5b8419"
        },
        keys: {
            explorerApi: "H9YG861JU9VGXZXDBTR2C6CE23J8NSXSGC"
        }
    },
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).ARBITRUM,
        title: "Arbitrum",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH"
        },
        providers: {
            rpc: "https://arbitrum-one.public.blastapi.io"
        },
        urls: {
            explorer: "https://arbiscan.io"
        },
        addresses: {
            wrappedNativeCoinAddress: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
            mainAssetOracleAddress: "0x639fe6ab55c921f74e7fac1ee960c0b6293ba612"
        },
        keys: {
            explorerApi: "WSN4AIK9NGQ5DE2824YNMAYIGV82EJ33TS"
        }
    },
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).AVALANCHE,
        title: "Avalanche",
        nativeCurrency: {
            name: "Avalanche",
            symbol: "AVAX"
        },
        providers: {
            rpc: "https://rpc.ankr.com/avalanche"
        },
        urls: {
            explorer: "https://snowtrace.io"
        },
        addresses: {
            wrappedNativeCoinAddress: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7"
        },
        keys: {}
    },
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).POLYGON,
        title: "Polygon",
        nativeCurrency: {
            name: "Matic",
            symbol: "MATIC"
        },
        providers: {
            rpc: "https://rpc.ankr.com/polygon"
        },
        urls: {
            explorer: "https://polygonscan.com",
            explorerApi: "https://api.polygonscan.com"
        },
        keys: {
            explorerApi: "PJMV9MU5ZK43D5JWZTJ28YJWJ51G76Q9U2"
        },
        addresses: {
            wrappedNativeCoinAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
            mainAssetOracleAddress: "0xab594600376ec9fd91f8e885dadf0ce036862de0"
        }
    }
];


const $5541b71a36c71c58$export$65da42e9a1acb4b0 = ()=>Object.fromEntries((0, $256cfab3646322b9$export$80ade7c548160012).map(({ chainId: chainId, providers: providers })=>[
            chainId,
            providers.rpc
        ]));


var $ce6e1f58ef2116bb$export$5d6973e21e6f88d9;
(function(WalletType) {
    WalletType["METAMASK"] = "METAMASK";
    WalletType["WALLET_CONNECT"] = "WALLET_CONNECT";
    WalletType["COINBASE"] = "COINBASE";
})($ce6e1f58ef2116bb$export$5d6973e21e6f88d9 || ($ce6e1f58ef2116bb$export$5d6973e21e6f88d9 = {}));


const $5eec0ea54595fadd$var$RPCs = (0, $5541b71a36c71c58$export$65da42e9a1acb4b0)();
const $5eec0ea54595fadd$var$metamaskConnector = (0, $21dacc32874bba56$exports.initializeConnector)((actions)=>new (0, $989e9203f47e6879$exports.MetaMask)(actions));
const $5eec0ea54595fadd$var$walletConnectConnector = (0, $21dacc32874bba56$exports.initializeConnector)((actions)=>new (0, $0bff700fbccebab8$exports.WalletConnect)(actions, {
        rpc: $5eec0ea54595fadd$var$RPCs
    }), Object.keys($5eec0ea54595fadd$var$RPCs).map(Number));
const $5eec0ea54595fadd$var$coinbaseConnector = (0, $21dacc32874bba56$exports.initializeConnector)((actions)=>new (0, $0d8f9ce9c9511b31$exports.CoinbaseWallet)(actions, {
        url: $5eec0ea54595fadd$var$RPCs[1][0],
        appName: "Roe App"
    }));
const $5eec0ea54595fadd$export$b21745c80acb63b0 = {
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).METAMASK]: $5eec0ea54595fadd$var$metamaskConnector,
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).WALLET_CONNECT]: $5eec0ea54595fadd$var$walletConnectConnector,
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).COINBASE]: $5eec0ea54595fadd$var$coinbaseConnector
};



var $ad9e9f310a798519$exports = {};
(function(GLOBAL) {
    "use strict";
    var Big, /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */ DP = 20, /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */ NE = -7, /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */ PE = 21, /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */ STRICT = false, /**************************************************************************************************/ // Error messages.
    NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", // The shared prototype object.
    P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    /*
   * Create and return a Big constructor.
   */ function _Big_() {
        /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else {
                if (typeof n !== "string") {
                    if (Big.strict === true && typeof n !== "bigint") throw TypeError(INVALID + "value");
                    // Minus zero?
                    n = n === 0 && 1 / n < 0 ? "-0" : String(n);
                }
                parse(x, n);
            }
            // Retain a reference to this Big constructor.
            // Shadow Big.prototype.constructor which points to Object.
            x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.NE = NE;
        Big.PE = PE;
        Big.strict = STRICT;
        Big.roundDown = 0;
        Big.roundHalfUp = 1;
        Big.roundHalfEven = 2;
        Big.roundUp = 3;
        return Big;
    }
    /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */ function parse(x, n) {
        var e, i, nl;
        if (!NUMERIC.test(n)) throw Error(INVALID + "number");
        // Determine sign.
        x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        nl = n.length;
        // Determine leading zeros.
        for(i = 0; i < nl && n.charAt(i) == "0";)++i;
        if (i == nl) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; nl > 0 && n.charAt(--nl) == "0";);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
        }
        return x;
    }
    /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */ function round(x, sd, rm, more) {
        var xc = x.c;
        if (rm === UNDEFINED) rm = x.constructor.RM;
        if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error(INVALID_RM);
        if (sd < 1) {
            more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
            xc.length = 1;
            if (more) {
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = x.e - sd + 1;
                xc[0] = 1;
            } else // Zero.
            xc[0] = x.e = 0;
        } else if (sd < xc.length) {
            // xc[sd] is the digit after the digit that may be rounded up.
            more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
            // Remove any digits after the required precision.
            xc.length = sd;
            // Round up?
            if (more) // Rounding up may mean the previous digit has to be rounded up.
            for(; ++xc[--sd] > 9;){
                xc[sd] = 0;
                if (sd === 0) {
                    ++x.e;
                    xc.unshift(1);
                    break;
                }
            }
            // Remove trailing zeros.
            for(sd = xc.length; !xc[--sd];)xc.pop();
        }
        return x;
    }
    /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */ function stringify(x, doExponential, isNonzero) {
        var e = x.e, s = x.c.join(""), n = s.length;
        // Exponential notation?
        if (doExponential) s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
        else if (e < 0) {
            for(; ++e;)s = "0" + s;
            s = "0." + s;
        } else if (e > 0) {
            if (++e > n) for(e -= n; e--;)s += "0";
            else if (e < n) s = s.slice(0, e) + "." + s.slice(e);
        } else if (n > 1) s = s.charAt(0) + "." + s.slice(1);
        return x.s < 0 && isNonzero ? "-" + s : s;
    }
    // Prototype/instance methods
    /*
   * Return a new Big whose value is the absolute value of this Big.
   */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */ P.cmp = function(y) {
        var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        isneg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ isneg ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = -1; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ isneg ? 1 : -1;
    };
    /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.div = function(y) {
        var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
        // Divisor is zero?
        if (!b[0]) throw Error(DIV_BY_ZERO);
        // Dividend is 0? Return +-0.
        if (!a[0]) {
            y.s = k;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
        q.s = k;
        k = p < 0 ? 0 : p;
        // Create version of divisor with leading zero.
        bz.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; rl++ < bl;)r.push(0);
        do {
            // n is how many times the divisor goes into current remainder.
            for(n = 0; n < 10; n++){
                // Compare divisor and remainder.
                if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
                else {
                    for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                        cmp = b[ri] > r[ri] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(bt = rl == bl ? b : bz; rl;){
                        if (r[--rl] < bt[rl]) {
                            ri = rl;
                            for(; ri && !r[--ri];)r[ri] = 9;
                            --r[ri];
                            r[rl] += 10;
                        }
                        r[rl] -= bt[rl];
                    }
                    for(; !r[0];)r.shift();
                } else break;
            }
            // Add the digit n to the result array.
            qc[qi++] = cmp ? n : ++n;
            // Update the remainder.
            if (r[0] && cmp) r[rl] = a[ai] || 0;
            else r = [
                a[ai]
            ];
        }while ((ai++ < al || r[0] !== UNDEFINED) && k--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
            p--;
        }
        // Round?
        if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);
        return q;
    };
    /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */ P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */ P.minus = P.sub = function(y) {
        var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (yc[0]) y.s = -b;
            else if (xc[0]) y = new Big(x);
            else y.s = 1;
            return y;
        }
        // Determine which is the bigger number. Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xlty = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--;)t.push(0);
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xlty = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xlty = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xlty) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i];)xc[i] = 9;
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0;)xc.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */ P.mod = function(y) {
        var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throw Error(DIV_BY_ZERO);
        x.s = y.s = 1;
        ygtx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (ygtx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
   * Return a new Big whose value is the value of this Big negated.
   */ P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return x;
    };
    /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */ P.plus = P.add = function(y) {
        var e, k, t, x = this, Big = x.constructor;
        y = new Big(y);
        // Signs differ?
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (!yc[0]) {
                if (xc[0]) y = new Big(x);
                else y.s = x.s;
            }
            return y;
        }
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: reverse faster than unshifts.
        if (e = xe - ye) {
            if (e > 0) {
                ye = xe;
                t = yc;
            } else {
                e = -e;
                t = xc;
            }
            t.reverse();
            for(; e--;)t.push(0);
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        e = yc.length;
        // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
        for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (k) {
            xc.unshift(k);
            ++ye;
        }
        // Remove trailing zeros.
        for(e = xc.length; xc[--e] === 0;)xc.pop();
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */ P.pow = function(n) {
        var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + "exponent");
        if (isneg) n = -n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isneg ? one.div(y) : y;
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.prec = function(sd, rm) {
        if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
        return round(new this.constructor(this), sd, rm);
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.round = function(dp, rm) {
        if (dp === UNDEFINED) dp = 0;
        else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
        return round(new this.constructor(this), dp + this.e + 1, rm);
    };
    /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.sqrt = function() {
        var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big("0.5");
        // Zero?
        if (!x.c[0]) return new Big(x);
        // Negative?
        if (s < 0) throw Error(NAME + "No square root");
        // Estimate.
        s = Math.sqrt(x + "");
        // Math.sqrt underflow/overflow?
        // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
        if (s === 0 || s === 1 / 0) {
            c = x.c.join("");
            if (!(c.length + e & 1)) c += "0";
            s = Math.sqrt(c);
            e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
            r = new Big((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
        } else r = new Big(s + "");
        e = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            t = r;
            r = half.times(t.plus(x.div(t)));
        }while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
        return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
    };
    /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */ P.times = P.mul = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) {
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--;)c[j] = 0;
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = b;
        }
        // Increment result exponent if there is a final carry, otherwise remove leading zero.
        if (b) ++y.e;
        else c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i];)c.pop();
        y.c = c;
        return y;
    };
    /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toExponential = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), ++dp, rm);
            for(; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, true, !!n);
    };
    /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */ P.toFixed = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), dp + x.e + 1, rm);
            // x.e may have changed if the value is rounded up.
            for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, false, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */ P.toJSON = P.toString = function() {
        var x = this, Big = x.constructor;
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
    };
    /*
   * Return the value of this Big as a primitve number.
   */ P.toNumber = function() {
        var n = Number(stringify(this, true, true));
        if (this.constructor.strict === true && !this.eq(n.toString())) throw Error(NAME + "Imprecise conversion");
        return n;
    };
    /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toPrecision = function(sd, rm) {
        var x = this, Big = x.constructor, n = x.c[0];
        if (sd !== UNDEFINED) {
            if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
            x = round(new Big(x), sd, rm);
            for(; x.c.length < sd;)x.c.push(0);
        }
        return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */ P.valueOf = function() {
        var x = this, Big = x.constructor;
        if (Big.strict === true) throw Error(NAME + "valueOf disallowed");
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
    };
    // Export
    Big = _Big_();
    Big["default"] = Big.Big = Big;
    //AMD.
    if (typeof define === "function" && define.amd) define(function() {
        return Big;
    });
    else if (0, $ad9e9f310a798519$exports) $ad9e9f310a798519$exports = Big;
    else GLOBAL.Big = Big;
})($ad9e9f310a798519$exports);


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $4730acf0753ac89a$export$6acf61af03e62db = typeof window === "undefined";
function $4730acf0753ac89a$export$8793edee2d425525() {
    return undefined;
}
function $4730acf0753ac89a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $4730acf0753ac89a$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $4730acf0753ac89a$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $4730acf0753ac89a$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $4730acf0753ac89a$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $4730acf0753ac89a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $4730acf0753ac89a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $4730acf0753ac89a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg1);
}
function $4730acf0753ac89a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? [
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $4730acf0753ac89a$export$42387eeaac09cf54(arg1, arg2) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $4730acf0753ac89a$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $4730acf0753ac89a$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $4730acf0753ac89a$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $4730acf0753ac89a$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($4730acf0753ac89a$export$5fcb678681417b54(mutation.options.mutationKey) !== $4730acf0753ac89a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $4730acf0753ac89a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $4730acf0753ac89a$export$5fcb678681417b54(queryKey) {
    var asArray = $4730acf0753ac89a$export$4d32d63f64b825b9(queryKey);
    return $4730acf0753ac89a$export$e7f2f041280beb00(asArray);
}
function $4730acf0753ac89a$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $4730acf0753ac89a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $4730acf0753ac89a$export$2f07189bb9fa26a7(a, b) {
    return $4730acf0753ac89a$export$3bc9138b70293839($4730acf0753ac89a$export$4d32d63f64b825b9(a), $4730acf0753ac89a$export$4d32d63f64b825b9(b));
}
function $4730acf0753ac89a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$4730acf0753ac89a$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $4730acf0753ac89a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $4730acf0753ac89a$export$53b83ca8eaab0383(a) && $4730acf0753ac89a$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $4730acf0753ac89a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $4730acf0753ac89a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $4730acf0753ac89a$export$53b83ca8eaab0383(o) {
    if (!$4730acf0753ac89a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$4730acf0753ac89a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $4730acf0753ac89a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $4730acf0753ac89a$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $4730acf0753ac89a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $4730acf0753ac89a$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $4730acf0753ac89a$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $4730acf0753ac89a$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}






var $a326eb7faf36b653$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $a326eb7faf36b653$export$520687f44db6e1ab = new $a326eb7faf36b653$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $71a71a329ca2584f$var$logger = console;
function $71a71a329ca2584f$export$2b1d391cd05230fd() {
    return $71a71a329ca2584f$var$logger;
}
function $71a71a329ca2584f$export$3abbd92f765bee58(newLogger) {
    $71a71a329ca2584f$var$logger = newLogger;
}



var $8806d6a418db4b9d$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $dd382c2a22c34b78$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $dd382c2a22c34b78$export$6bf54661be5b02cf = new $dd382c2a22c34b78$export$86f1af424b2ca4de();





var $8283b4ebace21c13$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $8283b4ebace21c13$export$b113e788b2dd3fdc = new $8283b4ebace21c13$export$58774fb55d5ff7fc();



function $90c5b2b1a5489698$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $90c5b2b1a5489698$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $90c5b2b1a5489698$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $90c5b2b1a5489698$export$986cc6445c1d323(value) {
    return value instanceof $90c5b2b1a5489698$export$a8430ed4188f35a9;
} // CLASS
var $90c5b2b1a5489698$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $90c5b2b1a5489698$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $90c5b2b1a5489698$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $4730acf0753ac89a$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() || !(0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $b3c5b3b704751c57$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $4730acf0753ac89a$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $4730acf0753ac89a$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $4730acf0753ac89a$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $90c5b2b1a5489698$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $55146b963a737dee$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $b3c5b3b704751c57$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));









var $8d56420e30839da2$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $8d56420e30839da2$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $8d56420e30839da2$var$reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $8d56420e30839da2$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $8d56420e30839da2$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $10b6fdd47d933258$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $8d56420e30839da2$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $4730acf0753ac89a$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));







function $73df723cfc461e76$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $73df723cfc461e76$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $73df723cfc461e76$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $73df723cfc461e76$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $73df723cfc461e76$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $73df723cfc461e76$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $73df723cfc461e76$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $73df723cfc461e76$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}


var $13e074efb1ecf7c6$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $55146b963a737dee$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $10b6fdd47d933258$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $73df723cfc461e76$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(queryKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(mutationKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $d0188f2d930898c2$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).unstable_batchedUpdates;


(0, $a326eb7faf36b653$export$520687f44db6e1ab).setBatchNotifyFunction((0, $d0188f2d930898c2$export$c78a37762a8d58e1));



var $a9338c6a303143c8$export$af88d00dbe7f521 = console;


(0, $71a71a329ca2584f$export$3abbd92f765bee58)((0, $a9338c6a303143c8$export$af88d00dbe7f521));



var $acw62 = parcelRequire("acw62");
var $ccb8f828cefd6075$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $ccb8f828cefd6075$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $ccb8f828cefd6075$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $ccb8f828cefd6075$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $ccb8f828cefd6075$var$defaultContext;
}
var $ccb8f828cefd6075$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $ccb8f828cefd6075$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $ccb8f828cefd6075$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ccb8f828cefd6075$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $acw62 = parcelRequire("acw62");







var $d69ec76a7f524d37$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $8d56420e30839da2$export$a1659b54bac3252a)();
        var result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $a92a0ee821c291b8$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $0bcdd0ea2a5866d5$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $4730acf0753ac89a$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $d69ec76a7f524d37$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}










var $461f073e5b72a6b1$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($461f073e5b72a6b1$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp("error");
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.options.enabled === false || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $461f073e5b72a6b1$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = "loading";
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && (status === "loading" || status === "idle")) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        var result = {
            status: status,
            isLoading: status === "loading",
            isSuccess: status === "success",
            isError: status === "error",
            isIdle: status === "idle",
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== "loading",
            isLoadingError: status === "error" && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === "error" && state.dataUpdatedAt !== 0,
            isStale: $461f073e5b72a6b1$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === "tracked" && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === "tracked" ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $4730acf0753ac89a$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error" && !(0, $90c5b2b1a5489698$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    };
    return QueryObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
function $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $461f073e5b72a6b1$var$shouldFetchOnMount(query, options) {
    return $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $461f073e5b72a6b1$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $461f073e5b72a6b1$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $461f073e5b72a6b1$var$isStale(query, options);
    }
    return false;
}
function $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $461f073e5b72a6b1$var$isStale(query, options);
}
function $461f073e5b72a6b1$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $af499ad4852a56cf$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $af499ad4852a56cf$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($af499ad4852a56cf$var$createValue()); // HOOK
var $af499ad4852a56cf$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($af499ad4852a56cf$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $af499ad4852a56cf$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $af499ad4852a56cf$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af499ad4852a56cf$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




function $02303e84e5b435f8$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $af499ad4852a56cf$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === "tracked") result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $369f47a093b8c0cf$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $02303e84e5b435f8$export$fff0865807e996c5)(parsedOptions, (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c));
}



var $acw62 = parcelRequire("acw62");






var $3fe6fab6545cf77d$export$15352e437905ad4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueriesObserver, _Subscribable);
    function QueriesObserver(client, queries) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.queries = [];
        _this.result = [];
        _this.observers = [];
        _this.observersMap = {};
        if (queries) _this.setQueries(queries);
        return _this;
    }
    var _proto = QueriesObserver.prototype;
    _proto.onSubscribe = function onSubscribe() {
        var _this2 = this;
        if (this.listeners.length === 1) this.observers.forEach(function(observer) {
            observer.subscribe(function(result) {
                _this2.onUpdate(observer, result);
            });
        });
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.observers.forEach(function(observer) {
            observer.destroy();
        });
    };
    _proto.setQueries = function setQueries(queries, notifyOptions) {
        this.queries = queries;
        this.updateObservers(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.result;
    };
    _proto.getOptimisticResult = function getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map(function(match) {
            return match.observer.getOptimisticResult(match.defaultedQueryOptions);
        });
    };
    _proto.findMatchingObservers = function findMatchingObservers(queries) {
        var _this3 = this;
        var prevObservers = this.observers;
        var defaultedQueryOptions = queries.map(function(options) {
            return _this3.client.defaultQueryObserverOptions(options);
        });
        var matchingObservers = defaultedQueryOptions.flatMap(function(defaultedOptions) {
            var match = prevObservers.find(function(observer) {
                return observer.options.queryHash === defaultedOptions.queryHash;
            });
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        var matchedQueryHashes = matchingObservers.map(function(match) {
            return match.defaultedQueryOptions.queryHash;
        });
        var unmatchedQueries = defaultedQueryOptions.filter(function(defaultedOptions) {
            return !matchedQueryHashes.includes(defaultedOptions.queryHash);
        });
        var unmatchedObservers = prevObservers.filter(function(prevObserver) {
            return !matchingObservers.some(function(match) {
                return match.observer === prevObserver;
            });
        });
        var newOrReusedObservers = unmatchedQueries.map(function(options, index) {
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                var previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: _this3.getObserver(options)
            };
        });
        var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
            return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        };
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    };
    _proto.getObserver = function getObserver(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var currentObserver = this.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c)(this.client, defaultedOptions);
    };
    _proto.updateObservers = function updateObservers(notifyOptions) {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            var prevObservers = _this4.observers;
            var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach(function(match) {
                return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
            });
            var newObservers = newObserverMatches.map(function(match) {
                return match.observer;
            });
            var newObserversMap = Object.fromEntries(newObservers.map(function(observer) {
                return [
                    observer.options.queryHash,
                    observer
                ];
            }));
            var newResult = newObservers.map(function(observer) {
                return observer.getCurrentResult();
            });
            var hasIndexChange = newObservers.some(function(observer, index) {
                return observer !== prevObservers[index];
            });
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            _this4.observers = newObservers;
            _this4.observersMap = newObserversMap;
            _this4.result = newResult;
            if (!_this4.hasListeners()) return;
            (0, $4730acf0753ac89a$export$acaf96a27438246b)(prevObservers, newObservers).forEach(function(observer) {
                observer.destroy();
            });
            (0, $4730acf0753ac89a$export$acaf96a27438246b)(newObservers, prevObservers).forEach(function(observer) {
                observer.subscribe(function(result) {
                    _this4.onUpdate(observer, result);
                });
            });
            _this4.notify();
        });
    };
    _proto.onUpdate = function onUpdate(observer, result) {
        var index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $4730acf0753ac89a$export$224e3b7078227b8a)(this.result, index, result);
            this.notify();
        }
    };
    _proto.notify = function notify() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.listeners.forEach(function(listener) {
                listener(_this5.result);
            });
        });
    };
    return QueriesObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $990eb380e3560bcc$export$408667c6c87da1e5(queries) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var defaultedQueries = (0, $acw62.useMemo)(function() {
        return queries.map(function(options) {
            var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions.optimisticResults = true;
            return defaultedOptions;
        });
    }, [
        queries,
        queryClient
    ]);
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new (0, $3fe6fab6545cf77d$export$15352e437905ad4c)(queryClient, defaultedQueries);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedQueries);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    return result;
}









var $6d82b87c0cff5ff1$exports = {};
$6d82b87c0cff5ff1$exports = {
    ReactQueryDevtools: function() {
        return null;
    },
    ReactQueryDevtoolsPanel: function() {
        return null;
    }
};


const $99cd6d6a768f3807$export$463d32b91de8b4d = {
    twitter: "https://twitter.com/RoeFinance",
    discord: "https://dsc.gg/roefinance",
    medium: "https://medium.com/@Roefinance",
    privacyPolicy: "https://github.com/RoeFinance/roe-docs/blob/main/Privacy_Policy.pdf",
    termsAndConditions: "https://github.com/RoeFinance/roe-docs/blob/main/Terms.pdf",
    gitBook: "https://docs.roe.finance/roe-finance",
    gitBookSupply: "https://docs.roe.finance/roe-finance/products/supply",
    gitBookTrade: "https://docs.roe.finance/roe-finance/products/trade",
    gitBookIntroduction: "https://docs.roe.finance/roe-finance/introduction/first-time-here",
    gitHub: "https://github.com/RoeFinance/RoeMarkets",
    roeSupply: "https://supply.roe.finance",
    roeTrade: "https://trade.roe.finance",
    tradeProfitCalculator: "https://docs.google.com/spreadsheets/d/1pcYrg6hoePTzw96faph2g1cH8rVMRp87gcSsBS4HykQ",
    crew3Quest: "https://google.com"
};



var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;


var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;


function $6bb1e54ce1bc6efa$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $6bb1e54ce1bc6efa$export$2e2bcd8739ae039 = $6bb1e54ce1bc6efa$var$memoize;


var $4a3f4fcffc4e4ba8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $4a3f4fcffc4e4ba8$var$isPropValid = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $4a3f4fcffc4e4ba8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $4a3f4fcffc4e4ba8$export$2e2bcd8739ae039 = $4a3f4fcffc4e4ba8$var$isPropValid;


var $72623ab6bcb0a33b$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;



var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$v() {
    return ($f8dbcd8598db1f0b$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $3251146683c5d714$exports.typeOf)(t);
}, $f8dbcd8598db1f0b$var$w = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$b(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$A = ("undefined" != typeof $hPtJY && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.5", $f8dbcd8598db1f0b$var$I = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $hPtJY, typeof $hPtJY, false)), $f8dbcd8598db1f0b$var$O = {}, $f8dbcd8598db1f0b$var$R = {};
function $f8dbcd8598db1f0b$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = new Map, $f8dbcd8598db1f0b$var$V = 1, $f8dbcd8598db1f0b$var$B = function(e) {
    if ($f8dbcd8598db1f0b$var$x.has(e)) return $f8dbcd8598db1f0b$var$x.get(e);
    for(; $f8dbcd8598db1f0b$var$k.has($f8dbcd8598db1f0b$var$V);)$f8dbcd8598db1f0b$var$V++;
    var t = $f8dbcd8598db1f0b$var$V++;
    return $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e), t;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$k.get(e);
}, $f8dbcd8598db1f0b$var$M = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$V && ($f8dbcd8598db1f0b$var$V = t + 1), $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e);
}, $f8dbcd8598db1f0b$var$G = "style[" + $f8dbcd8598db1f0b$var$A + '][data-styled-version="5.3.5"]', $f8dbcd8598db1f0b$var$L = new RegExp("^" + $f8dbcd8598db1f0b$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$M(u, c), $f8dbcd8598db1f0b$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$A, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var i = $f8dbcd8598db1f0b$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$J = $f8dbcd8598db1f0b$var$I, $f8dbcd8598db1f0b$var$X = {
    isServer: !$f8dbcd8598db1f0b$var$I,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$P
}, $f8dbcd8598db1f0b$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$v({}, $f8dbcd8598db1f0b$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$I && $f8dbcd8598db1f0b$var$J && ($f8dbcd8598db1f0b$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$A) && ($f8dbcd8598db1f0b$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$U(o) : r ? new $f8dbcd8598db1f0b$var$$(o) : new $f8dbcd8598db1f0b$var$W(o), new $f8dbcd8598db1f0b$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$K = /(a)(d)/gi, $f8dbcd8598db1f0b$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$Q(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$Q(t % 52) + n).replace($f8dbcd8598db1f0b$var$K, "$1-$2");
}
var $f8dbcd8598db1f0b$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$ne = function(e) {
    return $f8dbcd8598db1f0b$var$te(5381, e);
};
function $f8dbcd8598db1f0b$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$b(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$oe = $f8dbcd8598db1f0b$var$ne("5.3.5"), $f8dbcd8598db1f0b$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$re(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$oe, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$Ne(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$ie = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$E : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$w : c, l = new (0, $9a1e650477d9d52e$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$j(15), $f8dbcd8598db1f0b$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$he = ($f8dbcd8598db1f0b$var$de.Consumer, new $f8dbcd8598db1f0b$var$Z), $f8dbcd8598db1f0b$var$pe = $f8dbcd8598db1f0b$var$ce();
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$var$me() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$de) || $f8dbcd8598db1f0b$var$pe;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$fe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$pe), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ge = /([A-Z])/, $f8dbcd8598db1f0b$var$Se = /([A-Z])/g, $f8dbcd8598db1f0b$var$we = /^ms-/, $f8dbcd8598db1f0b$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$be(e) {
    return $f8dbcd8598db1f0b$var$ge.test(e) ? e.replace($f8dbcd8598db1f0b$var$Se, $f8dbcd8598db1f0b$var$Ee).replace($f8dbcd8598db1f0b$var$we, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$_e(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$b(t[i]) ? s.push($f8dbcd8598db1f0b$var$be(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $d9263a4c6739b952$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$b(e) || $f8dbcd8598db1f0b$var$S(e) ? $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g($f8dbcd8598db1f0b$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g(e, n)));
}
var $f8dbcd8598db1f0b$var$Ie = /invalid hook call/i, $f8dbcd8598db1f0b$var$Pe = new Set, $f8dbcd8598db1f0b$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Re = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$je = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$Te(e) {
    return e.replace($f8dbcd8598db1f0b$var$De, "-").replace($f8dbcd8598db1f0b$var$je, "");
}
var $f8dbcd8598db1f0b$var$xe = function(e) {
    return $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$ne(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$ke(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$ze(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$Ve(t) && $f8dbcd8598db1f0b$var$Ve(r) ? $f8dbcd8598db1f0b$var$Me(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$Ve(i)) for(var a in i)$f8dbcd8598db1f0b$var$Be(a) && $f8dbcd8598db1f0b$var$ze(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$j(14);
            if ($f8dbcd8598db1f0b$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$j(8) : t ? $f8dbcd8598db1f0b$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ye = {};
function $f8dbcd8598db1f0b$var$qe(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$ke(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$Te(e);
        $f8dbcd8598db1f0b$var$Ye[n] = ($f8dbcd8598db1f0b$var$Ye[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$xe("5.3.5" + n + $f8dbcd8598db1f0b$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $f8dbcd8598db1f0b$var$ke(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $f8dbcd8598db1f0b$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$E);
                var r = $f8dbcd8598db1f0b$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Re(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$fe(), s = $f8dbcd8598db1f0b$var$me(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $f8dbcd8598db1f0b$var$ke(_), A = g !== t ? $f8dbcd8598db1f0b$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $4a3f4fcffc4e4ba8$export$2e2bcd8739ae039), _) : !N || (0, $4a3f4fcffc4e4ba8$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $f8dbcd8598db1f0b$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $acw62.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$ke(e) ? e : $f8dbcd8598db1f0b$var$Te($f8dbcd8598db1f0b$var$_(e)));
        return $f8dbcd8598db1f0b$var$qe(e, $f8dbcd8598db1f0b$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !(0, $3251146683c5d714$exports.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$j(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$He[e] = $f8dbcd8598db1f0b$var$He(e);
});
var $f8dbcd8598db1f0b$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$re(e), $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$xe(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$$e(i, a);
    function l(e) {
        var t = $f8dbcd8598db1f0b$var$fe(), n = $f8dbcd8598db1f0b$var$me(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), l = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$O, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$v({}, t, {
                theme: $f8dbcd8598db1f0b$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$xe(o);
    return new $f8dbcd8598db1f0b$var$ve(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$A + '="true"',
                'data-styled-version="5.3.5"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$j(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$A] = "", t["data-styled-version"] = "5.3.5", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$j(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$_(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Z,
    masterSheet: $f8dbcd8598db1f0b$var$he
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$He;



const $f795f85f6d7c50c9$export$2b77a92f1a5ad772 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-yjkdvo-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "maxWidth": "24rem",
    "padding": "1rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderRadius": "1.5rem",
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))",
    "@media (min-width: 640px)": {
        "padding": "1.5rem"
    }
});




const $ee6df5c9947f7a82$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $f795f85f6d7c50c9$export$2b77a92f1a5ad772)).withConfig({
    componentId: "sc-je0vpe-0"
})({
    "gap": "1rem",
    "paddingLeft": "1.25rem",
    "paddingRight": "1.25rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem"
});
const $ee6df5c9947f7a82$export$8b251419efc915eb = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-je0vpe-1"
})({
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $ee6df5c9947f7a82$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-je0vpe-2"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.75rem"
});
const $ee6df5c9947f7a82$export$a06f1c675e846f6f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-je0vpe-3"
})({
    "fontWeight": "500",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "textAlign": "center",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem"
});
const $ee6df5c9947f7a82$export$e0513c91be1318ca = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.withConfig({
    componentId: "sc-je0vpe-4"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(52, 105, 250, var(--tw-text-opacity))"
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0bc79745b9fc41e5$export$33ffd74ebf07f060 = ()=>(0, $acw62.useContext)((0, $7ba40f9fe3eefc5f$export$ab57792b9b6974a6));




var $acw62 = parcelRequire("acw62");


const $6ee4eb9811c1da47$export$ea4c5d0fd6b9cf98 = new Map((0, $256cfab3646322b9$export$80ade7c548160012).map((config)=>[
        config.chainId,
        config
    ]));
const $6ee4eb9811c1da47$export$703a843624f42e6c = (chainId)=>{
    const chainConfig = $6ee4eb9811c1da47$export$ea4c5d0fd6b9cf98.get(chainId);
    if (chainConfig) return chainConfig;
    return (0, $256cfab3646322b9$export$80ade7c548160012)[0];
};


const $c5d83ab7f6cc48d2$export$f1dc06d76b316271 = (chainId)=>{
    const { title: title, nativeCurrency: nativeCurrency, providers: providers, urls: urls } = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    const { name: name, symbol: symbol } = nativeCurrency;
    const { rpc: rpc } = providers;
    const { explorer: explorer } = urls;
    return {
        chainId: chainId,
        chainName: title,
        nativeCurrency: {
            name: name,
            symbol: symbol,
            decimals: 18
        },
        rpcUrls: [
            rpc
        ],
        blockExplorerUrls: [
            explorer
        ]
    };
};



var $acw62 = parcelRequire("acw62");
const $47bd16473dc44a09$export$ad294aa86b32df5a = "lastConnectedWalletType";



const $3dd491d04fdd240e$export$1659f95f98d29f1 = ()=>{
    const rawLastWalletType = localStorage.getItem((0, $47bd16473dc44a09$export$ad294aa86b32df5a));
    const lastWalletType = rawLastWalletType && rawLastWalletType in (0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9) ? rawLastWalletType : undefined;
    const setLastWalletType = (0, $acw62.useCallback)((walletType)=>{
        localStorage.setItem((0, $47bd16473dc44a09$export$ad294aa86b32df5a), walletType);
    }, []);
    const removeLastWalletType = (0, $acw62.useCallback)(()=>{
        localStorage.removeItem((0, $47bd16473dc44a09$export$ad294aa86b32df5a));
    }, []);
    return {
        lastWalletType: lastWalletType,
        setLastWalletType: setLastWalletType,
        removeLastWalletType: removeLastWalletType
    };
};


const $75e390eec3a10f89$export$c34addee860b0acb = ()=>{
    const { connector: connectedConnector, provider: provider, chainId: chainId, account: account, isActivating: isConnecting, isActive: isConnected } = (0, $21dacc32874bba56$exports.useWeb3React)();
    const { setLastWalletType: setLastWalletType, removeLastWalletType: removeLastWalletType } = (0, $3dd491d04fdd240e$export$1659f95f98d29f1)();
    const connect = (0, $acw62.useCallback)(async (walletType)=>{
        const [connector] = (0, $5eec0ea54595fadd$export$b21745c80acb63b0)[walletType];
        await connector.activate();
        setLastWalletType(walletType);
    }, [
        setLastWalletType
    ]);
    const disconnect = (0, $acw62.useCallback)(()=>{
        (async ()=>{
            await connectedConnector.deactivate();
            removeLastWalletType();
        })();
    }, [
        connectedConnector,
        removeLastWalletType
    ]);
    const switchChainId = (0, $acw62.useCallback)(async (nextChainId)=>{
        const chainParameters = (0, $c5d83ab7f6cc48d2$export$f1dc06d76b316271)(nextChainId);
        await connectedConnector.activate(chainParameters);
    }, [
        connectedConnector
    ]);
    return {
        account: account,
        chainId: chainId,
        provider: provider,
        isConnected: isConnected,
        isConnecting: isConnecting,
        switchChainId: switchChainId,
        connect: connect,
        disconnect: disconnect
    };
};


var $0eddc7f87de4a7d4$exports = {};

$0eddc7f87de4a7d4$exports = new URL((parcelRequire("27Lyk")).resolve("9wcDE"), import.meta.url).toString();


var $0c4c46938b3a256b$exports = {};

$0c4c46938b3a256b$exports = new URL((parcelRequire("27Lyk")).resolve("iQPAT"), import.meta.url).toString();


var $3659f4c7a7791554$exports = {};

$3659f4c7a7791554$exports = new URL((parcelRequire("27Lyk")).resolve("fJuFa"), import.meta.url).toString();


var $5b3c09e03456c9a0$exports = {};

$5b3c09e03456c9a0$exports = new URL((parcelRequire("27Lyk")).resolve("1Gmkl"), import.meta.url).toString();





const $868a5f18bbac93b3$export$658d9d9e42d1e3e6 = {
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).METAMASK]: {
        title: "MetaMask",
        iconSource: (0, (/*@__PURE__*/$parcel$interopDefault($0eddc7f87de4a7d4$exports)))
    },
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).WALLET_CONNECT]: {
        title: "WalletConnect",
        iconSource: (0, (/*@__PURE__*/$parcel$interopDefault($0c4c46938b3a256b$exports)))
    },
    [(0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).COINBASE]: {
        title: "Coinbase Wallet",
        iconSource: (0, (/*@__PURE__*/$parcel$interopDefault($3659f4c7a7791554$exports)))
    }
};




const $be288bf3e759632e$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1998utq-0"
})([
    "",
    " ",
    " ",
    ""
], {
    "transitionProperty": "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "borderWidth": "2px",
    "borderRadius": "0.5rem",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(54, 56, 63, var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "fontWeight": "600",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
}, ({ disabled: disabled = false })=>disabled ? {
        "opacity": "0.6",
        "cursor": "not-allowed"
    } : {
        ":hover": {
            "--tw-text-opacity": "1",
            "color": "rgba(52, 105, 250, var(--tw-text-opacity))",
            "--tw-border-opacity": "1",
            "borderColor": "rgba(52, 105, 250, var(--tw-border-opacity))"
        },
        ":active": {
            "--tw-scale-x": ".9",
            "--tw-scale-y": ".9",
            "transform": "var(--tw-transform)"
        }
    }, ({ isError: isError = false })=>isError && {
        "--tw-text-opacity": "1",
        "color": "rgba(220, 38, 38, var(--tw-text-opacity))",
        "--tw-border-opacity": "1",
        "borderColor": "rgba(220, 38, 38, var(--tw-border-opacity))"
    });





const $9c3d0fc45ccacf57$export$f04a61298a47a40f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1kwq3m0-0"
})({
    "objectFit": "contain"
});




const $e277dff9a8d7c0e7$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-8bkq58-0"
})({
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "borderStyle": "none",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))"
    },
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(62, 68, 83, var(--tw-bg-opacity))",
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "borderRadius": "0.5rem"
});
const $e277dff9a8d7c0e7$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-8bkq58-1"
})({
    "display": "flex",
    "justifyContent": "space-between",
    "alignItems": "center"
});
const $e277dff9a8d7c0e7$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-8bkq58-2"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "1.25rem"
});
const $e277dff9a8d7c0e7$export$deff84e7338ee5a5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-8bkq58-3"
})({
    "width": "1.75rem"
});
const $e277dff9a8d7c0e7$export$fec93b5f1e2bccb4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-8bkq58-4"
})({
    "width": "1rem"
});



const $c819689014f943b2$export$eab4424f030fcb21 = ({ walletType: walletType })=>{
    const { connect: connect } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { popModal: popModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    const connectWallet = (0, $acw62.useCallback)(()=>{
        (async ()=>{
            await connect(walletType);
            popModal();
        })();
    }, [
        connect,
        walletType,
        popModal
    ]);
    const { title: title, iconSource: iconSource } = (0, $868a5f18bbac93b3$export$658d9d9e42d1e3e6)[walletType];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e277dff9a8d7c0e7$export$353f5b6fc5456de1), {
        onClick: connectWallet,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e277dff9a8d7c0e7$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e277dff9a8d7c0e7$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e277dff9a8d7c0e7$export$deff84e7338ee5a5), {
                        src: iconSource
                    }),
                    title
                ]
            })
        })
    });
};



const $52a10aa693e23096$export$e25981b208cc50fb = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee6df5c9947f7a82$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6df5c9947f7a82$export$8b251419efc915eb), {
                children: "Connect wallet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee6df5c9947f7a82$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c819689014f943b2$export$eab4424f030fcb21), {
                        walletType: (0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).METAMASK
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c819689014f943b2$export$eab4424f030fcb21), {
                        walletType: (0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).WALLET_CONNECT
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c819689014f943b2$export$eab4424f030fcb21), {
                        walletType: (0, $ce6e1f58ef2116bb$export$5d6973e21e6f88d9).COINBASE
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee6df5c9947f7a82$export$a06f1c675e846f6f), {
                children: [
                    "By connecting your wallet, you agree to our",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6df5c9947f7a82$export$e0513c91be1318ca), {
                        href: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).termsAndConditions,
                        target: "_blank",
                        children: "Terms and Conditions"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6df5c9947f7a82$export$e0513c91be1318ca), {
                        href: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).privacyPolicy,
                        target: "_blank",
                        children: "Privacy Policy"
                    })
                ]
            })
        ]
    });



var $acw62 = parcelRequire("acw62");

const $420decebc72e5343$export$e77e7f4d34d3c08d = ()=>localStorage.getItem("isDisclaimerShown");
const $420decebc72e5343$export$89c2504c66931ce7 = ()=>{
    localStorage.setItem("isDisclaimerShown", "true");
};





const $524574528501fe7f$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $f795f85f6d7c50c9$export$2b77a92f1a5ad772)).withConfig({
    componentId: "sc-1d3tre3-0"
})({
    "gap": "1rem",
    "paddingLeft": "1.25rem",
    "paddingRight": "1.25rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "maxWidth": "432px",
    "width": "100%"
});
const $524574528501fe7f$export$8b251419efc915eb = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h1.withConfig({
    componentId: "sc-1d3tre3-1"
})({
    "display": "flex",
    "justifyContent": "center",
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $524574528501fe7f$export$358a232cca1ab2ac = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p.withConfig({
    componentId: "sc-1d3tre3-2"
})({
    "marginBottom": "1rem"
});
const $524574528501fe7f$export$a06f1c675e846f6f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1d3tre3-3"
})({
    "fontWeight": "500",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "textAlign": "center",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem"
});
const $524574528501fe7f$export$379e952c4af8f97 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-1d3tre3-4"
})([
    "",
    " ",
    ""
], {
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(59, 153, 252, var(--tw-bg-opacity))",
    "borderStyle": "none",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(23, 115, 213, var(--tw-bg-opacity))"
    }
}, ({ disabled: disabled })=>disabled && {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(150, 150, 150, var(--tw-bg-opacity))",
        ":hover": {
            "--tw-bg-opacity": "1",
            "backgroundColor": "rgba(150, 150, 150, var(--tw-bg-opacity))"
        }
    });
const $524574528501fe7f$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1d3tre3-5"
})([
    "",
    " ul{",
    " li{",
    " &::after{",
    "}}}"
], {
    "maxHeight": "448px",
    "height": "100%",
    "overflowY": "auto",
    "--tw-text-opacity": "1",
    "color": "rgba(150, 150, 150, var(--tw-text-opacity))",
    "fontWeight": "500"
}, {
    "paddingLeft": "1.25rem",
    "paddingRight": "0.25rem"
}, {
    "position": "relative",
    "paddingBottom": "1rem"
}, {
    "content": '""',
    "width": "5px",
    "height": "5px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(150, 150, 150, var(--tw-bg-opacity))",
    "borderRadius": "9999px",
    "position": "absolute",
    "left": "-1rem",
    "top": "10px"
});



const $61993cced2f2a7e1$export$325b16bac8018e2e = ()=>{
    const { hideModal: hideModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    const contentReference = (0, $acw62.useRef)(null);
    const [isDisclaimerReaded, setIsDisclaimerReaded] = (0, $acw62.useState)(false);
    const onScroll = ()=>{
        const { scrollTop: scrollTop, clientHeight: clientHeight, scrollHeight: scrollHeight } = contentReference?.current ?? {
            scrollTop: 0,
            clientHeight: 0,
            scrollHeight: 0
        };
        const isFullyScrolled = scrollTop + clientHeight >= scrollHeight;
        if (!isDisclaimerReaded) setIsDisclaimerReaded(isFullyScrolled);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $524574528501fe7f$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $524574528501fe7f$export$8b251419efc915eb), {
                children: "Terms of Service"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $524574528501fe7f$export$7c6e2c02157bb7d2), {
                onScroll: onScroll,
                ref: contentReference,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $524574528501fe7f$export$358a232cca1ab2ac), {
                        children: "By clicking “I agree” below, you agree to be bound by the terms of this Agreement. As such, you fully understand that:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "ROE Finance is a blockchain-based decentralized finance project. You are participating at your own risk."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "ROE Finance is offered for use “as is” and without any guarantees regarding security. The protocol is made up of immutable code and can be accessed through a variety of user interfaces."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "No central entity operates the ROE Finance protocol. Decisions related to the protocol are governed by a dispersed group of participants who collectively govern and maintain the protocol."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "ROE Finance does not unilaterally offer, maintain, operate, administer, or control any trading interfaces. The only user interfaces maintained by ROE Finance are the governance and staking interfaces herein."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "You can participate in the governance process by staking SNX tokens in accordance with the rules and parameters summarized here, and/or joining the Synthetix Discord and contributing to the conversation."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "The rules and parameters associated with the Synthetix protocol and Synthetix DAO governance are subject to change at any time."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "Your use of Synthetix is conditioned upon your acceptance to be bound by the Synthetix Term of Use, which can be found here."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "The laws that apply to your use of Synthetix may vary based upon the jurisdiction in which you are located. We strongly encourage you to speak with legal counsel in your jurisdiction if you have any questions regarding your use of Synthetix."
                            }),
                            " ",
                            "By entering into this agreement, you are not agreeing to enter into a partnership. You understand that Synthetix is a decentralized protocol provided on an “as is” basis.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "You hereby release all present and future claims against Synthetix DAO related to your use of the protocol, the SNX token, SNX DAO governance, and any other facet of the protocol."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "You agree to indemnify and hold harmless SNX DAO and its affiliates for any costs arising out of or relating to your use of the Synthetix protocol."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "You are not accessing the protocol from Burma (Myanmar), Cuba, Iran, Sudan, Syria, the Western Balkans, Belarus, C\xf4te d’Ivoire, Democratic Republic of the Congo, Iraq, Lebanon, Liberia, Libya, North Korea, Russia, certain sanctioned areas of Ukraine, Somalia, Venezuela, Yemen, or Zimbabwe (collectively, “Prohibited Jurisdictions”), or any other jurisdiction listed as a Specially Designated National by the United States Office of Foreign Asset Control (“OFAC”)."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $524574528501fe7f$export$a06f1c675e846f6f), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $524574528501fe7f$export$379e952c4af8f97), {
                    disabled: !isDisclaimerReaded,
                    onClick: ()=>{
                        (0, $420decebc72e5343$export$89c2504c66931ce7)();
                        hideModal();
                    },
                    children: "I agree"
                })
            })
        ]
    });
};



const $39a9b22a0e28d503$export$30f78adcaaa2eb7 = (value)=>new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(value.toString());
const $39a9b22a0e28d503$export$fb01dd61d0afd9de = (value)=>new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(10).pow(value);
const $39a9b22a0e28d503$export$6904811048a20190 = ()=>new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(0);


const $c33fe5be75c498d7$export$77e06e799013588a = {
    tokenData: undefined,
    inputValue: "",
    setInputValue: ()=>undefined,
    inputValueBig: (0, $39a9b22a0e28d503$export$6904811048a20190)(),
    isError: false,
    error: undefined
};


var $86c0cfc9656a567e$export$12eeba8c72faa230;
(function(TokenInputError) {
    TokenInputError["INSUFFICIENT_TOKEN_BALANCE"] = "INSUFFICIENT_TOKEN_BALANCE";
    TokenInputError["INSUFFICIENT_TOKEN_INPUT"] = "INSUFFICIENT_TOKEN_INPUT";
    TokenInputError["UNKNOWN"] = "UNKNOWN";
})($86c0cfc9656a567e$export$12eeba8c72faa230 || ($86c0cfc9656a567e$export$12eeba8c72faa230 = {}));



const $feb73828867e3133$export$e3cb40993f38d6be = (value, tokenData)=>tokenData?.balance && value.gt((0, $39a9b22a0e28d503$export$6904811048a20190)()) ? tokenData.balance.lt(value) : false;
const $feb73828867e3133$export$b31436da9c02311c = (value, tokenData)=>tokenData && value.gt((0, $39a9b22a0e28d503$export$6904811048a20190)()) ? tokenData.allowance.lt(value) : false;
const $feb73828867e3133$export$ff2de70b3eabebde = (value, tokenData)=>tokenData && value.gt((0, $39a9b22a0e28d503$export$6904811048a20190)()) ? (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(-tokenData.decimals).gt(value) : false;


const $7481d344cad456e1$export$6509b2465401b583 = (value, tokenData)=>{
    if ((0, $feb73828867e3133$export$e3cb40993f38d6be)(value, tokenData)) return (0, $86c0cfc9656a567e$export$12eeba8c72faa230).INSUFFICIENT_TOKEN_BALANCE;
    if ((0, $feb73828867e3133$export$ff2de70b3eabebde)(value, tokenData)) return (0, $86c0cfc9656a567e$export$12eeba8c72faa230).INSUFFICIENT_TOKEN_INPUT;
    return undefined;
};



const $d105c29cf7169379$export$55c2201905ba0b8d = (inputValue)=>inputValue ? (0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(inputValue) : (0, $39a9b22a0e28d503$export$6904811048a20190)();



var $acw62 = parcelRequire("acw62");
const $b24cf0b5fa9d389a$export$b5d303c2a6ccf5e1 = (address)=>`${address.slice(0, 6)}...${address.slice(-4)}`;
const $b24cf0b5fa9d389a$export$9e1af1a79ed2c7c7 = (address0, address1)=>address0.toLowerCase() === address1.toLowerCase();



const $287c4ac331c75a82$export$31b943359438ed84 = (chainId)=>{
    const chainConfig = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    return chainConfig.addresses.wrappedNativeCoinAddress;
};


const $c692ba37486e1b48$export$e2d78002650b3b1 = (defaultTokens, nativeCoinData, chainId)=>{
    const defaultTokenDataAddress = defaultTokens[0]?.address;
    const [tokenDataAddress, setTokenDataAddress] = (0, $acw62.useState)(defaultTokenDataAddress);
    (0, $acw62.useEffect)(()=>{
        setTokenDataAddress(defaultTokenDataAddress);
    }, [
        defaultTokenDataAddress
    ]);
    const wrappedNativeCoinAddress = chainId ? (0, $287c4ac331c75a82$export$31b943359438ed84)(chainId) : null;
    const wrappedNativeCoinDataIndex = defaultTokens.findIndex((tokenData)=>tokenData && wrappedNativeCoinAddress ? (0, $b24cf0b5fa9d389a$export$9e1af1a79ed2c7c7)(tokenData.address, wrappedNativeCoinAddress) : false);
    const shouldAddNativeCoinData = nativeCoinData && wrappedNativeCoinDataIndex >= 0;
    const tokensWithNativeCoin = [
        ...defaultTokens.slice(0, wrappedNativeCoinDataIndex + 1),
        nativeCoinData,
        ...defaultTokens.slice(wrappedNativeCoinDataIndex + 1)
    ];
    const tokens = shouldAddNativeCoinData ? tokensWithNativeCoin : defaultTokens;
    const tokenData = tokens.find((token)=>token?.address === tokenDataAddress);
    return [
        tokenData,
        tokens,
        setTokenDataAddress
    ];
};



var $acw62 = parcelRequire("acw62");
const $97040645fc5a577a$export$5bc6031dcd0c59f7 = (pair)=>{
    const { token0: token0, token1: token1 } = pair;
    return `${token0.symbol}-${token1.symbol}`;
};



var $2599ca2123527e27$export$7c8e26efb80b90e8;
(function(QueryType) {
    QueryType["TOKEN"] = "TOKEN";
    QueryType["PAIRS_SWAP_FEES"] = "PAIRS_SWAP_FEES";
})($2599ca2123527e27$export$7c8e26efb80b90e8 || ($2599ca2123527e27$export$7c8e26efb80b90e8 = {}));



const $4401935ec9f1441c$export$b13ad920efa14713 = "NATIVE_COIN_ADDRESS";


const $17ea153afdabe1fb$export$cf2a895cd8b3d7b6 = (tokenAddress)=>(0, $b24cf0b5fa9d389a$export$9e1af1a79ed2c7c7)(tokenAddress, (0, $4401935ec9f1441c$export$b13ad920efa14713));
const $17ea153afdabe1fb$export$81809787e85049ab = (tokenData)=>$17ea153afdabe1fb$export$cf2a895cd8b3d7b6(tokenData.address);


var $4263977a5a9a6ac1$exports = {};

$parcel$export($4263977a5a9a6ac1$exports, "AddressZero", () => $a7aab4b2e8ff7109$export$badd13187c087617);
$parcel$export($4263977a5a9a6ac1$exports, "NegativeOne", () => $23a6ae12d38ed7fa$export$c83ef0909a6ddeec);
$parcel$export($4263977a5a9a6ac1$exports, "Zero", () => $23a6ae12d38ed7fa$export$aaef8a3eae948f03);
$parcel$export($4263977a5a9a6ac1$exports, "One", () => $23a6ae12d38ed7fa$export$9aa05a5866350bcf);
$parcel$export($4263977a5a9a6ac1$exports, "Two", () => $23a6ae12d38ed7fa$export$9276dd97bf62cc8d);
$parcel$export($4263977a5a9a6ac1$exports, "WeiPerEther", () => $23a6ae12d38ed7fa$export$c8db55bd7405209e);
$parcel$export($4263977a5a9a6ac1$exports, "MaxUint256", () => $23a6ae12d38ed7fa$export$1b53890de5aabdd0);
$parcel$export($4263977a5a9a6ac1$exports, "MinInt256", () => $23a6ae12d38ed7fa$export$963c9b9317b80aaf);
$parcel$export($4263977a5a9a6ac1$exports, "MaxInt256", () => $23a6ae12d38ed7fa$export$6f8dbb07ebe6d738);
$parcel$export($4263977a5a9a6ac1$exports, "HashZero", () => $12a2c77208f0458e$export$71c2e4e213dcb7f2);
$parcel$export($4263977a5a9a6ac1$exports, "EtherSymbol", () => $a7fc97f28de0b9c7$export$c7e79fcb6f8ac048);
const $a7aab4b2e8ff7109$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";



var $dEXSZ = parcelRequire("dEXSZ");

var $9uSEH = parcelRequire("9uSEH");

var $f8A5C = parcelRequire("f8A5C");
const $70ed171ea6e5a914$export$83d89fbfd8236492 = "bignumber/5.6.2";


"use strict";
var $ef87335f524ab6ee$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $ef87335f524ab6ee$var$logger = new (0, $f8A5C.Logger)((0, $70ed171ea6e5a914$export$83d89fbfd8236492));
const $ef87335f524ab6ee$var$_constructorGuard = {};
const $ef87335f524ab6ee$var$MAX_SAFE = 0x1fffffffffffff;
function $ef87335f524ab6ee$export$a3d0a7fa9b65683b(value) {
    return value != null && ($ef87335f524ab6ee$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $9uSEH.isHexString)(value) || typeof value === "bigint" || (0, $9uSEH.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $ef87335f524ab6ee$var$_warnedToStringRadix = false;
class $ef87335f524ab6ee$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $ef87335f524ab6ee$var$_constructorGuard) $ef87335f524ab6ee$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $ef87335f524ab6ee$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).add($ef87335f524ab6ee$var$toBN(other)));
    }
    sub(other) {
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).sub($ef87335f524ab6ee$var$toBN(other)));
    }
    div(other) {
        const o = $ef87335f524ab6ee$export$d97aa349ed20696.from(other);
        if (o.isZero()) $ef87335f524ab6ee$var$throwFault("division-by-zero", "div");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).div($ef87335f524ab6ee$var$toBN(other)));
    }
    mul(other) {
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).mul($ef87335f524ab6ee$var$toBN(other)));
    }
    mod(other) {
        const value = $ef87335f524ab6ee$var$toBN(other);
        if (value.isNeg()) $ef87335f524ab6ee$var$throwFault("division-by-zero", "mod");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $ef87335f524ab6ee$var$toBN(other);
        if (value.isNeg()) $ef87335f524ab6ee$var$throwFault("negative-power", "pow");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $ef87335f524ab6ee$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $ef87335f524ab6ee$var$throwFault("unbound-bitwise-result", "and");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).and(value));
    }
    or(other) {
        const value = $ef87335f524ab6ee$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $ef87335f524ab6ee$var$throwFault("unbound-bitwise-result", "or");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $ef87335f524ab6ee$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $ef87335f524ab6ee$var$throwFault("unbound-bitwise-result", "xor");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $ef87335f524ab6ee$var$throwFault("negative-width", "mask");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $ef87335f524ab6ee$var$throwFault("negative-width", "shl");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $ef87335f524ab6ee$var$throwFault("negative-width", "shr");
        return $ef87335f524ab6ee$var$toBigNumber($ef87335f524ab6ee$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $ef87335f524ab6ee$var$toBN(this).eq($ef87335f524ab6ee$var$toBN(other));
    }
    lt(other) {
        return $ef87335f524ab6ee$var$toBN(this).lt($ef87335f524ab6ee$var$toBN(other));
    }
    lte(other) {
        return $ef87335f524ab6ee$var$toBN(this).lte($ef87335f524ab6ee$var$toBN(other));
    }
    gt(other) {
        return $ef87335f524ab6ee$var$toBN(this).gt($ef87335f524ab6ee$var$toBN(other));
    }
    gte(other) {
        return $ef87335f524ab6ee$var$toBN(this).gte($ef87335f524ab6ee$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $ef87335f524ab6ee$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $ef87335f524ab6ee$var$toBN(this).toNumber();
        } catch (error) {
            $ef87335f524ab6ee$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $ef87335f524ab6ee$var$logger.throwError("this platform does not support BigInt", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$ef87335f524ab6ee$var$_warnedToStringRadix) {
                    $ef87335f524ab6ee$var$_warnedToStringRadix = true;
                    $ef87335f524ab6ee$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $ef87335f524ab6ee$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $f8A5C.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $ef87335f524ab6ee$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $f8A5C.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $ef87335f524ab6ee$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $ef87335f524ab6ee$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $ef87335f524ab6ee$export$d97aa349ed20696($ef87335f524ab6ee$var$_constructorGuard, $ef87335f524ab6ee$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $ef87335f524ab6ee$export$d97aa349ed20696($ef87335f524ab6ee$var$_constructorGuard, $ef87335f524ab6ee$var$toHex(new $ef87335f524ab6ee$var$BN(value)));
            return $ef87335f524ab6ee$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $ef87335f524ab6ee$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $ef87335f524ab6ee$var$MAX_SAFE || value <= -$ef87335f524ab6ee$var$MAX_SAFE) $ef87335f524ab6ee$var$throwFault("overflow", "BigNumber.from", value);
            return $ef87335f524ab6ee$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $ef87335f524ab6ee$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $9uSEH.isBytes)(anyValue)) return $ef87335f524ab6ee$export$d97aa349ed20696.from((0, $9uSEH.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $ef87335f524ab6ee$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $9uSEH.isHexString)(hex) || hex[0] === "-" && (0, $9uSEH.isHexString)(hex.substring(1))) return $ef87335f524ab6ee$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $ef87335f524ab6ee$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $ef87335f524ab6ee$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $ef87335f524ab6ee$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $ef87335f524ab6ee$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $ef87335f524ab6ee$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $ef87335f524ab6ee$var$toBigNumber(value) {
    return $ef87335f524ab6ee$export$d97aa349ed20696.from($ef87335f524ab6ee$var$toHex(value));
}
function $ef87335f524ab6ee$var$toBN(value) {
    const hex = $ef87335f524ab6ee$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $ef87335f524ab6ee$var$BN("-" + hex.substring(3), 16);
    return new $ef87335f524ab6ee$var$BN(hex.substring(2), 16);
}
function $ef87335f524ab6ee$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $ef87335f524ab6ee$var$logger.throwError(fault, (0, $f8A5C.Logger).errors.NUMERIC_FAULT, params);
}
function $ef87335f524ab6ee$export$51e4a08295f7770f(value) {
    return new $ef87335f524ab6ee$var$BN(value, 36).toString(16);
}
function $ef87335f524ab6ee$export$1293db5d29c264ff(value) {
    return new $ef87335f524ab6ee$var$BN(value, 16).toString(36);
}


const $23a6ae12d38ed7fa$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(-1);
const $23a6ae12d38ed7fa$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(0);
const $23a6ae12d38ed7fa$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(1);
const $23a6ae12d38ed7fa$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(2);
const $23a6ae12d38ed7fa$export$c8db55bd7405209e = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("1000000000000000000");
const $23a6ae12d38ed7fa$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $23a6ae12d38ed7fa$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $23a6ae12d38ed7fa$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");


const $12a2c77208f0458e$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";


// NFKC (composed)             // (decomposed)
const $a7fc97f28de0b9c7$export$c7e79fcb6f8ac048 = "Ξ"; // "\uD835\uDF63";


"use strict";




var $6c57cc56acea9c6c$exports = {};

$parcel$export($6c57cc56acea9c6c$exports, "logger", () => $6c57cc56acea9c6c$export$af88d00dbe7f521);
$parcel$export($6c57cc56acea9c6c$exports, "Signer", () => (parcelRequire("j7x7T")).Signer);
$parcel$export($6c57cc56acea9c6c$exports, "Wallet", () => $8c76997802860d88$exports.Wallet);
$parcel$export($6c57cc56acea9c6c$exports, "VoidSigner", () => (parcelRequire("j7x7T")).VoidSigner);
$parcel$export($6c57cc56acea9c6c$exports, "getDefaultProvider", () => (parcelRequire("bsYBY")).getDefaultProvider);
$parcel$export($6c57cc56acea9c6c$exports, "providers", () => (parcelRequire("bsYBY")));
$parcel$export($6c57cc56acea9c6c$exports, "BaseContract", () => $77d1b08e82bacf11$exports.BaseContract);
$parcel$export($6c57cc56acea9c6c$exports, "Contract", () => $77d1b08e82bacf11$exports.Contract);
$parcel$export($6c57cc56acea9c6c$exports, "ContractFactory", () => $77d1b08e82bacf11$exports.ContractFactory);
$parcel$export($6c57cc56acea9c6c$exports, "BigNumber", () => $ef87335f524ab6ee$export$d97aa349ed20696);
$parcel$export($6c57cc56acea9c6c$exports, "FixedNumber", () => $b263b4723a2f8d0b$export$d4693c66c2213e45);
$parcel$export($6c57cc56acea9c6c$exports, "constants", () => $4263977a5a9a6ac1$exports);
$parcel$export($6c57cc56acea9c6c$exports, "errors", () => (parcelRequire("f8A5C")).ErrorCode);
$parcel$export($6c57cc56acea9c6c$exports, "utils", () => $0e788201f8a90b1e$exports);
$parcel$export($6c57cc56acea9c6c$exports, "wordlists", () => $c98b8711de347986$export$e8e1b4711c2d1939);
$parcel$export($6c57cc56acea9c6c$exports, "version", () => $9f7bf65ddafc81a6$export$83d89fbfd8236492);
$parcel$export($6c57cc56acea9c6c$exports, "Wordlist", () => $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
var $77d1b08e82bacf11$exports = {};

$parcel$export($77d1b08e82bacf11$exports, "BaseContract", () => $77d1b08e82bacf11$export$304faa4fc17528db);
$parcel$export($77d1b08e82bacf11$exports, "Contract", () => $77d1b08e82bacf11$export$8517d80acf00e19a);
$parcel$export($77d1b08e82bacf11$exports, "ContractFactory", () => $77d1b08e82bacf11$export$505569a6bf584fd9);

var $9uSEH = parcelRequire("9uSEH");


var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");
const $f3770e70b434de02$export$83d89fbfd8236492 = "abi/5.6.4";


"use strict";
const $2443aa857d9ae22f$var$logger = new (0, $f8A5C.Logger)((0, $f3770e70b434de02$export$83d89fbfd8236492));
function $2443aa857d9ae22f$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $2443aa857d9ae22f$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $2443aa857d9ae22f$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $2443aa857d9ae22f$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $e72ut.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $9uSEH.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $9uSEH.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $9uSEH.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $9uSEH.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $9uSEH.arrayify)((0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $2443aa857d9ae22f$var$logger.throwError("value out-of-bounds", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $9uSEH.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $2443aa857d9ae22f$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $e72ut.defineReadOnly)(this, "_data", (0, $9uSEH.arrayify)(data));
        (0, $e72ut.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $e72ut.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $e72ut.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $9uSEH.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $2443aa857d9ae22f$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $2443aa857d9ae22f$var$logger.throwError("data out-of-bounds", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $2443aa857d9ae22f$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}


var $9uSEH = parcelRequire("9uSEH");


var $1IGmO = parcelRequire("1IGmO");

var $9uSEH = parcelRequire("9uSEH");
"use strict";
function $5915e762efc52191$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $9uSEH.arrayify)(data));
}



var $hiDPq = parcelRequire("hiDPq");

var $f8A5C = parcelRequire("f8A5C");
const $2d21e614cee3f35b$export$83d89fbfd8236492 = "address/5.6.1";


"use strict";
const $3bbab26945c6bdb1$var$logger = new (0, $f8A5C.Logger)((0, $2d21e614cee3f35b$export$83d89fbfd8236492));
function $3bbab26945c6bdb1$var$getChecksumAddress(address) {
    if (!(0, $9uSEH.isHexString)(address, 20)) $3bbab26945c6bdb1$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $9uSEH.arrayify)((0, $5915e762efc52191$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $3bbab26945c6bdb1$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $3bbab26945c6bdb1$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $3bbab26945c6bdb1$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$3bbab26945c6bdb1$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$3bbab26945c6bdb1$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $3bbab26945c6bdb1$var$safeDigits = Math.floor($3bbab26945c6bdb1$var$log10($3bbab26945c6bdb1$var$MAX_SAFE_INTEGER));
function $3bbab26945c6bdb1$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $3bbab26945c6bdb1$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $3bbab26945c6bdb1$var$safeDigits){
        let block = expanded.substring(0, $3bbab26945c6bdb1$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $3bbab26945c6bdb1$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $3bbab26945c6bdb1$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $3bbab26945c6bdb1$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $3bbab26945c6bdb1$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $3bbab26945c6bdb1$var$ibanChecksum(address)) $3bbab26945c6bdb1$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $ef87335f524ab6ee$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $3bbab26945c6bdb1$var$getChecksumAddress("0x" + result);
    } else $3bbab26945c6bdb1$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $3bbab26945c6bdb1$export$977e255126d763d6(address) {
    try {
        $3bbab26945c6bdb1$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $3bbab26945c6bdb1$export$962c4ddada9f668f(address) {
    let base36 = (0, $ef87335f524ab6ee$export$1293db5d29c264ff)($3bbab26945c6bdb1$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $3bbab26945c6bdb1$var$ibanChecksum("XE00" + base36) + base36;
}
function $3bbab26945c6bdb1$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $3bbab26945c6bdb1$export$88411125f012957a(transaction.from);
    } catch (error) {
        $3bbab26945c6bdb1$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $9uSEH.stripZeros)((0, $9uSEH.arrayify)((0, $ef87335f524ab6ee$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $3bbab26945c6bdb1$export$88411125f012957a((0, $9uSEH.hexDataSlice)((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $hiDPq.encode)([
        from,
        nonce
    ])), 12));
}
function $3bbab26945c6bdb1$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $9uSEH.hexDataLength)(salt) !== 32) $3bbab26945c6bdb1$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $9uSEH.hexDataLength)(initCodeHash) !== 32) $3bbab26945c6bdb1$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $3bbab26945c6bdb1$export$88411125f012957a((0, $9uSEH.hexDataSlice)((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
        "0xff",
        $3bbab26945c6bdb1$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}




var $9uSEH = parcelRequire("9uSEH");


var $9uSEH = parcelRequire("9uSEH");

var $f8A5C = parcelRequire("f8A5C");
const $7a5dfe009b1adb90$export$83d89fbfd8236492 = "strings/5.6.1";


"use strict";
const $c64f307c4161c9d6$var$logger = new (0, $f8A5C.Logger)((0, $7a5dfe009b1adb90$export$83d89fbfd8236492));
var $c64f307c4161c9d6$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($c64f307c4161c9d6$export$c6986442964129f5 || ($c64f307c4161c9d6$export$c6986442964129f5 = {}));
var $c64f307c4161c9d6$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($c64f307c4161c9d6$export$c285fa6ac15ff6a6 || ($c64f307c4161c9d6$export$c285fa6ac15ff6a6 = {}));
function $c64f307c4161c9d6$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $c64f307c4161c9d6$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $c64f307c4161c9d6$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $c64f307c4161c9d6$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $c64f307c4161c9d6$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $c64f307c4161c9d6$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $c64f307c4161c9d6$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $c64f307c4161c9d6$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $c64f307c4161c9d6$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $c64f307c4161c9d6$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $c64f307c4161c9d6$var$errorFunc,
    ignore: $c64f307c4161c9d6$var$ignoreFunc,
    replace: $c64f307c4161c9d6$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $c64f307c4161c9d6$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $c64f307c4161c9d6$export$c6e2180c5bb5bc05.error;
    bytes = (0, $9uSEH.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($c64f307c4161c9d6$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $c64f307c4161c9d6$export$8feeb310b4b4752f(str, form = $c64f307c4161c9d6$export$c6986442964129f5.current) {
    if (form != $c64f307c4161c9d6$export$c6986442964129f5.current) {
        $c64f307c4161c9d6$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $9uSEH.arrayify)(result);
}
function $c64f307c4161c9d6$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $c64f307c4161c9d6$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $c64f307c4161c9d6$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $c64f307c4161c9d6$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $c64f307c4161c9d6$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $c64f307c4161c9d6$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $c64f307c4161c9d6$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $c64f307c4161c9d6$export$7643a1dc2c38d5eb(bytes, onError) {
    return $c64f307c4161c9d6$export$232e1dab03132235($c64f307c4161c9d6$var$getUtf8CodePoints(bytes, onError));
}
function $c64f307c4161c9d6$export$ae470a36a31b28c2(str, form = $c64f307c4161c9d6$export$c6986442964129f5.current) {
    return $c64f307c4161c9d6$var$getUtf8CodePoints($c64f307c4161c9d6$export$8feeb310b4b4752f(str, form));
}


function $c37a351bb1ec7c40$export$d560c7e4a29451c2(text) {
    return (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(text));
}




var $e72ut = parcelRequire("e72ut");

var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");




var $9uSEH = parcelRequire("9uSEH");

"use strict";
class $f44de11454ba97df$export$59dbbded7775bfe7 extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $3bbab26945c6bdb1$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $3bbab26945c6bdb1$export$88411125f012957a)((0, $9uSEH.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}



var $f8A5C = parcelRequire("f8A5C");



"use strict";
class $51918cffd30a011f$export$87c41d1139a03fa2 extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $e1076d6b326d46fd$var$logger = new (0, $f8A5C.Logger)((0, $f3770e70b434de02$export$83d89fbfd8236492));
function $e1076d6b326d46fd$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $e1076d6b326d46fd$var$logger.throwError("cannot encode object for signature with missing names", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $e1076d6b326d46fd$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $e1076d6b326d46fd$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $e1076d6b326d46fd$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $2443aa857d9ae22f$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $2443aa857d9ae22f$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $e1076d6b326d46fd$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $f8A5C.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $f8A5C.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $e1076d6b326d46fd$export$88bc419d2df11f54 extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $e1076d6b326d46fd$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $e1076d6b326d46fd$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $e1076d6b326d46fd$var$logger.throwError("insufficient data length", (0, $f8A5C.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $51918cffd30a011f$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $e1076d6b326d46fd$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $3916872c2e90c74e$export$fe9118d6c093150c extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}



var $9uSEH = parcelRequire("9uSEH");

"use strict";
class $230e84ef92b46210$export$db9eadd8df12ad2e extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $9uSEH.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $230e84ef92b46210$export$e5823e9574df18d2 extends $230e84ef92b46210$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $9uSEH.hexlify)(super.decode(reader)));
    }
}



var $9uSEH = parcelRequire("9uSEH");

"use strict";
class $89b4e3e4a33d6e0b$export$7dec9db68e6bcf5a extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $9uSEH.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $9uSEH.hexlify)(reader.readBytes(this.size)));
    }
}



"use strict";
class $713e5f0d7fe40658$export$70982cadf2d6b4ec extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}





"use strict";
class $bb3bd932e94178d6$export$b934dc8cfe13938c extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $23a6ae12d38ed7fa$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $23a6ae12d38ed7fa$export$9aa05a5866350bcf)).mul((0, $23a6ae12d38ed7fa$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $23a6ae12d38ed7fa$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




"use strict";
class $19885440fbffe59f$export$2d1b854518731426 extends (0, $230e84ef92b46210$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $c64f307c4161c9d6$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $8048bc68cfd850c0$export$e9fceba8f110fea6 extends (0, $2443aa857d9ae22f$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $e1076d6b326d46fd$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $e1076d6b326d46fd$export$417857010dc9287f)(reader, this.coders));
    }
}




var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");

"use strict";
const $be76a1f9a941f8f7$var$logger = new (0, $f8A5C.Logger)((0, $f3770e70b434de02$export$83d89fbfd8236492));
const $be76a1f9a941f8f7$var$_constructorGuard = {};
let $be76a1f9a941f8f7$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $be76a1f9a941f8f7$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $be76a1f9a941f8f7$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($be76a1f9a941f8f7$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($be76a1f9a941f8f7$var$ModifiersNest[name]) return true;
    }
    if ($be76a1f9a941f8f7$var$ModifiersBytes[name] || name === "payable") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $be76a1f9a941f8f7$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $be76a1f9a941f8f7$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $be76a1f9a941f8f7$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($be76a1f9a941f8f7$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $be76a1f9a941f8f7$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($be76a1f9a941f8f7$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $be76a1f9a941f8f7$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $be76a1f9a941f8f7$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($be76a1f9a941f8f7$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $be76a1f9a941f8f7$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($be76a1f9a941f8f7$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $be76a1f9a941f8f7$var$verifyType(parent.type);
    return parent;
}
function $be76a1f9a941f8f7$var$populate(object, params) {
    for(let key in params)(0, $e72ut.defineReadOnly)(object, key, params[key]);
}
const $be76a1f9a941f8f7$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $be76a1f9a941f8f7$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $be76a1f9a941f8f7$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $be76a1f9a941f8f7$var$_constructorGuard) $be76a1f9a941f8f7$var$logger.throwError("use fromString", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $be76a1f9a941f8f7$var$populate(this, params);
        let match = this.type.match($be76a1f9a941f8f7$var$paramTypeArray);
        if (match) $be76a1f9a941f8f7$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $be76a1f9a941f8f7$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $be76a1f9a941f8f7$export$f010f239efc4d445.sighash;
        if (!$be76a1f9a941f8f7$export$f010f239efc4d445[format]) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $be76a1f9a941f8f7$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $be76a1f9a941f8f7$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $be76a1f9a941f8f7$export$426dc07f493a4c47($be76a1f9a941f8f7$var$_constructorGuard, {
            name: value.name || null,
            type: $be76a1f9a941f8f7$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($be76a1f9a941f8f7$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $be76a1f9a941f8f7$var$parseParams(value, allowIndex) {
    return $be76a1f9a941f8f7$var$splitNesting(value).map((param)=>$be76a1f9a941f8f7$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $be76a1f9a941f8f7$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $be76a1f9a941f8f7$var$_constructorGuard) $be76a1f9a941f8f7$var$logger.throwError("use a static from method", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $be76a1f9a941f8f7$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($be76a1f9a941f8f7$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $be76a1f9a941f8f7$export$ffb0004e005737fa.fromString(value);
        return $be76a1f9a941f8f7$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $be76a1f9a941f8f7$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $be76a1f9a941f8f7$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $be76a1f9a941f8f7$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $be76a1f9a941f8f7$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $be76a1f9a941f8f7$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $be76a1f9a941f8f7$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $be76a1f9a941f8f7$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $be76a1f9a941f8f7$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $be76a1f9a941f8f7$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $be76a1f9a941f8f7$export$958548f08bac2833 extends $be76a1f9a941f8f7$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $be76a1f9a941f8f7$export$f010f239efc4d445.sighash;
        if (!$be76a1f9a941f8f7$export$f010f239efc4d445[format]) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $be76a1f9a941f8f7$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $be76a1f9a941f8f7$export$958548f08bac2833.fromString(value);
        return $be76a1f9a941f8f7$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $be76a1f9a941f8f7$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $be76a1f9a941f8f7$export$958548f08bac2833($be76a1f9a941f8f7$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($be76a1f9a941f8f7$var$regexParen);
        if (!match) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $be76a1f9a941f8f7$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $be76a1f9a941f8f7$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $be76a1f9a941f8f7$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $be76a1f9a941f8f7$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $be76a1f9a941f8f7$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $be76a1f9a941f8f7$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $be76a1f9a941f8f7$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $be76a1f9a941f8f7$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $be76a1f9a941f8f7$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $be76a1f9a941f8f7$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $be76a1f9a941f8f7$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $be76a1f9a941f8f7$export$3ac5c9504f801ea4 extends $be76a1f9a941f8f7$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $be76a1f9a941f8f7$export$f010f239efc4d445.sighash;
        if (!$be76a1f9a941f8f7$export$f010f239efc4d445[format]) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) $be76a1f9a941f8f7$var$logger.throwError("cannot format a constructor for sighash", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $be76a1f9a941f8f7$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $be76a1f9a941f8f7$export$3ac5c9504f801ea4.fromString(value);
        return $be76a1f9a941f8f7$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $be76a1f9a941f8f7$var$verifyState(value);
        if (state.constant) $be76a1f9a941f8f7$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $be76a1f9a941f8f7$export$3ac5c9504f801ea4($be76a1f9a941f8f7$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $be76a1f9a941f8f7$var$parseGas(value, params);
        let parens = value.match($be76a1f9a941f8f7$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $be76a1f9a941f8f7$var$parseParams(parens[2].trim(), false);
        $be76a1f9a941f8f7$var$parseModifiers(parens[3].trim(), params);
        return $be76a1f9a941f8f7$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $be76a1f9a941f8f7$export$8d576c928b93668f extends $be76a1f9a941f8f7$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $be76a1f9a941f8f7$export$f010f239efc4d445.sighash;
        if (!$be76a1f9a941f8f7$export$f010f239efc4d445[format]) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $be76a1f9a941f8f7$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $be76a1f9a941f8f7$export$8d576c928b93668f.fromString(value);
        return $be76a1f9a941f8f7$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $be76a1f9a941f8f7$var$verifyState(value);
        const params = {
            type: value.type,
            name: $be76a1f9a941f8f7$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $be76a1f9a941f8f7$export$8d576c928b93668f($be76a1f9a941f8f7$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $be76a1f9a941f8f7$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($be76a1f9a941f8f7$var$regexParen);
        if (!parens) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $be76a1f9a941f8f7$var$verifyIdentifier(params.name);
        params.inputs = $be76a1f9a941f8f7$var$parseParams(parens[2], false);
        $be76a1f9a941f8f7$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($be76a1f9a941f8f7$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $be76a1f9a941f8f7$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $be76a1f9a941f8f7$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $be76a1f9a941f8f7$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $be76a1f9a941f8f7$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $be76a1f9a941f8f7$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $be76a1f9a941f8f7$export$2c42c6d543aa9b59 extends $be76a1f9a941f8f7$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $be76a1f9a941f8f7$export$f010f239efc4d445.sighash;
        if (!$be76a1f9a941f8f7$export$f010f239efc4d445[format]) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $be76a1f9a941f8f7$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $be76a1f9a941f8f7$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $be76a1f9a941f8f7$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $be76a1f9a941f8f7$export$2c42c6d543aa9b59.fromString(value);
        return $be76a1f9a941f8f7$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($be76a1f9a941f8f7$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $be76a1f9a941f8f7$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($be76a1f9a941f8f7$export$426dc07f493a4c47.fromObject) : []
        };
        return $be76a1f9a941f8f7$var$checkForbidden(new $be76a1f9a941f8f7$export$2c42c6d543aa9b59($be76a1f9a941f8f7$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($be76a1f9a941f8f7$var$regexParen);
        if (!parens) $be76a1f9a941f8f7$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $be76a1f9a941f8f7$var$verifyIdentifier(params.name);
        params.inputs = $be76a1f9a941f8f7$var$parseParams(parens[2], false);
        return $be76a1f9a941f8f7$var$checkForbidden($be76a1f9a941f8f7$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $be76a1f9a941f8f7$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $be76a1f9a941f8f7$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $be76a1f9a941f8f7$var$verifyIdentifier(value) {
    if (!value || !value.match($be76a1f9a941f8f7$var$regexIdentifier)) $be76a1f9a941f8f7$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $be76a1f9a941f8f7$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $be76a1f9a941f8f7$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $be76a1f9a941f8f7$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $45e842348d346001$var$logger = new (0, $f8A5C.Logger)((0, $f3770e70b434de02$export$83d89fbfd8236492));
const $45e842348d346001$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $45e842348d346001$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $45e842348d346001$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $e72ut.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $f44de11454ba97df$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $3916872c2e90c74e$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $19885440fbffe59f$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $230e84ef92b46210$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $e1076d6b326d46fd$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $8048bc68cfd850c0$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $713e5f0d7fe40658$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($45e842348d346001$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $45e842348d346001$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $bb3bd932e94178d6$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($45e842348d346001$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $45e842348d346001$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $89b4e3e4a33d6e0b$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $45e842348d346001$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $2443aa857d9ae22f$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $2443aa857d9ae22f$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $be76a1f9a941f8f7$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $8048bc68cfd850c0$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $45e842348d346001$var$logger.throwError("types/values length mismatch", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $be76a1f9a941f8f7$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $8048bc68cfd850c0$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $be76a1f9a941f8f7$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $8048bc68cfd850c0$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $9uSEH.arrayify)(data), loose));
    }
}
const $45e842348d346001$export$51d1cfcdb913adff = new $45e842348d346001$export$fe041e1a83d3efc6();





var $f8A5C = parcelRequire("f8A5C");

"use strict";
const $6c9fdbc6de4e49f0$var$logger = new (0, $f8A5C.Logger)((0, $f3770e70b434de02$export$83d89fbfd8236492));
class $6c9fdbc6de4e49f0$export$c2ab6499be98b3c5 extends (0, $e72ut.Description) {
}
class $6c9fdbc6de4e49f0$export$7a3223b0fadb690b extends (0, $e72ut.Description) {
}
class $6c9fdbc6de4e49f0$export$cfba08fc0e40e2ab extends (0, $e72ut.Description) {
}
class $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c extends (0, $e72ut.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $6c9fdbc6de4e49f0$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $6c9fdbc6de4e49f0$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $6c9fdbc6de4e49f0$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $e72ut.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $be76a1f9a941f8f7$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $e72ut.defineReadOnly)(this, "_abiCoder", (0, $e72ut.getStatic)(new.target, "getAbiCoder")());
        (0, $e72ut.defineReadOnly)(this, "functions", {});
        (0, $e72ut.defineReadOnly)(this, "errors", {});
        (0, $e72ut.defineReadOnly)(this, "events", {});
        (0, $e72ut.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $6c9fdbc6de4e49f0$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $e72ut.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $6c9fdbc6de4e49f0$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $e72ut.defineReadOnly)(this, "deploy", (0, $be76a1f9a941f8f7$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $e72ut.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $be76a1f9a941f8f7$export$f010f239efc4d445).full;
        if (format === (0, $be76a1f9a941f8f7$export$f010f239efc4d445).sighash) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $be76a1f9a941f8f7$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $45e842348d346001$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $3bbab26945c6bdb1$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $9uSEH.hexDataSlice)((0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $9uSEH.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $be76a1f9a941f8f7$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $9uSEH.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $be76a1f9a941f8f7$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $9uSEH.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $e72ut.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $be76a1f9a941f8f7$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $e72ut.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $e72ut.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $9uSEH.arrayify)(data);
        if ((0, $9uSEH.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $6c9fdbc6de4e49f0$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $9uSEH.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $9uSEH.hexlify)((0, $9uSEH.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $9uSEH.arrayify)(data);
        if ((0, $9uSEH.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $6c9fdbc6de4e49f0$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $9uSEH.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $9uSEH.hexlify)((0, $9uSEH.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $9uSEH.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $9uSEH.hexlify)(bytes.slice(0, 4));
                    const builtin = $6c9fdbc6de4e49f0$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $6c9fdbc6de4e49f0$var$logger.throwError("call revert exception" + message, (0, $f8A5C.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $9uSEH.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $9uSEH.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $6c9fdbc6de4e49f0$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $f8A5C.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $9uSEH.hexZeroPad)((0, $9uSEH.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $6c9fdbc6de4e49f0$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $6c9fdbc6de4e49f0$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $5915e762efc52191$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $9uSEH.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $6c9fdbc6de4e49f0$var$logger.throwError("fragment/topic mismatch", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $be76a1f9a941f8f7$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $9uSEH.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $6c9fdbc6de4e49f0$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $6c9fdbc6de4e49f0$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6c9fdbc6de4e49f0$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $6c9fdbc6de4e49f0$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $9uSEH.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6c9fdbc6de4e49f0$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}


var $20eaa00aa96c05e1$exports = {};

$parcel$export($20eaa00aa96c05e1$exports, "Provider", () => $20eaa00aa96c05e1$export$2881499e37b75b9a);


var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");
const $bf3ad5a6311799ff$export$83d89fbfd8236492 = "abstract-provider/5.6.1";


"use strict";
var $20eaa00aa96c05e1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $20eaa00aa96c05e1$var$logger = new (0, $f8A5C.Logger)((0, $bf3ad5a6311799ff$export$83d89fbfd8236492));
class $20eaa00aa96c05e1$export$406ece1549ccd00e extends (0, $e72ut.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $20eaa00aa96c05e1$export$5b2cada8494f9d99 extends $20eaa00aa96c05e1$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $9uSEH.isHexString)(blockHash, 32)) $20eaa00aa96c05e1$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $20eaa00aa96c05e1$export$26bcd61a55716c98 extends $20eaa00aa96c05e1$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $9uSEH.isHexString)(hash, 32)) $20eaa00aa96c05e1$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $20eaa00aa96c05e1$export$8f8609bfee47c93 extends $20eaa00aa96c05e1$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $9uSEH.isHexString)(beforeHash, 32)) $20eaa00aa96c05e1$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $9uSEH.isHexString)(afterHash, 32)) $20eaa00aa96c05e1$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $20eaa00aa96c05e1$export$2881499e37b75b9a {
    constructor(){
        $20eaa00aa96c05e1$var$logger.checkAbstract(new.target, $20eaa00aa96c05e1$export$2881499e37b75b9a);
        (0, $e72ut.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $20eaa00aa96c05e1$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $e72ut.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                maxPriorityFeePerGas = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}



var $j7x7T = parcelRequire("j7x7T");



var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");



var $9uSEH = parcelRequire("9uSEH");



var $e72ut = parcelRequire("e72ut");

var $hiDPq = parcelRequire("hiDPq");

var $dEXSZ = parcelRequire("dEXSZ");

var $kiSKt = parcelRequire("kiSKt");
var $0e3b3b24de51dc48$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $0e3b3b24de51dc48$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $0e3b3b24de51dc48$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $0e3b3b24de51dc48$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $0e3b3b24de51dc48$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $0e3b3b24de51dc48$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $0e3b3b24de51dc48$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $0e3b3b24de51dc48$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $0e3b3b24de51dc48$var$minimalisticAssert = $0e3b3b24de51dc48$var$assert;
function $0e3b3b24de51dc48$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$0e3b3b24de51dc48$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $0e3b3b24de51dc48$var$utils_1 = $0e3b3b24de51dc48$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $0e3b3b24de51dc48$var$utils_1$1 = $0e3b3b24de51dc48$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $0e3b3b24de51dc48$var$minimalisticAssert;
    utils.toArray = $0e3b3b24de51dc48$var$utils_1.toArray;
    utils.zero2 = $0e3b3b24de51dc48$var$utils_1.zero2;
    utils.toHex = $0e3b3b24de51dc48$var$utils_1.toHex;
    utils.encode = $0e3b3b24de51dc48$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $0e3b3b24de51dc48$var$getNAF = $0e3b3b24de51dc48$var$utils_1$1.getNAF;
var $0e3b3b24de51dc48$var$getJSF = $0e3b3b24de51dc48$var$utils_1$1.getJSF;
var $0e3b3b24de51dc48$var$assert$1 = $0e3b3b24de51dc48$var$utils_1$1.assert;
function $0e3b3b24de51dc48$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $0e3b3b24de51dc48$var$base = $0e3b3b24de51dc48$var$BaseCurve;
$0e3b3b24de51dc48$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$0e3b3b24de51dc48$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$0e3b3b24de51dc48$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e3b3b24de51dc48$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e3b3b24de51dc48$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e3b3b24de51dc48$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e3b3b24de51dc48$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e3b3b24de51dc48$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$0e3b3b24de51dc48$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e3b3b24de51dc48$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e3b3b24de51dc48$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e3b3b24de51dc48$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e3b3b24de51dc48$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e3b3b24de51dc48$var$BaseCurve.BasePoint = $0e3b3b24de51dc48$var$BasePoint;
$0e3b3b24de51dc48$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$0e3b3b24de51dc48$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e3b3b24de51dc48$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $0e3b3b24de51dc48$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e3b3b24de51dc48$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e3b3b24de51dc48$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$0e3b3b24de51dc48$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e3b3b24de51dc48$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$0e3b3b24de51dc48$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $0e3b3b24de51dc48$var$utils_1$1.encode(this._encode(compact), enc);
};
$0e3b3b24de51dc48$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e3b3b24de51dc48$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e3b3b24de51dc48$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e3b3b24de51dc48$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e3b3b24de51dc48$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e3b3b24de51dc48$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $0e3b3b24de51dc48$var$inherits_browser = $0e3b3b24de51dc48$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $0e3b3b24de51dc48$var$assert$2 = $0e3b3b24de51dc48$var$utils_1$1.assert;
function $0e3b3b24de51dc48$var$ShortCurve(conf) {
    $0e3b3b24de51dc48$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$0e3b3b24de51dc48$var$inherits_browser($0e3b3b24de51dc48$var$ShortCurve, $0e3b3b24de51dc48$var$base);
var $0e3b3b24de51dc48$var$short_1 = $0e3b3b24de51dc48$var$ShortCurve;
$0e3b3b24de51dc48$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $0e3b3b24de51dc48$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$0e3b3b24de51dc48$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$0e3b3b24de51dc48$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$0e3b3b24de51dc48$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$0e3b3b24de51dc48$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$0e3b3b24de51dc48$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$0e3b3b24de51dc48$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $0e3b3b24de51dc48$var$Point(curve, x, y, isRed) {
    $0e3b3b24de51dc48$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$0e3b3b24de51dc48$var$inherits_browser($0e3b3b24de51dc48$var$Point, $0e3b3b24de51dc48$var$base.BasePoint);
$0e3b3b24de51dc48$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $0e3b3b24de51dc48$var$Point(this, x, y, isRed);
};
$0e3b3b24de51dc48$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $0e3b3b24de51dc48$var$Point.fromJSON(this, obj, red);
};
$0e3b3b24de51dc48$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$0e3b3b24de51dc48$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$0e3b3b24de51dc48$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$0e3b3b24de51dc48$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$0e3b3b24de51dc48$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$0e3b3b24de51dc48$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0e3b3b24de51dc48$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0e3b3b24de51dc48$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$0e3b3b24de51dc48$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$0e3b3b24de51dc48$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$0e3b3b24de51dc48$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$0e3b3b24de51dc48$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$0e3b3b24de51dc48$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$0e3b3b24de51dc48$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$0e3b3b24de51dc48$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $0e3b3b24de51dc48$var$JPoint(curve, x, y, z) {
    $0e3b3b24de51dc48$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$0e3b3b24de51dc48$var$inherits_browser($0e3b3b24de51dc48$var$JPoint, $0e3b3b24de51dc48$var$base.BasePoint);
$0e3b3b24de51dc48$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $0e3b3b24de51dc48$var$JPoint(this, x, y, z);
};
$0e3b3b24de51dc48$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$0e3b3b24de51dc48$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$0e3b3b24de51dc48$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$0e3b3b24de51dc48$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$0e3b3b24de51dc48$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$0e3b3b24de51dc48$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$0e3b3b24de51dc48$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$0e3b3b24de51dc48$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$0e3b3b24de51dc48$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$0e3b3b24de51dc48$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $0e3b3b24de51dc48$var$curve_1 = $0e3b3b24de51dc48$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $0e3b3b24de51dc48$var$base;
    curve.short = $0e3b3b24de51dc48$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $0e3b3b24de51dc48$var$curves_1 = $0e3b3b24de51dc48$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $0e3b3b24de51dc48$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $0e3b3b24de51dc48$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $0e3b3b24de51dc48$var$curve_1.edwards(options);
        else this.curve = new $0e3b3b24de51dc48$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $0e3b3b24de51dc48$var$HmacDRBG(options) {
    if (!(this instanceof $0e3b3b24de51dc48$var$HmacDRBG)) return new $0e3b3b24de51dc48$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $0e3b3b24de51dc48$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $0e3b3b24de51dc48$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $0e3b3b24de51dc48$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $0e3b3b24de51dc48$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $0e3b3b24de51dc48$var$hmacDrbg = $0e3b3b24de51dc48$var$HmacDRBG;
$0e3b3b24de51dc48$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$0e3b3b24de51dc48$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$0e3b3b24de51dc48$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$0e3b3b24de51dc48$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $0e3b3b24de51dc48$var$utils_1.toArray(entropy, entropyEnc);
    add = $0e3b3b24de51dc48$var$utils_1.toArray(add, addEnc);
    $0e3b3b24de51dc48$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$0e3b3b24de51dc48$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $0e3b3b24de51dc48$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $0e3b3b24de51dc48$var$utils_1.encode(res, enc);
};
"use strict";
var $0e3b3b24de51dc48$var$assert$3 = $0e3b3b24de51dc48$var$utils_1$1.assert;
function $0e3b3b24de51dc48$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $0e3b3b24de51dc48$var$key = $0e3b3b24de51dc48$var$KeyPair;
$0e3b3b24de51dc48$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $0e3b3b24de51dc48$var$KeyPair) return pub;
    return new $0e3b3b24de51dc48$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$0e3b3b24de51dc48$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $0e3b3b24de51dc48$var$KeyPair) return priv;
    return new $0e3b3b24de51dc48$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$0e3b3b24de51dc48$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$0e3b3b24de51dc48$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$0e3b3b24de51dc48$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$0e3b3b24de51dc48$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$0e3b3b24de51dc48$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $0e3b3b24de51dc48$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $0e3b3b24de51dc48$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$0e3b3b24de51dc48$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $0e3b3b24de51dc48$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$0e3b3b24de51dc48$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$0e3b3b24de51dc48$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$0e3b3b24de51dc48$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $0e3b3b24de51dc48$var$assert$4 = $0e3b3b24de51dc48$var$utils_1$1.assert;
function $0e3b3b24de51dc48$var$Signature(options, enc) {
    if (options instanceof $0e3b3b24de51dc48$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $0e3b3b24de51dc48$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $0e3b3b24de51dc48$var$signature = $0e3b3b24de51dc48$var$Signature;
function $0e3b3b24de51dc48$var$Position() {
    this.place = 0;
}
function $0e3b3b24de51dc48$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $0e3b3b24de51dc48$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$0e3b3b24de51dc48$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $0e3b3b24de51dc48$var$utils_1$1.toArray(data, enc);
    var p = new $0e3b3b24de51dc48$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $0e3b3b24de51dc48$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $0e3b3b24de51dc48$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $0e3b3b24de51dc48$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $0e3b3b24de51dc48$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$0e3b3b24de51dc48$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $0e3b3b24de51dc48$var$rmPadding(r);
    s = $0e3b3b24de51dc48$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $0e3b3b24de51dc48$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $0e3b3b24de51dc48$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $0e3b3b24de51dc48$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $0e3b3b24de51dc48$var$utils_1$1.encode(res, enc);
};
"use strict";
var $0e3b3b24de51dc48$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $0e3b3b24de51dc48$var$assert$5 = $0e3b3b24de51dc48$var$utils_1$1.assert;
function $0e3b3b24de51dc48$var$EC(options) {
    if (!(this instanceof $0e3b3b24de51dc48$var$EC)) return new $0e3b3b24de51dc48$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $0e3b3b24de51dc48$var$assert$5(Object.prototype.hasOwnProperty.call($0e3b3b24de51dc48$var$curves_1, options), "Unknown curve " + options);
        options = $0e3b3b24de51dc48$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $0e3b3b24de51dc48$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $0e3b3b24de51dc48$var$ec = $0e3b3b24de51dc48$var$EC;
$0e3b3b24de51dc48$var$EC.prototype.keyPair = function keyPair(options) {
    return new $0e3b3b24de51dc48$var$key(this, options);
};
$0e3b3b24de51dc48$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $0e3b3b24de51dc48$var$key.fromPrivate(this, priv, enc);
};
$0e3b3b24de51dc48$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $0e3b3b24de51dc48$var$key.fromPublic(this, pub, enc);
};
$0e3b3b24de51dc48$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $0e3b3b24de51dc48$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $0e3b3b24de51dc48$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$0e3b3b24de51dc48$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$0e3b3b24de51dc48$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $0e3b3b24de51dc48$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $0e3b3b24de51dc48$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$0e3b3b24de51dc48$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $0e3b3b24de51dc48$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$0e3b3b24de51dc48$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $0e3b3b24de51dc48$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $0e3b3b24de51dc48$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$0e3b3b24de51dc48$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $0e3b3b24de51dc48$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $0e3b3b24de51dc48$var$elliptic_1 = $0e3b3b24de51dc48$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $0e3b3b24de51dc48$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $0e3b3b24de51dc48$var$curve_1;
    elliptic.curves = $0e3b3b24de51dc48$var$curves_1;
    // Protocols
    elliptic.ec = $0e3b3b24de51dc48$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $0e3b3b24de51dc48$export$129fe12d32abc311 = $0e3b3b24de51dc48$var$elliptic_1.ec;



var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");
const $9011202b8af46e1c$export$83d89fbfd8236492 = "signing-key/5.6.2";


"use strict";
const $c996070d7a4cc0da$var$logger = new (0, $f8A5C.Logger)((0, $9011202b8af46e1c$export$83d89fbfd8236492));
let $c996070d7a4cc0da$var$_curve = null;
function $c996070d7a4cc0da$var$getCurve() {
    if (!$c996070d7a4cc0da$var$_curve) $c996070d7a4cc0da$var$_curve = new (0, $0e3b3b24de51dc48$export$129fe12d32abc311)("secp256k1");
    return $c996070d7a4cc0da$var$_curve;
}
class $c996070d7a4cc0da$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $e72ut.defineReadOnly)(this, "curve", "secp256k1");
        (0, $e72ut.defineReadOnly)(this, "privateKey", (0, $9uSEH.hexlify)(privateKey));
        if ((0, $9uSEH.hexDataLength)(this.privateKey) !== 32) $c996070d7a4cc0da$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $c996070d7a4cc0da$var$getCurve().keyFromPrivate((0, $9uSEH.arrayify)(this.privateKey));
        (0, $e72ut.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $e72ut.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $e72ut.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $c996070d7a4cc0da$var$getCurve().keyFromPublic((0, $9uSEH.arrayify)(this.publicKey));
        const p1 = $c996070d7a4cc0da$var$getCurve().keyFromPublic((0, $9uSEH.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $c996070d7a4cc0da$var$getCurve().keyFromPrivate((0, $9uSEH.arrayify)(this.privateKey));
        const digestBytes = (0, $9uSEH.arrayify)(digest);
        if (digestBytes.length !== 32) $c996070d7a4cc0da$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $9uSEH.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $9uSEH.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $9uSEH.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $c996070d7a4cc0da$var$getCurve().keyFromPrivate((0, $9uSEH.arrayify)(this.privateKey));
        const otherKeyPair = $c996070d7a4cc0da$var$getCurve().keyFromPublic((0, $9uSEH.arrayify)($c996070d7a4cc0da$export$4a89473d39301224(otherKey)));
        return (0, $9uSEH.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $c996070d7a4cc0da$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $9uSEH.splitSignature)(signature);
    const rs = {
        r: (0, $9uSEH.arrayify)(sig.r),
        s: (0, $9uSEH.arrayify)(sig.s)
    };
    return "0x" + $c996070d7a4cc0da$var$getCurve().recoverPubKey((0, $9uSEH.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $c996070d7a4cc0da$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $9uSEH.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $c996070d7a4cc0da$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $c996070d7a4cc0da$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $9uSEH.hexlify)(bytes);
        return "0x" + $c996070d7a4cc0da$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $9uSEH.hexlify)(bytes);
        return "0x" + $c996070d7a4cc0da$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $c996070d7a4cc0da$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



var $f8A5C = parcelRequire("f8A5C");
const $5b81fed67827fb75$export$83d89fbfd8236492 = "transactions/5.6.2";


"use strict";
const $c220423970a40605$var$logger = new (0, $f8A5C.Logger)((0, $5b81fed67827fb75$export$83d89fbfd8236492));
var $c220423970a40605$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($c220423970a40605$export$80349e05e0724e11 || ($c220423970a40605$export$80349e05e0724e11 = {}));
///////////////////////////////
function $c220423970a40605$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $3bbab26945c6bdb1$export$88411125f012957a)(value);
}
function $c220423970a40605$var$handleNumber(value) {
    if (value === "0x") return 0, $23a6ae12d38ed7fa$export$aaef8a3eae948f03;
    return (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $c220423970a40605$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $c220423970a40605$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $c220423970a40605$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $c996070d7a4cc0da$export$4a89473d39301224)(key);
    return (0, $3bbab26945c6bdb1$export$88411125f012957a)((0, $9uSEH.hexDataSlice)((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.hexDataSlice)(publicKey, 1)), 12));
}
function $c220423970a40605$export$23cc18f96d8510e2(digest, signature) {
    return $c220423970a40605$export$e67e2732ba9803f9((0, $c996070d7a4cc0da$export$952dd09fbe0232b7)((0, $9uSEH.arrayify)(digest), signature));
}
function $c220423970a40605$var$formatNumber(value, name) {
    const result = (0, $9uSEH.stripZeros)((0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $c220423970a40605$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $c220423970a40605$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $3bbab26945c6bdb1$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $9uSEH.hexDataLength)(storageKey) !== 32) $c220423970a40605$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $c220423970a40605$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $c220423970a40605$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $c220423970a40605$var$accessSetify(set[0], set[1]);
        }
        return $c220423970a40605$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $c220423970a40605$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $c220423970a40605$var$formatAccessList(value) {
    return $c220423970a40605$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $c220423970a40605$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $c220423970a40605$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $c220423970a40605$var$formatNumber(transaction.chainId || 0, "chainId"),
        $c220423970a40605$var$formatNumber(transaction.nonce || 0, "nonce"),
        $c220423970a40605$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $c220423970a40605$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $c220423970a40605$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $3bbab26945c6bdb1$export$88411125f012957a)(transaction.to) : "0x",
        $c220423970a40605$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $c220423970a40605$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $9uSEH.splitSignature)(signature);
        fields.push($c220423970a40605$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $9uSEH.stripZeros)(sig.r));
        fields.push((0, $9uSEH.stripZeros)(sig.s));
    }
    return (0, $9uSEH.hexConcat)([
        "0x02",
        $hiDPq.encode(fields)
    ]);
}
function $c220423970a40605$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $c220423970a40605$var$formatNumber(transaction.chainId || 0, "chainId"),
        $c220423970a40605$var$formatNumber(transaction.nonce || 0, "nonce"),
        $c220423970a40605$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $c220423970a40605$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $3bbab26945c6bdb1$export$88411125f012957a)(transaction.to) : "0x",
        $c220423970a40605$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $c220423970a40605$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $9uSEH.splitSignature)(signature);
        fields.push($c220423970a40605$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $9uSEH.stripZeros)(sig.r));
        fields.push((0, $9uSEH.stripZeros)(sig.s));
    }
    return (0, $9uSEH.hexConcat)([
        "0x01",
        $hiDPq.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $c220423970a40605$var$_serialize(transaction, signature) {
    (0, $e72ut.checkProperties)(transaction, $c220423970a40605$var$allowedTransactionKeys);
    const raw = [];
    $c220423970a40605$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $9uSEH.arrayify)((0, $9uSEH.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $c220423970a40605$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $9uSEH.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $c220423970a40605$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $9uSEH.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $c220423970a40605$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $9uSEH.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $9uSEH.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $hiDPq.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $9uSEH.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $c220423970a40605$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $c220423970a40605$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $9uSEH.hexlify)(v));
    raw.push((0, $9uSEH.stripZeros)((0, $9uSEH.arrayify)(sig.r)));
    raw.push((0, $9uSEH.stripZeros)((0, $9uSEH.arrayify)(sig.s)));
    return $hiDPq.encode(raw);
}
function $c220423970a40605$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $c220423970a40605$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $c220423970a40605$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $c220423970a40605$var$_serializeEip2930(transaction, signature);
        case 2:
            return $c220423970a40605$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $c220423970a40605$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $c220423970a40605$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $c220423970a40605$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $c220423970a40605$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $9uSEH.hexZeroPad)(fields[1], 32);
    tx.s = (0, $9uSEH.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $5915e762efc52191$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $c220423970a40605$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $c220423970a40605$var$_parseEip1559(payload) {
    const transaction = $hiDPq.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $c220423970a40605$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $9uSEH.hexlify)(payload));
    const maxPriorityFeePerGas = $c220423970a40605$var$handleNumber(transaction[2]);
    const maxFeePerGas = $c220423970a40605$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $c220423970a40605$var$handleNumber(transaction[0]).toNumber(),
        nonce: $c220423970a40605$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $c220423970a40605$var$handleNumber(transaction[4]),
        to: $c220423970a40605$var$handleAddress(transaction[5]),
        value: $c220423970a40605$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $c220423970a40605$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $5915e762efc52191$export$f8151fce47ad1c35)(payload);
    $c220423970a40605$var$_parseEipSignature(tx, transaction.slice(9), $c220423970a40605$var$_serializeEip1559);
    return tx;
}
function $c220423970a40605$var$_parseEip2930(payload) {
    const transaction = $hiDPq.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $c220423970a40605$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $9uSEH.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $c220423970a40605$var$handleNumber(transaction[0]).toNumber(),
        nonce: $c220423970a40605$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $c220423970a40605$var$handleNumber(transaction[2]),
        gasLimit: $c220423970a40605$var$handleNumber(transaction[3]),
        to: $c220423970a40605$var$handleAddress(transaction[4]),
        value: $c220423970a40605$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $c220423970a40605$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $5915e762efc52191$export$f8151fce47ad1c35)(payload);
    $c220423970a40605$var$_parseEipSignature(tx, transaction.slice(8), $c220423970a40605$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $c220423970a40605$var$_parse(rawTransaction) {
    const transaction = $hiDPq.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $c220423970a40605$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $c220423970a40605$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $c220423970a40605$var$handleNumber(transaction[1]),
        gasLimit: $c220423970a40605$var$handleNumber(transaction[2]),
        to: $c220423970a40605$var$handleAddress(transaction[3]),
        value: $c220423970a40605$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $9uSEH.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $9uSEH.hexZeroPad)(transaction[8], 32);
    if ((0, $ef87335f524ab6ee$export$d97aa349ed20696).from(tx.r).isZero() && (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $9uSEH.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $5915e762efc52191$export$f8151fce47ad1c35)($hiDPq.encode(raw));
        try {
            tx.from = $c220423970a40605$export$23cc18f96d8510e2(digest, {
                r: (0, $9uSEH.hexlify)(tx.r),
                s: (0, $9uSEH.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $5915e762efc52191$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $c220423970a40605$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $9uSEH.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $c220423970a40605$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $c220423970a40605$var$_parseEip2930(payload);
        case 2:
            return $c220423970a40605$var$_parseEip1559(payload);
        default:
            break;
    }
    return $c220423970a40605$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



var $f8A5C = parcelRequire("f8A5C");
const $a373a377f5f8bca9$export$83d89fbfd8236492 = "contracts/5.6.2";


"use strict";
var $77d1b08e82bacf11$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $77d1b08e82bacf11$var$logger = new (0, $f8A5C.Logger)((0, $a373a377f5f8bca9$export$83d89fbfd8236492));
///////////////////////////////
const $77d1b08e82bacf11$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $77d1b08e82bacf11$var$resolveName(resolver, nameOrPromise) {
    return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $77d1b08e82bacf11$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $3bbab26945c6bdb1$export$88411125f012957a)(name);
        } catch (error) {}
        if (!resolver) $77d1b08e82bacf11$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $77d1b08e82bacf11$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $77d1b08e82bacf11$var$resolveAddresses(resolver, value, paramType) {
    return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $77d1b08e82bacf11$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $77d1b08e82bacf11$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $77d1b08e82bacf11$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($77d1b08e82bacf11$var$logger.makeError("invalid value for array", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$77d1b08e82bacf11$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $77d1b08e82bacf11$var$populateTransaction(contract, fragment, args) {
    return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $e72ut.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $77d1b08e82bacf11$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $e72ut.resolveProperties)({
                override: $77d1b08e82bacf11$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $3bbab26945c6bdb1$export$88411125f012957a)(check.signer) !== check.override) $77d1b08e82bacf11$var$logger.throwError("Contract with a Signer cannot override from", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $77d1b08e82bacf11$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $e72ut.resolveProperties)({
            args: $77d1b08e82bacf11$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $e72ut.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $c220423970a40605$export$6c8662b1600dce2)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $9uSEH.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $77d1b08e82bacf11$var$logger.throwError("non-payable method cannot override value", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $e72ut.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $77d1b08e82bacf11$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $77d1b08e82bacf11$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $77d1b08e82bacf11$var$populateTransaction(contract, fragment, args);
    };
}
function $77d1b08e82bacf11$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $77d1b08e82bacf11$var$logger.throwError("estimate require a provider or signer", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $77d1b08e82bacf11$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $77d1b08e82bacf11$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $e72ut.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $77d1b08e82bacf11$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $e72ut.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $77d1b08e82bacf11$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $f8A5C.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $77d1b08e82bacf11$var$buildSend(contract, fragment) {
    return function(...args) {
        return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $77d1b08e82bacf11$var$logger.throwError("sending a transaction requires a signer", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $77d1b08e82bacf11$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $77d1b08e82bacf11$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $77d1b08e82bacf11$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $77d1b08e82bacf11$var$buildCall(contract, fragment, collapseSimple);
    return $77d1b08e82bacf11$var$buildSend(contract, fragment);
}
function $77d1b08e82bacf11$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $77d1b08e82bacf11$var$RunningEvent {
    constructor(tag, filter){
        (0, $e72ut.defineReadOnly)(this, "tag", tag);
        (0, $e72ut.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $77d1b08e82bacf11$var$ErrorRunningEvent extends $77d1b08e82bacf11$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $77d1b08e82bacf11$var$FragmentRunningEvent extends $77d1b08e82bacf11$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $77d1b08e82bacf11$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($77d1b08e82bacf11$var$getEventTag(filter), filter);
        (0, $e72ut.defineReadOnly)(this, "address", address);
        (0, $e72ut.defineReadOnly)(this, "interface", contractInterface);
        (0, $e72ut.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $2443aa857d9ae22f$export$5546b9ec21157cc2)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $77d1b08e82bacf11$var$WildcardRunningEvent extends $77d1b08e82bacf11$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $e72ut.defineReadOnly)(this, "address", address);
        (0, $e72ut.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $77d1b08e82bacf11$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $e72ut.defineReadOnly)(this, "interface", (0, $e72ut.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $e72ut.defineReadOnly)(this, "provider", null);
            (0, $e72ut.defineReadOnly)(this, "signer", null);
        } else if ((0, $j7x7T.Signer).isSigner(signerOrProvider)) {
            (0, $e72ut.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $e72ut.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $20eaa00aa96c05e1$exports.Provider).isProvider(signerOrProvider)) {
            (0, $e72ut.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $e72ut.defineReadOnly)(this, "signer", null);
        } else $77d1b08e82bacf11$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $e72ut.defineReadOnly)(this, "callStatic", {});
        (0, $e72ut.defineReadOnly)(this, "estimateGas", {});
        (0, $e72ut.defineReadOnly)(this, "functions", {});
        (0, $e72ut.defineReadOnly)(this, "populateTransaction", {});
        (0, $e72ut.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $e72ut.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $e72ut.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $77d1b08e82bacf11$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $e72ut.defineReadOnly)(this, "_runningEvents", {});
        (0, $e72ut.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $77d1b08e82bacf11$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $e72ut.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $e72ut.defineReadOnly)(this, "resolvedAddress", $77d1b08e82bacf11$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $e72ut.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $3bbab26945c6bdb1$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $77d1b08e82bacf11$var$logger.throwError("provider is required to use ENS name as contract address", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $77d1b08e82bacf11$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $e72ut.defineReadOnly)(this, signature, $77d1b08e82bacf11$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $e72ut.defineReadOnly)(this.functions, signature, $77d1b08e82bacf11$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $e72ut.defineReadOnly)(this.callStatic, signature, $77d1b08e82bacf11$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $e72ut.defineReadOnly)(this.populateTransaction, signature, $77d1b08e82bacf11$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $e72ut.defineReadOnly)(this.estimateGas, signature, $77d1b08e82bacf11$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $e72ut.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $e72ut.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $e72ut.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $e72ut.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $e72ut.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $3bbab26945c6bdb1$export$b7fbffef12272e40)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $6c9fdbc6de4e49f0$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
        return new (0, $6c9fdbc6de4e49f0$export$48cefb51a4e315b2)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $77d1b08e82bacf11$var$logger.throwError("contract not deployed", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $77d1b08e82bacf11$var$logger.throwError("sending a transactions require a signer", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $e72ut.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $77d1b08e82bacf11$var$logger.throwError("cannot override " + key, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $j7x7T.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $e72ut.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$RunningEvent($77d1b08e82bacf11$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $77d1b08e82bacf11$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $e72ut.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $77d1b08e82bacf11$var$logger.throwError("events require a provider or a signer with a provider", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $e72ut.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $9uSEH.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $77d1b08e82bacf11$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $77d1b08e82bacf11$export$8517d80acf00e19a extends $77d1b08e82bacf11$export$304faa4fc17528db {
}
class $77d1b08e82bacf11$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $9uSEH.isBytes)(bytecode)) bytecodeHex = (0, $9uSEH.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $9uSEH.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $77d1b08e82bacf11$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $j7x7T.Signer).isSigner(signer)) $77d1b08e82bacf11$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $e72ut.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $e72ut.defineReadOnly)(this, "interface", (0, $e72ut.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $e72ut.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $e72ut.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$77d1b08e82bacf11$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $77d1b08e82bacf11$var$logger.throwError("cannot override " + key, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $77d1b08e82bacf11$var$logger.throwError("non-payable constructor cannot override value", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $77d1b08e82bacf11$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $9uSEH.hexlify)((0, $9uSEH.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $77d1b08e82bacf11$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $77d1b08e82bacf11$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $77d1b08e82bacf11$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $e72ut.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $e72ut.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $77d1b08e82bacf11$var$addContractWait(contract, tx);
            (0, $e72ut.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $77d1b08e82bacf11$var$logger.throwError("missing compiler output", (0, $f8A5C.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $77d1b08e82bacf11$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $3bbab26945c6bdb1$export$b7fbffef12272e40)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $77d1b08e82bacf11$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}



var $9uSEH = parcelRequire("9uSEH");

var $f8A5C = parcelRequire("f8A5C");


"use strict";
const $b263b4723a2f8d0b$var$logger = new (0, $f8A5C.Logger)((0, $70ed171ea6e5a914$export$83d89fbfd8236492));
const $b263b4723a2f8d0b$var$_constructorGuard = {};
const $b263b4723a2f8d0b$var$Zero = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(0);
const $b263b4723a2f8d0b$var$NegativeOne = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(-1);
function $b263b4723a2f8d0b$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $b263b4723a2f8d0b$var$logger.throwError(message, (0, $f8A5C.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $b263b4723a2f8d0b$var$zeros = "0";
while($b263b4723a2f8d0b$var$zeros.length < 256)$b263b4723a2f8d0b$var$zeros += $b263b4723a2f8d0b$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $b263b4723a2f8d0b$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $b263b4723a2f8d0b$var$zeros.substring(0, decimals);
    return $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $b263b4723a2f8d0b$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $b263b4723a2f8d0b$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value);
    const negative = value.lt($b263b4723a2f8d0b$var$Zero);
    if (negative) value = value.mul($b263b4723a2f8d0b$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $b263b4723a2f8d0b$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $b263b4723a2f8d0b$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $b263b4723a2f8d0b$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $b263b4723a2f8d0b$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $b263b4723a2f8d0b$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(whole);
    const fractionValue = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($b263b4723a2f8d0b$var$NegativeOne);
    return wei;
}
class $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $b263b4723a2f8d0b$var$_constructorGuard) $b263b4723a2f8d0b$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $b263b4723a2f8d0b$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d($b263b4723a2f8d0b$var$_constructorGuard, signed, width, decimals);
    }
}
class $b263b4723a2f8d0b$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $b263b4723a2f8d0b$var$_constructorGuard) $b263b4723a2f8d0b$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $b263b4723a2f8d0b$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $b263b4723a2f8d0b$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $b263b4723a2f8d0b$export$1b039987e86d7269(other._value, other.format.decimals);
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $b263b4723a2f8d0b$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $b263b4723a2f8d0b$export$1b039987e86d7269(other._value, other.format.decimals);
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $b263b4723a2f8d0b$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $b263b4723a2f8d0b$export$1b039987e86d7269(other._value, other.format.decimals);
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $b263b4723a2f8d0b$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $b263b4723a2f8d0b$export$1b039987e86d7269(other._value, other.format.decimals);
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $b263b4723a2f8d0b$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($b263b4723a2f8d0b$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $b263b4723a2f8d0b$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($b263b4723a2f8d0b$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $b263b4723a2f8d0b$export$d4693c66c2213e45.from("1" + $b263b4723a2f8d0b$var$zeros.substring(0, decimals), this.format);
        const bump = $b263b4723a2f8d0b$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $9uSEH.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $ef87335f524ab6ee$export$a3d0a7fa9b65683b)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromString($b263b4723a2f8d0b$export$cc011b843b5d69f2(value, decimals), $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $b263b4723a2f8d0b$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($b263b4723a2f8d0b$var$Zero)) $b263b4723a2f8d0b$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $9uSEH.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $b263b4723a2f8d0b$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $b263b4723a2f8d0b$export$d4693c66c2213e45($b263b4723a2f8d0b$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $b263b4723a2f8d0b$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $9uSEH.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $b263b4723a2f8d0b$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $b263b4723a2f8d0b$export$d4693c66c2213e45($b263b4723a2f8d0b$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $9uSEH.isBytes)(value)) return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $b263b4723a2f8d0b$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $f8A5C.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $b263b4723a2f8d0b$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $b263b4723a2f8d0b$var$ONE = $b263b4723a2f8d0b$export$d4693c66c2213e45.from(1);
const $b263b4723a2f8d0b$var$BUMP = $b263b4723a2f8d0b$export$d4693c66c2213e45.from("0.5");



var $j7x7T = parcelRequire("j7x7T");
var $8c76997802860d88$exports = {};

$parcel$export($8c76997802860d88$exports, "Wallet", () => $8c76997802860d88$export$bcca3ea514774656);
$parcel$export($8c76997802860d88$exports, "verifyMessage", () => $8c76997802860d88$export$228d0e772cc158cb);
$parcel$export($8c76997802860d88$exports, "verifyTypedData", () => $8c76997802860d88$export$3603b1c1bcd76798);



var $j7x7T = parcelRequire("j7x7T");

var $9uSEH = parcelRequire("9uSEH");
var $8feb3fe5353bb1cc$exports = {};

$parcel$export($8feb3fe5353bb1cc$exports, "TypedDataEncoder", () => $8feb3fe5353bb1cc$export$458ab927ae635c3);



var $9uSEH = parcelRequire("9uSEH");


var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");
const $29379b8d17d6e18a$export$83d89fbfd8236492 = "hash/5.6.1";



var $8feb3fe5353bb1cc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8feb3fe5353bb1cc$var$logger = new (0, $f8A5C.Logger)((0, $29379b8d17d6e18a$export$83d89fbfd8236492));
const $8feb3fe5353bb1cc$var$padding = new Uint8Array(32);
$8feb3fe5353bb1cc$var$padding.fill(0);
const $8feb3fe5353bb1cc$var$NegativeOne = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(-1);
const $8feb3fe5353bb1cc$var$Zero = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(0);
const $8feb3fe5353bb1cc$var$One = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(1);
const $8feb3fe5353bb1cc$var$MaxUint256 = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $8feb3fe5353bb1cc$var$hexPadRight(value) {
    const bytes = (0, $9uSEH.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $9uSEH.hexConcat)([
        bytes,
        $8feb3fe5353bb1cc$var$padding.slice(padOffset)
    ]);
    return (0, $9uSEH.hexlify)(bytes);
}
const $8feb3fe5353bb1cc$var$hexTrue = (0, $9uSEH.hexZeroPad)($8feb3fe5353bb1cc$var$One.toHexString(), 32);
const $8feb3fe5353bb1cc$var$hexFalse = (0, $9uSEH.hexZeroPad)($8feb3fe5353bb1cc$var$Zero.toHexString(), 32);
const $8feb3fe5353bb1cc$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $8feb3fe5353bb1cc$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $8feb3fe5353bb1cc$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $8feb3fe5353bb1cc$var$domainChecks = {
    name: $8feb3fe5353bb1cc$var$checkString("name"),
    version: $8feb3fe5353bb1cc$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $3bbab26945c6bdb1$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $9uSEH.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $9uSEH.hexlify)(bytes);
        } catch (error) {}
        return $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $8feb3fe5353bb1cc$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $8feb3fe5353bb1cc$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $8feb3fe5353bb1cc$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($8feb3fe5353bb1cc$var$One).mul($8feb3fe5353bb1cc$var$NegativeOne) : $8feb3fe5353bb1cc$var$Zero;
            return function(value) {
                const v = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $9uSEH.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $8feb3fe5353bb1cc$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $9uSEH.arrayify)(value);
                if (bytes.length !== width) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $8feb3fe5353bb1cc$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $9uSEH.hexZeroPad)((0, $3bbab26945c6bdb1$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $8feb3fe5353bb1cc$var$hexFalse : $8feb3fe5353bb1cc$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $5915e762efc52191$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $8feb3fe5353bb1cc$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $8feb3fe5353bb1cc$export$458ab927ae635c3 {
    constructor(types){
        (0, $e72ut.defineReadOnly)(this, "types", Object.freeze((0, $e72ut.deepCopy)(types)));
        (0, $e72ut.defineReadOnly)(this, "_encoderCache", {});
        (0, $e72ut.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $8feb3fe5353bb1cc$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $8feb3fe5353bb1cc$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $e72ut.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $8feb3fe5353bb1cc$var$encodeType(name, types[name]) + st.map((t)=>$8feb3fe5353bb1cc$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $8feb3fe5353bb1cc$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $8feb3fe5353bb1cc$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $5915e762efc52191$export$f8151fce47ad1c35));
                return (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $c37a351bb1ec7c40$export$d560c7e4a29451c2)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $5915e762efc52191$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $9uSEH.hexConcat)(values);
            };
        }
        return $8feb3fe5353bb1cc$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $5915e762efc52191$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $8feb3fe5353bb1cc$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $8feb3fe5353bb1cc$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $8feb3fe5353bb1cc$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $8feb3fe5353bb1cc$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $8feb3fe5353bb1cc$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $8feb3fe5353bb1cc$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $8feb3fe5353bb1cc$var$domainFieldTypes[name];
            if (!type) $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $8feb3fe5353bb1cc$var$domainFieldNames.indexOf(a.name) - $8feb3fe5353bb1cc$var$domainFieldNames.indexOf(b.name);
        });
        return $8feb3fe5353bb1cc$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $9uSEH.hexConcat)([
            "0x1901",
            $8feb3fe5353bb1cc$export$458ab927ae635c3.hashDomain(domain),
            $8feb3fe5353bb1cc$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $5915e762efc52191$export$f8151fce47ad1c35)($8feb3fe5353bb1cc$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $8feb3fe5353bb1cc$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $e72ut.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $9uSEH.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $8feb3fe5353bb1cc$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $9uSEH.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $8feb3fe5353bb1cc$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $8feb3fe5353bb1cc$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $8feb3fe5353bb1cc$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $8feb3fe5353bb1cc$var$domainFieldTypes[name]
            });
        });
        const encoder = $8feb3fe5353bb1cc$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $e72ut.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $8feb3fe5353bb1cc$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $9uSEH.hexlify)((0, $9uSEH.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $8feb3fe5353bb1cc$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $8feb3fe5353bb1cc$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}


var $9uSEH = parcelRequire("9uSEH");


const $146df85c9b7f1867$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $146df85c9b7f1867$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(message);
    return (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
        (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)($146df85c9b7f1867$export$1ff3fdc4802a2ba6),
        (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}


/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ const $c3a328ed98aba94d$export$83d89fbfd8236492 = "logger/5.6.0";


"use strict";
let $c1e9b530ab62bf0f$var$_permanentCensorErrors = false;
let $c1e9b530ab62bf0f$var$_censorErrors = false;
const $c1e9b530ab62bf0f$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $c1e9b530ab62bf0f$var$_logLevel = $c1e9b530ab62bf0f$var$LogLevels["default"];
let $c1e9b530ab62bf0f$var$_globalLogger = null;
function $c1e9b530ab62bf0f$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $c1e9b530ab62bf0f$var$_normalizeError = $c1e9b530ab62bf0f$var$_checkNormalize();
var $c1e9b530ab62bf0f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($c1e9b530ab62bf0f$export$243e62d78d3b544d || ($c1e9b530ab62bf0f$export$243e62d78d3b544d = {}));
var $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb || ($c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb = {}));
const $c1e9b530ab62bf0f$var$HEX = "0123456789abcdef";
class $c1e9b530ab62bf0f$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($c1e9b530ab62bf0f$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($c1e9b530ab62bf0f$var$_logLevel > $c1e9b530ab62bf0f$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($c1e9b530ab62bf0f$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($c1e9b530ab62bf0f$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($c1e9b530ab62bf0f$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($c1e9b530ab62bf0f$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $c1e9b530ab62bf0f$var$HEX[value[i] >> 4];
                        hex += $c1e9b530ab62bf0f$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($c1e9b530ab62bf0f$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $c1e9b530ab62bf0f$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$c1e9b530ab62bf0f$var$_globalLogger) $c1e9b530ab62bf0f$var$_globalLogger = new $c1e9b530ab62bf0f$export$efa9a398d6368992((0, $c3a328ed98aba94d$export$83d89fbfd8236492));
        return $c1e9b530ab62bf0f$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($c1e9b530ab62bf0f$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $c1e9b530ab62bf0f$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $c1e9b530ab62bf0f$var$_censorErrors = !!censorship;
        $c1e9b530ab62bf0f$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $c1e9b530ab62bf0f$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $c1e9b530ab62bf0f$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $c1e9b530ab62bf0f$var$_logLevel = level;
    }
    static from(version) {
        return new $c1e9b530ab62bf0f$export$efa9a398d6368992(version);
    }
}
$c1e9b530ab62bf0f$export$efa9a398d6368992.errors = $c1e9b530ab62bf0f$export$d4e71bc0b80dc0fb;
$c1e9b530ab62bf0f$export$efa9a398d6368992.levels = $c1e9b530ab62bf0f$export$243e62d78d3b544d;


const $f7b8286b4525e5c4$export$83d89fbfd8236492 = "bytes/5.6.1";


"use strict";
const $9159a6fb125b2d57$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $f7b8286b4525e5c4$export$83d89fbfd8236492));
///////////////////////////////
function $9159a6fb125b2d57$var$isHexable(value) {
    return !!value.toHexString;
}
function $9159a6fb125b2d57$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $9159a6fb125b2d57$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $9159a6fb125b2d57$export$9a14abb1a440cd5e(value) {
    return $9159a6fb125b2d57$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $9159a6fb125b2d57$export$c6fabfbfd097fc30(value);
}
function $9159a6fb125b2d57$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $9159a6fb125b2d57$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$9159a6fb125b2d57$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$9159a6fb125b2d57$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $9159a6fb125b2d57$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $9159a6fb125b2d57$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $9159a6fb125b2d57$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($9159a6fb125b2d57$var$isHexable(value)) value = value.toHexString();
    if ($9159a6fb125b2d57$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $9159a6fb125b2d57$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $9159a6fb125b2d57$var$addSlice(new Uint8Array(result));
    }
    if ($9159a6fb125b2d57$export$c6fabfbfd097fc30(value)) return $9159a6fb125b2d57$var$addSlice(new Uint8Array(value));
    return $9159a6fb125b2d57$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $9159a6fb125b2d57$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$9159a6fb125b2d57$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $9159a6fb125b2d57$var$addSlice(result);
}
function $9159a6fb125b2d57$export$a8f4574d0e56446c(value) {
    let result = $9159a6fb125b2d57$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $9159a6fb125b2d57$export$3cdc770bf8b2ed3d(value, length) {
    value = $9159a6fb125b2d57$export$3131421a7d01b4fb(value);
    if (value.length > length) $9159a6fb125b2d57$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $9159a6fb125b2d57$var$addSlice(result);
}
function $9159a6fb125b2d57$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $9159a6fb125b2d57$var$HexCharacters = "0123456789abcdef";
function $9159a6fb125b2d57$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $9159a6fb125b2d57$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $9159a6fb125b2d57$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($9159a6fb125b2d57$var$isHexable(value)) return value.toHexString();
    if ($9159a6fb125b2d57$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $9159a6fb125b2d57$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($9159a6fb125b2d57$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $9159a6fb125b2d57$var$HexCharacters[(v & 0xf0) >> 4] + $9159a6fb125b2d57$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $9159a6fb125b2d57$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $9159a6fb125b2d57$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(data);
    else if (!$9159a6fb125b2d57$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $9159a6fb125b2d57$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(data);
    else if (!$9159a6fb125b2d57$export$b02a40aff8e4ad18(data) || data.length % 2) $9159a6fb125b2d57$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $9159a6fb125b2d57$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $9159a6fb125b2d57$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $9159a6fb125b2d57$export$6916af760a341dd3(value) {
    const trimmed = $9159a6fb125b2d57$export$967bc0082a978949($9159a6fb125b2d57$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $9159a6fb125b2d57$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(value);
    if (!$9159a6fb125b2d57$export$b02a40aff8e4ad18(value)) $9159a6fb125b2d57$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $9159a6fb125b2d57$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(value);
    else if (!$9159a6fb125b2d57$export$b02a40aff8e4ad18(value)) $9159a6fb125b2d57$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $9159a6fb125b2d57$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $9159a6fb125b2d57$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($9159a6fb125b2d57$export$9a14abb1a440cd5e(signature)) {
        let bytes = $9159a6fb125b2d57$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $9159a6fb125b2d57$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $9159a6fb125b2d57$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $9159a6fb125b2d57$export$3cdc770bf8b2ed3d($9159a6fb125b2d57$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $9159a6fb125b2d57$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $9159a6fb125b2d57$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $9159a6fb125b2d57$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $9159a6fb125b2d57$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$9159a6fb125b2d57$export$b02a40aff8e4ad18(result.r)) $9159a6fb125b2d57$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $9159a6fb125b2d57$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$9159a6fb125b2d57$export$b02a40aff8e4ad18(result.s)) $9159a6fb125b2d57$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $9159a6fb125b2d57$export$e9c46a54370b47e8(result.s, 32);
        const vs = $9159a6fb125b2d57$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $9159a6fb125b2d57$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $9159a6fb125b2d57$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$9159a6fb125b2d57$export$b02a40aff8e4ad18(result._vs)) $9159a6fb125b2d57$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $9159a6fb125b2d57$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $9159a6fb125b2d57$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $9159a6fb125b2d57$export$71bb9d78a59bbe25(signature) {
    signature = $9159a6fb125b2d57$export$7fb170f1e457988f(signature);
    return $9159a6fb125b2d57$export$2b0d6b5fbe698c70($9159a6fb125b2d57$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $e72ut = parcelRequire("e72ut");
class $76a0e587fe4e380f$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $e72ut.defineReadOnly)(this, "alphabet", alphabet);
        (0, $e72ut.defineReadOnly)(this, "base", alphabet.length);
        (0, $e72ut.defineReadOnly)(this, "_alphabetMap", {});
        (0, $e72ut.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
    }
}
const $76a0e587fe4e380f$export$cfabb2852920f5ec = new $76a0e587fe4e380f$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $76a0e587fe4e380f$export$45a587635c9954b2 = new $76a0e587fe4e380f$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))




var $dEXSZ = parcelRequire("dEXSZ");


const $59357a3fc6cb812d$export$83d89fbfd8236492 = "bignumber/5.6.2";


"use strict";
var $99d09c413e88d51e$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $99d09c413e88d51e$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $59357a3fc6cb812d$export$83d89fbfd8236492));
const $99d09c413e88d51e$var$_constructorGuard = {};
const $99d09c413e88d51e$var$MAX_SAFE = 0x1fffffffffffff;
function $99d09c413e88d51e$export$a3d0a7fa9b65683b(value) {
    return value != null && ($99d09c413e88d51e$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $9159a6fb125b2d57$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $9159a6fb125b2d57$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $99d09c413e88d51e$var$_warnedToStringRadix = false;
class $99d09c413e88d51e$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $99d09c413e88d51e$var$_constructorGuard) $99d09c413e88d51e$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $99d09c413e88d51e$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).add($99d09c413e88d51e$var$toBN(other)));
    }
    sub(other) {
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).sub($99d09c413e88d51e$var$toBN(other)));
    }
    div(other) {
        const o = $99d09c413e88d51e$export$d97aa349ed20696.from(other);
        if (o.isZero()) $99d09c413e88d51e$var$throwFault("division-by-zero", "div");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).div($99d09c413e88d51e$var$toBN(other)));
    }
    mul(other) {
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).mul($99d09c413e88d51e$var$toBN(other)));
    }
    mod(other) {
        const value = $99d09c413e88d51e$var$toBN(other);
        if (value.isNeg()) $99d09c413e88d51e$var$throwFault("division-by-zero", "mod");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $99d09c413e88d51e$var$toBN(other);
        if (value.isNeg()) $99d09c413e88d51e$var$throwFault("negative-power", "pow");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $99d09c413e88d51e$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $99d09c413e88d51e$var$throwFault("unbound-bitwise-result", "and");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).and(value));
    }
    or(other) {
        const value = $99d09c413e88d51e$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $99d09c413e88d51e$var$throwFault("unbound-bitwise-result", "or");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $99d09c413e88d51e$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $99d09c413e88d51e$var$throwFault("unbound-bitwise-result", "xor");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $99d09c413e88d51e$var$throwFault("negative-width", "mask");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $99d09c413e88d51e$var$throwFault("negative-width", "shl");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $99d09c413e88d51e$var$throwFault("negative-width", "shr");
        return $99d09c413e88d51e$var$toBigNumber($99d09c413e88d51e$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $99d09c413e88d51e$var$toBN(this).eq($99d09c413e88d51e$var$toBN(other));
    }
    lt(other) {
        return $99d09c413e88d51e$var$toBN(this).lt($99d09c413e88d51e$var$toBN(other));
    }
    lte(other) {
        return $99d09c413e88d51e$var$toBN(this).lte($99d09c413e88d51e$var$toBN(other));
    }
    gt(other) {
        return $99d09c413e88d51e$var$toBN(this).gt($99d09c413e88d51e$var$toBN(other));
    }
    gte(other) {
        return $99d09c413e88d51e$var$toBN(this).gte($99d09c413e88d51e$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $99d09c413e88d51e$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $99d09c413e88d51e$var$toBN(this).toNumber();
        } catch (error) {
            $99d09c413e88d51e$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $99d09c413e88d51e$var$logger.throwError("this platform does not support BigInt", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$99d09c413e88d51e$var$_warnedToStringRadix) {
                    $99d09c413e88d51e$var$_warnedToStringRadix = true;
                    $99d09c413e88d51e$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $99d09c413e88d51e$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $99d09c413e88d51e$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $99d09c413e88d51e$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $99d09c413e88d51e$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $99d09c413e88d51e$export$d97aa349ed20696($99d09c413e88d51e$var$_constructorGuard, $99d09c413e88d51e$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $99d09c413e88d51e$export$d97aa349ed20696($99d09c413e88d51e$var$_constructorGuard, $99d09c413e88d51e$var$toHex(new $99d09c413e88d51e$var$BN(value)));
            return $99d09c413e88d51e$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $99d09c413e88d51e$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $99d09c413e88d51e$var$MAX_SAFE || value <= -$99d09c413e88d51e$var$MAX_SAFE) $99d09c413e88d51e$var$throwFault("overflow", "BigNumber.from", value);
            return $99d09c413e88d51e$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $99d09c413e88d51e$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $9159a6fb125b2d57$export$c6fabfbfd097fc30)(anyValue)) return $99d09c413e88d51e$export$d97aa349ed20696.from((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $99d09c413e88d51e$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $9159a6fb125b2d57$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $9159a6fb125b2d57$export$b02a40aff8e4ad18)(hex.substring(1))) return $99d09c413e88d51e$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $99d09c413e88d51e$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $99d09c413e88d51e$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $99d09c413e88d51e$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $99d09c413e88d51e$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $99d09c413e88d51e$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $99d09c413e88d51e$var$toBigNumber(value) {
    return $99d09c413e88d51e$export$d97aa349ed20696.from($99d09c413e88d51e$var$toHex(value));
}
function $99d09c413e88d51e$var$toBN(value) {
    const hex = $99d09c413e88d51e$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $99d09c413e88d51e$var$BN("-" + hex.substring(3), 16);
    return new $99d09c413e88d51e$var$BN(hex.substring(2), 16);
}
function $99d09c413e88d51e$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $99d09c413e88d51e$var$logger.throwError(fault, (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $99d09c413e88d51e$export$51e4a08295f7770f(value) {
    return new $99d09c413e88d51e$var$BN(value, 36).toString(16);
}
function $99d09c413e88d51e$export$1293db5d29c264ff(value) {
    return new $99d09c413e88d51e$var$BN(value, 16).toString(36);
}




const $08749f10fb081d44$export$83d89fbfd8236492 = "strings/5.6.1";


"use strict";
const $e8ba7ad5d41040e4$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $08749f10fb081d44$export$83d89fbfd8236492));
var $e8ba7ad5d41040e4$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($e8ba7ad5d41040e4$export$c6986442964129f5 || ($e8ba7ad5d41040e4$export$c6986442964129f5 = {}));
var $e8ba7ad5d41040e4$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6 || ($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6 = {}));
function $e8ba7ad5d41040e4$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $e8ba7ad5d41040e4$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $e8ba7ad5d41040e4$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $e8ba7ad5d41040e4$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $e8ba7ad5d41040e4$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $e8ba7ad5d41040e4$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $e8ba7ad5d41040e4$var$errorFunc,
    ignore: $e8ba7ad5d41040e4$var$ignoreFunc,
    replace: $e8ba7ad5d41040e4$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $e8ba7ad5d41040e4$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $e8ba7ad5d41040e4$export$c6e2180c5bb5bc05.error;
    bytes = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($e8ba7ad5d41040e4$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $e8ba7ad5d41040e4$export$8feeb310b4b4752f(str, form = $e8ba7ad5d41040e4$export$c6986442964129f5.current) {
    if (form != $e8ba7ad5d41040e4$export$c6986442964129f5.current) {
        $e8ba7ad5d41040e4$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(result);
}
function $e8ba7ad5d41040e4$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $e8ba7ad5d41040e4$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $e8ba7ad5d41040e4$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $e8ba7ad5d41040e4$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $e8ba7ad5d41040e4$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $e8ba7ad5d41040e4$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $e8ba7ad5d41040e4$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $e8ba7ad5d41040e4$export$7643a1dc2c38d5eb(bytes, onError) {
    return $e8ba7ad5d41040e4$export$232e1dab03132235($e8ba7ad5d41040e4$var$getUtf8CodePoints(bytes, onError));
}
function $e8ba7ad5d41040e4$export$ae470a36a31b28c2(str, form = $e8ba7ad5d41040e4$export$c6986442964129f5.current) {
    return $e8ba7ad5d41040e4$var$getUtf8CodePoints($e8ba7ad5d41040e4$export$8feeb310b4b4752f(str, form));
}




var $kiSKt = parcelRequire("kiSKt");

var $57fe67f9e914138c$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($57fe67f9e914138c$export$d2a8849cfb277c || ($57fe67f9e914138c$export$d2a8849cfb277c = {}));



const $511f28b206b5f771$export$83d89fbfd8236492 = "sha2/5.6.1";


"use strict";
const $6f432d194bb11e12$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $511f28b206b5f771$export$83d89fbfd8236492));
function $6f432d194bb11e12$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $6f432d194bb11e12$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $6f432d194bb11e12$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $6f432d194bb11e12$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $57fe67f9e914138c$export$d2a8849cfb277c)[algorithm]) $6f432d194bb11e12$var$logger.throwError("unsupported algorithm " + algorithm, (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(key)).update((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data)).digest("hex");
}


"use strict";
function $a7037ce6284c8725$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(password);
    salt = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(DK);
}



var $e72ut = parcelRequire("e72ut");

var $dEXSZ = parcelRequire("dEXSZ");

var $kiSKt = parcelRequire("kiSKt");
var $1bfd15ca1d0fe7e8$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $1bfd15ca1d0fe7e8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $1bfd15ca1d0fe7e8$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $1bfd15ca1d0fe7e8$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $1bfd15ca1d0fe7e8$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $1bfd15ca1d0fe7e8$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $1bfd15ca1d0fe7e8$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $1bfd15ca1d0fe7e8$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $1bfd15ca1d0fe7e8$var$minimalisticAssert = $1bfd15ca1d0fe7e8$var$assert;
function $1bfd15ca1d0fe7e8$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$1bfd15ca1d0fe7e8$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $1bfd15ca1d0fe7e8$var$utils_1 = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $1bfd15ca1d0fe7e8$var$utils_1$1 = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $1bfd15ca1d0fe7e8$var$minimalisticAssert;
    utils.toArray = $1bfd15ca1d0fe7e8$var$utils_1.toArray;
    utils.zero2 = $1bfd15ca1d0fe7e8$var$utils_1.zero2;
    utils.toHex = $1bfd15ca1d0fe7e8$var$utils_1.toHex;
    utils.encode = $1bfd15ca1d0fe7e8$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $1bfd15ca1d0fe7e8$var$getNAF = $1bfd15ca1d0fe7e8$var$utils_1$1.getNAF;
var $1bfd15ca1d0fe7e8$var$getJSF = $1bfd15ca1d0fe7e8$var$utils_1$1.getJSF;
var $1bfd15ca1d0fe7e8$var$assert$1 = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
function $1bfd15ca1d0fe7e8$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $1bfd15ca1d0fe7e8$var$base = $1bfd15ca1d0fe7e8$var$BaseCurve;
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $1bfd15ca1d0fe7e8$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $1bfd15ca1d0fe7e8$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $1bfd15ca1d0fe7e8$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $1bfd15ca1d0fe7e8$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $1bfd15ca1d0fe7e8$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $1bfd15ca1d0fe7e8$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $1bfd15ca1d0fe7e8$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $1bfd15ca1d0fe7e8$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$1bfd15ca1d0fe7e8$var$BaseCurve.BasePoint = $1bfd15ca1d0fe7e8$var$BasePoint;
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$1bfd15ca1d0fe7e8$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $1bfd15ca1d0fe7e8$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $1bfd15ca1d0fe7e8$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $1bfd15ca1d0fe7e8$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $1bfd15ca1d0fe7e8$var$utils_1$1.encode(this._encode(compact), enc);
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$1bfd15ca1d0fe7e8$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $1bfd15ca1d0fe7e8$var$inherits_browser = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $1bfd15ca1d0fe7e8$var$assert$2 = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
function $1bfd15ca1d0fe7e8$var$ShortCurve(conf) {
    $1bfd15ca1d0fe7e8$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$1bfd15ca1d0fe7e8$var$inherits_browser($1bfd15ca1d0fe7e8$var$ShortCurve, $1bfd15ca1d0fe7e8$var$base);
var $1bfd15ca1d0fe7e8$var$short_1 = $1bfd15ca1d0fe7e8$var$ShortCurve;
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $1bfd15ca1d0fe7e8$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $1bfd15ca1d0fe7e8$var$Point(curve, x, y, isRed) {
    $1bfd15ca1d0fe7e8$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$1bfd15ca1d0fe7e8$var$inherits_browser($1bfd15ca1d0fe7e8$var$Point, $1bfd15ca1d0fe7e8$var$base.BasePoint);
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $1bfd15ca1d0fe7e8$var$Point(this, x, y, isRed);
};
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $1bfd15ca1d0fe7e8$var$Point.fromJSON(this, obj, red);
};
$1bfd15ca1d0fe7e8$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$1bfd15ca1d0fe7e8$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$1bfd15ca1d0fe7e8$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$1bfd15ca1d0fe7e8$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$1bfd15ca1d0fe7e8$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$1bfd15ca1d0fe7e8$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$1bfd15ca1d0fe7e8$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$1bfd15ca1d0fe7e8$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$1bfd15ca1d0fe7e8$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$1bfd15ca1d0fe7e8$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $1bfd15ca1d0fe7e8$var$JPoint(curve, x, y, z) {
    $1bfd15ca1d0fe7e8$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$1bfd15ca1d0fe7e8$var$inherits_browser($1bfd15ca1d0fe7e8$var$JPoint, $1bfd15ca1d0fe7e8$var$base.BasePoint);
$1bfd15ca1d0fe7e8$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $1bfd15ca1d0fe7e8$var$JPoint(this, x, y, z);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$1bfd15ca1d0fe7e8$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $1bfd15ca1d0fe7e8$var$curve_1 = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $1bfd15ca1d0fe7e8$var$base;
    curve.short = $1bfd15ca1d0fe7e8$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $1bfd15ca1d0fe7e8$var$curves_1 = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $1bfd15ca1d0fe7e8$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $1bfd15ca1d0fe7e8$var$curve_1.edwards(options);
        else this.curve = new $1bfd15ca1d0fe7e8$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $1bfd15ca1d0fe7e8$var$HmacDRBG(options) {
    if (!(this instanceof $1bfd15ca1d0fe7e8$var$HmacDRBG)) return new $1bfd15ca1d0fe7e8$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $1bfd15ca1d0fe7e8$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $1bfd15ca1d0fe7e8$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $1bfd15ca1d0fe7e8$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $1bfd15ca1d0fe7e8$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $1bfd15ca1d0fe7e8$var$hmacDrbg = $1bfd15ca1d0fe7e8$var$HmacDRBG;
$1bfd15ca1d0fe7e8$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$1bfd15ca1d0fe7e8$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$1bfd15ca1d0fe7e8$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$1bfd15ca1d0fe7e8$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $1bfd15ca1d0fe7e8$var$utils_1.toArray(entropy, entropyEnc);
    add = $1bfd15ca1d0fe7e8$var$utils_1.toArray(add, addEnc);
    $1bfd15ca1d0fe7e8$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$1bfd15ca1d0fe7e8$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $1bfd15ca1d0fe7e8$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $1bfd15ca1d0fe7e8$var$utils_1.encode(res, enc);
};
"use strict";
var $1bfd15ca1d0fe7e8$var$assert$3 = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
function $1bfd15ca1d0fe7e8$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $1bfd15ca1d0fe7e8$var$key = $1bfd15ca1d0fe7e8$var$KeyPair;
$1bfd15ca1d0fe7e8$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $1bfd15ca1d0fe7e8$var$KeyPair) return pub;
    return new $1bfd15ca1d0fe7e8$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$1bfd15ca1d0fe7e8$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $1bfd15ca1d0fe7e8$var$KeyPair) return priv;
    return new $1bfd15ca1d0fe7e8$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $1bfd15ca1d0fe7e8$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $1bfd15ca1d0fe7e8$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $1bfd15ca1d0fe7e8$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$1bfd15ca1d0fe7e8$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $1bfd15ca1d0fe7e8$var$assert$4 = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
function $1bfd15ca1d0fe7e8$var$Signature(options, enc) {
    if (options instanceof $1bfd15ca1d0fe7e8$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $1bfd15ca1d0fe7e8$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $1bfd15ca1d0fe7e8$var$signature = $1bfd15ca1d0fe7e8$var$Signature;
function $1bfd15ca1d0fe7e8$var$Position() {
    this.place = 0;
}
function $1bfd15ca1d0fe7e8$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $1bfd15ca1d0fe7e8$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$1bfd15ca1d0fe7e8$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $1bfd15ca1d0fe7e8$var$utils_1$1.toArray(data, enc);
    var p = new $1bfd15ca1d0fe7e8$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $1bfd15ca1d0fe7e8$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $1bfd15ca1d0fe7e8$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $1bfd15ca1d0fe7e8$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $1bfd15ca1d0fe7e8$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$1bfd15ca1d0fe7e8$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $1bfd15ca1d0fe7e8$var$rmPadding(r);
    s = $1bfd15ca1d0fe7e8$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $1bfd15ca1d0fe7e8$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $1bfd15ca1d0fe7e8$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $1bfd15ca1d0fe7e8$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $1bfd15ca1d0fe7e8$var$utils_1$1.encode(res, enc);
};
"use strict";
var $1bfd15ca1d0fe7e8$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $1bfd15ca1d0fe7e8$var$assert$5 = $1bfd15ca1d0fe7e8$var$utils_1$1.assert;
function $1bfd15ca1d0fe7e8$var$EC(options) {
    if (!(this instanceof $1bfd15ca1d0fe7e8$var$EC)) return new $1bfd15ca1d0fe7e8$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $1bfd15ca1d0fe7e8$var$assert$5(Object.prototype.hasOwnProperty.call($1bfd15ca1d0fe7e8$var$curves_1, options), "Unknown curve " + options);
        options = $1bfd15ca1d0fe7e8$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $1bfd15ca1d0fe7e8$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $1bfd15ca1d0fe7e8$var$ec = $1bfd15ca1d0fe7e8$var$EC;
$1bfd15ca1d0fe7e8$var$EC.prototype.keyPair = function keyPair(options) {
    return new $1bfd15ca1d0fe7e8$var$key(this, options);
};
$1bfd15ca1d0fe7e8$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $1bfd15ca1d0fe7e8$var$key.fromPrivate(this, priv, enc);
};
$1bfd15ca1d0fe7e8$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $1bfd15ca1d0fe7e8$var$key.fromPublic(this, pub, enc);
};
$1bfd15ca1d0fe7e8$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $1bfd15ca1d0fe7e8$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $1bfd15ca1d0fe7e8$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$1bfd15ca1d0fe7e8$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$1bfd15ca1d0fe7e8$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $1bfd15ca1d0fe7e8$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $1bfd15ca1d0fe7e8$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$1bfd15ca1d0fe7e8$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $1bfd15ca1d0fe7e8$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$1bfd15ca1d0fe7e8$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $1bfd15ca1d0fe7e8$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $1bfd15ca1d0fe7e8$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$1bfd15ca1d0fe7e8$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $1bfd15ca1d0fe7e8$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $1bfd15ca1d0fe7e8$var$elliptic_1 = $1bfd15ca1d0fe7e8$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $1bfd15ca1d0fe7e8$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $1bfd15ca1d0fe7e8$var$curve_1;
    elliptic.curves = $1bfd15ca1d0fe7e8$var$curves_1;
    // Protocols
    elliptic.ec = $1bfd15ca1d0fe7e8$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $1bfd15ca1d0fe7e8$export$129fe12d32abc311 = $1bfd15ca1d0fe7e8$var$elliptic_1.ec;




var $e72ut = parcelRequire("e72ut");

const $0e40a975db685e06$export$83d89fbfd8236492 = "signing-key/5.6.2";


"use strict";
const $e420960bc05af908$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $0e40a975db685e06$export$83d89fbfd8236492));
let $e420960bc05af908$var$_curve = null;
function $e420960bc05af908$var$getCurve() {
    if (!$e420960bc05af908$var$_curve) $e420960bc05af908$var$_curve = new (0, $1bfd15ca1d0fe7e8$export$129fe12d32abc311)("secp256k1");
    return $e420960bc05af908$var$_curve;
}
class $e420960bc05af908$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $e72ut.defineReadOnly)(this, "curve", "secp256k1");
        (0, $e72ut.defineReadOnly)(this, "privateKey", (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $9159a6fb125b2d57$export$13882f896d3c0683)(this.privateKey) !== 32) $e420960bc05af908$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $e420960bc05af908$var$getCurve().keyFromPrivate((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.privateKey));
        (0, $e72ut.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $e72ut.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $e72ut.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $e420960bc05af908$var$getCurve().keyFromPublic((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $e420960bc05af908$var$getCurve().keyFromPublic((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $e420960bc05af908$var$getCurve().keyFromPrivate((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $e420960bc05af908$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $9159a6fb125b2d57$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $e420960bc05af908$var$getCurve().keyFromPrivate((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $e420960bc05af908$var$getCurve().keyFromPublic((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)($e420960bc05af908$export$4a89473d39301224(otherKey)));
        return (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $e420960bc05af908$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $9159a6fb125b2d57$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(sig.r),
        s: (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $e420960bc05af908$var$getCurve().recoverPubKey((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $e420960bc05af908$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $e420960bc05af908$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $e420960bc05af908$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $e420960bc05af908$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $e420960bc05af908$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $e420960bc05af908$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}






var $1IGmO = parcelRequire("1IGmO");

"use strict";
function $eca9204cbd9e84ee$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data));
}




const $89ca73a338df6eb5$export$83d89fbfd8236492 = "rlp/5.6.1";


"use strict";
const $eb96e4cfdb6db6b1$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $89ca73a338df6eb5$export$83d89fbfd8236492));
function $eb96e4cfdb6db6b1$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $eb96e4cfdb6db6b1$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $eb96e4cfdb6db6b1$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($eb96e4cfdb6db6b1$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $eb96e4cfdb6db6b1$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $9159a6fb125b2d57$export$9a14abb1a440cd5e)(object)) $eb96e4cfdb6db6b1$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $eb96e4cfdb6db6b1$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $eb96e4cfdb6db6b1$export$c564cdbbe6da493(object) {
    return (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)($eb96e4cfdb6db6b1$var$_encode(object));
}
function $eb96e4cfdb6db6b1$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $eb96e4cfdb6db6b1$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $eb96e4cfdb6db6b1$var$logger.throwError("child data too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $eb96e4cfdb6db6b1$var$_decode(data, offset) {
    if (data.length === 0) $eb96e4cfdb6db6b1$var$logger.throwError("data too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data short segment too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $eb96e4cfdb6db6b1$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data long segment too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $eb96e4cfdb6db6b1$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data array too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $eb96e4cfdb6db6b1$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data array too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $eb96e4cfdb6db6b1$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data array too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $eb96e4cfdb6db6b1$var$logger.throwError("data too short", (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $eb96e4cfdb6db6b1$export$2f872c0f2117be69(data) {
    const bytes = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(data);
    const decoded = $eb96e4cfdb6db6b1$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $eb96e4cfdb6db6b1$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $218480599eb2c7b8$export$83d89fbfd8236492 = "address/5.6.1";


"use strict";
const $904bb296b6785dcc$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $218480599eb2c7b8$export$83d89fbfd8236492));
function $904bb296b6785dcc$var$getChecksumAddress(address) {
    if (!(0, $9159a6fb125b2d57$export$b02a40aff8e4ad18)(address, 20)) $904bb296b6785dcc$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $904bb296b6785dcc$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $904bb296b6785dcc$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $904bb296b6785dcc$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$904bb296b6785dcc$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$904bb296b6785dcc$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $904bb296b6785dcc$var$safeDigits = Math.floor($904bb296b6785dcc$var$log10($904bb296b6785dcc$var$MAX_SAFE_INTEGER));
function $904bb296b6785dcc$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $904bb296b6785dcc$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $904bb296b6785dcc$var$safeDigits){
        let block = expanded.substring(0, $904bb296b6785dcc$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $904bb296b6785dcc$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $904bb296b6785dcc$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $904bb296b6785dcc$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $904bb296b6785dcc$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $904bb296b6785dcc$var$ibanChecksum(address)) $904bb296b6785dcc$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $99d09c413e88d51e$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $904bb296b6785dcc$var$getChecksumAddress("0x" + result);
    } else $904bb296b6785dcc$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $904bb296b6785dcc$export$977e255126d763d6(address) {
    try {
        $904bb296b6785dcc$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $904bb296b6785dcc$export$962c4ddada9f668f(address) {
    let base36 = (0, $99d09c413e88d51e$export$1293db5d29c264ff)($904bb296b6785dcc$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $904bb296b6785dcc$var$ibanChecksum("XE00" + base36) + base36;
}
function $904bb296b6785dcc$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $904bb296b6785dcc$export$88411125f012957a(transaction.from);
    } catch (error) {
        $904bb296b6785dcc$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $9159a6fb125b2d57$export$a8f4574d0e56446c)((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $99d09c413e88d51e$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $904bb296b6785dcc$export$88411125f012957a((0, $9159a6fb125b2d57$export$15da666eba198c18)((0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)((0, $eb96e4cfdb6db6b1$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $904bb296b6785dcc$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $9159a6fb125b2d57$export$13882f896d3c0683)(salt) !== 32) $904bb296b6785dcc$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $9159a6fb125b2d57$export$13882f896d3c0683)(initCodeHash) !== 32) $904bb296b6785dcc$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $904bb296b6785dcc$export$88411125f012957a((0, $9159a6fb125b2d57$export$15da666eba198c18)((0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)((0, $9159a6fb125b2d57$export$ee1b3e54f0441b22)([
        "0xff",
        $904bb296b6785dcc$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}





const $7a1526ef57620a0c$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from(-1);
const $7a1526ef57620a0c$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from(0);
const $7a1526ef57620a0c$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from(1);
const $7a1526ef57620a0c$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from(2);
const $7a1526ef57620a0c$export$c8db55bd7405209e = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from("1000000000000000000");
const $7a1526ef57620a0c$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $7a1526ef57620a0c$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $7a1526ef57620a0c$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $99d09c413e88d51e$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");




var $e72ut = parcelRequire("e72ut");



const $96b23b1fa1a277af$export$83d89fbfd8236492 = "transactions/5.6.2";


"use strict";
const $b2fc6a1f29091507$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $96b23b1fa1a277af$export$83d89fbfd8236492));
var $b2fc6a1f29091507$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($b2fc6a1f29091507$export$80349e05e0724e11 || ($b2fc6a1f29091507$export$80349e05e0724e11 = {}));
///////////////////////////////
function $b2fc6a1f29091507$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $904bb296b6785dcc$export$88411125f012957a)(value);
}
function $b2fc6a1f29091507$var$handleNumber(value) {
    if (value === "0x") return 0, $7a1526ef57620a0c$export$aaef8a3eae948f03;
    return (0, $99d09c413e88d51e$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $b2fc6a1f29091507$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $b2fc6a1f29091507$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $b2fc6a1f29091507$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $e420960bc05af908$export$4a89473d39301224)(key);
    return (0, $904bb296b6785dcc$export$88411125f012957a)((0, $9159a6fb125b2d57$export$15da666eba198c18)((0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)((0, $9159a6fb125b2d57$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $b2fc6a1f29091507$export$23cc18f96d8510e2(digest, signature) {
    return $b2fc6a1f29091507$export$e67e2732ba9803f9((0, $e420960bc05af908$export$952dd09fbe0232b7)((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(digest), signature));
}
function $b2fc6a1f29091507$var$formatNumber(value, name) {
    const result = (0, $9159a6fb125b2d57$export$a8f4574d0e56446c)((0, $99d09c413e88d51e$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $b2fc6a1f29091507$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $904bb296b6785dcc$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $9159a6fb125b2d57$export$13882f896d3c0683)(storageKey) !== 32) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $b2fc6a1f29091507$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $b2fc6a1f29091507$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $b2fc6a1f29091507$var$accessSetify(set[0], set[1]);
        }
        return $b2fc6a1f29091507$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $b2fc6a1f29091507$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $b2fc6a1f29091507$var$formatAccessList(value) {
    return $b2fc6a1f29091507$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $b2fc6a1f29091507$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $99d09c413e88d51e$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $99d09c413e88d51e$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $b2fc6a1f29091507$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $b2fc6a1f29091507$var$formatNumber(transaction.chainId || 0, "chainId"),
        $b2fc6a1f29091507$var$formatNumber(transaction.nonce || 0, "nonce"),
        $b2fc6a1f29091507$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $b2fc6a1f29091507$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $b2fc6a1f29091507$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $904bb296b6785dcc$export$88411125f012957a)(transaction.to) : "0x",
        $b2fc6a1f29091507$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $b2fc6a1f29091507$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $9159a6fb125b2d57$export$7fb170f1e457988f)(signature);
        fields.push($b2fc6a1f29091507$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $9159a6fb125b2d57$export$6d4b99629b38754a)([
        "0x02",
        $eb96e4cfdb6db6b1$export$c564cdbbe6da493(fields)
    ]);
}
function $b2fc6a1f29091507$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $b2fc6a1f29091507$var$formatNumber(transaction.chainId || 0, "chainId"),
        $b2fc6a1f29091507$var$formatNumber(transaction.nonce || 0, "nonce"),
        $b2fc6a1f29091507$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $b2fc6a1f29091507$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $904bb296b6785dcc$export$88411125f012957a)(transaction.to) : "0x",
        $b2fc6a1f29091507$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $b2fc6a1f29091507$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $9159a6fb125b2d57$export$7fb170f1e457988f)(signature);
        fields.push($b2fc6a1f29091507$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $9159a6fb125b2d57$export$6d4b99629b38754a)([
        "0x01",
        $eb96e4cfdb6db6b1$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $b2fc6a1f29091507$var$_serialize(transaction, signature) {
    (0, $e72ut.checkProperties)(transaction, $b2fc6a1f29091507$var$allowedTransactionKeys);
    const raw = [];
    $b2fc6a1f29091507$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $9159a6fb125b2d57$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $b2fc6a1f29091507$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $9159a6fb125b2d57$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $eb96e4cfdb6db6b1$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $9159a6fb125b2d57$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $b2fc6a1f29091507$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $b2fc6a1f29091507$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $9159a6fb125b2d57$export$a8f4574d0e56446c)((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(sig.s)));
    return $eb96e4cfdb6db6b1$export$c564cdbbe6da493(raw);
}
function $b2fc6a1f29091507$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $b2fc6a1f29091507$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $b2fc6a1f29091507$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $b2fc6a1f29091507$var$_serializeEip2930(transaction, signature);
        case 2:
            return $b2fc6a1f29091507$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $b2fc6a1f29091507$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $b2fc6a1f29091507$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $b2fc6a1f29091507$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $b2fc6a1f29091507$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $b2fc6a1f29091507$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $b2fc6a1f29091507$var$_parseEip1559(payload) {
    const transaction = $eb96e4cfdb6db6b1$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $b2fc6a1f29091507$var$handleNumber(transaction[2]);
    const maxFeePerGas = $b2fc6a1f29091507$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $b2fc6a1f29091507$var$handleNumber(transaction[0]).toNumber(),
        nonce: $b2fc6a1f29091507$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $b2fc6a1f29091507$var$handleNumber(transaction[4]),
        to: $b2fc6a1f29091507$var$handleAddress(transaction[5]),
        value: $b2fc6a1f29091507$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $b2fc6a1f29091507$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)(payload);
    $b2fc6a1f29091507$var$_parseEipSignature(tx, transaction.slice(9), $b2fc6a1f29091507$var$_serializeEip1559);
    return tx;
}
function $b2fc6a1f29091507$var$_parseEip2930(payload) {
    const transaction = $eb96e4cfdb6db6b1$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $b2fc6a1f29091507$var$handleNumber(transaction[0]).toNumber(),
        nonce: $b2fc6a1f29091507$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $b2fc6a1f29091507$var$handleNumber(transaction[2]),
        gasLimit: $b2fc6a1f29091507$var$handleNumber(transaction[3]),
        to: $b2fc6a1f29091507$var$handleAddress(transaction[4]),
        value: $b2fc6a1f29091507$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $b2fc6a1f29091507$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)(payload);
    $b2fc6a1f29091507$var$_parseEipSignature(tx, transaction.slice(8), $b2fc6a1f29091507$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $b2fc6a1f29091507$var$_parse(rawTransaction) {
    const transaction = $eb96e4cfdb6db6b1$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $b2fc6a1f29091507$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $b2fc6a1f29091507$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $b2fc6a1f29091507$var$handleNumber(transaction[1]),
        gasLimit: $b2fc6a1f29091507$var$handleNumber(transaction[2]),
        to: $b2fc6a1f29091507$var$handleAddress(transaction[3]),
        value: $b2fc6a1f29091507$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $99d09c413e88d51e$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $99d09c413e88d51e$export$d97aa349ed20696).from(tx.r).isZero() && (0, $99d09c413e88d51e$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)($eb96e4cfdb6db6b1$export$c564cdbbe6da493(raw));
        try {
            tx.from = $b2fc6a1f29091507$export$23cc18f96d8510e2(digest, {
                r: (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $eca9204cbd9e84ee$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $b2fc6a1f29091507$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $b2fc6a1f29091507$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $b2fc6a1f29091507$var$_parseEip2930(payload);
        case 2:
            return $b2fc6a1f29091507$var$_parseEip1559(payload);
        default:
            break;
    }
    return $b2fc6a1f29091507$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $c1e9b530ab62bf0f$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



var $1IGmO = parcelRequire("1IGmO");
const $649b8729019709a0$export$83d89fbfd8236492 = "logger/5.6.0";


"use strict";
let $71ded4224c2ff035$var$_permanentCensorErrors = false;
let $71ded4224c2ff035$var$_censorErrors = false;
const $71ded4224c2ff035$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $71ded4224c2ff035$var$_logLevel = $71ded4224c2ff035$var$LogLevels["default"];
let $71ded4224c2ff035$var$_globalLogger = null;
function $71ded4224c2ff035$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $71ded4224c2ff035$var$_normalizeError = $71ded4224c2ff035$var$_checkNormalize();
var $71ded4224c2ff035$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($71ded4224c2ff035$export$243e62d78d3b544d || ($71ded4224c2ff035$export$243e62d78d3b544d = {}));
var $71ded4224c2ff035$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($71ded4224c2ff035$export$d4e71bc0b80dc0fb || ($71ded4224c2ff035$export$d4e71bc0b80dc0fb = {}));
const $71ded4224c2ff035$var$HEX = "0123456789abcdef";
class $71ded4224c2ff035$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($71ded4224c2ff035$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($71ded4224c2ff035$var$_logLevel > $71ded4224c2ff035$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($71ded4224c2ff035$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($71ded4224c2ff035$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($71ded4224c2ff035$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($71ded4224c2ff035$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $71ded4224c2ff035$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $71ded4224c2ff035$var$HEX[value[i] >> 4];
                        hex += $71ded4224c2ff035$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $71ded4224c2ff035$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $71ded4224c2ff035$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($71ded4224c2ff035$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $71ded4224c2ff035$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $71ded4224c2ff035$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $71ded4224c2ff035$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $71ded4224c2ff035$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $71ded4224c2ff035$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $71ded4224c2ff035$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $71ded4224c2ff035$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $71ded4224c2ff035$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $71ded4224c2ff035$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$71ded4224c2ff035$var$_globalLogger) $71ded4224c2ff035$var$_globalLogger = new $71ded4224c2ff035$export$efa9a398d6368992((0, $649b8729019709a0$export$83d89fbfd8236492));
        return $71ded4224c2ff035$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $71ded4224c2ff035$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($71ded4224c2ff035$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $71ded4224c2ff035$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $71ded4224c2ff035$var$_censorErrors = !!censorship;
        $71ded4224c2ff035$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $71ded4224c2ff035$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $71ded4224c2ff035$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $71ded4224c2ff035$var$_logLevel = level;
    }
    static from(version) {
        return new $71ded4224c2ff035$export$efa9a398d6368992(version);
    }
}
$71ded4224c2ff035$export$efa9a398d6368992.errors = $71ded4224c2ff035$export$d4e71bc0b80dc0fb;
$71ded4224c2ff035$export$efa9a398d6368992.levels = $71ded4224c2ff035$export$243e62d78d3b544d;


const $36916b3727baeac1$export$83d89fbfd8236492 = "bytes/5.6.1";


"use strict";
const $2de8d985fca1f7f2$var$logger = new (0, $71ded4224c2ff035$export$efa9a398d6368992)((0, $36916b3727baeac1$export$83d89fbfd8236492));
///////////////////////////////
function $2de8d985fca1f7f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $2de8d985fca1f7f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $2de8d985fca1f7f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $2de8d985fca1f7f2$export$9a14abb1a440cd5e(value) {
    return $2de8d985fca1f7f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $2de8d985fca1f7f2$export$c6fabfbfd097fc30(value);
}
function $2de8d985fca1f7f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $2de8d985fca1f7f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$2de8d985fca1f7f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$2de8d985fca1f7f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $2de8d985fca1f7f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $2de8d985fca1f7f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $2de8d985fca1f7f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($2de8d985fca1f7f2$var$isHexable(value)) value = value.toHexString();
    if ($2de8d985fca1f7f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $2de8d985fca1f7f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $2de8d985fca1f7f2$var$addSlice(new Uint8Array(result));
    }
    if ($2de8d985fca1f7f2$export$c6fabfbfd097fc30(value)) return $2de8d985fca1f7f2$var$addSlice(new Uint8Array(value));
    return $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $2de8d985fca1f7f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$2de8d985fca1f7f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $2de8d985fca1f7f2$var$addSlice(result);
}
function $2de8d985fca1f7f2$export$a8f4574d0e56446c(value) {
    let result = $2de8d985fca1f7f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $2de8d985fca1f7f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $2de8d985fca1f7f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $2de8d985fca1f7f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $2de8d985fca1f7f2$var$addSlice(result);
}
function $2de8d985fca1f7f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $2de8d985fca1f7f2$var$HexCharacters = "0123456789abcdef";
function $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $2de8d985fca1f7f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $2de8d985fca1f7f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($2de8d985fca1f7f2$var$isHexable(value)) return value.toHexString();
    if ($2de8d985fca1f7f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $2de8d985fca1f7f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($2de8d985fca1f7f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $2de8d985fca1f7f2$var$HexCharacters[(v & 0xf0) >> 4] + $2de8d985fca1f7f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $2de8d985fca1f7f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(data);
    else if (!$2de8d985fca1f7f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $2de8d985fca1f7f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(data);
    else if (!$2de8d985fca1f7f2$export$b02a40aff8e4ad18(data) || data.length % 2) $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $2de8d985fca1f7f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $2de8d985fca1f7f2$export$6916af760a341dd3(value) {
    const trimmed = $2de8d985fca1f7f2$export$967bc0082a978949($2de8d985fca1f7f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $2de8d985fca1f7f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(value);
    if (!$2de8d985fca1f7f2$export$b02a40aff8e4ad18(value)) $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $2de8d985fca1f7f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(value);
    else if (!$2de8d985fca1f7f2$export$b02a40aff8e4ad18(value)) $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $2de8d985fca1f7f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $2de8d985fca1f7f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($2de8d985fca1f7f2$export$9a14abb1a440cd5e(signature)) {
        let bytes = $2de8d985fca1f7f2$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $2de8d985fca1f7f2$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $2de8d985fca1f7f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $2de8d985fca1f7f2$export$3cdc770bf8b2ed3d($2de8d985fca1f7f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$2de8d985fca1f7f2$export$b02a40aff8e4ad18(result.r)) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $2de8d985fca1f7f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$2de8d985fca1f7f2$export$b02a40aff8e4ad18(result.s)) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $2de8d985fca1f7f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $2de8d985fca1f7f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $2de8d985fca1f7f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$2de8d985fca1f7f2$export$b02a40aff8e4ad18(result._vs)) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $2de8d985fca1f7f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $2de8d985fca1f7f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $2de8d985fca1f7f2$export$71bb9d78a59bbe25(signature) {
    signature = $2de8d985fca1f7f2$export$7fb170f1e457988f(signature);
    return $2de8d985fca1f7f2$export$2b0d6b5fbe698c70($2de8d985fca1f7f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}


"use strict";
function $b45f4d257ce14d41$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $2de8d985fca1f7f2$export$3131421a7d01b4fb)(data));
}




const $2d6ddb2f812f57f6$export$83d89fbfd8236492 = "strings/5.6.1";


"use strict";
const $bf1f9bc94a5d0b7f$var$logger = new (0, $71ded4224c2ff035$export$efa9a398d6368992)((0, $2d6ddb2f812f57f6$export$83d89fbfd8236492));
var $bf1f9bc94a5d0b7f$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($bf1f9bc94a5d0b7f$export$c6986442964129f5 || ($bf1f9bc94a5d0b7f$export$c6986442964129f5 = {}));
var $bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6 || ($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6 = {}));
function $bf1f9bc94a5d0b7f$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $bf1f9bc94a5d0b7f$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $bf1f9bc94a5d0b7f$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $bf1f9bc94a5d0b7f$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $bf1f9bc94a5d0b7f$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $bf1f9bc94a5d0b7f$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $bf1f9bc94a5d0b7f$var$errorFunc,
    ignore: $bf1f9bc94a5d0b7f$var$ignoreFunc,
    replace: $bf1f9bc94a5d0b7f$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $bf1f9bc94a5d0b7f$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $bf1f9bc94a5d0b7f$export$c6e2180c5bb5bc05.error;
    bytes = (0, $2de8d985fca1f7f2$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($bf1f9bc94a5d0b7f$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $bf1f9bc94a5d0b7f$export$8feeb310b4b4752f(str, form = $bf1f9bc94a5d0b7f$export$c6986442964129f5.current) {
    if (form != $bf1f9bc94a5d0b7f$export$c6986442964129f5.current) {
        $bf1f9bc94a5d0b7f$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $2de8d985fca1f7f2$export$3131421a7d01b4fb)(result);
}
function $bf1f9bc94a5d0b7f$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $bf1f9bc94a5d0b7f$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $bf1f9bc94a5d0b7f$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $bf1f9bc94a5d0b7f$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $bf1f9bc94a5d0b7f$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $bf1f9bc94a5d0b7f$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $bf1f9bc94a5d0b7f$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $bf1f9bc94a5d0b7f$export$7643a1dc2c38d5eb(bytes, onError) {
    return $bf1f9bc94a5d0b7f$export$232e1dab03132235($bf1f9bc94a5d0b7f$var$getUtf8CodePoints(bytes, onError));
}
function $bf1f9bc94a5d0b7f$export$ae470a36a31b28c2(str, form = $bf1f9bc94a5d0b7f$export$c6986442964129f5.current) {
    return $bf1f9bc94a5d0b7f$var$getUtf8CodePoints($bf1f9bc94a5d0b7f$export$8feeb310b4b4752f(str, form));
}


function $a7d57e893638f654$export$d560c7e4a29451c2(text) {
    return (0, $b45f4d257ce14d41$export$f8151fce47ad1c35)((0, $bf1f9bc94a5d0b7f$export$8feeb310b4b4752f)(text));
}



var $e72ut = parcelRequire("e72ut");

const $7b1f5e4d32c2ee77$export$83d89fbfd8236492 = "wordlists/5.6.1";


"use strict";
// This gets overridden by rollup
const $1aa3df27db978ea8$var$exportWordlist = false;
const $1aa3df27db978ea8$export$af88d00dbe7f521 = new (0, $71ded4224c2ff035$export$efa9a398d6368992)((0, $7b1f5e4d32c2ee77$export$83d89fbfd8236492));
class $1aa3df27db978ea8$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1aa3df27db978ea8$export$af88d00dbe7f521.checkAbstract(new.target, $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
        (0, $e72ut.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $a7d57e893638f654$export$d560c7e4a29451c2)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1aa3df27db978ea8$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $e72ut.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}


"use strict";
const $e1c37ee3c90035e1$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $e1c37ee3c90035e1$var$wordlist = null;
function $e1c37ee3c90035e1$var$loadWords(lang) {
    if ($e1c37ee3c90035e1$var$wordlist != null) return;
    $e1c37ee3c90035e1$var$wordlist = $e1c37ee3c90035e1$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $e1c37ee3c90035e1$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $e1c37ee3c90035e1$var$LangEn extends (0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist[index];
    }
    getWordIndex(word) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist.indexOf(word);
    }
}
const $e1c37ee3c90035e1$export$a2c9518710cf1f49 = new $e1c37ee3c90035e1$var$LangEn();
(0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).register($e1c37ee3c90035e1$export$a2c9518710cf1f49);


"use strict";
const $c98b8711de347986$export$e8e1b4711c2d1939 = {
    en: (0, $e1c37ee3c90035e1$export$a2c9518710cf1f49)
};



const $6054160a15387c6c$export$83d89fbfd8236492 = "hdnode/5.6.2";


"use strict";
const $d830e21df8d45279$var$logger = new (0, $c1e9b530ab62bf0f$export$efa9a398d6368992)((0, $6054160a15387c6c$export$83d89fbfd8236492));
const $d830e21df8d45279$var$N = (0, $99d09c413e88d51e$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $d830e21df8d45279$var$MasterSecret = (0, $e8ba7ad5d41040e4$export$8feeb310b4b4752f)("Bitcoin seed");
const $d830e21df8d45279$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $d830e21df8d45279$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $d830e21df8d45279$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $d830e21df8d45279$var$bytes32(value) {
    return (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(value), 32);
}
function $d830e21df8d45279$var$base58check(data) {
    return (0, $76a0e587fe4e380f$export$45a587635c9954b2).encode((0, $9159a6fb125b2d57$export$ee1b3e54f0441b22)([
        data,
        (0, $9159a6fb125b2d57$export$15da666eba198c18)((0, $6f432d194bb11e12$export$bced8d2aada2d1c9)((0, $6f432d194bb11e12$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $d830e21df8d45279$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $c98b8711de347986$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $c98b8711de347986$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $d830e21df8d45279$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $d830e21df8d45279$var$_constructorGuard = {};
const $d830e21df8d45279$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $d830e21df8d45279$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $d830e21df8d45279$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $e420960bc05af908$export$21643ca94aed3e83)(privateKey);
            (0, $e72ut.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $e72ut.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $e72ut.defineReadOnly)(this, "privateKey", null);
            (0, $e72ut.defineReadOnly)(this, "publicKey", (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $e72ut.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $e72ut.defineReadOnly)(this, "fingerprint", (0, $9159a6fb125b2d57$export$15da666eba198c18)((0, $6f432d194bb11e12$export$d1cea0ee4e3f0d3e)((0, $6f432d194bb11e12$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $e72ut.defineReadOnly)(this, "address", (0, $b2fc6a1f29091507$export$e67e2732ba9803f9)(this.publicKey));
        (0, $e72ut.defineReadOnly)(this, "chainCode", chainCode);
        (0, $e72ut.defineReadOnly)(this, "index", index);
        (0, $e72ut.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $e72ut.defineReadOnly)(this, "mnemonic", null);
            (0, $e72ut.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $e72ut.defineReadOnly)(this, "mnemonic", null);
            (0, $e72ut.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $e72ut.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $e72ut.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $d830e21df8d45279$var$base58check((0, $9159a6fb125b2d57$export$ee1b3e54f0441b22)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(this.depth),
            this.parentFingerprint,
            (0, $9159a6fb125b2d57$export$e9c46a54370b47e8)((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $9159a6fb125b2d57$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$d830e21df8d45279$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $d830e21df8d45279$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$967075d2f3b8e7ff)((0, $57fe67f9e914138c$export$d2a8849cfb277c).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $d830e21df8d45279$var$bytes32((0, $99d09c413e88d51e$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($d830e21df8d45279$var$N));
        else {
            const ek = new (0, $e420960bc05af908$export$21643ca94aed3e83)((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, ki, Ki, this.fingerprint, $d830e21df8d45279$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($d830e21df8d45279$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$967075d2f3b8e7ff)((0, $57fe67f9e914138c$export$d2a8849cfb277c).sha512, $d830e21df8d45279$var$MasterSecret, seedArray));
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, $d830e21df8d45279$var$bytes32(I.slice(0, 32)), null, "0x00000000", $d830e21df8d45279$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $d830e21df8d45279$export$4becd65eb23312e6($d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed($d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $76a0e587fe4e380f$export$45a587635c9954b2).decode(extendedKey);
        if (bytes.length !== 82 || $d830e21df8d45279$var$base58check(bytes.slice(0, 78)) !== extendedKey) $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $e8ba7ad5d41040e4$export$8feeb310b4b4752f)("mnemonic" + password, (0, $e8ba7ad5d41040e4$export$c6986442964129f5).NFKD);
    return (0, $a7037ce6284c8725$export$448fa22aedc9dbca)((0, $e8ba7ad5d41040e4$export$8feeb310b4b4752f)(mnemonic, (0, $e8ba7ad5d41040e4$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    $d830e21df8d45279$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $d830e21df8d45279$var$getUpperMask(checksumBits);
    const checksum = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $9159a6fb125b2d57$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $d830e21df8d45279$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    entropy = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $d830e21df8d45279$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $9159a6fb125b2d57$export$3131421a7d01b4fb)((0, $6f432d194bb11e12$export$bced8d2aada2d1c9)(entropy))[0] & $d830e21df8d45279$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $d830e21df8d45279$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $d830e21df8d45279$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $d830e21df8d45279$var$HardenedBit || index % 1) $d830e21df8d45279$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}




var $e72ut = parcelRequire("e72ut");

var $9uSEH = parcelRequire("9uSEH");

var $f8A5C = parcelRequire("f8A5C");
const $c2f212119fbdb13a$export$83d89fbfd8236492 = "random/5.6.1";


"use strict";
const $c27b830bf614d184$var$logger = new (0, $f8A5C.Logger)((0, $c2f212119fbdb13a$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $c27b830bf614d184$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $c27b830bf614d184$var$anyGlobal = $c27b830bf614d184$var$getGlobal();
let $c27b830bf614d184$var$crypto = $c27b830bf614d184$var$anyGlobal.crypto || $c27b830bf614d184$var$anyGlobal.msCrypto;
if (!$c27b830bf614d184$var$crypto || !$c27b830bf614d184$var$crypto.getRandomValues) {
    $c27b830bf614d184$var$logger.warn("WARNING: Missing strong random number source");
    $c27b830bf614d184$var$crypto = {
        getRandomValues: function(buffer) {
            return $c27b830bf614d184$var$logger.throwError("no secure random source avaialble", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $c27b830bf614d184$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $c27b830bf614d184$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $c27b830bf614d184$var$crypto.getRandomValues(result);
    return (0, $9uSEH.arrayify)(result);
}



var $df9de36cc74f2de2$exports = {};
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $df9de36cc74f2de2$exports = aesjs;
})($df9de36cc74f2de2$exports);




var $9uSEH = parcelRequire("9uSEH");


var $9uSEH = parcelRequire("9uSEH");

var $kiSKt = parcelRequire("kiSKt");

var $9uSEH = parcelRequire("9uSEH");
var $6ca31e017acdfc0f$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($6ca31e017acdfc0f$export$d2a8849cfb277c || ($6ca31e017acdfc0f$export$d2a8849cfb277c = {}));



var $f8A5C = parcelRequire("f8A5C");
const $aade052bea3972cf$export$83d89fbfd8236492 = "sha2/5.6.1";


"use strict";
const $d435f7c5f3d5d722$var$logger = new (0, $f8A5C.Logger)((0, $aade052bea3972cf$export$83d89fbfd8236492));
function $d435f7c5f3d5d722$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $9uSEH.arrayify)(data)).digest("hex");
}
function $d435f7c5f3d5d722$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $9uSEH.arrayify)(data)).digest("hex");
}
function $d435f7c5f3d5d722$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $9uSEH.arrayify)(data)).digest("hex");
}
function $d435f7c5f3d5d722$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $6ca31e017acdfc0f$export$d2a8849cfb277c)[algorithm]) $d435f7c5f3d5d722$var$logger.throwError("unsupported algorithm " + algorithm, (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $9uSEH.arrayify)(key)).update((0, $9uSEH.arrayify)(data)).digest("hex");
}


"use strict";
function $bd1e6f296bb6f66e$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $9uSEH.arrayify)(password);
    salt = (0, $9uSEH.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $9uSEH.arrayify)((0, $d435f7c5f3d5d722$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $9uSEH.arrayify)((0, $d435f7c5f3d5d722$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $9uSEH.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $9uSEH.hexlify)(DK);
}




var $e72ut = parcelRequire("e72ut");

var $f8A5C = parcelRequire("f8A5C");
const $32d5aa4863d7f190$export$83d89fbfd8236492 = "json-wallets/5.6.1";



var $9uSEH = parcelRequire("9uSEH");

"use strict";
function $ed16e0b6bd9d06a7$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $9uSEH.arrayify)(hexString);
}
function $ed16e0b6bd9d06a7$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $ed16e0b6bd9d06a7$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(password, (0, $c64f307c4161c9d6$export$c6986442964129f5).NFKC);
    return (0, $9uSEH.arrayify)(password);
}
function $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $ed16e0b6bd9d06a7$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $9uSEH.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $9uSEH.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


"use strict";
const $f540d724ba570a34$var$logger = new (0, $f8A5C.Logger)((0, $32d5aa4863d7f190$export$83d89fbfd8236492));
class $f540d724ba570a34$export$93a76d16f88f2b3 extends (0, $e72ut.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $f540d724ba570a34$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $ed16e0b6bd9d06a7$export$350bd33120f7413e)(password);
    // Ethereum Address
    const ethaddr = (0, $3bbab26945c6bdb1$export$88411125f012957a)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $f540d724ba570a34$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $9uSEH.arrayify)((0, $bd1e6f296bb6f66e$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).padding.pkcs7.strip((0, $9uSEH.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(seedHex);
    const privateKey = (0, $5915e762efc52191$export$f8151fce47ad1c35)(seedHexBytes);
    return new $f540d724ba570a34$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $b468c02c6fac1503$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $b468c02c6fac1503$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $b468c02c6fac1503$export$9a68ee9f8f3afd38(json) {
    if ($b468c02c6fac1503$export$724d6cf6b9fd8578(json)) try {
        return (0, $3bbab26945c6bdb1$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($b468c02c6fac1503$export$67dc926b8e68b2d8(json)) try {
        return (0, $3bbab26945c6bdb1$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}


var $b87b0986a54bee46$exports = {};

$parcel$export($b87b0986a54bee46$exports, "decryptSync", () => $b87b0986a54bee46$export$9bd2c37889ee5e36);
$parcel$export($b87b0986a54bee46$exports, "decrypt", () => $b87b0986a54bee46$export$e85a0c9a1067c5d3);
$parcel$export($b87b0986a54bee46$exports, "encrypt", () => $b87b0986a54bee46$export$5b0f6292f11d1d18);

var $d60cab1af588cd1e$exports = {};
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof $d60cab1af588cd1e$exports !== "undefined") $d60cab1af588cd1e$exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})($d60cab1af588cd1e$exports);




var $9uSEH = parcelRequire("9uSEH");





var $e72ut = parcelRequire("e72ut");



var $f8A5C = parcelRequire("f8A5C");

"use strict";
var $b87b0986a54bee46$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b87b0986a54bee46$var$logger = new (0, $f8A5C.Logger)((0, $32d5aa4863d7f190$export$83d89fbfd8236492));
// Exported Types
function $b87b0986a54bee46$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $b87b0986a54bee46$export$cf9dc4fd6dde0315 extends (0, $e72ut.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $b87b0986a54bee46$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(key, counter);
        return (0, $9uSEH.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $b87b0986a54bee46$var$_getAccount(data, key) {
    const ciphertext = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    const computedMAC = (0, $9uSEH.hexlify)((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $b87b0986a54bee46$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $b87b0986a54bee46$var$logger.throwError("unsupported cipher", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $c220423970a40605$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $3bbab26945c6bdb1$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $9uSEH.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        const locale = (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        const entropy = (0, $9uSEH.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, locale);
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $f8A5C.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $b87b0986a54bee46$export$cf9dc4fd6dde0315(account);
}
function $b87b0986a54bee46$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $9uSEH.arrayify)((0, $bd1e6f296bb6f66e$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $b87b0986a54bee46$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($b87b0986a54bee46$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $b87b0986a54bee46$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $ed16e0b6bd9d06a7$export$350bd33120f7413e)(password);
    const kdf = (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $b87b0986a54bee46$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $ed16e0b6bd9d06a7$export$2cde08bde0cfd932)((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $ed16e0b6bd9d06a7$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $b87b0986a54bee46$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $b87b0986a54bee46$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $b87b0986a54bee46$var$_computeKdfKey(data, password, $b87b0986a54bee46$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).syncScrypt);
    return $b87b0986a54bee46$var$_getAccount(data, key);
}
function $b87b0986a54bee46$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $b87b0986a54bee46$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $b87b0986a54bee46$var$_computeKdfKey(data, password, $b87b0986a54bee46$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).scrypt, progressCallback);
        return $b87b0986a54bee46$var$_getAccount(data, key);
    });
}
function $b87b0986a54bee46$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $3bbab26945c6bdb1$export$88411125f012957a)(account.address) !== (0, $c220423970a40605$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($b87b0986a54bee46$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $9uSEH.arrayify)(account.privateKey);
    const passwordBytes = (0, $ed16e0b6bd9d06a7$export$350bd33120f7413e)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($b87b0986a54bee46$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $9uSEH.arrayify)((0, $d830e21df8d45279$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $9uSEH.arrayify)(options.salt);
    else salt = (0, $c27b830bf614d184$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $9uSEH.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $c27b830bf614d184$export$5f828d93ff035aa8)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $9uSEH.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $c27b830bf614d184$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $9uSEH.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $9uSEH.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $ed16e0b6bd9d06a7$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            Crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $9uSEH.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $9uSEH.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $9uSEH.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $c27b830bf614d184$export$5f828d93ff035aa8)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $9uSEH.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $ed16e0b6bd9d06a7$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $ed16e0b6bd9d06a7$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $ed16e0b6bd9d06a7$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $ed16e0b6bd9d06a7$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $ed16e0b6bd9d06a7$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $9uSEH.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $9uSEH.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


"use strict";
function $6ffbd0ae412cdac0$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $b468c02c6fac1503$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $f540d724ba570a34$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $b468c02c6fac1503$export$67dc926b8e68b2d8)(json)) return (0, $b87b0986a54bee46$exports.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $6ffbd0ae412cdac0$export$7a81c437a678891a(json, password) {
    if ((0, $b468c02c6fac1503$export$724d6cf6b9fd8578)(json)) return (0, $f540d724ba570a34$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $b468c02c6fac1503$export$67dc926b8e68b2d8)(json)) return (0, $b87b0986a54bee46$exports.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}




var $f8A5C = parcelRequire("f8A5C");
const $a88ee2a4f4f35842$export$83d89fbfd8236492 = "wallet/5.6.2";


"use strict";
var $8c76997802860d88$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8c76997802860d88$var$logger = new (0, $f8A5C.Logger)((0, $a88ee2a4f4f35842$export$83d89fbfd8236492));
function $8c76997802860d88$var$isAccount(value) {
    return value != null && (0, $9uSEH.isHexString)(value.privateKey, 32) && value.address != null;
}
function $8c76997802860d88$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $8c76997802860d88$export$bcca3ea514774656 extends (0, $j7x7T.Signer) {
    constructor(privateKey, provider){
        super();
        if ($8c76997802860d88$var$isAccount(privateKey)) {
            const signingKey = new (0, $c996070d7a4cc0da$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $e72ut.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $e72ut.defineReadOnly)(this, "address", (0, $c220423970a40605$export$e67e2732ba9803f9)(this.publicKey));
            if (this.address !== (0, $3bbab26945c6bdb1$export$88411125f012957a)(privateKey.address)) $8c76997802860d88$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($8c76997802860d88$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $e72ut.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $c220423970a40605$export$e67e2732ba9803f9)(node.privateKey) !== this.address) $8c76997802860d88$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $e72ut.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $c996070d7a4cc0da$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $8c76997802860d88$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $e72ut.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $c996070d7a4cc0da$export$21643ca94aed3e83)(privateKey);
                (0, $e72ut.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $e72ut.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $e72ut.defineReadOnly)(this, "address", (0, $c220423970a40605$export$e67e2732ba9803f9)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $20eaa00aa96c05e1$exports.Provider).isProvider(provider)) $8c76997802860d88$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $e72ut.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $8c76997802860d88$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $e72ut.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $3bbab26945c6bdb1$export$88411125f012957a)(tx.from) !== this.address) $8c76997802860d88$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $c220423970a40605$export$dfdc1655ccc5b9cb)(tx)));
            return (0, $c220423970a40605$export$dfdc1655ccc5b9cb)(tx, signature);
        });
    }
    signMessage(message) {
        return $8c76997802860d88$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $9uSEH.joinSignature)(this._signingKey().signDigest((0, $146df85c9b7f1867$export$d4c241cec96564c1)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $8c76997802860d88$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $8feb3fe5353bb1cc$exports.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $8c76997802860d88$var$logger.throwError("cannot resolve ENS names without a provider", (0, $f8A5C.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $9uSEH.joinSignature)(this._signingKey().signDigest((0, $8feb3fe5353bb1cc$exports.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $b87b0986a54bee46$exports.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $c27b830bf614d184$export$5f828d93ff035aa8)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $9uSEH.arrayify)((0, $9uSEH.hexDataSlice)((0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, options.locale);
        return $8c76997802860d88$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $6ffbd0ae412cdac0$export$e74fcde37488267a)(json, password, progressCallback).then((account)=>{
            return new $8c76997802860d88$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $8c76997802860d88$export$bcca3ea514774656((0, $6ffbd0ae412cdac0$export$7a81c437a678891a)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        return new $8c76997802860d88$export$bcca3ea514774656((0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $8c76997802860d88$export$228d0e772cc158cb(message, signature) {
    return (0, $c220423970a40605$export$23cc18f96d8510e2)((0, $146df85c9b7f1867$export$d4c241cec96564c1)(message), signature);
}
function $8c76997802860d88$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $c220423970a40605$export$23cc18f96d8510e2)((0, $8feb3fe5353bb1cc$exports.TypedDataEncoder).hash(domain, types, value), signature);
}




var $bsYBY = parcelRequire("bsYBY");

var $0e788201f8a90b1e$exports = {};

$parcel$export($0e788201f8a90b1e$exports, "AbiCoder", () => $45e842348d346001$export$fe041e1a83d3efc6);
$parcel$export($0e788201f8a90b1e$exports, "defaultAbiCoder", () => $45e842348d346001$export$51d1cfcdb913adff);
$parcel$export($0e788201f8a90b1e$exports, "Fragment", () => $be76a1f9a941f8f7$export$ffb0004e005737fa);
$parcel$export($0e788201f8a90b1e$exports, "ConstructorFragment", () => $be76a1f9a941f8f7$export$3ac5c9504f801ea4);
$parcel$export($0e788201f8a90b1e$exports, "ErrorFragment", () => $be76a1f9a941f8f7$export$2c42c6d543aa9b59);
$parcel$export($0e788201f8a90b1e$exports, "EventFragment", () => $be76a1f9a941f8f7$export$958548f08bac2833);
$parcel$export($0e788201f8a90b1e$exports, "FunctionFragment", () => $be76a1f9a941f8f7$export$8d576c928b93668f);
$parcel$export($0e788201f8a90b1e$exports, "ParamType", () => $be76a1f9a941f8f7$export$426dc07f493a4c47);
$parcel$export($0e788201f8a90b1e$exports, "FormatTypes", () => $be76a1f9a941f8f7$export$f010f239efc4d445);
$parcel$export($0e788201f8a90b1e$exports, "checkResultErrors", () => $2443aa857d9ae22f$export$5546b9ec21157cc2);
$parcel$export($0e788201f8a90b1e$exports, "Logger", () => (parcelRequire("f8A5C")).Logger);
$parcel$export($0e788201f8a90b1e$exports, "RLP", () => (parcelRequire("hiDPq")));
$parcel$export($0e788201f8a90b1e$exports, "_fetchData", () => $92a89a4bb9900a78$exports._fetchData);
$parcel$export($0e788201f8a90b1e$exports, "fetchJson", () => $92a89a4bb9900a78$exports.fetchJson);
$parcel$export($0e788201f8a90b1e$exports, "poll", () => $92a89a4bb9900a78$exports.poll);
$parcel$export($0e788201f8a90b1e$exports, "checkProperties", () => (parcelRequire("e72ut")).checkProperties);
$parcel$export($0e788201f8a90b1e$exports, "deepCopy", () => (parcelRequire("e72ut")).deepCopy);
$parcel$export($0e788201f8a90b1e$exports, "defineReadOnly", () => (parcelRequire("e72ut")).defineReadOnly);
$parcel$export($0e788201f8a90b1e$exports, "getStatic", () => (parcelRequire("e72ut")).getStatic);
$parcel$export($0e788201f8a90b1e$exports, "resolveProperties", () => (parcelRequire("e72ut")).resolveProperties);
$parcel$export($0e788201f8a90b1e$exports, "shallowCopy", () => (parcelRequire("e72ut")).shallowCopy);
$parcel$export($0e788201f8a90b1e$exports, "arrayify", () => (parcelRequire("9uSEH")).arrayify);
$parcel$export($0e788201f8a90b1e$exports, "concat", () => (parcelRequire("9uSEH")).concat);
$parcel$export($0e788201f8a90b1e$exports, "stripZeros", () => (parcelRequire("9uSEH")).stripZeros);
$parcel$export($0e788201f8a90b1e$exports, "zeroPad", () => (parcelRequire("9uSEH")).zeroPad);
$parcel$export($0e788201f8a90b1e$exports, "isBytes", () => (parcelRequire("9uSEH")).isBytes);
$parcel$export($0e788201f8a90b1e$exports, "isBytesLike", () => (parcelRequire("9uSEH")).isBytesLike);
$parcel$export($0e788201f8a90b1e$exports, "defaultPath", () => $d830e21df8d45279$export$d48ad89f7e11a603);
$parcel$export($0e788201f8a90b1e$exports, "HDNode", () => $d830e21df8d45279$export$b68640c53e22b952);
$parcel$export($0e788201f8a90b1e$exports, "SigningKey", () => $c996070d7a4cc0da$export$21643ca94aed3e83);
$parcel$export($0e788201f8a90b1e$exports, "Interface", () => $6c9fdbc6de4e49f0$export$48cefb51a4e315b2);
$parcel$export($0e788201f8a90b1e$exports, "LogDescription", () => $6c9fdbc6de4e49f0$export$c2ab6499be98b3c5);
$parcel$export($0e788201f8a90b1e$exports, "TransactionDescription", () => $6c9fdbc6de4e49f0$export$7a3223b0fadb690b);
$parcel$export($0e788201f8a90b1e$exports, "base58", () => $73b39074be9e3e41$export$45a587635c9954b2);
$parcel$export($0e788201f8a90b1e$exports, "base64", () => (parcelRequire("eGcmO")));
$parcel$export($0e788201f8a90b1e$exports, "hexlify", () => (parcelRequire("9uSEH")).hexlify);
$parcel$export($0e788201f8a90b1e$exports, "isHexString", () => (parcelRequire("9uSEH")).isHexString);
$parcel$export($0e788201f8a90b1e$exports, "hexConcat", () => (parcelRequire("9uSEH")).hexConcat);
$parcel$export($0e788201f8a90b1e$exports, "hexStripZeros", () => (parcelRequire("9uSEH")).hexStripZeros);
$parcel$export($0e788201f8a90b1e$exports, "hexValue", () => (parcelRequire("9uSEH")).hexValue);
$parcel$export($0e788201f8a90b1e$exports, "hexZeroPad", () => (parcelRequire("9uSEH")).hexZeroPad);
$parcel$export($0e788201f8a90b1e$exports, "hexDataLength", () => (parcelRequire("9uSEH")).hexDataLength);
$parcel$export($0e788201f8a90b1e$exports, "hexDataSlice", () => (parcelRequire("9uSEH")).hexDataSlice);
$parcel$export($0e788201f8a90b1e$exports, "nameprep", () => $d214c0e34c39ae0b$export$94f0b6f93c619bc);
$parcel$export($0e788201f8a90b1e$exports, "_toEscapedUtf8String", () => $c64f307c4161c9d6$export$a7a0ec15960b9055);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8Bytes", () => $c64f307c4161c9d6$export$8feeb310b4b4752f);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8CodePoints", () => $c64f307c4161c9d6$export$ae470a36a31b28c2);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8String", () => $c64f307c4161c9d6$export$7643a1dc2c38d5eb);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorFuncs", () => $c64f307c4161c9d6$export$c6e2180c5bb5bc05);
$parcel$export($0e788201f8a90b1e$exports, "formatBytes32String", () => $0b0f987b2ccf3c46$export$b97e949c0076e971);
$parcel$export($0e788201f8a90b1e$exports, "parseBytes32String", () => $0b0f987b2ccf3c46$export$49340cb8f3954db8);
$parcel$export($0e788201f8a90b1e$exports, "dnsEncode", () => $7387e94b7f65d4b6$export$6c0a8cdae51cb512);
$parcel$export($0e788201f8a90b1e$exports, "hashMessage", () => $146df85c9b7f1867$export$d4c241cec96564c1);
$parcel$export($0e788201f8a90b1e$exports, "namehash", () => $7387e94b7f65d4b6$export$91d651ee363e1209);
$parcel$export($0e788201f8a90b1e$exports, "isValidName", () => $7387e94b7f65d4b6$export$cce2300886e7ace6);
$parcel$export($0e788201f8a90b1e$exports, "id", () => $c37a351bb1ec7c40$export$d560c7e4a29451c2);
$parcel$export($0e788201f8a90b1e$exports, "_TypedDataEncoder", () => $8feb3fe5353bb1cc$exports.TypedDataEncoder);
$parcel$export($0e788201f8a90b1e$exports, "getAddress", () => $3bbab26945c6bdb1$export$88411125f012957a);
$parcel$export($0e788201f8a90b1e$exports, "getIcapAddress", () => $3bbab26945c6bdb1$export$962c4ddada9f668f);
$parcel$export($0e788201f8a90b1e$exports, "getContractAddress", () => $3bbab26945c6bdb1$export$b7fbffef12272e40);
$parcel$export($0e788201f8a90b1e$exports, "getCreate2Address", () => $3bbab26945c6bdb1$export$e0b22d96621f73a2);
$parcel$export($0e788201f8a90b1e$exports, "isAddress", () => $3bbab26945c6bdb1$export$977e255126d763d6);
$parcel$export($0e788201f8a90b1e$exports, "formatEther", () => $8634e8376b550172$export$11bc63b4c03ea518);
$parcel$export($0e788201f8a90b1e$exports, "parseEther", () => $8634e8376b550172$export$642c4e67bbdc0bc7);
$parcel$export($0e788201f8a90b1e$exports, "formatUnits", () => $8634e8376b550172$export$bd39b96f71da1885);
$parcel$export($0e788201f8a90b1e$exports, "parseUnits", () => $8634e8376b550172$export$203ae30b4f6490b3);
$parcel$export($0e788201f8a90b1e$exports, "commify", () => $8634e8376b550172$export$de1294767e6ef661);
$parcel$export($0e788201f8a90b1e$exports, "computeHmac", () => $d435f7c5f3d5d722$export$967075d2f3b8e7ff);
$parcel$export($0e788201f8a90b1e$exports, "keccak256", () => $5915e762efc52191$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "ripemd160", () => $d435f7c5f3d5d722$export$d1cea0ee4e3f0d3e);
$parcel$export($0e788201f8a90b1e$exports, "sha256", () => $d435f7c5f3d5d722$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "sha512", () => $d435f7c5f3d5d722$export$a888d2532e6dc7bb);
$parcel$export($0e788201f8a90b1e$exports, "randomBytes", () => $c27b830bf614d184$export$5f828d93ff035aa8);
$parcel$export($0e788201f8a90b1e$exports, "shuffled", () => $53b5d6c749d2ad13$export$e6c7296801b9b341);
$parcel$export($0e788201f8a90b1e$exports, "solidityPack", () => $524ef61eb4f4c5a7$export$2a703dbb0cb35339);
$parcel$export($0e788201f8a90b1e$exports, "solidityKeccak256", () => $524ef61eb4f4c5a7$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "soliditySha256", () => $524ef61eb4f4c5a7$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "splitSignature", () => (parcelRequire("9uSEH")).splitSignature);
$parcel$export($0e788201f8a90b1e$exports, "joinSignature", () => (parcelRequire("9uSEH")).joinSignature);
$parcel$export($0e788201f8a90b1e$exports, "accessListify", () => $c220423970a40605$export$6c8662b1600dce2);
$parcel$export($0e788201f8a90b1e$exports, "parseTransaction", () => $c220423970a40605$export$98e6a39c04603d36);
$parcel$export($0e788201f8a90b1e$exports, "serializeTransaction", () => $c220423970a40605$export$dfdc1655ccc5b9cb);
$parcel$export($0e788201f8a90b1e$exports, "TransactionTypes", () => $c220423970a40605$export$80349e05e0724e11);
$parcel$export($0e788201f8a90b1e$exports, "getJsonWalletAddress", () => $b468c02c6fac1503$export$9a68ee9f8f3afd38);
$parcel$export($0e788201f8a90b1e$exports, "computeAddress", () => $c220423970a40605$export$e67e2732ba9803f9);
$parcel$export($0e788201f8a90b1e$exports, "recoverAddress", () => $c220423970a40605$export$23cc18f96d8510e2);
$parcel$export($0e788201f8a90b1e$exports, "computePublicKey", () => $c996070d7a4cc0da$export$4a89473d39301224);
$parcel$export($0e788201f8a90b1e$exports, "recoverPublicKey", () => $c996070d7a4cc0da$export$952dd09fbe0232b7);
$parcel$export($0e788201f8a90b1e$exports, "verifyMessage", () => $8c76997802860d88$exports.verifyMessage);
$parcel$export($0e788201f8a90b1e$exports, "verifyTypedData", () => $8c76997802860d88$exports.verifyTypedData);
$parcel$export($0e788201f8a90b1e$exports, "getAccountPath", () => $d830e21df8d45279$export$22b80e4f9eff636d);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToEntropy", () => $d830e21df8d45279$export$135e090d58b310ca);
$parcel$export($0e788201f8a90b1e$exports, "entropyToMnemonic", () => $d830e21df8d45279$export$4becd65eb23312e6);
$parcel$export($0e788201f8a90b1e$exports, "isValidMnemonic", () => $d830e21df8d45279$export$5eea3393c6119c80);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToSeed", () => $d830e21df8d45279$export$3dee74f1204ab09f);
$parcel$export($0e788201f8a90b1e$exports, "SupportedAlgorithm", () => $6ca31e017acdfc0f$export$d2a8849cfb277c);
$parcel$export($0e788201f8a90b1e$exports, "UnicodeNormalizationForm", () => $c64f307c4161c9d6$export$c6986442964129f5);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorReason", () => $c64f307c4161c9d6$export$c285fa6ac15ff6a6);
$parcel$export($0e788201f8a90b1e$exports, "Indexed", () => $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c);



var $eGcmO = parcelRequire("eGcmO");
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");
class $73b39074be9e3e41$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $e72ut.defineReadOnly)(this, "alphabet", alphabet);
        (0, $e72ut.defineReadOnly)(this, "base", alphabet.length);
        (0, $e72ut.defineReadOnly)(this, "_alphabetMap", {});
        (0, $e72ut.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $9uSEH.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $9uSEH.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $73b39074be9e3e41$export$cfabb2852920f5ec = new $73b39074be9e3e41$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $73b39074be9e3e41$export$45a587635c9954b2 = new $73b39074be9e3e41$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))



var $9uSEH = parcelRequire("9uSEH");

var $9uSEH = parcelRequire("9uSEH");

"use strict";
function $d214c0e34c39ae0b$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $d214c0e34c39ae0b$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $d214c0e34c39ae0b$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $d214c0e34c39ae0b$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $d214c0e34c39ae0b$var$Table_A_1_ranges = $d214c0e34c39ae0b$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $d214c0e34c39ae0b$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $d214c0e34c39ae0b$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $d214c0e34c39ae0b$var$Table_B_2_lut_abs = $d214c0e34c39ae0b$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $d214c0e34c39ae0b$var$Table_B_2_lut_rel = $d214c0e34c39ae0b$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $d214c0e34c39ae0b$var$Table_B_2_complex = $d214c0e34c39ae0b$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $d214c0e34c39ae0b$var$bytes2);
const $d214c0e34c39ae0b$var$Table_C_ranges = $d214c0e34c39ae0b$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $d214c0e34c39ae0b$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $d214c0e34c39ae0b$export$d1ae0d802533bef0(codepoint) {
    return !!$d214c0e34c39ae0b$var$matchMap(codepoint, $d214c0e34c39ae0b$var$Table_A_1_ranges);
}
function $d214c0e34c39ae0b$export$9630a1f26a43b76c(codepoint) {
    let range = $d214c0e34c39ae0b$var$matchMap(codepoint, $d214c0e34c39ae0b$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $d214c0e34c39ae0b$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $d214c0e34c39ae0b$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $d214c0e34c39ae0b$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $d214c0e34c39ae0b$export$e07a548cae6d1553(codepoint) {
    return !!$d214c0e34c39ae0b$var$matchMap(codepoint, $d214c0e34c39ae0b$var$Table_C_ranges);
}
function $d214c0e34c39ae0b$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $c64f307c4161c9d6$export$ae470a36a31b28c2)(value);
    codes = $d214c0e34c39ae0b$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($d214c0e34c39ae0b$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $d214c0e34c39ae0b$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $c64f307c4161c9d6$export$ae470a36a31b28c2)((0, $c64f307c4161c9d6$export$232e1dab03132235)(codes), (0, $c64f307c4161c9d6$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($d214c0e34c39ae0b$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($d214c0e34c39ae0b$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $c64f307c4161c9d6$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    // IDNA: 4.2.4
    if (name.length > 63) throw new Error("too long");
    return name;
}




var $f8A5C = parcelRequire("f8A5C");

const $7387e94b7f65d4b6$var$logger = new (0, $f8A5C.Logger)((0, $29379b8d17d6e18a$export$83d89fbfd8236492));
const $7387e94b7f65d4b6$var$Zeros = new Uint8Array(32);
$7387e94b7f65d4b6$var$Zeros.fill(0);
const $7387e94b7f65d4b6$var$Partition = new RegExp("^((.*)\\.)?([^.]+)$");
function $7387e94b7f65d4b6$export$cce2300886e7ace6(name) {
    try {
        const comps = name.split(".");
        for(let i = 0; i < comps.length; i++){
            if ((0, $d214c0e34c39ae0b$export$94f0b6f93c619bc)(comps[i]).length === 0) throw new Error("empty");
        }
        return true;
    } catch (error) {}
    return false;
}
function $7387e94b7f65d4b6$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $7387e94b7f65d4b6$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let current = name;
    let result = $7387e94b7f65d4b6$var$Zeros;
    while(current.length){
        const partition = current.match($7387e94b7f65d4b6$var$Partition);
        if (partition == null || partition[2] === "") $7387e94b7f65d4b6$var$logger.throwArgumentError("invalid ENS address; missing component", "name", name);
        const label = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)((0, $d214c0e34c39ae0b$export$94f0b6f93c619bc)(partition[3]));
        result = (0, $5915e762efc52191$export$f8151fce47ad1c35)((0, $9uSEH.concat)([
            result,
            (0, $5915e762efc52191$export$f8151fce47ad1c35)(label)
        ]));
        current = partition[2] || "";
    }
    return (0, $9uSEH.hexlify)(result);
}
function $7387e94b7f65d4b6$export$6c0a8cdae51cb512(name) {
    return (0, $9uSEH.hexlify)((0, $9uSEH.concat)(name.split(".").map((comp)=>{
        // We jam in an _ prefix to fill in with the length later
        // Note: Nameprep throws if the component is over 63 bytes
        const bytes = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)("_" + (0, $d214c0e34c39ae0b$export$94f0b6f93c619bc)(comp));
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}






var $f8A5C = parcelRequire("f8A5C");



var $9uSEH = parcelRequire("9uSEH");




var $f8A5C = parcelRequire("f8A5C");
const $6d0e8c2649cd757e$export$83d89fbfd8236492 = "solidity/5.6.1";


"use strict";
const $524ef61eb4f4c5a7$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $524ef61eb4f4c5a7$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $524ef61eb4f4c5a7$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $524ef61eb4f4c5a7$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $524ef61eb4f4c5a7$var$logger = new (0, $f8A5C.Logger)((0, $6d0e8c2649cd757e$export$83d89fbfd8236492));
function $524ef61eb4f4c5a7$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $9uSEH.zeroPad)(value, 32);
            return (0, $9uSEH.arrayify)(value);
        case "string":
            return (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $9uSEH.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $9uSEH.zeroPad)(value, 32);
            return (0, $9uSEH.arrayify)(value);
    }
    let match = type.match($524ef61eb4f4c5a7$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $524ef61eb4f4c5a7$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $9uSEH.zeroPad)(value, size / 8);
    }
    match = type.match($524ef61eb4f4c5a7$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $524ef61eb4f4c5a7$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $9uSEH.arrayify)(value).byteLength !== size) $524ef61eb4f4c5a7$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $9uSEH.arrayify)((value + $524ef61eb4f4c5a7$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($524ef61eb4f4c5a7$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $524ef61eb4f4c5a7$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($524ef61eb4f4c5a7$var$_pack(baseType, value, true));
        });
        return (0, $9uSEH.concat)(result);
    }
    return $524ef61eb4f4c5a7$var$logger.throwArgumentError("invalid type", "type", type);
}
function $524ef61eb4f4c5a7$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $524ef61eb4f4c5a7$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($524ef61eb4f4c5a7$var$_pack(type, values[index]));
    });
    return (0, $9uSEH.hexlify)((0, $9uSEH.concat)(tight));
}
function $524ef61eb4f4c5a7$export$f8151fce47ad1c35(types, values) {
    return (0, $5915e762efc52191$export$f8151fce47ad1c35)($524ef61eb4f4c5a7$export$2a703dbb0cb35339(types, values));
}
function $524ef61eb4f4c5a7$export$bced8d2aada2d1c9(types, values) {
    return (0, $d435f7c5f3d5d722$export$bced8d2aada2d1c9)($524ef61eb4f4c5a7$export$2a703dbb0cb35339(types, values));
}


"use strict";
function $53b5d6c749d2ad13$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}



var $e72ut = parcelRequire("e72ut");

var $hiDPq = parcelRequire("hiDPq");



var $9uSEH = parcelRequire("9uSEH");

"use strict";
function $0b0f987b2ccf3c46$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $9uSEH.hexlify)((0, $9uSEH.concat)([
        bytes,
        (0, $12a2c77208f0458e$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $0b0f987b2ccf3c46$export$49340cb8f3954db8(bytes) {
    const data = (0, $9uSEH.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $c64f307c4161c9d6$export$7643a1dc2c38d5eb)(data.slice(0, length));
}





var $f8A5C = parcelRequire("f8A5C");
const $69ab60eb61b88b23$export$83d89fbfd8236492 = "units/5.6.1";


"use strict";
const $8634e8376b550172$var$logger = new (0, $f8A5C.Logger)((0, $69ab60eb61b88b23$export$83d89fbfd8236492));
const $8634e8376b550172$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $8634e8376b550172$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $8634e8376b550172$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $8634e8376b550172$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $8634e8376b550172$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $b263b4723a2f8d0b$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $8634e8376b550172$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $8634e8376b550172$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $8634e8376b550172$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $b263b4723a2f8d0b$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $8634e8376b550172$export$11bc63b4c03ea518(wei) {
    return $8634e8376b550172$export$bd39b96f71da1885(wei, 18);
}
function $8634e8376b550172$export$642c4e67bbdc0bc7(ether) {
    return $8634e8376b550172$export$203ae30b4f6490b3(ether, 18);
}



var $92a89a4bb9900a78$exports = {};

$parcel$export($92a89a4bb9900a78$exports, "_fetchData", () => $92a89a4bb9900a78$export$e37fa27017c6c012);
$parcel$export($92a89a4bb9900a78$exports, "fetchJson", () => $92a89a4bb9900a78$export$6d71b655afe1638d);
$parcel$export($92a89a4bb9900a78$exports, "poll", () => $92a89a4bb9900a78$export$e0c10349b2c5e1d4);

var $2vfMQ = parcelRequire("2vfMQ");

var $9uSEH = parcelRequire("9uSEH");

var $e72ut = parcelRequire("e72ut");


var $f8A5C = parcelRequire("f8A5C");
const $830847f8c5e4a627$export$83d89fbfd8236492 = "web/5.6.1";


var $5d616e69e79f3434$exports = {};

$parcel$export($5d616e69e79f3434$exports, "getUrl", () => $5d616e69e79f3434$export$94df0e59ebebf4a7);

var $9uSEH = parcelRequire("9uSEH");
"use strict";
var $5d616e69e79f3434$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $5d616e69e79f3434$export$94df0e59ebebf4a7(href, options) {
    return $5d616e69e79f3434$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $9uSEH.arrayify)(new Uint8Array(body))
        };
    });
}


"use strict";
var $92a89a4bb9900a78$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $92a89a4bb9900a78$var$logger = new (0, $f8A5C.Logger)((0, $830847f8c5e4a627$export$83d89fbfd8236492));
function $92a89a4bb9900a78$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $92a89a4bb9900a78$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $9uSEH.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $c64f307c4161c9d6$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $9uSEH.hexlify)(value);
    }
    return value;
}
function $92a89a4bb9900a78$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $92a89a4bb9900a78$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $92a89a4bb9900a78$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $92a89a4bb9900a78$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $92a89a4bb9900a78$var$logger.throwError("basic authentication requires a secure https url", (0, $f8A5C.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $2vfMQ.encode)((0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
    }
    const reData = new RegExp("^data:([a-z0-9-]+/[a-z0-9-]+);base64,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1]
            },
            body: (0, $2vfMQ.decode)(dataMatch[2])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $92a89a4bb9900a78$var$logger.throwError("processing response error", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
            body: $92a89a4bb9900a78$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($92a89a4bb9900a78$var$logger.makeError("timeout", (0, $f8A5C.Logger).errors.TIMEOUT, {
                    requestBody: $92a89a4bb9900a78$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $92a89a4bb9900a78$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $5d616e69e79f3434$exports.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $92a89a4bb9900a78$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $92a89a4bb9900a78$var$logger.throwError("missing response", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
                            requestBody: $92a89a4bb9900a78$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $92a89a4bb9900a78$var$logger.throwError("bad response", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $92a89a4bb9900a78$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $92a89a4bb9900a78$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $92a89a4bb9900a78$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $92a89a4bb9900a78$var$logger.throwError("processing response error", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
                        body: $92a89a4bb9900a78$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $92a89a4bb9900a78$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $92a89a4bb9900a78$var$logger.throwError("failed response", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
                requestBody: $92a89a4bb9900a78$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $92a89a4bb9900a78$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $c64f307c4161c9d6$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $92a89a4bb9900a78$var$logger.throwError("invalid JSON", (0, $f8A5C.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $c64f307c4161c9d6$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $e72ut.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $e72ut.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $92a89a4bb9900a78$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $92a89a4bb9900a78$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $e72ut.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}


"use strict";



var $f8A5C = parcelRequire("f8A5C");
const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "ethers/5.6.9";


"use strict";
const $6c57cc56acea9c6c$export$af88d00dbe7f521 = new (0, $f8A5C.Logger)((0, $9f7bf65ddafc81a6$export$83d89fbfd8236492));


var $j7x7T = parcelRequire("j7x7T");
var $bsYBY = parcelRequire("bsYBY");
var $f8A5C = parcelRequire("f8A5C");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $6c57cc56acea9c6c$exports;
} catch (error) {}


const $2f309fd939ca7757$var$abi$5 = [
    {
        type: "function",
        name: "isValidSignature",
        constant: true,
        inputs: [
            {
                type: "bytes32"
            },
            {
                type: "bytes"
            }
        ],
        outputs: [
            {
                type: "bytes4"
            }
        ],
        payable: false,
        stateMutability: "view"
    }
];
const $2f309fd939ca7757$var$returns = {
    isValidSignatureBytes32: "0x1626ba7e"
};
var $2f309fd939ca7757$var$erc1271 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi$5,
    returns: $2f309fd939ca7757$var$returns
});
const $2f309fd939ca7757$var$abi$4 = [
    {
        type: "function",
        name: "deploy",
        constant: false,
        inputs: [
            {
                type: "address"
            },
            {
                type: "bytes32"
            }
        ],
        outputs: [],
        payable: true,
        stateMutability: "payable"
    }
];
var $2f309fd939ca7757$var$factory = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi$4
});
const $2f309fd939ca7757$var$abi$3 = [
    {
        type: "function",
        name: "nonce",
        constant: true,
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view"
    },
    {
        type: "function",
        name: "readNonce",
        constant: true,
        inputs: [
            {
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view"
    },
    {
        type: "function",
        name: "updateImplementation",
        constant: false,
        inputs: [
            {
                type: "address"
            }
        ],
        outputs: [],
        payable: false,
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "selfExecute",
        constant: false,
        inputs: [
            {
                components: [
                    {
                        type: "bool",
                        name: "delegateCall"
                    },
                    {
                        type: "bool",
                        name: "revertOnError"
                    },
                    {
                        type: "uint256",
                        name: "gasLimit"
                    },
                    {
                        type: "address",
                        name: "target"
                    },
                    {
                        type: "uint256",
                        name: "value"
                    },
                    {
                        type: "bytes",
                        name: "data"
                    }
                ],
                type: "tuple[]"
            }
        ],
        outputs: [],
        payable: false,
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "execute",
        constant: false,
        inputs: [
            {
                components: [
                    {
                        type: "bool",
                        name: "delegateCall"
                    },
                    {
                        type: "bool",
                        name: "revertOnError"
                    },
                    {
                        type: "uint256",
                        name: "gasLimit"
                    },
                    {
                        type: "address",
                        name: "target"
                    },
                    {
                        type: "uint256",
                        name: "value"
                    },
                    {
                        type: "bytes",
                        name: "data"
                    }
                ],
                type: "tuple[]"
            },
            {
                type: "uint256"
            },
            {
                type: "bytes"
            }
        ],
        outputs: [],
        payable: false,
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "createContract",
        inputs: [
            {
                type: "bytes"
            }
        ],
        payable: true,
        stateMutability: "payable"
    }
];
var $2f309fd939ca7757$var$mainModule = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi$3
});
const $2f309fd939ca7757$var$abi$2 = [
    {
        type: "function",
        name: "updateImageHash",
        constant: true,
        inputs: [
            {
                type: "bytes32"
            }
        ],
        outputs: [],
        payable: false,
        stateMutability: "view"
    },
    {
        type: "function",
        name: "imageHash",
        constant: true,
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ],
        payable: false,
        stateMutability: "view"
    }
];
var $2f309fd939ca7757$var$mainModuleUpgradable = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi$2
});
const $2f309fd939ca7757$var$abi$1 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address"
            },
            {
                internalType: "address",
                name: "_mainModule",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_wallet",
                type: "address"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "_imageHash",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_signers",
                type: "bytes"
            }
        ],
        name: "RequiredConfig",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_wallet",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "_signer",
                type: "address"
            }
        ],
        name: "RequiredSigner",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address"
            }
        ],
        name: "callBalanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_i",
                type: "uint256"
            }
        ],
        name: "callBlockhash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address"
            }
        ],
        name: "callCode",
        outputs: [
            {
                internalType: "bytes",
                name: "code",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address"
            }
        ],
        name: "callCodeHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "codeHash",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address"
            }
        ],
        name: "callCodeSize",
        outputs: [
            {
                internalType: "uint256",
                name: "size",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callCoinbase",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callDifficulty",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callGasLeft",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callGasLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callGasPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callOrigin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "callTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "knownImageHashes",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        name: "lastImageHashUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "lastSignerUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "lastWalletUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "delegateCall",
                        type: "bool"
                    },
                    {
                        internalType: "bool",
                        name: "revertOnError",
                        type: "bool"
                    },
                    {
                        internalType: "uint256",
                        name: "gasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct IModuleCalls.Transaction[]",
                name: "_txs",
                type: "tuple[]"
            }
        ],
        name: "multiCall",
        outputs: [
            {
                internalType: "bool[]",
                name: "_successes",
                type: "bool[]"
            },
            {
                internalType: "bytes[]",
                name: "_results",
                type: "bytes[]"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "weight",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address"
                    }
                ],
                internalType: "struct RequireUtils.Member[]",
                name: "_members",
                type: "tuple[]"
            },
            {
                internalType: "bool",
                name: "_index",
                type: "bool"
            }
        ],
        name: "publishConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "_sizeMembers",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "_index",
                type: "bool"
            }
        ],
        name: "publishInitialSigners",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wallet",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256"
            }
        ],
        name: "requireMinNonce",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_expiration",
                type: "uint256"
            }
        ],
        name: "requireNonExpired",
        outputs: [],
        stateMutability: "view",
        type: "function"
    }
];
var $2f309fd939ca7757$var$sequenceUtils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi$1
});
const $2f309fd939ca7757$var$abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "requireFreshSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
var $2f309fd939ca7757$var$requireFreshSigner = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abi: $2f309fd939ca7757$var$abi
});
const $2f309fd939ca7757$export$5b3e72131e84edcc = {
    erc1271: $2f309fd939ca7757$var$erc1271,
    factory: $2f309fd939ca7757$var$factory,
    mainModule: $2f309fd939ca7757$var$mainModule,
    mainModuleUpgradable: $2f309fd939ca7757$var$mainModuleUpgradable,
    sequenceUtils: $2f309fd939ca7757$var$sequenceUtils,
    requireFreshSigner: $2f309fd939ca7757$var$requireFreshSigner
};


/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $7ca0d9e2d8e201da$require$Buffer = $6ZWSX.Buffer;
const $7ca0d9e2d8e201da$export$83d89fbfd8236492 = "3.7.2";
/**
 * @deprecated use lowercase `version`.
 */ const $7ca0d9e2d8e201da$export$a4ad2735b021c132 = $7ca0d9e2d8e201da$export$83d89fbfd8236492;
const $7ca0d9e2d8e201da$var$_hasatob = typeof atob === "function";
const $7ca0d9e2d8e201da$var$_hasbtoa = typeof btoa === "function";
const $7ca0d9e2d8e201da$var$_hasBuffer = typeof $7ca0d9e2d8e201da$require$Buffer === "function";
const $7ca0d9e2d8e201da$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $7ca0d9e2d8e201da$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $7ca0d9e2d8e201da$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $7ca0d9e2d8e201da$var$b64chs = Array.prototype.slice.call($7ca0d9e2d8e201da$var$b64ch);
const $7ca0d9e2d8e201da$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7ca0d9e2d8e201da$var$b64chs);
const $7ca0d9e2d8e201da$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7ca0d9e2d8e201da$var$_fromCC = String.fromCharCode.bind(String);
const $7ca0d9e2d8e201da$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it, fn = (x)=>x)=>new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
const $7ca0d9e2d8e201da$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $7ca0d9e2d8e201da$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $7ca0d9e2d8e201da$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7ca0d9e2d8e201da$var$b64chs[u32 >> 18 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 12 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 6 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7ca0d9e2d8e201da$export$a32219e24f8d1e2 = $7ca0d9e2d8e201da$var$_hasbtoa ? (bin)=>btoa(bin) : $7ca0d9e2d8e201da$var$_hasBuffer ? (bin)=>$7ca0d9e2d8e201da$require$Buffer.from(bin, "binary").toString("base64") : $7ca0d9e2d8e201da$export$ec0fb543302ee251;
const $7ca0d9e2d8e201da$var$_fromUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (u8a)=>$7ca0d9e2d8e201da$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7ca0d9e2d8e201da$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7ca0d9e2d8e201da$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_fromUint8Array(u8a)) : $7ca0d9e2d8e201da$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7ca0d9e2d8e201da$var$_fromCC(0xc0 | cc >>> 6) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f) : $7ca0d9e2d8e201da$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7ca0d9e2d8e201da$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7ca0d9e2d8e201da$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7ca0d9e2d8e201da$export$10d4b9bd20a66b0 = (u)=>u.replace($7ca0d9e2d8e201da$var$re_utob, $7ca0d9e2d8e201da$var$cb_utob);
//
const $7ca0d9e2d8e201da$var$_encode = $7ca0d9e2d8e201da$var$_hasBuffer ? (s)=>$7ca0d9e2d8e201da$require$Buffer.from(s, "utf8").toString("base64") : $7ca0d9e2d8e201da$var$_TE ? (s)=>$7ca0d9e2d8e201da$var$_fromUint8Array($7ca0d9e2d8e201da$var$_TE.encode(s)) : (s)=>$7ca0d9e2d8e201da$export$a32219e24f8d1e2($7ca0d9e2d8e201da$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_encode(src)) : $7ca0d9e2d8e201da$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$90c31d5baa78df44 = (src)=>$7ca0d9e2d8e201da$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7ca0d9e2d8e201da$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7ca0d9e2d8e201da$var$_fromCC((offset >>> 10) + 0xD800) + $7ca0d9e2d8e201da$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7ca0d9e2d8e201da$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7ca0d9e2d8e201da$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$67e9defdeac3dd95 = (b)=>b.replace($7ca0d9e2d8e201da$var$re_btou, $7ca0d9e2d8e201da$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7ca0d9e2d8e201da$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$7ca0d9e2d8e201da$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 18 | $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a = $7ca0d9e2d8e201da$var$_hasatob ? (asc)=>atob($7ca0d9e2d8e201da$var$_tidyB64(asc)) : $7ca0d9e2d8e201da$var$_hasBuffer ? (asc)=>$7ca0d9e2d8e201da$require$Buffer.from(asc, "base64").toString("binary") : $7ca0d9e2d8e201da$export$7f16d8e674ddec24;
//
const $7ca0d9e2d8e201da$var$_toUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$require$Buffer.from(a, "base64")) : (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a), (c)=>c.charCodeAt(0));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7ca0d9e2d8e201da$export$73470fd2221e6aef = (a)=>$7ca0d9e2d8e201da$var$_toUint8Array($7ca0d9e2d8e201da$var$_unURI(a));
//
const $7ca0d9e2d8e201da$var$_decode = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$require$Buffer.from(a, "base64").toString("utf8") : $7ca0d9e2d8e201da$var$_TD ? (a)=>$7ca0d9e2d8e201da$var$_TD.decode($7ca0d9e2d8e201da$var$_toUint8Array(a)) : (a)=>$7ca0d9e2d8e201da$export$67e9defdeac3dd95($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a));
const $7ca0d9e2d8e201da$var$_unURI = (a)=>$7ca0d9e2d8e201da$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$c537b38001c583b7 = (src)=>$7ca0d9e2d8e201da$var$_decode($7ca0d9e2d8e201da$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7ca0d9e2d8e201da$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7ca0d9e2d8e201da$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("fromBase64", function() {
        return $7ca0d9e2d8e201da$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $7ca0d9e2d8e201da$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245 = ()=>{
    $7ca0d9e2d8e201da$export$4678ebf2295c49b();
    $7ca0d9e2d8e201da$export$a105d6a15258bd2();
};
const $7ca0d9e2d8e201da$export$f436b0c2107cbd35 = {
    version: $7ca0d9e2d8e201da$export$83d89fbfd8236492,
    VERSION: $7ca0d9e2d8e201da$export$a4ad2735b021c132,
    atob: $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7ca0d9e2d8e201da$export$7f16d8e674ddec24,
    btoa: $7ca0d9e2d8e201da$export$a32219e24f8d1e2,
    btoaPolyfill: $7ca0d9e2d8e201da$export$ec0fb543302ee251,
    fromBase64: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    toBase64: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encode: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encodeURI: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    encodeURL: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    utob: $7ca0d9e2d8e201da$export$10d4b9bd20a66b0,
    btou: $7ca0d9e2d8e201da$export$67e9defdeac3dd95,
    decode: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    isValid: $7ca0d9e2d8e201da$export$1ea939691cdc45b8,
    fromUint8Array: $7ca0d9e2d8e201da$export$27bbb4e040978768,
    toUint8Array: $7ca0d9e2d8e201da$export$73470fd2221e6aef,
    extendString: $7ca0d9e2d8e201da$export$4678ebf2295c49b,
    extendUint8Array: $7ca0d9e2d8e201da$export$a105d6a15258bd2,
    extendBuiltins: $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245
};




var $1c38d8340004597f$exports = {};
"use strict";
var $1c38d8340004597f$var$__createBinding = $1c38d8340004597f$exports && $1c38d8340004597f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1c38d8340004597f$var$__setModuleDefault = $1c38d8340004597f$exports && $1c38d8340004597f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1c38d8340004597f$var$__importStar = $1c38d8340004597f$exports && $1c38d8340004597f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1c38d8340004597f$var$__createBinding(result, mod, k);
    }
    $1c38d8340004597f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1c38d8340004597f$exports, "__esModule", {
    value: true
});
$1c38d8340004597f$exports.formatBytes32String = $1c38d8340004597f$exports.Utf8ErrorFuncs = $1c38d8340004597f$exports.toUtf8String = $1c38d8340004597f$exports.toUtf8CodePoints = $1c38d8340004597f$exports.toUtf8Bytes = $1c38d8340004597f$exports._toEscapedUtf8String = $1c38d8340004597f$exports.nameprep = $1c38d8340004597f$exports.hexDataSlice = $1c38d8340004597f$exports.hexDataLength = $1c38d8340004597f$exports.hexZeroPad = $1c38d8340004597f$exports.hexValue = $1c38d8340004597f$exports.hexStripZeros = $1c38d8340004597f$exports.hexConcat = $1c38d8340004597f$exports.isHexString = $1c38d8340004597f$exports.hexlify = $1c38d8340004597f$exports.base64 = $1c38d8340004597f$exports.base58 = $1c38d8340004597f$exports.TransactionDescription = $1c38d8340004597f$exports.LogDescription = $1c38d8340004597f$exports.Interface = $1c38d8340004597f$exports.SigningKey = $1c38d8340004597f$exports.HDNode = $1c38d8340004597f$exports.defaultPath = $1c38d8340004597f$exports.isBytesLike = $1c38d8340004597f$exports.isBytes = $1c38d8340004597f$exports.zeroPad = $1c38d8340004597f$exports.stripZeros = $1c38d8340004597f$exports.concat = $1c38d8340004597f$exports.arrayify = $1c38d8340004597f$exports.shallowCopy = $1c38d8340004597f$exports.resolveProperties = $1c38d8340004597f$exports.getStatic = $1c38d8340004597f$exports.defineReadOnly = $1c38d8340004597f$exports.deepCopy = $1c38d8340004597f$exports.checkProperties = $1c38d8340004597f$exports.poll = $1c38d8340004597f$exports.fetchJson = $1c38d8340004597f$exports._fetchData = $1c38d8340004597f$exports.RLP = $1c38d8340004597f$exports.Logger = $1c38d8340004597f$exports.checkResultErrors = $1c38d8340004597f$exports.FormatTypes = $1c38d8340004597f$exports.ParamType = $1c38d8340004597f$exports.FunctionFragment = $1c38d8340004597f$exports.EventFragment = $1c38d8340004597f$exports.ErrorFragment = $1c38d8340004597f$exports.ConstructorFragment = $1c38d8340004597f$exports.Fragment = $1c38d8340004597f$exports.defaultAbiCoder = $1c38d8340004597f$exports.AbiCoder = void 0;
$1c38d8340004597f$exports.Indexed = $1c38d8340004597f$exports.Utf8ErrorReason = $1c38d8340004597f$exports.UnicodeNormalizationForm = $1c38d8340004597f$exports.SupportedAlgorithm = $1c38d8340004597f$exports.mnemonicToSeed = $1c38d8340004597f$exports.isValidMnemonic = $1c38d8340004597f$exports.entropyToMnemonic = $1c38d8340004597f$exports.mnemonicToEntropy = $1c38d8340004597f$exports.getAccountPath = $1c38d8340004597f$exports.verifyTypedData = $1c38d8340004597f$exports.verifyMessage = $1c38d8340004597f$exports.recoverPublicKey = $1c38d8340004597f$exports.computePublicKey = $1c38d8340004597f$exports.recoverAddress = $1c38d8340004597f$exports.computeAddress = $1c38d8340004597f$exports.getJsonWalletAddress = $1c38d8340004597f$exports.TransactionTypes = $1c38d8340004597f$exports.serializeTransaction = $1c38d8340004597f$exports.parseTransaction = $1c38d8340004597f$exports.accessListify = $1c38d8340004597f$exports.joinSignature = $1c38d8340004597f$exports.splitSignature = $1c38d8340004597f$exports.soliditySha256 = $1c38d8340004597f$exports.solidityKeccak256 = $1c38d8340004597f$exports.solidityPack = $1c38d8340004597f$exports.shuffled = $1c38d8340004597f$exports.randomBytes = $1c38d8340004597f$exports.sha512 = $1c38d8340004597f$exports.sha256 = $1c38d8340004597f$exports.ripemd160 = $1c38d8340004597f$exports.keccak256 = $1c38d8340004597f$exports.computeHmac = $1c38d8340004597f$exports.commify = $1c38d8340004597f$exports.parseUnits = $1c38d8340004597f$exports.formatUnits = $1c38d8340004597f$exports.parseEther = $1c38d8340004597f$exports.formatEther = $1c38d8340004597f$exports.isAddress = $1c38d8340004597f$exports.getCreate2Address = $1c38d8340004597f$exports.getContractAddress = $1c38d8340004597f$exports.getIcapAddress = $1c38d8340004597f$exports.getAddress = $1c38d8340004597f$exports._TypedDataEncoder = $1c38d8340004597f$exports.id = $1c38d8340004597f$exports.isValidName = $1c38d8340004597f$exports.namehash = $1c38d8340004597f$exports.hashMessage = $1c38d8340004597f$exports.dnsEncode = $1c38d8340004597f$exports.parseBytes32String = void 0;

Object.defineProperty($1c38d8340004597f$exports, "AbiCoder", {
    enumerable: true,
    get: function() {
        return $45e842348d346001$export$fe041e1a83d3efc6;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "checkResultErrors", {
    enumerable: true,
    get: function() {
        return $2443aa857d9ae22f$export$5546b9ec21157cc2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "ConstructorFragment", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$3ac5c9504f801ea4;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "defaultAbiCoder", {
    enumerable: true,
    get: function() {
        return $45e842348d346001$export$51d1cfcdb913adff;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "ErrorFragment", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$2c42c6d543aa9b59;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "EventFragment", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$958548f08bac2833;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "FormatTypes", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$f010f239efc4d445;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "Fragment", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$ffb0004e005737fa;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "FunctionFragment", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$8d576c928b93668f;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "Indexed", {
    enumerable: true,
    get: function() {
        return $6c9fdbc6de4e49f0$export$8ef99100a3c56f8c;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "Interface", {
    enumerable: true,
    get: function() {
        return $6c9fdbc6de4e49f0$export$48cefb51a4e315b2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "LogDescription", {
    enumerable: true,
    get: function() {
        return $6c9fdbc6de4e49f0$export$c2ab6499be98b3c5;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "ParamType", {
    enumerable: true,
    get: function() {
        return $be76a1f9a941f8f7$export$426dc07f493a4c47;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "TransactionDescription", {
    enumerable: true,
    get: function() {
        return $6c9fdbc6de4e49f0$export$7a3223b0fadb690b;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "getAddress", {
    enumerable: true,
    get: function() {
        return $3bbab26945c6bdb1$export$88411125f012957a;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "getCreate2Address", {
    enumerable: true,
    get: function() {
        return $3bbab26945c6bdb1$export$e0b22d96621f73a2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "getContractAddress", {
    enumerable: true,
    get: function() {
        return $3bbab26945c6bdb1$export$b7fbffef12272e40;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "getIcapAddress", {
    enumerable: true,
    get: function() {
        return $3bbab26945c6bdb1$export$962c4ddada9f668f;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isAddress", {
    enumerable: true,
    get: function() {
        return $3bbab26945c6bdb1$export$977e255126d763d6;
    }
});

var $1c38d8340004597f$var$base64 = $1c38d8340004597f$var$__importStar((parcelRequire("eGcmO")));
$1c38d8340004597f$exports.base64 = $1c38d8340004597f$var$base64;

Object.defineProperty($1c38d8340004597f$exports, "base58", {
    enumerable: true,
    get: function() {
        return $73b39074be9e3e41$export$45a587635c9954b2;
    }
});

var $9uSEH = parcelRequire("9uSEH");
Object.defineProperty($1c38d8340004597f$exports, "arrayify", {
    enumerable: true,
    get: function() {
        return $9uSEH.arrayify;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "concat", {
    enumerable: true,
    get: function() {
        return $9uSEH.concat;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexConcat", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexConcat;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexDataSlice", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexDataSlice;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexDataLength", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexDataLength;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexlify", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexlify;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexStripZeros", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexStripZeros;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexValue", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexValue;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hexZeroPad", {
    enumerable: true,
    get: function() {
        return $9uSEH.hexZeroPad;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isBytes", {
    enumerable: true,
    get: function() {
        return $9uSEH.isBytes;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isBytesLike", {
    enumerable: true,
    get: function() {
        return $9uSEH.isBytesLike;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $9uSEH.isHexString;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "joinSignature", {
    enumerable: true,
    get: function() {
        return $9uSEH.joinSignature;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "zeroPad", {
    enumerable: true,
    get: function() {
        return $9uSEH.zeroPad;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "splitSignature", {
    enumerable: true,
    get: function() {
        return $9uSEH.splitSignature;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "stripZeros", {
    enumerable: true,
    get: function() {
        return $9uSEH.stripZeros;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "_TypedDataEncoder", {
    enumerable: true,
    get: function() {
        return $8feb3fe5353bb1cc$exports.TypedDataEncoder;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "dnsEncode", {
    enumerable: true,
    get: function() {
        return $7387e94b7f65d4b6$export$6c0a8cdae51cb512;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "hashMessage", {
    enumerable: true,
    get: function() {
        return $146df85c9b7f1867$export$d4c241cec96564c1;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "id", {
    enumerable: true,
    get: function() {
        return $c37a351bb1ec7c40$export$d560c7e4a29451c2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isValidName", {
    enumerable: true,
    get: function() {
        return $7387e94b7f65d4b6$export$cce2300886e7ace6;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "namehash", {
    enumerable: true,
    get: function() {
        return $7387e94b7f65d4b6$export$91d651ee363e1209;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "defaultPath", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$d48ad89f7e11a603;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "entropyToMnemonic", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$4becd65eb23312e6;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "getAccountPath", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$22b80e4f9eff636d;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "HDNode", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$b68640c53e22b952;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "isValidMnemonic", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$5eea3393c6119c80;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "mnemonicToEntropy", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$135e090d58b310ca;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "mnemonicToSeed", {
    enumerable: true,
    get: function() {
        return $d830e21df8d45279$export$3dee74f1204ab09f;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "getJsonWalletAddress", {
    enumerable: true,
    get: function() {
        return $b468c02c6fac1503$export$9a68ee9f8f3afd38;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $5915e762efc52191$export$f8151fce47ad1c35;
    }
});

var $f8A5C = parcelRequire("f8A5C");
Object.defineProperty($1c38d8340004597f$exports, "Logger", {
    enumerable: true,
    get: function() {
        return $f8A5C.Logger;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "computeHmac", {
    enumerable: true,
    get: function() {
        return $d435f7c5f3d5d722$export$967075d2f3b8e7ff;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $d435f7c5f3d5d722$export$d1cea0ee4e3f0d3e;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "sha256", {
    enumerable: true,
    get: function() {
        return $d435f7c5f3d5d722$export$bced8d2aada2d1c9;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "sha512", {
    enumerable: true,
    get: function() {
        return $d435f7c5f3d5d722$export$a888d2532e6dc7bb;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "solidityKeccak256", {
    enumerable: true,
    get: function() {
        return $524ef61eb4f4c5a7$export$f8151fce47ad1c35;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "solidityPack", {
    enumerable: true,
    get: function() {
        return $524ef61eb4f4c5a7$export$2a703dbb0cb35339;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "soliditySha256", {
    enumerable: true,
    get: function() {
        return $524ef61eb4f4c5a7$export$bced8d2aada2d1c9;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "randomBytes", {
    enumerable: true,
    get: function() {
        return $c27b830bf614d184$export$5f828d93ff035aa8;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "shuffled", {
    enumerable: true,
    get: function() {
        return $53b5d6c749d2ad13$export$e6c7296801b9b341;
    }
});

var $e72ut = parcelRequire("e72ut");
Object.defineProperty($1c38d8340004597f$exports, "checkProperties", {
    enumerable: true,
    get: function() {
        return $e72ut.checkProperties;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "deepCopy", {
    enumerable: true,
    get: function() {
        return $e72ut.deepCopy;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "defineReadOnly", {
    enumerable: true,
    get: function() {
        return $e72ut.defineReadOnly;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "getStatic", {
    enumerable: true,
    get: function() {
        return $e72ut.getStatic;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "resolveProperties", {
    enumerable: true,
    get: function() {
        return $e72ut.resolveProperties;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "shallowCopy", {
    enumerable: true,
    get: function() {
        return $e72ut.shallowCopy;
    }
});

var $1c38d8340004597f$var$RLP = $1c38d8340004597f$var$__importStar((parcelRequire("hiDPq")));
$1c38d8340004597f$exports.RLP = $1c38d8340004597f$var$RLP;

Object.defineProperty($1c38d8340004597f$exports, "computePublicKey", {
    enumerable: true,
    get: function() {
        return $c996070d7a4cc0da$export$4a89473d39301224;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "recoverPublicKey", {
    enumerable: true,
    get: function() {
        return $c996070d7a4cc0da$export$952dd09fbe0232b7;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "SigningKey", {
    enumerable: true,
    get: function() {
        return $c996070d7a4cc0da$export$21643ca94aed3e83;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "formatBytes32String", {
    enumerable: true,
    get: function() {
        return $0b0f987b2ccf3c46$export$b97e949c0076e971;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "nameprep", {
    enumerable: true,
    get: function() {
        return $d214c0e34c39ae0b$export$94f0b6f93c619bc;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "parseBytes32String", {
    enumerable: true,
    get: function() {
        return $0b0f987b2ccf3c46$export$49340cb8f3954db8;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "_toEscapedUtf8String", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$a7a0ec15960b9055;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "toUtf8Bytes", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$8feeb310b4b4752f;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "toUtf8CodePoints", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$ae470a36a31b28c2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "toUtf8String", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$7643a1dc2c38d5eb;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "Utf8ErrorFuncs", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$c6e2180c5bb5bc05;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "accessListify", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$6c8662b1600dce2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "computeAddress", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$e67e2732ba9803f9;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "parseTransaction", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$98e6a39c04603d36;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "recoverAddress", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$23cc18f96d8510e2;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "serializeTransaction", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$dfdc1655ccc5b9cb;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "TransactionTypes", {
    enumerable: true,
    get: function() {
        return $c220423970a40605$export$80349e05e0724e11;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "commify", {
    enumerable: true,
    get: function() {
        return $8634e8376b550172$export$de1294767e6ef661;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "formatEther", {
    enumerable: true,
    get: function() {
        return $8634e8376b550172$export$11bc63b4c03ea518;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "parseEther", {
    enumerable: true,
    get: function() {
        return $8634e8376b550172$export$642c4e67bbdc0bc7;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "formatUnits", {
    enumerable: true,
    get: function() {
        return $8634e8376b550172$export$bd39b96f71da1885;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "parseUnits", {
    enumerable: true,
    get: function() {
        return $8634e8376b550172$export$203ae30b4f6490b3;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "verifyMessage", {
    enumerable: true,
    get: function() {
        return $8c76997802860d88$exports.verifyMessage;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "verifyTypedData", {
    enumerable: true,
    get: function() {
        return $8c76997802860d88$exports.verifyTypedData;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "_fetchData", {
    enumerable: true,
    get: function() {
        return $92a89a4bb9900a78$exports._fetchData;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $92a89a4bb9900a78$exports.fetchJson;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "poll", {
    enumerable: true,
    get: function() {
        return $92a89a4bb9900a78$exports.poll;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "SupportedAlgorithm", {
    enumerable: true,
    get: function() {
        return $6ca31e017acdfc0f$export$d2a8849cfb277c;
    }
});

Object.defineProperty($1c38d8340004597f$exports, "UnicodeNormalizationForm", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$c6986442964129f5;
    }
});
Object.defineProperty($1c38d8340004597f$exports, "Utf8ErrorReason", {
    enumerable: true,
    get: function() {
        return $c64f307c4161c9d6$export$c285fa6ac15ff6a6;
    }
});



var $hPtJY = parcelRequire("hPtJY");
const $aab880b0cdc93953$export$e510a73ee562749 = (val)=>{
    return (0, $7ca0d9e2d8e201da$export$f436b0c2107cbd35).encode(val, true);
};
const $aab880b0cdc93953$export$36aa0155940f8cb9 = (obj)=>{
    return (0, $7ca0d9e2d8e201da$export$f436b0c2107cbd35).encode(JSON.stringify(obj), true);
};
const $aab880b0cdc93953$export$c62426fdd000a97e = (encodedString)=>{
    if (encodedString === null || encodedString === undefined) return undefined;
    return (0, $7ca0d9e2d8e201da$export$f436b0c2107cbd35).decode(encodedString);
};
const $aab880b0cdc93953$export$30e01b9405dda9a2 = (encodedObject)=>{
    if (encodedObject === null || encodedObject === undefined) return undefined;
    return JSON.parse((0, $7ca0d9e2d8e201da$export$f436b0c2107cbd35).decode(encodedObject));
};
const $aab880b0cdc93953$export$26a4dcc6c3fc7b1f = (message)=>{
    if (typeof message === "string") return (0, $6c57cc56acea9c6c$exports).utils.arrayify((0, $6c57cc56acea9c6c$exports).utils.keccak256((0, $6c57cc56acea9c6c$exports).utils.toUtf8Bytes(message)));
    else return (0, $6c57cc56acea9c6c$exports).utils.arrayify((0, $6c57cc56acea9c6c$exports).utils.keccak256(message));
}; // packMessageData encodes the specified data ready for the Sequence Wallet contracts.
const $aab880b0cdc93953$export$b843ab62e4649c66 = (walletAddress, chainId, digest)=>{
    return (0, $6c57cc56acea9c6c$exports).utils.solidityPack([
        "string",
        "uint256",
        "address",
        "bytes32"
    ], [
        "\x19\x01",
        chainId,
        walletAddress,
        digest
    ]);
};
const $aab880b0cdc93953$export$d0c8b82b3d48e211 = (address, chainId, digest)=>{
    return (0, $6c57cc56acea9c6c$exports).utils.keccak256($aab880b0cdc93953$export$b843ab62e4649c66(address, chainId, digest));
};
const $aab880b0cdc93953$export$8ee0fc9ee280b4ee = ()=>{
    if (typeof window === "undefined" && typeof $hPtJY === "object") return true;
    else return false;
};
const $aab880b0cdc93953$export$4e09c449d6c407f7 = ()=>!$aab880b0cdc93953$export$8ee0fc9ee280b4ee();
const $aab880b0cdc93953$export$5da3ab533b62cb3f = (jwt)=>{
    const parts = jwt.split(".");
    if (parts.length !== 3) throw new Error("invalid jwt");
    const claims = JSON.parse((0, $7ca0d9e2d8e201da$export$f436b0c2107cbd35).decode(parts[1]));
    return claims;
};
function $aab880b0cdc93953$var$_extends() {
    $aab880b0cdc93953$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aab880b0cdc93953$var$_extends.apply(this, arguments);
}
var $aab880b0cdc93953$var$logLevel;
(function(logLevel) {
    logLevel[logLevel["DEBUG"] = 1] = "DEBUG";
    logLevel[logLevel["INFO"] = 2] = "INFO";
    logLevel[logLevel["WARN"] = 3] = "WARN";
    logLevel[logLevel["ERROR"] = 4] = "ERROR";
    logLevel[logLevel["DISABLED"] = 5] = "DISABLED";
})($aab880b0cdc93953$var$logLevel || ($aab880b0cdc93953$var$logLevel = {}));
class $aab880b0cdc93953$export$efa9a398d6368992 {
    constructor(config){
        this.config = config;
        this.logLevel = void 0;
        this.configure(config);
    }
    configure(config) {
        this.config = $aab880b0cdc93953$var$_extends({}, this.config, config);
        switch(this.config.logLevel){
            case "DEBUG":
                this.logLevel = $aab880b0cdc93953$var$logLevel.DEBUG;
                break;
            case "INFO":
                this.logLevel = $aab880b0cdc93953$var$logLevel.INFO;
                break;
            case "WARN":
                this.logLevel = $aab880b0cdc93953$var$logLevel.WARN;
                break;
            case "ERROR":
                this.logLevel = $aab880b0cdc93953$var$logLevel.ERROR;
                break;
            case "DISABLED":
                this.logLevel = $aab880b0cdc93953$var$logLevel.DISABLED;
                break;
            default:
                this.logLevel = $aab880b0cdc93953$var$logLevel.INFO;
                break;
        } // undefined silence value will disable the default silence flag
        if (this.config.silence === undefined) this.config.silence = false;
    }
    debug(message, ...optionalParams) {
        if (this.config.silence === true) return;
        if (this.logLevel === $aab880b0cdc93953$var$logLevel.DEBUG) console.log(message, ...optionalParams);
    }
    info(message, ...optionalParams) {
        if (this.config.silence === true) return;
        if (this.logLevel <= $aab880b0cdc93953$var$logLevel.INFO) console.log(message, ...optionalParams);
    }
    warn(message, ...optionalParams) {
        if (this.config.silence === true) return;
        if (this.logLevel <= $aab880b0cdc93953$var$logLevel.WARN) {
            console.warn(message, ...optionalParams);
            if (this.config.onwarn) this.config.onwarn(message, optionalParams);
        }
    }
    error(message, ...optionalParams) {
        if (this.config.silence === true) return;
        if (this.logLevel <= $aab880b0cdc93953$var$logLevel.ERROR) {
            console.error(message, ...optionalParams);
            if (this.config.onerror) this.config.onerror(message, optionalParams);
        }
    }
}
const $aab880b0cdc93953$export$af88d00dbe7f521 = new $aab880b0cdc93953$export$efa9a398d6368992({
    logLevel: "INFO",
    // By default we silence the logger. In tests we should call `configureLogger`
    // below to set silence: false.
    silence: true
});
const $aab880b0cdc93953$export$bfcc8eb13073c803 = (config)=>$aab880b0cdc93953$export$af88d00dbe7f521.configure(config);
function $aab880b0cdc93953$export$1d1d2ed6b55cf67f(f, thisContext) {
    return function(...a) {
        const args = Array.prototype.slice.call(a);
        return new Promise(async (resolve, reject)=>{
            try {
                args.push((err, result)=>err ? reject(err) : resolve(result));
                await f.apply(thisContext, args);
            } catch (e) {
                reject(e);
            }
        });
    };
}
const $aab880b0cdc93953$export$b141de964f0a90c1 = (min = 0, max = Number.MAX_SAFE_INTEGER)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
function $aab880b0cdc93953$export$8c457054d13a5b92(name, obj) {
    const k = encodeURIComponent(name);
    const v = encodeURIComponent(JSON.stringify(obj));
    return `${k}=${v}`;
}
function $aab880b0cdc93953$export$7a9d6e0f60ae4fa5(qs) {
    const p = qs.split("&");
    const o = {};
    for (const v of p){
        const z = v.split("=");
        o[decodeURIComponent(z[0])] = JSON.parse(decodeURIComponent(z[1]));
    }
    return o;
}
// sanitizeNumberString accepts a number string and returns back a clean number string.
// For example, input '1234.5678' will return '1234.5678' but '12javascript:{}etc' will return '12'
const $aab880b0cdc93953$export$a0f048cb0d0c7042 = (numString)=>{
    if (!numString || typeof numString !== "string") return "";
    const v = numString.match(/[\d.]+/);
    return v && v.length > 0 ? v[0].trim() : "";
}; // sanitizeAlphanumeric accepts any string and returns alphanumeric contents only
const $aab880b0cdc93953$export$e18b071c4bb569a2 = (alphanum)=>{
    if (!alphanum || typeof alphanum !== "string") return "";
    const v = alphanum.match(/[\w\s\d]+/);
    return v && v.length > 0 ? v[0].trim() : "";
}; // sanitizeHost accepts any string and returns valid host string
const $aab880b0cdc93953$export$aa54acd7f8af8621 = (host)=>{
    if (!host || typeof host !== "string") return "";
    const v = host.match(/[\w\d.\-:\/]+/);
    return v && v.length > 0 ? v[0].trim() : "";
};
const $aab880b0cdc93953$export$e772c8ff12451969 = (t)=>{
    return new Promise((resolve)=>{
        const timeout = setTimeout(()=>{
            clearTimeout(timeout);
            resolve();
        }, t);
    });
};
const $aab880b0cdc93953$export$bc0d2b629fd05aca = (typedData)=>{
    const types = $aab880b0cdc93953$var$_extends({}, typedData.types); // remove EIP712Domain key from types as ethers will auto-gen it in
    // the hash encoder below
    delete types["EIP712Domain"];
    return (0, $6c57cc56acea9c6c$exports).utils._TypedDataEncoder.hash(typedData.domain, types, typedData.message);
};
const $aab880b0cdc93953$export$3b46c4bc31cc815c = (typedData)=>{
    return (0, $6c57cc56acea9c6c$exports).utils.arrayify($aab880b0cdc93953$export$bc0d2b629fd05aca(typedData));
};
// urlClean removes double slashes from url path
const $aab880b0cdc93953$export$27616982e8da1a23 = (url)=>url.replace(/([^:]\/)\/+/g, "$1");
function $aab880b0cdc93953$export$a3d0a7fa9b65683b(value) {
    return value != null && ((0, $ef87335f524ab6ee$export$d97aa349ed20696).isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $1c38d8340004597f$exports.isHexString)(value) || typeof value === "bigint" || (0, $1c38d8340004597f$exports.isBytes)(value));
}




parcelRequire("bsYBY");
var $jviUl = parcelRequire("jviUl");
function $4c7872e0fa8555c0$var$_extends() {
    $4c7872e0fa8555c0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c7872e0fa8555c0$var$_extends.apply(this, arguments);
}
function $4c7872e0fa8555c0$export$4efe34b90e15b008(cand) {
    return cand && cand.chainId !== undefined && cand.name !== undefined && cand.rpcUrl !== undefined && cand.relayer !== undefined;
}
const $4c7872e0fa8555c0$export$850fa7b3891187c = (chainId)=>{
    if (typeof chainId === "number") return chainId;
    if (chainId.chainId) return chainId.chainId;
    return (0, $6c57cc56acea9c6c$exports).BigNumber.from(chainId).toNumber();
};
const $4c7872e0fa8555c0$export$3df1bf540c0d5d9 = (chainId)=>{
    if (!chainId) return undefined;
    return $4c7872e0fa8555c0$export$850fa7b3891187c(chainId);
};
const $4c7872e0fa8555c0$export$ddf8eae6c8f26ab4 = (networks)=>{
    return networks.find((network)=>network.isAuthChain);
};
const $4c7872e0fa8555c0$export$33bc2da361d02aa3 = (networkConfig, raise = false, skipRelayerCheck = false)=>{
    if (!networkConfig) throw new Error(`invalid network config: empty config`);
    const configs = [];
    if (Array.isArray(networkConfig)) configs.push(...networkConfig);
    else configs.push(networkConfig);
    if (configs.length === 0) {
        if (raise) throw new Error(`invalid network config: empty config`);
        return false;
    } // Ensure distinct chainId configs
    const chainIds = configs.map((c)=>c.chainId).sort();
    const dupes = chainIds.filter((c, i)=>chainIds.indexOf(c) !== i);
    if (dupes.length > 0) {
        if (raise) throw new Error(`invalid network config: duplicate chainIds ${dupes}`);
        return false;
    } // Downcase all network names
    configs.forEach((c)=>c.name = c.name.toLowerCase()); // Ensure distinct network names
    const names = configs.map((c)=>c.name).sort();
    const nameDupes = names.filter((c, i)=>names.indexOf(c) !== i);
    if (nameDupes.length > 0) {
        if (raise) throw new Error(`invalid network config: duplicate network names ${nameDupes}`);
        return false;
    } // Ensure rpcUrl or provider is specified
    // Ensure relayerUrl or relayer is specified
    // Ensure one default chain
    // Ensure one auth chain
    let defaultChain = false;
    let authChain = false;
    for(let i = 0; i < configs.length; i++){
        const c = configs[i];
        if ((!c.rpcUrl || c.rpcUrl === "") && !c.provider) {
            if (raise) throw new Error(`invalid network config for chainId ${c.chainId}: rpcUrl or provider must be provided`);
            return false;
        }
        if (!skipRelayerCheck) {
            if (!c.relayer) {
                if (raise) throw new Error(`invalid network config for chainId ${c.chainId}: relayer must be provided`);
                return false;
            }
        }
        if (c.isDefaultChain) {
            if (defaultChain) {
                if (raise) throw new Error(`invalid network config for chainId ${c.chainId}: DefaultChain is already set by another config`);
                return false;
            }
            defaultChain = true;
        }
        if (c.isAuthChain) {
            if (authChain) {
                if (raise) throw new Error(`invalid network config for chainId ${c.chainId}: AuthChain is already set by another config`);
            }
            authChain = true;
        }
    }
    if (!defaultChain) {
        if (raise) throw new Error(`invalid network config: DefaultChain must be set`);
        return false;
    }
    if (!authChain) {
        if (raise) throw new Error(`invalid network config: AuthChain must be set`);
        return false;
    }
    return true;
};
const $4c7872e0fa8555c0$export$11a4cc74d78d287a = (networks, skipRelayerCheck = false)=>{
    $4c7872e0fa8555c0$export$33bc2da361d02aa3(networks, true, skipRelayerCheck);
    return networks;
};
const $4c7872e0fa8555c0$export$b3c7ba4fff8de6cb = (networks, raise = true)=>{
    const chainIds = networks.map((c)=>c.chainId).sort();
    const dupes = chainIds.filter((c, i)=>chainIds.indexOf(c) !== i);
    if (dupes.length > 0) {
        if (raise) throw new Error(`invalid network config: duplicate chainIds ${dupes}`);
        return false;
    }
    return true;
};
const $4c7872e0fa8555c0$export$63e63ec4586fdd63 = (src, dest)=>{
    if (!src || !dest) return;
    if (!src.chainId && !src.name) throw new Error("failed to update network config: source config is missing chainId or name");
    if (src.chainId !== dest.chainId && src.name !== dest.name) throw new Error("failed to update network config: one of chainId or name must match");
    if (src.rpcUrl) {
        dest.rpcUrl = src.rpcUrl;
        dest.provider = undefined;
    }
    if (src.provider) dest.provider = src.provider;
    if (src.relayer) dest.relayer = src.relayer;
    if (src.ensAddress) dest.ensAddress = src.ensAddress;
     // NOTE: we do not set default or auth chain from here
// if (src.isDefaultChain) {
//   dest.isDefaultChain = src.isDefaultChain
// }
// if (src.isAuthChain) {
//   dest.isAuthChain = src.isAuthChain
// }
};
const $4c7872e0fa8555c0$export$5f2f200f4bc7d6e7 = (networks, defaultChainId, vars)=>{
    let config = [];
    if (typeof networks === "function" && vars) config = networks(vars);
    else config = networks;
    if (defaultChainId) {
        config.forEach((n)=>n.isDefaultChain = false);
        const mainNetwork = config.filter((n)=>n.chainId === defaultChainId);
        if (!mainNetwork || mainNetwork.length === 0) throw new Error(`defaultChainId ${defaultChainId} cannot be found in network list`);
        else mainNetwork[0].isDefaultChain = true;
    }
    return $4c7872e0fa8555c0$export$11a4cc74d78d287a($4c7872e0fa8555c0$export$bf2a2a8ffb1b859a(config));
};
const $4c7872e0fa8555c0$export$633a5164a4c93be5 = (networks, chainId)=>{
    if (typeof chainId === "string") {
        if (chainId.startsWith("0x")) {
            const id = (0, $6c57cc56acea9c6c$exports).BigNumber.from(chainId).toNumber();
            return networks.find((n)=>n.chainId === id);
        } else return networks.find((n)=>n.name === chainId);
    } else if (typeof chainId === "number") return networks.find((n)=>n.chainId === chainId);
    else if (chainId.chainId) return networks.find((n)=>n.chainId === chainId.chainId);
    else return undefined;
};
const $4c7872e0fa8555c0$export$4318fddf9be20373 = (network, chainId)=>{
    if (!network) return false;
    if (network.name === chainId) return true;
    if (network.chainId === chainId) return true;
    return false;
};
const $4c7872e0fa8555c0$export$24e1a0d27cd0851e = (networks)=>{
    const index = {};
    for(let i = 0; i < networks.length; i++)index[networks[i].name] = networks[i];
    return index;
}; // TODO: we should remove sortNetworks in the future but this is a breaking change for dapp integrations on older versions <-> wallet
// sortNetworks orders the network config list by: defaultChain, authChain, ..rest by chainId ascending numbers
const $4c7872e0fa8555c0$export$bf2a2a8ffb1b859a = (networks)=>{
    if (!networks) return [];
    const config = networks.sort((a, b)=>{
        if (a.chainId === b.chainId) return 0;
        return a.chainId < b.chainId ? -1 : 1;
    }); // DefaultChain goes first
    const defaultConfigIdx = config.findIndex((c)=>c.isDefaultChain);
    if (defaultConfigIdx > 0) config.splice(0, 0, config.splice(defaultConfigIdx, 1)[0]); // AuthChain goes second
    const authConfigIdx = config.findIndex((c)=>c.isAuthChain && c.isDefaultChain !== true);
    if (authConfigIdx > 0) config.splice(1, 0, config.splice(authConfigIdx, 1)[0]);
    return config;
};
let $4c7872e0fa8555c0$export$c06e1e7429de6283;
(function(ChainId) {
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["ROPSTEN"] = 3] = "ROPSTEN";
    ChainId[ChainId["RINKEBY"] = 4] = "RINKEBY";
    ChainId[ChainId["GOERLI"] = 5] = "GOERLI";
    ChainId[ChainId["KOVAN"] = 42] = "KOVAN";
    ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
    ChainId[ChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["BSC_TESTNET"] = 97] = "BSC_TESTNET";
    ChainId[ChainId["OPTIMISM"] = 10] = "OPTIMISM";
    ChainId[ChainId["OPTIMISM_TESTNET"] = 69] = "OPTIMISM_TESTNET";
    ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
    ChainId[ChainId["ARBITRUM_TESTNET"] = 421611] = "ARBITRUM_TESTNET";
    ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
    ChainId[ChainId["AVALANCHE_TESTNET"] = 43113] = "AVALANCHE_TESTNET";
    ChainId[ChainId["FANTOM"] = 250] = "FANTOM";
    ChainId[ChainId["FANTOM_TESTNET"] = 4002] = "FANTOM_TESTNET";
    ChainId[ChainId["GNOSIS"] = 100] = "GNOSIS";
    ChainId[ChainId["AURORA"] = 1313161554] = "AURORA";
    ChainId[ChainId["AURORA_TESTNET"] = 1313161556] = "AURORA_TESTNET";
})($4c7872e0fa8555c0$export$c06e1e7429de6283 || ($4c7872e0fa8555c0$export$c06e1e7429de6283 = {}));
const $4c7872e0fa8555c0$export$f09b1917886389c3 = {
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.MAINNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.MAINNET,
        name: "mainnet",
        title: "Ethereum",
        blockExplorer: {
            name: "Etherscan",
            rootUrl: "https://etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.ROPSTEN]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.ROPSTEN,
        name: "ropsten",
        title: "Ropsten",
        testnet: true,
        blockExplorer: {
            name: "Etherscan (Ropsten)",
            rootUrl: "https://ropsten.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.RINKEBY]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.RINKEBY,
        name: "rinkeby",
        title: "Rinkeby",
        testnet: true,
        blockExplorer: {
            name: "Etherscan (Rinkeby)",
            rootUrl: "https://rinkeby.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.GOERLI]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.GOERLI,
        name: "goerli",
        title: "Goerli",
        testnet: true,
        blockExplorer: {
            name: "Etherscan (Goerli)",
            rootUrl: "https://goerli.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.KOVAN]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.KOVAN,
        name: "kovan",
        title: "Kovan",
        testnet: true,
        blockExplorer: {
            name: "Etherscan (Kovan)",
            rootUrl: "https://kovan.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.POLYGON]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.POLYGON,
        name: "polygon",
        title: "Polygon",
        blockExplorer: {
            name: "Polygonscan",
            rootUrl: "https://polygonscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.POLYGON_MUMBAI]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.POLYGON_MUMBAI,
        name: "mumbai",
        title: "Polygon Mumbai",
        testnet: true,
        blockExplorer: {
            name: "Polygonscan (Mumbai)",
            rootUrl: "https://mumbai.polygonscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.BSC]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.BSC,
        name: "bsc",
        title: "BNB Smart Chain",
        blockExplorer: {
            name: "BSCScan",
            rootUrl: "https://bscscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.BSC_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.BSC_TESTNET,
        name: "bsc-testnet",
        title: "BNB Smart Chain Testnet",
        testnet: true,
        blockExplorer: {
            name: "BSCScan (Testnet)",
            rootUrl: "https://testnet.bscscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.OPTIMISM]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.OPTIMISM,
        name: "optimism",
        title: "Optimism",
        blockExplorer: {
            name: "Etherscan (Optimism)",
            rootUrl: "https://optimistic.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.OPTIMISM_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.OPTIMISM_TESTNET,
        name: "optimism-testnet",
        title: "Optimistic Kovan",
        testnet: true,
        blockExplorer: {
            name: "Etherscan (Optimism Testnet)",
            rootUrl: "https://kovan-optimistic.etherscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.ARBITRUM]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.ARBITRUM,
        name: "arbitrum",
        title: "Arbitrum",
        blockExplorer: {
            name: "Arbiscan",
            rootUrl: "https://arbiscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.ARBITRUM_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.ARBITRUM_TESTNET,
        name: "arbitrum-testnet",
        title: "Arbitrum Testnet",
        testnet: true,
        blockExplorer: {
            name: "Arbiscan (Testnet)",
            rootUrl: "https://testnet.arbiscan.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.AVALANCHE]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.AVALANCHE,
        name: "avalanche",
        title: "Avalanche",
        blockExplorer: {
            name: "Snowtrace",
            rootUrl: "https://snowtrace.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.AVALANCHE_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.AVALANCHE_TESTNET,
        name: "avalanche-testnet",
        title: "Avalanche Testnet",
        testnet: true,
        blockExplorer: {
            name: "Snowtrace (Testnet)",
            rootUrl: "https://testnet.snowtrace.io/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.FANTOM]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.FANTOM,
        name: "fantom",
        title: "Fantom",
        blockExplorer: {
            name: "FTMScan",
            rootUrl: "https://ftmscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.FANTOM_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.FANTOM_TESTNET,
        name: "fantom-testnet",
        title: "Fantom Testnet",
        testnet: true,
        blockExplorer: {
            name: "FTMScan (Testnet)",
            rootUrl: "https://testnet.ftmscan.com/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.GNOSIS]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.GNOSIS,
        name: "gnosis",
        title: "Gnosis Chain",
        blockExplorer: {
            name: "Gnosis Chain Explorer",
            rootUrl: "https://blockscout.com/xdai/mainnet/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.AURORA]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.AURORA,
        name: "aurora",
        title: "Aurora",
        blockExplorer: {
            name: "Aurora Explorer",
            rootUrl: "https://aurorascan.dev/"
        }
    },
    [$4c7872e0fa8555c0$export$c06e1e7429de6283.AURORA_TESTNET]: {
        chainId: $4c7872e0fa8555c0$export$c06e1e7429de6283.AURORA_TESTNET,
        name: "aurora-testnet",
        title: "Aurora Testnet",
        blockExplorer: {
            name: "Aurora Explorer (Testnet)",
            rootUrl: "https://testnet.aurorascan.dev/"
        }
    }
};
const $4c7872e0fa8555c0$export$5bc2c6d7ba77f072 = $4c7872e0fa8555c0$export$5f2f200f4bc7d6e7((vars)=>[
        $4c7872e0fa8555c0$var$_extends({}, $4c7872e0fa8555c0$export$f09b1917886389c3[$4c7872e0fa8555c0$export$c06e1e7429de6283.MAINNET], {
            ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
            rpcUrl: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRpcUrl}/mainnet`),
            relayer: {
                url: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRelayerUrl}/mainnet`)
            },
            isDefaultChain: true
        }),
        $4c7872e0fa8555c0$var$_extends({}, $4c7872e0fa8555c0$export$f09b1917886389c3[$4c7872e0fa8555c0$export$c06e1e7429de6283.POLYGON], {
            rpcUrl: "https://rpc-mainnet.matic.network",
            relayer: {
                url: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRelayerUrl}/matic`)
            },
            isAuthChain: true
        })
    ], 1, {
    baseRpcUrl: "https://nodes.sequence.app",
    baseRelayerUrl: "https://relayers.sequence.app"
});
const $4c7872e0fa8555c0$export$e70a7f30d6fac7e4 = $4c7872e0fa8555c0$export$5f2f200f4bc7d6e7((vars)=>[
        $4c7872e0fa8555c0$var$_extends({}, $4c7872e0fa8555c0$export$f09b1917886389c3[$4c7872e0fa8555c0$export$c06e1e7429de6283.RINKEBY], {
            ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
            rpcUrl: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRpcUrl}/rinkeby`),
            relayer: {
                url: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRelayerUrl}/rinkeby`)
            },
            isDefaultChain: true
        }),
        $4c7872e0fa8555c0$var$_extends({}, $4c7872e0fa8555c0$export$f09b1917886389c3[$4c7872e0fa8555c0$export$c06e1e7429de6283.GOERLI], {
            ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
            rpcUrl: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRpcUrl}/goerli`),
            relayer: {
                url: (0, $aab880b0cdc93953$export$27616982e8da1a23)(`${vars.baseRelayerUrl}/goerli`)
            },
            isAuthChain: true
        })
    ], undefined, {
    baseRpcUrl: "https://nodes.sequence.app",
    baseRelayerUrl: "https://relayers.sequence.app"
});
// WalletContext is the module addresses deployed on a network, aka the context / environment
// of the Sequence Smart Wallet system on Ethereum.
// sequenceContext are the deployed addresses of modules available on public networks.
const $4c7872e0fa8555c0$export$b69595cafb175950 = {
    factory: "0xf9D09D634Fb818b05149329C1dcCFAeA53639d96",
    mainModule: "0xd01F11855bCcb95f88D7A48492F66410d4637313",
    mainModuleUpgradable: "0x7EFE6cE415956c5f80C6530cC6cc81b4808F6118",
    guestModule: "0x02390F3E6E5FD1C6786CB78FD3027C117a9955A7",
    sequenceUtils: "0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E",
    libs: {
        requireFreshSigner: "0xE6B9B21C077F382333220a072e4c44280b873907"
    }
};
const $4c7872e0fa8555c0$export$d5468ab7f0da6733 = "2.0";
class $4c7872e0fa8555c0$export$6f1fd3054ec931c0 {
    constructor(middlewares, sender){
        this.sender = void 0;
        this.handler = void 0;
        this.sender = sender;
        if (middlewares) this.setMiddleware(middlewares);
    }
    setMiddleware(middlewares) {
        this.handler = $4c7872e0fa8555c0$export$a7b818da06e65a72(middlewares, this.sender.sendAsync);
    }
    sendAsync(request, callback, chainId) {
        try {
            this.handler(request, callback, chainId);
        } catch (err) {
            callback(err, undefined);
        }
    }
}
const $4c7872e0fa8555c0$export$a7b818da06e65a72 = (middlewares, handler)=>{
    if (middlewares.length === 0) return handler;
    const toMiddleware = (v)=>{
        if (v.sendAsyncMiddleware) return v.sendAsyncMiddleware;
        else return v;
    };
    let chain;
    chain = toMiddleware(middlewares[middlewares.length - 1])(handler);
    for(let i = middlewares.length - 2; i >= 0; i--)chain = toMiddleware(middlewares[i])(chain);
    return chain;
};
function $4c7872e0fa8555c0$export$82b55c3b548b6ecf(cand) {
    return cand !== undefined && cand.send !== undefined && cand.constructor.defaultUrl !== undefined && cand.detectNetwork !== undefined && cand.getSigner !== undefined && cand.perform !== undefined;
}
function $4c7872e0fa8555c0$export$505cb9b7e53019e7(cand) {
    return cand !== undefined && cand.sendAsync !== undefined;
}
let $4c7872e0fa8555c0$var$_nextId = 0;
class $4c7872e0fa8555c0$export$5521fc760005bde6 {
    constructor(provider, defaultChainId){
        this.send = void 0;
        this.request = void 0;
        this.defaultChainId = void 0;
        this.sendAsync = (request, callback, chainId)=>{
            this.send(request.method, request.params, chainId || this.defaultChainId).then((r)=>{
                callback(undefined, {
                    jsonrpc: "2.0",
                    id: request.id,
                    result: r
                });
            }).catch((e)=>{
                callback(e, undefined);
            });
        };
        this.defaultChainId = defaultChainId;
        if ($4c7872e0fa8555c0$export$82b55c3b548b6ecf(provider)) // we can ignore defaultChainId for JsonRpcProviders as they are already chain-bound
        this.send = provider.send.bind(provider);
        else if ($4c7872e0fa8555c0$export$505cb9b7e53019e7(provider)) this.send = (method, params, chainId)=>{
            return new Promise((resolve, reject)=>{
                provider.sendAsync({
                    // TODO: really shouldn't have to set these here?
                    jsonrpc: $4c7872e0fa8555c0$export$d5468ab7f0da6733,
                    id: ++$4c7872e0fa8555c0$var$_nextId,
                    method: method,
                    params: params
                }, (error, response)=>{
                    if (error) reject(error);
                    else if (response) resolve(response.result);
                    else resolve(undefined);
                }, chainId || this.defaultChainId);
            });
        };
        else this.send = provider;
        this.request = (request, chainId)=>{
            return this.send(request.method, request.params, chainId);
        };
    }
}
class $4c7872e0fa8555c0$export$79572dcf3587ff20 {
    constructor(provider){
        this.provider = provider;
        this.sendAsync = (request, callback)=>{
            this.provider.send(request.method, request.params).then((r)=>{
                callback(undefined, {
                    jsonrpc: "2.0",
                    id: request.id,
                    result: r
                });
            }).catch((e)=>{
                callback(e, undefined);
            });
        };
        this.send = this.sendAsync;
    }
}
class $4c7872e0fa8555c0$export$8054803cbc9ced1f {
    constructor(isAllowedFunc){
        this.sendAsyncMiddleware = void 0;
        this.isAllowedFunc = void 0;
        if (isAllowedFunc) this.isAllowedFunc = isAllowedFunc;
        else this.isAllowedFunc = (request)=>true;
        this.sendAsyncMiddleware = $4c7872e0fa8555c0$export$294869a601d6bea8(this.isAllowedFunc);
    }
    setIsAllowedFunc(fn) {
        this.isAllowedFunc = fn;
        this.sendAsyncMiddleware = $4c7872e0fa8555c0$export$294869a601d6bea8(this.isAllowedFunc);
    }
}
const $4c7872e0fa8555c0$export$294869a601d6bea8 = (isAllowed)=>(next)=>{
        return (request, callback, chainId)=>{
            // ensure precondition is met or do not allow the request to continue
            if (!isAllowed(request)) throw new Error("allowProvider middleware precondition is unmet.");
             // request is allowed. keep going..
            next(request, callback, chainId);
        };
    };
class $4c7872e0fa8555c0$export$8bafd260baf867d {
    constructor(defaultChainId){
        this.cachableJsonRpcMethods = [
            "net_version",
            "eth_chainId",
            "eth_accounts",
            "sequence_getWalletContext",
            "sequence_getNetworks"
        ];
        this.cache = void 0;
        this.onUpdateCallback = void 0;
        this.defaultChainId = void 0;
        this.sendAsyncMiddleware = (next)=>{
            return (request, callback, chainId)=>{
                // Respond early with cached result
                if (this.cachableJsonRpcMethods.includes(request.method)) {
                    const key = this.cacheKey(request.method, request.params, chainId || this.defaultChainId);
                    const result = this.getCacheValue(key);
                    if (result && result !== "") {
                        callback(undefined, {
                            jsonrpc: "2.0",
                            id: request.id,
                            result: result
                        });
                        return;
                    }
                } // Continue down the handler chain
                next(request, (error, response, chainId)=>{
                    // Store result in cache and continue
                    if (this.cachableJsonRpcMethods.includes(request.method)) {
                        if (response && response.result) {
                            const key = this.cacheKey(request.method, request.params, chainId || this.defaultChainId);
                            this.setCacheValue(key, response.result);
                        }
                    } // Exec next handler
                    callback(error, response);
                }, chainId || this.defaultChainId);
            };
        };
        this.cacheKey = (method, params, chainId)=>{
            let key = "";
            if (chainId) key = `${chainId}:${method}:`;
            else key = `:${method}:`;
            if (!params || params.length === 0) return key + "[]";
            return key + JSON.stringify(params);
        };
        this.getCache = ()=>this.cache;
        this.setCache = (cache)=>{
            this.cache = cache;
            if (this.onUpdateCallback) this.onUpdateCallback();
        };
        this.getCacheValue = (key)=>{
            return this.cache[key];
        };
        this.setCacheValue = (key, value)=>{
            this.cache[key] = value;
            if (this.onUpdateCallback) this.onUpdateCallback(key, value);
        };
        this.clearCache = ()=>{
            this.cache = {};
        };
        this.cache = {};
        this.defaultChainId = defaultChainId;
    }
    onUpdate(callback) {
        this.onUpdateCallback = callback;
    }
}
class $4c7872e0fa8555c0$export$22b98dd59b44e3d6 {
    constructor(props){
        this.props = void 0;
        this.sendAsyncMiddleware = (next)=>{
            return (request, callback, chainId)=>{
                const { id: id, method: method } = request;
                switch(method){
                    case "net_version":
                        if (this.props.chainId) {
                            callback(undefined, {
                                jsonrpc: "2.0",
                                id: id,
                                result: `${this.props.chainId}`
                            });
                            return;
                        }
                        break;
                    case "eth_chainId":
                        if (this.props.chainId) {
                            callback(undefined, {
                                jsonrpc: "2.0",
                                id: id,
                                result: (0, $6c57cc56acea9c6c$exports).utils.hexlify(this.props.chainId)
                            });
                            return;
                        }
                        break;
                    case "eth_accounts":
                        if (this.props.accountAddress) {
                            callback(undefined, {
                                jsonrpc: "2.0",
                                id: id,
                                result: [
                                    (0, $6c57cc56acea9c6c$exports).utils.getAddress(this.props.accountAddress)
                                ]
                            });
                            return;
                        }
                        break;
                    case "sequence_getWalletContext":
                        if (this.props.walletContext) {
                            callback(undefined, {
                                jsonrpc: "2.0",
                                id: id,
                                result: this.props.walletContext
                            });
                            return;
                        }
                        break;
                }
                next(request, callback, chainId);
            };
        };
        this.props = props;
    }
}
const $4c7872e0fa8555c0$export$c5c11e86f1832586 = (next)=>{
    return (request, callback, chainId)=>{
        next(request, (error, response)=>{
            if (!error && response && response.error) {
                if (typeof response.error === "string") throw new Error(response.error);
                else throw new Error(response.error.message);
            }
            callback(error, response);
        }, chainId);
    };
};
const $4c7872e0fa8555c0$export$a7b7a42ec4483512 = (next)=>{
    return (request, callback, chainId)=>{
        const chainIdLabel = chainId ? ` chainId:${chainId}` : "";
        (0, $aab880b0cdc93953$export$af88d00dbe7f521).info(`[provider request]${chainIdLabel} id:${request.id} method:${request.method} params:`, request.params);
        next(request, (error, response)=>{
            if (error) (0, $aab880b0cdc93953$export$af88d00dbe7f521).warn(`[provider response]${chainIdLabel} id:${request.id} method:${request.method} params:`, request.params, `error:`, error);
            else (0, $aab880b0cdc93953$export$af88d00dbe7f521).info(`[provider response]${chainIdLabel} id:${request.id} method:${request.method} params:`, request.params, `response:`, response);
            callback(error, response);
        }, chainId);
    };
};
const $4c7872e0fa8555c0$export$7e2a4348fc416527 = (getChainId)=>(next)=>{
        return (request, callback, chainId)=>{
            const networkChainId = getChainId(request);
            const { id: id, method: method } = request;
            switch(method){
                case "net_version":
                    callback(undefined, {
                        jsonrpc: "2.0",
                        id: id,
                        result: `${networkChainId}`
                    });
                    return;
                case "eth_chainId":
                    callback(undefined, {
                        jsonrpc: "2.0",
                        id: id,
                        result: (0, $6c57cc56acea9c6c$exports).utils.hexlify(networkChainId)
                    });
                    return;
            } // request is allowed. keep going..
            next(request, callback, chainId);
        };
    };
const $4c7872e0fa8555c0$var$SignerJsonRpcMethods = [
    "personal_sign",
    "eth_sign",
    "eth_signTypedData",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "eth_sendRawTransaction",
    "sequence_getWalletContext",
    "sequence_getWalletConfig",
    "sequence_getWalletState",
    "sequence_getNetworks",
    "sequence_updateConfig",
    "sequence_publishConfig",
    "sequence_estimateGasLimits",
    "sequence_gasRefundOptions",
    "sequence_getNonce",
    "sequence_relay",
    "eth_decrypt",
    "eth_getEncryptionPublicKey",
    "wallet_addEthereumChain",
    "wallet_switchEthereumChain",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
];
class $4c7872e0fa8555c0$export$47c92f5d149657f1 {
    constructor(provider){
        this.provider = void 0;
        this.sendAsyncMiddleware = (next)=>{
            return (request, callback, chainId)=>{
                // Forward signing requests to the signing provider
                if ($4c7872e0fa8555c0$var$SignerJsonRpcMethods.includes(request.method)) {
                    this.provider.sendAsync(request, callback, chainId);
                    return;
                } // Continue to next handler
                next(request, callback, chainId);
            };
        };
        this.provider = provider;
    }
}
class $4c7872e0fa8555c0$export$fa9139cb0ba53f90 {
    constructor(rpcUrl){
        this.privateJsonRpcMethods = [
            "net_version",
            "eth_chainId",
            "eth_accounts",
            ...$4c7872e0fa8555c0$var$SignerJsonRpcMethods
        ];
        this.provider = void 0;
        this.rpcUrl = void 0;
        this.sendAsyncMiddleware = (next)=>{
            return (request, callback)=>{
                // When provider is configured, send non-private methods to our local public provider
                if (this.provider && !this.privateJsonRpcMethods.includes(request.method)) {
                    this.provider.send(request.method, request.params).then((r)=>{
                        callback(undefined, {
                            jsonrpc: "2.0",
                            id: request.id,
                            result: r
                        });
                    }).catch((e)=>callback(e));
                    return;
                } // Continue to next handler
                (0, $aab880b0cdc93953$export$af88d00dbe7f521).debug("[public-provider] sending request to signer window", request.method);
                next(request, callback);
            };
        };
        if (rpcUrl) this.setRpcUrl(rpcUrl);
    }
    getRpcUrl() {
        return this.rpcUrl;
    }
    setRpcUrl(rpcUrl) {
        if (!rpcUrl || rpcUrl === "") {
            this.rpcUrl = undefined;
            this.provider = undefined;
        } else {
            this.rpcUrl = rpcUrl;
            this.provider = new (0, $jviUl.JsonRpcProvider)(rpcUrl);
        }
    }
}


function $13fa0b022f77d6d4$var$_extends() {
    $13fa0b022f77d6d4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $13fa0b022f77d6d4$var$_extends.apply(this, arguments);
}
let $13fa0b022f77d6d4$var$JsonRpcMethod;
(function(JsonRpcMethod) {
    JsonRpcMethod["ethCall"] = "eth_call";
    JsonRpcMethod["ethGetBalance"] = "eth_getBalance";
    JsonRpcMethod["ethGetCode"] = "eth_getCode";
})($13fa0b022f77d6d4$var$JsonRpcMethod || ($13fa0b022f77d6d4$var$JsonRpcMethod = {}));
async function $13fa0b022f77d6d4$var$safeSolve(promise, def) {
    try {
        return await promise;
    } catch (e) {
        const d = def instanceof Function ? def(e) : def;
        return d;
    }
}
function $13fa0b022f77d6d4$var$partition(array, callback) {
    return array.reduce(function(result, element, i) {
        callback(element, i) ? result[0].push(element) : result[1].push(element);
        return result;
    }, [
        [],
        []
    ]);
}
function $13fa0b022f77d6d4$var$parseBlockTag(cand) {
    if (cand === undefined) return "latest";
    switch(cand){
        case "earliest":
        case "latest":
        case "pending":
            return cand;
    }
    return (0, $ef87335f524ab6ee$export$d97aa349ed20696).from(cand);
}
function $13fa0b022f77d6d4$var$eqBlockTag(a, b) {
    if (a === b) return true;
    if ((0, $ef87335f524ab6ee$export$d97aa349ed20696).isBigNumber(a)) {
        if ((0, $ef87335f524ab6ee$export$d97aa349ed20696).isBigNumber(b)) return a.eq(b);
        return false;
    }
    if ((0, $ef87335f524ab6ee$export$d97aa349ed20696).isBigNumber(b)) return false;
    return a === b;
}
const $13fa0b022f77d6d4$var$DefaultMulticallOptions = {
    batchSize: 50,
    timeWindow: 50,
    contract: (0, $4c7872e0fa8555c0$export$b69595cafb175950).sequenceUtils,
    verbose: false
};
class $13fa0b022f77d6d4$export$74fd984ae9c44cf0 {
    constructor(options){
        var _this = this;
        this.batchableJsonRpcMethods = [
            $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall,
            $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode,
            $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance
        ];
        this.multicallInterface = new (0, $6c57cc56acea9c6c$exports).utils.Interface((0, $2f309fd939ca7757$export$5b3e72131e84edcc).sequenceUtils.abi);
        this.options = void 0;
        this.timeout = void 0;
        this.queue = [];
        this.scheduleExecution = ()=>{
            if (this.queue.length > 0) {
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(this.run, this.options.timeWindow);
            }
        };
        this.handle = (next, request, callback)=>{
            // Schedule for batching and return
            if (this.batchableJsonRpcMethods.find((m)=>m === request.method)) {
                this.queue.push({
                    request: request,
                    callback: callback,
                    next: next
                });
                if (this.options.verbose) console.log("Scheduling call", request.method);
                this.scheduleExecution();
                return;
            }
            if (this.options.verbose) console.log("Forwarded call", request.method); // Move to next handler
            return next(request, callback);
        };
        this.run = async function() {
            /* eslint-disable no-var */ if (_this.options.verbose) console.log("Processing multicall"); // Read items from queue
            const limit = Math.min(_this.options.batchSize, _this.queue.length);
            if (limit === 0) return; // Skip multicall on single item
            if (limit === 1) {
                _this.forward(_this.queue[0]);
                _this.queue = [];
                if (_this.options.verbose) console.log("Skip multicall, single item");
                return;
            }
            if (_this.options.verbose) console.log("Resolving", limit); // Get batch from queue
            var items = _this.queue.slice(0, limit); // Update queue
            _this.queue = limit === _this.queue.length ? [] : _this.queue.slice(limit);
            if (_this.options.verbose) console.log("Updated queue", _this.queue.length);
            if (_this.queue.length !== 0) _this.scheduleExecution();
             // Get next candidate
            const next = items[0].next;
            let blockTag; // Partition incompatible calls
            var [items, discartItems] = $13fa0b022f77d6d4$var$partition(items, (item)=>{
                try {
                    // Mixed next callbacks
                    if (item.next !== next) return false;
                    switch(item.request.method){
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall:
                            // Unsupported eth_call parameters
                            if (item.request.params[0].from || item.request.params[0].gasPrice || item.request.params[0].value) return false;
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance:
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode:
                            // Mixed blockTags
                            const itemBlockTag = $13fa0b022f77d6d4$var$parseBlockTag(item.request.params[1]);
                            if (blockTag === undefined) blockTag = itemBlockTag;
                            if (!$13fa0b022f77d6d4$var$eqBlockTag(itemBlockTag, blockTag)) return false;
                    }
                    return true;
                } catch (_unused) {
                    return false;
                }
            }); // Forward discarted items
            // end execution if no items remain
            if (discartItems.length !== 0) {
                if (_this.options.verbose) console.log("Forwarding incompatible calls", discartItems.length);
                _this.forward(discartItems);
                if (items.length === 0) return;
            } // Aggregate all calls
            let callParams = items.map((v)=>{
                try {
                    switch(v.request.method){
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall:
                            return {
                                delegateCall: false,
                                revertOnError: false,
                                target: v.request.params[0].to,
                                data: v.request.params[0].data,
                                gasLimit: v.request.params[0].gas ? v.request.params[0].gas : 0,
                                value: 0
                            };
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode:
                            return {
                                delegateCall: false,
                                revertOnError: false,
                                target: _this.options.contract,
                                gasLimit: 0,
                                value: 0,
                                data: _this.multicallInterface.encodeFunctionData(_this.multicallInterface.getFunction("callCode"), [
                                    v.request.params[0]
                                ])
                            };
                        case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance:
                            return {
                                delegateCall: false,
                                revertOnError: false,
                                target: _this.options.contract,
                                gasLimit: 0,
                                value: 0,
                                data: _this.multicallInterface.encodeFunctionData(_this.multicallInterface.getFunction("callBalanceOf"), [
                                    v.request.params[0]
                                ])
                            };
                        default:
                            return null;
                    }
                } catch (_unused2) {
                    return null;
                }
            }); // Filter calls with enconding errors and forward items
            var [items, discartItems] = $13fa0b022f77d6d4$var$partition(items, (_, i)=>callParams[i] !== undefined);
            callParams = callParams.filter((c)=>c);
            if (discartItems.length !== 0) {
                if (_this.options.verbose) console.log("Forwarding calls on error", discartItems.length);
                _this.forward(discartItems);
                if (items.length === 0) return;
            } // Encode multicall
            let encodedCall;
            try {
                encodedCall = _this.multicallInterface.encodeFunctionData(_this.multicallInterface.getFunction("multiCall"), [
                    callParams
                ]);
            } catch (_unused3) {
                _this.forward(items);
                return;
            } // Forward single multicall rpc call
            const reqId = (0, $aab880b0cdc93953$export$b141de964f0a90c1)(); // TODO: fix types below..
            const res = await $13fa0b022f77d6d4$var$safeSolve((0, $aab880b0cdc93953$export$1d1d2ed6b55cf67f)(next)({
                id: reqId,
                jsonrpc: (0, $4c7872e0fa8555c0$export$d5468ab7f0da6733),
                method: $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall,
                params: [
                    {
                        to: _this.options.contract,
                        value: 0,
                        data: encodedCall
                    },
                    (0, $ef87335f524ab6ee$export$d97aa349ed20696).isBigNumber(blockTag) ? blockTag.toNumber() : blockTag
                ] // @ts-ignore
            }), (e)=>({
                    jsonrpc: (0, $4c7872e0fa8555c0$export$d5468ab7f0da6733),
                    id: reqId,
                    result: undefined,
                    error: e
                })); // Error calling multicall
            // Forward all calls to middleware
            // @ts-ignore
            if (res.error) return _this.forward(items);
             // Decode result from multicall
            let decoded;
            try {
                // @ts-ignore
                decoded = _this.multicallInterface.decodeFunctionResult(_this.multicallInterface.getFunction("multiCall"), res.result);
            } catch (_unused4) {
                _this.forward(items);
                return;
            } // Send results for each request
            // errors fallback through the middleware
            if (_this.options.verbose) console.log("Got response for", items.length);
            items.forEach((item, index)=>{
                if (!decoded[0][index]) _this.forward(item);
                else switch(item.request.method){
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall:
                        item.callback(undefined, {
                            jsonrpc: item.request.jsonrpc,
                            id: item.request.id,
                            result: decoded[1][index]
                        });
                        break;
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode:
                        item.callback(undefined, {
                            jsonrpc: item.request.jsonrpc,
                            id: item.request.id,
                            result: (0, $6c57cc56acea9c6c$exports).utils.defaultAbiCoder.decode([
                                "bytes"
                            ], decoded[1][index])[0]
                        });
                        break;
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance:
                        item.callback(undefined, {
                            jsonrpc: item.request.jsonrpc,
                            id: item.request.id,
                            result: (0, $6c57cc56acea9c6c$exports).utils.defaultAbiCoder.decode([
                                "uint256"
                            ], decoded[1][index])[0]
                        });
                        break;
                }
            });
        };
        this.options = options ? $13fa0b022f77d6d4$var$_extends({}, $13fa0b022f77d6d4$export$74fd984ae9c44cf0.DefaultOptions, options) : $13fa0b022f77d6d4$export$74fd984ae9c44cf0.DefaultOptions;
        if (this.options.batchSize <= 0) throw new Error(`Invalid batch size of ${this.options.batchSize}`);
    }
    forward(entries) {
        if (Array.isArray(entries)) entries.forEach((e)=>e.next(e.request, e.callback));
        else entries.next(entries.request, entries.callback);
    }
    static isMulticall(cand) {
        return cand && cand.handle !== undefined && cand.conf !== undefined && $13fa0b022f77d6d4$export$74fd984ae9c44cf0.isMulticallOptions(cand.options);
    }
    static isMulticallOptions(cand) {
        return cand !== undefined && cand.batchSize !== undefined && cand.timeWindow !== undefined && cand.contract !== undefined;
    }
}
$13fa0b022f77d6d4$export$74fd984ae9c44cf0.DefaultOptions = $13fa0b022f77d6d4$var$_extends({}, $13fa0b022f77d6d4$var$DefaultMulticallOptions);
const $13fa0b022f77d6d4$var$ProxyMethods = [
    "getNetwork",
    "getBlockNumber",
    "getGasPrice",
    "getTransactionCount",
    "getStorageAt",
    "sendTransaction",
    "estimateGas",
    "getBlock",
    "getTransaction",
    "getTransactionReceipt",
    "getLogs",
    "emit",
    "litenerCount",
    "addListener",
    "removeListener",
    "waitForTransaction",
    "detectNetwork",
    "getBlockWithTransactions"
];
class $13fa0b022f77d6d4$var$MulticallProvider extends (0, $6c57cc56acea9c6c$exports).providers.BaseProvider {
    constructor(provider, multicall){
        var _this;
        super(provider.getNetwork());
        _this = this;
        this.provider = provider;
        this.multicall = void 0;
        this.listenerCount = this.provider.listenerCount;
        this.getResolver = async function(name) {
            const provider = _this.provider;
            if (provider.getResolver) {
                const ogResolver = await provider.getResolver(await name);
                if (!ogResolver) return null;
                return new (0, $6c57cc56acea9c6c$exports).providers.Resolver(_this, ogResolver.address, ogResolver.name);
            }
            return provider.getResolver(await name);
        };
        this.next = async function(req, callback) {
            try {
                switch(req.method){
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethCall:
                        _this.callback(req, callback, await _this.provider.call(req.params[0], req.params[1]));
                        break;
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode:
                        _this.callback(req, callback, await _this.provider.getCode(req.params[0], req.params[1]));
                        break;
                    case $13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance:
                        _this.callback(req, callback, await _this.provider.getBalance(req.params[0], req.params[1]));
                        break;
                }
            } catch (e) {
                _this.callback(req, callback, undefined, e);
            }
        };
        this.multicall = $13fa0b022f77d6d4$export$74fd984ae9c44cf0.isMulticall(multicall) ? multicall : new $13fa0b022f77d6d4$export$74fd984ae9c44cf0(multicall);
        $13fa0b022f77d6d4$var$ProxyMethods.forEach((m)=>{
            if (provider[m] !== undefined) this[m] = (...args)=>provider[m](...args);
        });
    }
    callback(req, callback, resp, err) {
        callback(err, {
            jsonrpc: (0, $4c7872e0fa8555c0$export$d5468ab7f0da6733),
            id: req.id,
            result: resp,
            error: err
        });
    }
    async call(transaction, blockTag) {
        return this.rpcCall($13fa0b022f77d6d4$var$JsonRpcMethod.ethCall, transaction, blockTag);
    }
    async getCode(addressOrName, blockTag) {
        return this.rpcCall($13fa0b022f77d6d4$var$JsonRpcMethod.ethGetCode, addressOrName, blockTag);
    }
    async getBalance(addressOrName, blockTag) {
        return this.rpcCall($13fa0b022f77d6d4$var$JsonRpcMethod.ethGetBalance, addressOrName, blockTag);
    }
    async rpcCall(method, ...params) {
        const reqId = (0, $aab880b0cdc93953$export$b141de964f0a90c1)();
        const resp = await (0, $aab880b0cdc93953$export$1d1d2ed6b55cf67f)(this.multicall.handle)(this.next, {
            jsonrpc: (0, $4c7872e0fa8555c0$export$d5468ab7f0da6733),
            id: reqId,
            method: method,
            params: params
        });
        return resp.result;
    }
}
class $13fa0b022f77d6d4$var$MulticallExternalProvider {
    constructor(provider, multicall){
        this.provider = provider;
        this.multicall = void 0;
        this.multicall = $13fa0b022f77d6d4$export$74fd984ae9c44cf0.isMulticall(multicall) ? multicall : new $13fa0b022f77d6d4$export$74fd984ae9c44cf0(multicall);
        if (provider.send) {
            const next = async function next(req, callback) {
                provider.send(req, callback);
            };
            this.send = (request, callback)=>{
                this.multicall.handle(next, request, callback);
            };
        }
        if (provider.sendAsync) {
            const next = async function next(req, callback) {
                provider.sendAsync(req, callback);
            };
            this.sendAsync = (request, callback)=>{
                this.multicall.handle(next, request, callback);
            };
        }
    }
    get isMetaMask() {
        return this.provider.isMetaMask;
    }
    get isStatus() {
        return this.provider.isStatus;
    }
}
const $13fa0b022f77d6d4$var$multicallMiddleware = (multicall)=>(next)=>{
        const lib = $13fa0b022f77d6d4$export$74fd984ae9c44cf0.isMulticall(multicall) ? multicall : new $13fa0b022f77d6d4$export$74fd984ae9c44cf0(multicall);
        return (request, callback)=>{
            return lib.handle(next, request, callback);
        };
    };
var $13fa0b022f77d6d4$export$ccb2d1cc7ff715f5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ProxyMethods: $13fa0b022f77d6d4$var$ProxyMethods,
    MulticallProvider: $13fa0b022f77d6d4$var$MulticallProvider,
    MulticallExternalProvider: $13fa0b022f77d6d4$var$MulticallExternalProvider,
    multicallMiddleware: $13fa0b022f77d6d4$var$multicallMiddleware
});



var $bsYBY = parcelRequire("bsYBY");

const $63265caba806f334$var$providersMap = new Map();
const $63265caba806f334$var$getRpcProvider = (chainId)=>{
    const chainConfig = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    const { rpc: rpcProviderUrl } = chainConfig.providers;
    const rpcProvider = new (0, $bsYBY).JsonRpcProvider(rpcProviderUrl);
    return new (0, $13fa0b022f77d6d4$export$ccb2d1cc7ff715f5).MulticallProvider(rpcProvider);
};
const $63265caba806f334$export$57632def5536cb24 = (chainId)=>{
    const providerFromMap = $63265caba806f334$var$providersMap.get(chainId);
    if (providerFromMap) return providerFromMap;
    const provider = $63265caba806f334$var$getRpcProvider(chainId);
    $63265caba806f334$var$providersMap.set(chainId, provider);
    return provider;
};



const $6be459f7fee870ab$export$885990a1ffdf815c = async (chainId, account)=>{
    const provider = (0, $63265caba806f334$export$57632def5536cb24)(chainId);
    const address = (0, $4401935ec9f1441c$export$b13ad920efa14713);
    const { nativeCurrency: { symbol: symbol } } = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    const [rawBalance] = await Promise.all([
        account ? provider.getBalance(account).then((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)) : null
    ]);
    const decimals = 18;
    const divisor = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(decimals);
    const balance = rawBalance ? rawBalance.div(divisor) : null;
    const allowance = account ? (0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)((0, $4263977a5a9a6ac1$exports).MaxUint256) : (0, $39a9b22a0e28d503$export$6904811048a20190)();
    const totalSupply = (0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)((0, $4263977a5a9a6ac1$exports).MaxUint256);
    return {
        address: address,
        symbol: symbol,
        decimals: decimals,
        balance: balance,
        allowance: allowance,
        totalSupply: totalSupply
    };
};



/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d214cc1aca330931$var$_abi = [
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            },
            {
                name: "_spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    }
];
class $d214cc1aca330931$export$d78f55477ff9aea9 {
    static #_ = (()=>{
        this.abi = $d214cc1aca330931$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d214cc1aca330931$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $d214cc1aca330931$var$_abi, signerOrProvider);
    }
}








const $a58200b7518ae117$export$2b37da08c39f96e4 = async (chainId, tokenAddress, spenderAddress, account)=>{
    const provider = (0, $63265caba806f334$export$57632def5536cb24)(chainId);
    const address = tokenAddress;
    const tokenContract = (0, $d214cc1aca330931$export$d78f55477ff9aea9).connect(address, provider);
    const [symbol, decimals, rawBalance, rawAllowance, rawTotalSupply] = await Promise.all([
        tokenContract.symbol(),
        tokenContract.decimals(),
        account ? tokenContract.balanceOf(account).then((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)) : null,
        spenderAddress && account ? tokenContract.allowance(account, spenderAddress).then((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)) : (0, $39a9b22a0e28d503$export$6904811048a20190)(),
        tokenContract.totalSupply().then((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7))
    ]);
    const divisor = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(decimals);
    const balance = rawBalance ? rawBalance.div(divisor) : null;
    const allowance = rawAllowance.div(divisor);
    const totalSupply = rawTotalSupply.div(divisor);
    return {
        address: address,
        symbol: symbol,
        decimals: decimals,
        balance: balance,
        allowance: allowance,
        totalSupply: totalSupply
    };
};


const $73411fa4076fd4c1$export$e92b4f03ff09cca8 = (chainId, tokenAddress, spenderAddress, account)=>({
        queryKey: [
            (0, $2599ca2123527e27$export$7c8e26efb80b90e8).TOKEN,
            chainId,
            tokenAddress,
            spenderAddress,
            account
        ],
        queryFn: async ()=>(0, $17ea153afdabe1fb$export$cf2a895cd8b3d7b6)(tokenAddress ?? "") ? await (0, $6be459f7fee870ab$export$885990a1ffdf815c)(chainId, account) : await (0, $a58200b7518ae117$export$2b37da08c39f96e4)(chainId, tokenAddress ?? "", spenderAddress, account),
        enabled: Boolean(tokenAddress)
    });


const $4c91147136419240$export$f7e40b15523578fd = ({ chainId: chainId, tokenAddress: tokenAddress, spenderAddress: spenderAddress, account: account })=>{
    const queryOptions = (0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, tokenAddress, spenderAddress, account);
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)(queryOptions);
};




var $f63b5092d9da353e$export$68251ae420ecadf7;
(function(PairSource) {
    PairSource["QUICKSWAP"] = "QUICKSWAP";
    PairSource["UNISWAPV2"] = "UNISWAPV2";
    PairSource["SUSHISWAP"] = "SUSHISWAP";
})($f63b5092d9da353e$export$68251ae420ecadf7 || ($f63b5092d9da353e$export$68251ae420ecadf7 = {}));


const $f689c6bb55d1135e$export$6912159ad0f5a2ef = [
    {
        id: "USDC-WETH-UNISWAPV2",
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET,
        source: (0, $f63b5092d9da353e$export$68251ae420ecadf7).UNISWAPV2,
        pairAddress: "0xb4e16d0168e52d35cacd2c6185b44281ec28c9dc",
        pairIdInAddressesProviderRegistry: 0,
        collateralTokenIndex: 0,
        poolId: 0,
        addresses: {
            lPoolApAddress: "0x01b76559D512Fa28aCc03630E8954405BcBB1E02",
            qsOracle: "0x0D1f22002e8B75CfF0F3f0A04BdF543ED043F6CC",
            assetOracle: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419"
        }
    },
    {
        id: "WBTC-USDC-UNISWAPV2",
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET,
        source: (0, $f63b5092d9da353e$export$68251ae420ecadf7).UNISWAPV2,
        pairAddress: "0x004375dff511095cc5a197a54140a24efef3a416",
        pairIdInAddressesProviderRegistry: 4,
        collateralTokenIndex: 1,
        poolId: 1,
        addresses: {
            lPoolApAddress: "0xCBc54aFbDCf9FE5dacA9980b26fEB8c3c0d14a08",
            qsOracle: "0x849AF4b128be3317a694bFD262dEFF636AB84c1b",
            assetOracle: "0xF4030086522a5bEEa4988F8cA5B36dbC97BeE88c"
        }
    },
    {
        id: "FXS-FRAX-UNISWAPV2",
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET,
        source: (0, $f63b5092d9da353e$export$68251ae420ecadf7).UNISWAPV2,
        pairAddress: "0xe1573b9d29e2183b1af0e743dc2754979a40d237",
        pairIdInAddressesProviderRegistry: 2,
        collateralTokenIndex: 1,
        poolId: 2,
        addresses: {
            lPoolApAddress: "0x1286A774322bB1153750f8a4Eb19Bab3a1343F69",
            qsOracle: "0xf97A1A905Ac35D364456dD173553131FB9039570",
            assetOracle: "0x6Ebc52C8C1089be9eB3945C4350B68B8E4C2233f"
        }
    },
    {
        id: "USDC-WETH-QUICKSWAP",
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).POLYGON,
        source: (0, $f63b5092d9da353e$export$68251ae420ecadf7).QUICKSWAP,
        pairAddress: "0x853ee4b2a13f8a742d64c8f088be7ba2131f670d",
        pairIdInAddressesProviderRegistry: 0,
        collateralTokenIndex: 0,
        poolId: 0,
        addresses: {
            lPoolApAddress: "0x9545bc5708ad2cd5D584465068412F2445018d6f",
            qsOracle: "0xD31750152eb8C9C46Fe00e8e3546750E975FD079",
            assetOracle: "0xF9680D99D6C9589e2a93a78A04A279e509205945"
        }
    },
    {
        id: "USDC-WETH-ARB!",
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).ARBITRUM,
        source: (0, $f63b5092d9da353e$export$68251ae420ecadf7).SUSHISWAP,
        pairAddress: "0x905dfcd5649217c42684f23958568e533c711aa3",
        pairIdInAddressesProviderRegistry: 0,
        collateralTokenIndex: 1,
        poolId: 0,
        addresses: {
            lPoolApAddress: "0x0029B254d039d8C5C88512a44EAa6FF999296009",
            qsOracle: "0x429aF81694078Fda879Aa6147bb107a81374Fc77",
            assetOracle: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612"
        }
    } // {
];


const $630b0f38660b8a03$export$9b63eff2ed67d74b = new Map((0, $f689c6bb55d1135e$export$6912159ad0f5a2ef).map((pair)=>[
        pair.id,
        pair
    ]));
const $630b0f38660b8a03$export$f0c9f85d2b6af2cc = (pairId)=>{
    const pairConfig = $630b0f38660b8a03$export$9b63eff2ed67d74b.get(pairId);
    if (pairConfig) return pairConfig;
    return (0, $f689c6bb55d1135e$export$6912159ad0f5a2ef)[0];
};


const $83c927673f132148$export$d398db6d32c368f4 = (pairId, pairQuery)=>{
    const { chainId: chainId } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
    const aTokenAddress = pairQuery.data?.aToken.address ?? null;
    const lendingPoolAddress = pairQuery.data?.lendingPoolAddress;
    return {
        chainId: chainId,
        tokenAddress: aTokenAddress,
        spenderAddress: lendingPoolAddress
    };
};



const $4a0b3df1dc1c06ef$export$bb6906292efbb73d = (pairId, pairQuery)=>{
    const { chainId: chainId, pairAddress: pairAddress } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
    const lendingPoolAddress = pairQuery.data?.lendingPoolAddress;
    return {
        chainId: chainId,
        tokenAddress: pairAddress,
        spenderAddress: lendingPoolAddress
    };
};




var $acw62 = parcelRequire("acw62");
const $fade73491fc225fc$export$33ffd74ebf07f060 = ()=>(0, $acw62.useContext)((0, $7ba40f9fe3eefc5f$export$ab57792b9b6974a6));




var $c285bee7a1a27c15$export$7c8e26efb80b90e8;
(function(QueryType) {
    QueryType["PAIR"] = "PAIR";
    QueryType["PAIRS_SWAP_FEES"] = "PAIRS_SWAP_FEES";
})($c285bee7a1a27c15$export$7c8e26efb80b90e8 || ($c285bee7a1a27c15$export$7c8e26efb80b90e8 = {}));






const $8cfe9ef9d2660a6b$export$1073520e33bb6112 = [
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET,
        addresses: {
            lendingPoolAddressesProviderRegistryAddress: "0x0029B254d039d8C5C88512a44EAa6FF999296009",
            roePm: "0x7515cd37707c700a0bd17D3E925b1b94f2C9B83f",
            qsRouterAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
            routerAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
            zapBoxAddress: "0x80e6Ef71A257c8495fdb862a531822A991830877"
        }
    },
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).POLYGON,
        addresses: {
            lendingPoolAddressesProviderRegistryAddress: "0x1ceb99Acd9788bb7d7Ce4a90219cBb0627b008F9",
            roePm: "0xe8a6265bDd7080B4C5786b5633bC5bCc3F7160AE",
            qsRouterAddress: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
            routerAddress: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
            zapBoxAddress: "0x75424486c5a6640e31EdBcd17d30bE4662446278"
        }
    },
    {
        chainId: (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).ARBITRUM,
        addresses: {
            lendingPoolAddressesProviderRegistryAddress: "0x01b76559D512Fa28aCc03630E8954405BcBB1E02",
            roePm: "0x1056b5664341487679d5B68854249318693dc53D",
            qsRouterAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
            routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
            zapBoxAddress: "0xB90240106d7Fcff6566ab83299D90d81753eA19c"
        }
    }
];


const $3cbba3765f818c71$export$a5b6c633d20af84e = new Map((0, $8cfe9ef9d2660a6b$export$1073520e33bb6112).map((metadata)=>[
        metadata.chainId,
        metadata
    ]));
const $3cbba3765f818c71$export$875a4d57319efd3 = (chainId)=>{
    const chainMetadata = $3cbba3765f818c71$export$a5b6c633d20af84e.get(chainId);
    if (chainMetadata) return chainMetadata;
    return (0, $8cfe9ef9d2660a6b$export$1073520e33bb6112)[0];
};





const $12b684a6faa19c6a$export$c0657b8b46b96a9a = (value, tokenData)=>{
    const multiplier = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(tokenData.decimals);
    return value.mul(multiplier).round(0, (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports))).roundDown);
};
const $12b684a6faa19c6a$export$2ce8838a4141a21d = (value, tokenData)=>{
    const divisor = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(tokenData.decimals);
    return value.div(divisor).round(6);
};



const $b296bcd53744d095$export$7c07b633a151f9c5 = new (0, $13e074efb1ecf7c6$export$405d0624ed55a03f)({});


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8008e9cc2238f77e$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowRateMode",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowRate",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "uint16",
                name: "referral",
                type: "uint16"
            }
        ],
        name: "Borrow",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "uint16",
                name: "referral",
                type: "uint16"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "initiator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "premium",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "referralCode",
                type: "uint16"
            }
        ],
        name: "FlashLoan",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "collateralAsset",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "debtAsset",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "debtToCover",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidatedCollateralAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "address",
                name: "liquidator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "receiveAToken",
                type: "bool"
            }
        ],
        name: "LiquidationCall",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [],
        name: "Paused",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "RebalanceStableBorrowRate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "repayer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "Repay",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidityRate",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableBorrowRate",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "variableBorrowRate",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidityIndex",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "variableBorrowIndex",
                type: "uint256"
            }
        ],
        name: "ReserveDataUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "ReserveUsedAsCollateralDisabled",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "ReserveUsedAsCollateralEnabled",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rateMode",
                type: "uint256"
            }
        ],
        name: "Swap",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [],
        name: "Unpaused",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "reserve",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [],
        name: "FLASHLOAN_PREMIUM_TOTAL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "LENDINGPOOL_REVISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_NUMBER_RESERVES",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_STABLE_RATE_BORROW_SIZE_PERCENT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "interestRateMode",
                type: "uint256"
            },
            {
                internalType: "uint16",
                name: "referralCode",
                type: "uint16"
            },
            {
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            }
        ],
        name: "borrow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            },
            {
                internalType: "uint16",
                name: "referralCode",
                type: "uint16"
            }
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "balanceFromBefore",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "balanceToBefore",
                type: "uint256"
            }
        ],
        name: "finalizeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiverAddress",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "assets",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "modes",
                type: "uint256[]"
            },
            {
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "params",
                type: "bytes"
            },
            {
                internalType: "uint16",
                name: "referralCode",
                type: "uint16"
            }
        ],
        name: "flashLoan",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getAddressesProvider",
        outputs: [
            {
                internalType: "contract ILendingPoolAddressesProvider",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            }
        ],
        name: "getConfiguration",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "data",
                        type: "uint256"
                    }
                ],
                internalType: "struct DataTypes.ReserveConfigurationMap",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            }
        ],
        name: "getReserveData",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "data",
                                type: "uint256"
                            }
                        ],
                        internalType: "struct DataTypes.ReserveConfigurationMap",
                        name: "configuration",
                        type: "tuple"
                    },
                    {
                        internalType: "uint128",
                        name: "liquidityIndex",
                        type: "uint128"
                    },
                    {
                        internalType: "uint128",
                        name: "variableBorrowIndex",
                        type: "uint128"
                    },
                    {
                        internalType: "uint128",
                        name: "currentLiquidityRate",
                        type: "uint128"
                    },
                    {
                        internalType: "uint128",
                        name: "currentVariableBorrowRate",
                        type: "uint128"
                    },
                    {
                        internalType: "uint128",
                        name: "currentStableBorrowRate",
                        type: "uint128"
                    },
                    {
                        internalType: "uint40",
                        name: "lastUpdateTimestamp",
                        type: "uint40"
                    },
                    {
                        internalType: "address",
                        name: "aTokenAddress",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "stableDebtTokenAddress",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "variableDebtTokenAddress",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "interestRateStrategyAddress",
                        type: "address"
                    },
                    {
                        internalType: "uint8",
                        name: "id",
                        type: "uint8"
                    }
                ],
                internalType: "struct DataTypes.ReserveData",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            }
        ],
        name: "getReserveNormalizedIncome",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            }
        ],
        name: "getReserveNormalizedVariableDebt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getReservesList",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "getUserAccountData",
        outputs: [
            {
                internalType: "uint256",
                name: "totalCollateralETH",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "totalDebtETH",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "availableBorrowsETH",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "currentLiquidationThreshold",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "ltv",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "healthFactor",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "getUserConfiguration",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "data",
                        type: "uint256"
                    }
                ],
                internalType: "struct DataTypes.UserConfigurationMap",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "address",
                name: "aTokenAddress",
                type: "address"
            },
            {
                internalType: "address",
                name: "stableDebtAddress",
                type: "address"
            },
            {
                internalType: "address",
                name: "variableDebtAddress",
                type: "address"
            },
            {
                internalType: "address",
                name: "interestRateStrategyAddress",
                type: "address"
            }
        ],
        name: "initReserve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPoolAddressesProvider",
                name: "provider",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collateralAsset",
                type: "address"
            },
            {
                internalType: "address",
                name: "debtAsset",
                type: "address"
            },
            {
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "debtToCover",
                type: "uint256"
            },
            {
                internalType: "bool",
                name: "receiveAToken",
                type: "bool"
            }
        ],
        name: "liquidationCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "address",
                name: "user",
                type: "address"
            }
        ],
        name: "rebalanceStableBorrowRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "rateMode",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "onBehalfOf",
                type: "address"
            }
        ],
        name: "repay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configuration",
                type: "uint256"
            }
        ],
        name: "setConfiguration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "val",
                type: "bool"
            }
        ],
        name: "setPause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "address",
                name: "rateStrategyAddress",
                type: "address"
            }
        ],
        name: "setReserveInterestRateStrategyAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useAsCollateral",
                type: "bool"
            }
        ],
        name: "setUserUseReserveAsCollateral",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rateMode",
                type: "uint256"
            }
        ],
        name: "swapBorrowRateMode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $8008e9cc2238f77e$export$93c097b072274bf4 {
    static #_ = (()=>{
        this.abi = $8008e9cc2238f77e$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8008e9cc2238f77e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $8008e9cc2238f77e$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $13dbd5b3254fd70b$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "hasProxy",
                type: "bool"
            }
        ],
        name: "AddressSet",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "ConfigurationAdminUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "EmergencyAdminUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "LendingPoolCollateralManagerUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "LendingPoolConfiguratorUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "LendingPoolUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "LendingRateOracleUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "newMarketId",
                type: "string"
            }
        ],
        name: "MarketIdSet",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "PriceOracleUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "ProxyCreated",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "getAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getEmergencyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getLendingPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getLendingPoolCollateralManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getLendingPoolConfigurator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getLendingRateOracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getMarketId",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getPoolAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getPriceOracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "setAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "impl",
                type: "address"
            }
        ],
        name: "setAddressAsProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "setEmergencyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "manager",
                type: "address"
            }
        ],
        name: "setLendingPoolCollateralManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "configurator",
                type: "address"
            }
        ],
        name: "setLendingPoolConfiguratorImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address"
            }
        ],
        name: "setLendingPoolImpl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "lendingRateOracle",
                type: "address"
            }
        ],
        name: "setLendingRateOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketId",
                type: "string"
            }
        ],
        name: "setMarketId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "setPoolAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "priceOracle",
                type: "address"
            }
        ],
        name: "setPriceOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $13dbd5b3254fd70b$export$c676bd26b630270c {
    static #_ = (()=>{
        this.abi = $13dbd5b3254fd70b$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($13dbd5b3254fd70b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $13dbd5b3254fd70b$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5a9ab3a21b0243a1$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "AddressesProviderRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "AddressesProviderUnregistered",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addressesProvider",
                type: "address"
            }
        ],
        name: "getAddressesProviderIdByAddress",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAddressesProvidersList",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "provider",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "registerAddressesProvider",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "provider",
                type: "address"
            }
        ],
        name: "unregisterAddressesProvider",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5a9ab3a21b0243a1$export$a12d19df4cb07443 {
    static #_ = (()=>{
        this.abi = $5a9ab3a21b0243a1$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5a9ab3a21b0243a1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $5a9ab3a21b0243a1$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b5d47d65ce035d18$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address"
            }
        ],
        name: "getAssetPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_assets",
                type: "address[]"
            }
        ],
        name: "getAssetsPrices",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getFallbackOracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address"
            }
        ],
        name: "getSourceOfAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $b5d47d65ce035d18$export$62f572bea9cf5055 {
    static #_ = (()=>{
        this.abi = $b5d47d65ce035d18$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b5d47d65ce035d18$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $b5d47d65ce035d18$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $4a5397d2129d571f$var$_abi = [
    {
        inputs: [],
        name: "latestAnswer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $4a5397d2129d571f$export$f8ce8567fbe6668e {
    static #_ = (()=>{
        this.abi = $4a5397d2129d571f$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($4a5397d2129d571f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $4a5397d2129d571f$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $63cca35022eeda10$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "Burn",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        name: "Mint",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount0In",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount1In",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount0Out",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount1Out",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "Swap",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint112",
                name: "reserve0",
                type: "uint112"
            },
            {
                indexed: false,
                internalType: "uint112",
                name: "reserve1",
                type: "uint112"
            }
        ],
        name: "Sync",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "MINIMUM_LIQUIDITY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "pure",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        payable: false,
        stateMutability: "pure",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "burn",
        outputs: [
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        payable: false,
        stateMutability: "pure",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "getReserves",
        outputs: [
            {
                internalType: "uint112",
                name: "reserve0",
                type: "uint112"
            },
            {
                internalType: "uint112",
                name: "reserve1",
                type: "uint112"
            },
            {
                internalType: "uint32",
                name: "blockTimestampLast",
                type: "uint32"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "kLast",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "pure",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256"
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8"
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
            }
        ],
        name: "permit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "price0CumulativeLast",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "price1CumulativeLast",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "skim",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount0Out",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount1Out",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "swap",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "pure",
        type: "function"
    },
    {
        constant: false,
        inputs: [],
        name: "sync",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "token0",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "token1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $63cca35022eeda10$export$fec8e528e8ff4a17 {
    static #_ = (()=>{
        this.abi = $63cca35022eeda10$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($63cca35022eeda10$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $63cca35022eeda10$var$_abi, signerOrProvider);
    }
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $9661304197807da0$var$_abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token0",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "token1",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        name: "zapIn",
        outputs: [
            {
                internalType: "uint256",
                name: "amountA",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amountB",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token0",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            }
        ],
        name: "zapInETH",
        outputs: [
            {
                internalType: "uint256",
                name: "amountToken",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amountETH",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token0",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "token1",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        name: "zapInSingleAsset",
        outputs: [
            {
                internalType: "uint256",
                name: "amountA",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amountB",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token0",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            }
        ],
        name: "zapInSingleAssetETH",
        outputs: [
            {
                internalType: "uint256",
                name: "amountToken",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amountETH",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "liquidity",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "zapOut",
        outputs: [
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ILendingPool",
                name: "lp",
                type: "address"
            },
            {
                internalType: "contract IUniswapV2Router01",
                name: "router",
                type: "address"
            },
            {
                internalType: "address",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "spender",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256"
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8"
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32"
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32"
                    }
                ],
                internalType: "struct ZapBox.PermitParam",
                name: "permit",
                type: "tuple"
            }
        ],
        name: "zapOutWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
class $9661304197807da0$export$fbaee63e5915cb6c {
    static #_ = (()=>{
        this.abi = $9661304197807da0$var$_abi;
    })();
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($9661304197807da0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $77d1b08e82bacf11$exports.Contract)(address, $9661304197807da0$var$_abi, signerOrProvider);
    }
}














const $55a3ff86d5a65058$export$8a68c3294a8fc7f1 = async ()=>{
    const url = "https://api.roe.finance/lp_returns.json";
    const response = await fetch(url);
    return await response.json();
};


const $d1699ff4bde186df$export$6cc9c2057185db11 = ()=>({
        queryKey: [
            (0, $c285bee7a1a27c15$export$7c8e26efb80b90e8).PAIRS_SWAP_FEES
        ],
        queryFn: async ()=>await (0, $55a3ff86d5a65058$export$8a68c3294a8fc7f1)(),
        staleTime: Number.POSITIVE_INFINITY
    });


const $c62b2d233204407f$export$53a09e2da08f8bd1 = async (id, chainId)=>{
    const { source: source, pairAddress: address, pairIdInAddressesProviderRegistry: pairIdInAddressesProviderRegistry } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(id);
    const { addresses: { lendingPoolAddressesProviderRegistryAddress: lendingPoolAddressesProviderRegistryAddress } } = (0, $3cbba3765f818c71$export$875a4d57319efd3)(chainId);
    const provider = (0, $63265caba806f334$export$57632def5536cb24)(chainId);
    const pairContract = (0, $63cca35022eeda10$export$fec8e528e8ff4a17).connect(address, provider);
    const lendingPoolAddressesProviderRegistryContract = (0, $5a9ab3a21b0243a1$export$a12d19df4cb07443).connect(lendingPoolAddressesProviderRegistryAddress, provider);
    const [token0Address, token1Address, rawReserves, addressesProvidersList] = await Promise.all([
        pairContract.token0(),
        pairContract.token1(),
        pairContract.getReserves(),
        lendingPoolAddressesProviderRegistryContract.getAddressesProvidersList()
    ]); // getting pair's addressesProviderAddress
    // by pairIdInAddressesProviderRegistry
    const addressesProviderAddress = addressesProvidersList[pairIdInAddressesProviderRegistry];
    const addressesProviderContract = (0, $13dbd5b3254fd70b$export$c676bd26b630270c).connect(addressesProviderAddress, provider);
    const [lendingPoolAddress, aavePriceOracleAddress, addressesProviderId, token0, token1, pairsSwapFees] = await Promise.all([
        addressesProviderContract.getLendingPool(),
        addressesProviderContract.getPriceOracle(),
        lendingPoolAddressesProviderRegistryContract.getAddressesProviderIdByAddress(addressesProviderAddress).then((value)=>(0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(value).toNumber()),
        (0, $b296bcd53744d095$export$7c07b633a151f9c5).fetchQuery((0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, token0Address)),
        (0, $b296bcd53744d095$export$7c07b633a151f9c5).fetchQuery((0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, token1Address)),
        (0, $b296bcd53744d095$export$7c07b633a151f9c5).fetchQuery((0, $d1699ff4bde186df$export$6cc9c2057185db11)())
    ]);
    const lendingPoolContract = (0, $8008e9cc2238f77e$export$93c097b072274bf4).connect(lendingPoolAddress, provider);
    const aavePriceOracleContract = (0, $b5d47d65ce035d18$export$62f572bea9cf5055).connect(aavePriceOracleAddress, provider);
    const [chainLinkPriceOracleAddress, { aTokenAddress: aTokenAddress, variableDebtTokenAddress: variableDebtTokenAddress, currentLiquidityRate: currentLiquidityRate }] = await Promise.all([
        aavePriceOracleContract.getSourceOfAsset(address),
        lendingPoolContract.getReserveData(address)
    ]);
    const chainLinkPriceOracleContract = (0, $4a5397d2129d571f$export$f8ce8567fbe6668e).connect(chainLinkPriceOracleAddress, provider);
    const [rawPairTokenPrice, aToken, debtToken] = await Promise.all([
        chainLinkPriceOracleContract.latestAnswer().then((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)),
        (0, $b296bcd53744d095$export$7c07b633a151f9c5).fetchQuery((0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, aTokenAddress)),
        (0, $b296bcd53744d095$export$7c07b633a151f9c5).fetchQuery((0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, variableDebtTokenAddress))
    ]);
    const reserves = {
        reserve0: (0, $12b684a6faa19c6a$export$2ce8838a4141a21d)((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(rawReserves.reserve0), token0),
        reserve1: (0, $12b684a6faa19c6a$export$2ce8838a4141a21d)((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(rawReserves.reserve1), token1)
    };
    const pairSwapFees = pairsSwapFees.chains[chainId]?.markets[addressesProviderId] ?? null;
    const swapFeesAPY = pairSwapFees ? pairSwapFees[7] : 0;
    const roeSupplyAPY = (0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(currentLiquidityRate).div((0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(27)).toNumber(); // hardcoded for now - 10%
    const rewardAPY = 0.1; // TODO: replace with real value
    const booster = 0.2;
    const pairTokenPrice = rawPairTokenPrice.div((0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(8)).toNumber();
    return {
        id: id,
        chainId: chainId,
        address: address,
        source: source,
        token0: token0,
        token1: token1,
        aToken: aToken,
        debtToken: debtToken,
        reserves: reserves,
        swapFeesAPY: swapFeesAPY,
        roeSupplyAPY: roeSupplyAPY,
        rewardAPY: rewardAPY,
        booster: booster,
        pairTokenPrice: pairTokenPrice,
        lendingPoolAddress: lendingPoolAddress
    };
};


const $8857fe245ddb9394$export$47705da074a47d45 = (id, chainId)=>({
        queryKey: [
            (0, $c285bee7a1a27c15$export$7c8e26efb80b90e8).PAIR,
            id,
            chainId
        ],
        queryFn: async ()=>await (0, $c62b2d233204407f$export$53a09e2da08f8bd1)(id, chainId),
        staleTime: Number.POSITIVE_INFINITY
    });


const $97e341dcee656957$export$6bf54bacd9124c31 = (pairId)=>{
    const { id: id, chainId: chainId } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
    const queryOptions = (0, $8857fe245ddb9394$export$47705da074a47d45)(id, chainId);
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)(queryOptions);
};


const $206208849bf34a5a$export$f2d0aad7869dde5f = ()=>{
    const { modalState: modalState } = (0, $fade73491fc225fc$export$33ffd74ebf07f060)();
    const { account: account } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { pairId: pairId = "" } = modalState ?? {};
    const pairQuery = (0, $97e341dcee656957$export$6bf54bacd9124c31)(pairId);
    const pairTokenParameters = (0, $4a0b3df1dc1c06ef$export$bb6906292efbb73d)(pairId, pairQuery);
    const pairTokenQuery = (0, $4c91147136419240$export$f7e40b15523578fd)(pairTokenParameters);
    const aTokenParameters = (0, $83c927673f132148$export$d398db6d32c368f4)(pairId, pairQuery);
    const aTokenQuery = (0, $4c91147136419240$export$f7e40b15523578fd)({
        ...aTokenParameters,
        account: account
    });
    return {
        pairQuery: pairQuery,
        pairTokenQuery: pairTokenQuery,
        aTokenQuery: aTokenQuery
    };
};








const $c3e8b2ac48c8d30a$export$c97301481e18dbaf = (pairId, pairQuery, tokenIndex)=>{
    const { chainId: chainId } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
    const token0 = pairQuery.data?.token0;
    const token1 = pairQuery.data?.token1;
    const address = tokenIndex === 0 ? token0?.address : token1?.address;
    const tokenAddress = address ?? null;
    const { addresses: { zapBoxAddress: zapBoxAddress } } = (0, $3cbba3765f818c71$export$875a4d57319efd3)(chainId);
    return {
        chainId: chainId,
        tokenAddress: tokenAddress,
        spenderAddress: zapBoxAddress
    };
};
const $c3e8b2ac48c8d30a$export$90a5c582ba48cb28 = (pairId)=>{
    const { chainId: chainId } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
    const tokenAddress = (0, $4401935ec9f1441c$export$b13ad920efa14713);
    return {
        chainId: chainId,
        tokenAddress: tokenAddress
    };
};


const $d97b5396a5102c45$export$6668418480f8c243 = ()=>{
    const { modalState: modalState } = (0, $fade73491fc225fc$export$33ffd74ebf07f060)();
    const { pairId: pairId = "" } = modalState ?? {};
    const pairQuery = (0, $97e341dcee656957$export$6bf54bacd9124c31)(pairId);
    const nativeCoinParameters = (0, $c3e8b2ac48c8d30a$export$90a5c582ba48cb28)(pairId);
    const nativeCoinQuery = (0, $4c91147136419240$export$f7e40b15523578fd)(nativeCoinParameters);
    const token0Parameters = (0, $c3e8b2ac48c8d30a$export$c97301481e18dbaf)(pairId, pairQuery, 0);
    const token0Query = (0, $4c91147136419240$export$f7e40b15523578fd)(token0Parameters);
    const token1Parameters = (0, $c3e8b2ac48c8d30a$export$c97301481e18dbaf)(pairId, pairQuery, 1);
    const token1Query = (0, $4c91147136419240$export$f7e40b15523578fd)(token1Parameters);
    return {
        pairQuery: pairQuery,
        nativeCoinQuery: nativeCoinQuery,
        token0Query: token0Query,
        token1Query: token1Query
    };
};



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
const $37a0d6d6b94d6391$export$7d7170b1a80a2975 = (token0InputValueBig, reserve0, reserve1)=>token0InputValueBig.div(reserve0).mul(reserve1);



var $6ad7a47cbfab54e4$export$7e9636d791c4004f;
(function(ZapType) {
    ZapType["DUAL"] = "DUAL";
    ZapType["LP"] = "LP";
    ZapType["ZAP"] = "ZAP";
})($6ad7a47cbfab54e4$export$7e9636d791c4004f || ($6ad7a47cbfab54e4$export$7e9636d791c4004f = {}));



const $1247ff9e013f953d$export$36c9b02cd4283b65 = /*#__PURE__*/ (0, $acw62.createContext)({
    zapType: null,
    setZapType: ()=>undefined,
    pairData: undefined,
    token0State: (0, $c33fe5be75c498d7$export$77e06e799013588a),
    token1State: (0, $c33fe5be75c498d7$export$77e06e799013588a),
    addresses: {
        routerAddress: "",
        zapBoxAddress: ""
    },
    isUseZapTransactionForToken: ()=>false
});
const $1247ff9e013f953d$export$ebec4f2159e8e6c7 = ({ children: children })=>{
    const [zapType, setZapType] = (0, $acw62.useState)((0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).LP);
    const [token0InputValue, setToken0InputValue] = (0, $acw62.useState)("");
    const [token1InputValue, setToken1InputValue] = (0, $acw62.useState)("");
    const { pairQuery: pairQuery, nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const pairData = pairQuery.data;
    const nativeCoinData = nativeCoinQuery.data;
    const chainId = pairQuery.data?.chainId;
    const [token0Data, tokens0, setToken0DataAddress] = (0, $c692ba37486e1b48$export$e2d78002650b3b1)([
        token0Query.data
    ], nativeCoinData, chainId);
    const [token1Data, tokens1, setToken1DataAddress] = (0, $c692ba37486e1b48$export$e2d78002650b3b1)([
        token1Query.data
    ], nativeCoinData, chainId);
    const reserve0 = pairData?.reserves.reserve0;
    const reserve1 = pairData?.reserves.reserve1;
    const token0InputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(token0InputValue);
    const token1InputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(token1InputValue);
    const token0Error = (0, $7481d344cad456e1$export$6509b2465401b583)(token0InputValueBig, token0Data);
    const token1Error = (0, $7481d344cad456e1$export$6509b2465401b583)(token1InputValueBig, token1Data);
    const setToken0Value = (0, $acw62.useCallback)((nextToken0InputValue)=>{
        setToken0InputValue(nextToken0InputValue);
        if (reserve0 && reserve1 && reserve0.gt((0, $39a9b22a0e28d503$export$6904811048a20190)())) {
            const nextToken0InputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(nextToken0InputValue);
            const token1Amount = (0, $37a0d6d6b94d6391$export$7d7170b1a80a2975)(nextToken0InputValueBig, reserve0, reserve1);
            const nextToken1InputValue = token1Amount.toString();
            setToken1InputValue(nextToken1InputValue);
        }
    }, [
        reserve0,
        reserve1
    ]);
    const setToken1Value = (0, $acw62.useCallback)((nextToken1InputValue)=>{
        setToken1InputValue(nextToken1InputValue);
        if (reserve0 && reserve1 && reserve1.gt((0, $39a9b22a0e28d503$export$6904811048a20190)())) {
            const nextToken1InputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(nextToken1InputValue);
            const token0Amount = (0, $37a0d6d6b94d6391$export$7d7170b1a80a2975)(nextToken1InputValueBig, reserve1, reserve0);
            const nextToken0InputValue = token0Amount.toString();
            setToken0InputValue(nextToken0InputValue);
        }
    }, [
        reserve0,
        reserve1
    ]);
    const chainMetadata = chainId ? (0, $3cbba3765f818c71$export$875a4d57319efd3)(chainId) : undefined;
    const routerAddress = chainMetadata?.addresses.routerAddress ?? "";
    const zapBoxAddress = chainMetadata?.addresses.zapBoxAddress ?? "";
    const token0State = (0, $acw62.useMemo)(()=>({
            tokenData: token0Data,
            tokens: tokens0,
            setTokenDataAddress: setToken0DataAddress,
            inputValue: token0InputValue,
            setInputValue: setToken0Value,
            inputValueBig: token0InputValueBig,
            isError: Boolean(token0Error),
            error: token0Error
        }), [
        token0Data,
        tokens0,
        setToken0DataAddress,
        token0InputValue,
        setToken0Value,
        token0InputValueBig,
        token0Error
    ]);
    const token1State = (0, $acw62.useMemo)(()=>({
            tokenData: token1Data,
            tokens: tokens1,
            setTokenDataAddress: setToken1DataAddress,
            inputValue: token1InputValue,
            setInputValue: setToken1Value,
            inputValueBig: token1InputValueBig,
            isError: Boolean(token1Error),
            error: token1Error
        }), [
        token1Data,
        tokens1,
        setToken1DataAddress,
        token1InputValue,
        setToken1Value,
        token1InputValueBig,
        token1Error
    ]);
    const addresses = (0, $acw62.useMemo)(()=>({
            routerAddress: routerAddress,
            zapBoxAddress: zapBoxAddress
        }), [
        routerAddress,
        zapBoxAddress
    ]);
    const isUseZapTransactionForToken = (0, $acw62.useCallback)((tokenData)=>[
            nativeCoinQuery,
            token0Query,
            token1Query
        ].map((query)=>query.data?.address).includes(tokenData?.address), [
        nativeCoinQuery,
        token0Query,
        token1Query
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            zapType: zapType,
            setZapType: setZapType,
            pairData: pairData,
            token0State: token0State,
            token1State: token1State,
            addresses: addresses,
            isUseZapTransactionForToken: isUseZapTransactionForToken
        }), [
        zapType,
        pairData,
        token0State,
        token1State,
        addresses,
        isUseZapTransactionForToken
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1247ff9e013f953d$export$36c9b02cd4283b65.Provider, {
        value: value,
        children: children
    });
};


const $d4ad2dd0d925e59b$export$1d35d7d022aec9ff = ()=>(0, $acw62.useContext)((0, $1247ff9e013f953d$export$36c9b02cd4283b65));


var $af6c5c79ba537edd$export$ea1f8d830f8d55e1;
(function(TabType) {
    TabType["SUPPLY"] = "SUPPLY";
    TabType["WITHDRAW"] = "WITHDRAW";
})($af6c5c79ba537edd$export$ea1f8d830f8d55e1 || ($af6c5c79ba537edd$export$ea1f8d830f8d55e1 = {}));




const $bd6b55b0c280c77f$export$87e825f565075fab = /*#__PURE__*/ (0, $acw62.createContext)({
    tabType: (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY,
    setTabType: ()=>undefined,
    pairData: undefined,
    supplyTokenState: (0, $c33fe5be75c498d7$export$77e06e799013588a),
    withdrawTokenState: (0, $c33fe5be75c498d7$export$77e06e799013588a)
});
const $bd6b55b0c280c77f$export$8467072453451889 = ({ children: children })=>{
    const [tabType, setTabType] = (0, $acw62.useState)((0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY);
    const [supplyTokenInputValue, setSupplyTokenInputValue] = (0, $acw62.useState)("");
    const [withdrawTokenInputValue, setWithdrawTokenInputValue] = (0, $acw62.useState)("");
    const { pairQuery: pairQuery, pairTokenQuery: pairTokenQuery, aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const { nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const { zapType: zapType } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const pairData = pairQuery.data;
    const chainId = pairData?.chainId;
    const pairTitle = pairData ? (0, $97040645fc5a577a$export$5bc6031dcd0c59f7)(pairData) : "-"; // update symbols for pairTokenData and aTokenData
    const pairTokenData = pairTokenQuery.data ? {
        ...pairTokenQuery.data,
        symbol: `${pairTitle} LP`
    } : undefined;
    const aTokenData = aTokenQuery.data ? {
        ...aTokenQuery.data,
        symbol: `ROE ${pairTitle} LP`
    } : undefined;
    const [supplyTokenData, supplyTokens, setSupplyTokenDataAddress] = (0, $c692ba37486e1b48$export$e2d78002650b3b1)(zapType === (0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).LP ? [
        pairTokenData
    ] : [
        token0Query.data,
        token1Query.data
    ], nativeCoinQuery.data, chainId);
    const [withdrawTokenData, withdrawTokens, setWithdrawTokenDataAddress] = (0, $c692ba37486e1b48$export$e2d78002650b3b1)([
        aTokenData
    ]);
    const supplyTokenInputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(supplyTokenInputValue);
    const withdrawTokenInputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(withdrawTokenInputValue);
    const supplyTokenError = (0, $7481d344cad456e1$export$6509b2465401b583)(supplyTokenInputValueBig, supplyTokenData);
    const withdrawTokenError = (0, $7481d344cad456e1$export$6509b2465401b583)(withdrawTokenInputValueBig, withdrawTokenData);
    const supplyTokenState = (0, $acw62.useMemo)(()=>({
            tokenData: supplyTokenData,
            tokens: supplyTokens,
            setTokenDataAddress: setSupplyTokenDataAddress,
            inputValue: supplyTokenInputValue,
            setInputValue: setSupplyTokenInputValue,
            inputValueBig: supplyTokenInputValueBig,
            isError: Boolean(supplyTokenError),
            error: supplyTokenError
        }), [
        supplyTokenData,
        supplyTokens,
        setSupplyTokenDataAddress,
        supplyTokenInputValue,
        setSupplyTokenInputValue,
        supplyTokenInputValueBig,
        supplyTokenError
    ]);
    const withdrawTokenState = (0, $acw62.useMemo)(()=>({
            tokenData: withdrawTokenData,
            tokens: withdrawTokens,
            setTokenDataAddress: setWithdrawTokenDataAddress,
            inputValue: withdrawTokenInputValue,
            setInputValue: setWithdrawTokenInputValue,
            inputValueBig: withdrawTokenInputValueBig,
            isError: Boolean(withdrawTokenError),
            error: withdrawTokenError
        }), [
        withdrawTokenData,
        withdrawTokens,
        setWithdrawTokenDataAddress,
        withdrawTokenInputValue,
        setWithdrawTokenInputValue,
        withdrawTokenInputValueBig,
        withdrawTokenError
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            tabType: tabType,
            setTabType: setTabType,
            pairData: pairData,
            supplyTokenState: supplyTokenState,
            withdrawTokenState: withdrawTokenState
        }), [
        tabType,
        setTabType,
        pairData,
        supplyTokenState,
        withdrawTokenState
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bd6b55b0c280c77f$export$87e825f565075fab.Provider, {
        value: value,
        children: children
    });
};



const $632426152e62c0d5$export$1f4b229aeaf9c037 = {
    mutation: {
        data: undefined,
        error: null,
        isError: false,
        isIdle: false,
        isLoading: false,
        isSuccess: true,
        isPaused: false,
        status: "success",
        mutate: ()=>undefined,
        mutateAsync: async ()=>{
            await Promise.resolve();
        },
        reset: ()=>undefined,
        context: undefined,
        failureCount: 0,
        variables: undefined
    },
    resetTransaction: ()=>undefined,
    transactionHash: undefined,
    runTransaction: async ()=>{
        await Promise.resolve();
    }
};



var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");


/* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable lines-around-comment */ 
var $acw62 = parcelRequire("acw62");


const $c8f594076b248413$export$46ef8bd8675f3408 = (contract, method, dependantQueries = [], onTransactionSuccess = ()=>undefined)=>{
    const [transactionHash, setTransactionHash] = (0, $acw62.useState)();
    const { provider: provider } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const mutationFunction = (0, $acw62.useCallback)(async (methodParameters)=>{
        if (!provider) throw new Error("No provider");
        const signer = provider.getSigner();
        const connectedContract = contract.connect(signer); // @ts-expect-error typings
        await connectedContract.callStatic[method](...methodParameters);
        let transaction = null;
        try {
            transaction = await connectedContract.functions[method](...methodParameters);
        } catch (error) {
            const { code: code, message: message } = error;
            if (code === 4001) throw new Error("Transaction Cancelled");
            throw new Error(message);
        }
        if (transaction) {
            const { hash: hash } = transaction;
            setTransactionHash(hash);
            await transaction.wait();
        }
    }, [
        contract,
        method,
        provider
    ]);
    const handleMutationSuccess = (0, $acw62.useCallback)(async ()=>{
        const dependantQueriesPromises = dependantQueries.map(async (query)=>await query.refetch());
        await Promise.all(dependantQueriesPromises);
        await onTransactionSuccess();
    }, [
        dependantQueries,
        onTransactionSuccess
    ]);
    const mutation = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)(mutationFunction, {
        onSuccess: handleMutationSuccess,
        onError: ()=>{
            setTimeout(()=>{
                mutation.reset();
            }, 2000);
        }
    });
    const resetTransaction = (0, $acw62.useCallback)(()=>{
        setTransactionHash(undefined);
        mutation.reset();
    }, [
        mutation
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash
    };
};


const $d2345d3795c126cd$export$de1692c931a405d7 = (tokenAddress, dependantQueries, onTransactionSuccess)=>{
    const { provider: provider } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const tokenContract = (0, $d214cc1aca330931$export$d78f55477ff9aea9).connect(tokenAddress, provider ?? (0, $bsYBY.getDefaultProvider)());
    const method = "approve";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(tokenContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)((spenderAddress)=>{
        mutation.mutate([
            spenderAddress,
            (0, $4263977a5a9a6ac1$exports).MaxUint256
        ]);
    }, [
        mutation
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};



var $acw62 = parcelRequire("acw62");



var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $9b70ae94f5ef7704$export$2dbfda57e10168fe = (lendingPoolAddress, dependantQueries, onTransactionSuccess)=>{
    const { account: account = "" } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const lendingPoolContract = (0, $8008e9cc2238f77e$export$93c097b072274bf4).connect(lendingPoolAddress, (0, $bsYBY.getDefaultProvider)());
    const method = "deposit";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(lendingPoolContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)((tokenAddress, amount)=>{
        mutation.mutate([
            tokenAddress,
            amount,
            account,
            0
        ]);
    }, [
        mutation,
        account
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};





var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $89e8adb1fe249217$export$cb2ac9a3e194557d = (lendingPoolAddress, dependantQueries, onTransactionSuccess)=>{
    const { account: account = "" } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const lendingPoolContract = (0, $8008e9cc2238f77e$export$93c097b072274bf4).connect(lendingPoolAddress, (0, $bsYBY.getDefaultProvider)());
    const method = "withdraw";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(lendingPoolContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)((tokenAddress, amount)=>{
        mutation.mutate([
            tokenAddress,
            amount,
            account
        ]);
    }, [
        mutation,
        account
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};




const $12b6cb0537f53c37$export$bfa1f2d9c50b1a4d = 0.005;


const $cfe353bd423358df$export$4538e7b39ab51095 = (value, slippage = (0, $12b6cb0537f53c37$export$bfa1f2d9c50b1a4d))=>value.mul(1 - slippage).round(0, (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports))).roundDown);





var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $48c57fb97952410d$export$31d2b590a17985b0 = (zapBoxAddress, dependantQueries, onTransactionSuccess)=>{
    const { provider: provider } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const signer = provider?.getSigner();
    const zapBoxContract = (0, $9661304197807da0$export$fbaee63e5915cb6c).connect(zapBoxAddress, signer ?? (0, $bsYBY.getDefaultProvider)());
    const method = "zapInSingleAssetETH";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(zapBoxContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)(async (lendingPoolAddress, routerAddress, nativeCoinAddress, nativeCoinAmount, token1Address)=>{
        const { amountToken: amountToken } = await zapBoxContract.callStatic[method](lendingPoolAddress, routerAddress, token1Address, (0, $4263977a5a9a6ac1$exports).Zero, {
            value: nativeCoinAmount
        });
        const token1Amount = (0, $cfe353bd423358df$export$4538e7b39ab51095)((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(amountToken)).toString();
        mutation.mutate([
            lendingPoolAddress,
            routerAddress,
            token1Address,
            token1Amount,
            {
                value: nativeCoinAmount
            }
        ]);
    }, [
        mutation,
        zapBoxContract
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};







var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $d2786945ab0922db$export$d1187a29db1b445d = (zapBoxAddress, dependantQueries, onTransactionSuccess)=>{
    const { provider: provider } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const signer = provider?.getSigner();
    const zapBoxContract = (0, $9661304197807da0$export$fbaee63e5915cb6c).connect(zapBoxAddress, signer ?? (0, $bsYBY.getDefaultProvider)());
    const method = "zapInSingleAsset";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(zapBoxContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)(async (lendingPoolAddress, routerAddress, token0Address, token0Amount, token1Address)=>{
        const { amountB: amountB } = await zapBoxContract.callStatic[method](lendingPoolAddress, routerAddress, token0Address, token0Amount, token1Address, (0, $4263977a5a9a6ac1$exports).Zero);
        const token1Amount = (0, $cfe353bd423358df$export$4538e7b39ab51095)((0, $39a9b22a0e28d503$export$30f78adcaaa2eb7)(amountB)).toString();
        mutation.mutate([
            lendingPoolAddress,
            routerAddress,
            token0Address,
            token0Amount,
            token1Address,
            token1Amount
        ]);
    }, [
        mutation,
        zapBoxContract
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};




var $acw62 = parcelRequire("acw62");

const $504feaabca9af2b3$export$935680025b36a932 = ()=>(0, $acw62.useContext)((0, $bd6b55b0c280c77f$export$87e825f565075fab));


const $7d64a5251f30eaf8$export$72749f11642fc1c6 = ()=>{
    const { tabType: tabType, supplyTokenState: supplyTokenState, withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    return tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? supplyTokenState : withdrawTokenState;
};
const $7d64a5251f30eaf8$export$1b909ddfc3d23cdb = ()=>{
    const { tabType: tabType, supplyTokenState: supplyTokenState, withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    return tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? withdrawTokenState : supplyTokenState;
};








const $1960857fdaf79085$export$c0c912d9972e5264 = /*#__PURE__*/ (0, $acw62.createContext)({
    tokenApproveTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037),
    lendingPoolTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037),
    zapSupplyTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037)
});
const $1960857fdaf79085$export$fd535cf936991f6a = ({ children: children })=>{
    const { tabType: tabType, pairData: pairData, supplyTokenState: supplyTokenState, withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { addresses: addresses } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { pairQuery: pairQuery, pairTokenQuery: pairTokenQuery, aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const { nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const { tokenData: tokenData } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const lendingPoolAddress = pairData?.lendingPoolAddress ?? "";
    const { zapBoxAddress: zapBoxAddress } = addresses;
    const lendingPoolDependantQueries = [
        pairQuery,
        pairTokenQuery,
        aTokenQuery
    ];
    const zapDependantQueries = lendingPoolDependantQueries.concat(nativeCoinQuery, token0Query, token1Query);
    const onTransactionSuccess = ()=>{
        supplyTokenState.setInputValue("");
        withdrawTokenState.setInputValue("");
    };
    const tokenAddress = tokenData?.address ?? "";
    const isUseNativeCoin = (0, $17ea153afdabe1fb$export$cf2a895cd8b3d7b6)(tokenAddress);
    const tokenApproveTransaction = (0, $d2345d3795c126cd$export$de1692c931a405d7)(tokenAddress, zapDependantQueries);
    const supplyTransaction = (0, $9b70ae94f5ef7704$export$2dbfda57e10168fe)(lendingPoolAddress, lendingPoolDependantQueries, onTransactionSuccess);
    const withdrawTransaction = (0, $89e8adb1fe249217$export$cb2ac9a3e194557d)(lendingPoolAddress, lendingPoolDependantQueries, onTransactionSuccess);
    const zapSingleSupplyTransaction = (0, $d2786945ab0922db$export$d1187a29db1b445d)(zapBoxAddress, zapDependantQueries, onTransactionSuccess);
    const zapSingleSupplyNativeCoinTransaction = (0, $48c57fb97952410d$export$31d2b590a17985b0)(zapBoxAddress, zapDependantQueries, onTransactionSuccess);
    const lendingPoolTransaction = tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? supplyTransaction : withdrawTransaction;
    const zapSupplyTransaction = isUseNativeCoin ? zapSingleSupplyNativeCoinTransaction : zapSingleSupplyTransaction;
    const value = (0, $acw62.useMemo)(()=>({
            tokenApproveTransaction: tokenApproveTransaction,
            lendingPoolTransaction: lendingPoolTransaction,
            zapSupplyTransaction: zapSupplyTransaction
        }), [
        tokenApproveTransaction,
        lendingPoolTransaction,
        zapSupplyTransaction
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1960857fdaf79085$export$c0c912d9972e5264.Provider, {
        value: value,
        children: children
    });
};







var $acw62 = parcelRequire("acw62");


var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $2a0a75335d2d64d9$export$3d8dbf375049db8a = (zapBoxAddress, dependantQueries, onTransactionSuccess)=>{
    const zapBoxContract = (0, $9661304197807da0$export$fbaee63e5915cb6c).connect(zapBoxAddress, (0, $bsYBY.getDefaultProvider)());
    const method = "zapInETH";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(zapBoxContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)((lendingPoolAddress, routerAddress, token0Address, token0Amount, nativeCoinAddress, nativeCoinAmount)=>{
        mutation.mutate([
            lendingPoolAddress,
            routerAddress,
            token0Address,
            token0Amount,
            {
                value: nativeCoinAmount
            }
        ]);
    }, [
        mutation
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};




var $bsYBY = parcelRequire("bsYBY");

var $acw62 = parcelRequire("acw62");

const $f6e45475b07f9b13$export$bac7e170fb17dcf6 = (zapBoxAddress, dependantQueries, onTransactionSuccess)=>{
    const zapBoxContract = (0, $9661304197807da0$export$fbaee63e5915cb6c).connect(zapBoxAddress, (0, $bsYBY.getDefaultProvider)());
    const method = "zapIn";
    const { mutation: mutation, resetTransaction: resetTransaction, transactionHash: transactionHash } = (0, $c8f594076b248413$export$46ef8bd8675f3408)(zapBoxContract, method, dependantQueries, onTransactionSuccess);
    const runTransaction = (0, $acw62.useCallback)((lendingPoolAddress, routerAddress, token0Address, token0Amount, token1Address, token1Amount)=>{
        mutation.mutate([
            lendingPoolAddress,
            routerAddress,
            token0Address,
            token0Amount,
            token1Address,
            token1Amount
        ]);
    }, [
        mutation
    ]);
    return {
        mutation: mutation,
        resetTransaction: resetTransaction,
        transactionHash: transactionHash,
        runTransaction: runTransaction
    };
};






const $383ca4a08629964c$export$1a6e03a6b5eaa999 = /*#__PURE__*/ (0, $acw62.createContext)({
    token0ApproveTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037),
    token1ApproveTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037),
    supplyTransaction: (0, $632426152e62c0d5$export$1f4b229aeaf9c037)
});
const $383ca4a08629964c$export$cd7e2fb6768d802a = ({ children: children })=>{
    const { token0State: token0State, token1State: token1State, addresses: addresses } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { pairQuery: pairQuery, nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const { aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const dependantQueries = [
        pairQuery,
        nativeCoinQuery,
        token0Query,
        token1Query,
        aTokenQuery
    ];
    const onTransactionSuccess = ()=>{
        token0State.setInputValue("");
        token1State.setInputValue("");
    };
    const { zapBoxAddress: zapBoxAddress } = addresses;
    const token0Address = token0State.tokenData?.address ?? "";
    const token1Address = token1State.tokenData?.address ?? "";
    const isUseNativeCoin = (0, $17ea153afdabe1fb$export$cf2a895cd8b3d7b6)(token0Address) || (0, $17ea153afdabe1fb$export$cf2a895cd8b3d7b6)(token1Address);
    const token0ApproveTransaction = (0, $d2345d3795c126cd$export$de1692c931a405d7)(token0Address, dependantQueries);
    const token1ApproveTransaction = (0, $d2345d3795c126cd$export$de1692c931a405d7)(token1Address, dependantQueries);
    const zapSupplyTransaction = (0, $f6e45475b07f9b13$export$bac7e170fb17dcf6)(zapBoxAddress, dependantQueries, onTransactionSuccess);
    const zapSupplyNativeCoinTransaction = (0, $2a0a75335d2d64d9$export$3d8dbf375049db8a)(zapBoxAddress, dependantQueries, onTransactionSuccess);
    const supplyTransaction = isUseNativeCoin ? zapSupplyNativeCoinTransaction : zapSupplyTransaction;
    const value = (0, $acw62.useMemo)(()=>({
            token0ApproveTransaction: token0ApproveTransaction,
            token1ApproveTransaction: token1ApproveTransaction,
            supplyTransaction: supplyTransaction
        }), [
        token0ApproveTransaction,
        token1ApproveTransaction,
        supplyTransaction
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($383ca4a08629964c$export$1a6e03a6b5eaa999.Provider, {
        value: value,
        children: children
    });
};



const $5d3566cb9f3688d1$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-xdgwrv-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.5rem",
    "alignItems": "flex-start",
    "@media (min-width: 640px)": {
        "flexDirection": "row"
    }
});
const $5d3566cb9f3688d1$export$f13a2f0aeb1af93c = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-xdgwrv-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.5rem"
});






const $86e000b9636ca3a5$export$c9554889b3e706cd = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $f795f85f6d7c50c9$export$2b77a92f1a5ad772)).withConfig({
    componentId: "sc-21lblg-0"
})({
    "gap": "1rem",
    "width": "448px",
    "maxWidth": "28rem"
});
const $86e000b9636ca3a5$export$1ff3c3f08ae963c0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-21lblg-1"
})({
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))"
});
const $86e000b9636ca3a5$export$2206531ad8592d57 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-21lblg-2"
})({
    "display": "flex",
    "justifyContent": "space-evenly"
});





var $acw62 = parcelRequire("acw62");



const $58d62e832b07bfa1$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-82s8tu-0"
})({
    "display": "flex",
    "flexDirection": "row",
    "gap": "1.5rem",
    "alignItems": "center",
    "justifyContent": "center"
});
const $58d62e832b07bfa1$export$37ab3bdebc286ca = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-82s8tu-1"
})([
    "",
    " ",
    " path{",
    "}:hover{",
    " *{fill:white;}}"
], {
    "display": "flex",
    "flexDirection": "row",
    "gap": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))",
    "alignItems": "center",
    "justifyContent": "center",
    "fontWeight": "600",
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
}, ({ isActive: isActive })=>isActive && {
        "--tw-text-opacity": "1",
        "color": "rgba(52, 105, 250, var(--tw-text-opacity))"
    }, ({ isActive: isActive })=>isActive && (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)({
        fill: "#3469FA"
    }), {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
});




const $dfbd2048cb370061$export$876618af2247305 = ()=>{
    const { zapType: currentZapType, setZapType: setZapType, token0State: token0State, token1State: token1State } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { supplyTokenState: supplyTokenState, withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const handleButtonClick = (0, $acw62.useCallback)((zapType)=>{
        setZapType(zapType);
        supplyTokenState.setInputValue("");
        withdrawTokenState.setInputValue("");
        token0State.setInputValue("");
        token1State.setInputValue("");
    }, [
        setZapType,
        supplyTokenState,
        withdrawTokenState,
        token0State,
        token1State
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58d62e832b07bfa1$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58d62e832b07bfa1$export$37ab3bdebc286ca), {
                isActive: currentZapType === (0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).LP,
                onClick: ()=>{
                    handleButtonClick((0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).LP);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M12.5 3C8.71036 3 5.75 4.67619 5.75 6.80952V17.1905C5.75 19.3238 8.71036 21 12.5 21C16.2896 21 19.25 19.3238 19.25 17.1905V6.80952C19.25 4.67619 16.2896 3 12.5 3ZM8.41143 5.02857C9.49143 4.45714 10.9475 4.14286 12.5 4.14286C14.0525 4.14286 15.5086 4.45714 16.5886 5.02857C17.6686 5.6 18.0929 6.17143 18.0929 6.80952C18.0929 7.44762 17.5432 8.09524 16.5886 8.59048C15.6339 9.08571 14.0525 9.47619 12.5 9.47619C10.9475 9.47619 9.49143 9.1619 8.41143 8.59048C7.33143 8.01905 6.90714 7.44762 6.90714 6.80952C6.90714 6.17143 7.45679 5.52381 8.41143 5.02857ZM16.5886 18.9714C15.5086 19.5429 14.0525 19.8571 12.5 19.8571C10.9475 19.8571 9.49143 19.5429 8.41143 18.9714C7.33143 18.4 6.90714 17.8286 6.90714 17.1905V8.97143C8.1125 9.97143 10.1471 10.619 12.5 10.619C14.8529 10.619 16.8875 9.97143 18.0929 8.97143V17.1905C18.0929 17.8286 17.5432 18.4762 16.5886 18.9714Z",
                                fill: "#C4C4C4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                clipRule: "evenodd",
                                d: "M18.0929 17.1905C18.0929 17.8286 17.5432 18.4762 16.5886 18.9714C15.5086 19.5429 14.0525 19.8571 12.5 19.8571C10.9475 19.8571 9.49143 19.5429 8.41143 18.9714C7.33143 18.4 6.90714 17.8286 6.90714 17.1905V8.97143C7.19538 9.21056 7.53105 9.42954 7.90714 9.62434C9.1038 10.2441 10.7098 10.619 12.5 10.619C14.2902 10.619 15.8962 10.2441 17.0929 9.62434C17.469 9.42954 17.8046 9.21056 18.0929 8.97143V17.1905ZM8.41143 5.02857C9.49143 4.45714 10.9475 4.14286 12.5 4.14286C14.0525 4.14286 15.5086 4.45714 16.5886 5.02857C17.6686 5.6 18.0929 6.17143 18.0929 6.80952C18.0929 7.44762 17.5432 8.09524 16.5886 8.59048C15.6339 9.08571 14.0525 9.47619 12.5 9.47619C10.9475 9.47619 9.49143 9.1619 8.41143 8.59048C7.33143 8.01905 6.90714 7.44762 6.90714 6.80952C6.90714 6.17143 7.45679 5.52381 8.41143 5.02857ZM5.75 6.80952C5.75 4.67619 8.71036 3 12.5 3C16.2896 3 19.25 4.67619 19.25 6.80952V17.1905C19.25 19.3238 16.2896 21 12.5 21C8.71036 21 5.75 19.3238 5.75 17.1905V6.80952Z",
                                fill: "#C4C4C4",
                                fillRule: "evenodd"
                            })
                        ]
                    }),
                    "LP"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58d62e832b07bfa1$export$37ab3bdebc286ca), {
                isActive: currentZapType === (0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).ZAP,
                onClick: ()=>{
                    handleButtonClick((0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).ZAP);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M15.751 4.06799C15.8489 4.12473 15.9246 4.21298 15.9658 4.31833C16.0071 4.42367 16.0114 4.53989 15.978 4.64799L14.177 10.5H17.5C17.5977 10.4999 17.6932 10.5285 17.7748 10.5821C17.8564 10.6358 17.9205 10.7121 17.9592 10.8018C17.9979 10.8914 18.0096 10.9905 17.9926 11.0866C17.9757 11.1828 17.931 11.2719 17.864 11.343L9.864 19.843C9.78659 19.9253 9.68359 19.979 9.57177 19.9952C9.45996 20.0115 9.34593 19.9894 9.24827 19.9326C9.15061 19.8758 9.07508 19.7875 9.03399 19.6823C8.9929 19.577 8.98868 19.461 9.022 19.353L10.823 13.5H7.5C7.40235 13.5 7.30682 13.4715 7.22521 13.4178C7.1436 13.3642 7.07948 13.2878 7.04077 13.1982C7.00205 13.1085 6.99044 13.0095 7.00737 12.9133C7.02429 12.8172 7.06901 12.728 7.136 12.657L15.136 4.15699C15.2133 4.07479 15.3162 4.02116 15.4278 4.00482C15.5395 3.98848 15.6534 4.01039 15.751 4.06699V4.06799Z",
                                fill: "#C4C4C4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                clipRule: "evenodd",
                                d: "M15.136 4.15699L7.136 12.657C7.06901 12.728 7.02429 12.8172 7.00737 12.9133C6.99044 13.0095 7.00205 13.1085 7.04077 13.1982C7.07948 13.2878 7.1436 13.3642 7.22521 13.4178C7.30682 13.4715 7.40235 13.5 7.5 13.5H10.823L9.022 19.353C8.98868 19.461 8.9929 19.577 9.03399 19.6823C9.07508 19.7875 9.15061 19.8758 9.24827 19.9326C9.34593 19.9894 9.45996 20.0115 9.57177 19.9952C9.68359 19.979 9.78659 19.9253 9.864 19.843L17.864 11.343C17.931 11.2719 17.9757 11.1828 17.9926 11.0866C18.0096 10.9905 17.9979 10.8914 17.9592 10.8018C17.9205 10.7121 17.8564 10.6358 17.7748 10.5821C17.6932 10.5285 17.5977 10.4999 17.5 10.5H14.177L15.978 4.64799C16.0114 4.53989 16.0071 4.42367 15.9658 4.31833C15.9246 4.21298 15.8489 4.12473 15.751 4.06799V4.06699C15.6534 4.01039 15.5395 3.98848 15.4278 4.00482C15.3645 4.01408 15.304 4.03533 15.2494 4.06699C15.2489 4.06732 15.2483 4.06765 15.2477 4.06799C15.2067 4.09199 15.169 4.12188 15.136 4.15699ZM14.3898 6.40894L8.65701 12.5H12.177L10.6105 17.5907L16.343 11.5H12.823L14.3898 6.40894ZM9.1358 19.1576C9.13574 19.1577 9.13586 19.1576 9.1358 19.1576Z",
                                fill: "#C4C4C4",
                                fillRule: "evenodd"
                            })
                        ]
                    }),
                    "Zap"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58d62e832b07bfa1$export$37ab3bdebc286ca), {
                isActive: currentZapType === (0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).DUAL,
                onClick: ()=>{
                    handleButtonClick((0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).DUAL);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            clipRule: "evenodd",
                            d: "M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z",
                            fill: "#C4C4C4",
                            fillRule: "evenodd"
                        })
                    }),
                    "Add"
                ]
            })
        ]
    });
};



const $00800dcb8b3e1993$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-10w1p7a-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "1rem"
});
const $00800dcb8b3e1993$export$9d50784561433df2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-10w1p7a-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "1rem"
});


const $9ff132523d0da48b$export$79d8b686bedbd98d = [
    "₀",
    "₁",
    "₂",
    "₃",
    "₄",
    "₅",
    "₆",
    "₇",
    "₈",
    "₉"
];



const $62681a7eaa870c9b$export$26053c9414c66e8d = (value, options)=>{
    const { maximumFractionDigits: maximumFractionDigits = 0 } = options ?? {};
    const currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: maximumFractionDigits,
        ...options
    });
    if (Number(Number(value).toFixed(maximumFractionDigits)) === 0) return currencyFormatter.format(0);
    return currencyFormatter.format(Number(value));
};
const $62681a7eaa870c9b$export$931b799afb644eab = (value, options)=>{
    const currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        ...options
    });
    return currencyFormatter.format(Number(value));
};
const $62681a7eaa870c9b$export$301b86ca0918a05b = (value, options)=>{
    const apyFormatter = new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
        ...options
    });
    const formattedValue = apyFormatter.format(value);
    return formattedValue === "-0%" ? "0%" : formattedValue;
};
const $62681a7eaa870c9b$export$9beb615f731480fd = (value, options)=>{
    const numberFormatter = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        ...options
    });
    const formattedValue = numberFormatter.format(value);
    return formattedValue === "-0" ? "0" : formattedValue;
};
const $62681a7eaa870c9b$export$164ec61f0ed23108 = (value)=>{
    const regexResult = /(?<zeros>0{1,20})(?<decimals>\d+)/u.exec(value);
    if (!regexResult?.groups) return value;
    const { zeros: zeros, decimals: decimals } = regexResult.groups;
    const zerosLength = zeros.length;
    const subZerosLength = zerosLength.toString().split("").map((digit)=>(0, $9ff132523d0da48b$export$79d8b686bedbd98d)[Number(digit)]).join("");
    return `0${subZerosLength}${decimals}`;
};
const $62681a7eaa870c9b$export$c15bed34ee7edd63 = (value, options)=>{
    const maximumFractionDigits = 4;
    const formatterOptions = {
        ...options,
        maximumFractionDigits: maximumFractionDigits
    }; // minValue equals to 0.00000001
    const minValue = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(-maximumFractionDigits);
    if (value.gt(0) && value.lt(minValue)) {
        const formattedValue = $62681a7eaa870c9b$export$9beb615f731480fd(minValue.toNumber(), formatterOptions);
        return `<${formattedValue}`;
    }
    return $62681a7eaa870c9b$export$9beb615f731480fd(value.toNumber(), formatterOptions);
};
const $62681a7eaa870c9b$export$4356254075e80b7d = (value, options)=>{
    let formatterValue = value;
    let postfix = "";
    if (value > 1000000) {
        formatterValue = value / 1000000;
        postfix = "M";
    } else if (value > 1000) {
        formatterValue = value / 1000;
        postfix = "K";
    } else {
        formatterValue = value;
        postfix = "";
    }
    const formattedValue = $62681a7eaa870c9b$export$9beb615f731480fd(formatterValue, options);
    return `${formattedValue}${postfix}`;
};
const $62681a7eaa870c9b$export$92521769c5df59ad = (timestamp, options)=>{
    const dateFormatter = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        ...options
    });
    return dateFormatter.format(timestamp);
};
const $62681a7eaa870c9b$export$247b7dec1c2fd456 = (timestamp, options)=>$62681a7eaa870c9b$export$92521769c5df59ad(timestamp, {
        hour: undefined,
        minute: undefined,
        second: undefined,
        ...options
    });
const $62681a7eaa870c9b$export$fe12fcc29c32b46 = (timestamp, options)=>$62681a7eaa870c9b$export$92521769c5df59ad(timestamp, {
        year: undefined,
        month: undefined,
        day: undefined,
        ...options
    });
const $62681a7eaa870c9b$export$d3bd6110a3b8e5a6 = (days, hours, minutes, seconds)=>[
        days,
        hours,
        minutes,
        seconds
    ].map((value)=>value.toString().padStart(2, "0"));


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}






function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}



var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};





function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $d807b28d49bc99ee$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $d807b28d49bc99ee$var$CONTENT_CLASS = "tippy-content";
var $d807b28d49bc99ee$var$BACKDROP_CLASS = "tippy-backdrop";
var $d807b28d49bc99ee$var$ARROW_CLASS = "tippy-arrow";
var $d807b28d49bc99ee$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $d807b28d49bc99ee$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $d807b28d49bc99ee$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $d807b28d49bc99ee$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $d807b28d49bc99ee$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $d807b28d49bc99ee$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $d807b28d49bc99ee$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $d807b28d49bc99ee$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $d807b28d49bc99ee$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $d807b28d49bc99ee$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $d807b28d49bc99ee$var$normalizeToArray(value) {
    return [].concat(value);
}
function $d807b28d49bc99ee$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $d807b28d49bc99ee$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $d807b28d49bc99ee$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $d807b28d49bc99ee$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $d807b28d49bc99ee$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $d807b28d49bc99ee$var$div() {
    return document.createElement("div");
}
function $d807b28d49bc99ee$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $d807b28d49bc99ee$var$isType(value, type);
    });
}
function $d807b28d49bc99ee$var$isNodeList(value) {
    return $d807b28d49bc99ee$var$isType(value, "NodeList");
}
function $d807b28d49bc99ee$var$isMouseEvent(value) {
    return $d807b28d49bc99ee$var$isType(value, "MouseEvent");
}
function $d807b28d49bc99ee$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $d807b28d49bc99ee$var$getArrayOfElements(value) {
    if ($d807b28d49bc99ee$var$isElement(value)) return [
        value
    ];
    if ($d807b28d49bc99ee$var$isNodeList(value)) return $d807b28d49bc99ee$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $d807b28d49bc99ee$var$arrayFrom(document.querySelectorAll(value));
}
function $d807b28d49bc99ee$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $d807b28d49bc99ee$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $d807b28d49bc99ee$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $d807b28d49bc99ee$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $d807b28d49bc99ee$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $d807b28d49bc99ee$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $d807b28d49bc99ee$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $d807b28d49bc99ee$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $d807b28d49bc99ee$var$currentInput = {
    isTouch: false
};
var $d807b28d49bc99ee$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $d807b28d49bc99ee$var$onDocumentTouchStart() {
    if ($d807b28d49bc99ee$var$currentInput.isTouch) return;
    $d807b28d49bc99ee$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $d807b28d49bc99ee$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $d807b28d49bc99ee$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $d807b28d49bc99ee$var$lastMouseMoveTime < 20) {
        $d807b28d49bc99ee$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $d807b28d49bc99ee$var$onDocumentMouseMove);
    }
    $d807b28d49bc99ee$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $d807b28d49bc99ee$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($d807b28d49bc99ee$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $d807b28d49bc99ee$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $d807b28d49bc99ee$var$onDocumentTouchStart, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $d807b28d49bc99ee$var$onWindowBlur);
}
var $d807b28d49bc99ee$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $d807b28d49bc99ee$var$isIE11 = $d807b28d49bc99ee$var$isBrowser ? !!window.msCrypto : false;
function $d807b28d49bc99ee$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $d807b28d49bc99ee$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $d807b28d49bc99ee$var$getDevMessage(message) {
    return $d807b28d49bc99ee$var$clean("\n  %ctippy.js\n\n  %c" + $d807b28d49bc99ee$var$clean(message) + "\n\n  %c\uD83D\uDC77‍ This is a development-only message. It will be removed in production.\n  ");
}
function $d807b28d49bc99ee$var$getFormattedMessage(message) {
    return [
        $d807b28d49bc99ee$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $d807b28d49bc99ee$var$visitedMessages;
function $d807b28d49bc99ee$var$resetVisitedMessages() {
    $d807b28d49bc99ee$var$visitedMessages = new Set();
}
function $d807b28d49bc99ee$var$warnWhen(condition, message) {
    if (condition && !$d807b28d49bc99ee$var$visitedMessages.has(message)) {
        var _console;
        $d807b28d49bc99ee$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $d807b28d49bc99ee$var$getFormattedMessage(message));
    }
}
function $d807b28d49bc99ee$var$errorWhen(condition, message) {
    if (condition && !$d807b28d49bc99ee$var$visitedMessages.has(message)) {
        var _console2;
        $d807b28d49bc99ee$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $d807b28d49bc99ee$var$getFormattedMessage(message));
    }
}
function $d807b28d49bc99ee$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $d807b28d49bc99ee$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $d807b28d49bc99ee$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $d807b28d49bc99ee$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $d807b28d49bc99ee$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $d807b28d49bc99ee$var$defaultProps = Object.assign({
    appendTo: $d807b28d49bc99ee$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $d807b28d49bc99ee$var$pluginProps, $d807b28d49bc99ee$var$renderProps);
var $d807b28d49bc99ee$var$defaultKeys = Object.keys($d807b28d49bc99ee$var$defaultProps);
var $d807b28d49bc99ee$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $d807b28d49bc99ee$var$defaultProps[key] = partialProps[key];
    });
};
function $d807b28d49bc99ee$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $d807b28d49bc99ee$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $d807b28d49bc99ee$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($d807b28d49bc99ee$var$getExtendedPassedProps(Object.assign({}, $d807b28d49bc99ee$var$defaultProps, {
        plugins: plugins
    }))) : $d807b28d49bc99ee$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $d807b28d49bc99ee$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $d807b28d49bc99ee$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $d807b28d49bc99ee$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $d807b28d49bc99ee$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $d807b28d49bc99ee$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $d807b28d49bc99ee$var$removeProperties($d807b28d49bc99ee$var$defaultProps, Object.keys($d807b28d49bc99ee$var$pluginProps));
        var didPassUnknownProp = !$d807b28d49bc99ee$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $d807b28d49bc99ee$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
function $d807b28d49bc99ee$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $d807b28d49bc99ee$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($d807b28d49bc99ee$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($d807b28d49bc99ee$var$ARROW_CLASS) || node.classList.contains($d807b28d49bc99ee$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($d807b28d49bc99ee$var$BACKDROP_CLASS);
        })
    };
}
var $d807b28d49bc99ee$var$idCounter = 1;
var $d807b28d49bc99ee$var$mouseMoveListeners = []; // Used by `hideAll()`
var $d807b28d49bc99ee$var$mountedInstances = [];
function $d807b28d49bc99ee$var$createTippy(reference, passedProps) {
    var props = $d807b28d49bc99ee$var$evaluateProps(reference, Object.assign({}, $d807b28d49bc99ee$var$defaultProps, $d807b28d49bc99ee$var$getExtendedPassedProps($d807b28d49bc99ee$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $d807b28d49bc99ee$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $d807b28d49bc99ee$var$idCounter++;
    var popperInstance = null;
    var plugins = $d807b28d49bc99ee$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $d807b28d49bc99ee$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $d807b28d49bc99ee$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $d807b28d49bc99ee$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $d807b28d49bc99ee$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $d807b28d49bc99ee$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $d807b28d49bc99ee$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $d807b28d49bc99ee$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $d807b28d49bc99ee$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $d807b28d49bc99ee$var$mouseMoveListeners = $d807b28d49bc99ee$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($d807b28d49bc99ee$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $d807b28d49bc99ee$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($d807b28d49bc99ee$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $d807b28d49bc99ee$var$actualContains(el, actualTarget);
        })) {
            if ($d807b28d49bc99ee$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $d807b28d49bc99ee$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $d807b28d49bc99ee$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $d807b28d49bc99ee$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $d807b28d49bc99ee$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $d807b28d49bc99ee$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($d807b28d49bc99ee$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $d807b28d49bc99ee$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $d807b28d49bc99ee$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($d807b28d49bc99ee$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $d807b28d49bc99ee$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $d807b28d49bc99ee$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $d807b28d49bc99ee$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $d807b28d49bc99ee$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $d807b28d49bc99ee$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($d807b28d49bc99ee$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $d807b28d49bc99ee$var$evaluateProps(reference, Object.assign({}, prevProps, $d807b28d49bc99ee$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $d807b28d49bc99ee$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $d807b28d49bc99ee$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $d807b28d49bc99ee$var$currentInput.isTouch && !instance.props.touch;
        var duration = $d807b28d49bc99ee$var$getValueAtIndexOrReturn(instance.props.duration, 0, $d807b28d49bc99ee$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $d807b28d49bc99ee$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $d807b28d49bc99ee$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $d807b28d49bc99ee$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $d807b28d49bc99ee$var$pushIfUnique($d807b28d49bc99ee$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $d807b28d49bc99ee$var$getValueAtIndexOrReturn(instance.props.duration, 1, $d807b28d49bc99ee$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $d807b28d49bc99ee$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $d807b28d49bc99ee$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $d807b28d49bc99ee$var$pushIfUnique($d807b28d49bc99ee$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $d807b28d49bc99ee$var$mountedInstances = $d807b28d49bc99ee$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $d807b28d49bc99ee$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $d807b28d49bc99ee$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $d807b28d49bc99ee$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $d807b28d49bc99ee$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $d807b28d49bc99ee$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $d807b28d49bc99ee$var$isElement(targets) ? instances[0] : instances;
}
$d807b28d49bc99ee$var$tippy.defaultProps = $d807b28d49bc99ee$var$defaultProps;
$d807b28d49bc99ee$var$tippy.setDefaultProps = $d807b28d49bc99ee$var$setDefaultProps;
$d807b28d49bc99ee$var$tippy.currentInput = $d807b28d49bc99ee$var$currentInput;
var $d807b28d49bc99ee$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $d807b28d49bc99ee$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $d807b28d49bc99ee$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $d807b28d49bc99ee$var$applyStylesModifier = Object.assign({}, (0, $7deefb3680d4558f$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $d807b28d49bc99ee$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $d807b28d49bc99ee$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $d807b28d49bc99ee$var$tippy($d807b28d49bc99ee$var$div(), Object.assign({}, $d807b28d49bc99ee$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $d807b28d49bc99ee$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $d807b28d49bc99ee$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $d807b28d49bc99ee$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $d807b28d49bc99ee$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $d807b28d49bc99ee$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $d807b28d49bc99ee$var$tippy(targets, parentProps);
    var normalizedReturnValue = $d807b28d49bc99ee$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $d807b28d49bc99ee$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($d807b28d49bc99ee$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $d807b28d49bc99ee$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $d807b28d49bc99ee$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $d807b28d49bc99ee$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $d807b28d49bc99ee$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $d807b28d49bc99ee$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $d807b28d49bc99ee$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $d807b28d49bc99ee$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $d807b28d49bc99ee$var$createBackdropElement() {
    var backdrop = $d807b28d49bc99ee$var$div();
    backdrop.className = $d807b28d49bc99ee$var$BACKDROP_CLASS;
    $d807b28d49bc99ee$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $d807b28d49bc99ee$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $d807b28d49bc99ee$var$activeInstances = [];
function $d807b28d49bc99ee$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $d807b28d49bc99ee$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $d807b28d49bc99ee$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $d807b28d49bc99ee$var$storeMouseCoords);
}
function $d807b28d49bc99ee$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $d807b28d49bc99ee$var$storeMouseCoords);
}
var $d807b28d49bc99ee$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $d807b28d49bc99ee$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $d807b28d49bc99ee$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $d807b28d49bc99ee$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $d807b28d49bc99ee$var$activeInstances = $d807b28d49bc99ee$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($d807b28d49bc99ee$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $d807b28d49bc99ee$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($d807b28d49bc99ee$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($d807b28d49bc99ee$var$isMouseEvent(event)) $d807b28d49bc99ee$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $d807b28d49bc99ee$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $d807b28d49bc99ee$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $d807b28d49bc99ee$var$getInlineBoundingClientRect($d807b28d49bc99ee$var$getBasePlacement(placement), reference.getBoundingClientRect(), $d807b28d49bc99ee$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($d807b28d49bc99ee$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($d807b28d49bc99ee$var$isMouseEvent(event)) {
                    var rects = $d807b28d49bc99ee$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $d807b28d49bc99ee$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $d807b28d49bc99ee$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $d807b28d49bc99ee$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $d807b28d49bc99ee$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $d807b28d49bc99ee$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$d807b28d49bc99ee$var$tippy.setDefaultProps({
    animation: false
});
var $d807b28d49bc99ee$export$2e2bcd8739ae039 = $d807b28d49bc99ee$var$tippy;



var $acw62 = parcelRequire("acw62");

function $af2008d5969d49e7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $af2008d5969d49e7$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
function $af2008d5969d49e7$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === "function") ref(node);
        if (({}).hasOwnProperty.call(ref, "current")) ref.current = node;
    }
}
function $af2008d5969d49e7$var$ssrSafeCreateDiv() {
    return $af2008d5969d49e7$var$isBrowser && document.createElement("div");
}
function $af2008d5969d49e7$var$toDataAttributes(attrs) {
    var dataAttrs = {
        "data-placement": attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs["data-reference-hidden"] = "";
    if (attrs.escaped) dataAttrs["data-escaped"] = "";
    return dataAttrs;
}
function $af2008d5969d49e7$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === "object" && x != null && typeof y === "object" && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$af2008d5969d49e7$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $af2008d5969d49e7$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $af2008d5969d49e7$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $af2008d5969d49e7$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $af2008d5969d49e7$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $af2008d5969d49e7$var$useIsomorphicLayoutEffect = $af2008d5969d49e7$var$isBrowser ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $af2008d5969d49e7$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $acw62.useRef)();
    if (!ref.current) ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
    return ref.current;
}
function $af2008d5969d49e7$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $af2008d5969d49e7$var$classNamePlugin = {
    name: "className",
    defaultValue: "",
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            $af2008d5969d49e7$var$updateClassName(box, "add", instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $af2008d5969d49e7$var$updateClassName(box, "remove", instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $af2008d5969d49e7$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $af2008d5969d49e7$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $acw62.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $acw62.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $acw62.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $af2008d5969d49e7$var$useMutableBox(function() {
            return {
                container: $af2008d5969d49e7$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = "manual";
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $af2008d5969d49e7$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty("current")) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $af2008d5969d49e7$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $af2008d5969d49e7$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $af2008d5969d49e7$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($af2008d5969d49e7$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        $af2008d5969d49e7$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== "$$tippyReact";
                    }), [
                        {
                            name: "$$tippyReact",
                            enabled: true,
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children ? /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $af2008d5969d49e7$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(render ? render($af2008d5969d49e7$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $af2008d5969d49e7$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $acw62.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $af2008d5969d49e7$var$useMutableBox({
            children: [],
            renders: 1
        });
        $af2008d5969d49e7$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $af2008d5969d49e7$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $af2008d5969d49e7$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $af2008d5969d49e7$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($af2008d5969d49e7$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $acw62.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $af2008d5969d49e7$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $af2008d5969d49e7$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
            ref: function ref(node) {
                $af2008d5969d49e7$var$preserveRef(_ref2, node);
                $af2008d5969d49e7$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $af2008d5969d49e7$export$abf4268d2dd55708 = /*#__PURE__*/ $af2008d5969d49e7$var$useSingletonGenerator((0, $d807b28d49bc99ee$export$374c483667c1ea9b));
var $af2008d5969d49e7$var$headless = /*#__PURE__*/ $af2008d5969d49e7$var$forwardRef(/*#__PURE__*/ $af2008d5969d49e7$var$TippyGenerator((0, $d807b28d49bc99ee$export$2e2bcd8739ae039)), {
    render: function render() {
        return "";
    }
});
var $af2008d5969d49e7$export$2e2bcd8739ae039 = $af2008d5969d49e7$var$headless;



const $10bfaa4306733f1f$var$whiteColor = "#FFFFFF";
const $10bfaa4306733f1f$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-sf8hxl-0"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))",
    "padding": "0.5rem",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(255, 255, 255, var(--tw-border-opacity))",
    "maxHeight": "50vh",
    "overflow": "auto"
});
const $10bfaa4306733f1f$export$21b07c8f274aebd5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-sf8hxl-1"
})({
    "width": "0.75rem",
    "height": "0.75rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))",
    "--tw-rotate": "45deg",
    "transform": "var(--tw-transform)",
    "position": "relative",
    "top": "-0.375rem",
    "borderRightWidth": "1px",
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(255, 255, 255, var(--tw-border-opacity))"
});
const $10bfaa4306733f1f$export$90a924e5f45b272e = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-sf8hxl-2"
})([
    "",
    " text-decoration:",
    ";text-decoration-style:dotted;text-decoration-color:",
    ";"
], {
    "display": "flex",
    "cursor": "pointer"
}, ({ disabledUnderline: disabledUnderline })=>disabledUnderline ? "none" : "underline", $10bfaa4306733f1f$var$whiteColor);



const $7050bc590ac1eef8$export$28c660c63b792dea = ({ content: content, children: children, disabledUnderline: disabledUnderline })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af2008d5969d49e7$export$2e2bcd8739ae039), {
        appendTo: ()=>document.body,
        interactive: true,
        render: (attributes)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...attributes,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10bfaa4306733f1f$export$42a852a2b6b56249), {
                        children: content
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-popper-arrow": "",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10bfaa4306733f1f$export$21b07c8f274aebd5), {})
                    })
                ]
            }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10bfaa4306733f1f$export$90a924e5f45b272e), {
            disabledUnderline: disabledUnderline,
            children: children
        })
    });



const $5a8458cc154f95c7$export$123447cf2124c743 = (tokenData)=>{
    if (tokenData === undefined) return "-";
    const { balance: balance } = tokenData;
    if (balance === null) return "N/A";
    return (0, $62681a7eaa870c9b$export$c15bed34ee7edd63)(balance);
};



const $4d125f6ec40b3c1a$export$8c7291e6ea0abb35 = {
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).QUICKSWAP]: "QuickSwap",
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).UNISWAPV2]: "Uniswap v2",
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).SUSHISWAP]: "SushiSwap"
};





const $5c76125541893789$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-8cv8zn-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.5rem"
});
const $5c76125541893789$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-8cv8zn-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.25rem"
});
const $5c76125541893789$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-8cv8zn-2"
})({
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "500"
});
const $5c76125541893789$export$6d08773d2e66f8f2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-8cv8zn-3"
})({
    "display": "flex",
    "gap": "0.25rem"
});
const $5c76125541893789$export$4c8d1a57a761ef94 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($5c76125541893789$export$f99233281efd08a0).withConfig({
    componentId: "sc-8cv8zn-4"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(59, 153, 252, var(--tw-text-opacity))"
});
const $5c76125541893789$export$571b33f40b6bd9e5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($5c76125541893789$export$f99233281efd08a0).withConfig({
    componentId: "sc-8cv8zn-5"
})({
    "fontWeight": "600"
});
const $5c76125541893789$export$d5c56664638992a4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-8cv8zn-6"
})({
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))"
});
const $5c76125541893789$export$a6c7ac8248d6e38a = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.attrs({
    target: "_blank"
}).withConfig({
    componentId: "sc-8cv8zn-7"
})([
    "",
    ""
], {
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(59, 153, 252, var(--tw-text-opacity))",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(59, 153, 252, var(--tw-text-opacity))"
    }
});



const $30360e99936837d5$export$7fd7ec3944df7f43 = ({ source: source, swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: // eslint-disable-next-line @typescript-eslint/no-unused-vars
rewardAPY })=>{
    const pairSourceTitle = (0, $4d125f6ec40b3c1a$export$8c7291e6ea0abb35)[source];
    const formattedSwapFeesAPY = (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(swapFeesAPY);
    const formattedRoeSupplyAPY = (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(roeSupplyAPY); // const formattedRewardAPY = getFormattedAPY(rewardAPY);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c76125541893789$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$571b33f40b6bd9e5), {
                children: "Supply APY Breakdown"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c76125541893789$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c76125541893789$export$6d08773d2e66f8f2), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$4c8d1a57a761ef94), {
                                children: formattedSwapFeesAPY
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$f99233281efd08a0), {
                                children: `${pairSourceTitle} Fees`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$d5c56664638992a4), {
                                children: "(avg. over past 7 days)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c76125541893789$export$6d08773d2e66f8f2), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$4c8d1a57a761ef94), {
                                children: formattedRoeSupplyAPY
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$f99233281efd08a0), {
                                children: "ROE Supply Interest"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c76125541893789$export$a6c7ac8248d6e38a), {
                href: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).gitBookSupply,
                children: "Learn More"
            })
        ]
    });
};


const $d91182ae554a6565$export$74ad4538f9721c00 = ({ swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY })=>swapFeesAPY + roeSupplyAPY;
const $d91182ae554a6565$export$1be513a619b91a39 = ({ swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: // eslint-disable-next-line @typescript-eslint/no-unused-vars
rewardAPY })=>swapFeesAPY + roeSupplyAPY; /* + rewardAPY */ 





const $957a77a5ae9cd736$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-lodpjr-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.125rem",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem"
});
const $957a77a5ae9cd736$export$b59bdbef9ce70de2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-lodpjr-1"
})({
    "display": "flex",
    "justifyContent": "space-between"
});
const $957a77a5ae9cd736$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-lodpjr-2"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "500"
});
const $957a77a5ae9cd736$export$4c8d1a57a761ef94 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($957a77a5ae9cd736$export$f99233281efd08a0).withConfig({
    componentId: "sc-lodpjr-3"
})({
    "textAlign": "right"
});




const $b88022a1b0f98dae$export$c4868e4a24d48fad = ()=>{
    const { tabType: tabType, pairData: pairData } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { tokenData: tokenData } = (0, $7d64a5251f30eaf8$export$1b909ddfc3d23cdb)();
    const formattedTokenBalance = (0, $5a8458cc154f95c7$export$123447cf2124c743)(tokenData);
    const formattedSupplyAPY = pairData ? (0, $62681a7eaa870c9b$export$301b86ca0918a05b)((0, $d91182ae554a6565$export$1be513a619b91a39)(pairData)) : "-"; // TODO: add Reward APY later
    // const formattedRewardAPY = pairData
    //   ? getFormattedAPY(pairData.rewardAPY)
    //   : "-";
    const formattedFees = (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(0);
    const title = tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? "Your ROE LP Token Balance" : "Your LP Token Balance";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $957a77a5ae9cd736$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $957a77a5ae9cd736$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$f99233281efd08a0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$4c8d1a57a761ef94), {
                        children: formattedTokenBalance
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $957a77a5ae9cd736$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$f99233281efd08a0), {
                        children: "Supply APY"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7050bc590ac1eef8$export$28c660c63b792dea), {
                        content: pairData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30360e99936837d5$export$7fd7ec3944df7f43), {
                            rewardAPY: pairData.rewardAPY,
                            roeSupplyAPY: pairData.roeSupplyAPY,
                            source: pairData.source,
                            swapFeesAPY: pairData.swapFeesAPY
                        }) : null,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$4c8d1a57a761ef94), {
                            children: formattedSupplyAPY
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $957a77a5ae9cd736$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$f99233281efd08a0), {
                        children: "Fees"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $957a77a5ae9cd736$export$4c8d1a57a761ef94), {
                        children: formattedFees
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
const $2fdb081c89f7eb15$export$d2f6f354293ef9f = "connectWallet";


/* eslint-disable react/forbid-component-props */ 
var $7a1b98988c432200$export$11e69cb9544e2d71;
(function(BigButtonColor) {
    BigButtonColor["BLUE"] = "BLUE";
    BigButtonColor["WHITE"] = "WHITE";
    BigButtonColor["BRAND"] = "BRAND";
    BigButtonColor["GRAY"] = "GRAY";
    BigButtonColor["LIGHTGRAY"] = "LIGHTGRAY";
    BigButtonColor["RED"] = "RED";
    BigButtonColor["GRADIENT"] = "GRADIENT";
})($7a1b98988c432200$export$11e69cb9544e2d71 || ($7a1b98988c432200$export$11e69cb9544e2d71 = {}));


const $4d56c610330dfb79$var$grayDarkColor = "#262B37";
const $4d56c610330dfb79$var$gradientColor = "linear-gradient(90deg, #ff4e02 0%, #fd800e 25%, #fba617 82%, #fc601e 135%)";
const $4d56c610330dfb79$var$blueButtonStyle = {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(59, 153, 252, var(--tw-bg-opacity))",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(23, 115, 213, var(--tw-bg-opacity))"
    }
};
const $4d56c610330dfb79$var$whiteButtonStyle = {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(230, 230, 230, var(--tw-bg-opacity))"
    }
};
const $4d56c610330dfb79$var$brandButtonStyle = {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(52, 105, 250, var(--tw-bg-opacity))",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(27, 82, 233, var(--tw-bg-opacity))"
    }
};
const $4d56c610330dfb79$var$grayButtonStyle = {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))"
};
const $4d56c610330dfb79$var$lightGrayButtonStyle = {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(150, 150, 150, var(--tw-bg-opacity))"
};
const $4d56c610330dfb79$var$redButtonStyle = {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(220, 38, 38, var(--tw-bg-opacity))"
};
const $4d56c610330dfb79$var$gradientButtonStyle = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)([
    "background:linear-gradient(",
    ",",
    ") padding-box,",
    " border-box;border:1px solid transparent;"
], $4d56c610330dfb79$var$grayDarkColor, $4d56c610330dfb79$var$grayDarkColor, $4d56c610330dfb79$var$gradientColor);
const $4d56c610330dfb79$var$bigButtonStyles = {
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).BLUE]: $4d56c610330dfb79$var$blueButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).WHITE]: $4d56c610330dfb79$var$whiteButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).BRAND]: $4d56c610330dfb79$var$brandButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).GRAY]: $4d56c610330dfb79$var$grayButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).LIGHTGRAY]: $4d56c610330dfb79$var$lightGrayButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).RED]: $4d56c610330dfb79$var$redButtonStyle,
    [(0, $7a1b98988c432200$export$11e69cb9544e2d71).GRADIENT]: $4d56c610330dfb79$var$gradientButtonStyle
};
const $4d56c610330dfb79$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1g3amn5-0"
})([
    "",
    " ",
    " ",
    ""
], {
    "transitionProperty": "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "borderRadius": "0.5rem",
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "fontWeight": "600"
}, ({ disabled: disabled = false })=>disabled ? {
        "opacity": "0.6",
        "cursor": "not-allowed"
    } : {
        ":active": {
            "--tw-scale-x": ".9",
            "--tw-scale-y": ".9",
            "transform": "var(--tw-transform)"
        }
    }, ({ color: color })=>$4d56c610330dfb79$var$bigButtonStyles[color]);
const $4d56c610330dfb79$export$9135d69ffc0e7e5f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1g3amn5-1"
})([
    "background:",
    ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;"
], $4d56c610330dfb79$var$gradientColor);




const $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b = ({ color: color, disabled: disabled, isLoading: isLoading, className: className, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d56c610330dfb79$export$353f5b6fc5456de1), {
        className: className,
        color: color,
        disabled: Boolean(disabled) || Boolean(isLoading),
        onClick: onClick,
        children: color === (0, $7a1b98988c432200$export$11e69cb9544e2d71).GRADIENT ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d56c610330dfb79$export$9135d69ffc0e7e5f), {
            children: children
        }) : children
    });





const $54ed3f43a20cf460$export$2c5011646c0b20c3 = ()=>{
    const { pushModal: pushModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    const showConnectWalletModal = (0, $acw62.useCallback)(()=>{
        pushModal((0, $2fdb081c89f7eb15$export$d2f6f354293ef9f));
    }, [
        pushModal
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).BLUE,
        onClick: showConnectWalletModal,
        children: "Connect Wallet"
    });
};






const $55ba62859e938d36$export$f56a791e7be511c0 = ({ title: title })=>{
    const { hideModal: hideModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).GRADIENT,
        onClick: ()=>{
            hideModal();
        },
        children: title
    });
};






const $7ab8ea50554bbd0f$export$816620cd7b25dd31 = ({ error: error, tokenData: tokenData })=>{
    if (!error) return null;
    let buttonTitle = "";
    if (error === (0, $86c0cfc9656a567e$export$12eeba8c72faa230).INSUFFICIENT_TOKEN_BALANCE) buttonTitle = tokenData ? `Insufficient ${tokenData.symbol} Balance` : "Insufficient Balance";
    else if (error === (0, $86c0cfc9656a567e$export$12eeba8c72faa230).INSUFFICIENT_TOKEN_INPUT) buttonTitle = tokenData ? `Insufficient ${tokenData.symbol} Input` : "Insufficient Input";
    else buttonTitle = "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).RED,
        disabled: true,
        children: buttonTitle
    });
};





const $3af1e2106769a6d0$export$e961fcd722c3cf24 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).GRAY,
        disabled: true,
        children: "Wrong Network"
    });





const $13b46140d36dc22c$export$2673c1d31784339c = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).GRAY,
        disabled: true,
        children: "Enter an amount"
    });







var $acw62 = parcelRequire("acw62");

const $f4415cf9cc1bd9fd$export$171bc4433675c7 = ()=>(0, $acw62.useContext)((0, $1960857fdaf79085$export$c0c912d9972e5264));





var $acw62 = parcelRequire("acw62");





const $96da19a48dc13d93$export$90584b9d5e24e0e4 = ({ mutation: mutation, resetTransaction: resetTransaction })=>{
    const { error: error } = mutation;
    const message = error?.message;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).RED,
        onClick: resetTransaction,
        children: message
    });
};



const $bc28b727e7e4d99b$export$98237485cba9eb33 = ({ tokenApproveTransaction: tokenApproveTransaction, spenderAddress: spenderAddress, tokenData: tokenData })=>{
    const { mutation: mutation, resetTransaction: resetTransaction, runTransaction: runTransaction } = tokenApproveTransaction;
    const { isError: isError, isLoading: isLoading } = mutation;
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        if (spenderAddress) runTransaction(spenderAddress);
    }, [
        runTransaction,
        spenderAddress
    ]);
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96da19a48dc13d93$export$90584b9d5e24e0e4), {
        mutation: mutation,
        resetTransaction: resetTransaction
    });
    const prefix = isLoading ? "Approving" : "Approve";
    const postfix = isLoading ? "..." : "";
    const title = tokenData ? `${prefix} ${tokenData.symbol}${postfix}` : `${prefix}${postfix}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).WHITE,
        disabled: !spenderAddress,
        isLoading: isLoading,
        onClick: handleButtonClick,
        children: title
    });
};







const $3d456d29a64bb92e$export$98237485cba9eb33 = ()=>{
    const { pairData: pairData } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { tokenApproveTransaction: tokenApproveTransaction } = (0, $f4415cf9cc1bd9fd$export$171bc4433675c7)();
    const { addresses: addresses, isUseZapTransactionForToken: isUseZapTransactionForToken } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { tokenData: tokenData } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const lendingPoolAddress = pairData?.lendingPoolAddress ?? "";
    const { zapBoxAddress: zapBoxAddress } = addresses; // spenderAddress for zap tokens - zapBoxAddress
    // spenderAddress for lpToken and roeLpToken - lendingPoolAddress
    const spenderAddress = isUseZapTransactionForToken(tokenData) ? zapBoxAddress : lendingPoolAddress;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc28b727e7e4d99b$export$98237485cba9eb33), {
        spenderAddress: spenderAddress,
        tokenApproveTransaction: tokenApproveTransaction,
        tokenData: tokenData
    });
};







var $acw62 = parcelRequire("acw62");







const $4bb978cf8f88b8e3$export$dc6f45aeed9e460f = ()=>{
    const { tabType: tabType } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { pairQuery: pairQuery, pairTokenQuery: pairTokenQuery, aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const { lendingPoolTransaction: lendingPoolTransaction } = (0, $f4415cf9cc1bd9fd$export$171bc4433675c7)();
    const { tokenData: tokenData, inputValueBig: inputValueBig } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const { mutation: mutation, resetTransaction: resetTransaction, runTransaction: runTransaction } = lendingPoolTransaction;
    const dependantQueries = [
        pairQuery,
        pairTokenQuery,
        aTokenQuery
    ];
    const [buttonTitle, loadingButtonTitle] = tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? [
        "Supply",
        "Supplying..."
    ] : [
        "Withdraw",
        "Withdrawing..."
    ];
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        const pairAddress = pairTokenQuery.data?.address;
        if (tokenData && pairAddress) {
            const amount = (0, $12b684a6faa19c6a$export$c0657b8b46b96a9a)(inputValueBig, tokenData).toString();
            runTransaction(pairAddress, amount);
        }
    }, [
        pairTokenQuery,
        tokenData,
        inputValueBig,
        runTransaction
    ]);
    const { isError: isError, isLoading: isLoading } = mutation;
    const isButtonDisabled = inputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)()) || dependantQueries.some((query)=>query.isLoading);
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96da19a48dc13d93$export$90584b9d5e24e0e4), {
        mutation: mutation,
        resetTransaction: resetTransaction
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).BRAND,
        disabled: isButtonDisabled,
        isLoading: isLoading,
        onClick: handleButtonClick,
        children: isLoading ? loadingButtonTitle : buttonTitle
    });
};







var $acw62 = parcelRequire("acw62");





const $959db82b481462db$export$a7e7d68c3797f440 = (token0Data, token0InputValueBig, token1Data, token1InputValueBig)=>{
    const token0DataAddress = token0Data.address;
    const token1DataAddress = token1Data.address;
    const token0DataAmount = (0, $12b684a6faa19c6a$export$c0657b8b46b96a9a)(token0InputValueBig, token0Data).toString();
    const token1DataAmount = (0, $12b684a6faa19c6a$export$c0657b8b46b96a9a)(token1InputValueBig, token1Data).toString();
    const isToken0NativeCoin = (0, $17ea153afdabe1fb$export$81809787e85049ab)(token0Data);
    const [token0Address, token0Amount] = isToken0NativeCoin ? [
        token1DataAddress,
        token1DataAmount
    ] : [
        token0DataAddress,
        token0DataAmount
    ];
    const [token1Address, token1Amount] = isToken0NativeCoin ? [
        token0DataAddress,
        token0DataAmount
    ] : [
        token1DataAddress,
        token1DataAmount
    ];
    return {
        token0Address: token0Address,
        token0Amount: token0Amount,
        token1Address: token1Address,
        token1Amount: token1Amount
    };
};
const $959db82b481462db$export$421c073ec896b491 = (tokenData, token0Data, token1Data, chainId)=>{
    const tokenDataAddress = tokenData.address;
    const token0DataAddress = token0Data.address;
    const token1DataAddress = token1Data.address;
    const wrappedNativeCoinAddress = (0, $287c4ac331c75a82$export$31b943359438ed84)(chainId);
    const token0Address = (0, $17ea153afdabe1fb$export$81809787e85049ab)(tokenData) ? wrappedNativeCoinAddress : tokenDataAddress;
    const token1Address = (0, $b24cf0b5fa9d389a$export$9e1af1a79ed2c7c7)(token0Address, token0DataAddress) ? token1DataAddress : token0DataAddress;
    return {
        token1Address: token1Address
    };
};








const $47327b59af8f541b$export$e7d417b3426755f8 = ()=>{
    const { pairData: pairData, addresses: addresses } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { pairQuery: pairQuery, pairTokenQuery: pairTokenQuery, aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const { nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const { zapSupplyTransaction: zapSupplyTransaction } = (0, $f4415cf9cc1bd9fd$export$171bc4433675c7)();
    const { tokenData: tokenData, inputValueBig: inputValueBig } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const token0Data = token0Query.data;
    const token1Data = token1Query.data;
    const { mutation: mutation, resetTransaction: resetTransaction, runTransaction: runTransaction } = zapSupplyTransaction;
    const dependantQueries = [
        pairQuery,
        pairTokenQuery,
        aTokenQuery,
        nativeCoinQuery,
        token0Query,
        token1Query
    ];
    const [buttonTitle, loadingButtonTitle] = [
        "Supply",
        "Supplying..."
    ];
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        if (pairData && tokenData && token0Data && token1Data) {
            const { chainId: chainId } = pairData;
            const { lendingPoolAddress: lendingPoolAddress } = pairData;
            const { routerAddress: routerAddress } = addresses;
            const token0Address = tokenData.address;
            const token0Amount = (0, $12b684a6faa19c6a$export$c0657b8b46b96a9a)(inputValueBig, tokenData).toString();
            const { token1Address: token1Address } = (0, $959db82b481462db$export$421c073ec896b491)(tokenData, token0Data, token1Data, chainId);
            runTransaction(lendingPoolAddress, routerAddress, token0Address, token0Amount, token1Address);
        }
    }, [
        pairData,
        tokenData,
        token0Data,
        token1Data,
        addresses,
        inputValueBig,
        runTransaction
    ]);
    const { isError: isError, isLoading: isLoading } = mutation;
    const isButtonDisabled = inputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)()) || dependantQueries.some((query)=>query.isLoading);
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96da19a48dc13d93$export$90584b9d5e24e0e4), {
        mutation: mutation,
        resetTransaction: resetTransaction
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).BRAND,
        disabled: isButtonDisabled,
        isLoading: isLoading,
        onClick: handleButtonClick,
        children: isLoading ? loadingButtonTitle : buttonTitle
    });
};



const $26554e8af700e18c$export$a40a94c09692fa82 = ()=>{
    const { isConnected: isConnected, chainId: chainId } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { tabType: tabType, pairData: pairData } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { isUseZapTransactionForToken: isUseZapTransactionForToken } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { lendingPoolTransaction: lendingPoolTransaction, zapSupplyTransaction: zapSupplyTransaction } = (0, $f4415cf9cc1bd9fd$export$171bc4433675c7)();
    const { tokenData: tokenData, inputValueBig: inputValueBig, isError: isError, error: error } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const { isSuccess: isSuccess } = isUseZapTransactionForToken(tokenData) ? zapSupplyTransaction.mutation : lendingPoolTransaction.mutation;
    const isZeroBalance = inputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)());
    const isInsufficientAllowance = (0, $feb73828867e3133$export$b31436da9c02311c)(inputValueBig, tokenData);
    if (!isConnected) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54ed3f43a20cf460$export$2c5011646c0b20c3), {});
    if (pairData && chainId && pairData.chainId !== chainId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3af1e2106769a6d0$export$e961fcd722c3cf24), {});
    if (isSuccess) {
        const title = tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? "Supply Successful" : "Withdraw Successful";
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55ba62859e938d36$export$f56a791e7be511c0), {
            title: title
        });
    }
    if (isZeroBalance) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13b46140d36dc22c$export$2673c1d31784339c), {});
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab8ea50554bbd0f$export$816620cd7b25dd31), {
        error: error,
        tokenData: tokenData
    });
    if (isInsufficientAllowance) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d456d29a64bb92e$export$98237485cba9eb33), {});
    if (isUseZapTransactionForToken(tokenData)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47327b59af8f541b$export$e7d417b3426755f8), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bb978cf8f88b8e3$export$dc6f45aeed9e460f), {});
};



var $acw62 = parcelRequire("acw62");








const $2e0e17dcfad2d12b$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1g7l6l6-0"
})([
    "",
    ""
], {
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.25rem",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(62, 68, 83, var(--tw-bg-opacity))",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(150, 150, 150, var(--tw-border-opacity))",
    "borderRadius": "0.5rem"
});
const $2e0e17dcfad2d12b$export$b821cb5d358838ed = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1g7l6l6-1"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "1rem"
});
const $2e0e17dcfad2d12b$export$f5b8910cec6cf069 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input.attrs({
    type: "number",
    inputMode: "decimal",
    placeholder: "0",
    min: "0",
    step: "any"
}).withConfig({
    componentId: "sc-1g7l6l6-2"
})([
    "",
    " ",
    " &::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;"
], {
    "transitionProperty": "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms",
    "display": "flex",
    "flex": "1 1 0%",
    "minWidth": "0px",
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600",
    "padding": "0px",
    "backgroundColor": "rgba(0, 0, 0, 0)",
    "borderStyle": "none",
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "textOverflow": "ellipsis"
}, ({ isError: isError })=>isError && {
        "--tw-text-opacity": "1",
        "color": "rgba(220, 38, 38, var(--tw-text-opacity))"
    });
const $2e0e17dcfad2d12b$export$a7a55dff594ea775 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1g7l6l6-3"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "display": "flex",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "fontWeight": "500",
    "borderRadius": "0.5rem",
    "borderStyle": "none"
});
const $2e0e17dcfad2d12b$export$41164ea466f6b019 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1g7l6l6-4"
})({
    "display": "flex",
    "justifyContent": "flex-end",
    "alignItems": "center",
    "gap": "0.25rem"
});
const $2e0e17dcfad2d12b$export$deff84e7338ee5a5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-1g7l6l6-5"
})({
    "width": "1rem"
});
const $2e0e17dcfad2d12b$export$9ebd661e23544fe6 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1g7l6l6-6"
})({
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $2e0e17dcfad2d12b$export$c04ed6f11664dd90 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b)).attrs({
    color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).LIGHTGRAY
}).withConfig({
    componentId: "sc-1g7l6l6-7"
})([
    "",
    ""
], {
    "paddingLeft": "0.25rem",
    "paddingRight": "0.25rem",
    "paddingTop": "0px",
    "paddingBottom": "0px",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(18, 18, 18, var(--tw-text-opacity))",
    "fontWeight": "400",
    "borderRadius": "1.5rem",
    "textTransform": "uppercase"
});



var $acw62 = parcelRequire("acw62");

const $561037673a877538$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1ftuxaj-0"
})({
    "display": "flex",
    "position": "relative"
});



var $acw62 = parcelRequire("acw62");
/**
 * Browser-safe usage of process
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $6ac9d0caf66597b9$var$defaultEnvironment = "production";
const $6ac9d0caf66597b9$export$a7b6bc01c63cdfc3 = typeof $hPtJY === "undefined" || $hPtJY.env === undefined ? $6ac9d0caf66597b9$var$defaultEnvironment : "production";


const $1c49e3de0f86bd12$export$f8caf8121275292d = 1 / 60 * 1000;
const $1c49e3de0f86bd12$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $1c49e3de0f86bd12$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($1c49e3de0f86bd12$var$getCurrentTime()), $1c49e3de0f86bd12$export$f8caf8121275292d);


function $56b75657d7530209$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $741aad569b766a4c$var$maxElapsed = 40;
let $741aad569b766a4c$var$useDefaultElapsed = true;
let $741aad569b766a4c$var$runNextFrame = false;
let $741aad569b766a4c$var$isProcessing = false;
const $741aad569b766a4c$var$frame = {
    delta: 0,
    timestamp: 0
};
const $741aad569b766a4c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $741aad569b766a4c$var$steps = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $56b75657d7530209$export$b995e5e85f5c8289)(()=>$741aad569b766a4c$var$runNextFrame = true);
    return acc;
}, {});
const $741aad569b766a4c$var$sync = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    const step = $741aad569b766a4c$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$741aad569b766a4c$var$runNextFrame) $741aad569b766a4c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $741aad569b766a4c$export$d93e9c1fe0553512 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $741aad569b766a4c$var$steps[key].cancel;
    return acc;
}, {});
const $741aad569b766a4c$export$cd75ccfd720a3cd4 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$741aad569b766a4c$var$steps[key].process($741aad569b766a4c$var$frame);
    return acc;
}, {});
const $741aad569b766a4c$var$processStep = (stepId)=>$741aad569b766a4c$var$steps[stepId].process($741aad569b766a4c$var$frame);
const $741aad569b766a4c$var$processFrame = (timestamp)=>{
    $741aad569b766a4c$var$runNextFrame = false;
    $741aad569b766a4c$var$frame.delta = $741aad569b766a4c$var$useDefaultElapsed ? (0, $1c49e3de0f86bd12$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $741aad569b766a4c$var$frame.timestamp, $741aad569b766a4c$var$maxElapsed), 1);
    $741aad569b766a4c$var$frame.timestamp = timestamp;
    $741aad569b766a4c$var$isProcessing = true;
    $741aad569b766a4c$var$stepsOrder.forEach($741aad569b766a4c$var$processStep);
    $741aad569b766a4c$var$isProcessing = false;
    if ($741aad569b766a4c$var$runNextFrame) {
        $741aad569b766a4c$var$useDefaultElapsed = false;
        (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
    }
};
const $741aad569b766a4c$var$startLoop = ()=>{
    $741aad569b766a4c$var$runNextFrame = true;
    $741aad569b766a4c$var$useDefaultElapsed = true;
    if (!$741aad569b766a4c$var$isProcessing) (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
};
const $741aad569b766a4c$export$7244445918e670ed = ()=>$741aad569b766a4c$var$frame;
var $741aad569b766a4c$export$2e2bcd8739ae039 = $741aad569b766a4c$var$sync;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $e64230e5b7e1ea23$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $d4c37182b9742a1a$export$700979bc83e7db82 = (0, $e64230e5b7e1ea23$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $f0fbb06c148fbbcd$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $d4c37182b9742a1a$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $625a26cf696b5836$export$91db9bc4f8ac944a() {
    const isMounted = (0, $f0fbb06c148fbbcd$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $e26ddca02c6ea1a0$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $3746c7fe46fc0226$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $fe238c722d403a4b$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $fe238c722d403a4b$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        var _a;
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        (_a = style.sheet) === null || _a === void 0 || _a.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($fe238c722d403a4b$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $ce5813204e8602a1$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $3746c7fe46fc0226$export$fe4300aa8eebea86)($ce5813204e8602a1$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete === null || onExitComplete === void 0 || onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $fe238c722d403a4b$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $ce5813204e8602a1$var$newChildrenMap() {
    return new Map();
}



var $acw62 = parcelRequire("acw62");
const $0c97efef6d7e7a91$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
function $7cdfaf436d3d3a7e$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}


const $bd831d81b77155e4$var$warned = new Set();
function $bd831d81b77155e4$export$5b28268982f175ba(condition, message, element) {
    if (condition || $bd831d81b77155e4$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $bd831d81b77155e4$var$warned.add(message);
}


const $d280cf62a9a45ed1$var$getChildKey = (child)=>child.key || "";
function $d280cf62a9a45ed1$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $d280cf62a9a45ed1$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $d280cf62a9a45ed1$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $d280cf62a9a45ed1$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) {
        mode = "wait";
        (0, $bd831d81b77155e4$export$5b28268982f175ba)(false, "Replace exitBeforeEnter with mode='wait'");
    }
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = (0, $625a26cf696b5836$export$91db9bc4f8ac944a)();
    const forceRenderLayoutGroup = (0, $acw62.useContext)((0, $0c97efef6d7e7a91$export$a3579ca508007a95)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    const isMounted = (0, $f0fbb06c148fbbcd$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $d280cf62a9a45ed1$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $d4c37182b9742a1a$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $d280cf62a9a45ed1$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7cdfaf436d3d3a7e$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $ce5813204e8602a1$export$979daf65881a382a), {
            key: $d280cf62a9a45ed1$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($d280cf62a9a45ed1$var$getChildKey);
    const targetKeys = filteredChildren.map($d280cf62a9a45ed1$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = ()=>{
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $acw62.createElement((0, $ce5813204e8602a1$export$979daf65881a382a), {
            key: $d280cf62a9a45ed1$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exiting.has(key) ? child : $acw62.createElement((0, $ce5813204e8602a1$export$979daf65881a382a), {
            key: $d280cf62a9a45ed1$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    if ((0, $6ac9d0caf66597b9$export$a7b6bc01c63cdfc3) !== "production" && mode === "wait" && childrenToRender.length > 1) console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    return $acw62.createElement($acw62.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * useDidMount hook
 * @description Calls a function on mount
 *
 * @param {Function} callback Callback function to be called on mount
 * @see https://react-hooks.org/docs/useDidMount
 */ function $854bd5b481d5c79f$export$4984640464733c64(callback) {
    (0, $acw62.useEffect)(function() {
        if (typeof callback === "function") callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}



var $acw62 = parcelRequire("acw62");
var $a144daa6ab437da7$export$8793edee2d425525 = function() {};


var $934a3efce6853ceb$var$config = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
/**
 *
 * useMutationObserver hook
 *
 * Returns a mutation observer for a React Ref and fires a callback
 *
 * @param {MutableRefObject<HTMLElement | null>} ref React ref on which mutations are to be observed
 * @param {MutationCallback} callback Function that needs to be fired on mutation
 * @param {MutationObserverInit} options
 * @see https://react-hooks.org/docs/useMutationObserver
 */ function $934a3efce6853ceb$export$8ecdcf3bb089e9cd(ref, callback, options) {
    if (options === void 0) options = $934a3efce6853ceb$var$config;
    (0, $acw62.useEffect)(function() {
        // Create an observer instance linked to the callback function
        if (ref.current) {
            var observer_1 = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observer_1.observe(ref.current, options);
            return function() {
                observer_1.disconnect();
            };
        }
        return 0, $a144daa6ab437da7$export$8793edee2d425525;
    }, [
        callback,
        options,
        ref
    ]);
}


/**
 * @param element HTML element whose boundingclientrect is needed
 * @returns DOMRect
 */ function $7a8f953b3506ddcb$var$getBoundingClientRect(element) {
    return element.getBoundingClientRect();
}
/**
 * useBoundingclientRect hook
 *
 * @param ref The React ref whose ClientRect is needed
 * @returns DOMRect | null
 * @see https://react-hooks.org/docs/useBoundingclientRect
 */ function $7a8f953b3506ddcb$export$b95e3d4f036ffdbe(ref) {
    var _a = (0, $acw62.useState)(null), domRect = _a[0], setDomRect = _a[1];
    var update = (0, $acw62.useCallback)(function() {
        setDomRect(ref.current ? $7a8f953b3506ddcb$var$getBoundingClientRect(ref.current) : null);
    }, [
        ref
    ]);
    (0, $854bd5b481d5c79f$export$4984640464733c64)(function() {
        update();
    });
    (0, $934a3efce6853ceb$export$8ecdcf3bb089e9cd)(ref, update);
    return domRect;
}


var $acw62 = parcelRequire("acw62");

/**
 * useOutsideClick hook
 * Checks if a click happened outside a Ref. Handy for dropdowns, modals and popups etc.
 *
 * @param ref Ref whose outside click needs to be listened to
 * @param handler Callback to fire on outside click
 * @param when A boolean which which activates the hook only when it is true. Useful for conditionally enable the outside click
 * @see https://react-hooks.org/docs/useOutsideClick
 * @example
 * ```tsx
 * import { useOutsideClick } from "./useOutsideClick";
 * import { useRef } from "react";
 * import { noop } from "../utils/noop";
 *
 * const MyComponent = () => {
 *  const ref = useRef<HTMLDivElement>(null);
 *  const [isOpen, setIsOpen] = useState(false);
 *    const handleOutsideClick = () => setIsOpen(false);
 *  useOutsideClick(ref, handleOutsideClick);
 *  return (
 *   <div ref={ref}>
 *    <button onClick={() => setIsOpen(true)}>Open</button>
 *   {isOpen && (
 *   <div>Inside</div>
 *   )}
 * </div>
 * );
 * }
 * ```
 */ function $a771512e471faa36$export$71b2224f1ce5e08e(ref, handler, when) {
    if (when === void 0) when = true;
    var savedHandler = (0, $acw62.useRef)(handler);
    var memoizedCallback = (0, $acw62.useCallback)(function(event) {
        if (ref.current && !ref.current.contains(event.target)) savedHandler.current(event);
    }, [
        ref
    ]);
    (0, $acw62.useEffect)(function() {
        savedHandler.current = handler;
    });
    (0, $acw62.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("ontouchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("ontouchstart", memoizedCallback, true);
            };
        }
        return 0, $a144daa6ab437da7$export$8793edee2d425525;
    }, [
        ref,
        handler,
        when,
        memoizedCallback
    ]);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $f2d37635429232b6$var$createDefinition = (propNames)=>({
        isEnabled: (props)=>propNames.some((name)=>!!props[name])
    });
const $f2d37635429232b6$export$65570e08d843624d = {
    measureLayout: $f2d37635429232b6$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $f2d37635429232b6$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $f2d37635429232b6$var$createDefinition([
        "exit"
    ]),
    drag: $f2d37635429232b6$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $f2d37635429232b6$var$createDefinition([
        "whileFocus"
    ]),
    hover: $f2d37635429232b6$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $f2d37635429232b6$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $f2d37635429232b6$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $f2d37635429232b6$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function $f2d37635429232b6$export$449561ec5703cdc8(features) {
    for(const key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") $f2d37635429232b6$export$65570e08d843624d.projectionNodeConstructor = features[key];
        else $f2d37635429232b6$export$65570e08d843624d[key].Component = features[key];
    }
}


var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};



var $acw62 = parcelRequire("acw62");
const $b0d28c506d54232b$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});


const $8d58a2e2f07730ac$var$featureNames = Object.keys((0, $f2d37635429232b6$export$65570e08d843624d));
const $8d58a2e2f07730ac$var$numFeatures = $8d58a2e2f07730ac$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $8d58a2e2f07730ac$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    const features = [];
    const lazyContext = (0, $acw62.useContext)((0, $b0d28c506d54232b$export$40f10139ecf1f171));
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if ((0, $6ac9d0caf66597b9$export$a7b6bc01c63cdfc3) !== "production" && preloadedFeatures && lazyContext.strict) (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(let i = 0; i < $8d58a2e2f07730ac$var$numFeatures; i++){
        const name = $8d58a2e2f07730ac$var$featureNames[i];
        const { isEnabled: isEnabled, Component: Component } = (0, $f2d37635429232b6$export$65570e08d843624d)[name];
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($acw62.createElement(Component, Object.assign({
            key: name
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}



var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dc1f85223fd7ddd4$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $0208410fefabf22e$export$2285bbca2c666415 = (0, $acw62.createContext)({});
function $0208410fefabf22e$export$cd995842eb2ab956() {
    return (0, $acw62.useContext)($0208410fefabf22e$export$2285bbca2c666415).visualElement;
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


// Does this device prefer reduced motion? Returns `null` server-side.
const $0fce4cd54241baaf$var$prefersReducedMotion = {
    current: null
};
let $0fce4cd54241baaf$var$hasDetected = false;
function $0fce4cd54241baaf$var$initPrefersReducedMotion() {
    $0fce4cd54241baaf$var$hasDetected = true;
    if (!(0, $e64230e5b7e1ea23$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>$0fce4cd54241baaf$var$prefersReducedMotion.current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else $0fce4cd54241baaf$var$prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $0fce4cd54241baaf$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !$0fce4cd54241baaf$var$hasDetected && $0fce4cd54241baaf$var$initPrefersReducedMotion();
    const [shouldReduceMotion] = (0, $acw62.useState)($0fce4cd54241baaf$var$prefersReducedMotion.current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function $0fce4cd54241baaf$export$ec21f7709af6bc1e() {
    const reducedMotionPreference = $0fce4cd54241baaf$export$6a42007cf1e7b6f8();
    const { reducedMotion: reducedMotion } = (0, $acw62.useContext)((0, $dc1f85223fd7ddd4$export$22a697fb29aac98d));
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}


function $09dca0aad4d4356e$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const lazyContext = (0, $acw62.useContext)((0, $b0d28c506d54232b$export$40f10139ecf1f171));
    const parent = (0, $0208410fefabf22e$export$cd995842eb2ab956)();
    const presenceContext = (0, $acw62.useContext)((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2));
    const shouldReduceMotion = (0, $0fce4cd54241baaf$export$ec21f7709af6bc1e)();
    const visualElementRef = (0, $acw62.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    const visualElement = visualElementRef.current;
    (0, $d4c37182b9742a1a$export$700979bc83e7db82)(()=>{
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $d4c37182b9742a1a$export$700979bc83e7db82)(()=>()=>visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(), []);
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $10bfea9bcc41843f$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $d136366eebab2605$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $10bfea9bcc41843f$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is an array of variant labels
 */ function $9fc0609ad108c3b4$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $9fc0609ad108c3b4$export$720b90e312cea233(v) {
    return typeof v === "string" || $9fc0609ad108c3b4$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $9fc0609ad108c3b4$var$getCurrent(visualElement) {
    const current = {};
    visualElement.forEachValue((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $9fc0609ad108c3b4$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.forEachValue((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $9fc0609ad108c3b4$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    var _a;
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function $9fc0609ad108c3b4$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return $9fc0609ad108c3b4$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $9fc0609ad108c3b4$var$getCurrent(visualElement), $9fc0609ad108c3b4$var$getVelocity(visualElement));
}
function $9fc0609ad108c3b4$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $9fc0609ad108c3b4$export$720b90e312cea233(props.initial) || $9fc0609ad108c3b4$export$720b90e312cea233(props.animate) || $9fc0609ad108c3b4$export$720b90e312cea233(props.whileHover) || $9fc0609ad108c3b4$export$720b90e312cea233(props.whileDrag) || $9fc0609ad108c3b4$export$720b90e312cea233(props.whileTap) || $9fc0609ad108c3b4$export$720b90e312cea233(props.whileFocus) || $9fc0609ad108c3b4$export$720b90e312cea233(props.exit);
}
function $9fc0609ad108c3b4$export$c0eba02279c18fea(props) {
    return Boolean($9fc0609ad108c3b4$export$cf3a7bd331c35bf0(props) || props.variants);
}


function $fe1423cc6dcb695d$export$12fc32fc096a04a3(props, context) {
    if ((0, $9fc0609ad108c3b4$export$cf3a7bd331c35bf0)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $9fc0609ad108c3b4$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $9fc0609ad108c3b4$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $adb479cb77684a78$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $fe1423cc6dcb695d$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $0208410fefabf22e$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $adb479cb77684a78$var$variantLabelsAsDependency(initial),
        $adb479cb77684a78$var$variantLabelsAsDependency(animate)
    ]);
}
function $adb479cb77684a78$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}





/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $d2a278e5dfe57496$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


let $69efbba3424f8344$var$id = 1;
function $69efbba3424f8344$export$5ed57b87c18af11a() {
    return (0, $3746c7fe46fc0226$export$fe4300aa8eebea86)(()=>{
        if ((0, $d2a278e5dfe57496$export$97db156a3ed1593b).hasEverUpdated) return $69efbba3424f8344$var$id++;
    });
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $63ce92882328da72$export$da5f7b802957459a = (0, $acw62.createContext)({});


function $520e469bb43e5b9a$export$80ade90e64f5118b(projectionId, { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll }, visualElement, ProjectionNodeConstructor) {
    var _a;
    const initialPromotionConfig = (0, $acw62.useContext)((0, $63ce92882328da72$export$da5f7b802957459a));
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_a = visualElement.parent) === null || _a === void 0 ? void 0 : _a.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $10bfea9bcc41843f$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: ()=>visualElement.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}



var $acw62 = parcelRequire("acw62");
class $d274e885d08e8b05$export$a9ca437df31f9491 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ getSnapshotBeforeUpdate() {
        this.updateProps();
        return null;
    }
    componentDidUpdate() {}
    updateProps() {
        const { visualElement: visualElement, props: props } = this.props;
        if (visualElement) visualElement.setProps(props);
    }
    render() {
        return this.props.children;
    }
}


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $98f6148882fd07b1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $f2d37635429232b6$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const layoutId = $98f6148882fd07b1$var$useLayoutId(props);
        props = Object.assign(Object.assign({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ const config = (0, $acw62.useContext)((0, $dc1f85223fd7ddd4$export$22a697fb29aac98d));
        let features = null;
        const context = (0, $adb479cb77684a78$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ const projectionId = config.isStatic ? undefined : (0, $69efbba3424f8344$export$5ed57b87c18af11a)();
        /**
         *
         */ const visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $e64230e5b7e1ea23$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $09dca0aad4d4356e$export$dc0335d73ab0b115)(Component, visualState, Object.assign(Object.assign({}, config), props), createVisualElement);
            (0, $520e469bb43e5b9a$export$80ade90e64f5118b)(projectionId, props, context.visualElement, projectionNodeConstructor || (0, $f2d37635429232b6$export$65570e08d843624d).projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = (0, $8d58a2e2f07730ac$export$4a39035bacc4ed76)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $d274e885d08e8b05$export$a9ca437df31f9491), {
            visualElement: context.visualElement,
            props: Object.assign(Object.assign({}, config), props)
        }, features, $acw62.createElement((0, $0208410fefabf22e$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $d136366eebab2605$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, $acw62.forwardRef)(MotionComponent);
}
function $98f6148882fd07b1$var$useLayoutId({ layoutId: layoutId }) {
    var _a;
    const layoutGroupId = (_a = (0, $acw62.useContext)((0, $0c97efef6d7e7a91$export$a3579ca508007a95))) === null || _a === void 0 ? void 0 : _a.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $7aaf31b5eefb469b$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $98f6148882fd07b1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1cc33161c297f4b3$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];


function $95c9f97c34d7cb74$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1cc33161c297f4b3$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $dae5832cc9c4c026$export$91ddd985b97788d1 = {};
function $dae5832cc9c4c026$export$de9e7791c71225fd(correctors) {
    Object.assign($dae5832cc9c4c026$export$91ddd985b97788d1, correctors);
}


/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $73c07a5d0b8699a4$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $73c07a5d0b8699a4$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ const $73c07a5d0b8699a4$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$73c07a5d0b8699a4$var$order.forEach((operationKey)=>$73c07a5d0b8699a4$export$67cd428da31419e1.forEach((axesKey)=>$73c07a5d0b8699a4$export$7b42a0094fb00b6e.push(operationKey + axesKey)));
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $73c07a5d0b8699a4$export$61f68472e7973485(a, b) {
    return $73c07a5d0b8699a4$export$7b42a0094fb00b6e.indexOf(a) - $73c07a5d0b8699a4$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ const $73c07a5d0b8699a4$var$transformPropSet = new Set($73c07a5d0b8699a4$export$7b42a0094fb00b6e);
function $73c07a5d0b8699a4$export$15240a8a4379d8de(key) {
    return $73c07a5d0b8699a4$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ const $73c07a5d0b8699a4$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $73c07a5d0b8699a4$export$91fe49ee9d172523(key) {
    return $73c07a5d0b8699a4$var$transformOriginProps.has(key);
}


function $d8040c83298fd44d$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $73c07a5d0b8699a4$export$15240a8a4379d8de)(key) || (0, $73c07a5d0b8699a4$export$91fe49ee9d172523)(key) || (layout || layoutId !== undefined) && (!!(0, $dae5832cc9c4c026$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $513bb72e2a3b2c38$export$605d60a2578142d3 = (value)=>{
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};



const $451830f1f5db0c75$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $451830f1f5db0c75$export$bdc96e0d5c8f914({ transform: transform, transformKeys: transformKeys }, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $73c07a5d0b8699a4$export$61f68472e7973485));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    let transformHasZ = false;
    // Loop over each transform and build them into transformString
    const numTransformKeys = transformKeys.length;
    for(let i = 0; i < numTransformKeys; i++){
        const key = transformKeys[i];
        transformString += `${$451830f1f5db0c75$var$translateAlias[key] || key}(${transform[key]}) `;
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $451830f1f5db0c75$export$22d2fbf39767d07a({ originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 }) {
    return `${originX} ${originY} ${originZ}`;
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $388a4b9b43db8ef3$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a58565876194530c$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $6d7848dd3b3ec6b5$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $6d7848dd3b3ec6b5$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $6d7848dd3b3ec6b5$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $6d7848dd3b3ec6b5$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $6d7848dd3b3ec6b5$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $2f64f305c5028a6f$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $2f64f305c5028a6f$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $2f64f305c5028a6f$export$98e628dec113755e), {
    transform: (0, $6d7848dd3b3ec6b5$export$7d15b64cf5a3a4c4)(0, 1)
});
const $2f64f305c5028a6f$export$dcdf75081b88279d = Object.assign(Object.assign({}, $2f64f305c5028a6f$export$98e628dec113755e), {
    default: 1
});


const $7053ea50bd4db8b8$var$createUnitType = (unit)=>({
        test: (v)=>(0, $6d7848dd3b3ec6b5$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $7053ea50bd4db8b8$export$41fc368e1a942b97 = $7053ea50bd4db8b8$var$createUnitType("deg");
const $7053ea50bd4db8b8$export$626336c2cd4b14de = $7053ea50bd4db8b8$var$createUnitType("%");
const $7053ea50bd4db8b8$export$91c0eda1d06bf008 = $7053ea50bd4db8b8$var$createUnitType("px");
const $7053ea50bd4db8b8$export$f91e8c45a95a32f2 = $7053ea50bd4db8b8$var$createUnitType("vh");
const $7053ea50bd4db8b8$export$aed3d7b7d206c196 = $7053ea50bd4db8b8$var$createUnitType("vw");
const $7053ea50bd4db8b8$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $7053ea50bd4db8b8$export$626336c2cd4b14de), {
    parse: (v)=>$7053ea50bd4db8b8$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$7053ea50bd4db8b8$export$626336c2cd4b14de.transform(v * 100)
});



const $fa83dcb874030132$export$7d260a2a5f8bc19e = Object.assign(Object.assign({}, (0, $2f64f305c5028a6f$export$98e628dec113755e)), {
    transform: Math.round
});


const $ea242f0d47c4a8ec$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderTopWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderRightWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderRadius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    radius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    maxWidth: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    height: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    maxHeight: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    size: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    top: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    right: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    bottom: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    left: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    paddingTop: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    paddingRight: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    paddingBottom: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    paddingLeft: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    margin: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    marginTop: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    marginRight: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    marginBottom: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    marginLeft: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    rotateX: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    rotateY: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    rotateZ: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    scale: $2f64f305c5028a6f$export$dcdf75081b88279d,
    scaleX: (0, $2f64f305c5028a6f$export$dcdf75081b88279d),
    scaleY: (0, $2f64f305c5028a6f$export$dcdf75081b88279d),
    scaleZ: (0, $2f64f305c5028a6f$export$dcdf75081b88279d),
    skew: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    skewX: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    skewY: (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    distance: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    translateX: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    translateY: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    translateZ: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    x: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    y: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    z: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    perspective: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    transformPerspective: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    opacity: (0, $2f64f305c5028a6f$export$58f0f39f63f3cf42),
    originX: (0, $7053ea50bd4db8b8$export$44e2e1705876d7ed),
    originY: (0, $7053ea50bd4db8b8$export$44e2e1705876d7ed),
    originZ: (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $fa83dcb874030132$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $2f64f305c5028a6f$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $2f64f305c5028a6f$export$58f0f39f63f3cf42),
    numOctaves: (0, $fa83dcb874030132$export$7d260a2a5f8bc19e)
};


function $2ab6dcf72886549b$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    const { style: style, vars: vars, transform: transform, transformKeys: transformKeys, transformOrigin: transformOrigin } = state;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $388a4b9b43db8ef3$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $ea242f0d47c4a8ec$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a58565876194530c$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $73c07a5d0b8699a4$export$15240a8a4379d8de)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $73c07a5d0b8699a4$export$91fe49ee9d172523)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $451830f1f5db0c75$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = (0, $451830f1f5db0c75$export$22d2fbf39767d07a)(transformOrigin);
}


const $bfe42b51bb0df1d4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    });


function $6e7e5e38a169aab4$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $513bb72e2a3b2c38$export$605d60a2578142d3)(source[key]) && !(0, $d8040c83298fd44d$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $6e7e5e38a169aab4$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $bfe42b51bb0df1d4$export$8940b483cf52eeda)();
        (0, $2ab6dcf72886549b$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        const { vars: vars, style: style } = state;
        return Object.assign(Object.assign({}, vars), style);
    }, [
        visualState
    ]);
}
function $6e7e5e38a169aab4$export$72c85e333541e7f(props, visualState, isStatic) {
    const styleProp = props.style || {};
    let style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $6e7e5e38a169aab4$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $6e7e5e38a169aab4$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $6e7e5e38a169aab4$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $6e7e5e38a169aab4$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $3930b505575f2f3a$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $3930b505575f2f3a$export$2f9c46555243bf04(key) {
    return $3930b505575f2f3a$var$validMotionProps.has(key);
}


let $1b9a857dc08944e4$var$shouldForward = (key)=>!(0, $3930b505575f2f3a$export$2f9c46555243bf04)(key);
function $1b9a857dc08944e4$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $1b9a857dc08944e4$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $3930b505575f2f3a$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $1b9a857dc08944e4$export$59d6962c470509a5((parcelRequire("7dGEo")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $1b9a857dc08944e4$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props)if ($1b9a857dc08944e4$var$shouldForward(key) || forwardMotionProps === true && (0, $3930b505575f2f3a$export$2f9c46555243bf04)(key) || !isDom && !(0, $3930b505575f2f3a$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");


var $7WQrb = parcelRequire("7WQrb");


function $f6296a51370202d9$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $f6296a51370202d9$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $f6296a51370202d9$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $f6296a51370202d9$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $6aae49c2da035864$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $6aae49c2da035864$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $6aae49c2da035864$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $6aae49c2da035864$var$dashKeys : $6aae49c2da035864$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $42a1a377eb6df020$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var { attrX: attrX, attrY: attrY, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0 } = _a, // This is object creation, which we try to avoid per-frame.
    latest = (0, $7WQrb.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $2ab6dcf72886549b$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $f6296a51370202d9$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $6aae49c2da035864$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $9d6ed8e7be909d3e$export$41be8b43e1c4d4f9 = ()=>Object.assign(Object.assign({}, (0, $bfe42b51bb0df1d4$export$8940b483cf52eeda)()), {
        attrs: {}
    });


function $abeedb12969cc840$export$84309c4f53cb1bd5(props, visualState) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $9d6ed8e7be909d3e$export$41be8b43e1c4d4f9)();
        (0, $42a1a377eb6df020$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return Object.assign(Object.assign({}, state.attrs), {
            style: Object.assign({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $6e7e5e38a169aab4$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = Object.assign(Object.assign({}, rawStyles), visualProps.style);
    }
    return visualProps;
}


function $4e76fadf08221b3d$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $95c9f97c34d7cb74$export$88f3fc2fd3766989)(Component) ? (0, $abeedb12969cc840$export$84309c4f53cb1bd5) : (0, $6e7e5e38a169aab4$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic);
        const filteredProps = (0, $1b9a857dc08944e4$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Object.assign(Object.assign(Object.assign({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $acw62.createElement)(Component, elementProps);
    };
    return useRender;
}


const $66b01c35fe5a3c5d$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
const $66b01c35fe5a3c5d$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ const $66b01c35fe5a3c5d$export$9fd24a634729c672 = (str)=>str.replace($66b01c35fe5a3c5d$var$CAMEL_CASE_PATTERN, $66b01c35fe5a3c5d$var$REPLACE_TEMPLATE).toLowerCase();


function $6e7fb0ef9d26d575$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $53cef2cbcabfbf37$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);


function $985f09fa180b53b7$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $6e7fb0ef9d26d575$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $53cef2cbcabfbf37$export$28931db5d57958e5).has(key) ? (0, $66b01c35fe5a3c5d$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $22640d6ce721193b$export$16da615486abaa45(props) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $513bb72e2a3b2c38$export$605d60a2578142d3)(style[key]) || (0, $d8040c83298fd44d$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $53bd1c12a432092a$export$16da615486abaa45(props) {
    const newValues = (0, $22640d6ce721193b$export$16da615486abaa45)(props);
    for(const key in props)if ((0, $513bb72e2a3b2c38$export$605d60a2578142d3)(props[key])) {
        const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
function $d53c40212eb56791$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}





const $cb191701c4d6cd5b$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $52f006ed9a22dd67$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $52f006ed9a22dd67$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cb191701c4d6cd5b$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $3849712c835fb3ad$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $513bb72e2a3b2c38$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $52f006ed9a22dd67$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}



function $4f2bd93a79d95635$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $4f2bd93a79d95635$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $4f2bd93a79d95635$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $0208410fefabf22e$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2));
        return isStatic ? $4f2bd93a79d95635$var$makeState(config, props, context, presenceContext) : (0, $3746c7fe46fc0226$export$fe4300aa8eebea86)(()=>$4f2bd93a79d95635$var$makeState(config, props, context, presenceContext));
    };
function $4f2bd93a79d95635$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    const motionValues = scrapeMotionValues(props);
    for(const key in motionValues)values[key] = (0, $3849712c835fb3ad$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants = (0, $9fc0609ad108c3b4$export$cf3a7bd331c35bf0)(props);
    const isVariantNode = (0, $9fc0609ad108c3b4$export$c0eba02279c18fea)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    const initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    const variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $d53c40212eb56791$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $9fc0609ad108c3b4$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition } = resolved, target = (0, $7WQrb.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}




const $81b76faafa361604$export$44dabd3fae512e85 = {
    useVisualState: (0, $4f2bd93a79d95635$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $53bd1c12a432092a$export$16da615486abaa45),
        createRenderState: (0, $9d6ed8e7be909d3e$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $42a1a377eb6df020$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            (0, $985f09fa180b53b7$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $f243b539e5f57ec2$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $4f2bd93a79d95635$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $22640d6ce721193b$export$16da615486abaa45),
        createRenderState: (0, $bfe42b51bb0df1d4$export$8940b483cf52eeda)
    })
};


function $fffacd8f6ed67621$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = (0, $95c9f97c34d7cb74$export$88f3fc2fd3766989)(Component) ? (0, $81b76faafa361604$export$44dabd3fae512e85) : (0, $f243b539e5f57ec2$export$e13ea21d87ea57c8);
    return Object.assign(Object.assign({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $4e76fadf08221b3d$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}


var $ee70e57f3fb913dc$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($ee70e57f3fb913dc$export$2deb71ebd3734d23 || ($ee70e57f3fb913dc$export$2deb71ebd3734d23 = {}));



var $acw62 = parcelRequire("acw62");
function $f3a3b2c3f11b0939$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $f3a3b2c3f11b0939$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $acw62.useEffect)(()=>{
        const element = ref.current;
        if (handler && element) return $f3a3b2c3f11b0939$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $0e07b917cc27c355$export$cac52d7cca250a66({ whileFocus: whileFocus, visualElement: visualElement }) {
    const onFocus = ()=>{
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Focus, true);
    };
    const onBlur = ()=>{
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $f3a3b2c3f11b0939$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $f3a3b2c3f11b0939$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}


function $6732a47008b71f77$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $6732a47008b71f77$export$c4dfce035d43d1e0(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}





/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $5dd76cedb80f66a0$var$filterPrimaryPointer(eventHandler) {
    return (event)=>{
        const isMouseEvent = event instanceof MouseEvent;
        const isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
const $5dd76cedb80f66a0$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $5dd76cedb80f66a0$var$pointFromTouch(e, pointType = "page") {
    const primaryTouch = e.touches[0] || e.changedTouches[0];
    const point = primaryTouch || $5dd76cedb80f66a0$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $5dd76cedb80f66a0$var$pointFromMouse(point, pointType = "page") {
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $5dd76cedb80f66a0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: (0, $6732a47008b71f77$export$c4dfce035d43d1e0)(event) ? $5dd76cedb80f66a0$var$pointFromTouch(event, pointType) : $5dd76cedb80f66a0$var$pointFromMouse(event, pointType)
    };
}
const $5dd76cedb80f66a0$export$f4437ba81469b709 = (handler, shouldFilterPrimaryPointer = false)=>{
    const listener = (event)=>handler(event, $5dd76cedb80f66a0$export$12f84bb882d06e1a(event));
    return shouldFilterPrimaryPointer ? $5dd76cedb80f66a0$var$filterPrimaryPointer(listener) : listener;
};



// We check for event support via functions in case they've been mocked by a testing suite.
const $ce973b4c3f9155f8$export$ed662207763ba653 = ()=>(0, $e64230e5b7e1ea23$export$4e09c449d6c407f7) && window.onpointerdown === null;
const $ce973b4c3f9155f8$export$58e9cbc5718eb8c2 = ()=>(0, $e64230e5b7e1ea23$export$4e09c449d6c407f7) && window.ontouchstart === null;
const $ce973b4c3f9155f8$export$1a3879af679d3ede = ()=>(0, $e64230e5b7e1ea23$export$4e09c449d6c407f7) && window.onmousedown === null;


const $e3b54d28724d6a02$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
const $e3b54d28724d6a02$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $e3b54d28724d6a02$var$getPointerEventName(name) {
    if ((0, $ce973b4c3f9155f8$export$ed662207763ba653)()) return name;
    else if ((0, $ce973b4c3f9155f8$export$58e9cbc5718eb8c2)()) return $e3b54d28724d6a02$var$touchEventNames[name];
    else if ((0, $ce973b4c3f9155f8$export$1a3879af679d3ede)()) return $e3b54d28724d6a02$var$mouseEventNames[name];
    return name;
}
function $e3b54d28724d6a02$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $f3a3b2c3f11b0939$export$b1d829ddf82884aa)(target, $e3b54d28724d6a02$var$getPointerEventName(eventName), (0, $5dd76cedb80f66a0$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}
function $e3b54d28724d6a02$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $f3a3b2c3f11b0939$export$c1052189363cb2e0)(ref, $e3b54d28724d6a02$var$getPointerEventName(eventName), handler && (0, $5dd76cedb80f66a0$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}


function $2adcc7ef57987f19$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $2adcc7ef57987f19$var$globalHorizontalLock = $2adcc7ef57987f19$export$518c5fc2dcb7974b("dragHorizontal");
const $2adcc7ef57987f19$var$globalVerticalLock = $2adcc7ef57987f19$export$518c5fc2dcb7974b("dragVertical");
function $2adcc7ef57987f19$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $2adcc7ef57987f19$var$globalVerticalLock();
    else if (drag === "x") lock = $2adcc7ef57987f19$var$globalHorizontalLock();
    else {
        const openHorizontal = $2adcc7ef57987f19$var$globalHorizontalLock();
        const openVertical = $2adcc7ef57987f19$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $2adcc7ef57987f19$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $2adcc7ef57987f19$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $946ca82b43a14536$var$createHoverEvent(visualElement, isActive, callback) {
    return (event, info)=>{
        var _a;
        if (!(0, $6732a47008b71f77$export$764db16956f554f8)(event) || (0, $2adcc7ef57987f19$export$1b3dd616664938e4)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function $946ca82b43a14536$export$dea06860711b7ebc({ onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, whileHover: whileHover, visualElement: visualElement }) {
    (0, $e3b54d28724d6a02$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $946ca82b43a14536$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $e3b54d28724d6a02$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $946ca82b43a14536$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}



var $acw62 = parcelRequire("acw62");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $296f666eed211502$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $296f666eed211502$export$e841ada32ff745b(parent, child.parentElement);
};




const $72ee85dbfbfb2228$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $72ee85dbfbfb2228$export$a4627e546088548d = (...transformers)=>transformers.reduce($72ee85dbfbfb2228$var$combineFunctions);




/**
 * @param handlers -
 * @internal
 */ function $23394c4282332d52$export$16dee6ef8c34532({ onTap: onTap, onTapStart: onTapStart, onTapCancel: onTapCancel, whileTap: whileTap, visualElement: visualElement }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = (0, $acw62.useRef)(false);
    const cancelPointerEndListeners = (0, $acw62.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Tap, false);
        return !(0, $2adcc7ef57987f19$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $296f666eed211502$export$e841ada32ff745b)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $72ee85dbfbfb2228$export$a4627e546088548d)((0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp, eventOptions), (0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    (0, $e3b54d28724d6a02$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $7cdfaf436d3d3a7e$export$f3a192d0cbd30b96)(removePointerEndListener);
}




var $acw62 = parcelRequire("acw62");



var $7WQrb = parcelRequire("7WQrb");
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $bf3e9c02e7b6dee8$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $bf3e9c02e7b6dee8$var$observers = new WeakMap();
const $bf3e9c02e7b6dee8$var$fireObserverCallback = (entry)=>{
    var _a;
    (_a = $bf3e9c02e7b6dee8$var$observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
const $bf3e9c02e7b6dee8$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($bf3e9c02e7b6dee8$var$fireObserverCallback);
};
function $bf3e9c02e7b6dee8$var$initIntersectionObserver(_a) {
    var { root: root } = _a, options = (0, $7WQrb.__rest)(_a, [
        "root"
    ]);
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$bf3e9c02e7b6dee8$var$observers.has(lookupRoot)) $bf3e9c02e7b6dee8$var$observers.set(lookupRoot, {});
    const rootObservers = $bf3e9c02e7b6dee8$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($bf3e9c02e7b6dee8$var$fireAllObserverCallbacks, Object.assign({
        root: root
    }, options));
    return rootObservers[key];
}
function $bf3e9c02e7b6dee8$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $bf3e9c02e7b6dee8$var$initIntersectionObserver(options);
    $bf3e9c02e7b6dee8$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $bf3e9c02e7b6dee8$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


function $7decbcf64df6d1b3$export$297ec8eb77d6211d({ visualElement: visualElement, whileInView: whileInView, onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave, viewport: viewport = {} }) {
    const state = (0, $acw62.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined" ? $7decbcf64df6d1b3$var$useMissingIntersectionObserver : $7decbcf64df6d1b3$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const $7decbcf64df6d1b3$var$thresholdNames = {
    some: 0,
    all: 1
};
function $7decbcf64df6d1b3$var$useIntersectionObserver(shouldObserve, state, visualElement, { root: root, margin: rootMargin, amount: amount = "some", once: once }) {
    (0, $acw62.useEffect)(()=>{
        if (!shouldObserve) return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $7decbcf64df6d1b3$var$thresholdNames[amount]
        };
        const intersectionCallback = (entry)=>{
            var _a;
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const props = visualElement.getProps();
            const callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return (0, $bf3e9c02e7b6dee8$export$b2bcd62fb7925aa5)(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $7decbcf64df6d1b3$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback: fallback = true }) {
    (0, $acw62.useEffect)(()=>{
        if (!shouldObserve || !fallback) return;
        if ((0, $6ac9d0caf66597b9$export$a7b6bc01c63cdfc3) !== "production") (0, $bd831d81b77155e4$export$5b28268982f175ba)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(()=>{
            var _a;
            state.hasEnteredView = true;
            const { onViewportEnter: onViewportEnter } = visualElement.getProps();
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).InView, true);
        });
    }, [
        shouldObserve
    ]);
}


const $cc60e9fdceeef420$export$46d1d6d046f826e4 = (hook)=>(props)=>{
        hook(props);
        return null;
    };


const $a2da84fda1ac4c61$export$e5b72898e5a201f1 = {
    inView: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $7decbcf64df6d1b3$export$297ec8eb77d6211d)),
    tap: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $23394c4282332d52$export$16dee6ef8c34532)),
    focus: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $0e07b917cc27c355$export$cac52d7cca250a66)),
    hover: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $946ca82b43a14536$export$dea06860711b7ebc))
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $4332d507cd311a00$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $4332d507cd311a00$export$8249053f690ea39a() {
    return $4332d507cd311a00$export$ee27c052bca048fb((0, $acw62.useContext)((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2)));
}
function $4332d507cd311a00$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




var $7WQrb = parcelRequire("7WQrb");


function $b7adce5ac5b13e8a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}



var $7WQrb = parcelRequire("7WQrb");

var $7WQrb = parcelRequire("7WQrb");

var $7WQrb = parcelRequire("7WQrb");

var $7WQrb = parcelRequire("7WQrb");

const $a54d409310b301c1$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $e1d0973d720183a9$var$safeMin = 0.001;
const $e1d0973d720183a9$export$a3cdb76e84ee608e = 0.01;
const $e1d0973d720183a9$export$1824b851fad8862b = 10.0;
const $e1d0973d720183a9$export$ff08f2d53484465 = 0.05;
const $e1d0973d720183a9$export$201ca48e54038115 = 1;
function $e1d0973d720183a9$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $4fd1ae9b00853f6f$export$491112666e282270)(duration <= $e1d0973d720183a9$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $a54d409310b301c1$export$7d15b64cf5a3a4c4)($e1d0973d720183a9$export$ff08f2d53484465, $e1d0973d720183a9$export$201ca48e54038115, dampingRatio);
    duration = (0, $a54d409310b301c1$export$7d15b64cf5a3a4c4)($e1d0973d720183a9$export$a3cdb76e84ee608e, $e1d0973d720183a9$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e1d0973d720183a9$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e1d0973d720183a9$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e1d0973d720183a9$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e1d0973d720183a9$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e1d0973d720183a9$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e1d0973d720183a9$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e1d0973d720183a9$var$rootIterations = 12;
function $e1d0973d720183a9$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e1d0973d720183a9$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e1d0973d720183a9$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $a5c2bc9ec0ebd2c6$var$durationKeys = [
    "duration",
    "bounce"
];
const $a5c2bc9ec0ebd2c6$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $a5c2bc9ec0ebd2c6$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $a5c2bc9ec0ebd2c6$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$a5c2bc9ec0ebd2c6$var$isSpringType(options, $a5c2bc9ec0ebd2c6$var$physicsKeys) && $a5c2bc9ec0ebd2c6$var$isSpringType(options, $a5c2bc9ec0ebd2c6$var$durationKeys)) {
        const derived = (0, $e1d0973d720183a9$export$b15f158dc6d6f458)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $a5c2bc9ec0ebd2c6$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $7WQrb.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $a5c2bc9ec0ebd2c6$var$getSpringOptions(options);
    let resolveSpring = $a5c2bc9ec0ebd2c6$var$zero;
    let resolveVelocity = $a5c2bc9ec0ebd2c6$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $e1d0973d720183a9$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$a5c2bc9ec0ebd2c6$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $a5c2bc9ec0ebd2c6$var$zero = (_t)=>0;


const $7bf74b962aaa51ba$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $b564c2928ae298dc$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;






const $9edef5a088e7a8bc$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $6d7848dd3b3ec6b5$export$844ec244b1367d54)(v) && (0, $6d7848dd3b3ec6b5$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $9edef5a088e7a8bc$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $6d7848dd3b3ec6b5$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $6d7848dd3b3ec6b5$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $60cf9b06eca83637$var$clampRgbUnit = (0, $6d7848dd3b3ec6b5$export$7d15b64cf5a3a4c4)(0, 255);
const $60cf9b06eca83637$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $2f64f305c5028a6f$export$98e628dec113755e)), {
    transform: (v)=>Math.round($60cf9b06eca83637$var$clampRgbUnit(v))
});
const $60cf9b06eca83637$export$4e46ac54fc82cf3b = {
    test: (0, $9edef5a088e7a8bc$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $9edef5a088e7a8bc$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $60cf9b06eca83637$export$7a99c86b5b1f4c9e.transform(red) + ", " + $60cf9b06eca83637$export$7a99c86b5b1f4c9e.transform(green) + ", " + $60cf9b06eca83637$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed)((0, $2f64f305c5028a6f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $6b4a050ea8323e36$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6b4a050ea8323e36$export$834dfc94dde4b3d8 = {
    test: (0, $9edef5a088e7a8bc$export$2c8400d58aca05e)("#"),
    parse: $6b4a050ea8323e36$var$parseHex,
    transform: (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b).transform
};





const $57907ace44cecf7d$export$810b04175080204c = {
    test: (0, $9edef5a088e7a8bc$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $9edef5a088e7a8bc$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $7053ea50bd4db8b8$export$626336c2cd4b14de).transform((0, $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $7053ea50bd4db8b8$export$626336c2cd4b14de).transform((0, $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed)((0, $2f64f305c5028a6f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



function $7a350e870196fa49$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $7a350e870196fa49$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $7a350e870196fa49$var$hueToRgb(p, q, hue + 1 / 3);
        green = $7a350e870196fa49$var$hueToRgb(p, q, hue);
        blue = $7a350e870196fa49$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}


const $24589631684f714f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $24589631684f714f$var$colorTypes = [
    (0, $6b4a050ea8323e36$export$834dfc94dde4b3d8),
    (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b),
    (0, $57907ace44cecf7d$export$810b04175080204c)
];
const $24589631684f714f$var$getColorType = (v)=>$24589631684f714f$var$colorTypes.find((type)=>type.test(v));
const $24589631684f714f$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $24589631684f714f$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $24589631684f714f$var$getColorType(from);
    let toColorType = $24589631684f714f$var$getColorType(to);
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!!fromColorType, $24589631684f714f$var$notAnimatable(from));
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!!toColorType, $24589631684f714f$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $57907ace44cecf7d$export$810b04175080204c)) {
        fromColor = (0, $7a350e870196fa49$export$6ae64dbcd6bfc33e)(fromColor);
        fromColorType = (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b);
    }
    if (toColorType === (0, $57907ace44cecf7d$export$810b04175080204c)) {
        toColor = (0, $7a350e870196fa49$export$6ae64dbcd6bfc33e)(toColor);
        toColorType = (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $24589631684f714f$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};






const $ef23ecf210043832$export$35e9368ef982300f = {
    test: (v)=>(0, $60cf9b06eca83637$export$4e46ac54fc82cf3b).test(v) || (0, $6b4a050ea8323e36$export$834dfc94dde4b3d8).test(v) || (0, $57907ace44cecf7d$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $60cf9b06eca83637$export$4e46ac54fc82cf3b).test(v)) return (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $57907ace44cecf7d$export$810b04175080204c).test(v)) return (0, $57907ace44cecf7d$export$810b04175080204c).parse(v);
        else return (0, $6b4a050ea8323e36$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $6d7848dd3b3ec6b5$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $60cf9b06eca83637$export$4e46ac54fc82cf3b).transform(v) : (0, $57907ace44cecf7d$export$810b04175080204c).transform(v);
    }
};




const $fbc1f2c1313bab98$var$colorToken = "${c}";
const $fbc1f2c1313bab98$var$numberToken = "${n}";
function $fbc1f2c1313bab98$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $6d7848dd3b3ec6b5$export$844ec244b1367d54)(v) && ((_b = (_a = v.match((0, $6d7848dd3b3ec6b5$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $6d7848dd3b3ec6b5$export$740b69c5fad25dba))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $fbc1f2c1313bab98$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $6d7848dd3b3ec6b5$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $6d7848dd3b3ec6b5$export$740b69c5fad25dba), $fbc1f2c1313bab98$var$colorToken);
        values.push(...colors.map((0, $ef23ecf210043832$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $6d7848dd3b3ec6b5$export$2444ca58c08448e4));
    if (numbers) {
        v = v.replace((0, $6d7848dd3b3ec6b5$export$2444ca58c08448e4), $fbc1f2c1313bab98$var$numberToken);
        values.push(...numbers.map((0, $2f64f305c5028a6f$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $fbc1f2c1313bab98$var$parse(v) {
    return $fbc1f2c1313bab98$var$analyse(v).values;
}
function $fbc1f2c1313bab98$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $fbc1f2c1313bab98$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $fbc1f2c1313bab98$var$colorToken : $fbc1f2c1313bab98$var$numberToken, i < numColors ? (0, $ef23ecf210043832$export$35e9368ef982300f).transform(v[i]) : (0, $6d7848dd3b3ec6b5$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $fbc1f2c1313bab98$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $fbc1f2c1313bab98$var$getAnimatableNone(v) {
    const parsed = $fbc1f2c1313bab98$var$parse(v);
    const transformer = $fbc1f2c1313bab98$var$createTransformer(v);
    return transformer(parsed.map($fbc1f2c1313bab98$var$convertNumbersToZero));
}
const $fbc1f2c1313bab98$export$83a0e34f1302825b = {
    test: $fbc1f2c1313bab98$var$test,
    parse: $fbc1f2c1313bab98$var$parse,
    createTransformer: $fbc1f2c1313bab98$var$createTransformer,
    getAnimatableNone: $fbc1f2c1313bab98$var$getAnimatableNone
};




const $5abb00901edf1187$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $5abb00901edf1187$export$4e960b977ccfec97 = (v)=>typeof v === "number";




function $afa8ea935758162e$var$getMixer(origin, target) {
    if ((0, $5abb00901edf1187$export$4e960b977ccfec97)(origin)) return (v)=>(0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $ef23ecf210043832$export$35e9368ef982300f).test(origin)) return (0, $24589631684f714f$export$51e568cf5c039bac)(origin, target);
    else return $afa8ea935758162e$export$65516310a87d8205(origin, target);
}
const $afa8ea935758162e$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$afa8ea935758162e$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $afa8ea935758162e$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $afa8ea935758162e$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $afa8ea935758162e$var$analyse(value) {
    const parsed = (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $afa8ea935758162e$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).createTransformer(target);
    const originStats = $afa8ea935758162e$var$analyse(origin);
    const targetStats = $afa8ea935758162e$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $72ee85dbfbfb2228$export$a4627e546088548d)($afa8ea935758162e$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};






const $f64591cf6cac814e$var$mixNumber = (from, to)=>(p)=>(0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(from, to, p);
function $f64591cf6cac814e$var$detectMixerFactory(v) {
    if (typeof v === "number") return $f64591cf6cac814e$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $ef23ecf210043832$export$35e9368ef982300f).test(v)) return 0, $24589631684f714f$export$51e568cf5c039bac;
        else return 0, $afa8ea935758162e$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $afa8ea935758162e$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $afa8ea935758162e$export$ebc23b6840c51ba1;
}
function $f64591cf6cac814e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $f64591cf6cac814e$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $72ee85dbfbfb2228$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $f64591cf6cac814e$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $7bf74b962aaa51ba$export$504d7abb21fa8c9)(from, to, v));
}
function $f64591cf6cac814e$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $7bf74b962aaa51ba$export$504d7abb21fa8c9)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $f64591cf6cac814e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $f64591cf6cac814e$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $f64591cf6cac814e$var$fastInterpolate(input, mixers) : $f64591cf6cac814e$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $a54d409310b301c1$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}


const $31ba6c9d119e8be7$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $31ba6c9d119e8be7$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $31ba6c9d119e8be7$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $31ba6c9d119e8be7$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $31ba6c9d119e8be7$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $31ba6c9d119e8be7$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};


const $bb4f4fde52c99102$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $bb4f4fde52c99102$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $bb4f4fde52c99102$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $bb4f4fde52c99102$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $bb4f4fde52c99102$export$45db2fc2f15997e7 = (p)=>p;
const $bb4f4fde52c99102$export$929e5a82286172a6 = (0, $31ba6c9d119e8be7$export$c90c8c5a3c7a5e80)(2);
const $bb4f4fde52c99102$export$57636bb43b1ccbb0 = (0, $31ba6c9d119e8be7$export$2c07eeff45156d4d)($bb4f4fde52c99102$export$929e5a82286172a6);
const $bb4f4fde52c99102$export$c07234257a03d5e9 = (0, $31ba6c9d119e8be7$export$f946554fb8aeaf0d)($bb4f4fde52c99102$export$929e5a82286172a6);
const $bb4f4fde52c99102$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $bb4f4fde52c99102$export$c8d67a19199d1a50 = (0, $31ba6c9d119e8be7$export$2c07eeff45156d4d)($bb4f4fde52c99102$export$e444123e42d03385);
const $bb4f4fde52c99102$export$30d3455eee55bed5 = (0, $31ba6c9d119e8be7$export$f946554fb8aeaf0d)($bb4f4fde52c99102$export$c8d67a19199d1a50);
const $bb4f4fde52c99102$export$b01116c84cdfe1a2 = (0, $31ba6c9d119e8be7$export$2a739ba6da1d1495)($bb4f4fde52c99102$var$DEFAULT_OVERSHOOT_STRENGTH);
const $bb4f4fde52c99102$export$77edfce482316a60 = (0, $31ba6c9d119e8be7$export$2c07eeff45156d4d)($bb4f4fde52c99102$export$b01116c84cdfe1a2);
const $bb4f4fde52c99102$export$ddc5fd596f6c71b2 = (0, $31ba6c9d119e8be7$export$f946554fb8aeaf0d)($bb4f4fde52c99102$export$b01116c84cdfe1a2);
const $bb4f4fde52c99102$export$6b0af63b873d419e = (0, $31ba6c9d119e8be7$export$222fa0be41d8b537)($bb4f4fde52c99102$var$DEFAULT_OVERSHOOT_STRENGTH);
const $bb4f4fde52c99102$var$ca = 4356.0 / 361.0;
const $bb4f4fde52c99102$var$cb = 35442.0 / 1805.0;
const $bb4f4fde52c99102$var$cc = 16061.0 / 1805.0;
const $bb4f4fde52c99102$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $bb4f4fde52c99102$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $bb4f4fde52c99102$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $bb4f4fde52c99102$var$BOUNCE_THIRD_THRESHOLD ? $bb4f4fde52c99102$var$ca * p2 - $bb4f4fde52c99102$var$cb * p + $bb4f4fde52c99102$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $bb4f4fde52c99102$export$fccebd7948554554 = (0, $31ba6c9d119e8be7$export$2c07eeff45156d4d)($bb4f4fde52c99102$export$cccc9e04465dce11);
const $bb4f4fde52c99102$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $bb4f4fde52c99102$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $bb4f4fde52c99102$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;


function $73997c813ec0c0e6$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $bb4f4fde52c99102$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $73997c813ec0c0e6$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $73997c813ec0c0e6$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $73997c813ec0c0e6$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $73997c813ec0c0e6$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $73997c813ec0c0e6$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $f64591cf6cac814e$export$89e29e4ab65e70a9)(times, values, {
            ease: Array.isArray(ease) ? ease : $73997c813ec0c0e6$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}


function $ab89f293e714664e$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}


const $5be904e1222a2339$var$types = {
    keyframes: $73997c813ec0c0e6$export$d25ddfdf17c3ad3e,
    spring: $a5c2bc9ec0ebd2c6$export$b36281d89752ae66,
    decay: $ab89f293e714664e$export$e9341ba102272ab9
};
function $5be904e1222a2339$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $73997c813ec0c0e6$export$d25ddfdf17c3ad3e;
    else if ($5be904e1222a2339$var$types[config.type]) return $5be904e1222a2339$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $73997c813ec0c0e6$export$d25ddfdf17c3ad3e;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $a5c2bc9ec0ebd2c6$export$b36281d89752ae66;
    return 0, $73997c813ec0c0e6$export$d25ddfdf17c3ad3e;
}




function $baa5f6ff992ac129$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $baa5f6ff992ac129$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $baa5f6ff992ac129$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $baa5f6ff992ac129$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}


const $776a01cac547a720$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $741aad569b766a4c$export$2e2bcd8739ae039).update(passTimestamp, true),
        stop: ()=>(0, $741aad569b766a4c$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $776a01cac547a720$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $776a01cac547a720$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $7WQrb.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $5be904e1222a2339$export$74df49bbebf8cb2c)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $f64591cf6cac814e$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $baa5f6ff992ac129$export$ab9042754680126b)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $baa5f6ff992ac129$export$7d0784e050d8e25f)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $baa5f6ff992ac129$export$c9c9437f9b8733b5)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}


function $bc439f50a2ba768a$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



function $9f01fbb988becf16$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $776a01cac547a720$export$e3607ec2d7a891c4)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $bc439f50a2ba768a$export$eab0632f7ad4f9d7)(v - prev, (0, $741aad569b766a4c$export$7244445918e670ed)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $4d9ddd47afc34a4b$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;




const $ee876282e941e744$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $ee876282e941e744$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $ee876282e941e744$var$c = (a1)=>3.0 * a1;
const $ee876282e941e744$var$calcBezier = (t, a1, a2)=>(($ee876282e941e744$var$a(a1, a2) * t + $ee876282e941e744$var$b(a1, a2)) * t + $ee876282e941e744$var$c(a1)) * t;
const $ee876282e941e744$var$getSlope = (t, a1, a2)=>3.0 * $ee876282e941e744$var$a(a1, a2) * t * t + 2.0 * $ee876282e941e744$var$b(a1, a2) * t + $ee876282e941e744$var$c(a1);
const $ee876282e941e744$var$subdivisionPrecision = 0.0000001;
const $ee876282e941e744$var$subdivisionMaxIterations = 10;
function $ee876282e941e744$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $ee876282e941e744$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $ee876282e941e744$var$subdivisionPrecision && ++i < $ee876282e941e744$var$subdivisionMaxIterations);
    return currentT;
}
const $ee876282e941e744$var$newtonIterations = 8;
const $ee876282e941e744$var$newtonMinSlope = 0.001;
function $ee876282e941e744$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $ee876282e941e744$var$newtonIterations; ++i){
        const currentSlope = $ee876282e941e744$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $ee876282e941e744$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $ee876282e941e744$var$kSplineTableSize = 11;
const $ee876282e941e744$var$kSampleStepSize = 1.0 / ($ee876282e941e744$var$kSplineTableSize - 1.0);
function $ee876282e941e744$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $bb4f4fde52c99102$export$45db2fc2f15997e7;
    const sampleValues = new Float32Array($ee876282e941e744$var$kSplineTableSize);
    for(let i = 0; i < $ee876282e941e744$var$kSplineTableSize; ++i)sampleValues[i] = $ee876282e941e744$var$calcBezier(i * $ee876282e941e744$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $ee876282e941e744$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $ee876282e941e744$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $ee876282e941e744$var$kSampleStepSize;
        const initialSlope = $ee876282e941e744$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $ee876282e941e744$var$newtonMinSlope) return $ee876282e941e744$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $ee876282e941e744$var$binarySubdivide(aX, intervalStart, intervalStart + $ee876282e941e744$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $ee876282e941e744$var$calcBezier(getTForX(t), mY1, mY2);
}


const $e95889d9d68fb798$var$easingLookup = {
    linear: $bb4f4fde52c99102$export$45db2fc2f15997e7,
    easeIn: $bb4f4fde52c99102$export$929e5a82286172a6,
    easeInOut: $bb4f4fde52c99102$export$c07234257a03d5e9,
    easeOut: $bb4f4fde52c99102$export$57636bb43b1ccbb0,
    circIn: $bb4f4fde52c99102$export$e444123e42d03385,
    circInOut: $bb4f4fde52c99102$export$30d3455eee55bed5,
    circOut: $bb4f4fde52c99102$export$c8d67a19199d1a50,
    backIn: $bb4f4fde52c99102$export$b01116c84cdfe1a2,
    backInOut: $bb4f4fde52c99102$export$ddc5fd596f6c71b2,
    backOut: $bb4f4fde52c99102$export$77edfce482316a60,
    anticipate: $bb4f4fde52c99102$export$6b0af63b873d419e,
    bounceIn: $bb4f4fde52c99102$export$fccebd7948554554,
    bounceInOut: $bb4f4fde52c99102$export$41ad9e9849a703ce,
    bounceOut: $bb4f4fde52c99102$export$cccc9e04465dce11
};
const $e95889d9d68fb798$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $ee876282e941e744$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)($e95889d9d68fb798$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $e95889d9d68fb798$var$easingLookup[definition];
    }
    return definition;
};
const $e95889d9d68fb798$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $526e91ddc3922da2$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};



const $e15b2240e296c05a$export$2577c2184b2254d3 = ()=>({
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    });
const $e15b2240e296c05a$export$a743142a31c132c = (to)=>({
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $e15b2240e296c05a$export$c2d663fbb86d66d6 = ()=>({
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    });
const $e15b2240e296c05a$var$keyframes = (values)=>({
        type: "keyframes",
        duration: 0.8,
        values: values
    });
const $e15b2240e296c05a$var$defaultTransitions = {
    x: $e15b2240e296c05a$export$2577c2184b2254d3,
    y: $e15b2240e296c05a$export$2577c2184b2254d3,
    z: $e15b2240e296c05a$export$2577c2184b2254d3,
    rotate: $e15b2240e296c05a$export$2577c2184b2254d3,
    rotateX: $e15b2240e296c05a$export$2577c2184b2254d3,
    rotateY: $e15b2240e296c05a$export$2577c2184b2254d3,
    rotateZ: $e15b2240e296c05a$export$2577c2184b2254d3,
    scaleX: $e15b2240e296c05a$export$a743142a31c132c,
    scaleY: $e15b2240e296c05a$export$a743142a31c132c,
    scale: $e15b2240e296c05a$export$a743142a31c132c,
    opacity: $e15b2240e296c05a$export$c2d663fbb86d66d6,
    backgroundColor: $e15b2240e296c05a$export$c2d663fbb86d66d6,
    color: $e15b2240e296c05a$export$c2d663fbb86d66d6,
    default: $e15b2240e296c05a$export$a743142a31c132c
};
const $e15b2240e296c05a$export$262124b154b9f1c0 = (valueKey, to)=>{
    let transitionFactory;
    if ((0, $cb191701c4d6cd5b$export$9153ad4c4999f4a0)(to)) transitionFactory = $e15b2240e296c05a$var$keyframes;
    else transitionFactory = $e15b2240e296c05a$var$defaultTransitions[valueKey] || $e15b2240e296c05a$var$defaultTransitions.default;
    return Object.assign({
        to: to
    }, transitionFactory(to));
};





const $b2d18e97a0fa9b81$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $b2d18e97a0fa9b81$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $6d7848dd3b3ec6b5$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $b2d18e97a0fa9b81$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $b2d18e97a0fa9b81$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $b2d18e97a0fa9b81$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $fbc1f2c1313bab98$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($b2d18e97a0fa9b81$var$functionRegex);
        return functions ? functions.map($b2d18e97a0fa9b81$var$applyDefaultFilter).join(" ") : v;
    }
});




/**
 * A map of default value types for common values
 */ const $f0d8d6602efe4eb4$export$98cd7c72c5a731fb = Object.assign(Object.assign({}, (0, $ea242f0d47c4a8ec$export$eec14432cd1cb67b)), {
    color: // Color props
    $ef23ecf210043832$export$35e9368ef982300f,
    backgroundColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    outlineColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    fill: (0, $ef23ecf210043832$export$35e9368ef982300f),
    stroke: (0, $ef23ecf210043832$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    borderTopColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    borderRightColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    borderBottomColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    borderLeftColor: (0, $ef23ecf210043832$export$35e9368ef982300f),
    filter: $b2d18e97a0fa9b81$export$3dea766d36a8935f,
    WebkitFilter: (0, $b2d18e97a0fa9b81$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ const $f0d8d6602efe4eb4$export$67d1babe0338d23b = (key)=>$f0d8d6602efe4eb4$export$98cd7c72c5a731fb[key];


function $0e1e432199b9680f$export$cea0cedcb94873b5(key, value) {
    var _a;
    let defaultValueType = (0, $f0d8d6602efe4eb4$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $b2d18e97a0fa9b81$export$3dea766d36a8935f)) defaultValueType = (0, $fbc1f2c1313bab98$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}


const $d44526e9f8e4c9df$export$888a3d84909f9e3d = {
    current: false
};



/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $f7775545d8272411$export$ca8e47dc8ed5a9d7(_a) {
    var transition = (0, $7WQrb.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
let $f7775545d8272411$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $f7775545d8272411$export$998eb6d72a6574db(_a) {
    var { ease: ease, times: times, yoyo: yoyo, flip: flip, loop: loop } = _a, transition = (0, $7WQrb.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    const options = Object.assign({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $4d9ddd47afc34a4b$export$fc3e7e8557f8c8c7)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $4d9ddd47afc34a4b$export$fc3e7e8557f8c8c7)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $e95889d9d68fb798$export$216948827bbdc797)(ease) ? ease.map((0, $e95889d9d68fb798$export$ef97fe084f156ca4)) : (0, $e95889d9d68fb798$export$ef97fe084f156ca4)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(!$f7775545d8272411$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $f7775545d8272411$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $f7775545d8272411$export$b55a0e77aebddb70(transition, key) {
    var _a, _b;
    const valueTransition = $f7775545d8272411$export$7c1391340308742e(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function $f7775545d8272411$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = [
            ...options.to
        ];
        options.to[0] = options.from;
    }
    return options;
}
function $f7775545d8272411$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $f7775545d8272411$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$f7775545d8272411$export$ca8e47dc8ed5a9d7(transition)) transition = Object.assign(Object.assign({}, transition), (0, $e15b2240e296c05a$export$262124b154b9f1c0)(key, options.to));
    return Object.assign(Object.assign({}, options), $f7775545d8272411$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $f7775545d8272411$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    const valueTransition = $f7775545d8272411$export$7c1391340308742e(transition, key);
    let origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    const isTargetAnimatable = (0, $526e91ddc3922da2$export$65676b58b122bc38)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $0e1e432199b9680f$export$cea0cedcb94873b5)(key, target);
    else if ($f7775545d8272411$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $f7775545d8272411$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $f7775545d8272411$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $f7775545d8272411$export$36cd6032f9de8a48(origin);
    const isOriginAnimatable = (0, $526e91ddc3922da2$export$65676b58b122bc38)(key, origin);
    (0, $4fd1ae9b00853f6f$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${key} from "${origin}" to "${target}". ${origin} is not an animatable value - to enable this animation set ${origin} to a value animatable to ${target} via the \`style\` property.`);
    function start() {
        const options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: (v)=>value.set(v)
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $9f01fbb988becf16$export$ee3ff3a17106998)(Object.assign(Object.assign({}, options), valueTransition)) : (0, $776a01cac547a720$export$e3607ec2d7a891c4)(Object.assign(Object.assign({}, $f7775545d8272411$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: (v)=>{
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: ()=>{
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        const finalTarget = (0, $52f006ed9a22dd67$export$5485128c47bd48bb)(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: ()=>{}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $f7775545d8272411$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $f7775545d8272411$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $0e1e432199b9680f$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $f7775545d8272411$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function $f7775545d8272411$export$592dbd515a49cf1b(key, value, target, transition = {}) {
    if ((0, $d44526e9f8e4c9df$export$888a3d84909f9e3d).current) transition = {
        type: false
    };
    return value.start((onComplete)=>{
        let delayTimer;
        let controls;
        const animation = $f7775545d8272411$var$getAnimation(key, value, target, transition, onComplete);
        const delay = $f7775545d8272411$export$b55a0e77aebddb70(transition, key);
        const start = ()=>controls = animation();
        if (delay) delayTimer = window.setTimeout(start, (0, $4d9ddd47afc34a4b$export$fc3e7e8557f8c8c7)(delay));
        else start();
        return ()=>{
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}



var $7WQrb = parcelRequire("7WQrb");

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $25efaedc655d899e$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $fd760a472026d312$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);





function $3572374855c91d5f$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3572374855c91d5f$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3572374855c91d5f$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $3572374855c91d5f$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $3572374855c91d5f$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


const $a36f38d144f94e7c$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $a36f38d144f94e7c$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "7.2.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current) this.updateSubscribers.notify(this.current);
            // Update velocity subscribers
            if (this.velocityUpdateSubscribers.getSize()) this.velocityUpdateSubscribers.notify(this.getVelocity());
            // Update render subscribers
            if (render) this.renderSubscribers.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                this.velocityUpdateSubscribers.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $a36f38d144f94e7c$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ onChange(subscription) {
        return this.updateSubscribers.add(subscription);
    }
    clearListeners() {
        this.updateSubscribers.clear();
    }
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ onRenderRequest(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $bc439f50a2ba768a$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(animation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
        }).then(()=>this.clearAnimation());
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    }
}
function $a36f38d144f94e7c$export$ce8bdc721e76545f(init) {
    return new $a36f38d144f94e7c$export$8cea36d14ee64562(init);
}





/**
 * Tests a provided value against a ValueType
 */ const $1dc6c4ca114b532e$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $28b86e603ac745c5$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $c71e259185df4a56$export$d176691c1998a1f5 = [
    (0, $2f64f305c5028a6f$export$98e628dec113755e),
    (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008),
    (0, $7053ea50bd4db8b8$export$626336c2cd4b14de),
    (0, $7053ea50bd4db8b8$export$41fc368e1a942b97),
    (0, $7053ea50bd4db8b8$export$aed3d7b7d206c196),
    (0, $7053ea50bd4db8b8$export$f91e8c45a95a32f2),
    (0, $28b86e603ac745c5$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $c71e259185df4a56$export$eefdd52e3ccae428 = (v)=>$c71e259185df4a56$export$d176691c1998a1f5.find((0, $1dc6c4ca114b532e$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $12041c42cfd485f0$var$valueTypes = [
    ...(0, $c71e259185df4a56$export$d176691c1998a1f5),
    (0, $ef23ecf210043832$export$35e9368ef982300f),
    (0, $fbc1f2c1313bab98$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $12041c42cfd485f0$export$950e7e59ea1ffed7 = (v)=>$12041c42cfd485f0$var$valueTypes.find((0, $1dc6c4ca114b532e$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $5e97cf8de56a4aeb$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)(value));
}
function $5e97cf8de56a4aeb$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $9fc0609ad108c3b4$export$7b1b1c981f4f0558)(visualElement, definition);
    let _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, { transitionEnd: transitionEnd = {}, transition: transition = {} } = _a, target = (0, $7WQrb.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = Object.assign(Object.assign({}, target), transitionEnd);
    for(const key in target){
        const value = (0, $52f006ed9a22dd67$export$5485128c47bd48bb)(target[key]);
        $5e97cf8de56a4aeb$var$setMotionValue(visualElement, key, value);
    }
}
function $5e97cf8de56a4aeb$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        var _a;
        const variant = visualElement.getVariant(key);
        variant && $5e97cf8de56a4aeb$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            $5e97cf8de56a4aeb$var$setVariants(child, variantLabels);
        });
    });
}
function $5e97cf8de56a4aeb$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $5e97cf8de56a4aeb$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $5e97cf8de56a4aeb$var$setVariants(visualElement, [
        definition
    ]);
    else $5e97cf8de56a4aeb$export$1f61c53461aff4a5(visualElement, definition);
}
function $5e97cf8de56a4aeb$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $25efaedc655d899e$export$65583ed5a868f2d9)(value) || (0, $fd760a472026d312$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $12041c42cfd485f0$export$950e7e59ea1ffed7)(value) && (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).test(targetValue)) value = (0, $0e1e432199b9680f$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $5e97cf8de56a4aeb$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $5e97cf8de56a4aeb$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    const origin = {};
    for(const key in target)origin[key] = (_a = $5e97cf8de56a4aeb$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}





function $d1f89f312c7fb45a$export$98397f3adbf6259f(value) {
    return Boolean((0, $513bb72e2a3b2c38$export$605d60a2578142d3)(value) && value.add);
}


function $ff749f65475ff6a2$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notifyAnimationStart(definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>$ff749f65475ff6a2$var$animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $ff749f65475ff6a2$var$animateVariant(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $9fc0609ad108c3b4$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $ff749f65475ff6a2$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(()=>visualElement.notifyAnimationComplete(definition));
}
function $ff749f65475ff6a2$var$animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $9fc0609ad108c3b4$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>$ff749f65475ff6a2$var$animateTarget(visualElement, resolved, options) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $ff749f65475ff6a2$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $ff749f65475ff6a2$var$animateTarget(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let _b = visualElement.makeTargetAnimatable(definition), { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd } = _b, target = (0, $7WQrb.__rest)(_b, [
        "transition",
        "transitionEnd"
    ]);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $ff749f65475ff6a2$var$shouldBlockAnimation(animationTypeState, key)) continue;
        let valueTransition = Object.assign({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $73c07a5d0b8699a4$export$15240a8a4379d8de)(key)) valueTransition = Object.assign(Object.assign({}, valueTransition), {
            type: false,
            delay: 0
        });
        let animation = (0, $f7775545d8272411$export$592dbd515a49cf1b)(key, value, valueTarget, valueTransition);
        if ((0, $d1f89f312c7fb45a$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation = animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(()=>{
        transitionEnd && (0, $5e97cf8de56a4aeb$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $ff749f65475ff6a2$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($ff749f65475ff6a2$export$523a0bedf33ad781).forEach((child, i)=>{
        animations.push($ff749f65475ff6a2$var$animateVariant(child, variant, Object.assign(Object.assign({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(()=>child.notifyAnimationComplete(variant)));
    });
    return Promise.all(animations);
}
function $ff749f65475ff6a2$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue((value)=>value.stop());
}
function $ff749f65475ff6a2$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $ff749f65475ff6a2$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}




const $dffd66329b96c3c5$export$16e45afcc206d3a8 = [
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Animate,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).InView,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Focus,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Hover,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Tap,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Drag,
    (0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Exit
];
const $dffd66329b96c3c5$var$reversePriorityOrder = [
    ...$dffd66329b96c3c5$export$16e45afcc206d3a8
].reverse();
const $dffd66329b96c3c5$var$numAnimationTypes = $dffd66329b96c3c5$export$16e45afcc206d3a8.length;
function $dffd66329b96c3c5$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $ff749f65475ff6a2$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $dffd66329b96c3c5$export$bb53502b7a672aa8(visualElement) {
    let animate = $dffd66329b96c3c5$var$animateList(visualElement);
    const state = $dffd66329b96c3c5$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $9fc0609ad108c3b4$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $7WQrb.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = Object.assign(Object.assign(Object.assign({}, acc), target), transitionEnd);
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $dffd66329b96c3c5$var$numAnimationTypes; i++){
            const type = $dffd66329b96c3c5$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            const propIsVariant = (0, $9fc0609ad108c3b4$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = Object.assign({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $d53c40212eb56791$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $dffd66329b96c3c5$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = Object.assign(Object.assign({}, prevResolvedValues), resolvedValues);
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $cb191701c4d6cd5b$export$9153ad4c4999f4a0)(next) && (0, $cb191701c4d6cd5b$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $b7adce5ac5b13e8a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = Object.assign(Object.assign({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: Object.assign({
                        type: type
                    }, options)
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $dffd66329b96c3c5$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $9fc0609ad108c3b4$export$562271cd22f751d)(next)) return !(0, $b7adce5ac5b13e8a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $dffd66329b96c3c5$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $dffd66329b96c3c5$var$createState() {
    return {
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Animate]: $dffd66329b96c3c5$var$createTypeState(true),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).InView]: $dffd66329b96c3c5$var$createTypeState(),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Hover]: $dffd66329b96c3c5$var$createTypeState(),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Tap]: $dffd66329b96c3c5$var$createTypeState(),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Drag]: $dffd66329b96c3c5$var$createTypeState(),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Focus]: $dffd66329b96c3c5$var$createTypeState(),
        [(0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Exit]: $dffd66329b96c3c5$var$createTypeState()
    };
}




const $4835319a35a50ba0$export$7f9953c70dacfd7f = {
    animation: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)(({ visualElement: visualElement, animate: animate })=>{
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $dffd66329b96c3c5$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $d53c40212eb56791$export$aa71198ceeaf53ce)(animate)) (0, $acw62.useEffect)(()=>animate.subscribe(visualElement), [
            animate
        ]);
    }),
    exit: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((props)=>{
        const { custom: custom, visualElement: visualElement } = props;
        const [isPresent, safeToRemove] = (0, $4332d507cd311a00$export$2a8c16d82a0a0e26)();
        const presenceContext = (0, $acw62.useContext)((0, $e26ddca02c6ea1a0$export$f224e4635b6f8ce2));
        (0, $acw62.useEffect)(()=>{
            var _a, _b;
            visualElement.isPresent = isPresent;
            const animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};



var $acw62 = parcelRequire("acw62");






const $3fc9c01a7f128781$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");



const $9d3540ae63683297$export$319d74662aaa2966 = (point)=>(0, $3fc9c01a7f128781$export$aff838a5553f2a92)(point) && point.hasOwnProperty("z");



const $59c45a26d5fcb906$var$distance1D = (a, b)=>Math.abs(a - b);
function $59c45a26d5fcb906$export$9f17032d917177de(a, b) {
    if ((0, $5abb00901edf1187$export$4e960b977ccfec97)(a) && (0, $5abb00901edf1187$export$4e960b977ccfec97)(b)) return $59c45a26d5fcb906$var$distance1D(a, b);
    else if ((0, $3fc9c01a7f128781$export$aff838a5553f2a92)(a) && (0, $3fc9c01a7f128781$export$aff838a5553f2a92)(b)) {
        const xDelta = $59c45a26d5fcb906$var$distance1D(a.x, b.x);
        const yDelta = $59c45a26d5fcb906$var$distance1D(a.y, b.y);
        const zDelta = (0, $9d3540ae63683297$export$319d74662aaa2966)(a) && (0, $9d3540ae63683297$export$319d74662aaa2966)(b) ? $59c45a26d5fcb906$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}


/**
 * @internal
 */ class $37501b120e4c5c84$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $37501b120e4c5c84$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $59c45a26d5fcb906$export$9f17032d917177de)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
            this.history.push(Object.assign(Object.assign({}, point), {
                timestamp: timestamp
            }));
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $37501b120e4c5c84$var$transformPoint(info, this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $6732a47008b71f77$export$764db16956f554f8)(event) && event.buttons === 0) {
                this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $37501b120e4c5c84$var$getPanInfo($37501b120e4c5c84$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $6732a47008b71f77$export$c4dfce035d43d1e0)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $5dd76cedb80f66a0$export$12f84bb882d06e1a)(event);
        const initialInfo = $37501b120e4c5c84$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $741aad569b766a4c$export$7244445918e670ed)();
        this.history = [
            Object.assign(Object.assign({}, point), {
                timestamp: timestamp
            })
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $37501b120e4c5c84$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $72ee85dbfbfb2228$export$a4627e546088548d)((0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $37501b120e4c5c84$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $37501b120e4c5c84$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $37501b120e4c5c84$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $37501b120e4c5c84$var$subtractPoint(point, $37501b120e4c5c84$var$lastDevicePoint(history)),
        offset: $37501b120e4c5c84$var$subtractPoint(point, $37501b120e4c5c84$var$startDevicePoint(history)),
        velocity: $37501b120e4c5c84$var$getVelocity(history, 0.1)
    };
}
function $37501b120e4c5c84$var$startDevicePoint(history) {
    return history[0];
}
function $37501b120e4c5c84$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $37501b120e4c5c84$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $37501b120e4c5c84$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $4d9ddd47afc34a4b$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b8541eec9de7918b$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b8541eec9de7918b$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return (0, $59c45a26d5fcb906$export$9f17032d917177de)(value, target) < maxDistance;
}
function $b8541eec9de7918b$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b8541eec9de7918b$export$c1c127004b72a37(target) / $b8541eec9de7918b$export$c1c127004b72a37(source);
    if ($b8541eec9de7918b$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b8541eec9de7918b$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b8541eec9de7918b$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b8541eec9de7918b$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $b8541eec9de7918b$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $b8541eec9de7918b$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b8541eec9de7918b$export$c1c127004b72a37(relative);
}
function $b8541eec9de7918b$export$426154f9d100f99(target, relative, parent) {
    $b8541eec9de7918b$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b8541eec9de7918b$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b8541eec9de7918b$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b8541eec9de7918b$export$c1c127004b72a37(layout);
}
function $b8541eec9de7918b$export$2785bfcc929c5650(target, layout, parent) {
    $b8541eec9de7918b$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b8541eec9de7918b$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $94a1fa3fad900562$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $94a1fa3fad900562$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $94a1fa3fad900562$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $94a1fa3fad900562$export$690c180aa5775042(layoutBox.x, left, right),
        y: $94a1fa3fad900562$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $94a1fa3fad900562$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $94a1fa3fad900562$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $94a1fa3fad900562$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $94a1fa3fad900562$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $94a1fa3fad900562$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b8541eec9de7918b$export$c1c127004b72a37)(source);
    const targetLength = (0, $b8541eec9de7918b$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $7bf74b962aaa51ba$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $7bf74b962aaa51ba$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $a54d409310b301c1$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $94a1fa3fad900562$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $94a1fa3fad900562$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $94a1fa3fad900562$export$7c5eaef8f4723d22(dragElastic = $94a1fa3fad900562$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $94a1fa3fad900562$export$a3366d3bac43a742;
    return {
        x: $94a1fa3fad900562$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $94a1fa3fad900562$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $94a1fa3fad900562$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $94a1fa3fad900562$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $94a1fa3fad900562$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $94a1fa3fad900562$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



const $cd73f61bf295ea66$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $cd73f61bf295ea66$export$3d227df54007d73a = ()=>({
        x: $cd73f61bf295ea66$export$ff25708b37f72782(),
        y: $cd73f61bf295ea66$export$ff25708b37f72782()
    });
const $cd73f61bf295ea66$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $cd73f61bf295ea66$export$6459fc9e86be362e = ()=>({
        x: $cd73f61bf295ea66$export$6db76765312617ac(),
        y: $cd73f61bf295ea66$export$6db76765312617ac()
    });


function $d0f2d46f6c63e689$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $bc49f17c50b3f81d$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $bc49f17c50b3f81d$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $bc49f17c50b3f81d$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $460146e1da75af03$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $460146e1da75af03$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$460146e1da75af03$var$isIdentityScale(scale) || !$460146e1da75af03$var$isIdentityScale(scaleX) || !$460146e1da75af03$var$isIdentityScale(scaleY);
}
function $460146e1da75af03$export$a545127cf1fbb600(values) {
    return $460146e1da75af03$export$bdf30dca883ea463(values) || $460146e1da75af03$var$hasTranslate(values.x) || $460146e1da75af03$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $460146e1da75af03$var$hasTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $0b4972342458c5b9$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $0b4972342458c5b9$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $0b4972342458c5b9$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $0b4972342458c5b9$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $0b4972342458c5b9$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $0b4972342458c5b9$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $0b4972342458c5b9$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $0b4972342458c5b9$export$d80074982803af5c(box, { x: x, y: y }) {
    $0b4972342458c5b9$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $0b4972342458c5b9$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $0b4972342458c5b9$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $0b4972342458c5b9$export$58b16271041fbfb(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $0b4972342458c5b9$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $460146e1da75af03$export$a545127cf1fbb600)(node.latestValues)) $0b4972342458c5b9$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $0b4972342458c5b9$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $0b4972342458c5b9$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $0b4972342458c5b9$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $0b4972342458c5b9$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $0b4972342458c5b9$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $0b4972342458c5b9$export$58b16271041fbfb(box, transform) {
    $0b4972342458c5b9$export$625f1dd140a2f5e7(box.x, transform, $0b4972342458c5b9$var$xKeys);
    $0b4972342458c5b9$export$625f1dd140a2f5e7(box.y, transform, $0b4972342458c5b9$var$yKeys);
}


function $1ba7f60b818ea8ed$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $bc49f17c50b3f81d$export$d3955c6a8f65a36b)((0, $bc49f17c50b3f81d$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $1ba7f60b818ea8ed$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $1ba7f60b818ea8ed$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(viewportBox.x, scroll.x);
        (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}









const $3da4be9d4bc9b72b$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
class $3da4be9d4bc9b72b$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $5dd76cedb80f66a0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $2adcc7ef57987f19$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $7053ea50bd4db8b8$export$626336c2cd4b14de).test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        const length = (0, $b8541eec9de7918b$export$c1c127004b72a37)(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Drag, true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $3da4be9d4bc9b72b$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $37501b120e4c5c84$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $ee70e57f3fb913dc$export$2deb71ebd3734d23).Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3da4be9d4bc9b72b$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $94a1fa3fad900562$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $10bfea9bcc41843f$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $94a1fa3fad900562$export$4e9195bf7793bc78)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $94a1fa3fad900562$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $94a1fa3fad900562$export$e9672cc4c36a8b87)(layout.actual[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $10bfea9bcc41843f$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $1ba7f60b818ea8ed$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $94a1fa3fad900562$export$4228500f19d4cdf7)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $bc49f17c50b3f81d$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $bc49f17c50b3f81d$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            var _a;
            if (!$3da4be9d4bc9b72b$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = Object.assign(Object.assign({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return (0, $f7775545d8272411$export$592dbd515a49cf1b)(axis, axisValue, 0, transition);
    }
    stopAnimation() {
        (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        var _a, _b;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    }
    snapToCursor(point) {
        (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$3da4be9d4bc9b72b$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.actual[axis];
                axisValue.set(point[axis] - (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        var _a;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $10bfea9bcc41843f$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $94a1fa3fad900562$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            if (!$3da4be9d4bc9b72b$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        $3da4be9d4bc9b72b$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $e3b54d28724d6a02$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $10bfea9bcc41843f$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $f3a3b2c3f11b0939$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.syncRender();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $94a1fa3fad900562$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return Object.assign(Object.assign({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    }
}
function $3da4be9d4bc9b72b$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3da4be9d4bc9b72b$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $b6fd39ed13003d2c$export$7941f8aafa4b6021(props) {
    const { dragControls: groupDragControls, visualElement: visualElement } = props;
    const dragControls = (0, $3746c7fe46fc0226$export$fe4300aa8eebea86)(()=>new (0, $3da4be9d4bc9b72b$export$86bff71f18910307)(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $acw62.useEffect)(()=>groupDragControls && groupDragControls.subscribe(dragControls), [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $acw62.useEffect)(()=>dragControls.addListeners(), [
        dragControls
    ]);
}



var $acw62 = parcelRequire("acw62");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $ffccd31e993ac9b3$export$eb0f62174cac1aec({ onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, visualElement: visualElement }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = (0, $acw62.useRef)(null);
    const { transformPagePoint: transformPagePoint } = (0, $acw62.useContext)((0, $dc1f85223fd7ddd4$export$22a697fb29aac98d));
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info)=>{
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $37501b120e4c5c84$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $e3b54d28724d6a02$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $7cdfaf436d3d3a7e$export$f3a192d0cbd30b96)(()=>panSession.current && panSession.current.end());
}



const $862fa84301dd2a70$export$d7d5d435647ed5a0 = {
    pan: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $ffccd31e993ac9b3$export$eb0f62174cac1aec)),
    drag: (0, $cc60e9fdceeef420$export$46d1d6d046f826e4)((0, $b6fd39ed13003d2c$export$7941f8aafa4b6021))
};



var $7WQrb = parcelRequire("7WQrb");

var $7WQrb = parcelRequire("7WQrb");






const $45baa5d7eeeada9b$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $45baa5d7eeeada9b$export$f6841af6ea5003ab() {
    const managers = $45baa5d7eeeada9b$var$names.map(()=>new (0, $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c)());
    const propSubscriptions = {};
    const lifecycles = {
        clearAllListeners: ()=>managers.forEach((manager)=>manager.clear()),
        updatePropListeners: (props)=>{
            $45baa5d7eeeada9b$var$names.forEach((name)=>{
                var _a;
                const on = "on" + name;
                const propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach((manager, i)=>{
        lifecycles["on" + $45baa5d7eeeada9b$var$names[i]] = (handler)=>manager.add(handler);
        lifecycles["notify" + $45baa5d7eeeada9b$var$names[i]] = (...args)=>manager.notify(...args);
    });
    return lifecycles;
}






function $cdc84e4516939e8e$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $513bb72e2a3b2c38$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d1f89f312c7fb45a$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $513bb72e2a3b2c38$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)(nextValue));
            if ((0, $d1f89f312c7fb45a$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



const $f26b19dcd9ae5e4b$export$5ad594e944c33d76 = ({ treeType: treeType = "", build: build, getBaseTarget: getBaseTarget, makeTargetAnimatable: makeTargetAnimatable, measureViewportBox: measureViewportBox, render: renderInstance, readValueFromInstance: readValueFromInstance, removeValueFromRenderState: removeValueFromRenderState, sortNodePosition: sortNodePosition, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps })=>({ parent: parent, props: props, presenceId: presenceId, blockInitialAnimation: blockInitialAnimation, visualState: visualState, shouldReduceMotion: shouldReduceMotion }, options = {})=>{
        let isMounted = false;
        const { latestValues: latestValues, renderState: renderState } = visualState;
        /**
     * The instance of the render-specific node that will be hydrated by the
     * exposed React ref. So for example, this visual element can host a
     * HTMLElement, plain object, or Three.js object. The functions provided
     * in VisualElementConfig allow us to interface with this instance.
     */ let instance;
        /**
     * Manages the subscriptions for a visual element's lifecycle, for instance
     * onRender
     */ const lifecycles = (0, $45baa5d7eeeada9b$export$f6841af6ea5003ab)();
        /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */ const values = new Map();
        /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */ const valueSubscriptions = new Map();
        /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */ let prevMotionValues = {};
        /**
     * When values are removed from all animation props we need to search
     * for a fallback value to animate to. These values are tracked in baseTarget.
     */ const baseTarget = Object.assign({}, latestValues);
        // Internal methods ========================
        /**
     * On mount, this will be hydrated with a callback to disconnect
     * this visual element from its parent on unmount.
     */ let removeFromVariantTree;
        /**
     * Render the element with the latest styles outside of the React
     * render lifecycle
     */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
     *
     */ function bindToMotionValue(key, value) {
            const removeOnChange = value.onChange((latestValue)=>{
                latestValues[key] = latestValue;
                props.onUpdate && (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(update, false, true);
            });
            const removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, ()=>{
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't neccessarily a breaking change,
     * more a reflection of the test.
     */ const _a = scrapeMotionValuesFromProps(props), { willChange: willChange } = _a, initialMotionValues = (0, $7WQrb.__rest)(_a, [
            "willChange"
        ]);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $513bb72e2a3b2c38$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d1f89f312c7fb45a$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
        /**
     * Determine what role this visual element should take in the variant tree.
     */ const isControllingVariants = (0, $9fc0609ad108c3b4$export$cf3a7bd331c35bf0)(props);
        const isVariantNode = (0, $9fc0609ad108c3b4$export$c0eba02279c18fea)(props);
        const element = Object.assign(Object.assign({
            treeType: treeType,
            /**
         * This is a mirror of the internal instance prop, which keeps
         * VisualElement type-compatible with React's RefObject.
         */ current: null,
            /**
         * The depth of this visual element within the visual element tree.
         */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            presenceId: /**
         *
         */ presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
         * If this component is part of the variant tree, it should track
         * any children that are also part of the tree. This is essentially
         * a shadow tree to simplify logic around how to stagger over children.
         */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
         * Whether this instance is visible. This can be changed imperatively
         * by the projection tree, is analogous to CSS's visibility in that
         * hidden elements should take up layout, and needs enacting by the configured
         * render function.
         */ isVisible: undefined,
            /**
         * Normally, if a component is controlled by a parent's variants, it can
         * rely on that ancestor to trigger animations further down the tree.
         * However, if a component is created after its parent is mounted, the parent
         * won't trigger that mount animation so the child needs to.
         *
         * TODO: This might be better replaced with a method isParentMounted
         */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            blockInitialAnimation: /**
         * This can be set by AnimatePresence to force components that mount
         * at the same time as it to mount as if they have initial={false} set.
         */ blockInitialAnimation,
            /**
         * Determine whether this component has mounted yet. This is mostly used
         * by variant children to determine whether they need to trigger their
         * own animations on mount.
         */ isMounted: ()=>Boolean(instance),
            mount (newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach((value, key)=>bindToMotionValue(key, value));
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
         *
         */ unmount () {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(update);
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).render(render);
                valueSubscriptions.forEach((remove)=>remove());
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
         * Add a child visual element to our set of children.
         */ addVariantChild (child) {
                var _a;
                const closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return ()=>closestVariantNode.variantChildren.delete(child);
                }
            },
            sortNodePosition (other) {
                /**
             * If these nodes aren't even of the same type we can't compare their depth.
             */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
         * Returns the closest variant node in the tree starting from
         * this visual element.
         */ getClosestVariantNode: ()=>isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode(),
            /**
         * Expose the latest layoutId prop.
         */ getLayoutId: ()=>props.layoutId,
            /**
         * Returns the current instance.
         */ getInstance: ()=>instance,
            /**
         * Get/set the latest static values.
         */ getStaticValue: (key)=>latestValues[key],
            setStaticValue: (key, value)=>latestValues[key] = value,
            /**
         * Returns the latest motion value state. Currently only used to take
         * a snapshot of the visual element - perhaps this can return the whole
         * visual state
         */ getLatestValues: ()=>latestValues,
            /**
         * Set the visiblity of the visual element. If it's changed, schedule
         * a render to reflect these changes.
         */ setVisibility (visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
         * Make a target animatable by Popmotion. For instance, if we're
         * trying to animate width from 100px to 100vw we need to measure 100vw
         * in pixels to determine what we really need to animate to. This is also
         * pluggable to support Framer's custom value types like Color,
         * and CSS variables.
         */ makeTargetAnimatable (target, canMutate = true) {
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
         * Measure the current viewport box with or without transforms.
         * Only measures axis-aligned boxes, rotate and skew must be manually
         * removed with a re-render to work.
         */ measureViewportBox () {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
         * Add a motion value and bind it to this visual element.
         */ addValue (key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
         * Remove a motion value and unbind any active subscriptions.
         */ removeValue (key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
         * Check whether we have a motion value for this key
         */ hasValue: (key)=>values.has(key),
            /**
         * Get a motion value for this key. If called with a default
         * value, we'll create one if none exists.
         */ getValue (key, defaultValue) {
                let value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
         * Iterate over our motion values.
         */ forEachValue: (callback)=>values.forEach(callback),
            /**
         * If we're trying to animate to a previously unencountered value,
         * we need to check for it in our state and as a last resort read it
         * directly from the instance (which might have performance implications).
         */ readValue: (key)=>{
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
         * Set the base target to later animate back to. This is currently
         * only hydrated on creation and when we first read a value.
         */ setBaseTarget (key, value) {
                baseTarget[key] = value;
            },
            /**
         * Find the base target for a value thats been removed from all animation
         * props.
         */ getBaseTarget (key) {
                if (getBaseTarget) {
                    const target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $513bb72e2a3b2c38$export$605d60a2578142d3)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
         * Build the renderer state based on the latest visual state.
         */ build () {
                triggerBuild();
                return renderState;
            },
            /**
         * Schedule a render on the next animation frame.
         */ scheduleRender () {
                (0, $741aad569b766a4c$export$2e2bcd8739ae039).render(render, false, true);
            },
            /**
         * Synchronously fire render. It's prefered that we batch renders but
         * in many circumstances, like layout measurement, we need to run this
         * synchronously. However in those instances other measures should be taken
         * to batch reads/writes.
         */ syncRender: render,
            /**
         * Update the provided props. Ensure any newly-added motion values are
         * added to our map, old ones removed, and listeners updated.
         */ setProps (newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $cdc84e4516939e8e$export$9a552858d5197f6e)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: ()=>props,
            // Variants ==============================
            /**
         * Returns the variant definition with a given name.
         */ getVariant: (name)=>{
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
         * Returns the defined default transition on this component.
         */ getDefaultTransition: ()=>props.transition,
            getTransformPagePoint: ()=>{
                return props.transformPagePoint;
            },
            /**
         * Used by child variant nodes to get the closest ancestor variant props.
         */ getVariantContext (startAtParent = false) {
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    const context = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context.initial = props.initial;
                    return context;
                }
                const context = {};
                for(let i = 0; i < $f26b19dcd9ae5e4b$var$numVariantProps; i++){
                    const name = $f26b19dcd9ae5e4b$var$variantProps[i];
                    const prop = props[name];
                    if ((0, $9fc0609ad108c3b4$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
                }
                return context;
            }
        });
        return element;
    };
const $f26b19dcd9ae5e4b$var$variantProps = [
    "initial",
    ...(0, $dffd66329b96c3c5$export$16e45afcc206d3a8)
];
const $f26b19dcd9ae5e4b$var$numVariantProps = $f26b19dcd9ae5e4b$var$variantProps.length;






var $7WQrb = parcelRequire("7WQrb");

function $61b8030c71d803ef$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $61b8030c71d803ef$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $61b8030c71d803ef$export$b9f0c1f373aee2b0(current) {
    const match = $61b8030c71d803ef$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $61b8030c71d803ef$var$maxDepth = 4;
function $61b8030c71d803ef$var$getVariableValue(current, element, depth = 1) {
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(depth <= $61b8030c71d803ef$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $61b8030c71d803ef$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($61b8030c71d803ef$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $61b8030c71d803ef$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $61b8030c71d803ef$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $7WQrb.__rest)(_a, []);
    const element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = Object.assign({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue((value)=>{
        const current = value.get();
        if (!$61b8030c71d803ef$var$isCSSVariable(current)) return;
        const resolved = $61b8030c71d803ef$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!$61b8030c71d803ef$var$isCSSVariable(current)) continue;
        const resolved = $61b8030c71d803ef$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}








const $6ebd47f846b82cbe$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
const $6ebd47f846b82cbe$var$isPositionalKey = (key)=>$6ebd47f846b82cbe$var$positionalKeys.has(key);
const $6ebd47f846b82cbe$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($6ebd47f846b82cbe$var$isPositionalKey);
};
const $6ebd47f846b82cbe$var$setAndResetVelocity = (value, to)=>{
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
const $6ebd47f846b82cbe$var$isNumOrPxType = (v)=>v === (0, $2f64f305c5028a6f$export$98e628dec113755e) || v === (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008);
var $6ebd47f846b82cbe$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($6ebd47f846b82cbe$export$d0c75e4fa9e69db8 || ($6ebd47f846b82cbe$export$d0c75e4fa9e69db8 = {}));
const $6ebd47f846b82cbe$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $6ebd47f846b82cbe$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $6ebd47f846b82cbe$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $6ebd47f846b82cbe$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $6ebd47f846b82cbe$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $6ebd47f846b82cbe$var$nonTranslationalTransformKeys = (0, $73c07a5d0b8699a4$export$7b42a0094fb00b6e).filter((key)=>!$6ebd47f846b82cbe$var$transformKeys.has(key));
function $6ebd47f846b82cbe$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $6ebd47f846b82cbe$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
const $6ebd47f846b82cbe$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $6ebd47f846b82cbe$var$getTranslateFromMatrix(4, 13),
    y: $6ebd47f846b82cbe$var$getTranslateFromMatrix(5, 14)
};
const $6ebd47f846b82cbe$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.getInstance();
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $6ebd47f846b82cbe$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        $6ebd47f846b82cbe$var$setAndResetVelocity(value, origin[key]);
        target[key] = $6ebd47f846b82cbe$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $6ebd47f846b82cbe$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = Object.assign({}, target);
    transitionEnd = Object.assign({}, transitionEnd);
    const targetPositionalKeys = Object.keys(target).filter($6ebd47f846b82cbe$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $c71e259185df4a56$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $cb191701c4d6cd5b$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $c71e259185df4a56$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $c71e259185df4a56$export$eefdd52e3ccae428)(to[i]);
                (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(toType === fromType || $6ebd47f846b82cbe$var$isNumOrPxType(fromType) && $6ebd47f846b82cbe$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)((0, $c71e259185df4a56$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $c71e259185df4a56$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($6ebd47f846b82cbe$var$isNumOrPxType(fromType) && $6ebd47f846b82cbe$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $6ebd47f846b82cbe$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $6ebd47f846b82cbe$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $6ebd47f846b82cbe$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if ((0, $e64230e5b7e1ea23$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $6ebd47f846b82cbe$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $6ebd47f846b82cbe$var$hasPositionalKey(target) ? $6ebd47f846b82cbe$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $f8ebe1d59dfecd09$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $61b8030c71d803ef$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $6ebd47f846b82cbe$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







function $a13456fe223a7ed6$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
const $a13456fe223a7ed6$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance (domElement, key) {
        if ((0, $73c07a5d0b8699a4$export$15240a8a4379d8de)(key)) {
            const defaultType = (0, $f0d8d6602efe4eb4$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $a13456fe223a7ed6$export$3735103072e4a80(domElement);
            const value = ((0, $388a4b9b43db8ef3$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    },
    sortNodePosition (a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget (props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox (element, { transformPagePoint: transformPagePoint }) {
        return (0, $1ba7f60b818ea8ed$export$d8718b6a7e5c624e)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform (element, domElement, props) {
        const { transformTemplate: transformTemplate } = props;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform (instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState (key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable (element, _a, _b, isMounted) {
        var { transition: transition, transitionEnd: transitionEnd } = _a, target = (0, $7WQrb.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        let origin = (0, $5e97cf8de56a4aeb$export$5a759dc7a1cfb72a)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $5e97cf8de56a4aeb$export$6afbed164019a54c)(element, target, origin);
            const parsed = (0, $f8ebe1d59dfecd09$export$5849e743e29831d6)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return Object.assign({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: $22640d6ce721193b$export$16da615486abaa45,
    build (element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $2ab6dcf72886549b$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $6e7fb0ef9d26d575$export$1a32bf6229c258c0)
};
const $a13456fe223a7ed6$export$9509f7c142585e92 = (0, $f26b19dcd9ae5e4b$export$5ad594e944c33d76)($a13456fe223a7ed6$export$985b1494d4aeee90);











const $a6a557c4d716c303$export$3ba8992de7b705bc = (0, $f26b19dcd9ae5e4b$export$5ad594e944c33d76)(Object.assign(Object.assign({}, (0, $a13456fe223a7ed6$export$985b1494d4aeee90)), {
    getBaseTarget (props, key) {
        return props[key];
    },
    readValueFromInstance (domElement, key) {
        var _a;
        if ((0, $73c07a5d0b8699a4$export$15240a8a4379d8de)(key)) return ((_a = (0, $f0d8d6602efe4eb4$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $53cef2cbcabfbf37$export$28931db5d57958e5).has(key) ? (0, $66b01c35fe5a3c5d$export$9fd24a634729c672)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: $53bd1c12a432092a$export$16da615486abaa45,
    build (_element, renderState, latestValues, options, props) {
        (0, $42a1a377eb6df020$export$5475d24f125d7053)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $985f09fa180b53b7$export$c5f8399d19a7394b)
}));



const $21ce6a73189ebfca$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $95c9f97c34d7cb74$export$88f3fc2fd3766989)(Component) ? (0, $a6a557c4d716c303$export$3ba8992de7b705bc)(options, {
        enableHardwareAcceleration: false
    }) : (0, $a13456fe223a7ed6$export$9509f7c142585e92)(options, {
        enableHardwareAcceleration: true
    });
};




var $acw62 = parcelRequire("acw62");





function $02e73067c1e8cf4f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $02e73067c1e8cf4f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $02e73067c1e8cf4f$export$fafff692be55225d(latest, node.target.x);
        const y = $02e73067c1e8cf4f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};





const $ee2bfe5b4b486eaa$var$varToken = "_$css";
const $ee2bfe5b4b486eaa$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $61b8030c71d803ef$export$f7c0a352d8ef6313), (match)=>{
            cssVariables.push(match);
            return $ee2bfe5b4b486eaa$var$varToken;
        });
        const shadow = (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $fbc1f2c1313bab98$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace($ee2bfe5b4b486eaa$var$varToken, ()=>{
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    }
};



class $601c32375b806898$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $dae5832cc9c4c026$export$de9e7791c71225fd)($601c32375b806898$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions(Object.assign(Object.assign({}, projection.options), {
                onExitComplete: ()=>this.safeToRemove()
            }));
        }
        (0, $d2a278e5dfe57496$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(()=>{
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    }
    render() {
        return null;
    }
}
function $601c32375b806898$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $4332d507cd311a00$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $0c97efef6d7e7a91$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($601c32375b806898$var$MeasureLayoutWithContext, Object.assign({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $63ce92882328da72$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
const $601c32375b806898$var$defaultScaleCorrectors = {
    borderRadius: Object.assign(Object.assign({}, (0, $02e73067c1e8cf4f$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $02e73067c1e8cf4f$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $02e73067c1e8cf4f$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $02e73067c1e8cf4f$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $02e73067c1e8cf4f$export$5eafb6257a5844c),
    boxShadow: (0, $ee2bfe5b4b486eaa$export$eb0bc629e74dcf8)
};


const $71977169278a496b$export$518df03f164c507 = {
    measureLayout: (0, $601c32375b806898$export$779f5fb01ad751cd)
};







/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $b9e53472812a2f06$export$e3607ec2d7a891c4(from, to, transition = {}) {
    const value = (0, $513bb72e2a3b2c38$export$605d60a2578142d3)(from) ? from : (0, $a36f38d144f94e7c$export$ce8bdc721e76545f)(from);
    (0, $f7775545d8272411$export$592dbd515a49cf1b)("", value, to, transition);
    return {
        stop: ()=>value.stop(),
        isAnimating: ()=>value.isAnimating()
    };
}





const $b61c2ecdb95d10ca$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $b61c2ecdb95d10ca$var$numBorders = $b61c2ecdb95d10ca$var$borders.length;
const $b61c2ecdb95d10ca$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $b61c2ecdb95d10ca$var$isPx = (value)=>typeof value === "number" || (0, $7053ea50bd4db8b8$export$91c0eda1d06bf008).test(value);
function $b61c2ecdb95d10ca$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $b61c2ecdb95d10ca$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $b61c2ecdb95d10ca$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $b61c2ecdb95d10ca$var$numBorders; i++){
        const borderLabel = `border${$b61c2ecdb95d10ca$var$borders[i]}Radius`;
        let followRadius = $b61c2ecdb95d10ca$var$getRadius(follow, borderLabel);
        let leadRadius = $b61c2ecdb95d10ca$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $b61c2ecdb95d10ca$var$isPx(followRadius) === $b61c2ecdb95d10ca$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $b564c2928ae298dc$export$2c9e8a9632a706b2)($b61c2ecdb95d10ca$var$asNumber(followRadius), $b61c2ecdb95d10ca$var$asNumber(leadRadius), progress), 0);
            if ((0, $7053ea50bd4db8b8$export$626336c2cd4b14de).test(leadRadius) || (0, $7053ea50bd4db8b8$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b61c2ecdb95d10ca$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $b61c2ecdb95d10ca$var$easeCrossfadeIn = $b61c2ecdb95d10ca$var$compress(0, 0.5, (0, $bb4f4fde52c99102$export$c8d67a19199d1a50));
const $b61c2ecdb95d10ca$var$easeCrossfadeOut = $b61c2ecdb95d10ca$var$compress(0.5, 0.95, (0, $bb4f4fde52c99102$export$45db2fc2f15997e7));
function $b61c2ecdb95d10ca$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $7bf74b962aaa51ba$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f5cb10895b74e63d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f5cb10895b74e63d$export$c53fd88f45d77e4b(box, originBox) {
    $f5cb10895b74e63d$export$a0230ae482601ae8(box.x, originBox.x);
    $f5cb10895b74e63d$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $6eb2ad7e0436206d$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $0b4972342458c5b9$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $0b4972342458c5b9$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $6eb2ad7e0436206d$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $7053ea50bd4db8b8$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $6eb2ad7e0436206d$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $6eb2ad7e0436206d$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $6eb2ad7e0436206d$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $6eb2ad7e0436206d$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $6eb2ad7e0436206d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $6eb2ad7e0436206d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $6eb2ad7e0436206d$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $6eb2ad7e0436206d$export$42b76f1d0d16d5b(box.x, transforms, $6eb2ad7e0436206d$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $6eb2ad7e0436206d$export$42b76f1d0d16d5b(box.y, transforms, $6eb2ad7e0436206d$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}




function $695ba11ce39c9c02$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $695ba11ce39c9c02$export$a7ec7642fe550fb6(delta) {
    return $695ba11ce39c9c02$var$isAxisDeltaZero(delta.x) && $695ba11ce39c9c02$var$isAxisDeltaZero(delta.y);
}
function $695ba11ce39c9c02$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}



class $037fee08948b8662$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $3572374855c91d5f$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $3572374855c91d5f$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



const $f8b2c9ca93b9ee8d$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function $f8b2c9ca93b9ee8d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    let transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform === $f8b2c9ca93b9ee8d$export$f6730f82d2dcfda3 ? "none" : transform;
}






const $cdaf7b89ee893bf4$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $235e04da0003ea99$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $3572374855c91d5f$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $3572374855c91d5f$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $cdaf7b89ee893bf4$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $248c3ccd3f87e27c$var$animationTarget = 1000;
function $248c3ccd3f87e27c$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(id, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            this.updateProjection = ()=>{
                this.nodes.forEach($248c3ccd3f87e27c$var$resolveTargetDelta);
                this.nodes.forEach($248c3ccd3f87e27c$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $235e04da0003ea99$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $97a6aa4eb7f40e4e$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(id, node) {
            this.potentialNodes.set(id, node);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let unblockTimeout;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout);
                    unblockTimeout = window.setTimeout(resizeUnblockUpdate, 250);
                    if ((0, $d2a278e5dfe57496$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $d2a278e5dfe57496$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($248c3ccd3f87e27c$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                var _a, _b, _c, _d, _e;
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : $248c3ccd3f87e27c$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $695ba11ce39c9c02$export$8d5cf76bb7daff09)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = Object.assign(Object.assign({}, (0, $f7775545d8272411$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && this.animationProgress === 0) this.finishAnimation();
                    this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 || _e.call(_d));
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $741aad569b766a4c$export$d93e9c1fe0553512).preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($248c3ccd3f87e27c$var$resetRotation);
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($248c3ccd3f87e27c$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($248c3ccd3f87e27c$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($248c3ccd3f87e27c$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($248c3ccd3f87e27c$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($248c3ccd3f87e27c$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).update();
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).preRender();
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).render();
        }
        clearAllSnapshots() {
            this.nodes.forEach($248c3ccd3f87e27c$var$clearSnapshot);
            this.sharedNodes.forEach($248c3ccd3f87e27c$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            const measured = this.measure();
            const layout = this.removeTransform(this.removeElementScroll(measured));
            $248c3ccd3f87e27c$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        }
        updateLayout() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const measured = this.measure();
            $248c3ccd3f87e27c$var$roundBox(measured);
            const prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        }
        updateScroll() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        }
        resetTransform() {
            var _a;
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $695ba11ce39c9c02$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $460146e1da75af03$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(box.x, scroll.x);
                (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(box.y, scroll.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options, isScrollRoot: isScrollRoot } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.x);
                            (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.x);
                    (0, $0b4972342458c5b9$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $0b4972342458c5b9$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!(0, $460146e1da75af03$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $0b4972342458c5b9$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $460146e1da75af03$export$a545127cf1fbb600)(this.latestValues)) (0, $0b4972342458c5b9$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $460146e1da75af03$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $460146e1da75af03$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                const nodeBox = node.measure();
                (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $6eb2ad7e0436206d$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $460146e1da75af03$export$a545127cf1fbb600)(this.latestValues)) (0, $6eb2ad7e0436206d$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        /**
         *
         */ setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            var _a;
            this.options = Object.assign(Object.assign(Object.assign({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */ resolveTargetDelta() {
            var _a;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    (0, $b8541eec9de7918b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $b8541eec9de7918b$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
                (0, $0b4972342458c5b9$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    (0, $b8541eec9de7918b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $460146e1da75af03$export$a545127cf1fbb600)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        calcProjection() {
            var _a;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            const lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $0b4972342458c5b9$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            const { target: target } = lead;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $cd73f61bf295ea66$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $cd73f61bf295ea66$export$3d227df54007d73a)();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b8541eec9de7918b$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $f8b2c9ca93b9ee8d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = Object.assign({}, this.latestValues);
            const targetDelta = (0, $cd73f61bf295ea66$export$3d227df54007d73a)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
            const isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            const isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($248c3ccd3f87e27c$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest)=>{
                var _a;
                const progress = latest / 1000;
                $248c3ccd3f87e27c$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $248c3ccd3f87e27c$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $b8541eec9de7918b$export$2785bfcc929c5650)(relativeLayout, this.layout.actual, this.relativeParent.layout.actual);
                    $248c3ccd3f87e27c$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $b61c2ecdb95d10ca$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(()=>{
                (0, $d2a278e5dfe57496$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $b9e53472812a2f06$export$e3607ec2d7a891c4)(0, $248c3ccd3f87e27c$var$animationTarget, Object.assign(Object.assign({}, options), {
                    onUpdate: (latest)=>{
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: ()=>{
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        this.completeAnimation();
                    }
                }));
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $248c3ccd3f87e27c$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = this.getLead();
            if (!targetWithTransforms || !target || !layout) return;
            (0, $f5cb10895b74e63d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $0b4972342458c5b9$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $b8541eec9de7918b$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $037fee08948b8662$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            // Keep a record of all the values we've reset
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < (0, $73c07a5d0b8699a4$export$67cd428da31419e1).length; i++){
                const axis = (0, $73c07a5d0b8699a4$export$67cd428da31419e1)[i];
                const key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c, _d, _e, _f;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $3849712c835fb3ad$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = (0, $3849712c835fb3ad$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $460146e1da75af03$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $f8b2c9ca93b9ee8d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $dae5832cc9c4c026$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $dae5832cc9c4c026$export$91ddd985b97788d1)[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $3849712c835fb3ad$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($248c3ccd3f87e27c$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $248c3ccd3f87e27c$var$updateLayout(node) {
    node.updateLayout();
}
function $248c3ccd3f87e27c$var$notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    const snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { actual: layout, measured: measuredLayout } = node.layout;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            const length = (0, $b8541eec9de7918b$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $d0f2d46f6c63e689$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            const length = (0, $b8541eec9de7918b$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        const layoutDelta = (0, $cd73f61bf295ea66$export$3d227df54007d73a)();
        (0, $b8541eec9de7918b$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layout);
        const visualDelta = (0, $cd73f61bf295ea66$export$3d227df54007d73a)();
        if (snapshot.isShared) (0, $b8541eec9de7918b$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else (0, $b8541eec9de7918b$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layout);
        const hasLayoutChanged = !(0, $695ba11ce39c9c02$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = node.relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    (0, $b8541eec9de7918b$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    const relativeLayout = (0, $cd73f61bf295ea66$export$6459fc9e86be362e)();
                    (0, $b8541eec9de7918b$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.actual);
                    if (!(0, $695ba11ce39c9c02$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $248c3ccd3f87e27c$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $248c3ccd3f87e27c$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $248c3ccd3f87e27c$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function $248c3ccd3f87e27c$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $248c3ccd3f87e27c$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $248c3ccd3f87e27c$var$calcProjection(node) {
    node.calcProjection();
}
function $248c3ccd3f87e27c$var$resetRotation(node) {
    node.resetRotation();
}
function $248c3ccd3f87e27c$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $248c3ccd3f87e27c$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $248c3ccd3f87e27c$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $b564c2928ae298dc$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $248c3ccd3f87e27c$export$6ffd3e6ae339a132(output, from, to, p) {
    $248c3ccd3f87e27c$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $248c3ccd3f87e27c$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $248c3ccd3f87e27c$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $248c3ccd3f87e27c$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $248c3ccd3f87e27c$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ let searchNode = node.root;
    for(let i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${id}"]`);
    if (element) node.mount(element, true);
}
function $248c3ccd3f87e27c$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $248c3ccd3f87e27c$var$roundBox(box) {
    $248c3ccd3f87e27c$var$roundAxis(box.x);
    $248c3ccd3f87e27c$var$roundAxis(box.y);
}




const $3392c225ca4eafb4$export$2d029a49a09b6177 = (0, $248c3ccd3f87e27c$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $f3a3b2c3f11b0939$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $e77320490d7449f7$export$b91509fcf893b648 = {
    current: undefined
};
const $e77320490d7449f7$export$b61a9eb3dbde8858 = (0, $248c3ccd3f87e27c$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$e77320490d7449f7$export$b91509fcf893b648.current) {
            const documentNode = new (0, $3392c225ca4eafb4$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $e77320490d7449f7$export$b91509fcf893b648.current = documentNode;
        }
        return $e77320490d7449f7$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fd374e7a8b8677d2$var$featureBundle = Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4835319a35a50ba0$export$7f9953c70dacfd7f)), (0, $a2da84fda1ac4c61$export$e5b72898e5a201f1)), (0, $862fa84301dd2a70$export$d7d5d435647ed5a0)), (0, $71977169278a496b$export$518df03f164c507));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $fd374e7a8b8677d2$export$e25e478948902b8b = /*@__PURE__*/ (0, $7aaf31b5eefb469b$export$a28d6df673050e18)((Component, config)=>(0, $fffacd8f6ed67621$export$732916c0e88175fb)(Component, config, $fd374e7a8b8677d2$var$featureBundle, (0, $21ce6a73189ebfca$export$56ba0183203348f5), (0, $e77320490d7449f7$export$b61a9eb3dbde8858)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $fd374e7a8b8677d2$export$546614c4a05701f9(key) {
    return (0, $98f6148882fd07b1$export$46b7e4b9dc6110c3)((0, $fffacd8f6ed67621$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $fd374e7a8b8677d2$var$featureBundle, (0, $21ce6a73189ebfca$export$56ba0183203348f5), (0, $e77320490d7449f7$export$b61a9eb3dbde8858)));
}



const $c4e455fe90d7d7b1$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $fd374e7a8b8677d2$export$e25e478948902b8b).div).attrs(()=>({
        initial: {
            scale: 0
        },
        animate: {
            scale: 1
        },
        exit: {
            scale: 0
        }
    })).withConfig({
    componentId: "sc-btxw81-0"
})([
    "top:",
    "px;right:",
    ";min-width:",
    "px;",
    ""
], ({ topPosition: topPosition })=>topPosition, ({ rightPosition: rightPosition })=>rightPosition, ({ minWidth: minWidth })=>minWidth, {
    "position": "absolute",
    "width": "max-content"
});
const $c4e455fe90d7d7b1$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-btxw81-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderRadius": "0.5rem",
    "overflow": "hidden",
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))"
});





const $35ce4af7e686b2f6$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-186xwbt-0"
})({
    "width": "100%",
    "borderStyle": "none",
    "backgroundColor": "rgba(0, 0, 0, 0)",
    "borderRadius": "0px",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
    }
});
const $35ce4af7e686b2f6$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-186xwbt-1"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "0.5rem",
    "justifyContent": "space-between",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "fontWeight": "500"
});
const $35ce4af7e686b2f6$export$a6c7ac8248d6e38a = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.withConfig({
    componentId: "sc-186xwbt-2"
})({
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))"
    }
});
const $35ce4af7e686b2f6$export$f04a61298a47a40f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-186xwbt-3"
})({
    "width": "1.25rem"
});



const $293cd9286b03c713$export$4f8de5f5e34dc41e = ({ title: title, icon: icon, link: link, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35ce4af7e686b2f6$export$a6c7ac8248d6e38a), {
        href: link,
        rel: "noreferrer",
        target: "_blank",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35ce4af7e686b2f6$export$353f5b6fc5456de1), {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35ce4af7e686b2f6$export$7c6e2c02157bb7d2), {
                children: [
                    title,
                    icon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35ce4af7e686b2f6$export$f04a61298a47a40f), {
                        src: icon
                    }) : null
                ]
            })
        })
    });



const $3d3b62df7122f73a$export$e40cc1c58d22b809 = ({ isShow: isShow, options: options, align: align, parentReference: parentReference, onHide: onHide })=>{
    const clientRect = (0, $7a8f953b3506ddcb$export$b95e3d4f036ffdbe)(parentReference);
    (0, $a771512e471faa36$export$71b2224f1ce5e08e)(parentReference, onHide);
    const { width: width = 0, height: height = 0 } = clientRect ?? {};
    const topPosition = height + 10;
    const rightPosition = align === "right" ? "0" : "initial";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d280cf62a9a45ed1$export$3ae376d12526dd6f), {
        children: isShow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4e455fe90d7d7b1$export$42a852a2b6b56249), {
            minWidth: width,
            rightPosition: rightPosition,
            topPosition: topPosition,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4e455fe90d7d7b1$export$7c6e2c02157bb7d2), {
                children: options.map(({ title: title, icon: icon, link: link, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $293cd9286b03c713$export$4f8de5f5e34dc41e), {
                        icon: icon,
                        link: link,
                        onClick: onClick,
                        title: title
                    }, title))
            })
        }) : null
    });
};



const $548768d9fbef52ca$export$931cbfb6bfb85fc = ({ isShowDropdown: isShowDropdown, hideDropdown: hideDropdown, options: options, align: align = "left", children: children })=>{
    const parentReference = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $561037673a877538$export$42a852a2b6b56249), {
        ref: parentReference,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d3b62df7122f73a$export$e40cc1c58d22b809), {
                align: align,
                isShow: isShowDropdown,
                onHide: hideDropdown,
                options: options,
                parentReference: parentReference
            })
        ]
    });
};


var $56493611e1b94441$exports = {};

$56493611e1b94441$exports = new URL((parcelRequire("27Lyk")).resolve("dCzFL"), import.meta.url).toString();


var $a1406e152dd404e5$exports = {};

$a1406e152dd404e5$exports = new URL((parcelRequire("27Lyk")).resolve("blnWe"), import.meta.url).toString();


var $746d5a8ddd269a1e$exports = {};

$746d5a8ddd269a1e$exports = new URL((parcelRequire("27Lyk")).resolve("24K9g"), import.meta.url).toString();


var $1295a175239102c4$exports = {};

$1295a175239102c4$exports = new URL((parcelRequire("27Lyk")).resolve("7FY4I"), import.meta.url).toString();


var $5fa5f315d52e4c8f$exports = {};

$5fa5f315d52e4c8f$exports = new URL((parcelRequire("27Lyk")).resolve("8Bg1f"), import.meta.url).toString();


var $ec328874715fd635$exports = {};

$ec328874715fd635$exports = new URL((parcelRequire("27Lyk")).resolve("N75Mw"), import.meta.url).toString();


var $b0bf29661793b213$exports = {};

$b0bf29661793b213$exports = new URL((parcelRequire("27Lyk")).resolve("lfCb5"), import.meta.url).toString();






const $d51ad39af9484464$export$85ac33870499f48b = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-1mujel7-0"
})({
    "width": "0.625rem"
});



const $a54fc0dd8862e70c$export$3d6d548c35afaaed = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d51ad39af9484464$export$85ac33870499f48b), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a1406e152dd404e5$exports)))
    });



var $acw62 = parcelRequire("acw62");
const $1ace21c61fa2fbe9$export$8c32fdb3462273b4 = ()=>{
    const [isShowDropdown, setIsShowDropdown] = (0, $acw62.useState)(false);
    const toggleDropdown = (0, $acw62.useCallback)(()=>{
        setIsShowDropdown((previousIsShowDropdown)=>!previousIsShowDropdown);
    }, []);
    const hideDropdown = (0, $acw62.useCallback)(()=>{
        setIsShowDropdown(false);
    }, []);
    return {
        isShowDropdown: isShowDropdown,
        toggleDropdown: toggleDropdown,
        hideDropdown: hideDropdown
    };
};





const $28ec34334958968b$export$181f40ec41159e56 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-1jzsdoo-0"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))",
    "borderStyle": "none",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem"
});



const $b54ec61dc57f6b43$export$ea07814f98c39a77 = ({ tokenData: tokenData, tokens: tokens = [], setTokenDataAddress: setTokenDataAddress = ()=>undefined, setInputValue: setInputValue })=>{
    const { isShowDropdown: isShowDropdown, toggleDropdown: toggleDropdown, hideDropdown: hideDropdown } = (0, $1ace21c61fa2fbe9$export$8c32fdb3462273b4)();
    const filteredTokens = tokens.filter((token)=>token?.address !== tokenData?.address);
    const options = filteredTokens.map((token)=>({
            title: token?.symbol ?? "-",
            onClick: ()=>{
                if (token) {
                    setInputValue("");
                    setTokenDataAddress(token.address);
                }
                hideDropdown();
            }
        }));
    const tokenSymbol = tokenData?.symbol ?? "-";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $548768d9fbef52ca$export$931cbfb6bfb85fc), {
        align: "right",
        hideDropdown: hideDropdown,
        isShowDropdown: isShowDropdown,
        options: options,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28ec34334958968b$export$181f40ec41159e56), {
            onClick: toggleDropdown,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35ce4af7e686b2f6$export$7c6e2c02157bb7d2), {
                children: [
                    tokenSymbol,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a54fc0dd8862e70c$export$3d6d548c35afaaed), {})
                ]
            })
        })
    });
};



const $f4db3017610608f9$export$33565d6eb423d013 = ({ tokenData: tokenData, tokens: tokens, setTokenDataAddress: setTokenDataAddress, inputValue: inputValue, setInputValue: setInputValue, isError: isError, maxLength: maxLength })=>{
    const tokenSymbol = tokenData?.symbol ?? "-";
    const tokenBalance = tokenData?.balance ?? (0, $39a9b22a0e28d503$export$6904811048a20190)();
    const formattedTokenBalance = (0, $5a8458cc154f95c7$export$123447cf2124c743)(tokenData);
    const inputValueBig = (0, $d105c29cf7169379$export$55c2201905ba0b8d)(inputValue ?? "0");
    const isShowTokensDropdown = Array.isArray(tokens) && tokens.length > 1;
    const isShowMaxButton = !tokenBalance.eq(inputValueBig) && tokenBalance.gt((0, $39a9b22a0e28d503$export$6904811048a20190)());
    const handleInputChange = (0, $acw62.useCallback)((event)=>{
        if (maxLength && event.target.value.length > maxLength) // eslint-disable-next-line no-param-reassign
        event.target.value = event.target.value.slice(0, maxLength);
        setInputValue(event.target.value);
    }, [
        setInputValue,
        maxLength
    ]);
    const handleMaxButtonClick = (0, $acw62.useCallback)(()=>{
        if (tokenData?.balance) setInputValue(tokenData.balance.toString());
    }, [
        tokenData,
        setInputValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2e0e17dcfad2d12b$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2e0e17dcfad2d12b$export$b821cb5d358838ed), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0e17dcfad2d12b$export$f5b8910cec6cf069), {
                        isError: isError,
                        onChange: handleInputChange,
                        value: inputValue
                    }),
                    isShowTokensDropdown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b54ec61dc57f6b43$export$ea07814f98c39a77), {
                        setInputValue: setInputValue,
                        setTokenDataAddress: setTokenDataAddress,
                        tokenData: tokenData,
                        tokens: tokens
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0e17dcfad2d12b$export$a7a55dff594ea775), {
                        children: tokenSymbol
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2e0e17dcfad2d12b$export$41164ea466f6b019), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0e17dcfad2d12b$export$deff84e7338ee5a5), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5b3c09e03456c9a0$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0e17dcfad2d12b$export$9ebd661e23544fe6), {
                        children: formattedTokenBalance
                    }),
                    isShowMaxButton ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e0e17dcfad2d12b$export$c04ed6f11664dd90), {
                        onClick: handleMaxButtonClick,
                        children: "Max"
                    }) : null
                ]
            })
        ]
    });
};




const $8646152b9479ddeb$export$725fb9bdf24c7d8c = ()=>{
    const { tokenData: tokenData, tokens: tokens, setTokenDataAddress: setTokenDataAddress, inputValue: inputValue, setInputValue: setInputValue, isError: isError } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4db3017610608f9$export$33565d6eb423d013), {
        inputValue: inputValue,
        isError: isError,
        setInputValue: setInputValue,
        setTokenDataAddress: setTokenDataAddress,
        tokenData: tokenData,
        tokens: tokens
    });
};








const $3b72a2dd3070c74e$export$61e84ce827d2e5bc = (tokenInputValueBig, reserve, pairTokenData)=>{
    if (reserve && pairTokenData) {
        const pairTokenTotalSupply = pairTokenData.totalSupply;
        const lpTokenAmount = tokenInputValueBig.div(reserve).mul(pairTokenTotalSupply);
        return lpTokenAmount.round(10).toString();
    }
    return "-";
};





const $8cf511c773e67386$export$338621bd634bf31b = (tokenInputValueBig, reserve)=>{
    if (reserve) {
        const shareOfPool = tokenInputValueBig.div(tokenInputValueBig.add(reserve)); // <0.01%
        const minValue = (0, $39a9b22a0e28d503$export$fb01dd61d0afd9de)(-4); // 100%
        const maxValue = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(1);
        if (shareOfPool.lt(minValue)) {
            const formattedShareOfPool = (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(minValue.toNumber());
            return `<${formattedShareOfPool}`;
        }
        if (shareOfPool.gt(maxValue)) // return 100%
        return (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(maxValue.toNumber());
        return (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(shareOfPool.toNumber());
    }
    return "-";
};


const $536a83652fb426fa$export$9840a8eefafff653 = (reserve0, reserve1)=>{
    if (reserve0 && reserve1) {
        const token0Price = reserve0.div(reserve1);
        return token0Price.round(6).toString();
    }
    return "-";
};









const $3ebc75e668684833$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $fd374e7a8b8677d2$export$e25e478948902b8b).div).attrs({
    initial: {
        height: 0
    },
    animate: {
        height: "auto"
    },
    exit: {
        height: 0
    },
    transition: {
        ease: "linear",
        duration: 0.15
    }
}).withConfig({
    componentId: "sc-e90gad-0"
})([
    "",
    ""
], {
    "overflow": "hidden"
});



const $f58b7743289ad52d$export$5296ab4f7e1438d2 = ({ isExpanded: isExpanded, children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d280cf62a9a45ed1$export$3ae376d12526dd6f), {
        children: isExpanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ebc75e668684833$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                children: children
            })
        }) : null
    });


const $c2f42623926f285f$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $f58b7743289ad52d$export$5296ab4f7e1438d2)).withConfig({
    componentId: "sc-3b26sl-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(18, 18, 18, var(--tw-bg-opacity))",
    "borderRadius": "1.5rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(28, 32, 43, var(--tw-border-opacity))"
});
const $c2f42623926f285f$export$35e09ba17cc51c69 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-3b26sl-1"
})({
    "display": "flex",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $c2f42623926f285f$export$cbc5e4ce06b8fb22 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-3b26sl-2"
})({
    "display": "flex",
    "justifyContent": "space-between",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "borderTopWidth": "1px",
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(28, 32, 43, var(--tw-border-opacity))"
});
const $c2f42623926f285f$export$369328572c3b6a8c = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-3b26sl-3"
})({
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
});
const $c2f42623926f285f$export$6a43b0f6a1452c8b = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-3b26sl-4"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $c2f42623926f285f$export$3884436537c81b2e = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-3b26sl-5"
})({
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))",
    "fontWeight": "500"
});



const $2b04b0427a7c2565$export$ef4290b6ce2270a = ({ isExpanded: isExpanded, tokenInputValueBig: tokenInputValueBig, reserve: reserve })=>{
    const { token0State: token0State, token1State: token1State, pairData: pairData } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { pairTokenQuery: pairTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const token0Data = token0State.tokenData;
    const token1Data = token1State.tokenData;
    const pairTokenData = pairTokenQuery.data;
    const reserve0 = pairData?.reserves.reserve0;
    const reserve1 = pairData?.reserves.reserve1;
    const token0Price = (0, $536a83652fb426fa$export$9840a8eefafff653)(reserve0, reserve1);
    const token1Price = (0, $536a83652fb426fa$export$9840a8eefafff653)(reserve1, reserve0);
    const formattedShareOfPool = (0, $8cf511c773e67386$export$338621bd634bf31b)(tokenInputValueBig, reserve);
    const formattedLpTokenAmount = (0, $3b72a2dd3070c74e$export$61e84ce827d2e5bc)(tokenInputValueBig, reserve, pairTokenData);
    const token0Symbol = token0Data?.symbol ?? "-";
    const token1Symbol = token1Data?.symbol ?? "-";
    const withdrawTokenSymbol = withdrawTokenState.tokenData?.symbol ?? "-";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2f42623926f285f$export$42a852a2b6b56249), {
        isExpanded: isExpanded,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$35e09ba17cc51c69), {
                children: "Prices and pool share"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2f42623926f285f$export$cbc5e4ce06b8fb22), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2f42623926f285f$export$369328572c3b6a8c), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$6a43b0f6a1452c8b), {
                                children: token0Price
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$3884436537c81b2e), {
                                children: `${token0Symbol} per ${token1Symbol}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2f42623926f285f$export$369328572c3b6a8c), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$6a43b0f6a1452c8b), {
                                children: token1Price
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$3884436537c81b2e), {
                                children: `${token1Symbol} per ${token0Symbol}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2f42623926f285f$export$369328572c3b6a8c), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$6a43b0f6a1452c8b), {
                                children: formattedShareOfPool
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$3884436537c81b2e), {
                                children: "Share of Pool"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2f42623926f285f$export$35e09ba17cc51c69), {
                children: `You will receive ~${formattedLpTokenAmount} ${withdrawTokenSymbol} Tokens`
            })
        ]
    });
};



const $e0841862cb16031e$export$4403757d613d3caf = ()=>{
    const { tokenData: tokenData, inputValueBig: inputValueBig } = (0, $7d64a5251f30eaf8$export$72749f11642fc1c6)();
    const { token0State: token0State, pairData: pairData, isUseZapTransactionForToken: isUseZapTransactionForToken } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const token0Address = token0State.tokenData?.address ?? "";
    const rawTokenDataAddress = tokenData?.address ?? "";
    const chainId = pairData?.chainId;
    const reserve0 = pairData?.reserves.reserve0;
    const reserve1 = pairData?.reserves.reserve1; // because we will supply only single asset
    // and half of it will be used for swap to another asset
    const tokenInputValueBig = inputValueBig.div(2);
    const wrappedNativeCoinAddress = chainId ? (0, $287c4ac331c75a82$export$31b943359438ed84)(chainId) : "";
    const tokenDataAddress = tokenData && (0, $17ea153afdabe1fb$export$81809787e85049ab)(tokenData) ? wrappedNativeCoinAddress : rawTokenDataAddress;
    const reserve = (0, $b24cf0b5fa9d389a$export$9e1af1a79ed2c7c7)(tokenDataAddress, token0Address) ? reserve0 : reserve1;
    const isExpanded = isUseZapTransactionForToken(tokenData) && tokenInputValueBig.gt((0, $39a9b22a0e28d503$export$6904811048a20190)());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b04b0427a7c2565$export$ef4290b6ce2270a), {
        isExpanded: isExpanded,
        reserve: reserve,
        tokenInputValueBig: tokenInputValueBig
    });
};



const $7388118904bb9474$export$69b3c981e9f23d5a = (chainId, linkType, hash)=>{
    const { urls: urls } = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    const { explorer: explorer } = urls;
    return [
        explorer,
        linkType,
        hash
    ].join("/");
};




const $b2036eefaf2ae643$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $f58b7743289ad52d$export$5296ab4f7e1438d2)).withConfig({
    componentId: "sc-uepvp0-0"
})({
    "display": "flex",
    "justifyContent": "center"
});
const $b2036eefaf2ae643$export$a6c7ac8248d6e38a = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.attrs({
    target: "_blank"
}).withConfig({
    componentId: "sc-uepvp0-1"
})([
    "",
    ""
], {
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(59, 153, 252, var(--tw-text-opacity))",
    "fontWeight": "600",
    "textDecoration": "underline",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(52, 105, 250, var(--tw-text-opacity))"
    }
});


var $82caeb4711a08c99$export$8a891f208f17912c;
(function(ExplorerLinkType) {
    ExplorerLinkType["TX"] = "tx";
    ExplorerLinkType["ADDRESS"] = "address";
    ExplorerLinkType["TOKEN"] = "token";
})($82caeb4711a08c99$export$8a891f208f17912c || ($82caeb4711a08c99$export$8a891f208f17912c = {}));



const $e6202f1083a13361$export$db64c372b196a48 = ({ chainId: chainId, transactionHash: transactionHash })=>{
    const link = chainId && transactionHash ? (0, $7388118904bb9474$export$69b3c981e9f23d5a)(chainId, (0, $82caeb4711a08c99$export$8a891f208f17912c).TX, transactionHash) : undefined;
    const isExpanded = Boolean(transactionHash);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2036eefaf2ae643$export$42a852a2b6b56249), {
        isExpanded: isExpanded,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2036eefaf2ae643$export$a6c7ac8248d6e38a), {
            href: link,
            children: "View on explorer"
        })
    });
};





const $db17b0fa7be13da2$export$1be843fd711718f1 = ()=>{
    const { pairData: pairData } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { lendingPoolTransaction: lendingPoolTransaction, zapSupplyTransaction: zapSupplyTransaction } = (0, $f4415cf9cc1bd9fd$export$171bc4433675c7)();
    const transactionHash = lendingPoolTransaction.transactionHash ?? zapSupplyTransaction.transactionHash;
    const chainId = pairData?.chainId;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6202f1083a13361$export$db64c372b196a48), {
        chainId: chainId,
        transactionHash: transactionHash
    });
};



const $491f42be04946776$export$33cd4dd33318ef5c = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00800dcb8b3e1993$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8646152b9479ddeb$export$725fb9bdf24c7d8c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0841862cb16031e$export$4403757d613d3caf), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88022a1b0f98dae$export$c4868e4a24d48fad), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00800dcb8b3e1993$export$9d50784561433df2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26554e8af700e18c$export$a40a94c09692fa82), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db17b0fa7be13da2$export$1be843fd711718f1), {})
                ]
            })
        ]
    });



var $acw62 = parcelRequire("acw62");

const $e719d8725f973a01$export$5166fa32f99d3a79 = {
    [(0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY]: "Supply",
    [(0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).WITHDRAW]: "Withdraw"
};






const $b5db5741282d67ac$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-avvxml-0"
})([
    "",
    " ",
    ""
], {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem",
    "padding": "0px",
    "borderStyle": "none"
}, ({ isActive: isActive })=>isActive && {
        "--tw-text-opacity": "1",
        "color": "rgba(52, 105, 250, var(--tw-text-opacity))"
    });





const $9e5a36330a17e0ec$export$7e36e2f4770bc64d = ({ tabType: tabType })=>{
    const { tabType: currentTabType, setTabType: setTabType, supplyTokenState: supplyTokenState, withdrawTokenState: withdrawTokenState } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    const { setZapType: setZapType } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const isActive = currentTabType === tabType;
    const handleClick = (0, $acw62.useCallback)(()=>{
        setTabType(tabType);
        supplyTokenState.setInputValue("");
        withdrawTokenState.setInputValue("");
        if (tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).WITHDRAW) setZapType(null);
        else setZapType((0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).LP);
    }, [
        setTabType,
        tabType,
        supplyTokenState,
        withdrawTokenState,
        setZapType
    ]);
    const title = (0, $e719d8725f973a01$export$5166fa32f99d3a79)[tabType];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db5741282d67ac$export$353f5b6fc5456de1), {
        isActive: isActive,
        onClick: handleClick,
        children: title
    });
};






const $c145022a0c236365$export$636d63a5e187e1ef = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-ov22go-0"
})({
    "display": "flex",
    "justifyContent": "center"
});
const $c145022a0c236365$export$f21ab0717a89c77f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-ov22go-1"
})({
    "width": "1.5rem"
});







const $fc333a6caaf7c63b$export$a36bb9ae8af26fca = ()=>{
    const { token0State: token0State, token1State: token1State, pairData: pairData } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const token0InputValueBig = token0State.inputValueBig;
    const token1InputValueBig = token1State.inputValueBig;
    const reserve = pairData?.reserves.reserve0;
    const isExpanded = token0InputValueBig.gt((0, $39a9b22a0e28d503$export$6904811048a20190)()) && token1InputValueBig.gt((0, $39a9b22a0e28d503$export$6904811048a20190)());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b04b0427a7c2565$export$ef4290b6ce2270a), {
        isExpanded: isExpanded,
        reserve: reserve,
        tokenInputValueBig: token0InputValueBig
    });
};













var $acw62 = parcelRequire("acw62");

const $05b2dec8872e54f2$export$209d265e002fccbb = ()=>(0, $acw62.useContext)((0, $383ca4a08629964c$export$1a6e03a6b5eaa999));







var $acw62 = parcelRequire("acw62");






const $c632ff3e77bb670c$export$f1856bd7347ff27e = ()=>{
    const { pairData: pairData, token0State: token0State, token1State: token1State, addresses: addresses } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { pairQuery: pairQuery, nativeCoinQuery: nativeCoinQuery, token0Query: token0Query, token1Query: token1Query } = (0, $d97b5396a5102c45$export$6668418480f8c243)();
    const { aTokenQuery: aTokenQuery } = (0, $206208849bf34a5a$export$f2d0aad7869dde5f)();
    const { supplyTransaction: supplyTransaction } = (0, $05b2dec8872e54f2$export$209d265e002fccbb)();
    const { mutation: mutation, resetTransaction: resetTransaction, runTransaction: runTransaction } = supplyTransaction;
    const dependantQueries = [
        pairQuery,
        nativeCoinQuery,
        token0Query,
        token1Query,
        aTokenQuery
    ];
    const { tokenData: token0Data, inputValueBig: token0InputValueBig } = token0State;
    const { tokenData: token1Data, inputValueBig: token1InputValueBig } = token1State;
    const handleButtonClick = (0, $acw62.useCallback)(()=>{
        if (pairData && token0Data && token1Data) {
            const { lendingPoolAddress: lendingPoolAddress } = pairData;
            const { routerAddress: routerAddress } = addresses;
            const { token0Address: token0Address, token0Amount: token0Amount, token1Address: token1Address, token1Amount: token1Amount } = (0, $959db82b481462db$export$a7e7d68c3797f440)(token0Data, token0InputValueBig, token1Data, token1InputValueBig);
            runTransaction(lendingPoolAddress, routerAddress, token0Address, token0Amount, token1Address, token1Amount);
        }
    }, [
        pairData,
        addresses,
        token0Data,
        token1Data,
        token0InputValueBig,
        token1InputValueBig,
        runTransaction
    ]);
    const { isError: isError, isLoading: isLoading } = mutation;
    const isZeroBalance = token0InputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)()) || token1InputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)());
    const isButtonDisabled = isZeroBalance || dependantQueries.some((query)=>query.isLoading);
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96da19a48dc13d93$export$90584b9d5e24e0e4), {
        mutation: mutation,
        resetTransaction: resetTransaction
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d1837a35d0f03a5$export$4b7aa3c9ee65a20b), {
        color: (0, $7a1b98988c432200$export$11e69cb9544e2d71).BRAND,
        disabled: isButtonDisabled,
        isLoading: isLoading,
        onClick: handleButtonClick,
        children: isLoading ? "Supplying..." : "Supply"
    });
};



const $4984aa9459034465$export$4df3e185edfc4f00 = ()=>{
    const { isConnected: isConnected, chainId: chainId } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { pairData: pairData, token0State: token0State, token1State: token1State, addresses: addresses } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { supplyTransaction: supplyTransaction, token0ApproveTransaction: token0ApproveTransaction, token1ApproveTransaction: token1ApproveTransaction } = (0, $05b2dec8872e54f2$export$209d265e002fccbb)();
    const { zapBoxAddress: zapBoxAddress } = addresses;
    const token0Data = token0State.tokenData;
    const token1Data = token1State.tokenData;
    const token0InputValueBig = token0State.inputValueBig;
    const token1InputValueBig = token1State.inputValueBig;
    const isToken0Error = token0State.isError;
    const isToken1Error = token1State.isError;
    const token0Error = token0State.error;
    const token1Error = token1State.error;
    const isInsufficientToken0Allowance = (0, $feb73828867e3133$export$b31436da9c02311c)(token0InputValueBig, token0Data);
    const isInsufficientToken1Allowance = (0, $feb73828867e3133$export$b31436da9c02311c)(token1InputValueBig, token1Data);
    const { mutation: { isSuccess: isSuccess } } = supplyTransaction;
    const isZeroBalance = token0InputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)()) || token1InputValueBig.lte((0, $39a9b22a0e28d503$export$6904811048a20190)());
    if (!isConnected) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54ed3f43a20cf460$export$2c5011646c0b20c3), {});
    if (pairData && chainId && pairData.chainId !== chainId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3af1e2106769a6d0$export$e961fcd722c3cf24), {});
    if (isSuccess) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55ba62859e938d36$export$f56a791e7be511c0), {
        title: "Supply Successful"
    });
    if (isZeroBalance) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13b46140d36dc22c$export$2673c1d31784339c), {});
    if (isToken0Error || isToken1Error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab8ea50554bbd0f$export$816620cd7b25dd31), {
        error: isToken0Error ? token0Error : token1Error,
        tokenData: isToken0Error ? token0Data : token1Data
    });
    if (isInsufficientToken0Allowance) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc28b727e7e4d99b$export$98237485cba9eb33), {
        spenderAddress: zapBoxAddress,
        tokenApproveTransaction: token0ApproveTransaction,
        tokenData: token0Data
    });
    if (isInsufficientToken1Allowance) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc28b727e7e4d99b$export$98237485cba9eb33), {
        spenderAddress: zapBoxAddress,
        tokenApproveTransaction: token1ApproveTransaction,
        tokenData: token1Data
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c632ff3e77bb670c$export$f1856bd7347ff27e), {});
};





const $179c458391bec2a1$export$c58e13ece39f0616 = ({ tokenIndex: tokenIndex })=>{
    const { token0State: token0State, token1State: token1State } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const tokenState = tokenIndex === 0 ? token0State : token1State;
    const { tokenData: tokenData, tokens: tokens, setTokenDataAddress: setTokenDataAddress, inputValue: inputValue, setInputValue: setInputValue, isError: isError } = tokenState;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4db3017610608f9$export$33565d6eb423d013), {
        inputValue: inputValue,
        isError: isError,
        setInputValue: setInputValue,
        setTokenDataAddress: setTokenDataAddress,
        tokenData: tokenData,
        tokens: tokens
    });
};






const $dafee5f45a92a18d$export$fe55dfe262ce3e59 = ()=>{
    const { pairData: pairData } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { supplyTransaction: supplyTransaction } = (0, $05b2dec8872e54f2$export$209d265e002fccbb)();
    const { transactionHash: transactionHash } = supplyTransaction;
    const chainId = pairData?.chainId;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6202f1083a13361$export$db64c372b196a48), {
        chainId: chainId,
        transactionHash: transactionHash
    });
};



const $7eda472d86acd96e$export$5343528509cd58ec = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00800dcb8b3e1993$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $179c458391bec2a1$export$c58e13ece39f0616), {
                tokenIndex: 0
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c145022a0c236365$export$636d63a5e187e1ef), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c145022a0c236365$export$f21ab0717a89c77f), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1295a175239102c4$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $179c458391bec2a1$export$c58e13ece39f0616), {
                tokenIndex: 1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc333a6caaf7c63b$export$a36bb9ae8af26fca), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88022a1b0f98dae$export$c4868e4a24d48fad), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00800dcb8b3e1993$export$9d50784561433df2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4984aa9459034465$export$4df3e185edfc4f00), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dafee5f45a92a18d$export$fe55dfe262ce3e59), {})
                ]
            })
        ]
    });



const $a3c4fd83e0dc0c49$export$6da19a24bf249f17 = ()=>{
    const { zapType: zapType } = (0, $d4ad2dd0d925e59b$export$1d35d7d022aec9ff)();
    const { tabType: tabType } = (0, $504feaabca9af2b3$export$935680025b36a932)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $86e000b9636ca3a5$export$c9554889b3e706cd), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $86e000b9636ca3a5$export$2206531ad8592d57), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e5a36330a17e0ec$export$7e36e2f4770bc64d), {
                        tabType: (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e5a36330a17e0ec$export$7e36e2f4770bc64d), {
                        tabType: (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).WITHDRAW
                    })
                ]
            }),
            tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86e000b9636ca3a5$export$1ff3c3f08ae963c0), {}) : null,
            tabType === (0, $af6c5c79ba537edd$export$ea1f8d830f8d55e1).SUPPLY ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dfbd2048cb370061$export$876618af2247305), {}) : null,
            zapType === (0, $6ad7a47cbfab54e4$export$7e9636d791c4004f).DUAL ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7eda472d86acd96e$export$5343528509cd58ec), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $491f42be04946776$export$33cd4dd33318ef5c), {})
        ]
    });
};



const $12f5a28efb4d20e8$export$be06ac219186be3b = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d3566cb9f3688d1$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c4fd83e0dc0c49$export$6da19a24bf249f17), {})
    });



const $d8b58bc67bac65d1$export$78551cd89116a48e = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1247ff9e013f953d$export$ebec4f2159e8e6c7), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $383ca4a08629964c$export$cd7e2fb6768d802a), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd6b55b0c280c77f$export$8467072453451889), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1960857fdaf79085$export$fd535cf936991f6a), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12f5a28efb4d20e8$export$be06ac219186be3b), {})
                })
            })
        })
    });



const $f0351b78a9dc1abf$export$bfff7b2971fe89b6 = "disclaimer";


const $7623922504668c72$export$1a19d1c70c588858 = "pair";


const $25e4dd67dd85c75d$export$31c5a5680ff37c63 = {
    connectWallet: (0, $2fdb081c89f7eb15$export$d2f6f354293ef9f),
    pair: (0, $7623922504668c72$export$1a19d1c70c588858),
    disclaimer: (0, $f0351b78a9dc1abf$export$bfff7b2971fe89b6)
};


const $b8fa529dfebe451a$export$8b06a8008f908d68 = {
    [(0, $25e4dd67dd85c75d$export$31c5a5680ff37c63).connectWallet]: (0, $52a10aa693e23096$export$e25981b208cc50fb),
    [(0, $25e4dd67dd85c75d$export$31c5a5680ff37c63).pair]: (0, $d8b58bc67bac65d1$export$78551cd89116a48e),
    [(0, $25e4dd67dd85c75d$export$31c5a5680ff37c63).disclaimer]: (0, $61993cced2f2a7e1$export$325b16bac8018e2e)
};




var $acw62 = parcelRequire("acw62");
var $339251108ccfe2f3$exports = {};

$parcel$export($339251108ccfe2f3$exports, "useKey", () => $339251108ccfe2f3$export$a41bc8a5485cb6b);

var $acw62 = parcelRequire("acw62");
var $1079bdc073fa3265$export$8f5885e0a893ee67 = function(error, identifier) {
    if (error.key === identifier || error.code === identifier || error.keyCode === identifier || error.which === identifier || error.charCode === identifier) return true;
    return false;
};



var $339251108ccfe2f3$var$__assign = undefined && undefined.__assign || function() {
    $339251108ccfe2f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $339251108ccfe2f3$var$__assign.apply(this, arguments);
};
var $339251108ccfe2f3$var$defaultOptions = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
/**
 * useKey hook
 *
 * Fires a callback on keyboard events like keyDown, keyPress and keyUp
 *
 * @param {TrackedKeyEvents} keys List of keys to listen for. Eg: ["a", "b"]
 * @param {Callback} callback  Callback to fire on keyboard events
 * @param {Options} options Options
 * @see https://react-hooks.org/docs/useKey
 */ function $339251108ccfe2f3$export$a41bc8a5485cb6b(keys, callback, options) {
    var keyList = (0, $acw62.useMemo)(function() {
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    var internalOptions = (0, $acw62.useMemo)(function() {
        return $339251108ccfe2f3$var$__assign($339251108ccfe2f3$var$__assign({}, $339251108ccfe2f3$var$defaultOptions), options);
    }, [
        options
    ]);
    var when = internalOptions.when, eventTypes = internalOptions.eventTypes;
    var callbackRef = (0, $acw62.useRef)(callback);
    var target = internalOptions.target;
    (0, $acw62.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $acw62.useCallback)(function(event) {
        if (keyList.some(function(identifier) {
            return (0, $1079bdc073fa3265$export$8f5885e0a893ee67)(event, identifier);
        })) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $acw62.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            // If target is defined by the user
            if (target) {
                var targetNode_1 = target.current;
                if (targetNode_1) {
                    for(var _i = 0, eventTypes_1 = eventTypes; _i < eventTypes_1.length; _i++){
                        var eventType = eventTypes_1[_i];
                        targetNode_1.addEventListener(eventType, handle);
                    }
                    return function() {
                        for(var _i = 0, eventTypes_3 = eventTypes; _i < eventTypes_3.length; _i++){
                            var eventType = eventTypes_3[_i];
                            targetNode_1.removeEventListener(eventType, handle);
                        }
                    };
                }
            } else {
                for(var _a = 0, eventTypes_2 = eventTypes; _a < eventTypes_2.length; _a++){
                    var eventType = eventTypes_2[_a];
                    window.addEventListener(eventType, handle);
                }
                return function() {
                    for(var _i = 0, eventTypes_4 = eventTypes; _i < eventTypes_4.length; _i++){
                        var eventType = eventTypes_4[_i];
                        window.removeEventListener(eventType, handle);
                    }
                };
            }
        }
        return 0, $a144daa6ab437da7$export$8793edee2d425525;
    }, [
        when,
        eventTypes,
        keyList,
        target,
        callback,
        handle
    ]);
}


var $acw62 = parcelRequire("acw62");

/**
 * useOutsideClickRef hook
 * Checks if a click happened outside a Ref. Handy for dropdowns, modals and popups etc.
 *
 * @param handler Callback to fire on outside click
 * @param when A boolean which which activates the hook only when it is true. Useful for conditionally enable the outside click
 * @returns An array with first item being ref
 * @see https://react-hooks.org/docs/useOutsideClick
 */ function $a2b8a451f211dc52$export$c5f9bba475faecdf(handler, when) {
    if (when === void 0) when = true;
    var savedHandler = (0, $acw62.useRef)(handler);
    var _a = (0, $acw62.useState)(null), node = _a[0], setNode = _a[1];
    var memoizedCallback = (0, $acw62.useCallback)(function(event) {
        if (node && !node.contains(event.target)) savedHandler.current(event);
    }, [
        node
    ]);
    (0, $acw62.useEffect)(function() {
        savedHandler.current = handler;
    });
    var ref = (0, $acw62.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    (0, $acw62.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("ontouchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("ontouchstart", memoizedCallback, true);
            };
        }
        return 0, $a144daa6ab437da7$export$8793edee2d425525;
    }, [
        when,
        memoizedCallback
    ]);
    return [
        ref
    ];
}




const $65be0a33848b39da$var$EmptyComponent = ()=>null;
const $65be0a33848b39da$export$816c3f597e00a36d = (modalType, modalComponents)=>modalType && modalType in modalComponents ? modalComponents[modalType] : $65be0a33848b39da$var$EmptyComponent;





const $f8ca8917bb5aa28e$export$698223c589197ab7 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $fd374e7a8b8677d2$export$e25e478948902b8b).div).attrs({
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
}).withConfig({
    componentId: "sc-13arywh-0"
})([
    "",
    ""
], {
    "position": "fixed",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "100vw",
    "height": "100vh",
    "zIndex": "10",
    "backgroundColor": "rgba(0, 0, 0, 0.6)"
});
const $f8ca8917bb5aa28e$export$c9554889b3e706cd = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $fd374e7a8b8677d2$export$e25e478948902b8b).div).attrs({
    initial: {
        scale: 0
    },
    animate: {
        scale: 1
    },
    exit: {
        scale: 0
    }
}).withConfig({
    componentId: "sc-13arywh-1"
})([
    "",
    ""
], {
    "display": "flex",
    "maxWidth": "95vw",
    "maxHeight": "95vh"
});



const $80c852c41db7a96e$export$2b77a92f1a5ad772 = ()=>{
    const { modalType: modalType, hideModal: hideModal, modalComponents: modalComponents, pushModal: pushModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    const ModalComponent = (0, $65be0a33848b39da$export$816c3f597e00a36d)(modalType, modalComponents);
    const hideModalOverrided = ()=>{
        if ((0, $420decebc72e5343$export$e77e7f4d34d3c08d)()) hideModal();
    };
    (0, $339251108ccfe2f3$exports.useKey)("Escape", hideModalOverrided);
    const [modalContainerReference] = (0, $a2b8a451f211dc52$export$c5f9bba475faecdf)(hideModalOverrided);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $420decebc72e5343$export$e77e7f4d34d3c08d)()) pushModal((0, $f0351b78a9dc1abf$export$bfff7b2971fe89b6));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d280cf62a9a45ed1$export$3ae376d12526dd6f), {
        children: modalType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8ca8917bb5aa28e$export$698223c589197ab7), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8ca8917bb5aa28e$export$c9554889b3e706cd), {
                ref: modalContainerReference,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ModalComponent, {})
            })
        }) : null
    });
};



var $acw62 = parcelRequire("acw62");


const $08821d93f5fb6adf$export$600932898aefe927 = ()=>{
    const { lastWalletType: lastWalletType } = (0, $3dd491d04fdd240e$export$1659f95f98d29f1)();
    (0, $acw62.useEffect)(()=>{
        if (lastWalletType) {
            const [lastWallet] = (0, $5eec0ea54595fadd$export$b21745c80acb63b0)[lastWalletType];
            lastWallet.connectEagerly();
        } // because we don't need to reconnect each time we change lastWalletType
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};




var $77bcbd561abcee21$exports = {};

$77bcbd561abcee21$exports = new URL((parcelRequire("27Lyk")).resolve("8hqox"), import.meta.url).toString();


var $0d68a50a6260c3b7$exports = {};

$0d68a50a6260c3b7$exports = new URL((parcelRequire("27Lyk")).resolve("9kDIw"), import.meta.url).toString();


var $59c622b01664e5c3$exports = {};

$59c622b01664e5c3$exports = new URL((parcelRequire("27Lyk")).resolve("5zlcU"), import.meta.url).toString();


var $48043a70b3ee5711$exports = {};

$48043a70b3ee5711$exports = new URL((parcelRequire("27Lyk")).resolve("7M4qD"), import.meta.url).toString();


var $50e455b3bc9ee56d$exports = {};

$50e455b3bc9ee56d$exports = new URL((parcelRequire("27Lyk")).resolve("k1oNi"), import.meta.url).toString();


var $c4ef816cfbeb99b5$exports = {};

$c4ef816cfbeb99b5$exports = new URL((parcelRequire("27Lyk")).resolve("JScY3"), import.meta.url).toString();


var $f7c030b8ecb7979d$exports = {};

$f7c030b8ecb7979d$exports = new URL((parcelRequire("27Lyk")).resolve("25Dlt"), import.meta.url).toString();


var $827727cb792ebb7b$exports = {};

$827727cb792ebb7b$exports = new URL((parcelRequire("27Lyk")).resolve("arehy"), import.meta.url).toString();


var $8b08179d00779698$exports = {};

$8b08179d00779698$exports = new URL((parcelRequire("27Lyk")).resolve("bSruq"), import.meta.url).toString();







const $8a131a2dee41207d$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-4pwk2r-0"
})({
    "fontSize": "1.25rem",
    "lineHeight": "0",
    "fontWeight": "600"
});



const $8511ba07e08219ea$var$options = [
    {
        title: "Twitter",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).twitter,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f7c030b8ecb7979d$exports)))
    },
    {
        title: "Discord",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).discord,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0d68a50a6260c3b7$exports)))
    },
    {
        title: "Medium",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).medium,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($48043a70b3ee5711$exports)))
    },
    {
        title: "Docs",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).gitBook,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($77bcbd561abcee21$exports)))
    },
    {
        title: "Privacy Policies",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).privacyPolicy,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($50e455b3bc9ee56d$exports)))
    },
    {
        title: "Legal & Terms",
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).termsAndConditions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c4ef816cfbeb99b5$exports)))
    }
];
const $8511ba07e08219ea$export$266a769812832828 = ()=>{
    const { isShowDropdown: isShowDropdown, toggleDropdown: toggleDropdown, hideDropdown: hideDropdown } = (0, $1ace21c61fa2fbe9$export$8c32fdb3462273b4)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $548768d9fbef52ca$export$931cbfb6bfb85fc), {
        align: "right",
        hideDropdown: hideDropdown,
        isShowDropdown: isShowDropdown,
        options: $8511ba07e08219ea$var$options,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a131a2dee41207d$export$353f5b6fc5456de1), {
            onClick: toggleDropdown,
            children: "⋯"
        })
    });
};


var $caad0df21bcf81f4$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $caad0df21bcf81f4$exports = factory();
})($caad0df21bcf81f4$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ exports: {},
                /******/ id: moduleId,
                /******/ loaded: false
            };
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            const pnglib = __webpack_require__(1);
            const hsl2rgb = __webpack_require__(2);
            // The random number is a js implementation of the Xorshift PRNG
            const randseed = new Array(4); // Xorshift: [x, y, z, w] 32 bit values
            function seedrand(seed) {
                for(let i = 0; i < randseed.length; i++)randseed[i] = 0;
                for(let i = 0; i < seed.length; i++)randseed[i % 4] = (randseed[i % 4] << 5) - randseed[i % 4] + seed.charCodeAt(i);
            }
            function rand() {
                // based on Java's String.hashCode(), expanded to 4 32bit values
                const t = randseed[0] ^ randseed[0] << 11;
                randseed[0] = randseed[1];
                randseed[1] = randseed[2];
                randseed[2] = randseed[3];
                randseed[3] = randseed[3] ^ randseed[3] >> 19 ^ t ^ t >> 8;
                return (randseed[3] >>> 0) / 2147483648;
            }
            function createColor() {
                //saturation is the whole color spectrum
                const h = Math.floor(rand() * 360);
                //saturation goes from 40 to 100, it avoids greyish colors
                const s = rand() * 60 + 40;
                //lightness can be anything from 0 to 100, but probabilities are a bell curve around 50%
                const l = (rand() + rand() + rand() + rand()) * 25;
                return [
                    h / 360,
                    s / 100,
                    l / 100
                ];
            }
            function createImageData(size) {
                const width = size; // Only support square icons for now
                const height = size;
                const dataWidth = Math.ceil(width / 2);
                const mirrorWidth = width - dataWidth;
                const data = [];
                for(let y = 0; y < height; y++){
                    let row = [];
                    for(let x = 0; x < dataWidth; x++)// this makes foreground and background color to have a 43% (1/2.3) probability
                    // spot color has 13% chance
                    row[x] = Math.floor(rand() * 2.3);
                    const r = row.slice(0, mirrorWidth).reverse();
                    row = row.concat(r);
                    for(let i = 0; i < row.length; i++)data.push(row[i]);
                }
                return data;
            }
            // Modifies the passed PNG to fill in a specified rectangle
            function fillRect(png, x, y, w, h, color) {
                for(let i = 0; i < w; i++)for(let j = 0; j < h; j++)png.buffer[png.index(x + i, y + j)] = color;
            }
            function buildOpts(opts) {
                if (!opts.seed) throw new Error("No seed provided");
                seedrand(opts.seed);
                return Object.assign({
                    size: 8,
                    scale: 16,
                    color: createColor(),
                    bgcolor: createColor(),
                    spotcolor: createColor()
                }, opts);
            }
            function makeBlockie(address) {
                const opts = buildOpts({
                    seed: address.toLowerCase()
                });
                const imageData = createImageData(opts.size);
                const width = Math.sqrt(imageData.length);
                const p = new pnglib(opts.size * opts.scale, opts.size * opts.scale, 3);
                const bgcolor = p.color(...hsl2rgb(...opts.bgcolor));
                const color = p.color(...hsl2rgb(...opts.color));
                const spotcolor = p.color(...hsl2rgb(...opts.spotcolor));
                for(let i = 0; i < imageData.length; i++){
                    const row = Math.floor(i / width);
                    const col = i % width;
                    // if data is 0, leave the background
                    if (imageData[i]) {
                        // if data is 2, choose spot color, if 1 choose foreground
                        const pngColor = imageData[i] == 1 ? color : spotcolor;
                        fillRect(p, col * opts.scale, row * opts.scale, opts.scale, opts.scale, pngColor);
                    }
                }
                return `data:image/png;base64,${p.getBase64()}`;
            }
            module1.exports = makeBlockie;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
	 * A handy class to calculate color values.
	 *
	 * @version 1.0
	 * @author Robert Eisele <robert@xarg.org>
	 * @copyright Copyright (c) 2010, Robert Eisele
	 * @link http://www.xarg.org/2010/03/generate-client-side-png-files-using-javascript/
	 * @license http://www.opensource.org/licenses/bsd-license.php BSD License
	 *
	 */ // Modified by George Chan <gchan@21cn.com>
            // Further modified by Will O'B <@wbobeirne> to make it
            // UglifyJS and "use strict"; friendly
            module1.exports = function(width, height, depth) {
                // helper functions for that ctx
                function write(buffer, offs) {
                    for(var i = 2; i < arguments.length; i++)for(var j = 0; j < arguments[i].length; j++)buffer[offs++] = arguments[i].charAt(j);
                }
                function byte2(w) {
                    return String.fromCharCode(w >> 8 & 255, w & 255);
                }
                function byte4(w) {
                    return String.fromCharCode(w >> 24 & 255, w >> 16 & 255, w >> 8 & 255, w & 255);
                }
                function byte2lsb(w) {
                    return String.fromCharCode(w & 255, w >> 8 & 255);
                }
                this.width = width;
                this.height = height;
                this.depth = depth;
                // pixel data and row filter identifier size
                this.pix_size = height * (width + 1);
                // deflate header, pix_size, block headers, adler32 checksum
                this.data_size = 2 + this.pix_size + 5 * Math.floor((0xfffe + this.pix_size) / 0xffff) + 4;
                // offsets and sizes of Png chunks
                this.ihdr_offs = 0; // IHDR offset and size
                this.ihdr_size = 25;
                this.plte_offs = this.ihdr_offs + this.ihdr_size; // PLTE offset and size
                this.plte_size = 8 + 3 * depth + 4;
                this.trns_offs = this.plte_offs + this.plte_size; // tRNS offset and size
                this.trns_size = 8 + depth + 4;
                this.idat_offs = this.trns_offs + this.trns_size; // IDAT offset and size
                this.idat_size = 8 + this.data_size + 4;
                this.iend_offs = this.idat_offs + this.idat_size; // IEND offset and size
                this.iend_size = 12;
                this.buffer_size = this.iend_offs + this.iend_size; // total PNG size
                this.buffer = new Array();
                this.palette = new Object();
                this.pindex = 0;
                var _crc32 = new Array();
                // initialize buffer with zero bytes
                for(var i = 0; i < this.buffer_size; i++)this.buffer[i] = "\x00";
                // initialize non-zero elements
                write(this.buffer, this.ihdr_offs, byte4(this.ihdr_size - 12), "IHDR", byte4(width), byte4(height), "\b\x03");
                write(this.buffer, this.plte_offs, byte4(this.plte_size - 12), "PLTE");
                write(this.buffer, this.trns_offs, byte4(this.trns_size - 12), "tRNS");
                write(this.buffer, this.idat_offs, byte4(this.idat_size - 12), "IDAT");
                write(this.buffer, this.iend_offs, byte4(this.iend_size - 12), "IEND");
                // initialize deflate header
                var header = 30912;
                header += 31 - header % 31;
                write(this.buffer, this.idat_offs + 8, byte2(header));
                // initialize deflate block headers
                for(var i = 0; (i << 16) - 1 < this.pix_size; i++){
                    var size, bits;
                    if (i + 0xffff < this.pix_size) {
                        size = 0xffff;
                        bits = "\x00";
                    } else {
                        size = this.pix_size - (i << 16) - i;
                        bits = "\x01";
                    }
                    write(this.buffer, this.idat_offs + 8 + 2 + (i << 16) + (i << 2), bits, byte2lsb(size), byte2lsb(~size));
                }
                /* Create crc32 lookup table */ for(var i = 0; i < 256; i++){
                    var c = i;
                    for(var j = 0; j < 8; j++)if (c & 1) c = -306674912 ^ c >> 1 & 0x7fffffff;
                    else c = c >> 1 & 0x7fffffff;
                    _crc32[i] = c;
                }
                // compute the index into a png for a given pixel
                this.index = function(x, y) {
                    var i = y * (this.width + 1) + x + 1;
                    var j = this.idat_offs + 8 + 2 + 5 * Math.floor(i / 0xffff + 1) + i;
                    return j;
                };
                // convert a color and build up the palette
                this.color = function(red, green, blue, alpha) {
                    alpha = alpha >= 0 ? alpha : 255;
                    var color = ((alpha << 8 | red) << 8 | green) << 8 | blue;
                    if (typeof this.palette[color] == "undefined") {
                        if (this.pindex == this.depth) return "\x00";
                        var ndx = this.plte_offs + 8 + 3 * this.pindex;
                        this.buffer[ndx + 0] = String.fromCharCode(red);
                        this.buffer[ndx + 1] = String.fromCharCode(green);
                        this.buffer[ndx + 2] = String.fromCharCode(blue);
                        this.buffer[this.trns_offs + 8 + this.pindex] = String.fromCharCode(alpha);
                        this.palette[color] = String.fromCharCode(this.pindex++);
                    }
                    return this.palette[color];
                };
                // output a PNG string, Base64 encoded
                this.getBase64 = function() {
                    var s = this.getDump();
                    var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var c1, c2, c3, e1, e2, e3, e4;
                    var l = s.length;
                    var i = 0;
                    var r = "";
                    do {
                        c1 = s.charCodeAt(i);
                        e1 = c1 >> 2;
                        c2 = s.charCodeAt(i + 1);
                        e2 = (c1 & 3) << 4 | c2 >> 4;
                        c3 = s.charCodeAt(i + 2);
                        if (l < i + 2) e3 = 64;
                        else e3 = (c2 & 0xf) << 2 | c3 >> 6;
                        if (l < i + 3) e4 = 64;
                        else e4 = c3 & 0x3f;
                        r += ch.charAt(e1) + ch.charAt(e2) + ch.charAt(e3) + ch.charAt(e4);
                    }while ((i += 3) < l);
                    return r;
                };
                // output a PNG string
                this.getDump = function() {
                    // compute adler32 of output pixels + row filter bytes
                    var BASE = 65521; /* largest prime smaller than 65536 */ 
                    var NMAX = 5552; /* NMAX is the largest n such that 255n(n+1)/2 + (n+1)(BASE-1) <= 2^32-1 */ 
                    var s1 = 1;
                    var s2 = 0;
                    var n = NMAX;
                    for(var y = 0; y < this.height; y++)for(var x = -1; x < this.width; x++){
                        s1 += this.buffer[this.index(x, y)].charCodeAt(0);
                        s2 += s1;
                        if ((n -= 1) == 0) {
                            s1 %= BASE;
                            s2 %= BASE;
                            n = NMAX;
                        }
                    }
                    s1 %= BASE;
                    s2 %= BASE;
                    write(this.buffer, this.idat_offs + this.idat_size - 8, byte4(s2 << 16 | s1));
                    // compute crc32 of the PNG chunks
                    function crc32(png, offs, size) {
                        var crc = -1;
                        for(var i = 4; i < size - 4; i += 1)crc = _crc32[(crc ^ png[offs + i].charCodeAt(0)) & 0xff] ^ crc >> 8 & 0x00ffffff;
                        write(png, offs + size - 4, byte4(crc ^ -1));
                    }
                    crc32(this.buffer, this.ihdr_offs, this.ihdr_size);
                    crc32(this.buffer, this.plte_offs, this.plte_size);
                    crc32(this.buffer, this.trns_offs, this.trns_size);
                    crc32(this.buffer, this.idat_offs, this.idat_size);
                    crc32(this.buffer, this.iend_offs, this.iend_size);
                    // convert PNG to string
                    return "\x89PNG\r\n\x1a\n" + this.buffer.join("");
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            // https://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
            /**
	 * Converts an HSL color value to RGB. Conversion formula
	 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
	 * Assumes h, s, and l are contained in the set [0, 1] and
	 * returns r, g, and b in the set [0, 255].
	 *
	 * @param   {number}  h       The hue
	 * @param   {number}  s       The saturation
	 * @param   {number}  l       The lightness
	 * @return  {Array}           The RGB representation
	 */ function hue2rgb(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            }
            function hsl2rgb(h, s, l) {
                let r, g, b;
                if (s == 0) r = g = b = l; // achromatic
                else {
                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    const p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }
                return [
                    Math.round(r * 255),
                    Math.round(g * 255),
                    Math.round(b * 255),
                    255
                ];
            }
            module1.exports = hsl2rgb;
        /***/ }
    ]);
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $f7d222943dcdace7$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-0"
})({
    "position": "relative"
});
const $f7d222943dcdace7$export$d7df4bcb9a53fba5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-1"
})({
    "display": "flex",
    "justifyContent": "space-between",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "fontWeight": "500"
});
const $f7d222943dcdace7$export$de65de8213222d10 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1fbr00w-2"
})({});
const $f7d222943dcdace7$export$493dd78b8dd0935e = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1fbr00w-3"
})({});
const $f7d222943dcdace7$export$8a23e74e5cf3ca41 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $fd374e7a8b8677d2$export$e25e478948902b8b).div).attrs(()=>({
        initial: {
            scale: 0
        },
        animate: {
            scale: 1
        },
        exit: {
            scale: 0
        }
    })).withConfig({
    componentId: "sc-1fbr00w-4"
})([
    "",
    ""
], {
    "display": "flex",
    "flexDirection": "column",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))",
    "position": "absolute",
    "borderRadius": "0.5rem",
    "width": "20rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "right": "0px",
    "marginTop": "0.5rem",
    "gap": "1rem"
});
const $f7d222943dcdace7$export$64ef9b8c11710c47 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-5"
})({
    "display": "flex",
    "flexDirection": "column",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(255, 255, 255, var(--tw-border-opacity))",
    "borderRadius": "0.5rem",
    "padding": "0.5rem",
    "gap": "0.5rem"
});
const $f7d222943dcdace7$export$c40915f5101f5fb = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-6"
})({
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "500"
});
const $f7d222943dcdace7$export$3d52c813451d2484 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-7"
})({
    "display": "flex",
    "gap": "0.5rem"
});
const $f7d222943dcdace7$export$7ddbc2cdbc7f78fa = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-8"
})({
    "display": "flex",
    "gap": "1.25rem"
});
const $f7d222943dcdace7$export$fec3433a91320c03 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1fbr00w-9"
})({});
const $f7d222943dcdace7$export$270ff1595fd06908 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1fbr00w-10"
})({
    "paddingLeft": "0.375rem",
    "paddingRight": "0.375rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(59, 153, 252, var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgba(59, 153, 252, var(--tw-text-opacity))",
    "borderRadius": "0.5rem",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "500"
});
const $f7d222943dcdace7$export$654d04d0d8df21ae = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1fbr00w-11"
})({
    "paddingLeft": "0.375rem",
    "paddingRight": "0.375rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(255, 255, 255, var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "borderRadius": "0.5rem",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "500"
});
const $f7d222943dcdace7$export$4f2558dd25106ae2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button.withConfig({
    componentId: "sc-1fbr00w-12"
})({
    "display": "flex",
    "alignItems": "center",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgba(59, 153, 252, var(--tw-text-opacity))",
    "gap": "0.25rem"
});
const $f7d222943dcdace7$export$17f7e665f6e23426 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.withConfig({
    componentId: "sc-1fbr00w-13"
})({
    "display": "flex",
    "alignItems": "center",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "gap": "0.25rem"
});
const $f7d222943dcdace7$export$7d3ec07ebe7469e5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1fbr00w-14"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "0.5rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "500"
});
const $f7d222943dcdace7$export$c50eaf1ed9ecb91f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1fbr00w-15"
})({
    "width": "1rem",
    "height": "1rem",
    "borderRadius": "0.5rem"
});













const $624848ba02aeea6e$export$448434c6e27b3166 = ({ isShow: isShow, parentReference: parentReference, onHide: onHide, disconnect: disconnect, changeProvider: changeProvider })=>{
    (0, $a771512e471faa36$export$71b2224f1ce5e08e)(parentReference, onHide);
    const { account: account = "", chainId: chainId = (0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const truncatedAccount = account ? (0, $b24cf0b5fa9d389a$export$b5d303c2a6ccf5e1)(account) : null;
    const avatar = (0, (/*@__PURE__*/$parcel$interopDefault($caad0df21bcf81f4$exports)))(account);
    const explorerLink = (0, $7388118904bb9474$export$69b3c981e9f23d5a)(chainId, (0, $82caeb4711a08c99$export$8a891f208f17912c).ADDRESS, account);
    const copyAddress = ()=>{
        navigator.clipboard.writeText(account);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d280cf62a9a45ed1$export$3ae376d12526dd6f), {
        children: isShow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$8a23e74e5cf3ca41), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$d7df4bcb9a53fba5), {
                    children: [
                        "Account",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$de65de8213222d10), {
                            onClick: onHide,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$493dd78b8dd0935e), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b0bf29661793b213$exports)))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$64ef9b8c11710c47), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$c40915f5101f5fb), {
                            children: [
                                "Connected",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$3d52c813451d2484), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$270ff1595fd06908), {
                                            onClick: disconnect,
                                            children: "Disconnect"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$654d04d0d8df21ae), {
                                            onClick: changeProvider,
                                            children: "Change"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$7d3ec07ebe7469e5), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$c50eaf1ed9ecb91f), {
                                    src: avatar
                                }),
                                truncatedAccount
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$7ddbc2cdbc7f78fa), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$4f2558dd25106ae2), {
                                    onClick: copyAddress,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$fec3433a91320c03), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec328874715fd635$exports)))
                                        }),
                                        "Copy address"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$17f7e665f6e23426), {
                                    href: explorerLink,
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d222943dcdace7$export$fec3433a91320c03), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5fa5f315d52e4c8f$exports)))
                                        }),
                                        "View on explorer"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : null
    });
};



const $b3ec4a367c4de379$export$2528756baaccf436 = ({ isShowDropdown: isShowDropdown, hideDropdown: hideDropdown, children: children, disconnect: disconnect, changeProvider: changeProvider })=>{
    const parentReference = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7d222943dcdace7$export$42a852a2b6b56249), {
        ref: parentReference,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $624848ba02aeea6e$export$448434c6e27b3166), {
                changeProvider: changeProvider,
                disconnect: disconnect,
                isShow: isShowDropdown,
                onHide: hideDropdown,
                parentReference: parentReference
            })
        ]
    });
};











const $3ffe284ce6f569c8$export$f7af86e18d783e97 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-7k21k3-0"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(59, 153, 252, var(--tw-bg-opacity))",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(59, 153, 252, var(--tw-border-opacity))",
    ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(23, 115, 213, var(--tw-bg-opacity))"
    }
});
const $3ffe284ce6f569c8$export$c50eaf1ed9ecb91f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-7k21k3-1"
})({
    "width": "1rem",
    "height": "1rem",
    "borderRadius": "0.5rem"
});
const $3ffe284ce6f569c8$export$a38d69fa4ca768a3 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-7k21k3-2"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "0.5rem"
});



const $1cb98425a44f292d$export$901ad094b25ad8b9 = ()=>{
    const { isConnected: isConnected, disconnect: disconnect, account: account } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { pushModal: pushModal } = (0, $0bc79745b9fc41e5$export$33ffd74ebf07f060)();
    const { isShowDropdown: isShowDropdown, toggleDropdown: toggleDropdown, hideDropdown: hideDropdown } = (0, $1ace21c61fa2fbe9$export$8c32fdb3462273b4)();
    const showConnectWalletModal = (0, $acw62.useCallback)(()=>{
        pushModal((0, $2fdb081c89f7eb15$export$d2f6f354293ef9f));
    }, [
        pushModal
    ]);
    const changeProvider = (0, $acw62.useCallback)(()=>{
        disconnect();
        showConnectWalletModal();
    }, [
        disconnect,
        showConnectWalletModal
    ]);
    const truncatedAccount = account ? (0, $b24cf0b5fa9d389a$export$b5d303c2a6ccf5e1)(account) : null;
    const avatar = account ? (0, (/*@__PURE__*/$parcel$interopDefault($caad0df21bcf81f4$exports)))(account) : "";
    return isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3ec4a367c4de379$export$2528756baaccf436), {
        changeProvider: changeProvider,
        disconnect: disconnect,
        hideDropdown: hideDropdown,
        isShowDropdown: isShowDropdown,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be288bf3e759632e$export$353f5b6fc5456de1), {
            onClick: toggleDropdown,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3ffe284ce6f569c8$export$a38d69fa4ca768a3), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ffe284ce6f569c8$export$c50eaf1ed9ecb91f), {
                        src: avatar
                    }),
                    truncatedAccount,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a54fc0dd8862e70c$export$3d6d548c35afaaed), {})
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ffe284ce6f569c8$export$f7af86e18d783e97), {
        onClick: showConnectWalletModal,
        children: "Connect Wallet"
    });
};





var $73f3560a6367ee5a$exports = {};

$73f3560a6367ee5a$exports = new URL((parcelRequire("27Lyk")).resolve("d0ZJV"), import.meta.url).toString();


var $49a362987d12de87$exports = {};

$49a362987d12de87$exports = new URL((parcelRequire("27Lyk")).resolve("fZtY5"), import.meta.url).toString();


var $ca6183d870e3ae01$exports = {};

$ca6183d870e3ae01$exports = new URL((parcelRequire("27Lyk")).resolve("3M32g"), import.meta.url).toString();


var $2d0b78637d3e4e21$exports = {};

$2d0b78637d3e4e21$exports = new URL((parcelRequire("27Lyk")).resolve("gqtRq"), import.meta.url).toString();


var $717e996a602e38c0$exports = {};

$717e996a602e38c0$exports = new URL((parcelRequire("27Lyk")).resolve("kJiE8"), import.meta.url).toString();


var $6ffcfbfc41f26969$exports = {};

$6ffcfbfc41f26969$exports = new URL((parcelRequire("27Lyk")).resolve("csHDN"), import.meta.url).toString();


var $5642a9473bb50a15$exports = {};

$5642a9473bb50a15$exports = new URL((parcelRequire("27Lyk")).resolve("1HGEx"), import.meta.url).toString();


var $91cca4a3bb0145b1$exports = {};

$91cca4a3bb0145b1$exports = new URL((parcelRequire("27Lyk")).resolve("4NN8W"), import.meta.url).toString();


var $d35b15f7476ec35e$exports = {};

$d35b15f7476ec35e$exports = new URL((parcelRequire("27Lyk")).resolve("kHMmM"), import.meta.url).toString();


var $1f8a828240029f02$exports = {};

$1f8a828240029f02$exports = new URL((parcelRequire("27Lyk")).resolve("8wFmr"), import.meta.url).toString();




const $d8749c11653c5eb9$var$chainsIcons = {
    [(0, $ba7eaeeb642ff516$export$c06e1e7429de6283).MAINNET]: (0, (/*@__PURE__*/$parcel$interopDefault($49a362987d12de87$exports))),
    [(0, $ba7eaeeb642ff516$export$c06e1e7429de6283).POLYGON]: (0, (/*@__PURE__*/$parcel$interopDefault($ca6183d870e3ae01$exports))),
    [(0, $ba7eaeeb642ff516$export$c06e1e7429de6283).ARBITRUM]: (0, (/*@__PURE__*/$parcel$interopDefault($5642a9473bb50a15$exports)))
};
const $d8749c11653c5eb9$export$54154c36dfb17306 = (chainId)=>{
    if ($d8749c11653c5eb9$var$chainsIcons[chainId]) return $d8749c11653c5eb9$var$chainsIcons[chainId];
    return null;
};











const $4f459f01fd4d0b1d$export$c550ef4926494cef = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1t9otto-0"
})({
    "display": "none",
    "@media (min-width: 768px)": {
        "display": "block"
    }
});



const $1d6b2b6fdccbb311$export$179a2d4534d0f37d = ({ supportedChainIds: supportedChainIds, onClick: onClick })=>{
    const { isConnected: isConnected, chainId: chainId } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    if (!isConnected || !chainId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be288bf3e759632e$export$353f5b6fc5456de1), {
        disabled: true,
        children: "Network"
    });
    if (chainId && !supportedChainIds.includes(chainId)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be288bf3e759632e$export$353f5b6fc5456de1), {
        isError: true,
        onClick: onClick,
        children: "Wrong Network"
    });
    const chainConfig = (0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId);
    const { title: title, chainId: chainConfigChainId } = chainConfig;
    const iconSource = (0, $d8749c11653c5eb9$export$54154c36dfb17306)(chainConfigChainId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be288bf3e759632e$export$353f5b6fc5456de1), {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35ce4af7e686b2f6$export$7c6e2c02157bb7d2), {
            children: [
                iconSource ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35ce4af7e686b2f6$export$f04a61298a47a40f), {
                    src: iconSource
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f459f01fd4d0b1d$export$c550ef4926494cef), {
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a54fc0dd8862e70c$export$3d6d548c35afaaed), {})
            ]
        })
    });
};



const $83ee95629f98356b$export$87dd1b4aceb12c0e = ({ supportedChainIds: supportedChainIds })=>{
    const { chainId: walletChainId, switchChainId: switchChainId } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const { isShowDropdown: isShowDropdown, toggleDropdown: toggleDropdown, hideDropdown: hideDropdown } = (0, $1ace21c61fa2fbe9$export$8c32fdb3462273b4)();
    const supportedChainConfigs = supportedChainIds.map((chainId)=>(0, $6ee4eb9811c1da47$export$703a843624f42e6c)(chainId));
    const filteredChainConfigs = supportedChainConfigs.filter(({ chainId: chainId })=>chainId !== walletChainId);
    const options = filteredChainConfigs.map(({ chainId: chainId, title: title })=>({
            title: title,
            icon: (0, $d8749c11653c5eb9$export$54154c36dfb17306)(chainId),
            onClick: async ()=>{
                await switchChainId(chainId);
                hideDropdown();
            }
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $548768d9fbef52ca$export$931cbfb6bfb85fc), {
        hideDropdown: hideDropdown,
        isShowDropdown: isShowDropdown,
        options: options,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d6b2b6fdccbb311$export$179a2d4534d0f37d), {
            onClick: toggleDropdown,
            supportedChainIds: supportedChainIds
        })
    });
};



const $ce0053d4027384de$export$fa2b8f299c79a430 = ()=>(0, $8cfe9ef9d2660a6b$export$1073520e33bb6112).map(({ chainId: chainId })=>chainId);



var $5d1c410edf9f6922$exports = {};

$5d1c410edf9f6922$exports = new URL((parcelRequire("27Lyk")).resolve("gvUUH"), import.meta.url).toString();


var $3191f977065c893e$exports = {};

$3191f977065c893e$exports = new URL((parcelRequire("27Lyk")).resolve("2agzy"), import.meta.url).toString();


var $a135bbb906be2f65$exports = {};

$a135bbb906be2f65$exports = new URL((parcelRequire("27Lyk")).resolve("QSRtL"), import.meta.url).toString();






const $9bc0d102dfce92ca$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).header.withConfig({
    componentId: "sc-1xgo2l8-0"
})({
    "display": "flex",
    "justifyContent": "space-between",
    "alignItems": "center",
    "gap": "0.5rem",
    "padding": "1.5rem"
});
const $9bc0d102dfce92ca$export$d43ffeaaec0b2a58 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1xgo2l8-1"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "4rem",
    "@media (min-width: 1024px)": {
        "flex": "1 1 0%"
    }
});
const $9bc0d102dfce92ca$export$8988ccf8115f4efc = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-1xgo2l8-2"
})({
    "width": "6rem",
    "display": "none",
    "@media (min-width: 768px)": {
        "display": "block"
    }
});
const $9bc0d102dfce92ca$export$fd738f1d243a3380 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-1xgo2l8-3"
})({
    "width": "1.5rem",
    "display": "block",
    "@media (min-width: 768px)": {
        "display": "none"
    }
});
const $9bc0d102dfce92ca$export$31eeecf9356ae974 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1xgo2l8-4"
})({
    "display": "none",
    "@media (min-width: 768px)": {
        "display": "flex"
    },
    "@media (min-width: 1024px)": {
        "flex": "1 1 0%",
        "justifyContent": "center"
    }
});
const $9bc0d102dfce92ca$export$b532c2c5ca69a972 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1xgo2l8-5"
})({
    "display": "flex",
    "flex": "1 1 0%",
    "justifyContent": "flex-end",
    "gap": "0.5rem"
});



const $b9f803e1851e13c0$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-3xo5tx-0"
})({
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "padding": "0.125rem",
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(54, 56, 63, var(--tw-border-opacity))"
});
const $b9f803e1851e13c0$export$743cfcc1bff7b596 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.withConfig({
    componentId: "sc-3xo5tx-1"
})({
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "padding": "0.5rem",
    "borderRadius": "0.5rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600",
    "lineHeight": "1rem",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))"
    }
});
const $b9f803e1851e13c0$export$9c0f59c5bbfc033d = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b9f803e1851e13c0$export$743cfcc1bff7b596).withConfig({
    componentId: "sc-3xo5tx-2"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(52, 105, 250, var(--tw-bg-opacity))",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(52, 105, 250, var(--tw-bg-opacity))"
    }
});



const $703aef25eb8e517e$export$67106ee6a721ff2 = ({ options: options })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9f803e1851e13c0$export$42a852a2b6b56249), {
        children: options.map(({ title: title, href: href, isActive: isActive })=>isActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9f803e1851e13c0$export$9c0f59c5bbfc033d), {
                href: href,
                children: title
            }, title) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9f803e1851e13c0$export$743cfcc1bff7b596), {
                href: href,
                children: title
            }, title))
    });




const $13c3d8bfa51203f0$export$c10e4a71a0098a67 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $703aef25eb8e517e$export$67106ee6a721ff2), {
        options: [
            {
                title: "Supply",
                href: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).roeSupply,
                isActive: true
            },
            {
                title: "Trade",
                href: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).roeTrade,
                isActive: false
            }
        ]
    });



const $bc4adf8c3c4899c4$export$8b251419efc915eb = ()=>{
    const { isConnected: isConnected } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const supportedChainIds = (0, $ce0053d4027384de$export$fa2b8f299c79a430)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9bc0d102dfce92ca$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9bc0d102dfce92ca$export$d43ffeaaec0b2a58), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9bc0d102dfce92ca$export$8988ccf8115f4efc), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d1c410edf9f6922$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9bc0d102dfce92ca$export$fd738f1d243a3380), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3191f977065c893e$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9bc0d102dfce92ca$export$31eeecf9356ae974), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13c3d8bfa51203f0$export$c10e4a71a0098a67), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9bc0d102dfce92ca$export$b532c2c5ca69a972), {
                children: [
                    isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83ee95629f98356b$export$87dd1b4aceb12c0e), {
                        supportedChainIds: supportedChainIds
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cb98425a44f292d$export$901ad094b25ad8b9), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8511ba07e08219ea$export$266a769812832828), {})
                ]
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");

const $efc03f6dedc37e73$export$e6d68e3ef93ef78f = /*#__PURE__*/ (0, $acw62.createContext)({
    filterInputValue: "",
    setFilterInputValue: ()=>undefined
});
const $efc03f6dedc37e73$export$335db524a096131c = ({ children: children })=>{
    const [filterInputValue, setFilterInputValue] = (0, $acw62.useState)("");
    const value = (0, $acw62.useMemo)(()=>({
            filterInputValue: filterInputValue,
            setFilterInputValue: setFilterInputValue
        }), [
        filterInputValue,
        setFilterInputValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efc03f6dedc37e73$export$e6d68e3ef93ef78f.Provider, {
        value: value,
        children: children
    });
};



const $5cf58e504521d81e$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-vtmw4a-0"
})({
    "display": "flex",
    "flex": "1 1 0%",
    "justifyContent": "center",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
});
const $5cf58e504521d81e$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-vtmw4a-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "flex": "1 1 0%",
    "gap": "0.5rem",
    "width": "100%",
    "maxWidth": "864px"
});
const $5cf58e504521d81e$export$f2c3aea42b2a048f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-vtmw4a-2"
})({
    "display": "flex",
    "flexDirection": "column",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))"
});
const $5cf58e504521d81e$export$31eeecf9356ae974 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-vtmw4a-3"
})({
    "display": "flex",
    "justifyContent": "center",
    "@media (min-width: 768px)": {
        "display": "none"
    }
});



const $f2248ef4d9cf8baf$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1qhmx3d-0"
})([
    "",
    " background-image:url(",
    ");"
], {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "borderRadius": "0.5rem",
    "backgroundSize": "cover",
    "width": "100%"
}, (props)=>props.backgroundSrc);
const $f2248ef4d9cf8baf$export$7c6e2c02157bb7d2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1qhmx3d-1"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "1rem"
});
const $f2248ef4d9cf8baf$export$f2edc0624664f4a4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1qhmx3d-2"
})({
    "display": "flex",
    "flexDirection": "column"
});
const $f2248ef4d9cf8baf$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1qhmx3d-3"
})({
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "700"
});
const $f2248ef4d9cf8baf$export$a6c7ac8248d6e38a = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a.attrs({
    target: "_blank"
}).withConfig({
    componentId: "sc-1qhmx3d-4"
})([
    "",
    ""
], {
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "500",
    "fontStyle": "italic"
});
const $f2248ef4d9cf8baf$export$f04a61298a47a40f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1qhmx3d-5"
})({
    "width": "11rem"
});



const $1b17ca57e04205c1$export$5aa6dd2381fe0a18 = ({ backgroundSrc: backgroundSource, iconSrc: iconSource, titles: titles, link: link })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2248ef4d9cf8baf$export$42a852a2b6b56249), {
        backgroundSrc: backgroundSource,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2248ef4d9cf8baf$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2248ef4d9cf8baf$export$f2edc0624664f4a4), {
                        children: titles.map((title, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2248ef4d9cf8baf$export$f99233281efd08a0), {
                                children: title
                            }, `${title}${index.toString()}`))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2248ef4d9cf8baf$export$a6c7ac8248d6e38a), {
                        href: link,
                        children: "Click to read more"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2248ef4d9cf8baf$export$f04a61298a47a40f), {
                src: iconSource
            })
        ]
    });



var $4eaaff718ba4abc4$exports = {};

$4eaaff718ba4abc4$exports = new URL((parcelRequire("27Lyk")).resolve("1zX9S"), import.meta.url).toString();


var $5e2eb11b6f699f9a$exports = {};

$5e2eb11b6f699f9a$exports = new URL((parcelRequire("27Lyk")).resolve("fUVAz"), import.meta.url).toString();





const $c9fbbf031e3976e4$export$3b4e64e77073e307 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b17ca57e04205c1$export$5aa6dd2381fe0a18), {
        backgroundSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4eaaff718ba4abc4$exports))),
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($5e2eb11b6f699f9a$exports))),
        link: (0, $99cd6d6a768f3807$export$463d32b91de8b4d).gitBookSupply,
        titles: [
            "Supply Your LP Tokens",
            "AMM Swap Fees, Supply Interest And More!"
        ]
    });




const $f78b970511b2fd7c$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1h815yz-0"
})({
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "flexDirection": "row",
    "gap": "0.5rem"
});
const $f78b970511b2fd7c$export$54443ba37957b180 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1h815yz-1"
})({
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "padding": "0.25rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(52, 105, 250, var(--tw-bg-opacity))",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(27, 82, 233, var(--tw-border-opacity))",
    "borderRadius": "0.5rem"
});
const $f78b970511b2fd7c$export$f4619d70a16e5ea0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-1h815yz-2"
})({
    "width": "1.5rem"
});
const $f78b970511b2fd7c$export$c6336bc933e0ce5f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1h815yz-3"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.25rem"
});
const $f78b970511b2fd7c$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1h815yz-4"
})({
    "fontSize": "0.875rem",
    "lineHeight": "1",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))"
});
const $f78b970511b2fd7c$export$4dc9f58ad9a1a000 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1h815yz-5"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "0.25rem"
});
const $f78b970511b2fd7c$export$4c8d1a57a761ef94 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1h815yz-6"
})({
    "fontSize": "1.125rem",
    "lineHeight": "1",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $f78b970511b2fd7c$export$d5c56664638992a4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1h815yz-7"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(196, 196, 196, var(--tw-text-opacity))",
    "lineHeight": "1"
});



const $152791225e99417e$export$cd140626134a6062 = ({ icon: icon, title: title, value: value, prefix: prefix, postfix: postfix })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f78b970511b2fd7c$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$54443ba37957b180), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$f4619d70a16e5ea0), {
                    src: icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f78b970511b2fd7c$export$c6336bc933e0ce5f), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$f99233281efd08a0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f78b970511b2fd7c$export$4dc9f58ad9a1a000), {
                        children: [
                            typeof prefix === "string" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$d5c56664638992a4), {
                                children: prefix
                            }) : prefix,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$4c8d1a57a761ef94), {
                                children: value
                            }),
                            typeof postfix === "string" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$d5c56664638992a4), {
                                children: postfix
                            }) : postfix
                        ]
                    })
                ]
            })
        ]
    });



var $31a89bf6bf2f3493$exports = {};

$31a89bf6bf2f3493$exports = new URL((parcelRequire("27Lyk")).resolve("fEqK1"), import.meta.url).toString();


var $390e73305bab3681$exports = {};

$390e73305bab3681$exports = new URL((parcelRequire("27Lyk")).resolve("a7ixg"), import.meta.url).toString();


var $9f0a46e37e98f1e1$exports = {};

$9f0a46e37e98f1e1$exports = new URL((parcelRequire("27Lyk")).resolve("6vz32"), import.meta.url).toString();





const $4a7c1c0dcb2e1ad9$export$43926c8279651e06 = (sumBalance)=>{
    if (sumBalance === undefined) return "-";
    if (sumBalance === null) return "N/A";
    return (0, $62681a7eaa870c9b$export$4356254075e80b7d)(sumBalance);
};
const $4a7c1c0dcb2e1ad9$export$fa1110d202e6b945 = (averageAPY)=>{
    if (averageAPY === undefined) return "-";
    if (averageAPY === null) return "N/A";
    return (0, $62681a7eaa870c9b$export$9beb615f731480fd)(averageAPY * 100);
};



const $7292d30d9ce09b62$export$1204268d3d4dac = (row)=>{
    const { pairTokenPrice: pairTokenPrice, walletAToken: walletAToken } = row;
    return walletAToken?.balance?.mul(pairTokenPrice).toNumber() ?? null;
};
const $7292d30d9ce09b62$export$7381a01e1bf135b4 = (rows)=>{
    const firstBalance = $7292d30d9ce09b62$export$1204268d3d4dac(rows[0]);
    if (firstBalance === null) return null;
    return rows.reduce((accumulator, row)=>{
        const balance = $7292d30d9ce09b62$export$1204268d3d4dac(row);
        return balance !== null ? accumulator + balance : 0;
    }, 0);
};
const $7292d30d9ce09b62$export$8623a50635b31c42 = (rows)=>{
    const firstBalance = $7292d30d9ce09b62$export$1204268d3d4dac(rows[0]);
    if (firstBalance === null) return null;
    return rows.reduce((accumulator, row)=>{
        const balance = $7292d30d9ce09b62$export$1204268d3d4dac(row);
        const APY = (0, $d91182ae554a6565$export$1be513a619b91a39)(row);
        return balance !== null ? accumulator + balance * APY : 0;
    }, 0);
};
const $7292d30d9ce09b62$export$95ab22703be2a5c3 = (rows)=>rows.reduce((accumulator, { totalSupplied: totalSupplied })=>accumulator + totalSupplied, 0);
const $7292d30d9ce09b62$export$9de3ff9a8f993fe9 = (sumBalanceByAPY, sumBalance)=>{
    if (sumBalanceByAPY === null || sumBalance === null) return null;
    if (sumBalance === 0) return 0;
    return sumBalanceByAPY / sumBalance;
};



const $69c15c2666b0fefd$export$4048bf770a12177e = ()=>(0, $f689c6bb55d1135e$export$6912159ad0f5a2ef).map(({ id: id })=>id);





const $6730f78adeee59b5$export$959f3276eb8feab0 = (tokensQueriesParameters)=>{
    const { account: account } = (0, $75e390eec3a10f89$export$c34addee860b0acb)();
    const queriesOptions = tokensQueriesParameters.map(({ chainId: chainId, tokenAddress: tokenAddress, spenderAddress: spenderAddress })=>(0, $73411fa4076fd4c1$export$e92b4f03ff09cca8)(chainId, tokenAddress, spenderAddress, account));
    return (0, $990eb380e3560bcc$export$408667c6c87da1e5)(queriesOptions);
};





const $ee4e3ccc5f045149$export$3cda29418d736c0d = (pairIds)=>{
    const queriesOptions = pairIds.map((pairId)=>{
        const { id: id, chainId: chainId } = (0, $630b0f38660b8a03$export$f0c9f85d2b6af2cc)(pairId);
        return (0, $8857fe245ddb9394$export$47705da074a47d45)(id, chainId);
    });
    return (0, $990eb380e3560bcc$export$408667c6c87da1e5)(queriesOptions);
};




const $292d187f8f65625f$export$b62c0e3ad55249ca = (pair)=>{
    const { aToken: aToken, pairTokenPrice: pairTokenPrice } = pair;
    return aToken.totalSupply.mul(pairTokenPrice).toNumber();
};
const $292d187f8f65625f$export$e9e503f1b7248a9e = (pair)=>{
    const { debtToken: debtToken, pairTokenPrice: pairTokenPrice } = pair;
    return debtToken.totalSupply.mul(pairTokenPrice).toNumber();
};


const $ebab040a632dca2c$export$2042ab1c947c2cef = (pair, walletPairToken, walletAToken)=>{
    const { id: id, chainId: chainId, source: source, token0: token0, token1: token1, swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: rewardAPY, booster: booster, pairTokenPrice: pairTokenPrice } = pair;
    const tokens = [
        token0.symbol,
        token1.symbol
    ];
    const title = (0, $97040645fc5a577a$export$5bc6031dcd0c59f7)(pair);
    const totalSupplied = (0, $292d187f8f65625f$export$b62c0e3ad55249ca)(pair);
    const totalBorrowed = (0, $292d187f8f65625f$export$e9e503f1b7248a9e)(pair);
    return {
        id: id,
        chainId: chainId,
        source: source,
        tokens: tokens,
        title: title,
        totalSupplied: totalSupplied,
        totalBorrowed: totalBorrowed,
        swapFeesAPY: swapFeesAPY,
        roeSupplyAPY: roeSupplyAPY,
        rewardAPY: rewardAPY,
        booster: booster,
        pairTokenPrice: pairTokenPrice,
        walletPairToken: walletPairToken,
        walletAToken: walletAToken
    };
};



const $7060843b4f5955a5$export$b5c58888723fa5d4 = ()=>{
    const pairIds = (0, $69c15c2666b0fefd$export$4048bf770a12177e)();
    const pairsQueries = (0, $ee4e3ccc5f045149$export$3cda29418d736c0d)(pairIds);
    const pairTokensQueriesParameters = pairIds.map((pairId, index)=>(0, $4a0b3df1dc1c06ef$export$bb6906292efbb73d)(pairId, pairsQueries[index]));
    const aTokensQueriesParameters = pairIds.map((pairId, index)=>(0, $83c927673f132148$export$d398db6d32c368f4)(pairId, pairsQueries[index]));
    const pairTokensQueries = (0, $6730f78adeee59b5$export$959f3276eb8feab0)(pairTokensQueriesParameters);
    const aTokensQueries = (0, $6730f78adeee59b5$export$959f3276eb8feab0)(aTokensQueriesParameters);
    const toPairRowParameters = pairsQueries.map((pairQuery, index)=>{
        const pairQueryData = pairQuery.data;
        const pairTokenQueryData = pairTokensQueries[index].data;
        const aTokenQueryData = aTokensQueries[index].data;
        return {
            pairQueryData: pairQueryData,
            pairTokenQueryData: pairTokenQueryData,
            aTokenQueryData: aTokenQueryData
        };
    });
    return toPairRowParameters.map(({ pairQueryData: pairQueryData, pairTokenQueryData: pairTokenQueryData, aTokenQueryData: aTokenQueryData })=>pairQueryData ? (0, $ebab040a632dca2c$export$2042ab1c947c2cef)(pairQueryData, pairTokenQueryData, aTokenQueryData) : undefined);
};


const $c7bd89ddc081b65b$export$255a985966df6537 = ()=>{
    const rows = (0, $7060843b4f5955a5$export$b5c58888723fa5d4)();
    const isLoading = rows.some((row)=>!row || !row.walletPairToken || !row.walletAToken);
    if (isLoading) return {
        sumBalance: undefined,
        sumTVL: undefined,
        averageAPY: undefined
    };
    const loadedRows = rows;
    const sumBalance = (0, $7292d30d9ce09b62$export$7381a01e1bf135b4)(loadedRows);
    const sumTVL = (0, $7292d30d9ce09b62$export$95ab22703be2a5c3)(loadedRows);
    const sumBalanceByAPY = (0, $7292d30d9ce09b62$export$8623a50635b31c42)(loadedRows);
    const averageAPY = (0, $7292d30d9ce09b62$export$9de3ff9a8f993fe9)(sumBalanceByAPY, sumBalance);
    return {
        sumBalance: sumBalance,
        sumTVL: sumTVL,
        averageAPY: averageAPY
    };
};



const $8d98d931a70d091d$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-ve5ure-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(62, 68, 83, var(--tw-border-opacity))",
    "gap": "2rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem"
});
const $8d98d931a70d091d$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2.withConfig({
    componentId: "sc-ve5ure-1"
})({
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontWeight": "600"
});
const $8d98d931a70d091d$export$ab73a55b19082507 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-ve5ure-2"
})({
    "display": "flex",
    "gap": "2rem"
});



const $dd23269a2e5edb11$export$ed9166ec0f465b5e = ()=>{
    const { sumBalance: sumBalance, averageAPY: averageAPY } = (0, $c7bd89ddc081b65b$export$255a985966df6537)();
    const formattedSumBalance = (0, $4a7c1c0dcb2e1ad9$export$43926c8279651e06)(sumBalance);
    const formattedAverageAPY = (0, $4a7c1c0dcb2e1ad9$export$fa1110d202e6b945)(averageAPY);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d98d931a70d091d$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d98d931a70d091d$export$f99233281efd08a0), {
                children: "Your Summary"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d98d931a70d091d$export$ab73a55b19082507), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $152791225e99417e$export$cd140626134a6062), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($31a89bf6bf2f3493$exports))),
                        prefix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$d5c56664638992a4), {
                            children: "$"
                        }),
                        title: "Balance",
                        value: formattedSumBalance
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $152791225e99417e$export$cd140626134a6062), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($390e73305bab3681$exports))),
                        postfix: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f78b970511b2fd7c$export$d5c56664638992a4), {
                            children: "%"
                        }),
                        title: "Net Supply APY",
                        value: formattedAverageAPY
                    })
                ]
            })
        ]
    });
};





const $65ce953e0ac4bc9b$export$5b6c8e359d4618aa = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-sral1h-0"
})({
    "width": "1.5rem"
});
const $65ce953e0ac4bc9b$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-sral1h-1"
})({
    "width": "100%",
    "display": "flex",
    "justifyContent": "center"
});



const $66dd3d7c3a0c8184$export$4a01bfee18ca2c98 = ({ chainId: chainId })=>{
    const iconSource = (0, $d8749c11653c5eb9$export$54154c36dfb17306)(chainId);
    return iconSource ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65ce953e0ac4bc9b$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65ce953e0ac4bc9b$export$5b6c8e359d4618aa), {
            src: iconSource
        })
    }) : null;
};



var $acw62 = parcelRequire("acw62");
var $7e3a173e7e936018$exports = {};

var $acw62 = parcelRequire("acw62");
var $138bf068d8c0f43c$export$26ecbb5c9753d95f = function(visible) {
    return {
        display: visible ? "flex" : "none"
    };
};


var $5bce88e8def4447d$export$37394b0fa44b998c = "#4fa94d";
var $5bce88e8def4447d$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "status"
};


var $7e3a173e7e936018$var$__assign = undefined && undefined.__assign || function() {
    $7e3a173e7e936018$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e3a173e7e936018$var$__assign.apply(this, arguments);
};
var $7e3a173e7e936018$var$Audio = function(_a) {
    var _b = _a.height, height = _b === void 0 ? "100" : _b, _c = _a.width, width = _c === void 0 ? "100" : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "audio-loading" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $7e3a173e7e936018$var$__assign({
        style: $7e3a173e7e936018$var$__assign($7e3a173e7e936018$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: "".concat(height),
        width: "".concat(width),
        fill: color,
        viewBox: "0 0 55 80",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "audio-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "matrix(1 0 0 -1 0 80)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: "10",
        height: "20",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "4.3s",
        values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "15",
        width: "10",
        height: "80",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "2s",
        values: "80;55;33;5;75;23;73;33;12;14;60;80",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "30",
        width: "10",
        height: "50",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "1.4s",
        values: "50;34;78;23;56;23;34;76;80;54;21;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "45",
        width: "10",
        height: "30",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "2s",
        values: "30;45;13;80;56;72;45;76;34;23;67;30",
        calcMode: "linear",
        repeatCount: "indefinite"
    })))));
};
var $7e3a173e7e936018$export$2e2bcd8739ae039 = $7e3a173e7e936018$var$Audio;


var $b29ed46212d3f444$exports = {};

var $acw62 = parcelRequire("acw62");


var $b29ed46212d3f444$var$__assign = undefined && undefined.__assign || function() {
    $b29ed46212d3f444$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b29ed46212d3f444$var$__assign.apply(this, arguments);
};
var $b29ed46212d3f444$var$BallTriangle = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 100 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, _d = _a.radius, radius = _d === void 0 ? 5 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "ball-triangle-loading" : _f, wrapperClass = _a.wrapperClass, wrapperStyle = _a.wrapperStyle, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $b29ed46212d3f444$var$__assign({
        style: $b29ed46212d3f444$var$__assign($b29ed46212d3f444$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        height: height,
        width: width,
        stroke: color,
        viewBox: "0 0 57 57",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "ball-triangle-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(1 1)",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5",
        cy: "50",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        values: "50;5;50;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cx",
        begin: "0s",
        dur: "2.2s",
        values: "5;27;49;5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "27",
        cy: "5",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        from: "5",
        to: "5",
        values: "5;50;50;5",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cx",
        begin: "0s",
        dur: "2.2s",
        from: "27",
        to: "27",
        values: "27;49;5;27",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "49",
        cy: "50",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        values: "50;50;5;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cx",
        from: "49",
        to: "49",
        begin: "0s",
        dur: "2.2s",
        values: "49;5;27;49",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))))));
};
var $b29ed46212d3f444$export$2e2bcd8739ae039 = $b29ed46212d3f444$var$BallTriangle;


var $1b4fd7ef632cc9fc$exports = {};

var $acw62 = parcelRequire("acw62");


var $1b4fd7ef632cc9fc$var$__assign = undefined && undefined.__assign || function() {
    $1b4fd7ef632cc9fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b4fd7ef632cc9fc$var$__assign.apply(this, arguments);
};
var $1b4fd7ef632cc9fc$var$Bars = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "bars-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $1b4fd7ef632cc9fc$var$__assign({
        style: $1b4fd7ef632cc9fc$var$__assign($1b4fd7ef632cc9fc$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        fill: color,
        viewBox: "0 0 135 140",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "bars-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $1b4fd7ef632cc9fc$export$2e2bcd8739ae039 = $1b4fd7ef632cc9fc$var$Bars;


var $ec3b5a65e606fcc7$exports = {};

var $acw62 = parcelRequire("acw62");


var $ec3b5a65e606fcc7$var$__assign = undefined && undefined.__assign || function() {
    $ec3b5a65e606fcc7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec3b5a65e606fcc7$var$__assign.apply(this, arguments);
};
var $ec3b5a65e606fcc7$var$Circles = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "circles-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $ec3b5a65e606fcc7$var$__assign({
        style: $ec3b5a65e606fcc7$var$__assign($ec3b5a65e606fcc7$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 135 135",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "circles-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 67 67",
        to: "-360 67 67",
        dur: "2.5s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 67 67",
        to: "360 67 67",
        dur: "8s",
        repeatCount: "indefinite"
    }))));
};
var $ec3b5a65e606fcc7$export$2e2bcd8739ae039 = $ec3b5a65e606fcc7$var$Circles;


var $7386a3e2e2ab6b11$exports = {};

var $acw62 = parcelRequire("acw62");


var $7386a3e2e2ab6b11$var$__assign = undefined && undefined.__assign || function() {
    $7386a3e2e2ab6b11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7386a3e2e2ab6b11$var$__assign.apply(this, arguments);
};
var $7386a3e2e2ab6b11$var$CirclesWithBar = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _g, outerCircleColor = _a.outerCircleColor, innerCircleColor = _a.innerCircleColor, barColor = _a.barColor, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "circles-with-bar-loading" : _h;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $7386a3e2e2ab6b11$var$__assign({
        style: $7386a3e2e2ab6b11$var$__assign($7386a3e2e2ab6b11$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18), {
        "data-testid": "circles-with-bar-wrapper"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        version: "1.1",
        id: "L1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        height: "".concat(height),
        width: "".concat(width),
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "circles-with-bar-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: "".concat(outerCircleColor || color),
        strokeWidth: "6",
        strokeMiterlimit: "15",
        strokeDasharray: "14.2472,14.2472",
        cx: "50",
        cy: "50",
        r: "47"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "5s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: "".concat(innerCircleColor || color),
        strokeWidth: "1",
        strokeMiterlimit: "10",
        strokeDasharray: "10,10",
        cx: "50",
        cy: "50",
        r: "39"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "5s",
        from: "0 50 50",
        to: "-360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "".concat(barColor || color),
        "data-testid": "circles-with-bar-svg-bar"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "30",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.1"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "40",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.2"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "50",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.3"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "60",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.4"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "70",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.5"
    })))));
};
var $7386a3e2e2ab6b11$export$2e2bcd8739ae039 = $7386a3e2e2ab6b11$var$CirclesWithBar;


var $4439f3185251fe02$exports = {};

var $acw62 = parcelRequire("acw62");


var $4439f3185251fe02$var$__assign = undefined && undefined.__assign || function() {
    $4439f3185251fe02$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4439f3185251fe02$var$__assign.apply(this, arguments);
};
var $4439f3185251fe02$export$ef2184bd89960b14 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 12.5 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "grid-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $4439f3185251fe02$var$__assign({
        style: $4439f3185251fe02$var$__assign($4439f3185251fe02$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 105 105",
        fill: color,
        "data-testid": "grid-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0s",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "100ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "300ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "600ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "800ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "400ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "700ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "500ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "200ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $4439f3185251fe02$export$2e2bcd8739ae039 = $4439f3185251fe02$export$ef2184bd89960b14;


var $fb16fe00db762750$exports = {};

var $acw62 = parcelRequire("acw62");


var $fb16fe00db762750$var$__assign = undefined && undefined.__assign || function() {
    $fb16fe00db762750$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb16fe00db762750$var$__assign.apply(this, arguments);
};
var $fb16fe00db762750$var$Hearts = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "hearts-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $fb16fe00db762750$var$__assign({
        style: $fb16fe00db762750$var$__assign($fb16fe00db762750$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 140 64",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "hearts-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
        attributeName: "fill-opacity",
        from: "0",
        to: ".5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0s",
        dur: "1.4s",
        values: "0.5;1;0.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
        attributeName: "fill-opacity",
        from: "0",
        to: ".5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0.7s",
        dur: "1.4s",
        values: "0.5;1;0.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    })));
};
var $fb16fe00db762750$export$2e2bcd8739ae039 = $fb16fe00db762750$var$Hearts;


var $206d94d500e87106$exports = {};

var $acw62 = parcelRequire("acw62");


var $206d94d500e87106$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $206d94d500e87106$var$len = 242.776657104492;
var $206d94d500e87106$var$time = 1.6;
var $206d94d500e87106$var$anim = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)($206d94d500e87106$var$templateObject_1 || ($206d94d500e87106$var$templateObject_1 = $206d94d500e87106$var$__makeTemplateObject([
    "\n  12.5% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  43.75% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  100% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n"
], [
    "\n  12.5% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  43.75% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  100% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n"
])), $206d94d500e87106$var$len * 0.14, $206d94d500e87106$var$len, $206d94d500e87106$var$len * 0.11, $206d94d500e87106$var$len * 0.35, $206d94d500e87106$var$len, $206d94d500e87106$var$len * 0.35, $206d94d500e87106$var$len * 0.01, $206d94d500e87106$var$len, $206d94d500e87106$var$len * 0.99);
var $206d94d500e87106$var$Path = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).path($206d94d500e87106$var$templateObject_2 || ($206d94d500e87106$var$templateObject_2 = $206d94d500e87106$var$__makeTemplateObject([
    "\n  stroke-dasharray: ",
    "px, ",
    ";\n  stroke-dashoffset: 0;\n  animation: ",
    " ",
    "s linear infinite;\n"
], [
    "\n  stroke-dasharray: ",
    "px, ",
    ";\n  stroke-dashoffset: 0;\n  animation: ",
    " ",
    "s linear infinite;\n"
])), $206d94d500e87106$var$len * 0.01, $206d94d500e87106$var$len, $206d94d500e87106$var$anim, $206d94d500e87106$var$time);
var $206d94d500e87106$var$InfinitySpin = function(_a) {
    var _b = _a.color, color = _b === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _b, _c = _a.width, width = _c === void 0 ? "200" : _c;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "".concat(width),
        height: "".concat(Number(width) * 0.5),
        viewBox: "0 0 ".concat(width, " ").concat(Number(100)),
        "data-testid": "infinity-spin"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($206d94d500e87106$var$Path, {
        "data-testid": "infinity-spin-path-1",
        stroke: color,
        fill: "none",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "data-testid": "infinity-spin-path-2",
        opacity: "0.07",
        fill: "none",
        stroke: color,
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    }));
};
var $206d94d500e87106$export$2e2bcd8739ae039 = $206d94d500e87106$var$InfinitySpin;
var $206d94d500e87106$var$templateObject_1, $206d94d500e87106$var$templateObject_2;


var $ad3c262dd5af8f74$exports = {};

var $acw62 = parcelRequire("acw62");


var $ad3c262dd5af8f74$var$__assign = undefined && undefined.__assign || function() {
    $ad3c262dd5af8f74$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad3c262dd5af8f74$var$__assign.apply(this, arguments);
};
var $ad3c262dd5af8f74$var$LineWave = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "line-wave-loading" : _h, firstLineColor = _a.firstLineColor, middleLineColor = _a.middleLineColor, lastLineColor = _a.lastLineColor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $ad3c262dd5af8f74$var$__assign({
        style: $ad3c262dd5af8f74$var$__assign($ad3c262dd5af8f74$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        version: "1.1",
        height: "".concat(height),
        width: "".concat(width),
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 0 0",
        xmlSpace: "preserve",
        "data-testid": "line-wave-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "20",
        y: "50",
        width: "4",
        height: "10",
        fill: firstLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0",
        dur: "0.6s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "30",
        y: "50",
        width: "4",
        height: "10",
        fill: middleLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.2s",
        dur: "0.6s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "40",
        y: "50",
        width: "4",
        height: "10",
        fill: lastLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.4s",
        dur: "0.6s",
        repeatCount: "indefinite"
    }))));
};
var $ad3c262dd5af8f74$export$2e2bcd8739ae039 = $ad3c262dd5af8f74$var$LineWave;


var $85ce1c1cd50dfa98$exports = {};

var $acw62 = parcelRequire("acw62");


var $85ce1c1cd50dfa98$var$__assign = undefined && undefined.__assign || function() {
    $85ce1c1cd50dfa98$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $85ce1c1cd50dfa98$var$__assign.apply(this, arguments);
};
var $85ce1c1cd50dfa98$var$MutatingDots = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 90 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 12.5 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.secondaryColor, secondaryColor = _f === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "mutating-dots-loading" : _g, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _h = _a.visible, visible = _h === void 0 ? true : _h;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $85ce1c1cd50dfa98$var$__assign({
        style: $85ce1c1cd50dfa98$var$__assign($85ce1c1cd50dfa98$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        id: "goo-loader",
        width: width,
        height: height,
        "data-testid": "mutating-dots-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("filter", {
        id: "fancy-goo"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feGaussianBlur", {
        in: "SourceGraphic",
        stdDeviation: "6",
        result: "blur"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feColorMatrix", {
        in: "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
        result: "goo"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("feComposite", {
        in: "SourceGraphic",
        in2: "goo",
        operator: "atop"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        filter: "url(#fancy-goo)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        id: "mainAnim",
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        from: "0 50 50",
        to: "359 50 50",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "50%",
        cy: "40",
        r: radius,
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        id: "cAnim1",
        attributeType: "XML",
        attributeName: "cy",
        dur: "0.6s",
        begin: "0;cAnim1.end+0.2s",
        calcMode: "spline",
        values: "40;20;40",
        keyTimes: "0;0.3;1",
        keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "50%",
        cy: "60",
        r: radius,
        fill: secondaryColor
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        id: "cAnim2",
        attributeType: "XML",
        attributeName: "cy",
        dur: "0.6s",
        begin: "0.4s;cAnim2.end+0.2s",
        calcMode: "spline",
        values: "60;80;60",
        keyTimes: "0;0.3;1",
        keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    })))));
};
var $85ce1c1cd50dfa98$export$2e2bcd8739ae039 = $85ce1c1cd50dfa98$var$MutatingDots;


var $9bf99c99f0690dd4$exports = {};

var $acw62 = parcelRequire("acw62");


var $9bf99c99f0690dd4$var$__assign = undefined && undefined.__assign || function() {
    $9bf99c99f0690dd4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9bf99c99f0690dd4$var$__assign.apply(this, arguments);
};
var $9bf99c99f0690dd4$var$RADIUS = 20;
var $9bf99c99f0690dd4$var$getPath = function(radius) {
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
var $9bf99c99f0690dd4$var$getViewBoxSize = function(strokeWidth, secondaryStrokeWidth, radius) {
    var maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    var startingPoint = -radius - maxStrokeWidth / 2 + 1;
    var endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
var $9bf99c99f0690dd4$var$Oval = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.secondaryColor, secondaryColor = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "oval-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g, _h = _a.strokeWidth, strokeWidth = _h === void 0 ? 2 : _h, strokeWidthSecondary = _a.strokeWidthSecondary;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $9bf99c99f0690dd4$var$__assign({
        style: $9bf99c99f0690dd4$var$__assign($9bf99c99f0690dd4$var$__assign($9bf99c99f0690dd4$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle), {
            padding: 3
        }),
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: $9bf99c99f0690dd4$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $9bf99c99f0690dd4$var$RADIUS),
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "oval-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(1 1)",
        strokeWidth: Number(strokeWidthSecondary || strokeWidth),
        "data-testid": "oval-secondary-group"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        strokeOpacity: ".5",
        cx: "0",
        cy: "0",
        r: $9bf99c99f0690dd4$var$RADIUS,
        stroke: secondaryColor,
        strokeWidth: strokeWidth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: $9bf99c99f0690dd4$var$getPath($9bf99c99f0690dd4$var$RADIUS)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 0 0",
        to: "360 0 0",
        dur: "1s",
        repeatCount: "indefinite"
    }))))));
};
var $9bf99c99f0690dd4$export$2e2bcd8739ae039 = $9bf99c99f0690dd4$var$Oval;


var $4e6abcd595dc6353$exports = {};

var $acw62 = parcelRequire("acw62");


var $4e6abcd595dc6353$var$__assign = undefined && undefined.__assign || function() {
    $4e6abcd595dc6353$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e6abcd595dc6353$var$__assign.apply(this, arguments);
};
var $4e6abcd595dc6353$export$83d2259ec538613b = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 1 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "puff-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $4e6abcd595dc6353$var$__assign({
        style: $4e6abcd595dc6353$var$__assign($4e6abcd595dc6353$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "puff-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        begin: "0s",
        dur: "1.8s",
        values: "1; 20",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.165, 0.84, 0.44, 1",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "0s",
        dur: "1.8s",
        values: "1; 0",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.3, 0.61, 0.355, 1",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        begin: "-0.9s",
        dur: "1.8s",
        values: "1; 20",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.165, 0.84, 0.44, 1",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "-0.9s",
        dur: "1.8s",
        values: "1; 0",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.3, 0.61, 0.355, 1",
        repeatCount: "indefinite"
    })))));
};
var $4e6abcd595dc6353$export$2e2bcd8739ae039 = $4e6abcd595dc6353$export$83d2259ec538613b;


var $ff0bb1d47777e42d$exports = {};

var $acw62 = parcelRequire("acw62");


var $ff0bb1d47777e42d$var$__assign = undefined && undefined.__assign || function() {
    $ff0bb1d47777e42d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff0bb1d47777e42d$var$__assign.apply(this, arguments);
};
var $ff0bb1d47777e42d$var$RevolvingDot = function(_a) {
    var _b = _a.radius, radius = _b === void 0 ? 45 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 5 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, secondaryColor = _a.secondaryColor, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "revolving-dot-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $ff0bb1d47777e42d$var$__assign({
        style: $ff0bb1d47777e42d$var$__assign($ff0bb1d47777e42d$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        version: "1.1",
        width: "calc(".concat(radius, " * 2.5)"),
        height: "calc(".concat(radius, " * 2.5)"),
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        "data-testid": "revolving-dot-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: secondaryColor || color,
        strokeWidth: strokeWidth,
        cx: "calc(".concat(radius, " * 1.28)"),
        cy: "calc(".concat(radius, " * 1.28)"),
        r: radius,
        style: {
            opacity: 0.5
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: color,
        stroke: color,
        strokeWidth: "3",
        cx: "calc(".concat(radius, " * 1.28)"),
        cy: "calc(".concat(radius, " / 3.5)"),
        r: "calc(".concat(radius, " / 5)"),
        style: {
            transformOrigin: "50% 50%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "2s",
        type: "rotate",
        from: "0",
        to: "360",
        repeatCount: "indefinite"
    }))));
};
var $ff0bb1d47777e42d$export$2e2bcd8739ae039 = $ff0bb1d47777e42d$var$RevolvingDot;


var $0974c2cde1e173ea$exports = {};

var $acw62 = parcelRequire("acw62");


var $0974c2cde1e173ea$var$__assign = undefined && undefined.__assign || function() {
    $0974c2cde1e173ea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0974c2cde1e173ea$var$__assign.apply(this, arguments);
};
var $0974c2cde1e173ea$export$fdd9e2f491a77de7 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 6 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "rings-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $0974c2cde1e173ea$var$__assign({
        style: $0974c2cde1e173ea$var$__assign($0974c2cde1e173ea$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 45 45",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "rings-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(1 1)",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius,
        strokeOpacity: "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        begin: "1.5s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "stroke-opacity",
        begin: "1.5s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "stroke-width",
        begin: "1.5s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius,
        strokeOpacity: "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        begin: "3s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "3s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "strokeWidth",
        begin: "3s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: Number(radius) + 2
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        begin: "0s",
        dur: "1.5s",
        values: "6;1;2;3;4;5;6",
        calcMode: "linear",
        repeatCount: "indefinite"
    })))));
};
var $0974c2cde1e173ea$export$2e2bcd8739ae039 = $0974c2cde1e173ea$export$fdd9e2f491a77de7;


var $5932ebb73b8212d1$exports = {};

var $acw62 = parcelRequire("acw62");


var $5932ebb73b8212d1$var$__assign = undefined && undefined.__assign || function() {
    $5932ebb73b8212d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5932ebb73b8212d1$var$__assign.apply(this, arguments);
};
var $5932ebb73b8212d1$var$RotatingSquare = function(_a) {
    var _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.color, color = _c === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _c, _d = _a.height, height = _d === void 0 ? 100 : _d, _e = _a.width, width = _e === void 0 ? 100 : _e, _f = _a.strokeWidth, strokeWidth = _f === void 0 ? 4 : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-square-loading" : _g, _h = _a.wrapperStyle, wrapperStyle = _h === void 0 ? {} : _h, _j = _a.visible, visible = _j === void 0 ? true : _j;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $5932ebb73b8212d1$var$__assign({
        style: $5932ebb73b8212d1$var$__assign($5932ebb73b8212d1$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        height: "".concat(height),
        width: "".concat(width),
        "data-testid": "rotating-square-svg",
        xmlSpace: "preserve"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        fill: "none",
        stroke: color,
        strokeWidth: strokeWidth,
        x: "25",
        y: "25",
        width: "50",
        height: "50"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "0.5s",
        from: "0 50 50",
        to: "180 50 50",
        type: "rotate",
        id: "strokeBox",
        attributeType: "XML",
        begin: "rectBox.end"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "27",
        y: "27",
        fill: color,
        width: "46",
        height: "50"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        dur: "1.3s",
        attributeType: "XML",
        from: "50",
        to: "0",
        id: "rectBox",
        fill: "freeze",
        begin: "0s;strokeBox.end"
    }))));
};
var $5932ebb73b8212d1$export$2e2bcd8739ae039 = $5932ebb73b8212d1$var$RotatingSquare;


var $729820ced476238b$exports = {};

var $acw62 = parcelRequire("acw62");

/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * import styled from "styled-components";
 * import { prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   color: ${prop("color", "red")};
 * `;
 */ var $d9ff0d50ceb9bc27$var$prop = function prop(path, defaultValue) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (typeof props[path] !== "undefined") return props[path];
        if (path && path.indexOf(".") > 0) {
            var paths = path.split(".");
            var length = paths.length;
            var object = props[paths[0]];
            var index = 1;
            while(object != null && index < length){
                object = object[paths[index]];
                index += 1;
            }
            if (typeof object !== "undefined") return object;
        }
        return defaultValue;
    };
};
var $d9ff0d50ceb9bc27$export$2e2bcd8739ae039 = $d9ff0d50ceb9bc27$var$prop;


function $e354584c2b061d62$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e354584c2b061d62$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e354584c2b061d62$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e354584c2b061d62$var$_typeof(obj);
}
var $e354584c2b061d62$var$parseFunction = function parseFunction(props, test) {
    return Boolean(test(props));
};
var $e354584c2b061d62$var$parseObject = function parseObject(props, test) {
    var keys = Object.keys(test);
    var length = keys.length;
    for(var index = 0; index < length; index += 1){
        var key = keys[index];
        var expected = test[key];
        var value = (0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)(key)(props);
        if (expected !== value) return false;
    }
    return true;
};
var $e354584c2b061d62$var$parseString = function parseString(props, test) {
    return Boolean((0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)(test)(props));
};
var $e354584c2b061d62$var$parseMap = {
    function: $e354584c2b061d62$var$parseFunction,
    object: $e354584c2b061d62$var$parseObject,
    string: $e354584c2b061d62$var$parseString
};
/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifProp, palette } from "styled-tools";
 *
 * const Button = styled.button`
 *   background-color: ${ifProp("transparent", "transparent", palette(0))};
 *   color: ${ifProp(["transparent", "accent"], palette("secondary"))};
 *   font-size: ${ifProp({ size: "large" }, "20px", ifProp({ size: "medium" }, "16px", "12px"))};
 * `;
 */ var $e354584c2b061d62$var$ifProp = function ifProp(test) {
    var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var fail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var result = true;
        if (Array.isArray(test)) {
            var length = test.length;
            var index = 0;
            while(result && index < length){
                result = $e354584c2b061d62$var$parseMap[$e354584c2b061d62$var$_typeof(test[index])](props, test[index]);
                index += 1;
            }
        } else result = $e354584c2b061d62$var$parseMap[$e354584c2b061d62$var$_typeof(test)](props, test);
        var value = result ? pass : fail;
        return typeof value === "function" ? value(props) : value;
    };
};
var $e354584c2b061d62$export$2e2bcd8739ae039 = $e354584c2b061d62$var$ifProp;


/**
 * Returns `pass` if prop is falsy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifNotProp } from "styled-tools";
 *
 * const Button = styled.button`
 *   font-size: ${ifNotProp("large", "20px", "30px")};
 * `;
 */ var $c7b912c1bbb7f637$var$ifNotProp = function ifNotProp(test, pass, fail) {
    return (0, $e354584c2b061d62$export$2e2bcd8739ae039)(test, fail, pass);
};
var $c7b912c1bbb7f637$export$2e2bcd8739ae039 = $c7b912c1bbb7f637$var$ifNotProp;




var $8229ab55828c3b1d$var$toArray = function toArray(arg) {
    return Array.isArray(arg) ? arg : [
        arg
    ];
};
var $8229ab55828c3b1d$var$clamp = function clamp(number, min, max) {
    if (number < min) return min;
    if (number > max) return max;
    return number;
};
/**
 * Returns `props.theme.palette[key || props.palette][tone || props.tone || 0]` or `defaultValue`.
 * @example
 * import styled, { ThemeProvider } from "styled-components";
 * import { palette } from "styled-tools";
 *
 * const theme = {
 *   palette: {
 *     primary: ['#1976d2', '#2196f3', '#71bcf7', '#c2e2fb'],
 *     secondary: ['#c2185b', '#e91e63', '#f06292', '#f8bbd0']
 *   }
 * };
 *
 * const Button = styled.button`
 *   color: ${palette(1)};                    // props.theme.palette[props.palette][1]
 *   color: ${palette("primary", 1)};         // props.theme.palette.primary[1]
 *   color: ${palette("primary")};            // props.theme.palette.primary[props.tone || 0]
 *   color: ${palette("primary", -1)};        // props.theme.palette.primary[3]
 *   color: ${palette("primary", 10)};        // props.theme.palette.primary[3]
 *   color: ${palette("primary", -10)};       // props.theme.palette.primary[0]
 *   color: ${palette("primary", 0, "red")};  // props.theme.palette.primary[0] || red
 * `;
 *
 * <ThemeProvider theme={theme}>
 *   <Button palette="secondary" />
 * </ThemeProvider>
 */ var $8229ab55828c3b1d$var$palette = function palette(keyOrTone, toneOrDefaultValue, defaultValue) {
    return function(props) {
        var key = typeof keyOrTone === "string" ? keyOrTone : props.palette;
        var tone = typeof keyOrTone === "number" ? keyOrTone : typeof toneOrDefaultValue === "number" ? toneOrDefaultValue : props.tone || 0;
        var finalDefaultValue = toneOrDefaultValue !== tone ? toneOrDefaultValue : defaultValue;
        if (!props.theme.palette || !props.theme.palette[key]) return finalDefaultValue;
        var tones = $8229ab55828c3b1d$var$toArray(props.theme.palette[key]);
        if (tone < 0) return tones[$8229ab55828c3b1d$var$clamp(tones.length + tone, 0, tones.length - 1)];
        return tones[$8229ab55828c3b1d$var$clamp(tone, 0, tones.length - 1)];
    };
};
var $8229ab55828c3b1d$export$2e2bcd8739ae039 = $8229ab55828c3b1d$var$palette;



/**
 * Switches on a given prop. Returns the value or function for a given prop value. Third parameter is default value.
 * @example
 * import styled, { css } from "styled-components";
 * import { switchProp, prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   font-size: ${switchProp(prop("size", "medium"), {
 *     small: prop("theme.sizes.sm", "12px"),
 *     medium: prop("theme.sizes.md", "16px"),
 *     large: prop("theme.sizes.lg", "20px")
 *   }, prop("theme.sizes.md", "16px"))};
 *   ${switchProp("theme.kind", {
 *     light: css`
 *       color: LightBlue;
 *     `,
 *     dark: css`
 *       color: DarkBlue;
 *     `
 *   }, css`color: black;`)}
 * `;
 *
 * <Button size="large" theme={{ kind: "light" }} />
 */ var $7b727d74bdb45bff$var$switchProp = function switchProp(needle, cases, defaultCase) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var value = typeof needle === "function" ? needle(props) : (0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)(needle)(props);
        var finalCases = typeof cases === "function" ? cases(props) : cases;
        if (value in finalCases) return finalCases[value];
        return defaultCase;
    };
};
var $7b727d74bdb45bff$export$2e2bcd8739ae039 = $7b727d74bdb45bff$var$switchProp;



/**
 * Same as `prop`, except that it returns `props.theme[path]` instead of
 * `props[path]`.
 * @example
 * import styled from "styled-components";
 * import { theme } from "styled-tools";
 *
 * const Button = styled.button`
 *  color: ${theme("button.color", "red")};
 * `;
 */ var $5bead30154074cc6$var$theme = function theme(path, defaultValue) {
    return function(props) {
        return (0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)(path, defaultValue)(props.theme);
    };
};
var $5bead30154074cc6$export$2e2bcd8739ae039 = $5bead30154074cc6$var$theme;



function $2eccef4ad69d0fb0$var$_toConsumableArray(arr) {
    return $2eccef4ad69d0fb0$var$_arrayWithoutHoles(arr) || $2eccef4ad69d0fb0$var$_iterableToArray(arr) || $2eccef4ad69d0fb0$var$_nonIterableSpread();
}
function $2eccef4ad69d0fb0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $2eccef4ad69d0fb0$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $2eccef4ad69d0fb0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
/**
 * Calls a function passing properties values as arguments.
 * @example
 * // example with polished
 * import styled from "styled-components";
 * import { darken } from "polished";
 * import { withProp, prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   border-color: ${withProp(prop("theme.primaryColor", "blue"), darken(0.5))};
 *   font-size: ${withProp("theme.size", size => `${size + 1}px`)};
 *   background: ${withProp(["foo", "bar"], (foo, bar) => `${foo}${bar}`)};
 * `;
 */ var $2eccef4ad69d0fb0$var$withProp = function withProp(needle, fn) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (Array.isArray(needle)) {
            var needles = needle.map(function(arg) {
                return withProp(arg, function(x) {
                    return x;
                })(props);
            });
            return fn.apply(void 0, $2eccef4ad69d0fb0$var$_toConsumableArray(needles));
        }
        if (typeof needle === "function") return fn(needle(props));
        return fn((0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)(needle)(props));
    };
};
var $2eccef4ad69d0fb0$export$2e2bcd8739ae039 = $2eccef4ad69d0fb0$var$withProp;





var $729820ced476238b$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $729820ced476238b$var$__assign = undefined && undefined.__assign || function() {
    $729820ced476238b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $729820ced476238b$var$__assign.apply(this, arguments);
};
var $729820ced476238b$var$spin = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)($729820ced476238b$var$templateObject_1 || ($729820ced476238b$var$templateObject_1 = $729820ced476238b$var$__makeTemplateObject([
    "\n to {\n    transform: rotate(360deg);\n  }\n"
], [
    "\n to {\n    transform: rotate(360deg);\n  }\n"
])));
var $729820ced476238b$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
var $729820ced476238b$var$Svg = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg($729820ced476238b$var$templateObject_2 || ($729820ced476238b$var$templateObject_2 = $729820ced476238b$var$__makeTemplateObject([
    "\n  animation: ",
    " 0.75s steps(12, end) infinite;\n  animation-duration: ",
    "s;\n"
], [
    "\n  animation: ",
    " 0.75s steps(12, end) infinite;\n  animation-duration: ",
    "s;\n"
])), $729820ced476238b$var$spin, (0, $d9ff0d50ceb9bc27$export$2e2bcd8739ae039)("speed", "0.75"));
var $729820ced476238b$var$Polyline = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).polyline($729820ced476238b$var$templateObject_3 || ($729820ced476238b$var$templateObject_3 = $729820ced476238b$var$__makeTemplateObject([
    "\n  stroke-width: ",
    "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"
], [
    "\n  stroke-width: ",
    "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"
])), function(props) {
    return props.width;
});
function $729820ced476238b$export$2e2bcd8739ae039(_a) {
    var _b = _a.strokeColor, strokeColor = _b === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? "5" : _c, _d = _a.animationDuration, animationDuration = _d === void 0 ? "0.75" : _d, _e = _a.width, width = _e === void 0 ? "96" : _e, _f = _a.visible, visible = _f === void 0 ? true : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-lines-loading" : _g;
    var lines = (0, $acw62.useCallback)(function() {
        return $729820ced476238b$var$POINTS.map(function(point) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($729820ced476238b$var$Polyline, {
                key: point,
                points: "24,12 24,4",
                width: strokeWidth,
                transform: "rotate(".concat(point, ", 24, 24)")
            });
        });
    }, [
        strokeWidth
    ]);
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($729820ced476238b$var$Svg, $729820ced476238b$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), lines());
}
var $729820ced476238b$var$templateObject_1, $729820ced476238b$var$templateObject_2, $729820ced476238b$var$templateObject_3;


var $a63d61823092eb5b$exports = {};

var $acw62 = parcelRequire("acw62");


var $a63d61823092eb5b$var$__assign = undefined && undefined.__assign || function() {
    $a63d61823092eb5b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a63d61823092eb5b$var$__assign.apply(this, arguments);
};
var $a63d61823092eb5b$export$f8e5ae7506d65b32 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 1 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "tail-spin-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a63d61823092eb5b$var$__assign({
        style: $a63d61823092eb5b$var$__assign($a63d61823092eb5b$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 38 38",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "tail-spin-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        x1: "8.042%",
        y1: "0%",
        x2: "65.682%",
        y2: "23.865%",
        id: "a"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: color,
        stopOpacity: "0",
        offset: "0%"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: color,
        stopOpacity: ".631",
        offset: "63.146%"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: color,
        offset: "100%"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(1 1)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M36 18c0-9.94-8.06-18-18-18",
        id: "Oval-2",
        stroke: color,
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "0.9s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#fff",
        cx: "36",
        cy: "18",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "0.9s",
        repeatCount: "indefinite"
    }))))));
};
var $a63d61823092eb5b$export$2e2bcd8739ae039 = $a63d61823092eb5b$export$f8e5ae7506d65b32;


var $795fdd4210adfdf1$exports = {};

var $acw62 = parcelRequire("acw62");


var $795fdd4210adfdf1$var$__assign = undefined && undefined.__assign || function() {
    $795fdd4210adfdf1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $795fdd4210adfdf1$var$__assign.apply(this, arguments);
};
var $795fdd4210adfdf1$var$ThreeCircles = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "three-circles-loading" : _h, outerCircleColor = _a.outerCircleColor, innerCircleColor = _a.innerCircleColor, middleCircleColor = _a.middleCircleColor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $795fdd4210adfdf1$var$__assign({
        style: $795fdd4210adfdf1$var$__assign($795fdd4210adfdf1$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        version: "1.1",
        height: "".concat(height),
        width: "".concat(width),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "three-circles-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: outerCircleColor || color,
        d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3\n  c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "2s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: middleCircleColor || color,
        d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7\n  c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "1s",
        from: "0 50 50",
        to: "-360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: innerCircleColor || color,
        d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5\n  L82,35.7z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "2s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    }))));
};
var $795fdd4210adfdf1$export$2e2bcd8739ae039 = $795fdd4210adfdf1$var$ThreeCircles;


var $489dbaee2b9210e7$exports = {};

var $acw62 = parcelRequire("acw62");


var $489dbaee2b9210e7$var$__assign = undefined && undefined.__assign || function() {
    $489dbaee2b9210e7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $489dbaee2b9210e7$var$__assign.apply(this, arguments);
};
var $489dbaee2b9210e7$var$ThreeDots = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 9 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "three-dots-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $489dbaee2b9210e7$var$__assign({
        style: $489dbaee2b9210e7$var$__assign($489dbaee2b9210e7$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "three-dots-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "15",
        cy: "15",
        r: Number(radius) + 6
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "60",
        cy: "15",
        r: radius,
        attributeName: "fill-opacity",
        from: "1",
        to: "0.3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "9",
        to: "9",
        begin: "0s",
        dur: "0.8s",
        values: "9;15;9",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "0.5",
        to: "0.5",
        begin: "0s",
        dur: "0.8s",
        values: ".5;1;.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "105",
        cy: "15",
        r: Number(radius) + 6
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $489dbaee2b9210e7$export$2e2bcd8739ae039 = $489dbaee2b9210e7$var$ThreeDots;


var $2996f03e8cd2f290$exports = {};

var $acw62 = parcelRequire("acw62");



var $2996f03e8cd2f290$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $2996f03e8cd2f290$var$__assign = undefined && undefined.__assign || function() {
    $2996f03e8cd2f290$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2996f03e8cd2f290$var$__assign.apply(this, arguments);
};
var $2996f03e8cd2f290$var$dash = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)($2996f03e8cd2f290$var$templateObject_1 || ($2996f03e8cd2f290$var$templateObject_1 = $2996f03e8cd2f290$var$__makeTemplateObject([
    "\n to {\n    stroke-dashoffset: 136;\n  }\n"
], [
    "\n to {\n    stroke-dashoffset: 136;\n  }\n"
])));
var $2996f03e8cd2f290$var$Polygon = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).polygon($2996f03e8cd2f290$var$templateObject_2 || ($2996f03e8cd2f290$var$templateObject_2 = $2996f03e8cd2f290$var$__makeTemplateObject([
    "\n  stroke-dasharray: 17;\n  animation: ",
    " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"
], [
    "\n  stroke-dasharray: 17;\n  animation: ",
    " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"
])), $2996f03e8cd2f290$var$dash);
var $2996f03e8cd2f290$var$SVG = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg($2996f03e8cd2f290$var$templateObject_3 || ($2996f03e8cd2f290$var$templateObject_3 = $2996f03e8cd2f290$var$__makeTemplateObject([
    "\n  transform-origin: 50% 65%;\n"
], [
    "\n  transform-origin: 50% 65%;\n"
])));
var $2996f03e8cd2f290$var$Triangle = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "triangle-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $2996f03e8cd2f290$var$__assign({
        style: $2996f03e8cd2f290$var$__assign($2996f03e8cd2f290$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: "".concat(wrapperClass),
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2996f03e8cd2f290$var$SVG, {
        id: "triangle",
        width: width,
        height: height,
        viewBox: "-3 -4 39 39",
        "data-testid": "triangle-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2996f03e8cd2f290$var$Polygon, {
        fill: "transparent",
        stroke: color,
        strokeWidth: "1",
        points: "16,0 32,32 0,32"
    })));
};
var $2996f03e8cd2f290$export$2e2bcd8739ae039 = $2996f03e8cd2f290$var$Triangle;
var $2996f03e8cd2f290$var$templateObject_1, $2996f03e8cd2f290$var$templateObject_2, $2996f03e8cd2f290$var$templateObject_3;


var $a809a43d740cbc26$exports = {};

var $acw62 = parcelRequire("acw62");


var $a809a43d740cbc26$var$__assign = undefined && undefined.__assign || function() {
    $a809a43d740cbc26$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a809a43d740cbc26$var$__assign.apply(this, arguments);
};
var $a809a43d740cbc26$var$Watch = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 48 : _d, _e = _a.color, color = _e === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "watch-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a809a43d740cbc26$var$__assign({
        style: $a809a43d740cbc26$var$__assign($a809a43d740cbc26$var$__assign({}, (0, $138bf068d8c0f43c$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        version: "1.1",
        id: "L2",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "watch-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        cx: "50",
        cy: "50",
        r: radius
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        fill: "none",
        strokeLinecap: "round",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        x1: "50",
        y1: "50",
        x2: "85",
        y2: "50.5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "2s",
        type: "rotate",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        fill: "none",
        strokeLinecap: "round",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        x1: "50",
        y1: "50",
        x2: "49.5",
        y2: "74"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "15s",
        type: "rotate",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    }))));
};
var $a809a43d740cbc26$export$2e2bcd8739ae039 = $a809a43d740cbc26$var$Watch;


var $380ee058730ba512$exports = {};

var $acw62 = parcelRequire("acw62");

var $380ee058730ba512$var$__assign = undefined && undefined.__assign || function() {
    $380ee058730ba512$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $380ee058730ba512$var$__assign.apply(this, arguments);
};
var $380ee058730ba512$var$FallingLines = function(_a) {
    var _b = _a.color, color = _b === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _b, _c = _a.width, width = _c === void 0 ? "100" : _c, _d = _a.visible, visible = _d === void 0 ? true : _d;
    return visible ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $380ee058730ba512$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color,
        "data-testid": "falling-lines-rect-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color,
        "data-testid": "falling-lines-rect-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }))) : null;
};
var $380ee058730ba512$export$2e2bcd8739ae039 = $380ee058730ba512$var$FallingLines;


var $c99f75806986b62e$exports = {};

var $acw62 = parcelRequire("acw62");

var $c99f75806986b62e$var$__assign = undefined && undefined.__assign || function() {
    $c99f75806986b62e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c99f75806986b62e$var$__assign.apply(this, arguments);
};
var $c99f75806986b62e$var$Vortex = function(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "vortex-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.colors, colors = _f === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461",
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : _f;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $c99f75806986b62e$var$__assign({
        height: height,
        width: width,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(50,50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "scale(0.7)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "rotate(137.831 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        values: "360 50 50;0 50 50",
        keyTimes: "0;1",
        dur: "1",
        keySplines: "0.5 0.5 0.5 0.5",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[0],
        d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[1],
        d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[2],
        d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[3],
        d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[4],
        d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: colors[5],
        d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
    }))))));
};
var $c99f75806986b62e$export$2e2bcd8739ae039 = $c99f75806986b62e$var$Vortex;


var $14ffa2e3e32d2ece$exports = {};

var $acw62 = parcelRequire("acw62");

var $14ffa2e3e32d2ece$var$__assign = undefined && undefined.__assign || function() {
    $14ffa2e3e32d2ece$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14ffa2e3e32d2ece$var$__assign.apply(this, arguments);
};
function $14ffa2e3e32d2ece$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-triangle-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $14ffa2e3e32d2ece$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(50,42)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "scale(0.8)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        "ng-attr-fill": "{{config.c1}}",
        points: "72.5,50 50,11 27.5,50 50,50",
        fill: colors[0],
        transform: "rotate(186 50 38.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 38.5;360 50 38.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        "ng-attr-fill": "{{config.c2}}",
        points: "5,89 50,89 27.5,50",
        fill: colors[1],
        transform: "rotate(186 27.5 77.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 27.5 77.5;360 27.5 77.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        "ng-attr-fill": "{{config.c3}}",
        points: "72.5,50 50,89 95,89",
        fill: colors[2],
        transform: "rotate(186 72.2417 77.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 72.5 77.5;360 72 77.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    }))))));
}


var $dec8c71702caf768$exports = {};

var $acw62 = parcelRequire("acw62");

var $dec8c71702caf768$var$__assign = undefined && undefined.__assign || function() {
    $dec8c71702caf768$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dec8c71702caf768$var$__assign.apply(this, arguments);
};
function $dec8c71702caf768$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "radio-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        (0, $5bce88e8def4447d$export$37394b0fa44b998c),
        (0, $5bce88e8def4447d$export$37394b0fa44b998c),
        (0, $5bce88e8def4447d$export$37394b0fa44b998c)
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dec8c71702caf768$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "28",
        cy: "75",
        r: "11",
        "ng-attr-fill": "{{config.c1}}",
        fill: colors[0]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M28 47A28 28 0 0 1 56 75",
        fill: "none",
        "ng-attr-stroke": "{{config.c2}}",
        strokeWidth: "10",
        stroke: colors[1]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "stroke-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0.1s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M28 25A50 50 0 0 1 78 75",
        fill: "none",
        "ng-attr-stroke": "{{config.c3}}",
        strokeWidth: "10",
        stroke: colors[2]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "stroke-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0.2s",
        repeatCount: "indefinite"
    })));
}


var $5b048e6f60985402$exports = {};

var $acw62 = parcelRequire("acw62");

var $5b048e6f60985402$var$__assign = undefined && undefined.__assign || function() {
    $5b048e6f60985402$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b048e6f60985402$var$__assign.apply(this, arguments);
};
function $5b048e6f60985402$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "progress-bar-loading" : _g, _h = _a.borderColor, borderColor = _h === void 0 ? "#F4442E" : _h, _j = _a.barColor, barColor = _j === void 0 ? "#51E5FF" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $5b048e6f60985402$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
        "ng-attr-id": "{{config.cpid}}",
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        id: "lds-progress-cpid-5009611b8a418"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "0",
        y: "0",
        width: "66.6667",
        height: "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "width",
        calcMode: "linear",
        values: "0;100;100",
        keyTimes: "0;0.5;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "x",
        calcMode: "linear",
        values: "0;0;100",
        keyTimes: "0;0.5;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        "ng-attr-stroke": "{{config.c1}}",
        strokeWidth: "2.7928",
        d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
        stroke: borderColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.c2}}",
        "ng-attr-clip-path": "url(#{{config.cpid}})",
        d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
        fill: barColor,
        clipPath: "url(#lds-progress-cpid-5009611b8a418)"
    }));
}


var $32d35afcd238b057$exports = {};

var $acw62 = parcelRequire("acw62");

var $32d35afcd238b057$var$__assign = undefined && undefined.__assign || function() {
    $32d35afcd238b057$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32d35afcd238b057$var$__assign.apply(this, arguments);
};
function $32d35afcd238b057$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "magnifying-glass-loading" : _g, _h = _a.glassColor, glassColor = _h === void 0 ? "#c0efff" : _h, _j = _a.color, color = _j === void 0 ? "#e15b64" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $32d35afcd238b057$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(50,50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "ng-attr-transform": "scale({{config.scale}})",
        transform: "scale(0.82)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(16.3636 -20)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "translate",
        calcMode: "linear",
        values: "-20 -20;20 -20;0 20;-20 -20",
        keyTimes: "0;0.33;0.66;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.glass}}",
        d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
        fill: glassColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.frame}}",
        d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
        fill: color
    }))))));
}


var $9607e4a0d0d6813e$exports = {};

var $acw62 = parcelRequire("acw62");

var $9607e4a0d0d6813e$var$__assign = undefined && undefined.__assign || function() {
    $9607e4a0d0d6813e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9607e4a0d0d6813e$var$__assign.apply(this, arguments);
};
function $9607e4a0d0d6813e$export$2e2bcd8739ae039(_a) {
    var _b = _a.width, width = _b === void 0 ? "80" : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? (0, $5bce88e8def4447d$export$37394b0fa44b998c) : _d, _e = _a.ballColors, ballColors = _e === void 0 ? [
        "#fc636b",
        "#6a67ce",
        "#ffb900"
    ] : _e, _f = _a.wrapperClass, wrapperClass = _f === void 0 ? "" : _f, _g = _a.wrapperStyle, wrapperStyle = _g === void 0 ? {} : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "fidget-spinner-loader" : _h, _j = _a.visible, visible = _j === void 0 ? true : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $9607e4a0d0d6813e$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "rotate(6 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "ng-attr-transform": "scale({{config.r}})",
        transform: "scale(0.9)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(-50 -58)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.c2}}",
        d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
        fill: ballColors[0]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.c3}}",
        d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
        fill: ballColors[1]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        "ng-attr-fill": "{{config.c4}}",
        cx: "50",
        cy: "27",
        r: "7.4",
        fill: ballColors[2]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-fill": "{{config.c1}}",
        d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
        fill: backgroundColor
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $bfd3528d752a8e4e$exports = {};

var $acw62 = parcelRequire("acw62");

var $bfd3528d752a8e4e$var$__assign = undefined && undefined.__assign || function() {
    $bfd3528d752a8e4e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bfd3528d752a8e4e$var$__assign.apply(this, arguments);
};
function $bfd3528d752a8e4e$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "dna-loading" : _g;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $bfd3528d752a8e4e$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "6.451612903225806",
        cy: "60.6229",
        r: "3.41988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "0s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "6.451612903225806",
        cy: "39.3771",
        r: "2.58012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "16.129032258064512",
        cy: "68.1552",
        r: "3.17988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "16.129032258064512",
        cy: "31.8448",
        r: "2.82012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "25.806451612903224",
        cy: "69.3634",
        r: "2.93988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "25.806451612903224",
        cy: "30.6366",
        r: "3.06012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "35.48387096774193",
        cy: "65.3666",
        r: "2.69988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "35.48387096774193",
        cy: "34.6334",
        r: "3.30012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "45.16129032258064",
        cy: "53.8474",
        r: "2.45988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "45.16129032258064",
        cy: "46.1526",
        r: "3.54012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "54.838709677419345",
        cy: "39.3771",
        r: "2.58012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "54.838709677419345",
        cy: "60.6229",
        r: "3.41988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "64.51612903225805",
        cy: "31.8448",
        r: "2.82012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "64.51612903225805",
        cy: "68.1552",
        r: "3.17988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "74.19354838709677",
        cy: "30.6366",
        r: "3.06012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "74.19354838709677",
        cy: "69.3634",
        r: "2.93988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "83.87096774193547",
        cy: "34.6334",
        r: "3.30012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "83.87096774193547",
        cy: "65.3666",
        r: "2.69988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-3.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "93.54838709677418",
        cy: "46.1526",
        r: "3.54012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "93.54838709677418",
        cy: "53.8474",
        r: "2.45988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-3.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    })));
}


var $bf269fcf3362d21c$exports = {};

var $acw62 = parcelRequire("acw62");

var $bf269fcf3362d21c$var$__assign = undefined && undefined.__assign || function() {
    $bf269fcf3362d21c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf269fcf3362d21c$var$__assign.apply(this, arguments);
};
function $bf269fcf3362d21c$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "discuss-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        "#ff727d",
        "#ff727d"
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $bf269fcf3362d21c$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        "ng-attr-d": "{{config.d}}",
        "ng-attr-stroke-width": "{{config.width}}",
        "ng-attr-stroke": "{{config.stroke}}",
        fill: "none",
        d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
        strokeWidth: "5",
        stroke: colors[0]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "50",
        cy: "50",
        "ng-attr-r": "{{config.radius2}}",
        "ng-attr-stroke-width": "{{config.width}}",
        "ng-attr-stroke": "{{config.stroke}}",
        "ng-attr-stroke-dasharray": "{{config.dasharray}}",
        fill: "none",
        strokeLinecap: "round",
        r: "20",
        strokeWidth: "5",
        stroke: colors[1],
        strokeDasharray: "31.41592653589793 31.41592653589793",
        transform: "rotate(96 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $167796ca0f7856fe$exports = {};

var $acw62 = parcelRequire("acw62");

var $167796ca0f7856fe$var$__assign = undefined && undefined.__assign || function() {
    $167796ca0f7856fe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $167796ca0f7856fe$var$__assign.apply(this, arguments);
};
function $167796ca0f7856fe$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.colors, colors = _e === void 0 ? [
        "#e15b64",
        "#f47e60",
        "#f8b26a",
        "#abbd81",
        "#849b87"
    ] : _e, _f = _a.wrapperClass, wrapperClass = _f === void 0 ? "" : _f, _g = _a.wrapperStyle, wrapperStyle = _g === void 0 ? {} : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "color-ring-loading" : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $167796ca0f7856fe$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("mask", {
        id: "ldio-4offds5dlws-mask"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "50",
        cy: "50",
        r: "26",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeDasharray: "122.52211349000194 40.840704496667314",
        strokeWidth: "9",
        transform: "rotate(198.018 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        repeatCount: "indefinite"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        mask: "url(#ldio-4offds5dlws-mask)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "14.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[0]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.8s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "28.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[1]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.6s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "42.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[2]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.4s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "56.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[3]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.2s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "70.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[4]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    }))));
}


var $0d1a997071d23801$exports = {};

var $acw62 = parcelRequire("acw62");

var $0d1a997071d23801$var$__assign = undefined && undefined.__assign || function() {
    $0d1a997071d23801$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d1a997071d23801$var$__assign.apply(this, arguments);
};
function $0d1a997071d23801$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? "#ff6d00" : _e, _f = _a.color, color = _f === void 0 ? "#fff" : _f, _g = _a.wrapperClass, wrapperClass = _g === void 0 ? "" : _g, _h = _a.wrapperStyle, wrapperStyle = _h === void 0 ? {} : _h, _j = _a.ariaLabel, ariaLabel = _j === void 0 ? "comment-loading" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $0d1a997071d23801$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
        "ng-attr-fill": "{{config.c1}}",
        fill: backgroundColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "30",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c2}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "50",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c3}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;0;1;1",
        keyTimes: "0;0.2;0.4;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "70",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c4}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;0;1;1",
        keyTimes: "0;0.4;0.6;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $6db71266bbca242a$exports = {};

$parcel$export($6db71266bbca242a$exports, "default", () => $6db71266bbca242a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6db71266bbca242a$var$__assign = undefined && undefined.__assign || function() {
    $6db71266bbca242a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6db71266bbca242a$var$__assign.apply(this, arguments);
};
function $6db71266bbca242a$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "blocks-loading" : _g;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $6db71266bbca242a$var$__assign({
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg"
    }, (0, $5bce88e8def4447d$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "17",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "40",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.125s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "63",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.25s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "17",
        y: "40",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.875s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "63",
        y: "40",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.375s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "17",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.75s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "40",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.625s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "63",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.5s",
        calcMode: "discrete"
    })));
}




const $66e249ad2a11a9b1$export$4bf90403c8def309 = (row, column)=>{
    if (!row) return "-";
    if (column.render) return column.render(row);
    if (column.key) return String(row[column.key]);
    return null;
};


const $6793a69f7d0fd424$var$isAppropriateRow = (filterableColumn, row, filterInputValue)=>{
    const { key: key, render: render, filterBy: filterBy } = filterableColumn;
    let rowFilterableValue = "";
    if (!row || !filterBy) return true;
    if (key && filterBy === true) rowFilterableValue = String(row[key]);
    if (!key && render && filterBy === true) rowFilterableValue = String(render(row));
    if (typeof filterBy === "function") {
        const filterableValue = filterBy(row);
        rowFilterableValue = Array.isArray(filterableValue) ? filterableValue.join(" ") : filterableValue;
    }
    return rowFilterableValue.toLowerCase().includes(filterInputValue.toLowerCase());
};
const $6793a69f7d0fd424$export$2496b2048a77e742 = (columns, rows, filterInputValue)=>{
    let filteredRows = rows;
    if (filterInputValue) {
        const filterableColumns = columns.filter((column)=>"filterBy" in column);
        filteredRows = rows.filter((row)=>filterableColumns.some((filterableColumn)=>$6793a69f7d0fd424$var$isAppropriateRow(filterableColumn, row, filterInputValue)));
    }
    return {
        filteredRows: filteredRows
    };
};


// >>> INTERFACES <<<
// >>> HELPERS <<<
var $a8d3eac7384fda3b$var$castComparer = function(comparer) {
    return function(a, b, order) {
        return comparer(a, b, order) * order;
    };
};
var $a8d3eac7384fda3b$var$throwInvalidConfigErrorIfTrue = function(condition, context) {
    if (condition) throw Error("Invalid sort config: " + context);
};
var $a8d3eac7384fda3b$var$unpackObjectSorter = function(sortByObj) {
    var _a = sortByObj || {}, asc = _a.asc, desc = _a.desc;
    var order = asc ? 1 : -1;
    var sortBy = asc || desc;
    // Validate object config
    $a8d3eac7384fda3b$var$throwInvalidConfigErrorIfTrue(!sortBy, "Expected `asc` or `desc` property");
    $a8d3eac7384fda3b$var$throwInvalidConfigErrorIfTrue(asc && desc, "Ambiguous object with `asc` and `desc` config properties");
    var comparer = sortByObj.comparer && $a8d3eac7384fda3b$var$castComparer(sortByObj.comparer);
    return {
        order: order,
        sortBy: sortBy,
        comparer: comparer
    };
};
// >>> SORTERS <<<
var $a8d3eac7384fda3b$var$multiPropertySorterProvider = function(defaultComparer) {
    return function multiPropertySorter(sortBy, sortByArr, depth, order, comparer, a, b) {
        var valA;
        var valB;
        if (typeof sortBy === "string") {
            valA = a[sortBy];
            valB = b[sortBy];
        } else if (typeof sortBy === "function") {
            valA = sortBy(a);
            valB = sortBy(b);
        } else {
            var objectSorterConfig = $a8d3eac7384fda3b$var$unpackObjectSorter(sortBy);
            return multiPropertySorter(objectSorterConfig.sortBy, sortByArr, depth, objectSorterConfig.order, objectSorterConfig.comparer || defaultComparer, a, b);
        }
        var equality = comparer(valA, valB, order);
        if ((equality === 0 || valA == null && valB == null) && sortByArr.length > depth) return multiPropertySorter(sortByArr[depth], sortByArr, depth + 1, order, comparer, a, b);
        return equality;
    };
};
function $a8d3eac7384fda3b$var$getSortStrategy(sortBy, comparer, order) {
    // Flat array sorter
    if (sortBy === undefined || sortBy === true) return function(a, b) {
        return comparer(a, b, order);
    };
    // Sort list of objects by single object key
    if (typeof sortBy === "string") {
        $a8d3eac7384fda3b$var$throwInvalidConfigErrorIfTrue(sortBy.includes("."), "String syntax not allowed for nested properties.");
        return function(a, b) {
            return comparer(a[sortBy], b[sortBy], order);
        };
    }
    // Sort list of objects by single function sorter
    if (typeof sortBy === "function") return function(a, b) {
        return comparer(sortBy(a), sortBy(b), order);
    };
    // Sort by multiple properties
    if (Array.isArray(sortBy)) {
        var multiPropSorter_1 = $a8d3eac7384fda3b$var$multiPropertySorterProvider(comparer);
        return function(a, b) {
            return multiPropSorter_1(sortBy[0], sortBy, 1, order, comparer, a, b);
        };
    }
    // Unpack object config to get actual sorter strategy
    var objectSorterConfig = $a8d3eac7384fda3b$var$unpackObjectSorter(sortBy);
    return $a8d3eac7384fda3b$var$getSortStrategy(objectSorterConfig.sortBy, objectSorterConfig.comparer || comparer, objectSorterConfig.order);
}
var $a8d3eac7384fda3b$var$sortArray = function(order, ctx, sortBy, comparer) {
    var _a;
    if (!Array.isArray(ctx)) return ctx;
    // Unwrap sortBy if array with only 1 value to get faster sort strategy
    if (Array.isArray(sortBy) && sortBy.length < 2) _a = sortBy, sortBy = _a[0];
    return ctx.sort($a8d3eac7384fda3b$var$getSortStrategy(sortBy, comparer, order));
};
function $a8d3eac7384fda3b$export$d57fb2717431baac(opts) {
    var comparer = $a8d3eac7384fda3b$var$castComparer(opts.comparer);
    return function(_ctx) {
        var ctx = Array.isArray(_ctx) && !opts.inPlaceSorting ? _ctx.slice() : _ctx;
        return {
            asc: function(sortBy) {
                return $a8d3eac7384fda3b$var$sortArray(1, ctx, sortBy, comparer);
            },
            desc: function(sortBy) {
                return $a8d3eac7384fda3b$var$sortArray(-1, ctx, sortBy, comparer);
            },
            by: function(sortBy) {
                return $a8d3eac7384fda3b$var$sortArray(1, ctx, sortBy, comparer);
            }
        };
    };
}
var $a8d3eac7384fda3b$var$defaultComparer = function(a, b, order) {
    if (a == null) return order;
    if (b == null) return -order;
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
};
var $a8d3eac7384fda3b$export$97db5808d8f88186 = $a8d3eac7384fda3b$export$d57fb2717431baac({
    comparer: $a8d3eac7384fda3b$var$defaultComparer
});
var $a8d3eac7384fda3b$export$8e2051cee7d3bb4b = $a8d3eac7384fda3b$export$d57fb2717431baac({
    comparer: $a8d3eac7384fda3b$var$defaultComparer,
    inPlaceSorting: true
});



var $acw62 = parcelRequire("acw62");
const $fe9517a2740fc864$export$769dcabd4dad14b5 = (rows)=>{
    const [sortState, setSortState] = (0, $acw62.useState)({});
    const { key: sortStateKey, order: sortStateOrder, by: sortStateBy } = sortState;
    const updateSort = (0, $acw62.useCallback)((key, by)=>{
        let nextSortState = sortState;
        if (key === sortStateKey && sortStateOrder === "ASC") nextSortState = {
            key: key,
            order: "DESC",
            by: by
        };
        else if (key === sortStateKey && sortStateOrder === "DESC") nextSortState = {};
        else if (key !== sortStateKey) nextSortState = {
            key: key,
            order: "ASC",
            by: by
        };
        else nextSortState = sortState;
        setSortState(nextSortState);
    }, [
        sortState,
        sortStateKey,
        sortStateOrder
    ]);
    let sortedRows = rows;
    if (sortStateOrder === "ASC" && sortStateKey) sortedRows = (0, $a8d3eac7384fda3b$export$97db5808d8f88186)(rows).by({
        asc: sortStateBy ?? sortStateKey
    });
    if (sortStateOrder === "DESC" && sortStateKey) sortedRows = (0, $a8d3eac7384fda3b$export$97db5808d8f88186)(rows).by({
        desc: sortStateBy ?? sortStateKey
    });
    return {
        sortedRows: sortedRows,
        sortState: sortState,
        updateSort: updateSort
    };
};



const $016583c2efcca5b8$export$efcbfab786023e1a = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).th.withConfig({
    shouldForwardProp: (property, defaultValidatorFunction)=>[
            "align"
        ].includes(property) || defaultValidatorFunction(property)
}).withConfig({
    componentId: "sc-xzd950-0"
})([
    "",
    ""
], {
    "padding": "0.75rem",
    "whiteSpace": "nowrap",
    ":first-child": {
        "paddingLeft": "1.5rem"
    },
    ":last-child": {
        "paddingRight": "1.5rem"
    }
});
const $016583c2efcca5b8$export$f7dae34e2e37c751 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).tr.withConfig({
    componentId: "sc-xzd950-1"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))"
});
const $016583c2efcca5b8$export$f6f0c3fe4ec306ea = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).td.withConfig({
    shouldForwardProp: (property, defaultValidatorFunction)=>[
            "align"
        ].includes(property) || defaultValidatorFunction(property)
}).withConfig({
    componentId: "sc-xzd950-2"
})([
    "",
    ""
], {
    "padding": "0.75rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "whiteSpace": "nowrap",
    ":first-child": {
        "paddingLeft": "1.5rem",
        "width": "100%"
    },
    ":last-child": {
        "paddingRight": "1.5rem"
    }
});
const $016583c2efcca5b8$export$b59bdbef9ce70de2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).tr.withConfig({
    componentId: "sc-xzd950-3"
})({
    "transitionProperty": "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderTopWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(54, 56, 63, var(--tw-border-opacity))",
    "cursor": "pointer",
    ":hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(28, 32, 43, var(--tw-bg-opacity))"
    }
});




const $0791d3188b48fced$export$353f5b6fc5456de1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $be288bf3e759632e$export$353f5b6fc5456de1)).withConfig({
    componentId: "sc-1uwjjsx-0"
})({
    "paddingLeft": "0px",
    "paddingRight": "0px",
    "paddingTop": "0px",
    "paddingBottom": "0px",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "borderStyle": "none"
});
const $0791d3188b48fced$export$9d2b4227a95687cc = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1uwjjsx-1"
})({
    "display": "flex",
    "flexDirection": "row",
    "gap": "0.25rem"
});
const $0791d3188b48fced$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1uwjjsx-2"
})({
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
});
const $0791d3188b48fced$export$b0686f2813f108a6 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-1uwjjsx-3"
})([
    "",
    " ",
    " ",
    ""
], {
    "transitionProperty": "transform",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "150ms"
}, ({ isShow: isShow })=>isShow ? {
        "opacity": "1"
    } : {
        "opacity": "0"
    }, ({ isUp: isUp })=>isUp ? {
        "--tw-rotate": "0deg",
        "transform": "var(--tw-transform)"
    } : {
        "--tw-rotate": "180deg",
        "transform": "var(--tw-transform)"
    });



const $f59f8b0d5942f7c2$export$8b251419efc915eb = ({ title: title })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0791d3188b48fced$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0791d3188b48fced$export$f99233281efd08a0), {
            children: title
        })
    });



const $c27dabea32c1e818$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-g7cgd-0"
})({
    "display": "flex",
    "justifyContent": "center",
    "paddingTop": "1.5rem",
    "paddingBottom": "1.5rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
});



const $1205999387bf231d$export$271f9f08425019c7 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c27dabea32c1e818$export$42a852a2b6b56249), {
        children: "Not Found"
    });



const $8ad4ab0260031db5$export$54ec01a60f47d33d = ({ columns: columns, rows: rows, getRowKey: getRowKey, filterInputValue: filterInputValue, onRowClick: onRowClick = ()=>undefined, noRowsTemplate: noRowsTemplate = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1205999387bf231d$export$271f9f08425019c7), {}) })=>{
    const { filteredRows: filteredRows } = (0, $6793a69f7d0fd424$export$2496b2048a77e742)(columns, rows, filterInputValue);
    const { sortedRows: sortedRows } = (0, $fe9517a2740fc864$export$769dcabd4dad14b5)(filteredRows);
    const handleRowClick = (0, $acw62.useCallback)((row)=>{
        if (row) onRowClick(row);
    }, [
        onRowClick
    ]);
    const [isRowsLoading, setIsRowsLoading] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        setIsRowsLoading(rows.length > 0 && !rows.reduce((previous, current)=>previous && Boolean(current), true));
    }, [
        rows
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $016583c2efcca5b8$export$f7dae34e2e37c751), {
                    children: columns.map(({ title: title, key: key }, columnIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $016583c2efcca5b8$export$efcbfab786023e1a), {
                            align: columnIndex === 0 ? "left" : "right",
                            children: title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f59f8b0d5942f7c2$export$8b251419efc915eb), {
                                title: title
                            }) : null
                        }, `${String(key)}${columnIndex.toString()}`))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: isRowsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "empty",
                        colSpan: columns.length,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6db71266bbca242a$exports.default), {
                            ariaLabel: "blocks-loading",
                            height: "50",
                            visible: true,
                            width: "calc(100% - 36px)",
                            wrapperClass: "blocks-wrapper"
                        })
                    })
                }) : sortedRows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "empty",
                        colSpan: columns.length,
                        children: noRowsTemplate
                    })
                }) : sortedRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $016583c2efcca5b8$export$b59bdbef9ce70de2), {
                        onClick: ()=>{
                            handleRowClick(row);
                        },
                        children: columns.map((column, columnIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $016583c2efcca5b8$export$f6f0c3fe4ec306ea), {
                                align: columnIndex === 0 ? "left" : "right",
                                children: (0, $66e249ad2a11a9b1$export$4bf90403c8def309)(row, column)
                            }, column.key?.toString() ?? columnIndex.toString()))
                    }, row && getRowKey ? getRowKey(row) : rowIndex))
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $4a62284be16bb842$export$bf9b96082d303c34 = ()=>(0, $acw62.useContext)((0, $efc03f6dedc37e73$export$e6d68e3ef93ef78f));




var $acw62 = parcelRequire("acw62");


const $d58e229fb592e2cb$export$614693ed64c7011f = ()=>{
    const { pushModal: pushModal } = (0, $fade73491fc225fc$export$33ffd74ebf07f060)();
    const showPairModal = (0, $acw62.useCallback)((pairId)=>{
        pushModal((0, $25e4dd67dd85c75d$export$31c5a5680ff37c63).pair, {
            pairId: pairId
        });
    }, [
        pushModal
    ]);
    return {
        showPairModal: showPairModal
    };
};



const $9900576da852ec58$export$f2c3aea42b2a048f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1kz1q0p-0"
})({
    "overflow": "auto"
});



const $c52658c0a31f3092$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9900576da852ec58$export$f2c3aea42b2a048f)).withConfig({
    componentId: "sc-12ed287-0"
})([
    "",
    " table{",
    "}"
], {
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))"
}, {
    "width": "100%"
});






const $322eb5adbafb1ec1$export$6e4a3e83036e0e65 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1wu24j1-0"
})({
    "display": "flex",
    "gap": "0.25rem",
    "width": "max-content",
    "borderBottomWidth": "1px",
    "borderStyle": "dotted",
    "--tw-border-opacity": "1",
    "borderColor": "rgba(150, 150, 150, var(--tw-border-opacity))"
});
const $322eb5adbafb1ec1$export$634d224cf96b03c4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img.withConfig({
    componentId: "sc-1wu24j1-1"
})({
    "width": "0.75rem"
});
const $322eb5adbafb1ec1$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-1wu24j1-2"
})({
    "width": "100%",
    "display": "flex",
    "justifyContent": "flex-end"
});




const $c73e053ec789a41e$export$15d5a0246088ad6b = ({ source: source, swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: rewardAPY })=>{
    // const supplyAPY = getPairSupplyAPY({ swapFeesAPY, roeSupplyAPY });
    const totalAPY = (0, $d91182ae554a6565$export$1be513a619b91a39)({
        swapFeesAPY: swapFeesAPY,
        roeSupplyAPY: roeSupplyAPY,
        rewardAPY: rewardAPY
    }); // const formattedSupplyAPY = getFormattedAPY(supplyAPY);
    // const formattedRewardAPY = getFormattedAPY(rewardAPY);
    const formattedTotalAPY = (0, $62681a7eaa870c9b$export$301b86ca0918a05b)(totalAPY); // return (
    //   <CellContent>
    //     <span>{formattedTotalAPY}</span>
    //     <Tooltip
    //       content={
    //         <SupplyAPYTooltip
    //           rewardAPY={rewardAPY}
    //           roeSupplyAPY={roeSupplyAPY}
    //           source={source}
    //           swapFeesAPY={swapFeesAPY}
    //         />
    //       }
    //       disabledUnderline
    //     >
    //       <SubTitleContainer>
    //         <SubTitle>{`${formattedSupplyAPY} +`}</SubTitle>
    //         <TokenIcon src={roe} />
    //         <SubTitle>{formattedRewardAPY}</SubTitle>
    //       </SubTitleContainer>
    //     </Tooltip>
    //   </CellContent>
    // );
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7050bc590ac1eef8$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30360e99936837d5$export$7fd7ec3944df7f43), {
            rewardAPY: rewardAPY,
            roeSupplyAPY: roeSupplyAPY,
            source: source,
            swapFeesAPY: swapFeesAPY
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $322eb5adbafb1ec1$export$f99233281efd08a0), {
            children: formattedTotalAPY
        })
    });
};




const $ede08f7447225109$export$3b628a2b5574282f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-dprmxd-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "gap": "0.25rem"
});
const $ede08f7447225109$export$d5c56664638992a4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span.withConfig({
    componentId: "sc-dprmxd-1"
})({
    "fontWeight": "600",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "--tw-text-opacity": "1",
    "color": "rgba(150, 150, 150, var(--tw-text-opacity))"
});





const $22f9eb8b2199e14e$export$edf119a5286980d7 = ({ totalSupplied: totalSupplied, totalBorrowed: totalBorrowed })=>{
    const formattedTotalSupplied = (0, $62681a7eaa870c9b$export$26053c9414c66e8d)(totalSupplied);
    const formattedTotalBorrowed = (0, $62681a7eaa870c9b$export$26053c9414c66e8d)(totalBorrowed);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ede08f7447225109$export$3b628a2b5574282f), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: formattedTotalSupplied
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ede08f7447225109$export$d5c56664638992a4), {
                children: `Borrowed: ${formattedTotalBorrowed}`
            })
        ]
    });
};



const $b7f4b2dab8eed0d9$var$coinsIcons = {
    BTC: (0, (/*@__PURE__*/$parcel$interopDefault($73f3560a6367ee5a$exports))),
    ETH: (0, (/*@__PURE__*/$parcel$interopDefault($49a362987d12de87$exports))),
    MATIC: (0, (/*@__PURE__*/$parcel$interopDefault($ca6183d870e3ae01$exports))),
    USDC: (0, (/*@__PURE__*/$parcel$interopDefault($2d0b78637d3e4e21$exports))),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "USDC.e": (0, (/*@__PURE__*/$parcel$interopDefault($2d0b78637d3e4e21$exports))),
    FXS: (0, (/*@__PURE__*/$parcel$interopDefault($717e996a602e38c0$exports))),
    FRAX: (0, (/*@__PURE__*/$parcel$interopDefault($6ffcfbfc41f26969$exports))),
    GMX: (0, (/*@__PURE__*/$parcel$interopDefault($91cca4a3bb0145b1$exports))),
    ARB: (0, (/*@__PURE__*/$parcel$interopDefault($5642a9473bb50a15$exports))),
    GOOD: (0, (/*@__PURE__*/$parcel$interopDefault($d35b15f7476ec35e$exports))),
    esGOOD: (0, (/*@__PURE__*/$parcel$interopDefault($1f8a828240029f02$exports))),
    // test tokens
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "tUSDC.e": (0, (/*@__PURE__*/$parcel$interopDefault($2d0b78637d3e4e21$exports))),
    tG: (0, (/*@__PURE__*/$parcel$interopDefault($d35b15f7476ec35e$exports))),
    BAD: (0, (/*@__PURE__*/$parcel$interopDefault($d35b15f7476ec35e$exports))),
    esBAD: (0, (/*@__PURE__*/$parcel$interopDefault($1f8a828240029f02$exports)))
};
const $b7f4b2dab8eed0d9$export$4f12fc5d7d70dc7e = (symbol)=>{
    if ($b7f4b2dab8eed0d9$var$coinsIcons[symbol]) return $b7f4b2dab8eed0d9$var$coinsIcons[symbol];
    if (symbol.startsWith("W")) {
        const slicedSymbol = symbol.slice(1);
        if ($b7f4b2dab8eed0d9$var$coinsIcons[slicedSymbol]) return $b7f4b2dab8eed0d9$var$coinsIcons[slicedSymbol];
    }
    return null;
};




const $c6e83191c482c6da$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-if3avq-0"
})({
    "display": "flex",
    "gap": "0.5rem",
    "height": "2.5rem"
});
const $c6e83191c482c6da$export$4b3adbe556d1213e = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-if3avq-1"
})({
    "display": "flex",
    "minWidth": "max-content"
});
const $c6e83191c482c6da$export$759a589c45080062 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $9c3d0fc45ccacf57$export$f04a61298a47a40f)).withConfig({
    componentId: "sc-if3avq-2"
})({
    "width": "1.5rem"
});
const $c6e83191c482c6da$export$95ec63446a0169b6 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c6e83191c482c6da$export$759a589c45080062).withConfig({
    componentId: "sc-if3avq-3"
})({
    "--tw-translate-x": "-0.375rem",
    "transform": "var(--tw-transform)"
});
const $c6e83191c482c6da$export$35e09ba17cc51c69 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-if3avq-4"
})({
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center"
});





const $434ed195e1a37d8c$export$89c285f228afdc27 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-4po5bk-0"
})({
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.125rem",
    "paddingBottom": "0.125rem",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "borderRadius": "0.5rem"
});
const $434ed195e1a37d8c$export$3c642e955a289024 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($434ed195e1a37d8c$export$89c285f228afdc27).withConfig({
    componentId: "sc-4po5bk-1"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(23, 115, 213, var(--tw-bg-opacity))"
});
const $434ed195e1a37d8c$export$5838a46810bf7e18 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($434ed195e1a37d8c$export$89c285f228afdc27).withConfig({
    componentId: "sc-4po5bk-2"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(255, 0, 122, var(--tw-bg-opacity))"
});
const $434ed195e1a37d8c$export$6e9c3b2aeeb8f21f = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($434ed195e1a37d8c$export$89c285f228afdc27).withConfig({
    componentId: "sc-4po5bk-3"
})({
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(17, 27, 50, var(--tw-bg-opacity))"
});



const $1ba281e74cf37b13$var$pairSourceTitleComponents = {
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).QUICKSWAP]: (0, $434ed195e1a37d8c$export$3c642e955a289024),
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).UNISWAPV2]: (0, $434ed195e1a37d8c$export$5838a46810bf7e18),
    [(0, $f63b5092d9da353e$export$68251ae420ecadf7).SUSHISWAP]: (0, $434ed195e1a37d8c$export$6e9c3b2aeeb8f21f)
};
const $1ba281e74cf37b13$export$d40b2c9cbf93d443 = ({ source: source })=>{
    const PairSourceTitleComponent = $1ba281e74cf37b13$var$pairSourceTitleComponents[source];
    const pairSourceTitle = (0, $4d125f6ec40b3c1a$export$8c7291e6ea0abb35)[source];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PairSourceTitleComponent, {
        children: pairSourceTitle
    });
};



const $0b0f3de69156f449$export$2692b073ef5fee01 = ({ source: source, title: title, tokens: tokens })=>{
    const [imageSource0, imageSource1] = tokens.map((0, $b7f4b2dab8eed0d9$export$4f12fc5d7d70dc7e));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c6e83191c482c6da$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c6e83191c482c6da$export$4b3adbe556d1213e), {
                children: [
                    imageSource0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e83191c482c6da$export$759a589c45080062), {
                        src: imageSource0
                    }) : null,
                    imageSource1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e83191c482c6da$export$95ec63446a0169b6), {
                        src: imageSource1
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c6e83191c482c6da$export$35e09ba17cc51c69), {
                children: [
                    title,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ba281e74cf37b13$export$d40b2c9cbf93d443), {
                        source: source
                    })
                ]
            })
        ]
    });
};



const $1c5c8a5c07f19275$var$columns = [
    {
        key: "title",
        title: "LP Tokens",
        render: ({ source: source, title: title, tokens: tokens })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b0f3de69156f449$export$2692b073ef5fee01), {
                source: source,
                title: title,
                tokens: tokens
            }),
        filterBy: ({ tokens: tokens })=>tokens
    },
    {
        key: "chainId",
        title: "Network",
        render: ({ chainId: chainId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66dd3d7c3a0c8184$export$4a01bfee18ca2c98), {
                chainId: chainId
            }),
        sortBy: ({ chainId: chainId })=>chainId
    },
    {
        key: "totalSupplied",
        title: "Supply",
        render: ({ totalSupplied: totalSupplied, totalBorrowed: totalBorrowed })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22f9eb8b2199e14e$export$edf119a5286980d7), {
                totalBorrowed: totalBorrowed,
                totalSupplied: totalSupplied
            })
    },
    {
        key: "roeSupplyAPY",
        title: "Supply APY",
        render: ({ source: source, swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: rewardAPY })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c73e053ec789a41e$export$15d5a0246088ad6b), {
                rewardAPY: rewardAPY,
                roeSupplyAPY: roeSupplyAPY,
                source: source,
                swapFeesAPY: swapFeesAPY
            }),
        sortBy: ({ swapFeesAPY: swapFeesAPY, roeSupplyAPY: roeSupplyAPY, rewardAPY: rewardAPY })=>(0, $d91182ae554a6565$export$1be513a619b91a39)({
                swapFeesAPY: swapFeesAPY,
                roeSupplyAPY: roeSupplyAPY,
                rewardAPY: rewardAPY
            })
    },
    // {
    //   key: "rewardAPY",
    //   title: "Reward APY",
    //   render: ({ rewardAPY }) => getFormattedAPY(rewardAPY),
    // },
    // TODO: add Booster button later
    // {
    //   key: "booster",
    //   title: "Booster",
    //   render: ({ booster }) => <BoosterButton booster={booster} />,
    // },
    {
        key: "walletPairToken",
        title: "LP Balance",
        render: ({ walletPairToken: walletPairToken })=>(0, $5a8458cc154f95c7$export$123447cf2124c743)(walletPairToken),
        sortBy: ({ walletPairToken: walletPairToken })=>walletPairToken?.balance?.toNumber() ?? null
    },
    {
        key: "walletAToken",
        title: "ROE LP Balance",
        render: ({ walletAToken: walletAToken })=>(0, $5a8458cc154f95c7$export$123447cf2124c743)(walletAToken),
        sortBy: ({ walletAToken: walletAToken })=>walletAToken?.balance?.toNumber() ?? null
    } // TODO: add Supply button later
];
const $1c5c8a5c07f19275$var$getRowKey = (row)=>row.id;
const $1c5c8a5c07f19275$export$1e628b6aeca50dbb = ()=>{
    const rows = (0, $7060843b4f5955a5$export$b5c58888723fa5d4)();
    const { filterInputValue: filterInputValue } = (0, $4a62284be16bb842$export$bf9b96082d303c34)();
    const { showPairModal: showPairModal } = (0, $d58e229fb592e2cb$export$614693ed64c7011f)();
    const handleRowClick = (0, $acw62.useCallback)((row)=>{
        showPairModal(row.id);
    }, [
        showPairModal
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c52658c0a31f3092$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ad4ab0260031db5$export$54ec01a60f47d33d), {
            columns: $1c5c8a5c07f19275$var$columns,
            filterInputValue: filterInputValue,
            getRowKey: $1c5c8a5c07f19275$var$getRowKey,
            onRowClick: handleRowClick,
            rows: rows
        })
    });
};





const $f11c0f9f3e57a8d6$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-f0qwrl-0"
})({
    "display": "flex",
    "alignItems": "center",
    "gap": "1rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(38, 43, 55, var(--tw-bg-opacity))",
    "borderRadius": "0.5rem"
});
const $f11c0f9f3e57a8d6$export$f99233281efd08a0 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h1.withConfig({
    componentId: "sc-f0qwrl-1"
})({
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
});
const $f11c0f9f3e57a8d6$export$16e16c86f919307d = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-f0qwrl-2"
})({
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(52, 105, 250, var(--tw-bg-opacity))",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "borderRadius": "0.25rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgba(255, 255, 255, var(--tw-text-opacity))"
});



const $a06d0b4553852a85$export$59f3a96d87e8b884 = ()=>{
    const { sumTVL: sumTVL } = (0, $c7bd89ddc081b65b$export$255a985966df6537)();
    const formattedSumTVL = sumTVL ? (0, $62681a7eaa870c9b$export$26053c9414c66e8d)(sumTVL) : "-";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f11c0f9f3e57a8d6$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f11c0f9f3e57a8d6$export$f99233281efd08a0), {
                children: "Supply LP Tokens"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f11c0f9f3e57a8d6$export$16e16c86f919307d), {
                children: `TVL ${formattedSumTVL}`
            })
        ]
    });
};



const $e034ea35163d0fa0$export$ceaf35c25d4b1fe2 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efc03f6dedc37e73$export$335db524a096131c), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cf58e504521d81e$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5cf58e504521d81e$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9fbbf031e3976e4$export$3b4e64e77073e307), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd23269a2e5edb11$export$ed9166ec0f465b5e), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5cf58e504521d81e$export$f2c3aea42b2a048f), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a06d0b4553852a85$export$59f3a96d87e8b884), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c5c8a5c07f19275$export$1e628b6aeca50dbb), {})
                        ]
                    })
                ]
            })
        })
    });



const $2628b9f4376c23f8$export$42a852a2b6b56249 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div.withConfig({
    componentId: "sc-11hk2up-0"
})({
    "display": "flex",
    "flexDirection": "column",
    "minWidth": "100%",
    "width": "100vw",
    "minHeight": "100vh",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(18, 18, 18, var(--tw-bg-opacity))"
});



const $10253a198f6125de$export$be92b6f5f03c0fe9 = ()=>{
    (0, $08821d93f5fb6adf$export$600932898aefe927)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2628b9f4376c23f8$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80c852c41db7a96e$export$2b77a92f1a5ad772), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc4adf8c3c4899c4$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e034ea35163d0fa0$export$ceaf35c25d4b1fe2), {})
        ]
    });
};





const $6349695f7d87bfd7$var$_GlobalStyles = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`*, ::before, ::after {
box-sizing: border-box;
border-width: 0;
border-style: solid;
border-color: currentColor;
--tw-translate-x: 0;
--tw-translate-y: 0;
--tw-rotate: 0;
--tw-skew-x: 0;
--tw-skew-y: 0;
--tw-scale-x: 1;
--tw-scale-y: 1;
--tw-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
--tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
--tw-ring-offset-width: 0px;
--tw-ring-offset-color: #fff;
--tw-ring-color: rgba(59, 130, 246, 0.5);
--tw-ring-offset-shadow: 0 0 #0000;
--tw-ring-shadow: 0 0 #0000;
--tw-shadow: 0 0 #0000;
--tw-blur: var(--tw-empty,/*!*/ /*!*/);
--tw-brightness: var(--tw-empty,/*!*/ /*!*/);
--tw-contrast: var(--tw-empty,/*!*/ /*!*/);
--tw-grayscale: var(--tw-empty,/*!*/ /*!*/);
--tw-hue-rotate: var(--tw-empty,/*!*/ /*!*/);
--tw-invert: var(--tw-empty,/*!*/ /*!*/);
--tw-saturate: var(--tw-empty,/*!*/ /*!*/);
--tw-sepia: var(--tw-empty,/*!*/ /*!*/);
--tw-drop-shadow: var(--tw-empty,/*!*/ /*!*/);
--tw-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
--tw-backdrop-blur: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-brightness: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-contrast: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-grayscale: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-hue-rotate: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-invert: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-opacity: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-saturate: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-sepia: var(--tw-empty,/*!*/ /*!*/);
--tw-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        }
html {
line-height: 1.5;
-webkit-text-size-adjust: 100%;
-moz-tab-size: 4;
tab-size: 4;
font-family: Inter, sans-serif;
        }
body {
margin: 0;
font-family: inherit;
line-height: inherit;
        }
hr {
height: 0;
color: inherit;
border-top-width: 1px;
        }
abbr[title] {
text-decoration: underline dotted;
        }
b, strong {
font-weight: bolder;
        }
code, kbd, samp, pre {
font-family: ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;
font-size: 1em;
        }
small {
font-size: 80%;
        }
sub, sup {
font-size: 75%;
line-height: 0;
position: relative;
vertical-align: baseline;
        }
sub {
bottom: -0.25em;
        }
sup {
top: -0.5em;
        }
table {
text-indent: 0;
border-color: inherit;
border-collapse: collapse;
        }
button, input, optgroup, select, textarea {
font-family: inherit;
font-size: 100%;
line-height: inherit;
margin: 0;
padding: 0;
color: inherit;
        }
button, select {
text-transform: none;
        }
button, [type='button'], [type='reset'], [type='submit'] {
-webkit-appearance: button;
        }
::-moz-focus-inner {
border-style: none;
padding: 0;
        }
:-moz-focusring {
outline: 1px dotted ButtonText;
        }
:-moz-ui-invalid {
box-shadow: none;
        }
legend {
padding: 0;
        }
progress {
vertical-align: baseline;
        }
::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
height: auto;
        }
[type='search'] {
-webkit-appearance: textfield;
outline-offset: -2px;
        }
::-webkit-search-decoration {
-webkit-appearance: none;
        }
::-webkit-file-upload-button {
-webkit-appearance: button;
font: inherit;
        }
summary {
display: list-item;
        }
blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre {
margin: 0;
        }
button {
background-color: transparent;
background-image: none;
        }
fieldset {
margin: 0;
padding: 0;
        }
ol, ul {
list-style: none;
margin: 0;
padding: 0;
        }
img {
border-style: solid;
        }
textarea {
resize: vertical;
        }
input::placeholder, textarea::placeholder {
color: #a1a1aa;
        }
button, [role="button"] {
cursor: pointer;
        }
h1, h2, h3, h4, h5, h6 {
font-size: inherit;
font-weight: inherit;
        }
a {
color: inherit;
text-decoration: inherit;
        }
pre, code, kbd, samp {
font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        }
img, svg, video, canvas, audio, iframe, embed, object {
display: block;
vertical-align: middle;
        }
img, video {
max-width: 100%;
height: auto;
        }
[hidden] {
display: none;
        }
@keyframes spin {
to {
transform: rotate(360deg);
        }
        }
@keyframes ping {
75%, 100% {
transform: scale(2);
opacity: 0;
        }
        }
@keyframes pulse {
50% {
opacity: .5;
        }
        }
@keyframes bounce {
0%, 100% {
transform: translateY(-25%);
animation-timing-function: cubic-bezier(0.8,0,1,1);
        }
50% {
transform: none;
animation-timing-function: cubic-bezier(0,0,0.2,1);
        }
        }`;
const $6349695f7d87bfd7$var$CustomStyles = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)([
    "body{",
    "}*::-webkit-scrollbar{width:2px;height:2px;}*::-webkit-scrollbar-track{background:transparent;}*::-webkit-scrollbar-thumb{background-color:#FFFFFF;border-radius:2px;}"
], {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(18, 18, 18, var(--tw-bg-opacity))",
    "WebkitFontSmoothing": "antialiased",
    "MozOsxFontSmoothing": "grayscale"
});
const $6349695f7d87bfd7$export$c507fb1c2e1ac13a = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6349695f7d87bfd7$var$_GlobalStyles, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6349695f7d87bfd7$var$CustomStyles, {})
        ]
    });



(0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports))).NE = -20;
(0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports))).PE = 80;
const $8c4434419c5373bb$var$connectors = Object.values((0, $5eec0ea54595fadd$export$b21745c80acb63b0));
const $8c4434419c5373bb$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb8f828cefd6075$export$45604f0cc8ae667b), {
        client: (0, $b296bcd53744d095$export$7c07b633a151f9c5),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21dacc32874bba56$exports.Web3ReactProvider), {
            connectors: $8c4434419c5373bb$var$connectors,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7ba40f9fe3eefc5f$export$178405afcd8c5eb), {
                modalComponents: (0, $b8fa529dfebe451a$export$8b06a8008f908d68),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6349695f7d87bfd7$export$c507fb1c2e1ac13a), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10253a198f6125de$export$be92b6f5f03c0fe9), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a8cbb743e3b2749$export$431600d623a8d3a4), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d82b87c0cff5ff1$exports.ReactQueryDevtools), {})
                ]
            })
        })
    });



const $d847a8d5c11f1f09$var$container = document.querySelector("#root");
const $d847a8d5c11f1f09$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($d847a8d5c11f1f09$var$container);
$d847a8d5c11f1f09$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c4434419c5373bb$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.02753117.js.map
